import angular$1 from 'angular';
import ngRoute from 'angular-route';
import { oneLineTrim, oneLine } from 'common-tags';
import ThreepioLib from 'gitlab:translations/threepio-browser@v1.2.21';
import { cookieBase, flnBillingBaseUrl, cdnUrls, facebookAppId, recaptchaPublicKey, languageCode, cookieDomain, sslBaseUrl, enterprise } from 'server-data/flconfigs';
import 'npm:angular-component@0.0.8';
import ngResource from 'angular-resource';
import md5Provider from 'npm:angular-md5@0.1.10';
import Raven from 'github:getsentry/sentry-javascript@2.3.0';
import jq from 'jquery';
import ThreepioLib$1 from 'gitlab:translations/threepio-browser@v1.2.20';
import { currency, invitedUser, isEscrowCurrencyRestricted, userLocation, prefill, freeUpgrades, escrowCurrencies, unsupportedCurrency, domainLanguage, taxName, isRestrictedUser } from 'angular-server-data/project-create';
import { pppABTest, pageName, iframeMode, maxFileSize, skillPlaceholder, contestBudgetRanges, giveGetBlockedStatus, tutorialVideoUrl } from 'server-data/project-create';
import moment from 'moment';
import angularMoment from 'angular-moment';
import ngMessages from 'angular-messages';
import 'jquery-iframe-transport';
import 'jquery-ui-widget';
import 'jquery-fileupload';
import 'jquery-fileupload-ui';
import GoogleMapsLoader from 'google-maps';
import 'css/abtests/MM-1483/MultiSelectCombobox.less';
import 'css/flux/modules/Modal.less';
import Billing from 'flnbln-sdk';
import 'npm:angular-easyfb@1.6.0';
import 'css/flux/modules/ModalLoginSignup.less';
import ngSanitize from 'angular-sanitize';
import _ from 'underscore';
import 'bootstrap';
import 'angular-slider';

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

/**
* @ngdoc overview
* @name flTranslate
* @module flTranslate
* @description
*
* # flTranslate
* [flTranslate](https://gitlab.freelancer.com/angular/fl-translate) is a Web
* application translation framework using an innovating approach to extract the
* translatable strings JS templates, which mean that you should no longer need
* to annotate your application for translation. If the default extraction
* strategy is failing or returning unexpecting results, check the
* [documentation](https://gitlab.freelancer.com/angular/fl-translate) to learn
* how to handle them.
*
* This specific `flAngular` module is the client side component of that
* framework: once that the strings extracted from the HTML views & JavaScript
* source files have been translated,  
*/
var threepio = angular$1.module('threepio', [ngRoute]).name;

angular$1.module(threepio)
/**
 * @ngdoc directive
 * @name threepio.directive:i18nId
 * @element A
 * @function
 *
 * @description
*/
.directive('i18nId', ['$rootScope', '$compile', '$interpolate', 'Translation', 'Localization', function ($rootScope, $compile, $interpolate, Translation, Localization) {
  return {
    restrict: 'A',
    priority: -1,
    link: function link(scope, element) {
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      function translate(language) {
        $rootScope.$broadcast('threepio:beforeTranslate');
        Translation.loadTranslations(language).then(function () {
          Translation.translate(element[0]);
        }).finally(function () {
          // Only recompile element if it contains an interpolated expression
          if (scope && element.html() && element.html().match(escapeRegExp($interpolate.startSymbol()))) {
            $compile(element, null, 0)(scope);
          }
          element.removeAttr('i18n-cloak');
          $rootScope.$broadcast('threepio:afterTranslate');
        });
      }

      // Re-translate if the language has changed
      var unsub = $rootScope.$on('TranslationLanguageChange', function () {
        element.data('lang', Localization.language());
        translate(Localization.language());
      });
      scope.$on('$destroy', unsub);

      // Translate at link time if needed
      var lang = Localization.language();
      if (element.data('lang') !== lang) {
        element.data('lang', lang);
        translate(lang);
      }
    }
  };
}]);

angular$1.module('threepio')
/**
 * @ngdoc directive
 * @name threepio.directive:i18nId
 * @element A
 * @function
 *
 * @description
*/
.directive('i18nSrc', ['$rootScope', 'Localization', function ($rootScope, Localization) {
  return {
    restrict: 'A',
    link: function link(scope, element, attr) {
      function selectSrc() {
        var lang = Localization.language();
        if (lang !== Localization.defaultLanguage()) {
          attr.$set('src', attr.i18nSrc.replace(/\.[^.]*$/, '.' + lang + '$&'));
        } else {
          attr.$set('src', attr.i18nSrc);
        }
      }
      selectSrc();
      // Re-download if the language has changed
      $rootScope.$on('LocalizationLanguageChange', function () {
        selectSrc();
      });
    }
  };
}]);

angular$1.module('threepio')
/**
 * @ngdoc directive
 * @name threepio.directive:script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element with a 'text/threepio'
 * type into the {@link threepio.translationCache `translationCache`}, so
 * that the catalog can be used by the
 * {@link threepio.service:translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/threepio'`.
 * @param {string} lang Language of catalog
 */
.directive('script', ['TranslationsCache', function (TranslationsCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function compile(element, attr) {
      if (attr.type === 'text/threepio') {
        var lang = attr.lang;
        // IE is not consistent, in scripts we have to read .text but in
        // other nodes we have to read .textContent
        var text = element[0].textContent.trim();
        TranslationsCache.put(lang, text);
      }
    }
  };
}]);

// FIXME: this is imported from flAngular to make threepio work with

/**
 *
 *
 * @param {any} expires   expiration in seconds
 * @returns               UTC string representation of the date
 *                        plus "expires" seconds
 */
function todayUTCString(expires) {
  var today = new Date();

  today.setTime(today.getTime() + expires * 1000);
  return today.toUTCString();
}

/**
* @ngdoc overview
* @name flCookies
* @module flCookies
* @description
*
* # flCookies
* The `flCookies` module provides a single
* {@link flCookies.CookieStore CookieStore} service that
* streamlines the interaction with the browser's cookies.
* AngularJS has
* {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
* its own $cookieStore implementation} but it doesn't support setting any
* cookie option (e.g. *path*, *domain*, *secure*,
* and *expiration*) as of today. The APIs are the same than Angular's
* {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
* $cookieStore} with an extra parameter (an object with
* ``expires``, ``path``, ``domain`` and ``secure`` as keys, ``expires``
* accepting different formats).
* It is currently used by ``flAuth`` (auth cookies) and ``flAnalytics``
* (tracking cookies), but you can easily use it in a custom service:
*
* ```
  angular.module('myApp')
  .factory('myAwesomeService', function(CookieStore) {
    return {
      setMagicCookie: function(magicNumber) {
        CookieStore.put('CHUCK_NORRIS', magicNumber, {
          expires: Infinity
        });

      ...
    }
  }
* ```
*/
angular$1.module('threepio')
/**
 * @ngdoc service
 * @name flCookies.CookieStore
 *
 * @description
 * A factory which creates a service that lets you interact with the browser's
 * cookies.
 *
 * The returned object has action methods which provide high-level behaviors
 * without the need to interact with the low level cookies implementation.
 */
.factory('ThreepioCookieStore', ['$document', function ($document) {
  return {
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#get
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Returns the value of given cookie key
     *
     * @param {String} key Id to use for lookup.
     * @returns {Object} Deserialized cookie value.
     */
    get: function get(key) {
      var re = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
      var value = $document[0].cookie.replace(re, '$1');

      return decodeURIComponent(value) || null;
    },

    /**
     * @ngdoc method
     * @name flCookies.CookieStore#put
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Sets a value for given cookie key
     *
     * @param {String} key Id for the `value`.
     * @param {Object} value The value you want to store in this cookie
     * @param {Object} options Additional settings for the cookie (optional):
     *
     * - expires: expiration date for the cookie
     * - domain: the domain for which the cookie is valid
     * - path: the path for which the cookie is valid
     * - secure: is cookie HTTPS only?
     */
    put: function put(key, value, options) {
      // Set cookie
      var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      // See options
      if (options) {
        // Expiration date
        if (options.expires) {
          var date = void 0;

          switch (options.expires.constructor) {
            case Number:
              {
                if (options.expires === Infinity) {
                  date = 'Fri, 31 Dec 9999 23:59:59 GMT';
                } else {
                  // Note: we don't use max-age here because it's
                  // not supported in IE8.
                  date = todayUTCString(options.expires);
                }
                break;
              }
            case String:
              {
                date = options.expires;
                break;
              }
            case Date:
              {
                date = options.expires.toUTCString();
                break;
              }
            default:
              {
                date = todayUTCString(0);
                break;
              }
          }

          cookie += ';expires=' + date;
        }
        // Domain
        cookie += options.domain ? ';domain=' + options.domain : '';
        // Path
        cookie += options.path ? ';path=' + options.path : ';path=/';
        // HTTPS Only
        cookie += options.secure ? ';secure' : '';
      }
      // Save the cookie
      // Note: $document is a jqLite wrapper
      $document[0].cookie = cookie;
    },

    /**
     * @ngdoc method
     * @name flCookies.CookieStore#remove
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Remove given cookie
     *
     * @param {String} key Id of the key-value pair to delete.
     * @param {Object} options Additional settings for the cookie (optional)
     */
    remove: function remove(key, options) {
      var opt = options || {};
      // Setting expiry date to a past date deletes a cookie
      opt.expires = new Date(0);
      this.put(key, '', opt);
    }
  };
}]);

angular$1.module('threepio')
/**
 * @ngdoc service
 * @name flTranslate.service:TranslationCache
 *
 * @description
 * Load the content of a `<script>` element with a 'text/fl-translate-catalog'
 * type into the {@link flTranslate.TranslationCache `TranslationCache`}, so
 * that the catalog can be used by the
 * {@link flTranslate.service:Translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/fl-translate-catalog'`.
 * @param {string} lang Language of catalog
 */
.factory('TranslationsCache', ['$cacheFactory', function ($cacheFactory) {
  return $cacheFactory('translationscache');
}]);

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceVariables(message, variables) {
  var fixedMessage = message;

  angular$1.forEach(variables, function (val, name) {
    fixedMessage = fixedMessage.replace(new RegExp(escapeRegExp('${' + name + '}'), 'g'), val);
  });
  return fixedMessage;
}

angular$1.module('threepio')
/**
 * @ngdoc service
 * @name threepio.service:i18n
 *
 * @description
 */
.factory('i18n', function () {
  return function (message, variables) {
    if (angular$1.isObject(message)) {
      // plural form
      if (variables.count === 1) {
        return replaceVariables(message.one, variables);
      }
      if (angular$1.isDefined(message[variables.count])) {
        return replaceVariables(message[variables.count], variables);
      }
      return replaceVariables(message.other, variables);
    }
    return replaceVariables(message, variables);
  };
});

angular$1.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.LocalizationProvider
 *
 * @description
 */
.provider('Localization', function LocalizationProvider() {
  var _defaultLanguage = 'en'; /* language of the site */
  var languageCookie = void 0;
  var languageCode$$1 = void 0;
  var cookieOptions = void 0;

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#defaultLanguage
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language without a dedicated
  * ccTLD or subdomain (retrieved from the LocalizationProvider).
  */
  this.defaultLanguage = function (code) {
    if (code) {
      _defaultLanguage = code;
    }
    return _defaultLanguage;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#setLanguageCookie
  *
  * @description
  * Set the name of the language cookie used to store the current
  * language of the user
  *
  * @param {String} Name of the language cookie
  */
  this.setLanguageCookie = function (name, options) {
    languageCookie = name;
    cookieOptions = options;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#setLanguage
  *
  * @description
  * Sets the language code - will be the selected language
  * if the language cookie is not set
  *
  * @param {String} code ISO 639‑1 language code
  */
  this.setLanguage = function (code) {
    languageCode$$1 = code;
  };

  /**
  * @ngdoc service
  * @name threepio.Localization
  *
  * @description
  */
  this.$get = ['$q', '$injector', '$timeout', '$rootScope', 'ThreepioCookieStore', function ($q, $injector, $timeout, $rootScope, ThreepioCookieStore) {
    var _language = ThreepioCookieStore.get(languageCookie) || languageCode$$1 || _defaultLanguage;

    return {
      /**
      * @ngdoc method
      * @name threepio.Localization#language
      *
      * @description
      * Get/set the current language
      *
      * @param {String} ISO 639‑1 language code
      * @param {String} ifDefault Only set the language is the current
      * language is the default one
      * @return {String} When used as a getter, the current language code
      */
      language: function language(code, ifDefault) {
        var d = $q.defer();
        if (code && (!ifDefault || ifDefault && !ThreepioCookieStore.get(languageCookie))) {
          _language = code;
          ThreepioCookieStore.put(languageCookie, _language, cookieOptions);
          $injector.invoke(['Translation', function (Translation) {
            Translation.loadTranslations(_language).then(function () {
              d.resolve();
              $rootScope.$broadcast('LocalizationLanguageChange');
            }).catch(function () {
              d.reject();
            });
          }]);
          return d.promise;
        }
        return _language;
      },
      /**
      * @ngdoc method
      * @name threepio.Localization#defaultLanguage
      *
      * @description
      */
      defaultLanguage: function defaultLanguage() {
        return _defaultLanguage;
      }
    };
  }];
});

var _templateObject = _taggedTemplateLiteral(['', '://', '\n            ', '', '\n            ', ''], ['', '://', '\n            ', '', '\n            ', '']);

angular$1.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.provider:LocalizedRouteProvider
 *
 * @description
 * Angular $routeProvider wrapper creating language-specific subdirectories
 * for each language without a dedicated ccTLD or subdomain.
 */
.provider('LocalizedRoute', ['$provide', '$routeProvider', 'LocalizationProvider', function LocalizedRouteProvider($provide, $routeProvider, LocalizationProvider) {
  var _this = this;

  var _languages = void 0;
  var localDomains = void 0;
  var primaryDomain = void 0;

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#languages
  *
  * @description
  * Set the supported languages
  *
  * @param arr {object} Map (3-letters ISO code -> Language name) of the
  * supported languages
  */
  this.languages = function (arr) {
    _languages = arr;
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#localDomains
  *
  * @description
  * Set the ccTLDs used (if any) and their default language
  *
  * @param arr {object} Map (domain name -> 3-letters ISO code) of the
  * supported ccTLDs
  */
  this.localDomains = function (def, arr) {
    primaryDomain = def;
    localDomains = arr;
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#when
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language without a dedicated
  * ccTLD or subdomain (retrieved from the LocalizationProvider).
  */
  this.when = function (path, route) {
    $routeProvider.when(path, route);
    angular$1.forEach(_languages, function (name, code) {
      if (code !== LocalizationProvider.defaultLanguage()) {
        $routeProvider.when('/' + code + path, route);
      }
    });
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#when
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language (retrieved from the
  * LocalizationProvider).
  */
  this.otherwise = function (params) {
    $routeProvider.otherwise(params);
    return _this;
  };

  this.$get = ['$window', '$location', '$rootScope', 'Localization', function ($window, $location, $rootScope, Localization) {

    function isValidLanguage(code) {
      return angular$1.isDefined(_languages[code]);
    }

    // Get the language code from a specified url or from the current url
    function urlToLangCode(url) {
      var langCode = void 0;
      if (url) {
        // Url rewriting
        var urlEl = $window.document.createElement('a');
        urlEl.href = url;
        // Fix IE inconsistency
        urlEl.pathname = urlEl.pathname[0] !== '/' ? '/' + urlEl.pathname[0] : urlEl.pathname;
        langCode = isValidLanguage(urlEl.pathname.split('/')[1]) ? urlEl.pathname.split('/')[1] : null;
      } else {
        langCode = localDomains[$location.host()] ? localDomains[$location.host()].split('-')[0] : null;

        if (!langCode) {
          langCode = isValidLanguage($location.path().split('/')[1]) ? $location.path().split('/')[1] : null;
        }
      }

      return langCode;
    }

    function unlocalizedPath() {
      var path = $location.path();
      var languageCode$$1 = path.split('/')[1];
      if (isValidLanguage(languageCode$$1)) {
        return path.replace('/' + languageCode$$1, '');
      }
      return path;
    }

    var langCode = urlToLangCode();
    if (isValidLanguage(langCode)) {
      Localization.language(langCode, true);
    }

    $rootScope.$on('$locationChangeStart', function (e, current, previous) {
      // hreflang
      function setHrefLang(lang, baseUrl) {
        // Remove the previous link element if any
        var oldHrefLand = $window.document.querySelector('link[hreflang=' + lang + ']');
        if (oldHrefLand) {
          angular$1.element(oldHrefLand).remove();
        }
        // Create a new link element for the locale
        var hrefLang = angular$1.element('<link></link>');
        hrefLang.attr('ref', 'alternate');
        hrefLang.attr('hreflang', lang);
        // Set href value
        var href = oneLineTrim(_templateObject, $location.protocol(), baseUrl, unlocalizedPath(), $window.location.search, $window.location.hash);
        hrefLang.attr('href', href);
        // Add it to the document head
        angular$1.element($window.document).find('head').append(hrefLang);
      }
      // Write the hreflang tags for the generic language pages, i.e. not
      // specific to a region, using a
      // https://<primary_domain>/<lang_code>/<path> url scheme
      angular$1.forEach(_languages, function (languageName, lang) {
        var baseUrl = primaryDomain;
        if (lang !== Localization.defaultLanguage()) {
          baseUrl += '/' + lang;
        }
        setHrefLang(lang, baseUrl);
      });
      // Write the hreflang tags for local domains (ccTLDs)
      angular$1.forEach(localDomains, function (lang, domain) {
        setHrefLang(lang, domain);
      });
      // Keep the language code if any and if the current language is not the
      // default one
      var prevLangCode = urlToLangCode(previous);
      var curLangCode = urlToLangCode(current);
      if (isValidLanguage(curLangCode)) {
        Localization.language(curLangCode);
      }
      if (prevLangCode && curLangCode !== prevLangCode && Localization.language() !== Localization.defaultLanguage()) {
        $location.path('/' + prevLangCode + $location.path());
        $location.replace();
      }
    });

    $rootScope.$on('LocalizationLanguageChange', function () {
      var lang = Localization.language();
      var urlLang = isValidLanguage($location.path().split('/')[1]) ? $location.path().split('/')[1] : null;
      if (lang === Localization.defaultLanguage() && urlLang) {
        $location.path($location.path().split('/')[2]);
      }
    });

    return {
      /**
       * @ngdoc method
       * @name threepio.Localization#languageList
       *
       * @description
       */
      languages: function languages() {
        return _languages;
      }
    };
  }];
}]);

angular$1.module('threepio')
/**
 * @ngdoc service
 * @name flTranslate.service:TranslationCache
 *
 * @description
 * Load the content of a `<script>` element with a 'text/fl-translate-catalog'
 * type into the {@link flTranslate.TranslationCache `TranslationCache`}, so
 * that the catalog can be used by the
 * {@link flTranslate.service:Translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/fl-translate-catalog'`.
 * @param {string} lang Language of catalog
 */
.factory('TemplateCache', ['$cacheFactory', function ($cacheFactory) {
  return $cacheFactory('templatecache');
}]);

/* global document */

angular$1.module('threepio')
/**
 * @ngdoc service
 * @name threepio.service:ThreepioLib
 *
 * @description
 * Angular wrapper from Threepio translation library
 */
.factory('ThreepioLib', ['$interpolate', function ($interpolate) {
  return new ThreepioLib(document, {
    startExpr: $interpolate.startSymbol(),
    endExpr: $interpolate.endSymbol(),
    // FIXME: ngPluralize plugin is broken for now
    /*
    attributes: {
      when: isGlobal ? $window.Threepio.Plugins.ngPluralize :
        require('Threepio.Plugins.ngPluralize')
    },
    */
    missing: true
  });
}]);

angular$1.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.TranslationProvider
 *
 * @description
 * Configure the Translation service by setting the translation domain &
 * preparing the DOM & HTML template for dynamic translation
 */
.provider('Translation', ['$provide', function TranslationProvider($provide) {

  var translationsRequest = void 0;

  /**
  * @ngdoc method
  * @name threepio.TranslationProvider#setDomain
  *
  * @description
  * Set the translation domain of the application (namespace used to
  * retrieve the translation catalogs).
  *
  * @param {String} Name of the translation domain
  */
  this.setTranslationsRequest = function (fn) {
    translationsRequest = fn;
  };

  // Angular $compile service decorator tagging the compiled element for
  // translation
  this.translateRootElement = function () {
    var first = false;
    $provide.decorator('$compile', ['$delegate', 'ThreepioLib', function ($delegate, ThreepioLib$$1) {
      function clone(func) {
        var temp = function temporary() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (!first) {
            first = true;
            var el = args[0];
            ThreepioLib$$1.prepare(el);
          }
          return func.apply(this, args);
        };
        Object.keys(func).forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(func, key)) {
            temp[key] = func[key];
          }
        });
        return temp;
      }
      var compile = clone($delegate);
      return compile;
    }]);
  };

  // Angular $templateRequest service decorator tagging the HTML templates for
  // translation
  $provide.decorator('$templateRequest', ['$delegate', '$q', 'ThreepioLib', 'TemplateCache', function ($delegate, $q, ThreepioLib$$1, TemplateCache) {
    return function (url, ignoreError) {
      var cachedTemplate = TemplateCache.get(url);
      if (cachedTemplate) {
        return $q.when(cachedTemplate);
      }
      return $delegate(url, ignoreError).then(function (template) {
        ThreepioLib$$1.prepare(template);
        var processedTemplate = ThreepioLib$$1.serialize();
        TemplateCache.put(url, processedTemplate);
        return processedTemplate;
      });
    };
  }]);

  /**
  * @ngdoc service
  * @name threepio.Translation
  *
  * @description
  * Translate the application between multiple languages
  */
  this.$get = ['$document', '$rootScope', '$q', '$injector', 'ThreepioLib', 'TranslationsCache', 'Localization', function ($document, $rootScope, $q, $injector, ThreepioLib$$1, TranslationsCache, Localization) {
    var catalog = {};
    var hasBeenTranslated = false;

    function getTranslations(language) {
      var cachedCatalog = TranslationsCache.get(language);
      if (cachedCatalog) {
        return $q.when(cachedCatalog);
      }
      return $injector.invoke(translationsRequest)(language).then(function (newCatalog) {
        TranslationsCache.put(language, newCatalog);
        return newCatalog;
      });
    }

    function _loadTranslations(language) {
      return getTranslations(language).then(function (newCatalog) {
        catalog = newCatalog;
        return catalog;
      });
    }

    /* Preload the translations in the current language before that the
       translate method gets called */
    var currentLanguage = Localization.language();
    if (currentLanguage !== Localization.defaultLanguage()) {
      _loadTranslations(currentLanguage).then(function () {
        $rootScope.$broadcast('TranslationLanguageChange');
      });
    }

    /* Add cloaking CSS style to prevent flash of untranslated content */
    var css = '[i18n-cloak] { display: none !important; }';
    var style = $document[0].createElement('style');
    style.type = 'text/css';
    style.appendChild($document[0].createTextNode(css));
    $document[0].head.appendChild(style);

    $rootScope.$on('LocalizationLanguageChange', function () {
      var language = Localization.language();
      if (language !== Localization.defaultLanguage()) {
        _loadTranslations(language).then(function () {
          $rootScope.$broadcast('TranslationLanguageChange');
        });
      } else {
        $rootScope.$broadcast('TranslationLanguageChange');
      }
    });

    return {
      /**
       * Used by the i18n service for JS translations
       */
      translations: catalog,
      /**
       * @ngdoc method
       * @name threepio.Translation#translate
       *
       * @description
       * Translate an element to the current language
       *
       * @param {HTMLElement} HTML element to translate
       * @param {String} Message ID of the element
       * @return {Promise} Promise resolve or rejected when the translation is
       * done
       */
      translate: function translate(el) {
        var language = Localization.language();
        if (language !== Localization.defaultLanguage()) {
          hasBeenTranslated = true;
          ThreepioLib$$1.process(el, function (message, replace) {
            var translation = catalog.translations[message.getId()] ? catalog.translations[message.getId()] : null;
            if (!translation) {
              /* Use the original message if the translation is missing */
              translation = message.text;
            }
            replace(translation);
          });
        } else if (hasBeenTranslated) {
          // Restore original text
          ThreepioLib$$1.process(el, function (message, replace) {
            replace(message.text);
          });
        }
      },

      /**
       * Load translations
       */
      loadTranslations: function loadTranslations(language) {
        if (language !== Localization.defaultLanguage()) {
          return _loadTranslations(language);
        }
        return $q.when();
      },

      /**
       * @ngdoc method
       * @name threepio.Translation#annotateTemplate
       *
       * @description
       * Annotate an inline template for translation
       *
       * @param {String} HTML template string to annotate for translation
       * @return {String} Annotated template
       */
      annotateTemplate: function annotateTemplate(template) {
        ThreepioLib$$1.prepare(template);
        return ThreepioLib$$1.serialize();
      }
    };
  }];
}]);

/*
 * Common Angular constants used in flAngular.
 * DEPRECATED: A better way to handle these configs should be looked for
 * /!\ DO NOT ADD ANY CODE TO THIS FILE BUT SHARED ANGULAR CONSTANTS /!\
 */

var OPAQUE_MODULE_NAME = 'flConfigs';

if (!window.__karma__) {
  angular$1.module(OPAQUE_MODULE_NAME, []).constant('API_BASE_URL', '/api').constant('AUTH_BASE_URL', '/auth').constant('AUTH_TOKEN_COOKIE', cookieBase + '_AUTH_HASH_V2').constant('FACEBOOK_APP_ID', facebookAppId).constant('GAF_BASE_URL', '').constant('GAF_CDN_URLS', cdnUrls.map(function (url) {
    return 'https://' + url;
  })).constant('USER_ID_COOKIE', cookieBase + '_USER_ID').constant('DEFAULT_AVATAR_URL', '/img/unknown.png').constant('LANGUAGE_COOKIE', cookieBase + '_LANGUAGE').constant('LANGUAGE_COOKIE_DOMAIN', cookieBase).constant('LANGUAGE_COOKIE_EXPIRES', 60 * 60 * 24 * 60) /* 60 days */
  .constant('FLN_BILLING_BASE_URL', flnBillingBaseUrl).constant('TRANSLATE_MODE_COOKIE', cookieBase + '_TRANSLATE_MODE').constant('LOOKING_FOR_COOKIE', cookieBase + '_LOOKING_FOR').constant('RECAPTCHA_PUBLIC_KEY', recaptchaPublicKey);
} else {
  angular$1.module(OPAQUE_MODULE_NAME, []).constant('API_BASE_URL', 'https://api-mock.freelancer.com').constant('AUTH_BASE_URL', 'https://auth-mock.freelancer.com').constant('AUTH_TOKEN_COOKIE', 'GETAFREE_AUTH_HASH_V2').constant('FACEBOOK_APP_ID', 123123123123).constant('GAF_BASE_URL', 'https://mock.freelancer.com').constant('GAF_CDN_URLS', ['https://cdn-mock.freelancer.com']).constant('USER_ID_COOKIE', 'GETAFREE_USER_ID').constant('DEFAULT_AVATAR_URL', '/img/unknown.png').constant('LANGUAGE_COOKIE', 'languageCookieMock').constant('LANGUAGE_COOKIE_DOMAIN', 'languageCookieDomainMock').constant('LANGUAGE_COOKIE_EXPIRES', 'languageCookieDomainExpires').constant('FLN_BILLING_BASE_URL', 'https://fln_billing_base_url').constant('TRANSLATE_MODE_COOKIE', 'GETAFREEST__TRANSLATE_MODE').constant('LOOKING_FOR_COOKIE', 'GETAFREEST__LOOKING_FOR').constant('RECAPTCHA_PUBLIC_KEY', recaptchaPublicKey);
  // FIXME: get rid of that (fix flAnalytics)
  window.dataLayer = [];
}

/*
 * Angular service wrapper to abstract the creation of Angular services in your
 * applications.
 *
 * ```
 * import ngResource from 'angular-resource';
 * import { flService } from 'fl-forward';
 *
 * export default flService('MyService',
 *   [ngResource],
 *   MyService
 * );
 *
 * class MyService {
 *   constructor($resource) {
 *     ...
 *   }
 * }
 * ```
 */
function flService(name, deps, classFn) {
  return angular$1.module('flForward.Service.' + name, deps).service(name, classFn).name;
}

/**
 * annotateTemplate - uses threepio to annotate AngularJS templates with
 * HTML attributes required for the translation system.
 *
 * @param  {string} template raw HTML template
 * @return {string}          annotated template
 */
function annotateTemplate(template) {
  if (typeof template === 'function') {
    return annotateTemplate(template());
  }
  if (typeof template !== 'string') {
    return template;
  }

  var threepio = new ThreepioLib(document, {
    startExpr: '{[{',
    endExpr: '}]}'
  });

  threepio.prepare(template);
  return threepio.serialize();
}

var _templateObject$1 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']),
    _templateObject2 = _taggedTemplateLiteral(['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.'], ['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.']),
    _templateObject3 = _taggedTemplateLiteral(['Components need to provide views through the\n      \'template\' property.'], ['Components need to provide views through the\n      \'template\' property.']);

var _templateObject$2 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\'']);

function flDirective(directiveCtrl, directiveObj) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!directiveObj.selector || !/^\[?fl-[a-z-]+\]?$/.test(directiveObj.selector)) {
    throw new Error(oneLine(_templateObject$2, directiveObj.selector));
  }

  // Compute the directive's name from the selector & the "restrict" attribute
  var directiveName = directiveObj.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  var decorator = false;
  if (directiveName[0] === '[') {
    directiveName = directiveName.slice(1, -1);
    decorator = true;
  }

  // The controllerAs value is the directive's name (without the 'fl' prefix)
  var controllerAs = directiveName.slice(2);

  // Create factory wrapper
  var ddo = function ddo() {
    return {
      restrict: decorator ? 'A' : 'E',
      replace: directiveObj.replace || false,
      scope: directiveObj.scope || false,
      transclude: directiveObj.transclude,
      require: directiveObj.require,
      template: annotateTemplate(directiveObj.template),
      compile: function compile() {
        return function (scope) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          // call the link function in the context of the controller
          if (scope[controllerAs].link) {
            var _scope$controllerAs;

            return (_scope$controllerAs = scope[controllerAs]).link.apply(_scope$controllerAs, [scope].concat(args));
          }
          return function noop() {};
        };
      },
      controller: directiveCtrl,
      bindToController: true,
      controllerAs: controllerAs
    };
  };

  // Create the directive itself
  return angular$1.module('flForward.Directive.' + directiveName, [].concat(directiveObj.providers || []).concat(directiveObj.directives || [])).directive(directiveName, ddo).name;
}

/**
* @ngdoc service
* @name flApi.flResourceInterceptor
* @description
* Global HTTP interceptor working in conjunction with flResource to allow
* custom endpoint-specific request transformations
*/

var flResourceInterceptor = function flResourceInterceptor() {
  _classCallCheck(this, flResourceInterceptor);

  return {
    /**
     * @ngdoc method
     * @name flApi.flResourceInterceptor#request
     * @methodOf flApi.flResourceInterceptor
     *
     * @description
     * Transform the request using the custom _flRequestInterceptor set on
     * the request configuration if any.
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      if (config._flRequestInterceptor) {
        return config._flRequestInterceptor(config);
      }
      return config;
    }
  };
};

var flResourceInterceptorModule = flService('flResourceInterceptor', [], flResourceInterceptor);

angular$1.module(flResourceInterceptorModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('flResourceInterceptor');
}]);

/**
 * @ngdoc service
 * @name flApi.flResource
 *
 * @description
 * The HTTP interceptors design in Angular is pretty bad as they have to be
 * installed globally and end up relying on crazy RegExes to match or not some
 * specific endpoints.
 *
 * flResource is an Angular $resource wrapper that handle request & response
 * interceptors on a per $resource and per action basics. This wrapper
 * introduces an extra mandatory "interceptor" argument in the 2nd position,
 * i.e. its prototype is:
 *
 * ```
 *    flResource(url, interceptor, [paramDefaults], [actions], options);
 * ```
 *
 * This extra arguments sets the defaults interceptor for the resource and all
 * its actions, the default ones and the one specific or overwritten in the
 * actions param. This interceptor is a standard Angular HTTP interceptor,
 * i.e. an object with one or many of the 3 methods "request, response, and
 * responseError". The ApiInterceptor and GafInterceptors can be use with
 * flResource:
 *
 * ```
 *    const DepositsConfirm = flResource(
 *    API_BASE_URL + '/payments/0.1/deposits/',
 *    ApiInterceptor, {}, { 'update': { method: 'PUT' }});
 * ```
 *
 * This wrapper also extend the interceptor key on the actions objects: by
 * default Angular $resource service only support response & responseError for
 * these. flResource extends that behavior by using a global interceptor to
 * set action-specific request interceptors. This is quite useful for
 * flResource objects that deal with different kind of endpoints:
 *
 * ```
 *    const Invoices = flResource(API_BASE_URL +
 *      '/projects/0.1/invoices/', ApiInterceptor, null, {
 *      fetch: {
 *        method: 'GET',
 *        url: GAF_BASE_URL + '/ajax/project/getProjectInvoices.php',
 *        interceptor: GafInterceptor
 *      },
 *      pay: {
 *        method: 'POST',
 *        url: GAF_BASE_URL + '/ajax/payment/payinvoice.php',
 *        interceptor: GafInterceptor
 *      },
 *      requestChange: {
 *        method: 'GET',
 *        url: GAF_BASE_URL + '/ajax/payment/on-request-invoice-change.php',
 *        interceptor: GafInterceptor
 *      }
 *    });
 *```
 */

var flResourceFactory = function flResourceFactory($resource) {
  _classCallCheck(this, flResourceFactory);

  return function flResource(url, defaultInterceptor, paramDefaults) {
    var actions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { stripTrailingSlashes: false };

    if (!defaultInterceptor || !defaultInterceptor.request) {
      throw new Error('No default interceptor set');
    }

    // Set the default interceptor for the custom actions if not specified
    angular$1.forEach(actions, function (value, action) {
      if (!angular$1.isDefined(actions[action].interceptor)) {
        actions[action].interceptor = defaultInterceptor;
        actions[action]._flRequestInterceptor = defaultInterceptor.request;
      } else {
        actions[action]._flRequestInterceptor = actions[action].interceptor.request;
      }
    });

    // Set the default interceptor for the default $resource action if not
    // defined
    var defaultActions = {
      get: { method: 'GET' },
      save: { method: 'POST' },
      query: { method: 'GET', isArray: true },
      remove: { method: 'DELETE' },
      delete: { method: 'DELETE' }
    };

    angular$1.forEach(defaultActions, function (value, action) {
      if (!angular$1.isDefined(actions[action])) {
        actions[action] = value;
        actions[action].interceptor = defaultInterceptor;
        actions[action]._flRequestInterceptor = defaultInterceptor.request;
      }
    });

    return $resource(url, paramDefaults, actions, options);
  };
};

flResourceFactory.$inject = ['$resource'];


var flResourceProvider = flService('flResource', [ngResource, flResourceInterceptorModule], flResourceFactory);

var _templateObject$3 = _taggedTemplateLiteral(['(?:(?:^|.*;)\\s*\n      ', '\n      \\s*\\=\\s*([^;]*).*$)|^.*$'], ['(?:(?:^|.*;)\\\\s*\n      ', '\n      \\\\s*\\\\=\\\\s*([^;]*).*$)|^.*$']);

/**
 * @ngdoc service
 * @name flCookies.CookieStore
 *
 * @description
 * A factory which creates a service that lets you interact with the browser's
 * cookies.
 *
 * AngularJS has
 * {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
 * its own $cookieStore implementation} but it doesn't support setting any
 * cookie option (e.g. *path*, *domain*, *secure*,
 * and *expiration*) as of today. The APIs are the same than Angular's
 * {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
 * $cookieStore} with an extra parameter (an object with
 * ``expires``, ``path``, ``domain`` and ``secure`` as keys, ``expires``
 * accepting different formats).
 * It is currently used by ``flAuth`` (auth cookies) and ``flAnalytics``
 * (tracking cookies), but you can easily use it in a custom service:
 *
 * ```
   angular.module('myApp')
   .factory('myAwesomeService', function(CookieStore) {
     return {
       setMagicCookie: function(magicNumber) {
         CookieStore.put('CHUCK_NORRIS', magicNumber, {
           expires: Infinity
         });

       ...
     }
   }
 * ```
 *
 * The returned object has action methods which provide high-level behaviors
 * without the need to interact with the low level cookies implementation.
 */

var CookieStoreProvider = function () {
  function CookieStoreProvider($document) {
    _classCallCheck(this, CookieStoreProvider);

    this.$document = $document;
  }
  /**
   * @ngdoc method
   * @name flCookies.CookieStore#get
   * @methodOf flCookies.CookieStore
   *
   * @description
   * Returns the value of given cookie key
   *
   * @param {String} key Id to use for lookup.
   * @returns {Object} Deserialized cookie value.
   */


  _createClass(CookieStoreProvider, [{
    key: 'get',
    value: function get(key) {
      var re = new RegExp(oneLineTrim(_templateObject$3, encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&')));
      var value = this.$document[0].cookie.replace(re, '$1');

      return decodeURIComponent(value) || null;
    }
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#put
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Sets a value for given cookie key
     *
     * @param {String} key Id for the `value`.
     * @param {Object} value The value you want to store in this cookie
     * @param {Object} options Additional settings for the cookie (optional):
     *
     * - expires: expiration date for the cookie
     * - domain: the domain for which the cookie is valid
     * - path: the path for which the cookie is valid
     * - secure: is cookie HTTPS only?
     */

  }, {
    key: 'put',
    value: function put(key, value, options) {
      // Set cookie
      var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      // See options
      if (options) {
        // Expiration date
        if (options.expires) {
          var date = void 0;

          switch (options.expires.constructor) {
            case Number:
              if (options.expires === Infinity) {
                date = 'Fri, 31 Dec 9999 23:59:59 GMT';
              } else {
                // Note: we don't use max-age here because it's
                // not supported in IE8.
                var d = new Date();
                d.setTime(d.getTime() + options.expires * 1000);
                date = d.toUTCString();
              }
              break;
            case String:
              date = options.expires;
              break;
            case Date:
              date = options.expires.toUTCString();
              break;
            default:
              break;
          }

          cookie += ';expires=' + date;
        }
        // Domain
        cookie += options.domain ? ';domain=' + options.domain : '';
        // Path
        cookie += options.path ? ';path=' + options.path : ';path=/';
        // HTTPS Only
        cookie += options.secure ? ';secure' : '';

        var sameSite = options.sameSite;
        if (sameSite === 'None') {
          // some browsers reject cookies with SameSite=None
          // we can test functionality by trying to set and checking if it worked
          // https://www.chromium.org/updates/same-site/incompatible-clients
          this.remove('testsamesitenone');
          this.$document[0].cookie = 'testsamesitenone=1; secure; SameSite=None';
          if (this.get('testsamesitenone') !== '1') {
            // cookie didn't come back: don't set SameSite=None
            sameSite = '';
          }
          this.remove('testsamesitenone');
        }
        cookie += sameSite ? '; SameSite=' + sameSite : '';
      }
      // Save the cookie
      // Note: this.$document is a jqLite wrapper
      this.$document[0].cookie = cookie;
    }
    /**
    * @ngdoc method
    * @name flCookies.CookieStore#remove
    * @methodOf flCookies.CookieStore
    *
    * @description
    * Remove given cookie
    *
    * @param {String} key Id of the key-value pair to delete.
    * @param {Object} options Additional settings for the cookie (optional)
    */

  }, {
    key: 'remove',
    value: function remove(key, options) {
      var opt = options || {};
      // Setting expiry date to a past date deletes a cookie
      opt.expires = new Date(0);
      this.put(key, '', opt);
    }
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#getDomain
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Get Cookie Domain by matching the regex `freelancer.*$`
     * and adding `.` front of it.
     * If it doesn't match the regex, just return the hostName.
     *
     * @param {String} hostName current host name
     *
     * @returns {String} Cookie Domain
     */

  }, {
    key: 'getDomain',
    value: function getDomain(hostName) {
      return hostName.match(/freelancer.*$/) ? '.' + hostName.match(/freelancer.*$/)[0] : '' + hostName;
    }
  }]);

  return CookieStoreProvider;
}();

CookieStoreProvider.$inject = ['$document'];


var CookieStoreProvider$1 = flService('CookieStore', [], CookieStoreProvider);

var _templateObject$4 = _taggedTemplateLiteral(['afpro=', ';\n      afpro_id=', ';\n      afro_sess=', ''], ['afpro=', ';\n      afpro_id=', ';\n      afro_sess=', '']),
    _templateObject2$1 = _taggedTemplateLiteral(['', '-\n        ', '-', '-', '-\n        ', ''], ['', '-\n        ', '-', '-', '-\n        ', '']);

/**
 * @ngdoc service
 * @name flAnalytics.Analytics
 *
 * @description
 * A service that allows you to perform common tasks
 * on Google Analytics.
 */

var AnalyticsProvider = function () {
  function AnalyticsProvider($window, CookieStore, md5) {
    _classCallCheck(this, AnalyticsProvider);

    this.$window = $window;
    this.CookieStore = CookieStore;
    this.md5 = md5;
  }
  /**
   * @ngdoc method
   * @name flAnalytics.Analytics#trackAction
   * @methodOf flAnalytics.Analytics
   *
   * @description
   * Tracks an event/action, i.e. something the app is doing
   *
   * @param {String} category The `eventCategory` parameter
   * @param {String} action The `eventAction` parameter
   * @param {String} result The `eventResult` parameter
   */


  _createClass(AnalyticsProvider, [{
    key: 'trackAction',
    value: function trackAction(category, action, result) {
      this.$window.dataLayer.push({
        event: 'app_action',
        eventCategory: category,
        eventAction: action,
        eventResult: result
      });
    }
    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackAction
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Track a DOM event / user action, e.g. a `click` on a button or
     * a `change` on a select input
     *
     * @param {String} section The `eventSection` parameter
     * @param {String} subsection The `eventSubsection` parameter
     * @param {String} name The `eventName` parameter
     * @param {String} action The `eventAction` parameter
     * @param {String} value The `eventValue` parameter
     * @param {String} label The `eventLabel` parameter
     * @param {String} reference The `eventReference` parameter
     * @param {String} referenceId The `eventReferenceId` parameter
     */

  }, {
    key: 'trackEvent',
    value: function trackEvent(section, subsection, name, action, value, label, reference, referenceId) {
      this.$window.dataLayer.push({
        event: 'user_action',
        eventSection: section,
        eventSubsection: subsection,
        eventName: name,
        eventAction: action,
        eventValue: value,
        eventLabel: label,
        eventReference: reference,
        eventReferenceId: referenceId
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackAjaxTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push user timing data to Google Tag Manager
    *
    * @param {String} method The `ajaxMethod` parameter
    * @param {String} url The `ajaxUrl` parameter
    * @param {String} status The `ajaxStatus` parameter
    * @param {String} timeSpent The `ajaxValue` parameter
    * @param {String} label The `ajaxLabel` parameter
    */

  }, {
    key: 'trackAjaxTiming',
    value: function trackAjaxTiming(method, url, status, timeSpent, label) {
      this.$window.dataLayer.push({
        event: 'ajax_timing',
        ajaxMethod: method,
        ajaxUrl: url,
        ajaxStatus: status,
        ajaxValue: timeSpent,
        ajaxLabel: label
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackAjaxTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track an error (not a JS error, an app error)
    *
    * @param {String} category The `eventCategory` parameter
    * @param {String} action The `eventAction` parameter
    * @param {String} result The `eventResult` parameter
    * @param {String} error The `eventData` parameter
    */

  }, {
    key: 'trackError',
    value: function trackError(category, action, result, error) {
      this.$window.dataLayer.push({
        event: 'app_error',
        eventCategory: category,
        eventAction: action,
        eventResult: result,
        eventLabel: error ? JSON.stringify(error) : undefined
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackABTest
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track an ab test with variation
    *
    * @param {String} category The `test` parameter
    * @param {String} variation The `variation` parameter
    */

  }, {
    key: 'trackABTest',
    value: function trackABTest(name, variation) {
      this.$window.dataLayer.push({
        event: 'abtest',
        testName: name,
        testVariation: variation
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackMobileUserTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push user timing data in Mobile Web to Google Tag Manager
    *
    * @param {String} markName The name of the user timing mark
    * @param {String} markTime The time when the mark was recorded
    */

  }, {
    key: 'trackMobileUserTiming',
    value: function trackMobileUserTiming(markName, markTime) {
      this.$window.dataLayer.push({
        event: 'mobile_user_timing',
        markName: markName,
        markTime: markTime
      });
    }

    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackMobileCountryDomain
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Push country domain data in Mobile Web to data layer
     *
     * @param {String} currentDomain The country domain being used
    */

  }, {
    key: 'trackMobileCountryDomain',
    value: function trackMobileCountryDomain(currentDomain) {
      this.$window.dataLayer.push({
        currentDomain: currentDomain
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackGTMConversion
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push GTM conversion tracking first with orderId, then conversion
    * type and then fire a QTS event together with the GTM tracking
    *
    * @param {String} type The order type, i.e. can be either 'project' or
    * 'contest'
    * @param {String} orderId The order Id
    * @param {String} conversionType The name of conversion type as
    * specified in the GTM console
    */

  }, {
    key: 'trackGTMConversion',
    value: function trackGTMConversion(type, orderId, conversionType) {
      var formattedOrderId = void 0;
      if (type === 'project') {
        formattedOrderId = 'P' + orderId;
      } else if (type === 'contest') {
        formattedOrderId = 'C' + orderId;
      } else {
        return;
      }

      this.$window.dataLayer.push({ order_id: formattedOrderId });
      this.$window.dataLayer.push({ event: conversionType });

      this.trackEvent('GTMTracking', conversionType, false, false, false, formattedOrderId);
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackPageView
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track the referrer of the given URL
    *
    * @param {String} url of the page
    * @param {String} referrer of the page
    */

  }, {
    key: 'trackPageView',
    value: function trackPageView(url, referrerUrl) {
      this.$window.dataLayer.push({
        event: 'page_view',
        referrerUrl: referrerUrl,
        url: url
      });
    }

    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackLocation
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Tracks the latitude and longitude of the user
     */

  }, {
    key: 'trackLocation',
    value: function trackLocation(lat, lon) {
      this.$window.dataLayer.push({
        event: 'user_location',
        lat: lat,
        lon: lon
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getAFPROHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the affiliate program tracking data. The affiliate tracking
    * cookies are set by GAF when redirecting marketing campaigns links,
    * a.k.a. with a pattern like
    * https://www.freelancer.com/campaign/0XYZ123/.
    *
    * @returns {String} a string containing the encoded value
    * of the affiliate tracking cookies
    */

  }, {
    key: 'getAFPROHeader',
    value: function getAFPROHeader() {
      var program = this.CookieStore.get('GETAFREE_AFPRO');
      var programId = this.CookieStore.get('GETAFREE_AFPRO_ID');
      var session = this.CookieStore.get('GETAFREE_AFPRO_SESS');
      if (!program || !programId || !session) {
        // Don't set the header if there's no data
        return undefined;
      }
      return oneLineTrim(_templateObject$4, encodeURIComponent(program), encodeURIComponent(programId), encodeURIComponent(session));
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getTrackingHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the tracking data (QTS session ID for now).
    *
    * @returns {String} a string containing the encoded value
    * of the affiliate tracking session cookie
    */

  }, {
    key: 'getTrackingHeader',
    value: function getTrackingHeader() {
      var tracking = this.CookieStore.get('_tracking_session');
      // Don't set the header if there's no data
      if (!tracking) {
        return undefined;
      }
      return encodeURIComponent(tracking);
    }
    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#setTrackingHeader
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Generates session ID cookie from md5 hash
     *
     * @returns {String} Session ID string
     */

  }, {
    key: 'setTrackingHeader',
    value: function setTrackingHeader() {
      var sessionId = this.getTrackingHeader();
      if (!sessionId) {
        var date = new Date();
        var hashed = this.md5.createHash(Math.random().toString());
        var md5SessionId = oneLineTrim(_templateObject2$1, hashed.substr(0, 8), hashed.substr(8, 4), hashed.substr(12, 4), hashed.substr(16, 4), hashed.substr(20, 12));

        this.CookieStore.put('_tracking_session', md5SessionId, {
          expires: date.getTime() + 60 * 60 * 24 * 365,
          domain: this.CookieStore.getDomain(this.$window.location.hostname)
        });

        return md5SessionId;
      }
      return sessionId;
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getTTREFHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the TTREF tracking data. The TTREF tracking cookies are used to
    * store the entry points (e.g., button click) that lead to a certain
    * action (e.g., post project).
    *
    * @returns {String} a string containing the encoded value
    * of the GETAFREE_TTREF cookie
    */

  }, {
    key: 'getTTREFHeader',
    value: function getTTREFHeader() {
      var ttref = this.CookieStore.get('GETAFREE_TTREF');
      // Don't set the header if there's no data
      if (!ttref) {
        return undefined;
      }
      return ttref;
    }
  }]);

  return AnalyticsProvider;
}();

AnalyticsProvider.$inject = ['$window', 'CookieStore', 'md5'];


var AnalyticsModule = flService('Analytics', [CookieStoreProvider$1, OPAQUE_MODULE_NAME, md5Provider], AnalyticsProvider);

// HTTP interceptor for tracking ajax requests timings
angular$1.module(AnalyticsModule).factory('AjaxTimingInterceptor', ['$q', 'Analytics', 'API_BASE_URL', 'AUTH_BASE_URL', 'GAF_BASE_URL', function ($q, Analytics, API_BASE_URL, AUTH_BASE_URL, GAF_BASE_URL) {
  var startTime = {};
  var logTimeSpent = function logTimeSpent(response) {
    // Compute the request end time
    var endTime = new Date().getTime();
    var timeSpent = endTime - startTime[response.config.url].shift();
    // Label the timing event
    var label = void 0;
    var url = response.config.url;
    if (url.match(/^\/views\//)) {
      label = 'HTML_PARTIAL';
    } else if (url.match(/^\/data\//)) {
      label = 'JSON_DATA';
    } else if (url.indexOf(API_BASE_URL) === 0) {
      label = 'REST_API';
    } else if (url.indexOf(AUTH_BASE_URL) === 0) {
      label = 'AUTH';
    } else if (url.indexOf(GAF_BASE_URL) === 0) {
      label = 'GAF';
    }
    // Log the data
    Analytics.trackAjaxTiming(response.config.method, response.config.url, response.status, timeSpent, label);
    // Do not leak memory!
    if (startTime[response.config.url].length === 0) {
      delete startTime[response.config.url];
    }
  };
  return {
    request: function request(config) {
      // Save the request start time
      if (!startTime[config.url]) {
        startTime[config.url] = [];
      }
      startTime[config.url].push(new Date().getTime());
      return config;
    },
    response: function response(_response) {
      logTimeSpent(_response);
      return _response;
    },
    responseError: function responseError(response) {
      logTimeSpent(response);
      return $q.reject(response);
    }
  };
}]);

// Insert the affiliate tracking header on user GET & POST requests
angular$1.module(AnalyticsModule).factory('AFPROInterceptor', ['Analytics', 'API_BASE_URL', function (Analytics, API_BASE_URL) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL + '/users/0.1/users/')) {
        newConfig.headers['Freelancer-AFPRO'] = Analytics.getAFPROHeader();
      }
      return newConfig;
    }
  };
}]);

// Insert the tracking header on all request to the REST API
angular$1.module(AnalyticsModule).factory('TrackingInterceptor', ['Analytics', 'API_BASE_URL', function (Analytics, API_BASE_URL) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL)) {
        newConfig.headers['Freelancer-Tracking'] = Analytics.getTrackingHeader();
      }
      return newConfig;
    }
  };
}]);

// Insert the TTREF tracking header on POST project request
angular$1.module(AnalyticsModule).factory('TTREFInterceptor', ['API_BASE_URL', 'Analytics', function (API_BASE_URL, Analytics) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL + '/projects/0.1/projects/') && config.method === 'POST') {
        newConfig.headers['Freelancer-TTREF'] = Analytics.getTTREFHeader();
      }
      return newConfig;
    }
  };
}]);

angular$1.module(AnalyticsModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AjaxTimingInterceptor');
  $httpProvider.interceptors.push('AFPROInterceptor');
  $httpProvider.interceptors.push('TrackingInterceptor');
  $httpProvider.interceptors.push('TTREFInterceptor');
}]);

angular$1.module(AnalyticsModule).run(['$window', function ($window) {
  // Log User Agent string.
  // Let's make sure the string is kinda safe while keeping it readable.
  var userAgent = encodeURIComponent($window.navigator.userAgent).replace(/%20/g, ' ').replace(/%2F/g, '/').replace(/%3B/g, ';').replace(/%2C/g, ',');

  $window.dataLayer.push({
    event: 'user_agent',
    uaString: userAgent
  });
}]);

/**
 * @ngdoc service
 * @name flApi.RequestTransformation
 * @description
 * Exposes data transformation methods used for encoding requests and
 * transforming events from realtime fl-notification.
 */

var RequestTransformation = function () {
  function RequestTransformation() {
    _classCallCheck(this, RequestTransformation);
  }

  _createClass(RequestTransformation, [{
    key: 'formUrlEncoded',

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#formUrlEncoded
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method encodes parameters in form encoding, with special handling of
     * array types NOT to use commas, e.g. users[]=123,345 is NOT allowed. This
     * method replaces it with users[]=123&users[]=345
     *
     * @param {Object} data the object intended to be encoded
     * @returns {String} an encoded string
     */
    value: function formUrlEncoded() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var i = void 0;
      var theData = void 0;
      var result = [];

      // If we are sending a Form Encoded request, don't apply the key-value
      // string to the URL. This is bad and makes the request empty :(
      if (data instanceof FormData) {
        return data;
      }

      // Split array parameters into multiple entries
      Object.keys(data).forEach(function (key) {
        if (data[key]) {
          theData = data[key];
          if (Array.isArray(theData)) {
            // Append a '[]' to the param so switching to non-formencoded
            // will be more seamless down the line
            for (i = 0; i < theData.length; i++) {
              var k = encodeURIComponent(key + '[]');
              var d = encodeURIComponent(theData[i]);

              result.push(k + '=' + d);
            }
          } else {
            // Just a normal parameter, encode and push it through
            var _k = encodeURIComponent(key);
            var _d = encodeURIComponent(theData);

            result.push(_k + '=' + _d);
          }
        }
      });
      return result.join('&');
    }
  }, {
    key: 'buildParams',
    value: function buildParams(prefix, obj, add) {
      var _this = this;

      if (Array.isArray(obj)) {
        // Serialize array item.
        angular$1.forEach(obj, function (v, i) {
          var r = typeof v === 'object' ? i : '';

          // Item is non-scalar (array or object), encode its numeric index.
          _this.buildParams(prefix + '[' + r + ']', v, add);
        });
      } else if (angular$1.isObject(obj)) {
        // Serialize object item.
        Object.keys(obj).forEach(function (name) {
          _this.buildParams(prefix + '[' + name + ']', obj[name], add);
        });
      } else {
        // Serialize scalar item.
        add(prefix, obj);
      }
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#formUrlEncodedRecursive
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * Serialize an array of form elements or a set of key/values into a query
     * string
     *
     * @param {Object} data the object intended to be encoded
     * @returns {String} an encoded string
     */

  }, {
    key: 'formUrlEncodedRecursive',
    value: function formUrlEncodedRecursive() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var s = [];
      var add = function add(key, value) {
        // If value is a function, invoke it and return its value
        var v = angular$1.isFunction(value) ? value() : value;

        if (value === null) {
          v = '';
        }

        s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(v);
      };

      // If an array was passed in, assume that it is an array of form elements.
      if (Array.isArray(data) && data !== {}) {
        // Serialize the form elements
        angular$1.forEach(data, function (v, i) {
          add(i, v);
        });
      } else {
        // otherwise encode params recursively.
        Object.keys(data).forEach(function (prefix) {
          _this2.buildParams(prefix, data[prefix], add);
        });
      }
      // update data with final serialization
      return s.join('&');
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#parseBidNotification
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method converts the bid data object from the realtime bid
     * notifications into a raw bid object which can be used to create a bid
     * factory
     *
     * @param {Object} data the bid data object returned by a realtime bid
     * notification
     * @returns {Object} a raw bid object
     */

  }, {
    key: 'parseBidNotification',
    value: function parseBidNotification(data) {
      return {
        id: parseInt(data.bid.id, 10),
        amount: parseInt(data.bid.sum, 10),
        fix_project_hourly_rate: parseFloat(data.bid.fix_project_hourly_rate),
        bidder_id: parseInt(data.bid.users_id, 10),
        description: data.bid.descr,
        award_status: data.bid.award_status,
        frontend_bid_status: 'active',
        hidden: data.bidHidden,
        highlighted: data.bid.highlighted,
        milestone_percentage: data.bid.milestone_percentage,
        period: parseInt(data.bid.period, 10),
        project_id: parseInt(data.bid.project_id, 10),
        project_owner_id: parseInt(data.accountId, 10),
        ranking: data.bid.ranking,
        retracted: false,
        shortlisted: data.bid.isShortlisted || false,
        submitdate: parseInt(data.bid.submitdate_ts, 10),
        time_submitted: parseInt(data.bid.submitdate_ts, 10),
        score: parseFloat(data.bid.score)
      };
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#parseUserNotification
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method converts the user data object from the realtime bid
     * notifications into a raw user object which can be used to create a user
     * factory
     *
     * @param {Object} data the bid data object returned by a realtime bid
     * notification
     * @returns {Object} a raw user object
     */

  }, {
    key: 'parseUserNotification',
    value: function parseUserNotification(data) {
      if (Array.isArray(data.bid.user.insignia)) {
        data.bid.user.insignia = data.bid.user.insignia.map(function (item) {
          return {
            id: parseInt(item.examId, 10),
            name: item.title,
            description: item.description,
            icon_name: item.name
            /* TODO: Data that cannot be parse from Notification's data
             * - icon_url
             * - level
             * - score_percentage
             * - type
             * - user_percentile
             */
          };
        });
      }
      var timezone = void 0;
      if (data.bid.user.timezone_info && data.bid.user.timezone_info.country && data.bid.user.timezone_info.id && data.bid.user.timezone_info.offset && data.bid.user.timezone_info.timezone) {
        timezone = {
          country: data.bid.user.timezone_info.country,
          id: data.bid.user.timezone_info.id,
          offset: data.bid.user.timezone_info.offset,
          timezone: data.bid.user.timezone_info.timezone
        };
      }

      return {
        avatar_cdn: data.imgUrl,
        hourly_rate: data.bid.user.hourlyrate,
        id: parseInt(data.bid.user.id, 10),
        location: {
          country: {
            code: data.bid.user.address.code,
            name: data.bid.user.flag.name
          }
        },
        registration_date: data.bid.user.reg_unixtime,
        reputation: {
          earnings_score: data.bid.user.earnings,
          entire_history: {
            all: data.bid.user.seller_rating.projectCount.entire_history.all,
            completion_rate: data.bid.user.seller_rating.projectCount.entire_history.completion_rate,
            overall: data.bid.user.seller_rating.avg,
            reviews: data.bid.user.seller_rating.count,
            on_time: data.bid.user.seller_rating.reputation.entire_history.ont,
            on_budget: data.bid.user.seller_rating.reputation.entire_history.onb,
            category_ratings: {
              quality: data.bid.user.seller_rating.reputation.entire_history.qua,
              communication: data.bid.user.seller_rating.reputation.entire_history.com,
              expertise: data.bid.user.seller_rating.reputation.entire_history.exp,
              professionalism: data.bid.user.seller_rating.reputation.entire_history.pro,
              hire_again: data.bid.user.seller_rating.reputation.entire_history.hag
            }
          },
          user_id: parseInt(data.bid.user.id, 10)
        },
        username: data.bid.user.username,
        isPortfolioCreated: data.bid.user.isPortfolioCreated,
        qualifications: data.bid.user.insignia,
        corporate: data.bid.user.corporate,
        public_name: data.bid.user.publicName,
        timezone: timezone
      };
    }
  }]);

  return RequestTransformation;
}();

var RequestTransformationProvider = flService('RequestTransformation', [], RequestTransformation);

var _templateObject$5 = _taggedTemplateLiteral(['\n      ', '/contacts/0.1/requests/pending_sent/'], ['\n      ', '/contacts/0.1/requests/pending_sent/']),
    _templateObject2$2 = _taggedTemplateLiteral(['\n            ', ' ', ''], ['\n            ', ' ', '']);

/**
* @ngdoc service
* @name flApi.ApiInterceptor
* @description
* Transform the requests to and from the REST API. Use it with flResource.
*/

var ApiInterceptor = function ApiInterceptor($q, $log, Analytics, RequestTransformation, API_BASE_URL) {
  _classCallCheck(this, ApiInterceptor);

  // In contacts and messaging APIs, the parameters for a request to the API
  // need to be form encoded. These are the exceptions, using a primitive
  // wildcard expression for threads.
  var contactRequestUrl = oneLineTrim(_templateObject$5, API_BASE_URL);
  var threadServiceUrl = API_BASE_URL + '/messages/0.1/threads/*';
  var messageServiceUrl = API_BASE_URL + '/messages/0.1/messages/*';
  var videochatServiceUrl = API_BASE_URL + '/messages/0.1/videochat/*';

  var encodeAsFormExceptionMatcher = function encodeAsFormExceptionMatcher(config) {
    var method = config.method;
    return config.url.match(threadServiceUrl) && (method === 'POST' || method === 'PUT') || config.url.match(messageServiceUrl) || config.url.match(videochatServiceUrl) || config.url.match(contactRequestUrl);
  };

  // Encode parameters in form encoding, with special handling of array
  // types NOT to use commas, e.g. users[]=123,345 is NOT allowed. This
  // function replaces it with users[]=123&users[]=345
  var encodeFormUrlEncoded = function encodeFormUrlEncoded(config) {
    // If we are sending a Form Encoded request, don't apply the key-value
    // string to the URL. This is bad and makes the request empty :(
    if (config.data instanceof FormData) {
      return;
    }

    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = RequestTransformation.formUrlEncoded(config.data);
  };

  // In the translations API, parameter flags are indicated are indicating
  // with either it's the presence (indicating true) or absence (indicating
  // false). As a result, parameters with a "false" value should simply be
  // removed.
  var translationsApiUrl = API_BASE_URL + '/translations/0.1/*';
  var removeFalseParams = function removeFalseParams(config) {
    Object.keys(config.params).forEach(function (key) {
      if (config.params[key] === false) {
        delete config.params[key];
      }
    });
  };
  return {
    /**
     * @ngdoc method
     * @name flApi.ApiInterceptor#request
     * @methodOf flApi.ApiInterceptor
     *
     * @description
     * Intercepts requests to `API_BASE_URL` and applies some modifications
     * to them according to certain criteria (e.g. some header could be
     * added/modified).
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      // Activate the "compact" mode on all requests to the API
      if (config.params) {
        config.params.compact = true;
      } else if (config.data && config.data instanceof FormData) {
        config.data.append('compact', 'true');
      } else if (config.data) {
        config.data.compact = true;
      }

      // Fix the "action" PATH & PUT requests being form submission
      // instead of application/json
      if (encodeAsFormExceptionMatcher(config)) {
        encodeFormUrlEncoded(config);
      } else if ((config.method === 'PUT' || config.method === 'PATCH') && config.data && config.data.action &&
      // Dirty hack, but we have no choice until we fix these global
      // interceptors
      !config.url.match('/api/users/0.1/showcase_items/') && !config.url.match('/api/users/0.1/phone_verifications/') && !config.url.match('/api/users/0.1/webhooks/')) {
        encodeFormUrlEncoded(config);
      }

      // Removing false params from all requests to the translations API
      if (config.url.match(translationsApiUrl)) {
        removeFalseParams(config);
      }
      return config;
    },
    /**
     * @ngdoc method
     * @name flApi.ApiInterceptor#response
     * @methodOf flApi.ApiInterceptor
     *
     * @description
     * Intercepts responses from `API_BASE_URL` and applies some
     * modifications to them according to certain criteria (e.g. some content
     * could be added/modified).
     *
     * @param {Object} response The content of the response.
     * @returns {Object} The object received as a parameter,
     * eventually modified.
     */
    response: function response(_response) {
      // Check the response validity
      if (_response.data && _response.data.status === 'success') {
        if (_response.data.result) {
          _response.data = _response.data.result;
        }
      } else {
        // Shouldn't happen, report the error
        var errorCode = 'INVALID_RESPONSE';
        $log.error('api: invalid server response: ' + _response.data);
        if (typeof Raven !== 'undefined') {
          Raven.captureMessage(errorCode, {
            extra: {
              response: JSON.stringify(_response.data),
              config: JSON.stringify(_response.config),
              status: _response.status,
              status_text: _response.statusText
            }
          });
        }
        Analytics.trackError('api', oneLineTrim(_templateObject2$2, _response.config.method, _response.config.url), _response.status, _response.data);
        _response.code = errorCode;
        return $q.reject(_response);
      }
      return _response.data;
    },
    /**
    * @ngdoc method
    * @name flApi.ApiInterceptor#responseError
    * @methodOf flApi.ApiInterceptor
    *
    * @description
    * `responseError` interceptor gets called when a previous interceptor
    * threw an error or resolved with a rejection.
    *
    * @param {Object} response The request configuration object
    * @returns {Object} The object received as a parameter,
    * eventually modified.
    */
    responseError: function responseError(response) {
      var errorCode = void 0;

      // Provide human-oriented error messages in response blob
      var humanError = {
        title: 'Something went wrong',
        message: 'Please check your internet connection and refresh the page.'
      };
      if (response.status >= 400 && response.status < 500) {
        humanError = {
          title: 'Something went wrong',
          message: 'If this problem persists, please contact support with ' + ('Error: ' + response.data.message)
        };
      } else if (response.status >= 500 && response.status < 600) {
        humanError = {
          title: 'Something went wrong with our service',
          message: 'To continue, please refresh the page and try again.'
        };
      }
      response.humanError = humanError;

      // We should always have an error message
      if (response.data && response.data.error_code) {
        var errors = response.data.error_code.match(/\.(.*$)/);
        if (errors && errors[1]) {
          errorCode = errors[1];
        } else {
          errorCode = 'INVALID_ERROR';
        }
      } else {
        errorCode = 'INVALID_RESPONSE';
      }

      // Push interesting errors into Sentry
      if (errorCode === 'UNKNOWN_ERROR' || errorCode === 'GAF_EXCEPTION' || errorCode === 'INVALID_ERROR' || errorCode === 'INVALID_RESPONSE' || errorCode === 'GENERAL') {
        if (typeof Raven !== 'undefined') {
          Raven.captureMessage(errorCode, {
            tags: {
              api: JSON.stringify(response.config.url)
            },
            extra: {
              response: JSON.stringify(response.data),
              config: JSON.stringify(response.config),
              status: response.status,
              status_text: response.statusText
            }
          });
        }
        Analytics.trackError('api', oneLineTrim(_templateObject2$2, response.config.method, response.config.url), response.status, response.data);
      }
      if (!response.data) {
        response.data = {};
      }
      response.code = errorCode;
      return $q.reject(response);
    }
  };
};

ApiInterceptor.$inject = ['$q', '$log', 'Analytics', 'RequestTransformation', 'API_BASE_URL'];


var ApiInterceptorProvider = flService('ApiInterceptor', [OPAQUE_MODULE_NAME, AnalyticsModule, RequestTransformationProvider], ApiInterceptor);

/**
 * @ngdoc service
 * @name flApiTranslations.Translations
 *
 * @description
 * A service that provides a convenient way to interact with the translations
 * API
 */
var OPAQUE_MODULE_NAME$1 = 'flAngular.TranslationsProvider';

var TranslationsProviderProvider = angular$1.module(OPAQUE_MODULE_NAME$1, [threepio, OPAQUE_MODULE_NAME, flResourceProvider, ApiInterceptorProvider]).provider('Translations', ['TranslationProvider', 'LocalizationProvider', 'LANGUAGE_COOKIE', 'LANGUAGE_COOKIE_EXPIRES', function TranslationsProvider(TranslationProvider, LocalizationProvider, LANGUAGE_COOKIE, LANGUAGE_COOKIE_EXPIRES) {
  var translationsDomain = void 0;

  this.translate = function (domain, translateRootEl) {
    translationsDomain = domain;
    TranslationProvider.setTranslationsRequest(['Translations', function (Translations) {
      return function (language) {
        return Translations.getStrings(domain, language);
      };
    }]);
    if (translateRootEl) {
      TranslationProvider.translateRootElement();
    }
    LocalizationProvider.setLanguageCookie(LANGUAGE_COOKIE, {
      domain: window.location.hostname.match(/freelancer.*$/) ? window.location.hostname.match(/freelancer.*$/)[0] : undefined,
      expires: LANGUAGE_COOKIE_EXPIRES
    });
  };

  this.setLanguage = function (languageCode$$1) {
    LocalizationProvider.setLanguage(languageCode$$1);
  };

  this.$get = ['flResource', 'ApiInterceptor', 'API_BASE_URL', function (flResource, ApiInterceptor, API_BASE_URL) {
    // The `/translations` GET API endpoint uses the `Accept` header to
    // indicate the preferred response media type. The default `Accept`
    // header for `$http` includes `application/json`, `text/plain`, and
    // `*/*` without any weights, which would create an ambiguous resulting
    // in a `300` status code.
    // Because of this we explicitly specify `application/json` as the sole
    // accepted media type.
    var Translations = flResource(API_BASE_URL + '/translations/0.1/translations/', ApiInterceptor, {
      hashed: true,
      legacy: true
    }, {
      get: {
        cache: true,
        headers: { Accept: 'application/json' }
      }
    });
    var Languages = flResource(API_BASE_URL + '/translations/0.1/languages/', ApiInterceptor);

    return {
      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getStrings
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Get the all the strings of a translation domain for a language
       *
       * @param {String} domain The domain for which to get the translations
       * @returns {Object} language The language code (e.g., "fr") of the
       * locale
       */
      getStrings: function getStrings(domain, language) {
        return Translations.get({
          domain: domain,
          language_code: language
        }).$promise;
      },

      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getDomain
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Get the translation domain set by the Angular app via .config()
       *
       * @returns {String} domain The domain for which to get the translations
       */
      getDomain: function getDomain() {
        return translationsDomain;
      },

      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getLanguages
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Fetch a list of all languages in the translations system
       *
       * @param {Boolean} activeOnly      Indicates whether or not inactive
       *                                  languages should also be returned
       * @param {Array}   languageCodes   An optional array of codes for the
       *                                  specific languages to return
       * @returns {Object}                A promise that resolves to an
       *                                  object hash of language codes and
       *                                  names
       */
      getLanguages: function getLanguages() {
        var activeOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var languageCodes = arguments[1];

        return Languages.get({
          'language_codes[]': languageCodes,
          active_only: activeOnly
        }).$promise;
      }
    };
  }];
}]).name;

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines a section that is being tracked.
 */

var flAnalyticsSection = function flAnalyticsSection($attrs) {
  _classCallCheck(this, flAnalyticsSection);

  this.section = $attrs.flAnalyticsSection;
};

flAnalyticsSection.$inject = ['$attrs'];


var flAnalyticsSection$1 = flDirective(flAnalyticsSection, {
  selector: '[fl-analytics-section]'
});

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines a subsection that is being tracked.
 */

var flAnalyticsSubsection = function flAnalyticsSubsection($attrs) {
  _classCallCheck(this, flAnalyticsSubsection);

  this.subsection = $attrs.flAnalyticsSubsection;
};

flAnalyticsSubsection.$inject = ['$attrs'];


var flAnalyticsSubsection$1 = flDirective(flAnalyticsSubsection, {
  selector: '[fl-analytics-subsection]'
});

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines an element that is being tracked. The event that
 * is being tracked is inferred by the type of the element.
 */

// Infer the DOM event type from the element tagName & type
function inferEventType(element) {
  if (['button', 'submit'].indexOf(element.type) !== -1) {
    return 'click';
  } else if (['select', 'input', 'textarea'].indexOf(element.tagName.toLowerCase()) !== -1) {
    return 'change';
  } else if (element.isContentEditable) {
    // contenteditable elements don't have change events
    return 'blur';
  }
  return 'click';
}

// Event section is mandotary, event subsection is optional

var flAnalytics = function () {
  function flAnalytics($parse, $log, Analytics) {
    _classCallCheck(this, flAnalytics);

    this.$parse = $parse;
    this.$log = $log;
    this.Analytics = Analytics;
  }

  _createClass(flAnalytics, [{
    key: 'link',
    value: function link(scope, element, attrs, ctrls) {
      var _this = this;

      // The name of the event (mandatory)
      var name = attrs.flAnalytics;
      // The section on the site (mandatory)
      var section = ctrls[0].section;
      // The subsection (optional)
      var subsection = ctrls[1] ? ctrls[1].subsection : undefined;

      if (name && section) {
        (function () {
          // DOM event type
          var type = inferEventType(element[0]);
          element.on(type, function (e) {
            var el = e.target;
            // Get the event value from the attributes (Angular expression) or
            // use the DOM element value is not specified
            var value = _this.$parse(attrs.flAnalyticsValue)(scope);
            // Get the action from the event type if no action is specified
            var action = attrs.flAnalyticsAction ? attrs.flAnalyticsAction : type;
            // Get the element label: if it's a select input & an element is
            // selected, get the selected text, otherwise we use the content
            var label = attrs.flAnalyticsLabel;
            if (!label && !el.isContentEditable) {
              label = el.value && el.options ? el.options[el.selectedIndex].text : el.textContent.trim();
            }
            var reference = attrs.flAnalyticsReference;
            var referenceId = attrs.flAnalyticsReferenceId;

            _this.Analytics.trackEvent(section, subsection, name, action, value, label, reference, referenceId);
          });
        })();
      } else {
        this.$log.warn('invalid event name or section');
      }
    }
  }]);

  return flAnalytics;
}();

flAnalytics.$inject = ['$parse', '$log', 'Analytics'];


var flAnalytics$1 = flDirective(flAnalytics, {
  selector: '[fl-analytics]',
  providers: [AnalyticsModule],
  directives: [flAnalyticsSection$1, flAnalyticsSubsection$1],
  require: ['^flAnalyticsSection', '?^flAnalyticsSubsection'],
  scope: false
});

var _templateObject$6 = _taggedTemplateLiteral(['Invalid app name selector (', '): the selector\n      must be a dash-delimited element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid app name selector (', '): the selector\n      must be a dash-delimited element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']);

/*
 * `angular.module` wrapper to abtract the Angular apps common configurations
 * in GAF. Use it instead of `angular.module` to create & bootstrap your app:
 *
 * ```
 * export default flApp('phoneVerification', [
 *   PhoneVerification
 * ]);
 * ```
 */
function flApp(name, deps, appController) {
  // Lint for invalid selector
  // TODO: this should be a lint rule
  if (!/^fl-[a-z-]+$/.test(name)) {
    throw new Error(oneLine(_templateObject$6, name));
  }

  var app = angular$1.module(name + 'App', deps.concat([TranslationsProviderProvider, flAnalytics$1, flAnalyticsSection$1, flAnalyticsSubsection$1])).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
  }]).config(['TranslationsProvider', function (TranslationsProvider) {
    var translationName = name.replace(/^fl-/, '');
    TranslationsProvider.translate('gaf|' + translationName);
    TranslationsProvider.setLanguage(languageCode);
  }]).config(['$interpolateProvider', function ($interpolateProvider) {
    $interpolateProvider.startSymbol('{[{');
    $interpolateProvider.endSymbol('}]}');
  }]);
  // FIXME: There's no way we're gonna to load the TranslationModal for
  // non-translators
  /* .run(function(TranslationModal, CookieStore, TRANSLATE_MODE_COOKIE) {
      TranslationModal.setTranslationMode(
        CookieStore.get(TRANSLATE_MODE_COOKIE) === '1'
      );
    }); */

  if (appController) {
    app.controller('appController', appController);
  }

  setTimeout(function () {
    var app = angular$1.element(document.querySelector(name));
    if (!app.injector()) {
      angular$1.bootstrap(app, [name + 'App']);
    }
  });
  return app;
}

function getQueryStringValueByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regexS = '[\\?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.href);
  if (results == null) {
    return '';
  }

  return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function setCookieToBrowser(cookieName, cookieValue, expiredays, path, domain) {
  var expiremins = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cookieName + '=' + escape(cookieValue) + ('' + (exdate ? ';expires=' + exdate.toUTCString() : '')) + ('' + (path ? ';path=' + path : '')) + ('' + (domain ? ';domain=' + domain : '')) + ';secure';
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function getUserIdfromCookie() {
  return getCookie(cookieBase + '_USER_ID');
}

// DEPRECATED. Just use cookieBase from 'server-data/flconfigs'
// const getCookieBase;

function getAuthHeader() {
  var authHashV2 = getCookie(cookieBase + '_AUTH_HASH_V2');
  var userId = getUserIdfromCookie();
  return { 'Freelancer-Auth-V2': userId + ';' + authHashV2 };
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

var EXPERIMENT_TYPE_SESSION_BASED = 1;
var EXPERIMENT_TYPE_USER_BASED = 2;
var EXPERIMENT_TYPE_PROJECT_BASED = 3;

var ABTestApi = {
  testSubjectEnrol: function testSubjectEnrol(experimentName, identifier, experimentType) {
    var authHeader = getAuthHeader();

    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'POST',
      data: JSON.stringify({
        id_type: experimentType,
        id: identifier,
        experiment_name: experimentName
      }),
      contentType: 'application/json',
      headers: authHeader
    });
  },
  testSubjectActivate: function testSubjectActivate(experimentName, variation) {
    var authHeader = getAuthHeader();
    var userId = getUserIdfromCookie();

    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'PUT',
      data: JSON.stringify({
        id_type: EXPERIMENT_TYPE_USER_BASED,
        id: parseInt(userId, 10),
        experiment_name: experimentName,
        variation: variation
      }),
      contentType: 'application/json',
      headers: authHeader
    });
  },
  activateSessionBasedTestSubject: function activateSessionBasedTestSubject(experimentName, variation) {
    var userId = getUserIdfromCookie();
    var authHeader = void 0;
    if (userId) {
      authHeader = getAuthHeader();
    }
    var sessionId = getCookie('_tracking_session');
    return jq.ajax({
      url: '/api/abtest/0.1/enrollments/',
      method: 'PUT',
      data: JSON.stringify({
        id_type: EXPERIMENT_TYPE_SESSION_BASED,
        id: sessionId,
        experiment_name: experimentName,
        variation: variation
      }),
      contentType: 'application/json',
      headers: authHeader
    });
  },

  EXPERIMENT_TYPE_USER_BASED: EXPERIMENT_TYPE_USER_BASED,
  EXPERIMENT_TYPE_SESSION_BASED: EXPERIMENT_TYPE_SESSION_BASED,
  EXPERIMENT_TYPE_PROJECT_BASED: EXPERIMENT_TYPE_PROJECT_BASED
};

var webappABTestServiceReady = new Promise(function (resolve) {
  if (window.webappCompatABTest) {
    resolve();
  } else {
    window.webappCompatABTestReadyCallback = function () {
      return resolve();
    };
  }
});

var ABTest = {
  // returns a Promise of the variation name, based on the experiment name and
  // the user's current tracking session ID.
  getSessionExperimentVariation: function getSessionExperimentVariation(experimentName) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.getSessionExperimentVariation(experimentName);
    });
  },

  // returns a Promise of the variation name, based on the experiment name and
  // an optional user id. If the user id is not specify, it falls back to using
  // the user's current ID (we run tests based on other users' IDs, e.g.
  // project owners IDs).
  getUserExperimentVariation: function getUserExperimentVariation(experimentName, userId) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.getUserExperimentVariation(experimentName, userId);
    });
  },

  // returns a Promise of the variation name, based on the experiment name and
  // a project ID.
  getProjectExperimentVariation: function getProjectExperimentVariation(experimentName, projectId) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.getProjectExperimentVariation(experimentName, projectId);
    });
  },

  // Determines whether or not to enrol a user/project based on a percentage split.
  shouldEnrol: function shouldEnrol(experimentName, contextId, testProportion) {
    return webappABTestServiceReady.then(function () {
      return window.webappCompatABTest.shouldEnrol(experimentName, contextId, testProportion);
    });
  }
};

/**
 * @ngdoc service
 * @name flAuth.Auth
 *
 * @description
 * Implementation of the Freelancer Auth API
 */

var AuthProvider = function () {
  function AuthProvider($http, $q, $rootScope, $window, CookieStore, AUTH_BASE_URL, AUTH_TOKEN_COOKIE, USER_ID_COOKIE, FACEBOOK_APP_ID) {
    _classCallCheck(this, AuthProvider);

    this.CookieStore = CookieStore;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$q = $q;
    this.$window = $window;
    this.AUTH_BASE_URL = AUTH_BASE_URL;
    this.AUTH_TOKEN_COOKIE = AUTH_TOKEN_COOKIE;
    this.USER_ID_COOKIE = USER_ID_COOKIE;
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.accessToken = CookieStore.get(AUTH_TOKEN_COOKIE);
    this.userId = parseInt(CookieStore.get(USER_ID_COOKIE), 10);

    // Avoid using $location in fl-api as it breaks backbone.js routers
    // and we need to support legacy code for now
    this.defaultCookieOptions = {
      domain: this.CookieStore.getDomain(this.$window.location.hostname),
      secure: $window.location.protocol === 'https:',
      // SameSite=None can only be set on Secure cookies
      sameSite: $window.location.protocol === 'https:' ? 'None' : ''
    };
  }
  // Start new session / Login user


  _createClass(AuthProvider, [{
    key: 'login',
    value: function login(username, password, remember) {
      var _this = this;

      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', username);
      payload.append('password', password);

      return this.$http.post(this.AUTH_BASE_URL + '/login/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function (response) {
        _this.set(response.data.token, response.data.user, remember);
        return response.data;
      });
    }

    // Reset session

  }, {
    key: 'reset',
    value: function reset() {
      // Reset state
      this.accessToken = null;
      this.userId = null;
      // Remove auth cookies
      this.CookieStore.remove(this.AUTH_TOKEN_COOKIE, this.defaultCookieOptions);
      this.CookieStore.remove(this.USER_ID_COOKIE, this.defaultCookieOptions);
      // Unset Raven userId
      if (typeof Raven !== 'undefined') {
        Raven.setUser();
      }
      this.$rootScope.$broadcast('user.logout');
    }
    // Set a new session

  }, {
    key: 'set',
    value: function set(accessToken, userId, remember) {
      // Save auth params
      this.accessToken = accessToken;
      this.userId = parseInt(userId, 10);
      // Store the auth params as cookies
      // Only send the session cookie over SSL to prevent session hijacking
      // Remember for a 2 weeks. Yes GAF remembers you for 5 years but
      // that's maybe a bit too much.
      var options = this.defaultCookieOptions;
      // TODO: ^This should be a shallow copy instead of copy by reference.
      // Copy by reference means `options.expires` will
      // also change this.defaultCookieOptions.expires value.
      options.expires = remember ? 60 * 60 * 24 * 14 : null;
      this.CookieStore.put(this.AUTH_TOKEN_COOKIE, accessToken, options);
      this.CookieStore.put(this.USER_ID_COOKIE, userId, options);
      // Set the user id into Raven
      if (typeof Raven !== 'undefined') {
        Raven.setUser({
          id: this.userId
        });
      }
      this.$rootScope.$broadcast('user.login');
    }

    // Set Extra Cookies

  }, {
    key: 'setExtraCookies',
    value: function setExtraCookies(cookies) {
      var _this2 = this;

      Object.keys(cookies).forEach(function (cookieName) {
        var cookie = cookies[cookieName];
        var options = Object.assign({}, _this2.defaultCookieOptions);
        if ('ttl' in cookie) {
          options.expires = cookie.ttl;
        }

        if ('value' in cookie) {
          _this2.CookieStore.put(cookieName, cookie.value, options);
        }
      });
    }

    // End session / Logout user

  }, {
    key: 'logout',
    value: function logout() {
      var _this3 = this;

      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', this.userId);
      payload.append('token', this.accessToken);

      // Destroys the session token
      return this.$http.post(this.AUTH_BASE_URL + '/logout/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function () {
        _this3.reset();
      }).catch(function (error) {
        // Reset the session anyway if the token is invalid
        _this3.reset();
        return error;
      });
    }
    // Is the user currently authenticated?

  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      return this.userId && this.accessToken;
    }
    // Get userId

  }, {
    key: 'getUserId',
    value: function getUserId() {
      return this.userId;
    }
    // Get accessToken

  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return this.accessToken;
    }
    // Freelancer-Auth-V2 auth header params for the REST API

  }, {
    key: 'getAuthHeader',
    value: function getAuthHeader() {
      // Do not set the header if not authenticated
      if (this.isAuthenticated()) {
        return this.userId + '; ' + encodeURIComponent(this.accessToken);
      }
      return undefined;
    }
    // Returns a promise

  }, {
    key: 'checkAuthenticated',
    value: function checkAuthenticated() {
      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      return this.$http.get(this.AUTH_BASE_URL + '/check/', {
        params: {
          user: this.userId,
          token: this.token
        }
      }).then(function (response) {
        return response.data.expiry;
      });
    }

    // Set a new password
    // - INVALID_USER
    // - WEAK_PASSWORD
    // - INVALID_CREDENTIALS

  }, {
    key: 'changePassword',
    value: function changePassword(oldPassword, newPassword) {
      var _this4 = this;

      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', this.userId);
      payload.append('old_password', oldPassword);
      payload.append('new_password', newPassword);

      return this.$http.post(this.AUTH_BASE_URL + '/change/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function (response) {
        _this4.set(response.data.token, response.data.user, true);
      });
    }

    // Send reset password email
    // - UNKOWN_EMAIL

  }, {
    key: 'resetPassword',
    value: function resetPassword(email) {
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('email', email);
      return this.$http.post(this.AUTH_BASE_URL + '/forgot/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      });
    }
    /**
    * @ngdoc method
    * @name flthis.Auth#login
    * @methodOf flthis.Auth
    *
    * @description
    * Use facebook credentials to login to Freelancer
    * Makes use of the FB.login call to the facebook api
    * to ensure the user is logged in to facebook and has
    * granted permissions to Freelance.
    *
    * @returns {Object} a Promise object that will be resolved with an
    * auth response object from the freelancer api
    */

  }, {
    key: 'loginWithFacebook',
    value: function loginWithFacebook(facebookAuthParams) {
      return this.oAuthLogin(this.FACEBOOK_APP_ID, 'facebook', facebookAuthParams.signedRequest);
    }
    // Login the user using OAuth credentials
    // INVALID_USER
    // INVALID_TOKEN

  }, {
    key: 'oAuthLogin',
    value: function oAuthLogin(appId, oauthType, credentials) {
      var _this5 = this;

      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('app_id', appId);
      payload.append('oauth_type', oauthType);
      payload.append('credentials', credentials);

      return this.$http.post(this.AUTH_BASE_URL + '/login/oauth/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function (response) {
        _this5.set(response.data.token, response.data.user, true);
        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#getDeviceToken
     * @methodOf flAuth.Auth
     *
     * @description
     * Fetch a unique token provided to a device, intended to be
     * stored by the device independent of user sessions.
     *
     * @returns {String} a Promise string token
     */

  }, {
    key: 'getDeviceToken',
    value: function getDeviceToken() {
      return this.$http.get(this.AUTH_BASE_URL + '/device/').then(function (response) {
        return response.data.token;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#loginWith2FA
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer login API with additional device token parameter to
     * determine if user 2FA is required or not. This will also send the TOTP
     * token to the delivery mechanism available for the user.
     *
     * @returns {Object} a Promise object that will throw an error if
     * 2FA is required, otherwise it will be resolved with an
     * auth token and user id.
     */

  }, {
    key: 'loginWith2FA',
    value: function loginWith2FA(username, password, remember, deviceToken) {
      var _this6 = this;

      var payload = new FormData();
      payload.append('user', username);
      payload.append('password', password);
      payload.append('device_token', deviceToken);

      return this.$http.post(this.AUTH_BASE_URL + '/login/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function (response) {
        if (response.data.pre_login_token) {
          var error = response.data;
          error.code = '2FA_REQUIRED';

          return _this6.$q.reject(error);
        }

        // No 2FA required
        _this6.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#verifyTotp
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer login API to verify if the prelogin token, TOTP
     * and device token are valid.
     *
     * @returns {Object} a Promise object that will be resolved with
     * an auth token and user id.
     */

  }, {
    key: 'verifyTotp',
    value: function verifyTotp(preLoginToken, totp, deviceToken, remember) {
      var _this7 = this;

      var payload = new FormData();
      payload.append('pre_login_token', preLoginToken);
      payload.append('totp', totp);
      payload.append('device_token', deviceToken);

      return this.$http.post(this.AUTH_BASE_URL + '/login/verify/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function (response) {
        _this7.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#switchAccount
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer switch account API to login linked corporate accounts
     *
     * @returns {Object} a Promise object that will be resolved with an
     * auth response object from the Freelancer Api
     */

  }, {
    key: 'switchAccount',
    value: function switchAccount(fromUserId, toUserId, remember) {
      var _this8 = this;

      var payload = new FormData();
      payload.append('user', fromUserId);
      payload.append('other_user', toUserId);
      payload.append('token', this.accessToken);

      return this.$http.post(this.AUTH_BASE_URL + '/switch_account/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular$1.identity
      }).then(function (response) {
        _this8.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }
  }]);

  return AuthProvider;
}();

AuthProvider.$inject = ['$http', '$q', '$rootScope', '$window', 'CookieStore', 'AUTH_BASE_URL', 'AUTH_TOKEN_COOKIE', 'USER_ID_COOKIE', 'FACEBOOK_APP_ID'];


var AuthModule = flService('Auth', [AnalyticsModule, CookieStoreProvider$1, OPAQUE_MODULE_NAME], AuthProvider);

// HTTP interceptor for 401 UNAUTHORIZED
// Logout the current user if it happens (it should not!)
angular$1.module(AuthModule).factory('AutoLogoutInterceptor', ['$q', '$injector', function ($q, $injector) {
  return {
    responseError: function responseError(response) {
      // Filter out login requests with invalid credentials
      if (response.status === 401 && response.config.url.indexOf('/auth/login') === -1) {
        // Clear invalid session token
        // Differed injection is need to work around circular
        // dependency between Auth & $http
        $injector.invoke(['Auth', function (Auth) {
          Auth.reset();
        }]);
      }
      return $q.reject(response);
    }
  };
}]);

// Add the REST API auth header
angular$1.module(AuthModule).factory('RESTAuthInterceptor', ['$injector', 'API_BASE_URL', function ($injector, API_BASE_URL) {
  return {
    request: function request(config) {
      if (config.url.match(API_BASE_URL)) {
        // Differed injection is need to work around circular
        // dependency between Auth & $http
        $injector.invoke(['Auth', function (Auth) {
          config.headers['Freelancer-Auth-V2'] = Auth.getAuthHeader();
        }]);
      }
      return config;
    }
  };
}]);

/**
 * @ngdoc service
 * @name flAuth.AuthBackendInterceptor
 *
 * @description
 * HTTP interceptor abstracting the comminutation with the auth backend
 */
angular$1.module(AuthModule).factory('AuthBackendInterceptor', ['$q', '$log', 'AUTH_BASE_URL', 'Analytics', function ($q, $log, AUTH_BASE_URL, Analytics) {
  return {
    /**
    * @ngdoc method
    * @name flAuth.AuthBackendInterceptor#response
    * @methodOf flAuth.AuthBackendInterceptor
    *
    * @description
    * Process auth related response -
    *    1. Replace response.data with response.data.result on success
    *    2. Report error and returns a rejected promise
    *
    * @param {Object} response The http response object
    * @returns {Object} successful resonse or a rejected promise
    */
    response: function response(_response) {
      // Only handles auth related urls
      if (_response.config.url.match(AUTH_BASE_URL + '(?:[?/]|$)')) {
        // Check the response validity
        if (_response.data && _response.data.status === 'success' && (_response.config.url.match(/\/logout\/$/) || _response.config.url.match(/\/forgot\/$/))) ; else if (_response.data && _response.data.status === 'success' && _response.data.result) {
          _response.data = _response.data.result;
        } else {
          // Shouldn't happen, report the error
          $log.error('auth: invalid server response: ' + _response.data);
          var errorCode = 'INVALID_RESPONSE';
          if (typeof Raven !== 'undefined') {
            Raven.captureMessage(errorCode, {
              extra: {
                response: JSON.stringify(_response.data),
                config: JSON.stringify(_response.config),
                status: _response.status,
                status_text: _response.statusText
              }
            });
          }
          Analytics.trackError('auth', _response.config.method + ' ' + _response.config.url, _response.status, _response.data);
          _response.code = errorCode;
          return $q.reject(_response);
        }
      }
      return _response;
    },
    /**
    * @ngdoc method
    * @name flAuth.AuthBackendInterceptor#responseError
    * @methodOf flAuth.AuthBackendInterceptor
    *
    * @description
    * Process auth related error response
    *
    * @param {Object} response The http response object
    * @returns {Object} A rejected promise with proper reason code
    */
    responseError: function responseError(response) {
      // Only handles auth related urls
      if (response.config.url.match(AUTH_BASE_URL + '(?:[?/]|$)')) {
        var errorCode = void 0;
        if (response.data && (response.data.error_code || response.data.message)) {
          if (response.data.error_code && response.data.error_code !== 'None') {
            var errors = response.data.error_code.match(/\.(.*$)/);
            if (errors && errors[1]) {
              errorCode = errors[1];
            } else {
              errorCode = 'INVALID_ERROR';
            }
          } else if (response.data.message) {
            // Error message -> error code mapping
            // TODO: Use error codes
            switch (response.data.message) {
              case 'Incorrect username or password provided':
                errorCode = 'INVALID_CREDENTIALS';
                break;
              case 'Invalid user provided':
                errorCode = 'INVALID_USER';
                break;
              case 'Invalid token provided':
                errorCode = 'INVALID_TOKEN';
                break;
              case 'Cannot find a user with that email address':
                errorCode = 'UNKNOWN_EMAIL';
                break;
              case 'Unable to authenticate user':
                errorCode = 'INVALID_USER';
                break;
              case 'An error occured verifying OAuth token':
                errorCode = 'INVALID_TOKEN';
                break;
              case 'User could not be found':
                errorCode = 'INVALID_USER';
                break;
              case 'Your new password is too weak. ' + 'Please choose a better password':
                errorCode = 'WEAK_PASSWORD';
                break;
              case 'Invalid user credentials provided':
                errorCode = 'INVALID_CREDENTIALS';
                break;
              case 'You are performing too many requests.':
                errorCode = 'TOO_MANY_REQUESTS';
                break;
              default:
                errorCode = 'UNKNOWN_ERROR';
                break;
            }
          }
        } else {
          errorCode = 'INVALID_RESPONSE';
          $log.error('auth: invalid server response: ' + response.data);
        }
        // Push interesting errors into Sentry
        if (errorCode === 'UNKNOWN_ERROR' || errorCode === 'INVALID_RESPONSE' || errorCode === 'TOO_MANY_REQUESTS') {
          if (typeof Raven !== 'undefined') {
            Raven.captureMessage(errorCode, {
              tags: {
                api: JSON.stringify(response.config.url)
              },
              extra: {
                response: JSON.stringify(response.data),
                config: JSON.stringify(response.config),
                status: response.status,
                status_text: response.statusText
              }
            });
          }
          Analytics.trackError('auth', response.config.method + ' ' + response.config.url, response.status, response.data);
        }
        response.code = errorCode;
        return $q.reject(response);
      }
      return $q.reject(response);
    }
  };
}]);

angular$1.module(AuthModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AutoLogoutInterceptor');
  $httpProvider.interceptors.push('RESTAuthInterceptor');
  $httpProvider.interceptors.push('AuthBackendInterceptor');
}]);

/**
 * @ngdoc directive
 * @name flUtils.directive:flIcon
 * @element A
 * @function
 *
 * @description
 * Our own md-icon.
 *
 * @example
  ```
    <fl-icon name="icon-name"></fl-icon>
  ```
 */
var OPAQUE_MODULE_NAME$2 = 'flAngular.flIcon';

var flIconProvider = angular$1.module(OPAQUE_MODULE_NAME$2, []).directive('flIcon', ['$sce', '$window', function ($sce, $window) {
  return {
    templateUrl: function templateUrl(elem, attrs) {
      return $sce.trustAsResourceUrl($window.SystemJS.normalizeSync('icons/' + attrs.name + '.svg'));
    },
    link: function link(scope, element, attrs) {
      if (attrs.class) {
        element.find('svg').addClass(attrs.class);
        element.removeAttr('class');
      }
    }
  };
}]).name; // exports the opaque token

/*
 * Angular service wrapper to abstract the creation of Angular services in your
 * applications.
 *
 * ```
 * import ngResource from 'angular-resource';
 * import { flService } from 'fl-forward';
 *
 * export default flService('MyService',
 *   [ngResource],
 *   MyService
 * );
 *
 * class MyService {
 *   constructor($resource) {
 *     ...
 *   }
 * }
 * ```
 */
function flService$1(name, deps, classFn) {
  return angular$1.module('flForward.Service.' + name, deps).service(name, classFn).name;
}

/**
 * annotateTemplate - uses threepio to annotate AngularJS templates with
 * HTML attributes required for the translation system.
 *
 * @param  {string} template raw HTML template
 * @return {string}          annotated template
 */
function annotateTemplate$1(template) {
  if (typeof template !== 'string') {
    return template;
  }

  var threepio = new ThreepioLib$1(document, {
    startExpr: '{[{',
    endExpr: '}]}'
  });

  threepio.prepare(template);
  return threepio.serialize();
}

var _templateObject$7 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']),
    _templateObject2$3 = _taggedTemplateLiteral(['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.'], ['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.']),
    _templateObject3$1 = _taggedTemplateLiteral(['Components need to provide views through the\n      \'template\' property.'], ['Components need to provide views through the\n      \'template\' property.']);

function flComponent$1(componentCtrl, componentOptions) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!componentOptions.selector || !/^fl-[a-z-]+$/.test(componentOptions.selector)) {
    throw new Error(oneLine(_templateObject$7, componentOptions.selector));
  }

  // Lint for invalid use of link function
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (componentCtrl && componentCtrl.prototype.link) {
    throw new Error(oneLine(_templateObject2$3));
  }

  // The templates must be loaded through SystemJS
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (componentOptions.templateUrl) {
    throw new Error(oneLine(_templateObject3$1));
  }

  // Get the component name from its selector
  var camelCasedName = componentOptions.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });

  // The controllerAs value is the component's name (without the 'fl' prefix)
  var controllerAs = camelCasedName.slice(2);

  return angular$1.module('flForward.Component.' + camelCasedName, [].concat(componentOptions.providers || []).concat(componentOptions.directives || [])).component(camelCasedName, {
    controller: componentCtrl,
    controllerAs: controllerAs,
    template: annotateTemplate$1(componentOptions.template),
    transclude: componentOptions.transclude,
    bindings: componentOptions.bindings,
    restrict: 'E',
    require: componentOptions.require
  }).name;
}

var _templateObject$8 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\'']);

function flDirective$1(directiveCtrl, directiveObj) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!directiveObj.selector || !/^\[?fl-[a-z-]+\]?$/.test(directiveObj.selector)) {
    throw new Error(oneLine(_templateObject$8, directiveObj.selector));
  }

  // Compute the directive's name from the selector & the "restrict" attribute
  var directiveName = directiveObj.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  var decorator = false;
  if (directiveName[0] === '[') {
    directiveName = directiveName.slice(1, -1);
    decorator = true;
  }

  // The controllerAs value is the directive's name (without the 'fl' prefix)
  var controllerAs = directiveName.slice(2);

  // Create factory wrapper
  var ddo = function ddo() {
    return {
      restrict: decorator ? 'A' : 'E',
      replace: directiveObj.replace || false,
      scope: directiveObj.scope || false,
      transclude: directiveObj.transclude,
      require: directiveObj.require,
      template: annotateTemplate$1(directiveObj.template),
      compile: function compile() {
        return function (scope) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          // call the link function in the context of the controller
          if (scope[controllerAs].link) {
            var _scope$controllerAs;

            return (_scope$controllerAs = scope[controllerAs]).link.apply(_scope$controllerAs, [scope].concat(args));
          }
          return function noop() {};
        };
      },
      controller: directiveCtrl,
      bindToController: true,
      controllerAs: controllerAs
    };
  };

  // Create the directive itself
  return angular$1.module('flForward.Directive.' + directiveName, [].concat(directiveObj.providers || []).concat(directiveObj.directives || [])).directive(directiveName, ddo).name;
}

/*
 * Angular filter wrapper to abstract the creation of Angular filters
 *
 * ```
 * import flFilter from 'fl-forward';
 *
 * function creditCardFilter() {
 *   return function(cardNumber) {
 *     var nums = cardNumber.replace(/ /g,'').match(/.{1,4}/g);
 *     return nums.join(' ');
 * };
 *
 * export default flFilter('creditCard',
 *   [], // providers if any
 *   creditCardFilter
 * );
 * ```
 */
function flFilter$1(name, deps, filterFn) {
  return angular$1.module('flForward.Filter.' + name, deps).filter(name, filterFn).name;
}

/*
 * Angular constant wrapper to abstract the creation of Angular constant
 *
 * ```
 * import { flConstant } from 'fl-forward';
 *
 * export default flConstant('CONNECTION_URL', 'http://foo');
 * ```
 */
function flConstant$1(varName, varValue) {
  return angular$1.module('flForward.Constant.' + varName, []).constant(varName, varValue).name;
}

var template = "<fl-onboard ng-if=\"ProjectCreate.showOnboard\"\n  class=\"Modal Modal--fullscreen\"\n  on-complete=\"ProjectCreate.onOnboardComplete()\">\n</fl-onboard>\n<div class=\"PagePostProject-content PagePostProject-container Container\">\n  <fl-draft-banner ng-if=\"ProjectCreate.AutoSaveDraftService.hasDraft\"></fl-draft-banner>\n  <fl-wizard-form t133576-test-variation=\"ProjectCreate.t133576TestVariation\"></fl-wizard-form>\n</div>\n";

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
function now() {
  return Date.now();
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$1.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = isFunction(value.valueOf) ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

var SkillPredictor = function () {
  function SkillPredictor($http) {
    _classCallCheck(this, SkillPredictor);

    this.$http = $http;
  }

  _createClass(SkillPredictor, [{
    key: 'predict',
    value: function predict(title, description) {
      var params = { title: title, description: description };
      return this.$http.get('/ajax/skills/predict.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        qtsp.push({
          section: 'MigratedPPP',
          subsection: 'ProjectDescription',
          name: 'SkillPredictor',
          action: 'error',
          value: JSON.stringify(e)
        });
      });
    }
  }]);

  return SkillPredictor;
}();

SkillPredictor.$inject = ['$http'];

var SkillPredictorProvider = flService$1('SkillPredictor', [], SkillPredictor);

var JobClassifier = function () {
  function JobClassifier($http) {
    _classCallCheck(this, JobClassifier);

    this.$http = $http;
  }

  /**
   * @ngdoc method
   * @name JobClassifier.classify
   * @description
   * Given an array of skill ids, return a promise which returns a Job
   * Classification. (Likely Contest, Likely Project, or Unknown).
   */

  _createClass(JobClassifier, [{
    key: 'classify',
    value: function classify(skillIds) {
      var params = {
        jobs: skillIds.map(function (skillId) {
          return parseInt(skillId, 10);
        }).join(',')
      };

      return this.$http.get('/ajax/job/classify.php', {
        params: params
      }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        qtsp.push({
          section: 'MigratedPPP',
          subsection: 'ProjectSkills',
          name: 'JobClassifier',
          action: 'error',
          value: JSON.stringify(e)
        });
      });
    }
  }]);

  return JobClassifier;
}();

JobClassifier.$inject = ['$http'];

var JobClassifierProvider = flService$1('JobClassifier', [], JobClassifier);

var ProjectData = function () {
  function ProjectData($http, currency$$1, JobClassifier, SkillPredictor, userLocation$$1, invitedUser$$1, isEscrowCurrencyRestricted$$1, $q, $rootScope, Auth) {
    var _this = this;

    _classCallCheck(this, ProjectData);

    this.$http = $http;
    this.project = {
      action: 'updatePublish',
      commitment: 40,
      commitmentInterval: 'week',
      csrfToken: getCSRFToken(),
      currency: currency$$1,
      duration: 6,
      invitedUser: invitedUser$$1,
      pageName: pageName,
      submitAction: 'publish project',
      isLocal: false,
      projectType: 'online',
      areSkillsAllLocal: false,
      selectedSkills: [],
      jobClassification: 'unknown',
      skillsDefinedByUser: false,
      isEscrowCurrencyRestricted: isEscrowCurrencyRestricted$$1
    };
    if (userLocation$$1) {
      this.initProjectLocation(userLocation$$1);
    } else {
      this.isValidGeoInfo = false;
    }
    if (!this.project.upgrades) {
      this.project.upgrades = {
        standard: {
          price: 0
        },
        recruiter: {
          checked: false
        },
        featured: {
          checked: false
        },
        urgent: {
          checked: false
        },
        private: {
          checked: false
        },
        nda: {
          checked: false
        },
        project_management_bundle: {
          checked: false,
          allowUpgrade: false
        }
      };
    }
    this.languageCode = languageCode;
    this.getSkillOptions();
    this.pppABTest = pppABTest || {};
    this.skillPredictor = SkillPredictor;
    this.predictInProgress = false;
    this.predictSuccess = false;
    this.debouncedSkillPredict = debounce(function () {
      return _this.predictSkills();
    }, 700);
    this.localSkills = [];
    this.urgentSkills = [];
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.designCategoryId = 3;
    this.contestMode = false;
    this.Auth = Auth;

    this.jobClassifier = JobClassifier;
    this.debouncedJobClassification = debounce(function () {
      return _this.classifyJob();
    }, 700);
    this.initialiseTrackingVars();
  }

  _createClass(ProjectData, [{
    key: 'initProjectLocation',
    value: function initProjectLocation(location) {
      location = JSON.parse(location);
      if (location) {
        this.project.project_geoInfo_lat = location.lat;
        this.project.project_geoInfo_lng = location.lng;
        this.project.project_geoInfo_vicinity = location.vicinity;
        this.project.project_geoInfo_administrative_area_level_1 = location.administrative_area_level_1;
        this.project.project_geoInfo_country = location.country;
        this.project.project_geoInfo_formatted_address = location.formatted_address;
        this.isValidGeoInfo = true;
      }
    }
  }, {
    key: 'getSkillOptions',
    value: function getSkillOptions() {
      var _this2 = this;

      this.skillsReadyPromise = this.$http.get('/api/projects/0.1/jobs/', {
        params: {
          lang: this.languageCode || 'en'
        }
      }).then(function (response) {
        _this2.skillOptions = response.data.result;
        return _this2.$q.when();
      }).catch(function () {
        _this2.skillOptions = [];
        return Promise.reject();
      });
    }
  }, {
    key: 'addSelectedSkill',
    value: function addSelectedSkill(newSkill, source) {
      // If skill already exists, don't add it.
      var existingSkill = this.project.selectedSkills.find(function (skill) {
        return skill && skill.id === newSkill.id;
      });

      if (existingSkill) {
        return;
      }

      // Tracking
      var previousSkills = this.getSelectedSkillsAsString();

      this.project.selectedSkills.push(newSkill);
      this.addUrgentSkill(newSkill);
      this.addLocalSkill(newSkill);
      this.getJobClassification();

      // Tracking
      if (source === 'skills-suggestion') {
        this.trackAddSuggestedSkill(newSkill);
      } else {
        this.trackSkillChanges(previousSkills, source);
      }
    }
  }, {
    key: 'addSelectedSkillById',
    value: function addSelectedSkillById(id, source) {
      var _this3 = this;

      this.skillsReadyPromise.then(function () {
        var newSkill = _this3.skillOptions.find(function (skill) {
          return parseInt(skill.id, 10) === id;
        });
        if (newSkill) {
          _this3.addSelectedSkill(newSkill, source);
        }
      }).catch();
    }
  }, {
    key: 'removeSelectedSkill',
    value: function removeSelectedSkill(skill, source) {
      // Don't remove anything if skills list is empty or udnefined
      if (!this.project.selectedSkills || this.project.selectedSkills.length === 0) {
        return;
      }

      // Tracking
      var previousSkills = this.getSelectedSkillsAsString();

      var index = this.project.selectedSkills.indexOf(skill);
      this.project.selectedSkills.splice(index, 1);
      if (this.project.selectedSkills.length === 0) {
        this.$rootScope.$broadcast('skillSetChange');
      }
      this.removeLocalSkill(skill);
      this.removeUrgentSkill(skill);
      this.getJobClassification();

      // Tracking
      this.trackSkillChanges(previousSkills, source);
    }
  }, {
    key: 'addUrgentSkill',
    value: function addUrgentSkill(skill) {
      var categoryId = skill.category ? skill.category.id : skill.category_id;

      if (categoryId === this.designCategoryId) {
        this.urgentSkills.push(skill);
        if (this.urgentSkills.length === 1) {
          this.$rootScope.$broadcast('skillSetChange');
        }
      }
    }
  }, {
    key: 'removeUrgentSkill',
    value: function removeUrgentSkill(skill) {
      var categoryId = skill.category ? skill.category.id : skill.category_id;

      if (categoryId === this.designCategoryId) {
        var index = this.urgentSkills.indexOf(skill);
        this.urgentSkills.splice(index, 1);
        if (this.urgentSkills.length === 0) {
          this.$rootScope.$broadcast('skillSetChange');
        }
      }
    }
  }, {
    key: 'addLocalSkill',
    value: function addLocalSkill(skill) {
      if (skill.local) {
        this.localSkills.push(skill);
        if (this.localSkills.length === 1) {
          this.$rootScope.$broadcast('skillSetChange');
        }
      }
      this.checkAllSkillsAreLocal();
    }
  }, {
    key: 'removeLocalSkill',
    value: function removeLocalSkill(skill) {
      if (skill.local) {
        var index = this.localSkills.indexOf(skill);
        this.localSkills.splice(index, 1);
        if (this.localSkills.length === 0) {
          this.$rootScope.$broadcast('skillSetChange');
        }
      }
      this.checkAllSkillsAreLocal();
    }
  }, {
    key: 'checkAllSkillsAreLocal',
    value: function checkAllSkillsAreLocal() {
      var arePreviousSkillsAllLocal = this.project.areSkillsAllLocal;
      this.project.areSkillsAllLocal = this.localSkills.length > 0 && this.localSkills.length === this.project.selectedSkills.length;

      if (arePreviousSkillsAllLocal != this.project.areSkillsAllLocal) {
        this.$rootScope.$broadcast('skillSetChange');
      }
    }
  }, {
    key: 'clearSkills',
    value: function clearSkills() {
      this.project.selectedSkills = [];
      this.project.skillsDefinedByUser = false;
      this.project.areSkillsAllLocal = false;
      this.project.jobClassification = 'unknown';
      this.localSkills = [];
      this.urgentSkills = [];
    }
  }, {
    key: 'detectSkills',
    value: function detectSkills() {
      if (this.project.skillsDefinedByUser) {
        return; // do not detect skills if user has edited them already.
      }

      if (!this.project.project_name || !this.project.description) {
        this.project.selectedSkills.splice(0, this.project.selectedSkills.length);
        this.localSkills.splice(0, this.localSkills.length);
        return;
      }
      this.predictInProgress = true;
      this.debouncedSkillPredict();
    }
  }, {
    key: 'predictSkills',
    value: function predictSkills() {
      var _this4 = this;

      var title = this.project.project_name;
      var description = this.project.description;
      this.skillPredictor.predict(title, description).then(function (result) {
        if (result.status === 'success') {
          if (result.skills.length > 5) {
            return result.skills.splice(0, 5);
          }
          return result.skills;
        }
        return [];
      }).then(function (skillIds) {
        _this4.predictSuccess = skillIds.length !== 0;
        _this4.clearSkills();
        skillIds.forEach(function (id) {
          return _this4.addSelectedSkillById(id, 'skills-predict');
        });
        _this4.predictInProgress = false;
      }).catch(function () {
        _this4.predictSuccess = false;
      });
    }
  }, {
    key: 'getJobClassification',
    value: function getJobClassification() {
      this.debouncedJobClassification();
    }
  }, {
    key: 'classifyJob',
    value: function classifyJob() {
      var _this5 = this;

      if (!this.project.selectedSkills.length) {
        return;
      }

      var skillIds = this.project.selectedSkills.map(function (skill) {
        return parseInt(skill.id, 10);
      });
      this.jobClassifier.classify(skillIds).then(function (data) {
        if (data && data.status === 'success' && data.result) {
          _this5.project.jobClassification = data.result.category;
        }
        data.result.skillIds = skillIds.join(',');
        qtsp.push({
          section: 'ContestUpsell',
          subsection: 'ProjectSkills',
          name: 'JobClassifier',
          label: data.status,
          value: JSON.stringify(data.result)
        });
      }).catch(function () {});
    }
  }, {
    key: 'toggleLocalJob',
    value: function toggleLocalJob(isLocal) {
      this.project.isLocal = isLocal;
      this.project.projectType = isLocal ? 'in-person' : 'online';
    }

    /**
     * @ngdoc method
     * @name ProjectData.trackAddSuggestedSkill
     * @description
     * Helper function to trigger delayed tracking of suggested skills.
     * (Adds to a list of suggested skills the user may have selected, which will
     *  then be sent all at once after debounce)
     */

  }, {
    key: 'trackAddSuggestedSkill',
    value: function trackAddSuggestedSkill(skill) {
      this.trackingInfo.suggestedSkills.push(parseInt(skill.id, 10));
      this.delayedTrackSuggestedSkills();
    }

    /**
     * @ngdoc method
     * @name ProjectData.trackSkillChanges
     * @description
     * Tracks a variety of sources (label) of Selected Skill Changes.
     *  - (Prefill, Predict, Draft, Suggestion, Manual)
     */

  }, {
    key: 'trackSkillChanges',
    value: function trackSkillChanges(previousSkills, label) {
      // Set Previous Skills only if its null (unset)
      if (this.trackingInfo.previousSkills === null) {
        this.trackingInfo.previousSkills = previousSkills != null ? previousSkills : '';
      }
      // Always update current skills
      var currentSkills = this.getSelectedSkillsAsString();
      this.trackingInfo.currentSkills = currentSkills;

      if (!label) {
        label = 'skills-change';
      }

      this.delayedTrackSkillChanges(label);
    }

    /**
     * @ngdoc method
     * @name ProjectData.getSelectedSkillsAsString
     * @description
     * Helper function to get the current selected skills as a string. (csv)
     */

  }, {
    key: 'getSelectedSkillsAsString',
    value: function getSelectedSkillsAsString() {
      return this.project.selectedSkills.map(function (skill) {
        return parseInt(skill.id, 10);
      }).sort(function (a, b) {
        return a - b;
      }).join(',');
    }

    /**
     * @ngdoc method
     * @name ProjectData.initialiseTrackingVars
     * @description
     * Sets up the Necessary Tracking Variables.
     * Currently only for tracking skills.
     *  - (Prefill, Predict, Draft, Suggestion, Manual)
     */

  }, {
    key: 'initialiseTrackingVars',
    value: function initialiseTrackingVars() {
      var _this6 = this;

      this.trackingInfo = {
        previousSkills: null,
        currentSkills: null,
        suggestedSkills: []
      };

      this.delayedTrackSkillChanges = debounce(function (label) {
        qtsp.push({
          section: 'wizard-form',
          value: '[' + _this6.trackingInfo.previousSkills + ']to[' + _this6.trackingInfo.currentSkills + ']',
          label: label
        });
        // Reset Previous and Current Skills
        _this6.trackingInfo.previousSkills = null;
        _this6.trackingInfo.currentSkills = null;
      }, 1000);

      this.delayedTrackSuggestedSkills = debounce(function () {
        qtsp.push({
          section: 'wizard-form',
          label: 'skills-suggestion',
          value: _this6.trackingInfo.suggestedSkills.join(',')
        });
        // Reset tracking suggested skills
        _this6.trackingInfo.suggestedSkills = [];
      }, 1000);
    }
  }]);

  return ProjectData;
}();

ProjectData.$inject = ['$http', 'currency', 'JobClassifier', 'SkillPredictor', 'userLocation', 'invitedUser', 'isEscrowCurrencyRestricted', '$q', '$rootScope', 'Auth'];

var ProjectDataProvider = flService$1('ProjectData', [currency, invitedUser, JobClassifierProvider, SkillPredictorProvider, userLocation, isEscrowCurrencyRestricted, AuthModule], ProjectData);

var LOCAL_DRAFT_STORAGE = 'flProjectV2';
var LOCAL_DRAFT_STORAGE_DATE = 'flDraftUpdateV2';

var LocalDraftStorage = function () {
  function LocalDraftStorage(ProjectData, $window, Auth) {
    _classCallCheck(this, LocalDraftStorage);

    this.ProjectData = ProjectData;
    this.Auth = Auth;
    this.localStorage = $window.localStorage;
  }

  _createClass(LocalDraftStorage, [{
    key: 'save',
    value: function save() {
      if (this.localStorage) {
        this.lastUpdate = new Date();
        this.localStorage.setItem('flDraftUpdateV2', this.lastUpdate);
        var projectData = this.ProjectData.project;
        if (this.Auth.getUserId()) {
          projectData.owner = this.Auth.getUserId();
        }
        projectData = JSON.stringify(this.ProjectData.project);
        this.localStorage.setItem(LOCAL_DRAFT_STORAGE, projectData);
      }
      return Promise.resolve();
    }
  }, {
    key: 'hasDraft',
    value: function hasDraft() {
      return this.localStorage ? this.localStorage.getItem(LOCAL_DRAFT_STORAGE) : false;
    }
  }, {
    key: 'clear',
    value: function clear() {
      qtsp.push({
        section: 'MigratedPPP',
        subsection: 'DraftBanner',
        label: 'ClearLoggedoutDraft'
      });
      this.localStorage.removeItem(LOCAL_DRAFT_STORAGE);
    }
  }, {
    key: 'load',
    value: function load() {
      if (!this.localStorage) {
        return Promise.reject();
      }
      var draft = this.localStorage.getItem(LOCAL_DRAFT_STORAGE);
      if (draft) {
        var draftData = JSON.parse(draft);
        if (this.Auth.getUserId() && draftData.owner && draftData.owner !== this.Auth.getUserId()) {
          return Promise.reject();
        }
        qtsp.push({
          section: 'MigratedPPP',
          subsection: 'DraftBanner',
          label: 'ShowLoggedoutDraftBanner'
        });
        draftData.lastUpdate = new Date(this.localStorage.getItem(LOCAL_DRAFT_STORAGE_DATE));
        return Promise.resolve(draftData);
      }
      return Promise.reject();
    }
  }, {
    key: 'hasSkills',
    value: function hasSkills(project) {
      return project.selectedSkills;
    }
  }, {
    key: 'setProjectData',
    value: function setProjectData(project) {
      var _this = this;

      if (project.id) {
        this.ProjectData.project.id = project.id;
      }
      this.ProjectData.project.project_name = project.project_name;
      this.ProjectData.project.description = project.description;
      if (this.hasSkills(project)) {
        project.selectedSkills.forEach(function (skill) {
          return _this.ProjectData.addSelectedSkill(skill, 'skills-local-draft');
        });
      }
      if (project.selectedCurrency) {
        this.ProjectData.project.prefillCurrencyId = project.selectedCurrency.id;
      }
      this.ProjectData.project.budgetPeriod = project.budgetPeriod;
      if (project.selectedBudget) {
        this.ProjectData.project.budgetId = project.selectedBudget.id;
      }
      this.ProjectData.project.budgetType = project.budgetType;
      this.ProjectData.project.selectedBudget = project.selectedBudget;
      this.ProjectData.project.selectedUpgrade = project.selectedUpgrade;
      this.ProjectData.project.upgrades = project.upgrades;
      this.ProjectData.project.lastUpdate = project.lastUpdate;
    }
  }]);

  return LocalDraftStorage;
}();

LocalDraftStorage.$inject = ['ProjectData', '$window', 'Auth'];

var LocalDraftStorageProvider = flService$1('LocalDraftStorage', [AuthModule, ProjectDataProvider], LocalDraftStorage);

var ServerDraftStorage = function () {
  function ServerDraftStorage($http, ProjectData, Auth) {
    _classCallCheck(this, ServerDraftStorage);

    this.ProjectData = ProjectData;
    this.Auth = Auth;
    this.$http = $http;
    this.autosavedOnce = false;
  }

  /**
   * Save to draft V3
   */

  _createClass(ServerDraftStorage, [{
    key: 'save',
    value: function save() {
      var draftData = JSON.stringify(this.ProjectData.project);
      return this.$http({
        method: 'POST',
        url: '/ajax/project/draft/saveDraft.php',
        data: 'draft_data=' + encodeURIComponent(draftData),
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        if (response.data.status === 'success') {
          return Promise.resolve();
        }
        return Promise.reject();
      });
    }
  }, {
    key: 'encodeForm',
    value: function encodeForm() {
      var keyValuePairs = [];
      var elements = document.getElementById('post-project-form').elements;
      for (var i = 0; i < elements.length; i++) {
        var elem = elements[i];
        if (elem.name && elem.value) {
          if (elem.type === 'checkbox' || elem.type === 'radio') {
            if (elem.checked) {
              keyValuePairs.push(encodeURIComponent(elem.name) + '=' + encodeURIComponent(elem.value));
            }
          } else {
            keyValuePairs.push(encodeURIComponent(elem.name) + '=' + encodeURIComponent(elem.value));
          }
        }
      }
      return keyValuePairs;
    }
  }, {
    key: 'track',
    value: function track() {
      qtsp.push({
        section: 'MigratedPPP',
        label: 'DraftCreated',
        reference: 'project_id',
        reference_id: this.ProjectData.project.id
      });
    }

    // Remove this once no more draft v2 in project table.

  }, {
    key: 'clear',
    value: function clear() {
      return this.newDraftClear();
    }
  }, {
    key: 'oldDraftClear',
    value: function oldDraftClear(project) {
      var params = {
        id: project.id,
        action: 'delete',
        isAjaxCall: 1
      };
      delete this.ProjectData.project.id;
      this.autosavedOnce = false;
      return this.$http.get('/buyers/draft-delete.php', { params: params });
    }
  }, {
    key: 'newDraftClear',
    value: function newDraftClear() {
      return this.$http({
        method: 'POST',
        url: '/ajax/project/draft/deleteDraft.php',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      });
    }

    /**
     * @description Loads data of latest draft
     */

  }, {
    key: 'load',
    value: function load() {
      var _this = this;

      return this.oldDraftLoad().then(function (draft) {
        // TODO Remove this once no more draft v2 in project table.
        // Save it to draft V3.
        _this.oldDraftSetProjectData(draft); // This will break prefill temporary if the user has draft.
        _this.save(); // save to v3
        _this.oldDraftClear(draft); // remove v2
        return Promise.resolve(_this.ProjectData.project);
      }).catch(function () {
        return (
          // draft v2 does not exist, Try to load V3
          _this.newDraftLoad()
        );
      });
    }

    // TODO Remove this once no more draft v2 in project table.

  }, {
    key: 'oldDraftLoad',
    value: function oldDraftLoad() {
      var params = { user_id: this.Auth.getUserId() };
      return this.$http.get('/ajax/project/getLatestDraftProject.php', {
        params: params
      }).then(function (res) {
        if (res.data.draft) {
          res.data.draft.lastUpdate = new Date(res.data.draft.submitUnixTime * 1000);
          return Promise.resolve(res.data.draft);
        }
        return Promise.reject();
      });
    }
  }, {
    key: 'newDraftLoad',
    value: function newDraftLoad() {
      return this.$http.get('/ajax/project/draft/getDraft.php').then(function (res) {
        if (res.data.draft) {
          var draftData = res.data.draft;
          draftData.lastUpdate = new Date(res.data.submitUnixTime * 1000);
          return Promise.resolve(draftData);
        }
        return Promise.reject();
      });
    }

    /**
     * @param {object} project Data representing the draft
     * @description Checks whether draft has skills
     */

  }, {
    key: 'hasSkills',
    value: function hasSkills(project) {
      return this.newDraftHasSkills(project);
    }

    // TODO Remove this once no more draft v2 in project table.

  }, {
    key: 'oldDraftHasSkills',
    value: function oldDraftHasSkills(project) {
      return project.skills.length > 0;
    }
  }, {
    key: 'newDraftHasSkills',
    value: function newDraftHasSkills(project) {
      return project.selectedSkills;
    }

    /**
     * @param {object} project Data representing the draft
     * @description Sets project data using the given data
     */

  }, {
    key: 'setProjectData',
    value: function setProjectData(project) {
      return this.newDraftSetProjectData(project);
    }

    // TODO Remove this once no more draft v2 in project table.

  }, {
    key: 'oldDraftSetProjectData',
    value: function oldDraftSetProjectData(project) {
      var _this2 = this;

      if (typeof project !== 'undefined') {
        this.ProjectData.project.project_name = project.title;
        this.ProjectData.project.description = project.description;

        if (project.minBudget || project.maxBudget) {
          this.ProjectData.project.budgetId = project.budgetId;
          this.ProjectData.project.prefillCurrencyId = project.currencyId;
        }

        if (project.budgetId === 'custom') {
          this.ProjectData.project.customMinBudget = project.minBudget;
          this.ProjectData.project.customMaxBudget = project.maxBudget;
          this.ProjectData.project.customFromPrefill = true;
        }
        this.ProjectData.project.budgetType = project.budgetPeriod;

        this.ProjectData.project.lastUpdate = project.lastUpdate;

        project.skills.forEach(function (skillId) {
          return _this2.ProjectData.addSelectedSkillById(parseInt(skillId, 10), 'skills-server-draft-old');
        });

        this.ProjectData.project.fileData = project.fileData;
      }
    }
  }, {
    key: 'newDraftSetProjectData',
    value: function newDraftSetProjectData(project) {
      var _this3 = this;

      this.ProjectData.project.project_name = project.project_name;
      this.ProjectData.project.description = project.description;
      if (this.hasSkills(project)) {
        project.selectedSkills.forEach(function (skill) {
          return _this3.ProjectData.addSelectedSkill(skill, 'skills-server-draft-new');
        });
      }
      if (project.selectedCurrency) {
        this.ProjectData.project.prefillCurrencyId = project.selectedCurrency.id;
      }
      this.ProjectData.project.budgetPeriod = project.budgetPeriod;
      if (project.selectedBudget) {
        this.ProjectData.project.budgetId = project.selectedBudget.id;
      }
      this.ProjectData.project.budgetType = project.budgetType;
      this.ProjectData.project.selectedBudget = project.selectedBudget;
      this.ProjectData.project.selectedUpgrade = project.selectedUpgrade;

      if (project.upgrades) {
        this.ProjectData.project.upgrades = project.upgrades;
      }

      this.ProjectData.project.lastUpdate = project.lastUpdate;
    }
  }]);

  return ServerDraftStorage;
}();

ServerDraftStorage.$inject = ['$http', 'ProjectData', 'Auth'];

var ServerDraftStorageProvider = flService$1('ServerDraftStorage', [ProjectDataProvider, AuthModule], ServerDraftStorage);

var AutoSaveDraft = function () {
  function AutoSaveDraft($http, $rootScope, ProjectData, $timeout, Auth, LocalDraftStorage, ServerDraftStorage, currency$$1, prefill$$1) {
    var _this = this;

    _classCallCheck(this, AutoSaveDraft);

    this.$http = $http;
    this.ProjectData = ProjectData;
    this.$timeout = $timeout;
    this.Auth = Auth;
    this.userId = this.Auth.getUserId();
    this.$rootScope = $rootScope;
    this.pristine = true;
    this.storage = this.selectStorage(Auth, LocalDraftStorage, ServerDraftStorage);
    this.hasDraft = false;
    this.defaultCurrency = currency$$1;
    this.loadPromise = this.storage.load();
    if (prefill$$1.length === 0) {
      this.loadPromise.then(function (draft) {
        if (_this.isOld(draft)) {
          return;
        }
        _this.hasDraft = true;
        _this.storage.setProjectData(draft);
        if (_this.storage.hasSkills(draft)) {
          _this.ProjectData.project.skillsDefinedByUser = true;
        }
        _this.$rootScope.$broadcast('draftLoaded');
      }).catch(function () {
        // There is no draft project from the storage.
        _this.$rootScope.$broadcast('noDraftLoaded');
      });
    }
  }

  _createClass(AutoSaveDraft, [{
    key: 'isOld',
    value: function isOld(draft) {
      return draft.lastUpdate < moment().subtract(90, 'days').toDate();
    }
  }, {
    key: 'selectStorage',
    value: function selectStorage(Auth, LocalDraftStorage, ServerDraftStorage) {
      return Auth.getUserId() ? ServerDraftStorage : LocalDraftStorage;
    }

    // when click discard draft in PJP, also wipe all the fields
    // when click submit button, clear the draft but keep the form

  }, {
    key: 'clear',
    value: function clear() {
      var keepForm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!keepForm) {
        this.ProjectData.project.project_name = '';
        this.ProjectData.project.description = '';
        delete this.ProjectData.project.prefillCurrencyId;
        delete this.ProjectData.project.budgetType;
        delete this.ProjectData.project.budgetId;
        delete this.ProjectData.project.selectedBudget;
        this.ProjectData.project.currency = this.defaultCurrency;
        this.ProjectData.clearSkills();
      }
      this.storage.clear();
      if (!keepForm) {
        this.$rootScope.$broadcast('clearDraft');
      }
      this.hasDraft = false;
    }
  }, {
    key: 'createDoNothingStorage',
    value: function createDoNothingStorage() {
      return {
        save: function save() {},
        load: function load() {
          return Promise.reject();
        }
      };
    }
  }, {
    key: 'prefillFromDraft',
    value: function prefillFromDraft(storage) {
      storage.load();
    }
  }, {
    key: 'trigger',
    value: function trigger() {
      var _this2 = this;

      this.cancelPendingAutosave();
      this.currentExecution = this.$timeout(function () {
        if (!_this2.ProjectData.project.project_name || !_this2.ProjectData.project.description || _this2.ProjectData.project.description.length < 30) {
          return;
        }
        _this2.save();
      }, 3000);
    }
  }, {
    key: 'save',
    value: function save() {
      return this.storage.save();
    }
  }, {
    key: 'cancelPendingAutosave',
    value: function cancelPendingAutosave() {
      if (this.currentExecution) {
        this.$timeout.cancel(this.currentExecution);
      }
    }
  }]);

  return AutoSaveDraft;
}();

AutoSaveDraft.$inject = ['$http', '$rootScope', 'ProjectData', '$timeout', 'Auth', 'LocalDraftStorage', 'ServerDraftStorage', 'currency', 'prefill'];

var AutoSaveDraftServiceProvider = flService$1('AutoSaveDraftService', [AuthModule, currency, LocalDraftStorageProvider, prefill, ProjectDataProvider, ServerDraftStorageProvider], AutoSaveDraft);

var AutoSaveDraft$1 = function () {
  function AutoSaveDraft(AutoSaveDraftService, ProjectData) {
    _classCallCheck(this, AutoSaveDraft);

    this.AutoSaveDraftService = AutoSaveDraftService;
    this.ProjectData = ProjectData;
  }

  _createClass(AutoSaveDraft, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      scope.$watchCollection(function () {
        return ngModel.$modelValue;
      }, function () {
        if (!ngModel.$pristine && !_this.ProjectData.contestMode) {
          _this.AutoSaveDraftService.trigger();
        }
      });
    }
  }]);

  return AutoSaveDraft;
}();

AutoSaveDraft$1.$inject = ['AutoSaveDraftService', 'ProjectData'];

var flAutoSaveDraft = flDirective$1(AutoSaveDraft$1, {
  selector: '[fl-autosave-draft]',
  require: 'ngModel',
  providers: [ProjectDataProvider]
});

var template$1 = "<div class=\"PagePostProject-draftBanner alert alert-success\">\n  <div class=\"PagePostProject-draftBanner-message\">\n      We've automatically loaded a project you were working on <span am-time-ago=\"DraftBanner.getDateFromLastEdited()\"></span>. You can continue working on it below. Pressing discard will clear the form and remove the draft forever.\n  </div>\n  <div class=\"PagePostProject-draftBanner-cta\">\n      <button class=\"btn pseudo-class-hover\"  ng-click=\"DraftBanner.clear()\">Discard</button>\n  </div>\n</div>\n";

var flDraftBanner = function () {
  function flDraftBanner(ProjectData, AutoSaveDraftService) {
    _classCallCheck(this, flDraftBanner);

    this.ProjectData = ProjectData;
    this.AutoSaveDraftService = AutoSaveDraftService;
  }

  _createClass(flDraftBanner, [{
    key: 'getDateFromLastEdited',
    value: function getDateFromLastEdited() {
      return this.ProjectData.project.lastUpdate;
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.AutoSaveDraftService.clear();
    }
  }]);

  return flDraftBanner;
}();

flDraftBanner.$inject = ['ProjectData', 'AutoSaveDraftService'];

var flDraftBanner$1 = flComponent$1(flDraftBanner, {
  selector: 'fl-draft-banner',
  template: template$1,
  providers: [ProjectDataProvider, AutoSaveDraftServiceProvider, angularMoment.name]
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$2.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto$2[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$3.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax$1(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$4.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$5.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$5.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$2.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$6.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$3.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$7;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$9.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$4.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$10.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template$2(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template$2(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template$2(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

/**
 * @ngdoc service
 * @name flApi.Currencies
 *
 * @description
 * A factory that returns an object that exposes methods to easily interact
 * with the `currencies` API
 */

var Currencies = function () {
  function Currencies(flResource, ApiInterceptor, API_BASE_URL) {
    _classCallCheck(this, Currencies);

    this.ApiInterceptor = ApiInterceptor;
    this.API_BASE_URL = API_BASE_URL;
    this.resource = flResource(API_BASE_URL + '/projects/0.1/currencies/', ApiInterceptor, null, { get: { cache: true } });
  }

  /**
   * @ngdoc method
   * @name flApi.Currencies#currencyFactory
   * @methodOf flApi.Currencies
   *
   * @description
   * A factory that generates Currency objects
   *
   * @param {Object} c An object containing a raw currency information
   * @returns {Object} The returned Currency object exposes 1 methods:
   *
   * - get() returns the raw currency information
   */


  _createClass(Currencies, [{
    key: 'currencyFactory',
    value: function currencyFactory(c) {
      var currency$$1 = c;

      return {
        get: function get() {
          return currency$$1;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.Currencies#get
     * @methodOf flApi.Currencies
     *
     * @description
     * Return a list of all currencies, or a subset if currencies specified.
     *
     * @param {Object} params An object containing a list of currencies.
     * Available options for params are:
     *
     * currency_codes[]: codes of the currencies
     * currency_ids[]: ids of the currencies
     * @returns {Object} An object generated by currencyListFactory
     */

  }, {
    key: 'get',
    value: function get(params) {
      var _this = this;

      return this.resource.get(params).$promise.then(function (data) {
        return _this.currencyListFactory(data.currencies);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Currencies#currencyListFactory
     * @methodOf flApi.Currencies
     *
     * @description
     * A factory that generates CurrencyList objects
     *
     * @param {Object} c An object containing a list of currencies
     * @returns {Object} The returned CurrencyList object exposes 3 methods:
     *
     * - getMap() returns the raw list of Currencies
     * - getById(id) returns a currency object, given a currencyId
     * - get(params) returns a currency object, given a list of parameters
     */

  }, {
    key: 'currencyListFactory',
    value: function currencyListFactory(c) {
      var _this2 = this;

      var currencies = c;

      return {
        getMap: function getMap() {
          return currencies;
        },
        getList: function getList() {
          return Array.from(Object.keys(currencies).map(function (key) {
            return currencies[key];
          }));
        },
        getById: function getById(id) {
          var currency$$1 = Object.keys(currencies).map(function (key) {
            return currencies[key];
          }).find(function (cu) {
            return cu.id === id;
          });
          if (currency$$1) {
            return _this2.currencyFactory(currency$$1);
          }
          return undefined;
        },
        get: function get(params) {
          if (Object.keys(params).length === 1) {
            var _ret = function () {
              var key = Object.keys(params)[0];

              var currency$$1 = Object.keys(currencies).map(function (k) {
                return currencies[k];
              }).find(function (cu) {
                return cu[key] === params[key];
              });
              if (currency$$1) {
                return {
                  v: _this2.currencyFactory(currency$$1)
                };
              }
            }();

            if (typeof _ret === "object") return _ret.v;
          }
          return undefined;
        }
      };
    }
  }]);

  return Currencies;
}();

Currencies.$inject = ['flResource', 'ApiInterceptor', 'API_BASE_URL'];


var CurrenciesProvider = flService('Currencies', [flResourceProvider, ApiInterceptorProvider, OPAQUE_MODULE_NAME], Currencies);

/**
 * @ngdoc service
 * @name flCdn.Cdn
 *
 * @description
 * A service to interact with Freelancer Content Delivery Network  ("f-cdn")
 */

var crcTable = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

// Compute the CRC32 of a string
var crc32 = function crc32(str) {
  var crc = 0 ^ -1;

  for (var i = 0; i < str.length; i++) {
    crc = crc >>> 8 ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xFF];
  }

  return (crc ^ -1) >>> 0;
};

var Cdn = function () {
  function Cdn(GAF_BASE_URL, GAF_CDN_URLS) {
    _classCallCheck(this, Cdn);

    this.GAF_BASE_URL = GAF_BASE_URL;
    this.GAF_CDN_URLS = GAF_CDN_URLS;
  }
  /**
  * @ngdoc method
  * @name flCdn.Cdn#getCdnUrl
  * @methodOf flCdn.Cdn
  *
  * @description
  * Tries to retrieve a CDN URL for a given URL, and falls back to
  * GAF_BASE_URL if it fails.
  *
  * @param {String} url The URL we want to convert to a CDN URL.
  * @returns {String} A CDN URL in case a CDN is available, otherwise it
  * returns a regular url.
  */


  _createClass(Cdn, [{
    key: 'getCdnUrl',
    value: function getCdnUrl(url) {
      if (this.GAF_CDN_URLS.length > 0) {
        var host = this.GAF_CDN_URLS[Math.abs(crc32(url)) % this.GAF_CDN_URLS.length];
        return host + url;
      }
      return this.GAF_BASE_URL + url;
    }
  }]);

  return Cdn;
}();

Cdn.$inject = ['GAF_BASE_URL', 'GAF_CDN_URLS'];


var CdnProvider = flService('Cdn', [OPAQUE_MODULE_NAME], Cdn);

/**
 * @ngdoc service
 * @name flApi.ProjectFees
 *
 * @description
 * A factory that returns a fee object that exposes methods to easily interact
 * with the project fees API
 */

var ProjectFees = function () {
  function ProjectFees(flResource, ApiInterceptor, API_BASE_URL) {
    _classCallCheck(this, ProjectFees);

    this.resource = flResource(API_BASE_URL + '/projects/0.1/projects/fees/', ApiInterceptor);
  }

  /**
   * @ngdoc method
   * @name flApi.ProjectFees#projectFeeFactory
   * @methodOf flApi.ProjectFees
   *
   * @description
   * A factory that generates Project Fee objects
   *
   * @param {Object} f An object containing raw project fee information
   * @returns {Object} The returned fee object exposes 1 method:
   *
   * - get() returns the raw project fee information
   */


  _createClass(ProjectFees, [{
    key: 'projectFeeFactory',
    value: function projectFeeFactory(f) {
      var fee = f;

      return {
        get: function get() {
          return fee;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.ProjectFees#get
     * @methodOf flApi.ProjectFees
     *
     * @description
     * Retrieves the project upgrade fees for the currently logged in user and
     * indicates whether the user is entitled to free upgrades depending on
     * their membership status.
     *
     * @param {Number} currencyId The id of the currency we want the fees in
     * @param {Boolean} freeUpgradeDetails Include whether a user is entitled
     * to a free upgrade or not
     * @param {Number} projectId Get fee information specific to a project
     * @returns {Object} An object generated by projectFeeFactory
     */

  }, {
    key: 'get',
    value: function get(currencyId, freeUpgradeDetails, projectId) {
      var _this = this;

      var params = {
        'currencies[]': currencyId || 1
      };

      if (angular$1.isDefined(projectId)) {
        params.project = projectId;
      }

      if (angular$1.isDefined(freeUpgradeDetails)) {
        params.free_upgrade_details = freeUpgradeDetails;
      }

      return this.resource.get(params).$promise.then(function (data) {
        return _this.projectFeeFactory(data.project_upgrade_fees[0]);
      });
    }
  }]);

  return ProjectFees;
}();

ProjectFees.$inject = ['flResource', 'ApiInterceptor', 'API_BASE_URL'];


var ProjectFeesProvider = flService('ProjectFees', [flResourceProvider, ApiInterceptorProvider, OPAQUE_MODULE_NAME], ProjectFees);

var UpgradesService = function () {
  function UpgradesService(ProjectFees, freeUpgrades$$1, ProjectData) {
    _classCallCheck(this, UpgradesService);

    this.ProjectFees = ProjectFees;
    this.projectData = ProjectData.project;
    this.freeUpgrades = freeUpgrades$$1;
    this.freeRecruiter = this.freeUpgrades.includes('recruiter');
    this.freeNDA = this.freeUpgrades.includes('nda');
    this.freeFeatured = this.freeUpgrades.includes('featured');
    this.freeUrgent = this.freeUpgrades.includes('urgent');
    this.freePrivate = this.freeUpgrades.includes('private');
    this.totalCost = 0;
    delete this.projectData.advancedUpgrades;
    this.getUpgradeFees();
    this.projectData.selectedUpgrade = null;
    this.previouslySelected = null;
  }

  _createClass(UpgradesService, [{
    key: 'addRecruiter',
    value: function addRecruiter() {
      this.previouslySelected = this.projectData.selectedUpgrade;
      this.projectData.selectedUpgrade = 'recruiter';
      this.getUpgradeFees();
    }
  }, {
    key: 'addUpgrade',
    value: function addUpgrade(upgradeName) {
      if (upgradeName in this.projectData.upgrades) {
        if ('checked' in this.projectData.upgrades[upgradeName]) {
          this.projectData.upgrades[upgradeName].checked = true;
          this.previouslySelected = this.projectData.selectedUpgrade;
          this.projectData.selectedUpgrade = 'advanced';
        }
      }
    }
  }, {
    key: 'getUpgradeFees',
    value: function getUpgradeFees() {
      var _this = this;

      var currency$$1 = this.projectData.selectedCurrency ? this.projectData.selectedCurrency : this.projectData.currency;
      return this.ProjectFees.get(currency$$1 ? currency$$1.id : 1).then(function (result) {
        var prices = result.get();

        _this.projectData.upgrades.recruiter.price = prices.assisted_price;
        _this.fullRecruiterPrice = prices.assisted_price * 2;
        _this.projectData.upgrades.nda.price = prices.nda_price;
        _this.projectData.upgrades.featured.price = prices.featured_price;
        _this.projectData.upgrades.urgent.price = prices.urgent_price;
        _this.projectData.upgrades.private.price = prices.nonpublic_price;
        if (_this.projectData.upgrades.hasOwnProperty('project_management_bundle')) {
          _this.projectData.upgrades.project_management_bundle.hourlyPrice = prices.project_management_price;
          _this.projectData.upgrades.project_management_bundle.price = prices.project_management_bundle_price;
          _this.fullProjectManagementBundlePrice = prices.project_management_bundle_price + prices.project_management_price / 2;
        }
        _this.sign = prices.currency.sign;
        _this.isTaxIncluded = prices.is_tax_included;
        _this.taxType = prices.tax_type ? prices.tax_type.toLowerCase() : null;

        if (_this.projectData.selectedUpgrade === 'advanced') {
          _this.computeAdvanced();
        } else {
          _this.recompute();
        }
      });
    }
  }, {
    key: 'changeUpgradeSelection',
    value: function changeUpgradeSelection() {
      this.clear();
      if (this.projectData.selectedUpgrade === 'advanced') {
        this.projectData.upgrades.recruiter.checked = this.previouslySelected === 'recruiter';
        // Track clicks for Show Advanced Options
        this.trackSelection(this.projectData.selectedUpgrade);
        this.computeAdvanced();
      } else {
        this.recompute();
      }
    }
  }, {
    key: 'recompute',
    value: function recompute() {
      this.totalCost = this.projectData.upgrades[this.projectData.selectedUpgrade] && !this.isFree(this.projectData.selectedUpgrade) ? this.projectData.upgrades[this.projectData.selectedUpgrade].price : 0;
      this.trackSelection(this.projectData.selectedUpgrade);
      this.previouslySelected = this.projectData.selectedUpgrade;
      this.getSelectedAdvancedUpgrades();
    }
  }, {
    key: 'trackSelection',
    value: function trackSelection(upgradeName) {
      qtsp.push({
        section: 'ProjectUpgrade',
        subsection: 'PPP',
        action: 'click',
        label: 'select',
        name: 'Upgrade Type',
        value: upgradeName
      });
      qtsp.push({
        section: 'ProjectUpgrade',
        subsection: 'PPP',
        action: 'click',
        label: 'deselect',
        name: 'Upgrade Type',
        value: this.previouslySelected
      });
    }
  }, {
    key: 'isFree',
    value: function isFree(upgrade) {
      return this.freeUpgrades.includes(upgrade);
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this2 = this;

      Object.keys(this.projectData.upgrades).forEach(function (key) {
        _this2.projectData.upgrades[key].checked = false;
      });
      this.totalCost = 0;
    }
  }, {
    key: 'computeAdvanced',
    value: function computeAdvanced() {
      var _this3 = this;

      var selectedName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.getSelectedAdvancedUpgrades();
      this.totalCost = Object.keys(this.projectData.upgrades).filter(function (upgradeName) {
        return _this3.projectData.upgrades[upgradeName].checked;
      }).reduce(function (carry, upgradeName) {
        return _this3.isFree(upgradeName) ? carry : carry + _this3.projectData.upgrades[upgradeName].price;
      }, 0);
      if (selectedName) {
        this.trackAdvancedSelection(selectedName);
      }
    }
  }, {
    key: 'getSelectedUpgrades',
    value: function getSelectedUpgrades() {
      var _this4 = this;

      if (this.projectData.selectedUpgrade === 'advanced') {
        return Object.keys(this.projectData.upgrades).filter(function (upgradeName) {
          return _this4.projectData.upgrades[upgradeName].checked;
        }).map(function (upgradeName) {
          return {
            name: upgradeName,
            price: _this4.projectData.upgrades[upgradeName].price
          };
        });
      }
      return [{
        name: this.projectData.selectedUpgrade,
        price: this.projectData.upgrades[this.projectData.selectedUpgrade].price
      }];
    }
  }, {
    key: 'getSelectedAdvancedUpgrades',
    value: function getSelectedAdvancedUpgrades() {
      var _this5 = this;

      this.selectedAdvancedUpgrades = Object.keys(this.projectData.upgrades).filter(function (upgradeName) {
        return _this5.projectData.upgrades[upgradeName].checked;
      });
    }
  }, {
    key: 'trackAdvancedSelection',
    value: function trackAdvancedSelection(upgradeName) {
      qtsp.push({
        section: 'ProjectUpgrade',
        subsection: 'PPP',
        action: 'click',
        label: this.projectData.upgrades[upgradeName].checked ? 'select' : 'deselect',
        name: 'Upgrade Type',
        value: upgradeName
      });
    }
  }]);

  return UpgradesService;
}();

UpgradesService.$inject = ['ProjectFees', 'freeUpgrades', 'ProjectData'];

var UpgradesServiceProvider = flService$1('UpgradesService', [freeUpgrades, ProjectDataProvider, ProjectFeesProvider], UpgradesService);

var WizardService = function () {
  function WizardService($window, $timeout, $document, $rootScope, ProjectData) {
    var _this = this;

    _classCallCheck(this, WizardService);

    this.$window = $window;
    this.$timeout = $timeout;
    this.$document = $document[0];
    this.$rootScope = $rootScope;
    this.ProjectData = ProjectData;

    this.iframeMode = iframeMode;
    this.currentStep = 1;
    this.lastStep = 'description';
    this.contestLastStep = 'contest';
    this.projectLastStep = this.lastStep;
    this.enableNext = false;
    this.autoScrolling = false;
    this.selectedLocal = false;
    this.showNextButton = true;
    this.steps = {
      title: {
        visited: true,
        previousStep: 'title',
        container: 'project-title-field',
        getNextStep: function getNextStep() {
          return 'description';
        }
      },
      description: {
        visited: true,
        previousStep: 'title',
        getNextStep: function getNextStep() {
          return 'skills';
        },
        container: 'description-field'
      },
      skills: {
        visited: false,
        getNextStep: function getNextStep() {
          return 'contest';
        },
        container: 'skills-selector-field'
      },
      contest: {
        visited: false,
        getNextStep: function getNextStep() {
          return _this.getLocationStep() || _this.getBudgetStep();
        },
        container: 'contest-upsell',
        isButton: true
      },
      localQuestion: {
        visited: false,
        getNextStep: function getNextStep() {
          if (_this.selectedLocal === 'yes') {
            _this.resetToLocalStep();
            return 'locationField';
          }
          return _this.getBudgetStep();
        },
        container: 'local-question',
        isButton: true
      },
      locationField: {
        visited: false,
        getNextStep: function getNextStep() {
          return _this.getBudgetStep();
        },
        container: 'location-field'
      },
      contestBudgetSelector: {
        visited: false,
        getNextStep: function getNextStep() {
          return _this.ProjectData.urgentSkills.length === 0 ? 'contestDuration' : 'contestDurationType';
        },
        container: 'contest-budget-selector'
      },
      contestDuration: {
        visited: false,
        getNextStep: function getNextStep() {
          return 'contestUpgrades';
        },
        container: 'contest-duration-field'
      },
      contestDurationType: {
        visited: false,
        getNextStep: function getNextStep() {
          if (_this.ProjectData.project.durationType !== 'urgent') {
            _this.resetToContestDurationStep();
            return 'contestDuration';
          }
          return 'contestUpgrades';
        },
        container: 'contest-duration-type',
        isButton: true
      },
      budgetType: {
        visited: false,
        getNextStep: function getNextStep() {
          return 'estimatedBudget';
        },
        container: 'budget-type-field',
        isButton: true
      },
      estimatedBudget: {
        visited: false,
        getNextStep: function getNextStep() {
          return 'upgrades';
        },
        container: 'estimated-budget-field'
      },
      upgrades: {
        visited: false,
        getNextStep: function getNextStep() {
          return 'projectSubmit';
        },
        container: 'upgrades-field',
        isButton: true
      },
      contestUpgrades: {
        visited: false,
        getNextStep: function getNextStep() {
          return 'contestSubmit';
        },
        container: 'contest-upgrades-field',
        isButton: true
      },
      projectSubmit: {
        visited: false,
        container: 'project-submit-field'
      },
      contestSubmit: {
        visited: false,
        container: 'contest-submit-field'
      }
    };
    this.$rootScope.$on('skillSetChange', function () {
      _this.resetToSkillStep();
    });
    this.focusStep('title');

    if (pppABTest && pppABTest.T70947) {
      this.pppABTest = pppABTest;
      this.pppABTest.T70947.activatedForSession = false;
    }
  }

  _createClass(WizardService, [{
    key: 'getLocationStep',
    value: function getLocationStep() {
      if (this.ProjectData.localSkills.length > 0 && !this.ProjectData.contestMode) {
        if (this.ProjectData.project.areSkillsAllLocal) {
          return 'locationField';
        }
        return 'localQuestion';
      }
      return null;
    }
  }, {
    key: 'getBudgetStep',
    value: function getBudgetStep() {
      return this.ProjectData.contestMode ? 'contestBudgetSelector' : 'budgetType';
    }
  }, {
    key: 'scheduleScrollToCurrent',
    value: function scheduleScrollToCurrent() {
      var _this2 = this;

      this.autoScrolling = true;
      this.$timeout(function () {
        _this2.smoothScroll(_this2.steps[_this2.currentStep].container);
        _this2.setAutoScrollToFalse();
      }, 0);
    }
  }, {
    key: 'onChoiceSelect',
    value: function onChoiceSelect(step) {
      if (this.currentStep !== step) {
        this.focusStep(step);
      }
      this.goToNextStep();
    }
  }, {
    key: 'goToPreviousStep',
    value: function goToPreviousStep() {
      var previousStep = this.steps[this.currentStep].previousStep;
      this.focusStep(previousStep);
    }
  }, {
    key: 'goToNextStep',
    value: function goToNextStep(fromButton) {
      var lastStep = this.ProjectData.jobType === 'contest' ? this.contestLastStep : this.projectLastStep;
      var current = fromButton ? lastStep : this.currentStep;
      this.steps[current].completed = true;
      var nextStep = this.steps[current].getNextStep();
      this.steps[nextStep].previousStep = current;
      if (!this.steps[nextStep].visited) {
        this.lastStep = nextStep;
        if (this.ProjectData.jobType === 'contest') {
          this.contestLastStep = this.lastStep;
        } else {
          this.projectLastStep = this.lastStep;
        }
      }
      this.focusStep(nextStep);
    }
  }, {
    key: 'focusStep',
    value: function focusStep(step) {
      if (this.currentStep === step) {
        return;
      }
      this.goToStep(step);
    }
  }, {
    key: 'goToStep',
    value: function goToStep(newStep) {
      var _this3 = this;

      this.currentStep = newStep;

      if (this.currentStep === 'contestUpgrades' && this.pppABTest && this.pppABTest.T70947 && this.pppABTest.T70947.isEligible && !this.pppABTest.T70947.activatedForSession) {
        if (getUserIdfromCookie()) {
          ABTestApi.testSubjectActivate(this.pppABTest.T70947.name, this.pppABTest.T70947.variation);
        } else {
          ABTestApi.activateSessionBasedTestSubject(this.pppABTest.T70947.name, this.pppABTest.T70947.variation);
        }

        this.pppABTest.T70947.activatedForSession = true;
      }

      this.$timeout(function () {
        var previousStepField = _this3.getFocusableField(_this3.steps[newStep].previousStep);
        if (previousStepField) {
          previousStepField.blur();
        }

        var newStepField = _this3.getFocusableField(newStep);
        if (newStepField) {
          newStepField.focus();
        }
      }, 0);

      if (!this.steps[this.currentStep].visited) {
        this.scheduleScrollToCurrent();
      }
      this.steps[this.currentStep].visited = true;

      this.showNextButton = !this.ProjectData.contestMode && !this.steps.projectSubmit.visited && !this.steps[this.projectLastStep].isButton || this.ProjectData.contestMode && !this.steps.contestSubmit.visited && !this.steps[this.contestLastStep].isButton;
    }
  }, {
    key: 'toggleNextButton',
    value: function toggleNextButton(show) {
      this.showNextButton = show;
    }
  }, {
    key: 'getFocusableField',
    value: function getFocusableField(step) {
      var element = document.getElementById(this.steps[step].container);
      if (element) {
        return element.getElementsByClassName('focusable-field')[0];
      }
      return null;
    }
  }, {
    key: 'hasNext',
    value: function hasNext() {
      if (this.steps[this.currentStep].getNextStep) {
        return true;
      }
      return false;
    }
  }, {
    key: 'smoothScroll',
    value: function smoothScroll(elementId) {
      if (this.skipAutoScroll) {
        return;
      }

      var viewPortHalf = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) / 2;
      var startY = this.currentYPosition();
      var elemHalf = document.getElementById(elementId).clientHeight / 2;
      var stopY = void 0;
      if (this.iframeMode) {
        stopY = this.elmYPosition(elementId);
      } else {
        stopY = this.elmYPosition(elementId) - viewPortHalf + elemHalf;
      }

      var distance = Math.abs(stopY - startY);
      this.autoscrollDuration = 0;
      if (distance < 100) {
        this.$window.scrollTo(0, stopY);
        return;
      }
      var speed = Math.round(distance / 50);
      var step = Math.round(distance / 50);
      var leapY = startY;
      var timer = 0;

      if (stopY > startY) {
        for (var i = startY; i < stopY; i += step) {
          var delay = timer * speed;
          this.timeoutScroll(leapY, delay);
          leapY += step;
          this.autoscrollDuration = delay;
          if (leapY > stopY) leapY = stopY;
          timer++;
        }
        return;
      }
      for (var _i = startY; _i > stopY; _i -= step) {
        var _delay = timer * speed;
        this.timeoutScroll(leapY, _delay);
        leapY -= step;
        this.autoscrollDuration = _delay;
        if (leapY < stopY) leapY = stopY;
        timer++;
      }
      // this.$window.scrollTo(0, stopY);
    }
  }, {
    key: 'setAutoScrollToFalse',
    value: function setAutoScrollToFalse() {
      var _this4 = this;

      setTimeout(function () {
        _this4.autoScrolling = false;
      }, this.autoscrollDuration);
    }
  }, {
    key: 'timeoutScroll',
    value: function timeoutScroll(leapY, timeout) {
      var _this5 = this;

      if (this.iframeMode) {
        return;
      }
      setTimeout(function () {
        return _this5.$window.scrollTo(0, leapY);
      }, timeout);
    }
  }, {
    key: 'currentYPosition',
    value: function currentYPosition() {
      // Firefox, Chrome, Opera, Safari
      if (this.$window.pageYOffset) {
        return this.$window.pageYOffset;
      }
      // Internet Explorer 6 - standards mode
      if (this.$document.documentElement && this.$document.documentElement.scrollTop) return this.$document.documentElement.scrollTop;
      // Internet Explorer 6, 7 and 8
      if (this.$document.body.scrollTop) {
        return this.$document.body.scrollTop;
      }
      return 0;
    }
  }, {
    key: 'validate',
    value: function validate() {
      var _this6 = this;

      var invalidStep = Object.keys(this.steps).filter(function (step) {
        if (document.getElementById(_this6.steps[step].container)) {
          return true;
        }
        return false;
      }).find(function (step) {
        return _this6.steps[step].validateSubmit && !_this6.steps[step].validateSubmit();
      });

      if (invalidStep) {
        this.focusStep(invalidStep);
        return false;
      }
      return true;
    }
  }, {
    key: 'validateStep',
    value: function validateStep(step) {
      if (step === 'title' || step === 'description') {
        return this.steps.title.validateSubmit && this.steps.description.validateSubmit && this.steps.title.validateSubmit() && this.steps.description.validateSubmit();
      }
      if (step === 'contest') {
        return typeof this.ProjectData.jobType !== 'undefined';
      }
      return this.steps[step].validate && this.steps[step].validate();
    }
  }, {
    key: 'elmYPosition',
    value: function elmYPosition(elementId) {
      var elm = this.$document.getElementById(elementId);
      var y = elm.offsetTop;
      var node = elm;
      while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      }
      return y;
    }

    // When user change its skill set, that is contest, urgent or local skill is added,
    // Hide visible fields below skills field

  }, {
    key: 'resetToSkillStep',
    value: function resetToSkillStep() {
      var _this7 = this;

      if (this.lastStep != 'title' && this.lastStep != 'description' && this.lastStep != 'skills') {
        Object.keys(this.steps).forEach(function (stepName) {
          if (stepName != 'title' && stepName != 'description' && stepName != 'skills') {
            _this7.steps[stepName].visited = false;
          }
        });
        this.projectLastStep = 'skills';
        this.contestLastStep = 'skills';
        this.currentStep = 'skills';
        this.showNextButton = true;
      }
    }

    // When user selects local job by clicking Yes in local question,
    // Hide fields below location field

  }, {
    key: 'resetToLocalStep',
    value: function resetToLocalStep() {
      this.steps.budgetType.visited = false;
      this.steps.estimatedBudget.visited = false;
      this.steps.upgrades.visited = false;
      this.steps.projectSubmit.visited = false;

      this.projectLastStep = 'locationField';
      this.showNextButton = true;
    }
  }, {
    key: 'resetToContestDurationStep',
    value: function resetToContestDurationStep() {
      this.steps.contestUpgrades.visited = false;
      this.steps.contestSubmit.visited = false;

      this.contestLastStep = 'contestDuration';
      this.showNextButton = true;
    }
  }]);

  return WizardService;
}();

WizardService.$inject = ['$window', '$timeout', '$document', '$rootScope', 'ProjectData'];

var WizardServiceProvider = flService$1('WizardService', [ProjectDataProvider], WizardService);

/**
 * @ngdoc service
 * @name BudgetService
 * @description
 * A service to handle "fake API calls". It essentially
 * gets the vars from php backend
 * while we wait for a real API to be implemented.
 */

var BudgetService = function () {
  function BudgetService($http) {
    _classCallCheck(this, BudgetService);

    this.$http = $http;
  }

  _createClass(BudgetService, [{
    key: 'listBy',
    value: function listBy(currency$$1, type) {
      var params = {
        currency: currency$$1,
        budgetPeriod: type
      };
      return this.$http.get('/buyers/on-budget-control.php', { params: params }).then(function (response) {
        return response.data;
      }).then(function (data) {
        return data.vars;
      }).then(function (vars) {
        return vars.budgets;
      }).catch(function (e) {
        qtsp.push({
          section: 'MigratedPPP',
          subsection: 'ProjectDescription',
          name: 'SkillPredictor',
          action: 'error',
          value: JSON.stringify(e)
        });
      });
    }
  }]);

  return BudgetService;
}();

BudgetService.$inject = ['$http'];

var BudgetServiceProvider = flService$1('BudgetService', [], BudgetService);

/**
 * @ngdoc directive
 * @name flCustomBudgetCheck
 * @restrict A
 * @description
 * Validates the custom budget values (either min or max)
 */

var CustomBudgetCheck = function () {
  function CustomBudgetCheck() {
    _classCallCheck(this, CustomBudgetCheck);
  }

  _createClass(CustomBudgetCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      ngModel.$validators.positiveValue = function (value) {
        return value > 0;
      };
      ngModel.$validators.wholeInteger = function (value) {
        return parseInt(value, 10) == value;
      };
    }
  }]);

  return CustomBudgetCheck;
}();

var flCustomBudgetCheck = flDirective$1(CustomBudgetCheck, {
  selector: '[fl-custom-budget-check]',
  require: 'ngModel',
  providers: []
});

/**
 * @ngdoc directive
 * @name flCustomMinimumBudgetCheck
 * @restrict A
 * @description
 * Validates if custom minimum budget is greater than zero and less than maximum
 */

var CustomMinimumBudgetCheck = function () {
  function CustomMinimumBudgetCheck(ProjectData) {
    _classCallCheck(this, CustomMinimumBudgetCheck);

    this.projectData = ProjectData.project;
  }

  _createClass(CustomMinimumBudgetCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      attr.$observe('flCustomMinimumBudgetCheck', function () {
        return ngModel.$validate();
      });

      ngModel.$validators.lessThanMax = function (minBudget) {
        var maxBudget = attr.flCustomMinimumBudgetCheck;
        if (minBudget && maxBudget) {
          return minBudget <= maxBudget;
        }
        return true;
      };
      ngModel.$validators.lessThanCurrencyMin = function (minBudget) {
        return minBudget ? minBudget >= _this.projectData.minimumCustomValue : true;
      };
    }
  }]);

  return CustomMinimumBudgetCheck;
}();

CustomMinimumBudgetCheck.$inject = ['ProjectData'];

var flCustomMinimumBudgetCheck = flDirective$1(CustomMinimumBudgetCheck, {
  selector: '[fl-custom-minimum-budget-check]',
  require: 'ngModel',
  providers: [ProjectDataProvider]
});

/**
 * @ngdoc directive
 * @name flCustomMaximumBudgetCheck
 * @restrict A
 * @description
 * Validates if custom maximum budget is greater than zero and greater than minimum
 */

var CustomMaximumBudgetCheck = function () {
  function CustomMaximumBudgetCheck() {
    _classCallCheck(this, CustomMaximumBudgetCheck);
  }

  _createClass(CustomMaximumBudgetCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      attr.$observe('flCustomMaximumBudgetCheck', function () {
        return ngModel.$validate();
      });

      ngModel.$validators.greaterThanMin = function (maxBudget) {
        var minBudget = attr.flCustomMaximumBudgetCheck;
        if (maxBudget && minBudget) {
          return minBudget <= maxBudget;
        }
        return true;
      };
    }
  }]);

  return CustomMaximumBudgetCheck;
}();

var flCustomMaximumBudgetCheck = flDirective$1(CustomMaximumBudgetCheck, {
  selector: '[fl-custom-maximum-budget-check]',
  require: 'ngModel',
  providers: []
});

var template$3 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <span ng-if=\"BudgetSelector.budgetField === 'budgetType'\">\n            <legend class=\"PagePostProject-legend\">How do you want to pay?</legend>\n            <nav class=\"PagePostProject-budgetTabs\">\n                <ul class=\"PagePostProject-budgetTabs-cards\" data-qtsb-section=\"PPP_Form_Behaviour\">\n                    <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\" data-qtsb-label=\"click_Fixed_Project\">\n                    <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        data-tab=\"fixed-budget\"\n                        id=\"budget-fixed\"\n                        name=\"budget-type\"\n                        ng-model=\"BudgetSelector.projectData.budgetType\"\n                        value=\"fixed\"\n                        ng-click=\"BudgetSelector.WizardService.onChoiceSelect('budgetType')\"\n                        fl-toggle-wizard-next=\"budgetType\"\n                        fl-autosave-draft\n                        checked=\"\">\n                    <label for=\"budget-fixed\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" ng-src=\"{[{BudgetSelector.fixedImage}]}\" alt=\"Fixed price project\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Pay fixed price\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Agree on a price and release payment when the job is done.<br>\n                                Best for one-off tasks.\n                            </div>\n                        </div>\n                    </label>\n                    </li>\n                    <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\" data-qtsb-label=\"click_Hourly_Project\">\n                        <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        data-tab=\"hourly-budget\"\n                        id=\"budget-hourly\"\n                        name=\"budget-type\"\n                        ng-model=\"BudgetSelector.projectData.budgetType\"\n                        value=\"hourly\"\n                        ng-click=\"BudgetSelector.WizardService.onChoiceSelect('budgetType')\"\n                        fl-toggle-wizard-next=\"budgetType\"\n                        fl-autosave-draft\n                        checked=\"\">\n                        <label for=\"budget-hourly\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" ng-src=\"{[{BudgetSelector.hourlyImage}]}\" alt=\"Hourly price project\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Pay by the hour\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Hire based on an hourly rate and pay for hours billed.<br>\n                                Best for ongoing work.\n                            </div>\n                        </div>\n                        </label>\n                    </li>\n                </ul>\n            </nav>\n        </span>\n\n        <span ng-if=\"BudgetSelector.budgetField === 'estimatedBudget'\">\n            <legend class=\"PagePostProject-legend\">What is your estimated budget?</legend>\n            <div ng-if=\"BudgetSelector.unsupportedCurrency\" class=\"alert alert-info\">\n                As of June 2018, we no longer offer {{BudgetSelector.unsupportedCurrency}} for new projects. You may still deposit in {{BudgetSelector.unsupportedCurrency}}, but projects must be posted with a currency from the list below.\n            </div>\n            <ol class=\"PagePostProject-budgetFields\" id=\"fixed-budget\">\n                <li class=\"form-step form-step--multiFields\">\n                    <div class=\"form-step-fieldContainer\">\n                        <label for=\"project-currency\" class=\"is-accessibly-hidden\">Currency</label>\n                        <select id=\"project-currency\" name=\"currency\"\n                            class=\"large-input focusable-field PagePostProject--selectIE\"\n                            ng-model=\"BudgetSelector.projectData.selectedCurrency\"\n                            ng-change=\"BudgetSelector.onCurrencyChange()\"\n                            ng-options=\"currency as currency.code for currency in BudgetSelector.currencyData track by currency.id\"\n                            fl-focus-in-tracker=\"Project_Currency\"\n                            fl-focus-out-tracker=\"Project_Currency\"\n                            fl-toggle-wizard-next=\"estimatedBudget\"\n                            fl-autosave-draft>\n                        </select>\n                    </div>\n                    <div class=\"form-step-fieldContainer\">\n                        <label for=\"project-budget\" class=\"is-accessibly-hidden\">Budget Range</label>\n                        <select id=\"project-budget\" name='budget'\n                            class=\"large-input focusable-field PagePostProject--selectIE\"\n                            ng-model=\"BudgetSelector.projectData.selectedBudget\"\n                            ng-options=\"budget as budget.displayName for budget in BudgetSelector.budgetData track by budget.id\"\n                            ng-change=\"BudgetSelector.onBudgetChange()\"\n                            fl-focus-in-tracker=\"Project_Budget\"\n                            fl-focus-out-tracker=\"Project_Budget\"\n                            fl-toggle-wizard-next=\"estimatedBudget\"\n                            fl-autosave-draft\n                            >\n                            <option value='custom'>Customize budget</option>\n                        </select>\n                    </div>\n                </li>\n                <!-- Custom Budget -->\n                <li class=\"form-step PagePostProject-customBudget project-custom-budget-fields\"\n                    ng-if=\"BudgetSelector.toggleCustomBudgetFields\"\n                    ng-class=\"{\n                        'is-invalid': (BudgetSelector.form.min_sum.$error.required &&\n                            BudgetSelector.form.min_sum.$dirty),\n                        'is-warning': (BudgetSelector.form.min_sum.$invalid &&\n                            !BudgetSelector.form.min_sum.$error.required &&\n                            BudgetSelector.form.min_sum.$dirty)\n                    }\">\n                    <label for=\"project-custom-min-budget\" class=\"PagePostProject-stepLabel\">Minimum Budget</label>\n                    <div class=\"input-group\">\n                        <span class=\"add-on currency-sign\">{[{BudgetSelector.projectData.selectedCurrency.sign}]}</span>\n                        <input id=\"project-custom-min-budget\" type=\"number\" name=\"min_sum\" class=\"large-input\"\n                            ng-model=\"BudgetSelector.projectData.customMinBudget\"\n                            ng-required=\"BudgetSelector.projectData.selectedBudget.id === 'custom'\"\n                            fl-custom-budget-check\n                            fl-custom-minimum-budget-check=\"{{BudgetSelector.projectData.customMaxBudget}}\"\n                            fl-toggle-wizard-next=\"estimatedBudget\"\n                            fl-autosave-draft>\n                        <span ng-if=\"BudgetSelector.projectData.budgetType === 'hourly'\" class=\"add-on\">per hour</span>\n                    </div>\n                    <div ng-messages=\"BudgetSelector.form.min_sum.$error\">\n                        <div class=\"form-error\" ng-message=\"required\">Please enter a minimum budget.</div>\n                        <div class=\"form-error\" ng-message=\"lessThanMax\">The minimum budget should be less than or equal the maximum.</div>\n                        <div class=\"form-error\" ng-message=\"positiveValue\">The minimum budget should be greater than zero (0).</div>\n                        <div class=\"form-error\" ng-message=\"lessThanCurrencyMin\">The minimum budget should be greater than {{BudgetSelector.projectData.minimumCustomValue}}.</div>\n                        <div class=\"form-error\" ng-message=\"wholeInteger\">Please enter a whole number of {{BudgetSelector.projectData.selectedCurrency.code}}.</div>\n                    </div>\n                </li>\n                <li class=\"form-step PagePostProject-customBudget project-custom-budget-fields\"\n                    ng-if=\"BudgetSelector.toggleCustomBudgetFields\"\n                    ng-class=\"{\n                        'is-invalid': (BudgetSelector.form.max_sum.$error.required &&\n                            BudgetSelector.form.max_sum.$dirty),\n                        'is-warning': (BudgetSelector.form.max_sum.$invalid &&\n                            !BudgetSelector.form.max_sum.$error.required &&\n                            BudgetSelector.form.max_sum.$dirty)\n                    }\">\n                    <label for=\"project-custom-max-budget\" class=\"PagePostProject-stepLabel\">Maximum Budget</label>\n                    <div class=\"input-group\">\n                        <span class=\"add-on currency-sign\">{[{BudgetSelector.projectData.selectedCurrency.sign}]}</span>\n                        <input id=\"project-custom-max-budget\" type=\"number\" name=\"max_sum\" class=\"large-input\"\n                            ng-model=\"BudgetSelector.projectData.customMaxBudget\"\n                            ng-required=\"BudgetSelector.projectData.selectedBudget.id === 'custom'\"\n                            fl-custom-budget-check\n                            fl-custom-maximum-budget-check=\"{{BudgetSelector.projectData.customMinBudget}}\"\n                            fl-toggle-wizard-next=\"estimatedBudget\"\n                            fl-autosave-draft>\n                        <span ng-if=\"BudgetSelector.projectData.budgetType === 'hourly'\" class=\"add-on\">per hour</span>\n                    </div>\n                    <div ng-messages=\"BudgetSelector.form.max_sum.$error\">\n                        <div class=\"form-error\" ng-message=\"required\">Please enter a maximum budget.</div>\n                        <div class=\"form-error\" ng-message=\"greaterThanMin\">The maximum budget should be greater than or equal the minimum.</div>\n                        <div class=\"form-error\" ng-message=\"positiveValue\">The maximum budget should be greater than zero (0).</div>\n                        <div class=\"form-error\" ng-message=\"wholeInteger\">Please enter a whole number of {{BudgetSelector.projectData.selectedCurrency.code}}.</div>\n                    </div>\n                </li>\n            </ol>\n        </span>\n    </fieldset>\n</div>\n\n";

var flBudgetSelector = function () {
  function flBudgetSelector(ProjectData, BudgetService, Currencies, UpgradesService, WizardService, $scope, $timeout, Cdn, unsupportedCurrency$$1, escrowCurrencies$$1) {
    var _this = this;

    _classCallCheck(this, flBudgetSelector);

    this.unsupportedCurrency = unsupportedCurrency$$1;
    this.escrowCurrencies = escrowCurrencies$$1;
    this.DEFAULT_BUDGET_INDEX = 2;
    this.projectData = ProjectData.project;
    this.previousCurrency = this.previousCurrency ? this.previousCurrency : this.projectData.currency;
    this.BudgetService = BudgetService;
    this.UpgradesService = UpgradesService;
    this.WizardService = WizardService;
    this.Currencies = Currencies;
    this.toggleCustomBudgetFields = false;
    this.$timeout = $timeout;
    this.fixedImage = Cdn.getCdnUrl('/static/img/fixed-price-project.svg');
    this.hourlyImage = Cdn.getCdnUrl('/static/img/hourly-price-project.svg');

    this.initialiseBudgetOptions();

    $scope.$on('clearDraft', function () {
      _this.initialiseBudgetOptions();
    });

    $scope.$on('draftLoaded', function () {
      _this.fetchCurrencyData().then(function () {
        _this.fetchBudgetData().then(function () {
          _this.setSelectedBudget();
        });
      });
    });

    $scope.$watch('BudgetSelector.projectData.budgetType', function () {
      if (_this.budgetField === 'estimatedBudget') {
        _this.refreshBudgetOptions();
      }
    });

    $scope.$watch('BudgetSelector.projectData.isEscrowCurrencyRestricted', function () {
      if (_this.projectData.isEscrowCurrencyRestricted && _this.currencyData) {
        _this.currencyData = _this.currencyData.filter(function (currency$$1) {
          return _this.escrowCurrencies.includes(currency$$1.code);
        });

        // Default currency is USD
        var defaultCurrency = _this.currencyData.find(function (currency$$1) {
          return currency$$1.id === 1;
        });

        _this.projectData.selectedCurrency = defaultCurrency;

        delete _this.projectData.budgetId;

        _this.onCurrencyChange();
      }
    });

    $scope.$watch('BudgetSelector.projectData.selectedBudget', function () {
      if (_this.projectData.budgetType === 'hourly') {
        _this.projectData.hourlyBudget = _this.projectData.selectedBudget;
      } else if (_this.projectData.budgetType === 'fixed') {
        _this.projectData.fixedBudget = _this.projectData.selectedBudget;
      }
    });
  }

  _createClass(flBudgetSelector, [{
    key: 'initialiseBudgetOptions',
    value: function initialiseBudgetOptions() {
      var _this2 = this;

      var currencyPromise = this.fetchCurrencyData();
      currencyPromise.then(function () {
        _this2.fetchBudgetData().then(function () {
          _this2.setSelectedBudget();
          _this2.UpgradesService.getUpgradeFees();
        });
      });
    }
  }, {
    key: 'fetchCurrencyData',
    value: function fetchCurrencyData() {
      var _this3 = this;

      return this.Currencies.get().then(function (currencies) {
        _this3.currencyData = currencies.getList();

        if (_this3.projectData.isEscrowCurrencyRestricted) {
          _this3.currencyData = _this3.currencyData.filter(function (currency$$1) {
            return _this3.escrowCurrencies.includes(currency$$1.code);
          });
        }

        _this3.currencyData.sort(function (a, b) {
          return a.code.localeCompare(b.code);
        });

        // Default currency is USD
        var defaultCurrency = _this3.currencyData.find(function (currency$$1) {
          return currency$$1.id === 1;
        });

        if (!_this3.projectData.selectedCurrency) {
          // Check if Prefilled Currency is a valid currency
          var prefilledCurrency = _this3.currencyData.find(function (currency$$1) {
            return parseInt(_this3.projectData.prefillCurrencyId, 10) === currency$$1.id;
          });
          if (prefilledCurrency) {
            _this3.projectData.selectedCurrency = prefilledCurrency;
            return;
          }

          // Otherwise use initial currency, and reset any prefilled budgetId
          var initialCurrency = _this3.currencyData.find(function (currency$$1) {
            return parseInt(_this3.projectData.currency.id, 10) === currency$$1.id;
          });

          _this3.projectData.selectedCurrency = initialCurrency || defaultCurrency;

          delete _this3.projectData.budgetId;

          return;
        }

        var selectedCurrency = _this3.currencyData.find(function (currency$$1) {
          return parseInt(_this3.projectData.selectedCurrency.id, 10) === currency$$1.id;
        });

        if (!selectedCurrency) {
          _this3.projectData.selectedCurrency = defaultCurrency;
          _this3.onCurrencyChange();
        }
      }).catch(function () {
        _this3.currencyData = {};
      });
    }
  }, {
    key: 'formatBudgetDisplayName',
    value: function formatBudgetDisplayName(budget, currency$$1) {
      return budget.name + ' (' + currency$$1.sign + budget.min_sum + ' ' + (budget.max_sum ? '-' : '+') + ' ' + (budget.max_sum ? budget.max_sum : '') + ' ' + currency$$1.code + ') ' + (this.projectData.budgetType == 'hourly' ? translate('per hour') : '');
    }
  }, {
    key: 'fetchBudgetData',
    value: function fetchBudgetData() {
      var _this4 = this;

      var currency$$1 = this.projectData.selectedCurrency;
      return this.BudgetService.listBy(currency$$1.id, this.projectData.budgetType).then(function (budgetData) {
        var budgets = budgetData.map(function (budget) {
          budget.displayName = _this4.formatBudgetDisplayName(budget, currency$$1);
          return budget;
        });

        budgets.push({
          id: 'custom',
          displayName: translate('Customize budget')
        });

        return budgets;
      }).then(function (budgetData) {
        _this4.budgetData = budgetData;
        _this4.projectData.minimumCustomValue = parseInt(budgetData[0].min_sum, 10);
        _this4.form.singlePriceBudget = _this4.form.singlePriceBudgetIdk ? '' : _this4.projectData.singlePriceBudget;
      }).catch(function () {
        _this4.budgetData = {};
        _this4.toggleCustomBudgetFields = false;
      });
    }
  }, {
    key: 'setSelectedBudget',
    value: function setSelectedBudget() {
      var _this5 = this;

      if (this.projectData.budgetId && this.projectData.budgetId !== 'custom') {
        this.projectData.selectedBudget = this.budgetData.find(function (budget) {
          return parseInt(budget.id, 10) === parseInt(_this5.projectData.budgetId, 10);
        });
      } else if (this.projectData.budgetId === 'custom') {
        this.projectData.selectedBudget = { id: 'custom' };
        this.onBudgetChange();
      } else if (!this.projectData.selectedBudget && this.projectData.budget) {
        this.projectData.selectedBudget = this.budgetData.find(function (budget) {
          return budget.max_sum === _this5.projectData.budget.max_sum && budget.min_sum === _this5.projectData.budget.min_sum;
        });
      } else {
        this.resetSelectedBudget();
      }
    }
  }, {
    key: 'switchBudgetType',
    value: function switchBudgetType() {
      var _this6 = this;

      this.budgetLoading = true;
      this.fetchBudgetData().then(function () {
        if (!_this6.previousSelectedBudget) {
          _this6.previousSelectedBudget = _this6.projectData.selectedBudget;
          _this6.resetSelectedBudget();
        } else {
          var currentSelectedBudget = _this6.projectData.selectedBudget;
          _this6.projectData.selectedBudget = _this6.previousSelectedBudget;
          _this6.previousSelectedBudget = currentSelectedBudget;
          _this6.onBudgetChange();
        }
        _this6.budgetLoading = false;
        _this6.projectData.customFromPrefill = false;
      }).catch(function () {
        _this6.budgetLoading = false;
      });
    }
  }, {
    key: 'onCurrencyChange',
    value: function onCurrencyChange() {
      this.refreshBudgetOptions();
      qtsp.push({
        section: 'PPP_Form_Behaviour',
        value: this.previousCurrency.code + 'to' + this.projectData.selectedCurrency.code,
        label: 'Project_Currency_change'
      });
      this.previousCurrency = this.projectData.selectedCurrency;
      this.projectData.customFromPrefill = false;
    }
  }, {
    key: 'refreshBudgetOptions',
    value: function refreshBudgetOptions() {
      var _this7 = this;

      this.previousSelectedBudget = undefined;
      this.fetchBudgetData().then(function () {
        _this7.resetSelectedBudget();
        _this7.onBudgetChange();
      });
      this.UpgradesService.getUpgradeFees();
    }
  }, {
    key: 'resetSelectedBudget',
    value: function resetSelectedBudget() {
      if (this.projectData.hourlyBudget && this.projectData.budgetType === 'hourly' && this.budgetData.map(function (b) {
        return b.id;
      }).indexOf(this.projectData.hourlyBudget.id) > -1) {
        this.projectData.selectedBudget = this.projectData.hourlyBudget;
      } else if (this.projectData.fixedBudget && this.projectData.budgetType === 'fixed' && this.budgetData.map(function (b) {
        return b.id;
      }).indexOf(this.projectData.fixedBudget.id) > -1) {
        this.projectData.selectedBudget = this.projectData.fixedBudget;
      } else {
        this.projectData.selectedBudget = this.budgetData[this.DEFAULT_BUDGET_INDEX];
      }
    }
  }, {
    key: 'onBudgetChange',
    value: function onBudgetChange() {
      this.toggleCustomBudgetFields = this.projectData.selectedBudget.id === 'custom';
      this.projectData.budgetId = this.projectData.selectedBudget.id;
      if (this.toggleCustomBudgetFields && !this.projectData.customFromPrefill) {
        // Set Custom Budget Min and Max values if they don't exist already
        if (!this.projectData.customMinBudget) {
          this.projectData.customMinBudget = parseInt(this.budgetData[0].min_sum, 10);
        }

        if (!this.projectData.customMaxBudget) {
          this.projectData.customMaxBudget = parseInt(this.budgetData[0].max_sum, 10);
        }
      }
    }
  }]);

  return flBudgetSelector;
}();

flBudgetSelector.$inject = ['ProjectData', 'BudgetService', 'Currencies', 'UpgradesService', 'WizardService', '$scope', '$timeout', 'Cdn', 'unsupportedCurrency', 'escrowCurrencies'];

var flBudgetSelector$1 = flComponent$1(flBudgetSelector, {
  selector: 'fl-budget-selector',
  transclude: true,
  template: template$3,
  bindings: {
    form: '=',
    budgetField: '@'
  },
  providers: [BudgetServiceProvider, CurrenciesProvider, WizardServiceProvider, flCustomBudgetCheck, flCustomMaximumBudgetCheck, flCustomMinimumBudgetCheck, ngMessages, ProjectDataProvider, UpgradesServiceProvider, CdnProvider, unsupportedCurrency, escrowCurrencies]
});

function processEvent(event) {
  var eventName = event.event;
  if (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
  if (eventName == 'NonHireMe Posted') {
    _ttref.push(['_trackEvent', 'PostProject', 'Posted']);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_PostProjectForm']);
  } else if (eventName == 'Buy Exam') {
    _ttref.push(['_trackEvent', 'Exams', 'ConfirmBuy', event.examName]);
  } else if (eventName == 'Bid on Project') {
    _ttref.push(['_trackEvent', 'Project', 'Bid', '', 0, true, true]);
    qtsp.push({
      label: 'PlaceBid',
      amount: event.amount,
      currency: event.currency
    });
  } else if (eventName == 'Contest Reposted') {
    _ttref.push(['_setEntrypoint', 'Contest_RepostSuccessContest']);
  } else if (eventName == 'Entries Submitted') {
    // track the submitted entries from dropdown notification
    if (event.xp_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'XP Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
    if (event.realtime_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'Realtime Notification Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
  } else if (eventName == 'Suggestion Click') {
    _t.push(['project_suggestion_redirect', {
      bidder_id: event.bidder_id,
      src_project_id: event.src_project_id,
      dst_project_id: event.dst_project_id,
      time: new Date()
    }]);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_Suggestion']);
    _ttref.push(['_trackEvent', 'Project', 'Suggestion', 'clicked', 0, false, true]);
  } else if (eventName == 'Service View') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'ViewPage',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Modal Cancel') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModalCancel',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Button Click') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderButton',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Confirm Modal') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModal',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Button Click Logged Out') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderButtonLoggedOut',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Payment Verified') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderModalOkPaymentVerified',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Modal Purchase') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      label: 'OrderModalOkPurchase',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Modal Ok') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderModal',
      label: 'OrderModalOk',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal Login') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'Login',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal FB Login') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'FBLogin',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Login Modal Sign Up') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderLoginModal',
      label: 'SignUp',
      action: 'click'
    }]);
  } else if (eventName == 'Service Order Deposit') {
    _t.push(['user_action', {
      section: 'ServiceDepositPage',
      label: 'OrderDepositPage',
      action: 'view'
    }]);
  } else if (eventName == 'Service Order Deposit Success') {
    _t.push(['user_action', {
      section: 'ServiceProjectPage',
      label: 'ServicePurchasedFromDeposit',
      action: 'view'
    }]);
  } else if (eventName == 'Dashboard MyProjects') {
    _t.push(['user_action', {
      section: 'Dashboard',
      subsection: 'Topnav',
      label: 'MyProjects'
    }]);
  } else if (eventName == 'Service Order Deposit Other Methods') {
    _t.push(['user_action', {
      section: 'ServiceViewPage',
      subsection: 'OrderDepositModal',
      label: 'OrderDepositOtherMethods',
      action: 'view'
    }]);
  } else if (eventName == 'Showcase Upsell PVP') {
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_ShowcaseUpsell']);

    _t.push(['user_action', {
      section: 'ProjectShowcaseUpsell',
      subsection: 'RepostButton',
      label: event.source,
      action: 'click'
    }]);
  } else if (eventName == 'Front Page Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'FrontPageUpperRight',
      action: 'click'
    }]);
  } else if (eventName == 'Post Project Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'PostProjectPage',
      action: 'click'
    }]);
  } else if (eventName == 'Post Contest Log In') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'PostContestPage',
      action: 'click'
    }]);
  } else if (eventName == 'Top Right Corner') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'TopRightCorner',
      action: 'click'
    }]);
  } else if (eventName == 'Hire Me Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'HireMePage',
      action: 'click'
    }]);
  } else if (eventName == 'User Login Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'UserLogInPage',
      action: 'click'
    }]);
  } else if (eventName == 'Repost Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'RepostPage',
      action: 'click'
    }]);
  } else if (eventName == 'Sign Up Modal') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'SignUpModal',
      action: 'click'
    }]);
  } else if (eventName == 'Find Freelancers Page') {
    _t.push(['user_action', {
      section: 'Login',
      subsection: 'LoginAttempt',
      label: 'FindFreelancersPage',
      action: 'click'
    }]);
  } else if (eventName == 'Directory Page Search') {
    _t.push(['search', {
      section: 'Directory',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page
    }]);
  } else if (eventName == 'Navigation Bar Search') {
    _t.push(['search', {
      section: 'MainNav',
      keyword: event.keyword
    }]);
  } else if (eventName == 'Jobs Page Search') {
    _t.push(['search', {
      section: 'JobTable',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page,
      sort: event.sort
    }]);
  } else if (eventName == 'Work Search') {
    _t.push(['search', {
      section: 'WorkTable',
      source: event.source,
      keyword: event.keyword,
      filters: event.filters,
      items_displayed: event.items_displayed,
      items_count: event.items_count,
      items_page: event.items_page,
      sort: event.sort
    }]);
  } else if (eventName == 'Project View Page - Upsell Banner') {
    _t.push(['user_action', {
      section: 'ProjectViewPage',
      subsection: event.eventOption.subsection,
      label: event.eventOption.label,
      action: event.eventOption.action
    }]);
  } else if (eventName === 'Project View Page - Bid on this project') {
    _t.push(['user_action', {
      section: 'Project',
      sub_section: 'BidTheProject',
      label: event.label
    }]);
  } else {
    _t.push(event);
  }
}

function LocalTracking() {
  this._events = [];
}

LocalTracking.prototype._save = function () {
  try {
    localStorage.setItem('LocalTracking', JSON.stringify(this._events));
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._restore = function () {
  try {
    var events = JSON.parse(localStorage.getItem('LocalTracking'));
    for (var _i = 0, _len = events.length; _i < _len; _i++) {
      this.push(events[_i]);
    }
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._process = function () {
  var events = this._events;
  this._events = [];
  for (var _i = 0, _len = events.length; _i < _len; _i++) {
    processEvent(events[_i]);
  }
  try {
    localStorage.removeItem('LocalTracking');
  } catch (e) {
    return false;
  }
  return true;
};

LocalTracking.prototype.push = function (event, options) {
  var delay = 5000;

  if (typeof options === 'object') {
    delay = options.delay ? options.delay : delay;
  }

  this._events.push(event);
  this._save();
  var self = this;
  setTimeout(function () {
    self._process();
  }, delay);
  return 1;
};

LocalTracking.prototype.init = function (_t) {
  var event = void 0;
  var _i = void 0;
  var _len = void 0;
  this._restore();
  if (_t == null) {
    _t = [];
  }
  for (_i = 0, _len = _t.length; _i < _len; _i++) {
    event = _t[_i];
    this.push(event);
  }
  return this;
};

var template$4 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset PagePostProject-contestUpsell\">\n        <legend class=\"PagePostProject-legend PagePostProject-legend--contestUpsell\">How would you like to get it done?</legend>\n        <div class=\"alert alert-info has-icon PagePostProject-contestUpsell-alert\"\n          ng-if=\"ContestUpsell.projectData.project.jobClassification !== 'unknown'\">\n            <div ng-if=\"ContestUpsell.projectData.project.jobClassification === 'likely_contest'\">\n                <span class=\"alert-icon PagePostProject-contestUpsell-alertIcon\">\n                  <img ng-src=\"{{ContestUpsell.Cdn.getCdnUrl('/static/img/ppp/contest-icon.svg')}}\"\n                    class=\"PagePostProject-budgetTabs-img\" alt=\"Post a Contest\">\n                </span>\n                Based on the description you have written, we recommend posting a contest. Contests are great for when you want to crowdsource the best ideas.\n            </div>\n            <div ng-if=\"ContestUpsell.projectData.project.jobClassification === 'likely_project'\">\n                <span class=\"alert-icon PagePostProject-contestUpsell-alertIcon\">\n                    <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/ppp/project-001.svg\" alt=\"Post a Project\">\n                </span>\n                Based on the description you have written, we recommend posting a project. Work with a freelancer 1&#8209;on&#8209;1 and only pay them when you're happy with the completed work.\n            </div>\n        </div>\n        <nav class=\"PagePostProject-budgetTabs\">\n            <ul class=\"PagePostProject-budgetTabs-cards\">\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                    <input type=\"radio\" name=\"type\" id=\"post-project\" value=\"project\"\n                        class=\"PagePostProject-selectableCard-input focusable-field\"\n                        data-tab=\"project-post\"\n                        ng-model=\"ContestUpsell.projectData.jobType\"\n                        ng-checked=\"!ContestUpsell.projectData.useWizardForm\">\n                    <label for=\"post-project\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\"\n                        ng-click=\"ContestUpsell.continueWithProject()\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/ppp/project-001.svg\" alt=\"Post a Project\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Post a project\n                            </h4>\n                            <h5 class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Receive free quotes, best for when you have a specific idea, the project is not visual in nature or the project is complex.\n                            </h5>\n                        </div>\n                        <span class=\"PagePostProject-budgetTabs-promotion\"\n                          ng-if=\"ContestUpsell.projectData.project.jobClassification === 'likely_project'\">\n                          Recommended\n                        </span>\n                        <span class=\"PagePostProject-budgetTabs-promotion\"\n                          ng-if=\"ContestUpsell.projectData.project.jobClassification === 'unknown'\">\n                          Most Popular\n                        </span>\n                    </label>\n                </li>\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                    <input type=\"radio\" name=\"type\" id=\"post-contest\" value=\"contest\"\n                        class=\"PagePostProject-selectableCard-input focusable-field\"\n                        data-tab=\"contest-post\"\n                        ng-model=\"ContestUpsell.projectData.jobType\">\n                    <label class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\" for=\"post-contest\"\n                        ng-click=\"ContestUpsell.switchToContest()\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img ng-src=\"{{ContestUpsell.Cdn.getCdnUrl('/static/img/ppp/contest-icon.svg')}}\"\n                              class=\"PagePostProject-budgetTabs-img\" alt=\"Post a Contest\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Start a contest\n                            </h4>\n                            <h5 class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Crowdsource ideas. Post a prize and get competing entries which you can iterate on with feedback. Great for visual designs.\n                            </h5>\n                        </div>\n                        <span class=\"PagePostProject-budgetTabs-promotion\"\n                            ng-if=\"ContestUpsell.projectData.project.jobClassification === 'likely_contest'\"\n                            >Recommended</span>\n                    </label>\n                </li>\n            </ul>\n        </nav>\n    </fieldset>\n</div>\n\n";

var ContestUpsell = function () {
  function ContestUpsell(Auth, Cdn, ProjectData, WizardService, $scope, $window) {
    _classCallCheck(this, ContestUpsell);

    this.Auth = Auth;
    this.Cdn = Cdn;
    this.projectData = ProjectData;
    this.WizardService = WizardService;
    this.$window = $window;
    this.tracker = new LocalTracking();

    this.postProjectImage = this.Cdn.getCdnUrl('/static/img/contest/post-project.png');
    this.postContestImage = this.Cdn.getCdnUrl('/static/img/contest/post-contest.png');

    qtsp.push({
      section: 'wizard-form',
      subsection: 'contest-upsell',
      label: 'show-step'
    });
  }

  _createClass(ContestUpsell, [{
    key: 'switchToContest',
    value: function switchToContest() {
      this.projectData.contestMode = true;
      this.projectData.jobType = 'contest';
      this.WizardService.currentStep = 'contest';
      this.WizardService.goToNextStep();

      this.trackSwitchToContestClick();
    }
  }, {
    key: 'redirectToPostContestPage',
    value: function redirectToPostContestPage() {
      var skills = this.projectData.project.selectedSkills.map(function (skill) {
        return skill.id;
      });
      var params = {
        description: this.projectData.project.description,
        skills: skills,
        name: this.projectData.project.project_name
      };
      localStorage.setItem('contest-carry-over-details', JSON.stringify(params));
      this.trackContestRedirect();
      this.$window.location.href = '/contest/create_new.php?from=Project';
    }
  }, {
    key: 'trackContestRedirect',
    value: function trackContestRedirect() {
      this.tracker.push(['user_action', {
        section: 'PPPContestUpsell',
        name: 'GoToPostContest',
        value: 'Post',
        label: 'PostContest'
      }]);
    }
  }, {
    key: 'continueWithProject',
    value: function continueWithProject() {
      this.projectData.contestMode = false;
      this.projectData.jobType = 'project';
      this.WizardService.currentStep = 'contest';
      this.WizardService.goToNextStep();
      this.trackPostProjectClick();
    }
  }, {
    key: 'trackPostProjectClick',
    value: function trackPostProjectClick() {
      qtsp.push({
        section: 'PPPContestUpsell',
        label: 'PostProject'
      });
    }
  }, {
    key: 'trackSwitchToContestClick',
    value: function trackSwitchToContestClick() {
      qtsp.push({
        section: 'PPPContestUpsell',
        label: 'PostContestMode'
      });
    }
  }]);

  return ContestUpsell;
}();

ContestUpsell.$inject = ['Auth', 'Cdn', 'ProjectData', 'WizardService', '$scope', '$window'];

var flContestUpsell = flComponent$1(ContestUpsell, {
  selector: 'fl-contest-upsell',
  transclude: true,
  template: template$4,
  bindings: {
    form: '='
  },
  providers: [AuthModule, ProjectDataProvider, CdnProvider, WizardServiceProvider]
});

var LanguageDetector = function () {
  function LanguageDetector() {
    _classCallCheck(this, LanguageDetector);
  }

  _createClass(LanguageDetector, [{
    key: 'detect',
    value: function detect(sourceText) {
      var _this = this;

      var formData = new FormData();
      formData.append('text', sourceText);
      return fetch('/ajax/language/detect_language.php', {
        method: 'POST',
        credentials: 'same-origin',
        body: formData
      }).then(function (response) {
        return response.json();
      }).catch(function (e) {
        return _this.trackDetectionError(e);
      });
    }
  }, {
    key: 'detectTopLanguage',
    value: function detectTopLanguage(sourceText) {
      var _this2 = this;

      return this.detect(sourceText).then(function (data) {
        if (data.status === 'error') {
          _this2.trackDetectionError(data.error_phase);
        } else {
          return data ? data.shift() : {};
        }
      });
    }
  }, {
    key: 'trackDetectionError',
    value: function trackDetectionError(e) {
      qtsp.push({
        section: 'PPPLanguageDetector',
        value: JSON.stringify(e),
        label: 'LanguageDetectionError'
      });
    }
  }]);

  return LanguageDetector;
}();

var LanguageDetectorProvider = flService$1('LanguageDetector', [], LanguageDetector);

var CRAIGSLIST_TERMS = ['craigslist', /(^|\W)cl($|\W)/, 'clist', 'adnuke', 'anonypay'];

var CRAIGSLIST_VIOLATION_TERMS = ['ghost', 'ghosting', 'flag', 'flagging', 'block', 'blocking', 'pva', 'pvas', 'phone verified accounts', 'auto reply', 'auto respond', 'post', 'poster', 'posting', 'autopost', 'autoposter', 'autoposting', 'anti-flagging', 'captcha', 'captchas'];

var COPYRIGHT_VIOLATION_TERMS = ['clone', 'exact copy'];

var REVIEW_TERMS = ['review', 'reviews'];

var REVIEW_SITES = ['google', 'yelp', 'citysearch', 'city search', 'trip advisor', 'tripadvisor', 'amazon', 'ebay', 'expedia'];

/**
 * @ngdoc directive
 * @name flDescriptionViolationCheck
 * @restrict A
 * @description
 * Checks if the Project Description contains any Violation Terms.
 *  - Copyright (warning)
 *  - Craigslist (validator error)
 *  - Review (validator error, unless checkbox ticked)
 */

var DescriptionViolationCheck = function () {
  function DescriptionViolationCheck(ProjectData) {
    _classCallCheck(this, DescriptionViolationCheck);

    this.projectData = ProjectData;
  }

  _createClass(DescriptionViolationCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.craigslistViolation = function (description) {
        return !_this.hasCraigslistViolations(description);
      };

      ngModel.$validators.fraudReviewViolation = function (description) {
        return !_this.hasFraudReviewViolations(description) || scope.DescriptionField.fraudReviewViolationConfirm;
      };

      // Extra $watch for Fraud Review Violation because we need to know
      // when to show the Checkbox on top of ngModel validator.
      scope.$watch(attr.ngModel, function (description) {
        scope.DescriptionField.fraudReviewViolation = _this.hasFraudReviewViolations(description);
        scope.DescriptionField.copyrightViolation = _this.hasCopyrightViolations(description);
      });

      // Manually trigger validate for DescriptionField when selected skills have
      // changed.
      scope.$watchCollection('DescriptionViolationCheck.projectData.project.selectedSkills', function () {
        ngModel.$setTouched();
        ngModel.$validate();
        scope.DescriptionField.fraudReviewViolation = _this.hasFraudReviewViolations(ngModel.$modelValue);
      });
    }
  }, {
    key: 'hasCopyrightViolations',
    value: function hasCopyrightViolations(description) {
      return this.hasViolationTerms(description, COPYRIGHT_VIOLATION_TERMS);
    }
  }, {
    key: 'hasCraigslistViolations',
    value: function hasCraigslistViolations(description) {
      return this.hasViolationTerms(description, CRAIGSLIST_TERMS) && this.hasViolationTerms(description, CRAIGSLIST_VIOLATION_TERMS);
    }

    /**
     * Has review violations if description contains violation terms
     * or project skills contain reviews
     */

  }, {
    key: 'hasFraudReviewViolations',
    value: function hasFraudReviewViolations(description) {
      var hasReviewSkill = this.projectData.project.selectedSkills.find(function (skill) {
        return skill.name === 'Reviews';
      });
      return this.hasViolationTerms(description, REVIEW_TERMS) && this.hasViolationTerms(description, REVIEW_SITES) || hasReviewSkill;
    }
  }, {
    key: 'hasViolationTerms',
    value: function hasViolationTerms(value, termsList) {
      if (!value) {
        return false;
      }
      value = value.toLowerCase();
      return termsList.reduce(function (hasTerm, term) {
        var matches = value.match(term);
        return hasTerm || matches && matches.length > 0;
      }, false);
    }
  }]);

  return DescriptionViolationCheck;
}();

DescriptionViolationCheck.$inject = ['ProjectData'];

var DescriptionViolationCheck$1 = flDirective$1(DescriptionViolationCheck, {
  restrict: 'A',
  selector: '[fl-description-violation-check]',
  require: 'ngModel',
  providers: [ProjectDataProvider]
});

var template$5 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <legend class=\"PagePostProject-legend\">{{DescriptionField.getTemplateLegend()}}</legend>\n        <p class=\"PagePostProject-legend-subtext\">{{DescriptionField.getTemplateLegendSubtext()}}</p>\n        <ol>\n            <li class=\"form-step\"\n                ng-class=\"{\n                    'is-invalid': (DescriptionField.form.visible_description.$error.required &&\n                        DescriptionField.form.visible_description.$dirty),\n                    'is-warning': (DescriptionField.form.visible_description.$invalid &&\n                        !DescriptionField.form.visible_description.$error.required &&\n                        DescriptionField.form.visible_description.$dirty)}\">\n                <label for=\"project-description\" class=\"is-accessibly-hidden\">\n                    {{DescriptionField.getTemplateLabel()}}\n                </label>\n                <input type=\"hidden\" name=\"description\" value=\"{{DescriptionField.projectData.project.description}}\"\n                    ng-if=\"!DescriptionField.projectData.contestMode\">\n                <input type=\"hidden\" name=\"contest_description\" value=\"{{DescriptionField.projectData.project.description}}\"\n                    ng-if=\"DescriptionField.projectData.contestMode\">\n                <textarea id=\"project-description\"\n                    ng-model-options=\"{ allowInvalid:true }\"\n                    class=\"PagePostProject-form-input large-textarea focusable-field\"\n                    placeholder=\"{{DescriptionField.getTemplatePlaceholder()}}\"\n                    name=\"visible_description\"\n                    rows=\"5\"\n                    ng-model=\"DescriptionField.projectData.project.description\"\n                    ng-required=\"true\"\n                    ng-minlength=\"30\"\n                    ng-maxlength=\"4000\"\n                    ng-change=\"DescriptionField.processDescription()\"\n                    fl-focus-in-tracker=\"Project_Description\"\n                    fl-focus-out-tracker=\"Project_Description\"\n                    fl-autosave-draft\n                    fl-description-violation-check\n                    fl-toggle-wizard-next=\"description\">\n                </textarea>\n                <div ng-messages=\"DescriptionField.form.visible_description.$error\"\n                  ng-messages-multiple\n                  ng-if=\"DescriptionField.form.visible_description.$dirty\">\n                    <div class=\"form-error\" ng-message=\"required\">{{DescriptionField.getTemplateRequiredErrorMessage()}}</div>\n                    <div class=\"form-error\" ng-message=\"minlength\">Please enter at least 30 characters.</div>\n                    <div class=\"form-error\" ng-message=\"maxlength\">Please enter at most 4000 characters.</div>\n                    <div class=\"alert alert-warning PagePostProject-alert-warning\" ng-message=\"craigslistViolation\">\n                      <strong>Warning!</strong>\n                        Craigslist, Inc. has advised that certain users might be soliciting others to violate Craigslist's <a target=_blank href=\"http://www.craigslist.org/about/terms.of.use\">Terms of Use</a>. This message is being displayed based on a list of keywords that Craigslist has provided us. Please ensure you do not violate Craigslist's TOU.\n                    </div>\n                </div>\n                <div class=\"alert alert-warning PagePostProject-alert-warning\" ng-if=\"DescriptionField.copyrightViolation\">\n                  <strong>Warning!</strong>\n                   It is illegal and against our terms of service to violate the intellectual property rights of others. Requesting exact copies or clones of items may be a violation if you are not the copyright holder, not authorised to do so by such, or not otherwise permitted by law.\n                </div>\n                <div class=\"alert alert-warning PagePostProject-alert-warning\"\n                  ng-if=\"DescriptionField.fraudReviewViolation\">\n                  <p class=\"ReviewWarning-title\">Warning about \"Review\" projects.</p>\n                  <p class=\"ReviewWarning-desc\">\n                    Projects to create fraudulent or fake reviews are strictly prohibited and are in violation of our Terms and Conditions. Posting such projects will result in your account being suspended or terminated.\n                  </p>\n                  <div class=\"Checkbox\">\n                    <input type=\"checkbox\" class=\"Checkbox-input focusable-field\"\n                      id=\"project-review-confirm\" name=\"review_confirm\"\n                      ng-required=\"true\"\n                      ng-model=\"DescriptionField.fraudReviewViolationConfirm\"\n                      ng-click=\"DescriptionField.form.visible_description.$validate()\" />\n                    <label class=\"Checkbox-label ReviewWarning-label\" for=\"project-review-confirm\">\n                      I confirm that this project is not to create fraudulent or fake reviews\n                    </label>\n                  </div>\n                  <div class=\"form-error\">\n                    <span ng-messages=\"DescriptionField.form.review_confirm.$error\">\n                      <span class=\"form-error\" ng-message=\"required\">You need to confirm in order to proceed</span>\n                    </span>\n                  </div>\n                </div>\n            </li>\n            <li class=\"form-step\" ng-show=\"DescriptionField.toggleLanguageSelector\">\n                <fl-language-selector form=\"DescriptionField.form\"></fl-language-selector>\n            </li>\n            <li class=\"form-step fileupload-container\">\n                <fl-file-upload form=\"DescriptionField.form\"></fl-file-upload>\n            </li>\n        </ol>\n    </fieldset>\n</div>\n";

var flDescriptionField = function () {
  function flDescriptionField(ProjectData, WizardService, LanguageDetector, domainLanguage$$1, $scope) {
    var _this = this;

    _classCallCheck(this, flDescriptionField);

    this.projectData = ProjectData;
    this.WizardService = WizardService;
    this.languageDetector = LanguageDetector;
    this.toggleLanguageSelector = false;
    this.LENGTH_DIFF_BEFORE_REDETECTION = 20;
    this.lastLengthDetected = 0;
    this.domainLanguage = domainLanguage$$1;
    $scope.$on('draftLoaded', function () {
      return _this.detectLanguage();
    });
    // Description Violations
    this.copyrightViolation = false;
    this.fraudReviewViolation = false;
    this.fraudReviewViolationConfirm = false;
  }

  _createClass(flDescriptionField, [{
    key: 'haveABTestT91960',
    value: function haveABTestT91960() {
      return this.projectData && this.projectData.pppABTest && this.projectData.pppABTest.T91960;
    }
  }, {
    key: 'tooShortForRedetection',
    value: function tooShortForRedetection(textLength) {
      return Math.abs(this.lastLengthDetected - textLength) < this.LENGTH_DIFF_BEFORE_REDETECTION;
    }
  }, {
    key: 'detectLanguage',
    value: function detectLanguage() {
      var _this2 = this;

      var description = this.projectData.project.description;
      if (!description || this.tooShortForRedetection(description.length)) {
        return;
      }
      this.lastLengthDetected = description.length;
      this.languageDetector.detectTopLanguage(description).then(function (language) {
        if (language && language.likelihood > 0.1) {
          _this2.projectData.project.detectedLanguage = {
            code: language.code,
            name: language.name
          };
          _this2.trackDetection(language.code);
          _this2.toggleLanguageSelector = language.code != _this2.domainLanguage;
        }
      });
    }
  }, {
    key: 'trackDetection',
    value: function trackDetection(langCode) {
      qtsp.push({
        section: 'PPPLanguageDetector',
        value: langCode,
        label: 'DetectedNewLanguage'
      });
    }
  }, {
    key: 'processDescription',
    value: function processDescription() {
      this.detectLanguage();
      this.projectData.detectSkills();
    }
  }, {
    key: 'getTemplateLegend',
    value: function getTemplateLegend() {
      return this.projectData.contestMode ? translate('Describe your contest in detail') : translate('Tell us more about your project');
    }
  }, {
    key: 'getTemplateLegendSubtext',
    value: function getTemplateLegendSubtext() {
      // T91960: Logged-Out PJP Changes Experiment
      return this.haveABTestT91960() && this.projectData.pppABTest.T91960.inTestVariant ? translate('Remember to include the goal, the timelines, ' + 'any special requirements and any other details that could help.') : translate('Start with a bit about yourself or your business, and include an overview of what you need done.');
    }
  }, {
    key: 'getTemplateLabel',
    value: function getTemplateLabel() {
      return this.projectData.contestMode ? translate('Describe your contest') : translate('Describe your project');
    }
  }, {
    key: 'getTemplatePlaceholder',
    value: function getTemplatePlaceholder() {
      if (this.projectData.contestMode) {
        return translate('Describe your contest here...');
      }
      if (this.haveABTestT91960() && this.projectData.pppABTest.T91960.inTestVariant) {
        // T91960: Logged-Out PJP Changes Experiment
        return translate('Start with the task you need done...');
      }
      return translate('Describe your project here...');
    }
  }, {
    key: 'getTemplateRequiredErrorMessage',
    value: function getTemplateRequiredErrorMessage() {
      return this.projectData.contestMode ? translate('Please enter a contest description.') : translate('Please enter a project description.');
    }
  }]);

  return flDescriptionField;
}();

flDescriptionField.$inject = ['ProjectData', 'WizardService', 'LanguageDetector', 'domainLanguage', '$scope'];

var flDescriptionField$1 = flComponent$1(flDescriptionField, {
  selector: 'fl-description-field',
  transclude: true,
  template: template$5,
  bindings: {
    form: '='
  },
  providers: [DescriptionViolationCheck$1, domainLanguage, LanguageDetectorProvider, ngMessages, ProjectDataProvider, WizardServiceProvider]
});

var fieldTemplate = "<div id=\"project-fileupload-container\">\n  <div id=\"fileupload-container\" class=\"file-uploader-area\">\n    <span class=\"btn btn-plain btn-file-uploader\">\n      <span class=\"fl-icon-plus\"></span>\n      <span id=\"file-upload-button-text\">Upload Files</span>\n      <input type=\"file\" name=\"upload[]\" multiple=\"\" class='fileupload-input'>\n      <input type=\"hidden\" name=\"fileset\" class=\"upload-fileset\" ng-model=\"FileUpload.form.fileset\"\n        value=\"{{FileUpload.projectData.fileset}}\" fl-autosave-draft>\n    </span>\n    <p class=\"file-upload-text\">Drag & drop any images or documents that might be helpful in explaining your project brief here.</p>\n  </div>\n\n  <div id='fileupload-error' class=\"alert alert-error upload-alert fileupload-error hide\">You have uploaded this file before</div>\n\n  <table class=\"file-uploader-table default-table table-alt-row fileupload-item-list\" role='presentation'>\n    <tbody class='files'></tbody>\n  </table>\n</div>\n";

var templateUpload = "<tr class=\"template-upload fileupload-upload-item\" data-filename='<%- name %>'>\n  <td class=\"file-upload-thumb preview\">\n    <span class='fade'></span>\n  </td>\n  <td class=\"file-upload-name\"><%- shortName %></td>\n  <td class=\"file-upload-size\"><%- size %></td>\n  <td class=\"file-upload-action cancel\">\n    <button class=\"btn btn-danger btn-small\">\n      Cancel\n    </button>\n  </td>\n  <td>\n    <div class=\"progress-bar-wrapper file-upload-progress-bar light-bar\">\n      <progress class=\"progress-bar\" value=\"0\" max=\"10\" style='width:100px;'>\n        <div class=\"progress-bar-fallback\">\n          <div class=\"progress-bar-fallback-value\"></div>\n        </div>\n      </progress>\n    </div>\n  </td>\n</tr>\n";

var templateDownload = "<tr\n  class=\"template-download <% if (error) {%> ui-state-error <% } %>\"\n  <% if (id) { %> fileid=<%-id%> <% } %>\n  <% if (isDriveFile) { %> data-drive-file=\"true\" <% } %>\n>\n  <td class=\"preview\">\n    <% if (thumbnail_url) { %>\n      <a href=\"<%= url %>\" target=\"_blank\"><img src=\"<%= thumbnail_url %>\"></a>\n    <% } %>\n  </td>\n  <td class=\"name\">\n    <span><%- shortName %></span>\n    <input type='hidden' name='<%- filenameParamName %>' value='<%- name %>'/>\n\n    <% if (isDriveFile) { %>\n      <input type='hidden' name='<%- driveFileParamName %>' value='<%- id %>'/>\n    <% } %>\n  </td>\n  <td class=\"size\" colspan='2'> <%- size %> </td>\n  <td class=\"delete\">\n    <button class=\"btn btn-danger btn-small\" data-type=\"<%- delete_type %>\" data-url=\"<%= delete_url %>\" >\n      <span>Delete</span>\n    </button>\n  </td>\n</tr>\n";

var templateError = "<div>\n  <ul>\n    <% if (errorsList['maxFileSize'].length > 0) { %>\n      <%- maxSizeError %>\n    <% } %>\n    <% for (var i = 0; i < errorsList['maxFileSize'].length; i++) { %>\n      <li>\n        <%- errorsList['maxFileSize'][i] %>\n      </li>\n    <% } %>\n  </ul>\n  <ul>\n    <% if (errorsList['minFileSize'].length > 0) { %>\n      <%- minSizeError %>\n    <% } %>\n    <% for (var i = 0; i < errorsList['minFileSize'].length; i++) { %>\n      <li>\n        <%- errorsList['minFileSize'][i] %>\n      </li>\n    <% } %>\n  </ul>\n  <ul>\n    <% if (errorsList['minAcceptFileType'].length > 0) { %>\n      <%- fileTypeError %>\n    <% } %>\n    <% for (var i = 0; i < errorsList['minAcceptFileType'].length; i++) { %>\n      <li>\n        <%- errorsList['minAcceptFileType'][i] %>\n      </li>\n    <% } %>\n  </ul>\n  <ul>\n    <% if (errorsList['maxNumberOfFiles'].length > 0) { %>\n      <%- maxFilesError%>\n    <% } %>\n    <% for (var i = 0; i < errorsList['maxNumberOfFiles'].length; i++) { %>\n      <li>\n        <%- errorsList['maxNumberOfFiles'][i] %>\n      </li>\n    <% } %>\n  </ul>\n  <ul>\n    <% if (errorsList['duplicateFileName'].length > 0) { %>\n      <%- duplicateError%>\n    <% } %>\n    <% for (var i = 0; i < errorsList['duplicateFileName'].length; i++) { %>\n      <li>\n        <%- errorsList['duplicateFileName'][i] %>\n      </li>\n    <% } %>\n  </ul>\n  <ul>\n    <% if (errorsList['other'].length > 0) { %>\n      <%- otherError %>\n    <% } %>\n    <% for (var i = 0; i < errorsList['other'].length; i++) { %>\n      <li>\n        <%- errorsList['other'][i] %>\n      </li>\n    <% } %>\n  </ul>\n</div>\n";

var _templateObject$9 = _taggedTemplateLiteral(['Your files are bigger than ', ' MBs: '], ['Your files are bigger than ', ' MBs: ']);

var flFileUpload = function () {
  function flFileUpload(ProjectData, $scope, AutoSaveDraftService) {
    var _this = this;

    _classCallCheck(this, flFileUpload);

    this.projectData = ProjectData.project;
    this.projectData.fileData = {};
    this.$scope = $scope;
    this.filenameParamName = 'project_files[]';
    this.driveFileParamName = 'drive_files[]';

    this.$container = jq('#project-fileupload-container');
    this.fileset = null;
    this.uploadedFiles = [];
    this.blueimpeFileuploadOpts = {
      autoUpload: true,
      dataType: 'json',
      destroy: function destroy(e, data) {
        return _this.deleteFile(data);
      },
      downloadTemplate: function downloadTemplate(data) {
        return _this.downloadTemplateRenderer(data);
      },
      downloadTemplateId: null,
      dropZone: this.$container.find('#fileupload-container'),
      getFilesFromResponse: function getFilesFromResponse(data) {
        return _this.filesFromResponseFormatter(data);
      },
      maxFileSize: parseInt(maxFileSize, 10) || 2000000,
      paramName: 'upload[]',
      pasteZone: null,
      prependFiles: true,
      singleFileUploads: false,
      uploadTemplate: function uploadTemplate(data) {
        return _this.uploadTemplateRenderer(data);
      },
      uploadTemplateId: null,
      url: '/buyers/postproject-upload.php?fileset='
    };

    // Initialize the jQuery File Upload widget:
    this.$container.fileupload(this.blueimpeFileuploadOpts);

    // Override to get DND to work for IE
    this.$container.unbind('dragover').bind('dragover', function (e) {
      return _this.onDragOver(e);
    }).unbind('dragenter').bind('dragenter', function () {
      return _this.onDragEnter();
    }).unbind('dragleave').bind('dragleave', function () {
      return _this.onDragLeave();
    }).unbind('drop').bind('drop', function () {
      return _this.onDrop();
    });

    // Fileupload events
    this.$container.bind('fileuploadadd', function (e, data) {
      return _this.onFileUploadAdd(e, data);
    }).bind('fileuploadfail', function (e, data) {
      return _this.onFileUploadFail(e, data);
    }).bind('fileuploadprogress', function (e, data) {
      return _this.onFileUploadProgress(e, data);
    }).bind('fileuploaddone', function (e, data) {
      return _this.onFileUploadDone(e, data);
    });

    // Display uploaded files from draft
    this.displayUploadedFilesFromDraft(AutoSaveDraftService);
    $scope.$on('clearDraft', function () {
      _this.clearFiles();
    });
  }

  _createClass(flFileUpload, [{
    key: 'clearFiles',
    value: function clearFiles() {
      this.projectData.fileData = {};
      this.uploadedFiles = {};
      this.$container.find('.files').empty();
    }
  }, {
    key: 'displayUploadedFilesFromDraft',
    value: function displayUploadedFilesFromDraft(autoSaveDraftService) {
      var _this2 = this;

      // Ensure project data has been loaded using promise
      autoSaveDraftService.loadPromise.then(function (project) {
        if (project.fileset && project.fileData) {
          _this2.projectData.fileset = project.fileset;
          _this2.fileset = project.fileset;
          _this2.projectData.fileData = project.fileData;
          _this2.uploadedFiles = project.fileData;
        }
        jq.each(_this2.projectData.fileData, function (index, file) {
          var el = _this2.createFileRow(file);
          _this2.$container.find('.files').append(el);
        });
      }).catch(function () {});
    }
  }, {
    key: 'createFileRow',
    value: function createFileRow(file) {
      var _this3 = this;

      var templateData = {
        id: file.id,
        error: file.error,
        preview: file.preview,
        name: file.name,
        shortName: file.name,
        size: this.formatFileSize(file.size),
        submitdate: file.submitdate,
        url: file.url,
        delete_url: file.delete_url,
        delete_type: file.delete_type,
        thumbnail_url: file.thumbnail_url,
        thumb_obj: file.thumb_obj,
        filenameParamName: this.filenameParamName,
        driveFileParamName: this.driveFileParamName,
        isDriveFile: file.isDriveFile
      };

      if (templateData.name.length > 20) {
        templateData.shortName = templateData.name.substring(0, 15) + '...';
      }

      var row = jq(template$2(templateDownload)(templateData));
      row.find('.delete').delegate('button', 'click', file, function (e) {
        delete _this3.uploadedFiles[e.data.name];
      });

      return row;
    }
  }, {
    key: 'formatFileSize',
    value: function formatFileSize(bytes) {
      if (typeof bytes !== 'number') {
        return '';
      }
      if (bytes >= 1000000000) {
        return (bytes / 1000000000).toFixed(2) + ' GB';
      }
      if (bytes >= 1000000) {
        return (bytes / 1000000).toFixed(2) + ' MB';
      }
      return (bytes / 1000).toFixed(2) + ' KB';
    }
  }, {
    key: 'filesFromResponseFormatter',
    value: function filesFromResponseFormatter(data) {
      return data.result && jq.isArray(data.result) ? data.result : [];
    }
  }, {
    key: 'uploadTemplateRenderer',
    value: function uploadTemplateRenderer(data) {
      var _this4 = this;

      var rows = jq();
      var errorCount = 0;
      var errorsList = {
        maxFileSize: [],
        minFileSize: [],
        minAcceptFileType: [],
        maxNumberOfFiles: [],
        duplicateFileName: [],
        other: []
      };
      var fileuploadErrorDom = this.$container.find('#fileupload-error');

      jq.each(data.files, function (index, file) {
        var templateData = {
          error: file.error,
          name: file.name,
          shortName: file.name,
          size: data.formatFileSize(file.size)
        };

        if (templateData.name.length > 20) {
          templateData.shortName = templateData.name.substring(0, 15) + '...';
        }

        if (file.error !== null && fileuploadErrorDom.length > 0) {
          // Delete file on the upload list, if error isn't duplicateFileName
          if (file.error !== 'duplicateFileName') {
            delete _this4.uploadedFiles[file.name];
          }

          switch (file.error) {
            case 'maxFileSize':
              errorsList.maxFileSize.push(file.name);
              qtsp.push({
                en: 'user_action',
                section: 'PPP_Form_Behaviour',
                label: 'file_upload_error_max_file_size',
                value: file.size / 1000000
              });
              break;
            case 'minFileSize':
              errorsList.minFileSize.push(file.name);
              break;
            case 'acceptFileType':
              errorsList.minAcceptFileType.push(file.name);
              break;
            case 'maxNumberOfFiles':
              errorsList.maxNumberOfFiles.push(file.name);
              break;
            case 'duplicateFileName':
              errorsList.duplicateFileName.push(file.name);
              break;
            default:
              errorsList.other.push(file.name);
              break;
          }
          errorCount++;
        } else {
          // No Errors, add to Row
          rows = rows.add(jq(template$2(templateUpload)(templateData)));
        }
      });

      if (errorCount > 0) {
        // Show errors, delete
        this.showUploadErrorMessages(errorsList, data);
        // Unblock upload button on error
        this.unlockFileUpload();
        return;
      }
      // No errors in any files, return rows
      return rows;
    }
  }, {
    key: 'onDrop',
    value: function onDrop() {
      this.$container.find('.file-uploader-area').removeClass('is-dragged');
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter() {
      this.$container.find('.file-uploader-area').addClass('is-dragged');
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave() {
      this.$container.find('.file-uploader-area').removeClass('is-dragged');
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(e) {
      this.$container.find('.file-uploader-area').addClass('is-dragged');
      var blueimpUiData = this.$container.data('blueimpUIFileupload');
      var dataTransfer = e.originalEvent.dataTransfer;
      e.dataTransfer = dataTransfer;

      if (blueimpUiData && blueimpUiData._trigger('dragover', e) === false) {
        return false;
      }

      if (dataTransfer) {
        try {
          // workaround for IE
          dataTransfer.effectAllowed = 'copy';
        } catch (_error) {
          // do nothing
        }
        dataTransfer.dropEffect = 'copy';
      }

      e.preventDefault();
    }
  }, {
    key: 'downloadTemplateRenderer',
    value: function downloadTemplateRenderer(data) {
      var _this5 = this;

      var rows = jq();
      var fileuploadErrorDom = this.$container.find('#fileupload-error');

      jq.each(data.files, function (index, file) {
        if (typeof file.error !== 'undefined') {
          var _ret = function () {
            // Delete file on the upload list if not duplicateFileName error
            if (file.error !== 'duplicateFileName') {
              delete _this5.uploadedFiles[file.name];
            }

            var method = 'text';
            var errorMessage = '';
            if (jq.isArray(file.error)) {
              if (file.error.length > 1) {
                errorMessage = jq('<ul>');
                jq.each(file.error, function (index, error) {
                  method = 'html';
                  errorMessage.append(jq('<li>', { text: error }));
                });
              } else {
                errorMessage = file.error[0];
              }
            } else {
              errorMessage = file.error;
            }

            fileuploadErrorDom[method](errorMessage).slideDown();

            setTimeout(function () {
              fileuploadErrorDom.empty().slideUp();
            }, 5000);

            return {
              v: void 0
            };
          }();

          if (typeof _ret === "object") return _ret.v;
        }

        var el = _this5.createFileRow(file);
        rows = rows.add(el);

        if (!_this5.projectData.fileData) {
          _this5.projectData.fileData = {};
        }
        _this5.projectData.fileData[file.name] = file;
      });
      return rows;
    }
  }, {
    key: 'onFileUploadAdd',
    value: function onFileUploadAdd(e, data) {
      var _this6 = this;

      this.$container.find('.file-uploader-area').removeClass('is-dragged');
      jq('.fileupload-item-list').show();

      var invalidFiles = [];
      data.url = this.blueimpeFileuploadOpts.url + this.fileset;
      data.files.forEach(function (file) {
        if (typeof _this6.uploadedFiles[file.name] === 'undefined') {
          _this6.uploadedFiles[file.name] = { is_uploaded: false };
        } else {
          invalidFiles.push(file.name);
          file.error = 'duplicateFileName';
        }
      });

      // block upload button so no concurrent uploads
      this.lockFileUpload();

      if (invalidFiles.length > 0) {
        e.preventDefault();
      }
    }
  }, {
    key: 'onFileUploadProgress',
    value: function onFileUploadProgress(e, data) {
      var progressBarDom = jq(data.context).find('progress');
      this.lockSubmit();

      if (progressBarDom.length > 0) {
        progressBarDom.val(parseInt(data.loaded / data.total * 10, 10));
      }
    }
  }, {
    key: 'onFileUploadDone',
    value: function onFileUploadDone(e, data) {
      var _this7 = this;

      this.unlockFileUpload();
      this.unlockSubmit();

      this.fileset = data.result[0].fileset;
      this.projectData.fileset = this.fileset;
      this.$scope.FileUpload.form.fileset.$setDirty();
      this.$scope.$apply();
      this.$scope.FileUpload.form.fileset.$setPristine();

      data.files.forEach(function (file) {
        if (typeof _this7.uploadedFiles[file.name] !== 'undefined') {
          _this7.uploadedFiles[file.name].is_uploaded = true;
        }
      });
    }
  }, {
    key: 'onFileUploadFail',
    value: function onFileUploadFail(e, data) {
      var _this8 = this;

      // Also unblock button if fileupload has failed
      this.unlockFileUpload();
      this.unlockSubmit();

      //  Loop through files and delete if error
      //  Don't delete if duplicateFileName error as previous file stays
      data.files.forEach(function (file) {
        if (typeof _this8.uploadedFiles[file.name] !== 'undefined' && file.error !== 'duplicateFileName') {
          delete _this8.uploadedFiles[file.name];
        }
      });
    }
  }, {
    key: 'deleteFile',
    value: function deleteFile(data) {
      var elem = jq(data.context[0]);
      var fileId = elem.attr('fileid');

      elem.remove();

      if (elem.data('drive-file') && fileId) {
        fetch('/ajax/files/deleteFile.php?id=' + fileId, {
          credentials: 'same-origin',
          headers: new Headers({
            'X-XSRF-TOKEN': getCSRFToken()
          }),
          method: 'DELETE'
        });
      }
    }
  }, {
    key: 'unlockFileUpload',
    value: function unlockFileUpload() {
      jq('#file-upload-button-text').text(translate('Upload Files'));
      jq('.btn-file-uploader').removeAttr('disabled');
      this.$container.off('click', this.disableMouseClick);
    }
  }, {
    key: 'lockFileUpload',
    value: function lockFileUpload() {
      jq('#file-upload-button-text').text(translate('Uploading...'));
      jq('.btn-file-uploader').attr('disabled', 'disabled');
      this.$container.on('click', this.disableMouseClick);
    }
  }, {
    key: 'unlockSubmit',
    value: function unlockSubmit() {
      jq('#post-project-submit').removeAttr('disabled');
    }
  }, {
    key: 'lockSubmit',
    value: function lockSubmit() {
      jq('#post-project-submit').attr('disabled', 'disabled');
    }
  }, {
    key: 'disableMouseClick',
    value: function disableMouseClick(event) {
      event.preventDefault();
    }
  }, {
    key: 'showUploadErrorMessages',
    value: function showUploadErrorMessages(errorsList, data) {
      var _this9 = this;

      var fileuploadErrorDom = this.$container.find('#fileupload-error');
      var fileSize = Math.round(this.blueimpeFileuploadOpts.maxFileSize / 1000000);

      fileuploadErrorDom.html(template$2(templateError)({
        errorsList: errorsList,
        maxSizeError: translate(_templateObject$9, fileSize),
        minSizeError: translate('Files are too small: '),
        fileTypeError: translate('Filetypes not allowed: '),
        maxFilesError: translate('Max number of Files Exceeded.'),
        duplicateError: translate("You've already uploaded files: "),
        otherError: translate('Error:')
      })).slideDown();

      setTimeout(function () {
        fileuploadErrorDom.text('').slideUp();
      }, 5000);

      // Delete all files from this upload selection
      data.files.forEach(function (file) {
        // 2nd Condition: Don't delete if error is duplicateFileName
        if (file.error !== 'duplicateFileName') {
          delete _this9.uploadedFiles[file.name];
        }
      });
    }
  }]);

  return flFileUpload;
}();

flFileUpload.$inject = ['ProjectData', '$scope', 'AutoSaveDraftService'];

var flFileUpload$1 = flComponent$1(flFileUpload, {
  selector: 'fl-file-upload',
  transclude: true,
  template: fieldTemplate,
  bindings: {
    form: '='
  },
  providers: [ProjectDataProvider, AutoSaveDraftServiceProvider]
});

/**
 * @ngdoc directive
 * @name flFocusInTracker
 * @restrict A
 * @description
 * Tracks when field is in focus
 */

var FocusInTracker = function () {
  function FocusInTracker() {
    _classCallCheck(this, FocusInTracker);
  }

  _createClass(FocusInTracker, [{
    key: 'link',
    value: function link(scope, element, attr) {
      var label = attr.flFocusInTracker;
      element[0].addEventListener('focus', function () {
        qtsp.push({
          section: 'PPP_Form_Behaviour',
          label: label + '_focusin'
        });
      });
    }
  }]);

  return FocusInTracker;
}();

var flFocusInTracker = flDirective$1(FocusInTracker, {
  selector: '[fl-focus-in-tracker]',
  providers: []
});

/**
 * @ngdoc directive
 * @name flFocusOutTracker
 * @restrict A
 * @description
 * Tracks when field is out of focus
 */

var FocusOutTracker = function () {
  function FocusOutTracker() {
    _classCallCheck(this, FocusOutTracker);
  }

  _createClass(FocusOutTracker, [{
    key: 'link',
    value: function link(scope, element, attr) {
      var label = attr.flFocusOutTracker;
      element[0].addEventListener('blur', function () {
        qtsp.push({
          section: 'PPP_Form_Behaviour',
          label: label + '_focusout'
        });
      });
    }
  }]);

  return FocusOutTracker;
}();

var flFocusOutTracker = flDirective$1(FocusOutTracker, {
  selector: '[fl-focus-out-tracker]',
  providers: []
});

var fieldTemplate$1 = "<div class=\"language-detector\">\n  <label class=\"language-detector-init-display language-detector-label PagePostProject-detector-label\" id=\"language-detector-display\"\n    ng-if=\"!LanguageSelector.displaySelector\">\n      Detected language:\n        <span class=\"language-detector-text\">{[{LanguageSelector.projectData.project.detectedLanguage.name}]}</span>.\n      If we are wrong <a class=\"language-detector-switch\" ng-click=\"LanguageSelector.displayLanguageOptions()\">click here</a>\n  </label>\n  <input type=\"hidden\" name=\"language\" value=\"{[{LanguageSelector.projectData.project.detectedLanguage.code}]}\"\n    ng-if=\"!LanguageSelector.displaySelector\">\n  <div class=\"PagePostProject-changeLanguage language-detector-option-container\" id=\"language-selector-container\"\n    ng-if=\"LanguageSelector.displaySelector\">\n      <label class=\"PagePostProject-changeLanguage-label\" for=\"change-language\">The description is written in</label>\n      <select id=\"change-language\" name=\"language\"\n        ng-model=\"LanguageSelector.projectData.project.selectedLanguage\"\n        ng-options=\"language as language.name for language in LanguageSelector.supportedLanguages track by language.code\"\n        ng-change=\"LanguageSelector.selectLanguage()\"\n        fl-focus-in-tracker=\"Project_Language\"\n        fl-focus-out-tracker=\"Project_Language\"\n        class=\"PagePostProject-changeLanguage-select large-input language-detector-selector\">\n      </select>\n  </div>\n</div>\n";

var flLanguageSelector = function () {
  function flLanguageSelector(ProjectData) {
    _classCallCheck(this, flLanguageSelector);

    this.projectData = ProjectData;
    this.fetchSupportedLanguages();
    this.displaySelector = false;
  }

  _createClass(flLanguageSelector, [{
    key: 'displayLanguageOptions',
    value: function displayLanguageOptions() {
      this.selectDetectedLanguage();
      this.displaySelector = true;
      this.trackShowLanguageSelector();
    }
  }, {
    key: 'trackShowLanguageSelector',
    value: function trackShowLanguageSelector() {
      qtsp.push({
        section: 'PPPLanguageDetector',
        subsection: 'ShowLanguageSwitch',
        action: 'click'
      });
      qtsp.push({
        section: 'ProjectForm',
        subsection: 'TranslationInfo',
        label: 'LanguageIsWrong'
      });
    }
  }, {
    key: 'selectDetectedLanguage',
    value: function selectDetectedLanguage() {
      var detectedLanguage = this.projectData.project.detectedLanguage;
      if (detectedLanguage) {
        this.projectData.project.selectedLanguage = this.supportedLanguages.find(function (language) {
          return detectedLanguage.code === language.code;
        });
      }
    }
  }, {
    key: 'selectLanguage',
    value: function selectLanguage() {
      qtsp.push({
        section: 'PPPLanguageDetector',
        action: 'click',
        value: this.projectData.project.selectedLanguage.code,
        label: 'SelectNewLanguage'
      });
    }
  }, {
    key: 'fetchSupportedLanguages',
    value: function fetchSupportedLanguages() {
      var _this = this;

      fetch('/ajax/language/getLanguages.php').then(function (data) {
        return data.json();
      }).catch(function () {
        _this.supportedLanguages = {};
      }).then(function (data) {
        if (data.status !== 'success') {
          Promise.reject();
        }
        _this.supportedLanguages = data.languages;
      }).catch(function () {
        _this.supportedLanguages = {};
      });
    }
  }]);

  return flLanguageSelector;
}();

flLanguageSelector.$inject = ['ProjectData'];

var flLanguageSelector$1 = flComponent$1(flLanguageSelector, {
  selector: 'fl-language-selector',
  transclude: true,
  template: fieldTemplate$1,
  bindings: {
    form: '='
  },
  providers: [ProjectDataProvider]
});

GoogleMapsLoader.KEY = 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.LANGUAGE = 'en';

var gmapPromise = new Promise(function (resolve) {
  GoogleMapsLoader.load(resolve);
});

var AUTOCOMPLETE_PREFERENCE = {
  country: 0,
  administrative_area_level_1: 1,
  locality: 2,
  vicinity: 3,
  formatted_address: 4
};

/**
 * Sets an input field and a link or button to get the geographic
 * information of a location.
 * @param {String} opts The object containing the configuration for geocoding.
 * @param {String} opts.autoCompleteElement The id of the input field that will
 *                                          have an autocomplete dropdown of
 *                                          possible locations when a user
 *                                          types in it.
 * @param {String} opts.autoCompletePreference The value to be filled into the
 *                                             autoCompleteElement.
 *                                             Defaulted to formatted_address
 * @param {Function} opts.autoCompleteCallback Callback function after showing
 *                                             the autocomplete dropdown.
 * @param {Function} opts.reverseGeocodingElement The id of the link or button
 *                                                that would get the current
 *                                                browser location.
 * @param {Function} opts.reverseGeocodingSuccessCallback Callback function
 *                                                        after getting the
 *                                                        browser location.
 * @param {Function} opts.reverseGeocodingErrorCallback Callback function when
 *                                                      the browser location
 *                                                      cannot be determined.
 * @param {Array} opts.placeTypes Place types which the autocomplete is limited to.
 *                                See https://developers.google.com/places/web-service/supported_types#table3.
 */

var Geocoding = function () {
  function Geocoding(opts) {
    var _this = this;

    _classCallCheck(this, Geocoding);

    this.config = opts;
    gmapPromise.then(function (google) {
      _this.gmap = google.maps;
      _this.autoComplete = new _this.gmap.places.Autocomplete(
      /* @type {HTMLInputElement} */
      document.getElementById(_this.config.autoCompleteElement), {
        // WARNING: don't put anything in fields that isn't "Basic Data"
        // https://developers.google.com/maps/billing/gmp-billing#data-skus
        // or it could incur significant extra costs to our google maps usage
        fields: ['address_components', 'formatted_address', 'geometry.location', 'vicinity']
      });

      if (_this.config.placeTypes) {
        _this.autoComplete.setTypes(_this.config.placeTypes);
      }

      _this.gmap.event.addListener(_this.autoComplete, 'place_changed', function () {
        if (_this.config.autoCompleteCallback) {
          _this.config.autoCompleteCallback(_this.getSelectedAddressGeoInfo());
        }
      });

      if (_this.config.initialLocation) {
        _this.setInitialLocation(_this.config.initialLocation);
      }
    });

    if (this.config.reverseGeocodingElement) {
      var reverseGeocodingElement = document.getElementById(this.config.reverseGeocodingElement);
      reverseGeocodingElement.addEventListener('click', function () {
        return _this.reverseGeocodeCurrentLocation();
      });
    }
  }

  _createClass(Geocoding, [{
    key: 'reverseGeocodeCurrentLocation',
    value: function reverseGeocodeCurrentLocation() {
      var _this2 = this;

      if (navigator.geolocation) {
        var geoOptions = {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(function (position) {
          _this2.getReverseGeoInfo(position.coords.latitude, position.coords.longitude);
        }, function (err) {
          if (_this2.config.reverseGeocodingErrorCallback) {
            _this2.config.reverseGeocodingErrorCallback('Failed to determine current location: ' + err.toString());
          }
        }, geoOptions);
      }
    }
  }, {
    key: 'setInitialLocation',
    value: function setInitialLocation(location) {
      var _this3 = this;

      var geoInfo = void 0;

      if (!location.formatted_address) {
        if (location.latitude && location.longitude) {
          this.getReverseGeoInfo(location.latitude, location.longitude);
        }
        return;
      }

      var geocoder = new this.gmap.Geocoder();
      var params = { address: location.formatted_address };
      geocoder.geocode(params, function (results, status) {
        if (status === _this3.gmap.GeocoderStatus.OK) {
          geoInfo = _this3.formatGeoInfo(results[0]);
          var autoCompleteElement = document.getElementById(_this3.config.autoCompleteElement);
          autoCompleteElement.value = geoInfo.formatted_address;
          if (_this3.config.reverseGeocodingSuccessCallback) {
            _this3.config.reverseGeocodingSuccessCallback(geoInfo);
          }
        } else if (location.latitude && location.longitude) {
          _this3.getReverseGeoInfo(location.latitude, location.longitude);
        }
      });
    }
  }, {
    key: 'formatGeoInfo',
    value: function formatGeoInfo(place) {
      var geoInfo = {
        administrative_area_level_1: '',
        country: '',
        formatted_address: '',
        lat: '',
        lng: '',
        vicinity: ''
      };

      if (!place.address_components) {
        return false;
      }

      var addressComponentMap = {
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        locality: 'long_name'
      };

      var geoInfoAddressComponents = place.address_components.reduce(function (addressInfo, addressComponent) {
        var addressType = addressComponent.types[0];
        if (addressComponentMap[addressType]) {
          addressInfo[addressType] = addressComponent[addressComponentMap[addressType]];
        }
        return addressInfo;
      }, {});

      Object.assign(geoInfo, geoInfoAddressComponents);

      geoInfo.formatted_address = place.formatted_address;
      geoInfo.lat = place.geometry.location.lat();
      geoInfo.lng = place.geometry.location.lng();
      geoInfo.vicinity = place.vicinity || geoInfo.locality || geoInfo.administrative_area_level_1 || geoInfo.country || '';
      return geoInfo;
    }
  }, {
    key: 'getSelectedAddressGeoInfo',
    value: function getSelectedAddressGeoInfo() {
      var place = this.autoComplete.getPlace();
      return this.formatGeoInfo(place);
    }
  }, {
    key: 'getReverseGeoInfo',
    value: function getReverseGeoInfo(latitude, longitude) {
      var _this4 = this;

      var geocoder = new this.gmap.Geocoder();
      var latlng = new this.gmap.LatLng(latitude, longitude);

      geocoder.geocode({ latLng: latlng }, function (results, status) {
        if (status === _this4.gmap.GeocoderStatus.OK) {
          var geoInfo = _this4.formatGeoInfo(results[0]);

          var autoCompleteElement = document.getElementById(_this4.config.autoCompleteElement);
          if (_this4.config.autoCompletePreference === AUTOCOMPLETE_PREFERENCE.country) {
            autoCompleteElement.value = geoInfo.country;
          } else if (_this4.config.autoCompletePreference === AUTOCOMPLETE_PREFERENCE.locality) {
            autoCompleteElement.value = geoInfo.locality;
          } else if (_this4.config.autoCompletePreference === AUTOCOMPLETE_PREFERENCE.vicinity) {
            autoCompleteElement.value = geoInfo.vicinity;
          } else {
            autoCompleteElement.value = geoInfo.formatted_address;
          }
          if (_this4.config.reverseGeocodingSuccessCallback) {
            _this4.config.reverseGeocodingSuccessCallback(geoInfo);
          }
        } else if (_this4.config.reverseGeocodingErrorCallback) {
          _this4.config.reverseGeocodingErrorCallback(status);
        }
      });
    }
  }]);

  return Geocoding;
}();

/**
 * Factory method to create Geocoding class
 */

function createGeocoding(opts) {
  return new Geocoding(opts);
}

/**
 * @ngdoc directive
 * @name flLocationCheck
 * @restrict A
 * @description
 * Validates if project location is from the geolocation API
 */

var LocationCheck = function () {
  function LocationCheck(ProjectData) {
    _classCallCheck(this, LocationCheck);

    this.projectData = ProjectData;
  }

  _createClass(LocationCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.locationInvalid = function () {
        return _this.projectData.isValidGeoInfo;
      };
    }
  }]);

  return LocationCheck;
}();

LocationCheck.$inject = ['ProjectData'];

var LocationCheck$1 = flDirective$1(LocationCheck, {
  selector: '[fl-location-check]',
  require: 'ngModel',
  providers: [ProjectDataProvider]
});

var fieldTemplate$2 = "<li class=\"form-step PagePostProject-type\" data-qtsb-section=\"PPP_Form_Behaviour\" id=\"ppp-location-selector\"\n  ng-class=\"{\n    'is-invalid': LocalJobsUpsell.form.project_location.$dirty && LocalJobsUpsell.form.project_location.$invalid}\">\n  <div class=\"PostProject-localJob\">\n    <div>\n      <legend class=\"PagePostProject-legend\">Where will this project be done?</legend>\n    </div>\n    <div class=\"input-btn-combo\">\n      <input type=\"hidden\" name=\"project_geoInfo_administrative_area_level_1\" value=\"{{LocalJobsUpsell.projectData.project.administrativeArea}}\">\n      <input type=\"hidden\" name=\"project_geoInfo_country\" value=\"{{LocalJobsUpsell.projectData.project.country}}\">\n      <input type=\"hidden\" name=\"project_geoInfo_formatted_address\" value=\"{{LocalJobsUpsell.projectData.project.address}}\">\n      <input type=\"hidden\" name=\"project_geoInfo_lat\" value=\"{{LocalJobsUpsell.projectData.project.lat}}\">\n      <input type=\"hidden\" name=\"project_geoInfo_lng\" value=\"{{LocalJobsUpsell.projectData.project.lng}}\">\n      <input type=\"hidden\" name=\"project_geoInfo_vicinity\" value=\"{{LocalJobsUpsell.projectData.project.vicinity}}\">\n      <input id=\"project-location\"\n        type=\"text\"\n        class=\"large-input focusable-field\"\n        name=\"project_location\"\n        ng-model=\"LocalJobsUpsell.formattedAddress\"\n        ng-model-options=\"{ allowInvalid: true }\"\n        ng-required=\"LocalJobsUpsell.projectData.project.areSkillsAllLocal\"\n        fl-location-check\n        placeholder=\"Enter a location (City, Suburb, Town or Address)\"\n        fl-toggle-wizard-next=\"locationField\"\n        >\n      <a id=\"project-reverseGeocode-btn\" class=\"btn btn-info\" data-qtsb-label=\"click_Local_Detect_Location\">\n        Detect My Location\n      </a>\n    </div>\n    <div ng-messages=\"LocalJobsUpsell.form.project_location.$error\">\n        <div class=\"form-error\" ng-message=\"required\">Please enter a project location.</div>\n        <div class=\"form-error\" ng-message=\"locationInvalid\">Please select a location from the dropdown.</div>\n    </div>\n  </div>\n</li>\n";

var flLocalJobsUpsell = function () {
  function flLocalJobsUpsell(ProjectData, $scope) {
    var _this = this;

    _classCallCheck(this, flLocalJobsUpsell);

    this.$scope = $scope;
    this.projectData = ProjectData;
    this.formattedAddress = this.projectData.project.project_geoInfo_formatted_address;
    createGeocoding({
      autoCompleteElement: 'project-location',
      reverseGeocodingElement: 'project-reverseGeocode-btn',
      autoCompleteCallback: function autoCompleteCallback(geoInfo) {
        return _this.setLocation(geoInfo);
      },
      reverseGeocodingSuccessCallback: function reverseGeocodingSuccessCallback(geoInfo) {
        return _this.setLocation(geoInfo);
      },
      parentForm: this
    });

    var inputField = document.getElementById('project-location');
    inputField.addEventListener('input', function () {
      _this.projectData.isValidGeoInfo = false;
    });

    inputField.addEventListener('keypress', function (event) {
      if (event.which === 13 || event.which === 9) {
        // enter or tab key
        event.preventDefault();
      }
    });

    qtsp.push({
      section: 'wizard-form',
      subsection: 'local-jobs-upsell',
      label: 'show-step'
    });
  }

  _createClass(flLocalJobsUpsell, [{
    key: 'setLocation',
    value: function setLocation(geoInfo) {
      this.projectData.project.lat = geoInfo.lat;
      this.projectData.project.lng = geoInfo.lng;
      this.projectData.project.vicinity = geoInfo.vicinity;
      this.projectData.project.administrativeArea = geoInfo.administrative_area_level_1;
      this.projectData.project.country = geoInfo.country;
      this.projectData.project.address = geoInfo.formatted_address;
      this.projectData.isValidGeoInfo = true;
      // Set project type as local job
      this.projectData.toggleLocalJob(true);

      var displayAddress = document.getElementById('project-location').value;
      if (displayAddress === this.formattedAddress) {
        this.formattedAddress = '';
        this.$scope.$apply();
      }
      this.formattedAddress = displayAddress;
      this.$scope.$apply();
    }
  }]);

  return flLocalJobsUpsell;
}();

flLocalJobsUpsell.$inject = ['ProjectData', '$scope'];

var flLocalJobsUpsell$1 = flComponent$1(flLocalJobsUpsell, {
  selector: 'fl-local-jobs-upsell',
  transclude: true,
  template: fieldTemplate$2,
  bindings: {
    form: '='
  },
  providers: [LocationCheck$1, ProjectDataProvider]
});

var template$6 = "<div id=\"skill-select\"\n  class=\"MultiSelectCombobox {[{AutocompleteCombobox.comboboxSize ? 'MultiSelectCombobox--' + AutocompleteCombobox.comboboxSize : '' }]}\"\n  ng-class=\"{'is-disabled': AutocompleteCombobox.disableInput, 'is-focused': inputHighlight}\"\n  ng-click=\"focusOnInput()\"\n  aria-haspopup=\"true\"\n  aria-expanded=\"{[{ ariaExpand }]}\"\n  role=\"combobox\">\n  <div class=\"MultiSelectCombobox-psuedoInput fl-tag-input\">\n    <div class=\"MultiSelectCombobox-psuedoInput-tag\" ng-repeat=\"item in AutocompleteCombobox.selectedOption\">\n      <div class=\"MultiSelectCombobox-psuedoInput-tagItem input-tag\">\n        {[{ item.name }]}\n        <span class=\"delete-tag\"\n          tab-index=\"0\"\n          ng-click=\"handleRemoveItem(item)\"\n          ng-disabled=\"AutocompleteCombobox.disableRemove\"\n          aria-label=\"Remove Tag\"\n          role=\"button\">&times;</span>\n      </div>\n    </div>\n    <label for=\"skill-input\" class=\"is-accessibly-hidden\">{[{ AutocompleteCombobox.placeholder }]}</label>\n    <input type=\"text\"\n      autocomplete=\"off\"\n      id=\"skill-input\"\n      class=\"MultiSelectCombobox-input {[{AutocompleteCombobox.comboboxSize ? AutocompleteCombobox.comboboxSize + '-input' : 'default-input' }]} focusable-field\"\n      data-js=\"suggest-input\"\n      placeholder=\"{[{ AutocompleteCombobox.placeholder }]}\"\n      ng-model=\"inputValue\"\n      ng-keydown=\"handleInput(inputValue, $event)\"\n      ng-blur=\"handleBlur()\"\n      ng-focus=\"handleFocus()\"\n      ng-disabled=\"AutocompleteCombobox.disableInput\"\n      ng-hide=\"AutocompleteCombobox.disableInput\"\n      aria-autocomplete=\"list\"\n      role=\"textbox\">\n  </div>\n  <ul id=\"skill-options\"\n    class=\"MultiSelectCombobox-options\"\n    data-js=\"suggest-options\"\n    aria-hidden=\"{[{ dropDownHidden }]}\"\n    role=\"listbox\">\n    <li id=\"{[{ 'option-item-' + optionItem.id }]}\"\n      class=\"MultiSelectCombobox-option\"\n      ng-class=\"{'is-MultiSelectCombobox-option-inFocus':optionItem.isFocus}\"\n      data-js=\"suggest-option\"\n      ng-repeat=\"optionItem in AutocompleteCombobox.optionList\"\n      ng-mousedown=\"handleClick(optionItem)\"\n      aria-hidden=\"{[{ optionItem.ariaHidden }]}\"\n      role=\"option\">{[{ optionItem[AutocompleteCombobox.optionText] }]}</li>\n  </ul>\n</div>\n";

/**
 * Angularized version of Accessible ARIA Autocomplete Combobox
 * made by Kevin To (kto@freelancer.com)
 * source: http://codepen.io/qkevinto/pen/NNZBaK
 *
 * @ngdoc directive
 * @name project-view-employer.directives.autocompleteCombobox
 * @module project-view-employer
 *
 * @param
 * - optionList: provided list of options
 * - disableInput: expression to disable input
 * - selectedOption: provided list that hold selected options
 * - disableRemove: expression to disable remove button on selected options
 * - optionText: the name of the option property that is going to be displayed
 *               in dropdown and used for comparison for autocomplete
 * - placeholder: place holder for the input
 * - inputCLass: additional class name/s for the input field
 * - addSelectionFn: callback method for adding item into selected options
 * - removeSelectionFn: callback method to remove item from selected options
 *
 * @description
 * This directive provide autocomplete combobox
 */

var flAutocompleteCombobox = function () {
  function flAutocompleteCombobox($timeout) {
    _classCallCheck(this, flAutocompleteCombobox);

    this.$timeout = $timeout;
    this.defaultPlaceholder = this.placeholder;
  }

  _createClass(flAutocompleteCombobox, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      scope.visibleOptions = [];
      scope.ariaExpand = false;
      scope.dropDownHidden = true;
      scope.focusedItem = false;
      scope.inputHighlight = false;

      scope.inputEl = angular$1.element(document.querySelector('[data-js="suggest-input"]'));
      scope.dropdownEl = angular$1.element(document.querySelector('[data-js="suggest-options"]'));

      scope.$watch((scope.selectedOption, function () {
        scope.togglePlaceholder();
      }));

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#getMatchingOptions
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Get list of matching options based on input key.
       * Text matching is case insensitive.
       */
      scope.getMatchingOptions = function (key) {
        return _this.optionList.filter(function (option) {
          return option[_this.optionText].toLowerCase().indexOf(key.toLowerCase()) >= 0;
        });
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#doShowMatchingOptions
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Hide non matching options and show matching options.
       */
      scope.doShowMatchingOptions = function (key) {
        scope.visibleOptions = scope.getMatchingOptions(key);

        _this.optionList.forEach(function (item) {
          // hide item
          item.ariaHidden = true;
        });

        scope.visibleOptions.forEach(function (item) {
          // show item`
          item.ariaHidden = false;
        });
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#doBlurCurrentOption
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Blur currently focused option.
       */
      scope.doBlurCurrentOption = function () {
        if (scope.focusedItem) {
          scope.inputEl.removeAttr('aria-activedescendant');
          scope.focusedItem.isFocus = false;
          scope.focusedItem = false;
        }
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#doFocusOption
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Blur currently focused option then focus on the new one.
       */
      scope.doFocusOption = function (item) {
        scope.doBlurCurrentOption();
        scope.inputEl.attr('aria-activedescendant', 'option-item-' + item.id);
        scope.focusedItem = item;
        item.isFocus = true;
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#doShowList
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Show the dropdown.
       */
      scope.doShowList = function () {
        scope.dropDownHidden = false;
        scope.ariaExpand = true;
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#doHideList
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Hide the dropdown and reset matching options.
       */
      scope.doHideList = function () {
        scope.dropDownHidden = true;
        scope.ariaExpand = false;

        // Empties visible options
        scope.visibleOptions = [];

        // Blurs the focused list element
        scope.doBlurCurrentOption();
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#doOffsetOptionsScroll
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Scroll the dropdown to the selected option.
       */
      scope.doOffsetOptionsScroll = function (item) {
        var indexOfFocusedElement = scope.visibleOptions.indexOf(item);
        var optionsToOffset = scope.visibleOptions.slice(0, indexOfFocusedElement);
        var optionsHeight = 0;

        if (optionsToOffset) {
          optionsHeight = optionsToOffset.map(function (item) {
            var el = document.querySelector('#option-item-' + item.id);
            return el.getBoundingClientRect().height;
          });
        }

        scope.dropdownEl[0].scrollTop = optionsHeight.reduce(function (prev, curr) {
          return prev + curr;
        }, 0);
      };

      // NOTE AutoComplete is disabled for now --------------------------
      /**
       * Highlight auto complete part in the input box ONLY after angular
       * finishes its digest cycle, hence the use of 0 second $timeout.
       * $timeout will be executed once the current digest cycle finish.
       */
      /* scope.doAutocomplete = (segment, suggestion) => {
       scope.inputValue = suggestion;
       $timeout(() => {
       scope.inputEl[0].setSelectionRange(
       suggestion.indexOf(segment) + segment.length,
       suggestion.length
       );
       });
       };
        scope.doClearAutocomplete = () => {
       if (scope.inputValue) {
       const selectionLength = window.getSelection().toString().length;
       const inputValueLength = scope.inputValue.length;
        scope.inputValue =
       scope.inputValue.slice(0, inputValueLength - selectionLength);
       }
       }; */
      // -----------------------------------------------------------------

      scope.handleTyping = function (input) {
        if (input) {
          scope.doShowMatchingOptions(input);
        }

        // Show dropdown only if there's input and elements to show
        if (input && scope.visibleOptions.length > 0) {
          // const currentText = input.toLowerCase();
          // const suggestedText =
          //   scope.visibleOptions[0][this.optionText].toLowerCase();

          scope.doShowList();
          scope.doFocusOption(scope.visibleOptions[0]);
          // scope.doAutocomplete(currentText, suggestedText);
        } else {
          // hide list if no matching options
          scope.doHideList();
        }
      };

      scope.handleBackspace = function () {
        if (scope.inputValue) {
          scope.doShowMatchingOptions(scope.inputValue);
        }

        if (!scope.inputValue) {
          scope.doBlurCurrentOption();
          scope.removeLastSelected();
        }
      };

      scope.removeLastSelected = function () {
        if (_this.selectedOption) {
          var lastSelected = _this.selectedOption[_this.selectedOption.length - 1];
          _this.removeSelectionFn({ item: lastSelected });
          scope.togglePlaceholder();
          ngModel.$setDirty();
        }
      };

      scope.handleEscape = function () {
        // scope.doClearAutocomplete();
        scope.doHideList();
      };

      scope.handleUpArrow = function () {
        var focusedItemPosition = scope.visibleOptions.indexOf(scope.focusedItem);
        var nextFocusIndex = 0;

        // Handles looping back around when user hits the top of the list
        if (focusedItemPosition > -1 && focusedItemPosition !== 0) {
          nextFocusIndex = focusedItemPosition - 1;
        } else {
          nextFocusIndex = scope.visibleOptions.length - 1;
        }

        scope.doFocusOption(scope.visibleOptions[nextFocusIndex]);
        scope.doOffsetOptionsScroll(scope.visibleOptions[nextFocusIndex]);
        scope.inputValue = scope.focusedItem[_this.optionText];
      };

      scope.handleDownArrow = function () {
        var focusedItemPosition = scope.visibleOptions.indexOf(scope.focusedItem);
        var nextFocusIndex = 0;

        // If there are no visible options then just show everything
        if (scope.visibleOptions.length === 0) {
          scope.doShowMatchingOptions('');
        }

        // Handles looping back around when user hits the bottom of the list
        if (focusedItemPosition > -1 && focusedItemPosition !== scope.visibleOptions.length - 1) {
          nextFocusIndex = focusedItemPosition + 1;
        } else {
          nextFocusIndex = 0;
        }

        // If the list is collapse, then just show the list. Otherwise start
        // traversing.
        if (!scope.ariaExpand) {
          scope.doShowList();
        } else {
          scope.doFocusOption(scope.visibleOptions[nextFocusIndex]);
          scope.doOffsetOptionsScroll(scope.visibleOptions[nextFocusIndex]);
          scope.inputValue = scope.focusedItem[_this.optionText];
        }
      };

      scope.handleEnter = function ($event) {
        // do not submit form on skill selection
        $event.preventDefault();
        // only add into selected item when there is focused item
        if (scope.focusedItem) {
          $event.stopPropagation();
          _this.addSelectionFn({ selected: scope.focusedItem });
          scope.togglePlaceholder();
        }
        scope.doHideList();
        scope.inputValue = '';
        scope.focusOnInput();
        ngModel.$setDirty();
      };

      scope.handleRemoveItem = function (item) {
        _this.removeSelectionFn({ item: item });
        scope.togglePlaceholder();
        ngModel.$setDirty();
      };

      scope.togglePlaceholder = function () {
        if (_this.selectedOption && _this.selectedOption.length === 0) {
          _this.placeholder = _this.defaultPlaceholder;
        } else {
          _this.placeholder = '';
        }
      };

      scope.handleInput = function (input, $event) {
        switch ($event.keyCode) {
          // Up Arrow
          case 38:
            scope.handleUpArrow();
            break;
          // Down Arrow
          case 40:
            scope.handleDownArrow();
            break;
          // Backspace
          case 8:
            scope.handleBackspace();
            break;
          // Escape
          case 27:
            scope.handleEscape();
            $event.stopPropagation();
            break;
          // Enter
          case 13:
            scope.handleEnter($event);
            break;
          // Control
          case 17:
            break;
          // Alt
          case 18:
            break;
          // Meta
          case 92:
            break;
          default:
            scope.handleTyping(input);
        }
      };

      scope.handleClick = function (item) {
        _this.addSelectionFn({ selected: item });
        scope.togglePlaceholder();
        scope.doHideList();
        scope.inputValue = '';
        scope.focusOnInput();
        ngModel.$setDirty();
      };

      scope.handleBlur = function () {
        scope.inputHighlight = false;
        scope.doHideList();
        _this.onBlurFn();
      };

      scope.handleFocus = function () {
        scope.inputHighlight = true;
        _this.onFocusFn();
      };

      /**
       * @ngdoc directive
       * @name project-view-employer.autocompleteCombobox#focusOnInput
       * @methodOf project-view-employer.autocompleteCombobox
       * @description
       * Set focus on input field
       */
      scope.focusOnInput = function () {
        if (!scope.inputHighlight && angular$1.isDefined(scope.inputEl[0])) {
          scope.inputEl[0].focus();
        }
      };
    }
  }]);

  return flAutocompleteCombobox;
}();

flAutocompleteCombobox.$inject = ['$timeout'];

var AutocompleteComboboxProvider = flDirective$1(flAutocompleteCombobox, {
  selector: 'fl-autocomplete-combobox',
  template: template$6,
  require: 'ngModel',
  scope: {
    optionList: '=',
    disableInput: '=',
    selectedOption: '=',
    disableRemove: '=',
    optionText: '@',
    placeholder: '@',
    comboboxSize: '@',
    addSelectionFn: '&',
    removeSelectionFn: '&',
    onBlurFn: '&',
    onFocusFn: '&',
    onTextFieldEnter: '&'
  },
  replace: true
});

var SkillSuggestion = function () {
  function SkillSuggestion($http, ProjectData) {
    _classCallCheck(this, SkillSuggestion);

    this.$http = $http;
    this.projectData = ProjectData;
  }

  _createClass(SkillSuggestion, [{
    key: 'getSkillSuggestions',
    value: function getSkillSuggestions() {
      var params = {
        jobs: this.projectData.project.selectedSkills.map(function (skill) {
          return parseInt(skill.id, 10);
        }).join(',')
      };

      return this.$http.get('/buyers/predict.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        qtsp.push({
          section: 'MigratedPPP',
          subsection: 'ProjectSkills',
          name: 'SkillSuggestion',
          action: 'error',
          value: JSON.stringify(e)
        });
      });
    }
  }]);

  return SkillSuggestion;
}();

SkillSuggestion.$inject = ['$http', 'ProjectData'];

var SkillSuggestionProvider = flService$1('SkillSuggestion', [ProjectDataProvider], SkillSuggestion);

var PRIVATE_FEE = 2;
var HIDDEN_FEE = 3;
var FEATURED_FEE = 4;
var HIGHLIGHT_FEE = 5;
var TOP_CONTEST_FEE = 12;
var URGENT_1DAY_FEE = 13;
var NDA_FEE = 15;

var ContestUpgradesService = function () {
  function ContestUpgradesService(ProjectData, $http) {
    _classCallCheck(this, ContestUpgradesService);

    this.projectData = ProjectData.project;
    this.$http = $http;
    if (!this.projectData.contestUpgrades) {
      this.projectData.contestUpgrades = {
        standard: {
          price: 0,
          checked: false
        },
        contest_type: {
          price: 0,
          checked: true
        },
        featured: {
          checked: false
        },
        topContest: {
          checked: false
        },
        highlight: {
          checked: false
        },
        sealed: {
          checked: false
        },
        nda: {
          checked: false
        },
        private: {
          checked: false
        },
        urgent: {
          checked: false
        }
      };
    }
    delete this.projectData.advancedContestUpgrades;
    this.getUpgradeFees();
    this.totalCost = this.computeInitialTotalCost();

    if (pppABTest && pppABTest.T70947) {
      this.isOnT70947Test = pppABTest.T70947.onTest;
    } else {
      this.isOnT70947Test = false;
    }
  }

  _createClass(ContestUpgradesService, [{
    key: 'computeInitialTotalCost',
    value: function computeInitialTotalCost() {
      return this.projectData.contestUpgrades.urgent.checked ? this.projectData.contestUpgrades.urgent.price + this.projectData.prize : this.projectData.prize;
    }
  }, {
    key: 'toggleUrgentUpgrade',
    value: function toggleUrgentUpgrade(checked) {
      this.projectData.contestUpgrades.urgent.checked = checked;
      this.computeAdvanced();
    }
  }, {
    key: 'getUpgradeFees',
    value: function getUpgradeFees() {
      var _this = this;

      var currency$$1 = this.projectData.selectedCurrency ? this.projectData.selectedCurrency : this.projectData.currency;
      var data = new FormData();
      data.append('currency', currency$$1 ? parseInt(currency$$1.id, 10) : 1);
      return this.$http.post('/ajax/contest/getFeesForCurrency.php', data, {
        headers: { 'Content-Type': undefined }
      }).then(function (result) {
        var fees = result.data.fees;
        _this.projectData.contestUpgrades.featured.price = fees[FEATURED_FEE];
        _this.projectData.contestUpgrades.topContest.price = fees[TOP_CONTEST_FEE];
        _this.projectData.contestUpgrades.highlight.price = fees[HIGHLIGHT_FEE];
        _this.projectData.contestUpgrades.sealed.price = fees[HIDDEN_FEE];
        _this.projectData.contestUpgrades.nda.price = fees[NDA_FEE];
        _this.projectData.contestUpgrades.private.price = fees[PRIVATE_FEE];
        _this.projectData.contestUpgrades.urgent.price = fees[URGENT_1DAY_FEE];
        _this.sign = currency$$1.sign;
        if (_this.projectData.selectedContestUpgrade === 'advanced') {
          _this.computeAdvanced();
        } else {
          _this.recompute();
        }
      });
    }
  }, {
    key: 'changeUpgradeSelection',
    value: function changeUpgradeSelection() {
      if (this.projectData.selectedContestUpgrade === 'advanced') {
        this.clear();

        if (this.projectData.contestUpgrades.urgent.checked || this.isOnT70947Test) {
          this.projectData.contestUpgrades.contest_type.checked = true;
        } else {
          this.projectData.selectedContestUpgrade = 'standard';
        }
        this.computeAdvanced();
      } else {
        this.recompute();
      }
    }
  }, {
    key: 'recompute',
    value: function recompute() {
      this.clear();
      if (this.projectData.selectedContestUpgrade === 'advanced') {
        this.projectData.contestUpgrades.contest_type.checked = true;
        this.getSelectedAdvancedUpgrades();
      } else {
        this.selectedUpgrades = this.projectData.contestUpgrades.urgent.checked ? ['urgent'] : [];
      }
      this.totalCost = this.projectData.contestUpgrades[this.projectData.selectedContestUpgrade] ? this.projectData.contestUpgrades[this.projectData.selectedContestUpgrade].price : 0;
      this.totalCost += this.computeInitialTotalCost();
    }
  }, {
    key: 'onBudgetReset',
    value: function onBudgetReset() {
      if (this.projectData.selectedContestUpgrade === 'advanced' || this.projectData.contestUpgrades.urgent.checked) {
        this.computeAdvanced();
        return;
      }
      this.totalCost = this.projectData.prize;
    }
  }, {
    key: 'computeAdvanced',
    value: function computeAdvanced() {
      var _this2 = this;

      var selectedName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.getSelectedAdvancedUpgrades();
      this.totalCost = Object.keys(this.projectData.contestUpgrades).filter(function (upgradeName) {
        return _this2.projectData.contestUpgrades[upgradeName].checked;
      }).reduce(function (carry, upgradeName) {
        return carry + _this2.projectData.contestUpgrades[upgradeName].price;
      }, 0);
      this.totalCost += this.projectData.prize;
      if (selectedName) {
        this.trackAdvancedSelection(selectedName);
      }
    }
  }, {
    key: 'getSelectedAdvancedUpgrades',
    value: function getSelectedAdvancedUpgrades() {
      var _this3 = this;

      this.selectedAdvancedUpgrades = Object.keys(this.projectData.contestUpgrades).filter(function (upgradeName) {
        return _this3.projectData.contestUpgrades[upgradeName].checked;
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this4 = this;

      Object.keys(this.projectData.contestUpgrades).forEach(function (key) {
        // Do not reset urgent upgrade
        if (key !== 'urgent') {
          _this4.projectData.contestUpgrades[key].checked = false;
        }
      });
      this.totalCost = 0;
    }
  }, {
    key: 'trackClickAdvancedOptionsToggle',
    value: function trackClickAdvancedOptionsToggle(isShow) {
      qtsp.push({
        section: 'ContestUpgrade',
        subsection: 'PPP',
        action: 'click',
        label: isShow ? 'select' : 'deselect',
        name: 'Upgrade Type',
        value: 'advanced'
      });
    }
  }, {
    key: 'trackMainUpgradeTypeCardClick',
    value: function trackMainUpgradeTypeCardClick(upgradeName) {
      if (!['guaranteed', 'standard'].includes(upgradeName)) {
        return;
      }

      var section = 'ContestType';
      var subsection = 'PPP';
      var action = 'click';
      var name = 'Contest Type';

      qtsp.push({
        section: section,
        subsection: subsection,
        action: action,
        label: 'select',
        name: name,
        value: upgradeName
      });
    }
  }, {
    key: 'trackAdvancedSelection',
    value: function trackAdvancedSelection(upgradeName) {
      qtsp.push({
        section: 'ContestUpgrade',
        subsection: 'PPP',
        action: 'click',
        label: this.projectData.contestUpgrades[upgradeName].checked ? 'select' : 'deselect',
        name: 'Upgrade Type',
        value: upgradeName
      });
    }
  }]);

  return ContestUpgradesService;
}();

ContestUpgradesService.$inject = ['ProjectData', '$http'];

var ContestUpgradesServiceProvider = flService$1('ContestUpgradesService', [ProjectDataProvider], ContestUpgradesService);

var fieldTemplate$3 = "<div class=\"NumberedForm-content\">\n  <fieldset class=\"PagePostProject-fieldset\">\n    <legend class=\"PagePostProject-legend\">\n      What skills are required?\n      <div class=\"Loader Loader--small\" id=\"skills-loader\"\n        ng-if=\"SkillsField.projectData.predictInProgress\"></div>\n    </legend>\n    <p class=\"PagePostProject-legend-subtext\" ng-show=\"!SkillsField.projectData.predictSuccess\">Enter up to 5 skills that best describe your project. Freelancers will use these skills to find projects they are most interested and experienced in.</p>\n    <p class=\"PagePostProject-legend-subtext\" ng-show=\"SkillsField.projectData.predictSuccess\">We've detected the following skills to suit your project. Feel free to modify these choices to best suit your needs.</p>\n    <ol>\n      <li class=\"form-step select2-form-step\" ng-class=\"{\n          'is-invalid': (SkillsField.form.skills.$error.emptySkills\n            && SkillsField.form.$submitted\n          )}\">\n        <input ng-repeat=\"skill in SkillsField.projectData.project.selectedSkills\"\n          type=\"hidden\" name=\"job_{{skill.id}}\" value=\"on\"/>\n        <label for=\"project-skills\" class=\"is-accessibly-hidden\">\n          What skills are required?\n        </label>\n\n        <fl-autocomplete-combobox\n          placeholder=\"What skills are required?\"\n          combobox-size=\"large\"\n          option-list=\"SkillsField.projectData.skillOptions\"\n          selected-option=\"SkillsField.projectData.project.selectedSkills\"\n          disable-input=\"SkillsField.projectData.project.selectedSkills.length >= SkillsField.SKILLS_LIMIT\"\n          option-text=\"name\"\n          add-selection-fn=\"SkillsField.addSelectedSkill(selected)\"\n          remove-selection-fn=\"SkillsField.removeSelectedSkill(item)\"\n          name=\"skills\"\n          ng-model=\"SkillsField.projectData.project.selectedSkills\"\n          fl-skills-check\n          fl-autosave-draft\n          fl-toggle-wizard-next=\"skills\"\n          >\n        </fl-autocomplete-combobox>\n        <div ng-messages=\"SkillsField.form.skills.$error\">\n            <div class=\"form-error\" ng-message=\"emptySkills\">Please select at least 1 skill.</div>\n        </div>\n\n        <div class=\"new-skill-suggestion-widget\"\n          ng-show=\"SkillsField.projectData.project.selectedSkills.length < SkillsField.SKILLS_LIMIT && SkillsField.suggestedSkills.length > 0\">\n          <header class=\"new-skill-suggestion-head\">\n            Suggested skills:\n          </header>\n          <span class=\"new-skill-suggestion-container\" ng-repeat=\"skill in SkillsField.suggestedSkillsDisplay\">\n            <a ng-click=\"SkillsField.addSkillSuggestion(skill)\"\n              class=\"new-skill-suggestion-link\">{{skill.name}}</a>\n            <span class=\"new-skill-suggestion-comma\"\n              ng-show=\"skill !== SkillsField.suggestedSkillsDisplay[SkillsField.suggestedSkillsDisplay.length-1]\">\n              ,\n            </span>\n          </span>\n        </div>\n      </li>\n    </ol>\n  </fieldset>\n</div>\n";

var SkillsCheck = function () {
  function SkillsCheck(ProjectData) {
    _classCallCheck(this, SkillsCheck);

    this.projectData = ProjectData;
  }

  _createClass(SkillsCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      scope.$watchCollection(function () {
        return ngModel.$modelValue;
      }, function () {
        ngModel.$setValidity('emptySkills', _this.projectData.project.selectedSkills.length > 0);
      });
    }
  }]);

  return SkillsCheck;
}();

SkillsCheck.$inject = ['ProjectData'];

var SkillsCheckProvider = flDirective$1(SkillsCheck, {
  selector: '[fl-skills-check]',
  require: 'ngModel',
  providers: [ProjectDataProvider]
});

var flSkillsField = function () {
  function flSkillsField(ProjectData, SkillSuggestion, $timeout, $rootScope, WizardService, ContestUpgradesService) {
    var _this = this;

    _classCallCheck(this, flSkillsField);

    this.SKILLS_LIMIT = 5;
    this.$timeout = $timeout;
    this.projectData = ProjectData;
    this.suggestedSkills = [];
    this.skillSuggestion = SkillSuggestion;
    this.suggestedSkillsDisplay = [];
    this.skillsRemaining = 5;
    this.model = {};
    this.widgetAction = false;
    this.timer = null;
    this.inputFocus = false;
    this.getSkillSuggestions();
    this.draftLoadedListener = $rootScope.$on('draftLoaded', function () {
      _this.getSkillSuggestions();
    });
    this.WizardService = WizardService;
    this.ContestUpgradesService = ContestUpgradesService;

    // To handle missing skills and autocomplete feature when page is translated,
    // trigger re-render by changing value of skill options and selected skills
    this.$timeout(function () {
      var lastElement = _this.projectData.skillOptions.pop();
      var lastSelectedOption = _this.projectData.project.selectedSkills.pop();
      $rootScope.$apply();
      if (lastElement) {
        _this.projectData.skillOptions.push(lastElement);
      }
      if (lastSelectedOption) {
        _this.projectData.project.selectedSkills.push(lastSelectedOption);
      }
      $rootScope.$apply();
    }, 3000);
  }

  _createClass(flSkillsField, [{
    key: 'getSkillSuggestions',
    value: function getSkillSuggestions() {
      var _this2 = this;

      if (this.projectData.project.selectedSkills.length === 0) {
        var _ret = function () {
          _this2.suggestedSkills = [];
          _this2.suggestedSkillsDisplay = [];
          var defaultSkillIds = [17, 32, 44, 39, 174];

          _this2.projectData.skillsReadyPromise.then(function () {
            defaultSkillIds.forEach(function (skillId, index) {
              var skill = _this2.projectData.skillOptions.find(function (skill) {
                return parseInt(skill.id, 10) === skillId;
              });
              if (skill) {
                _this2.suggestedSkills.push({
                  id: skill.id,
                  name: skill.name,
                  category: skill.category,
                  local: skill.local,
                  index: index
                });
              }
            });
            _this2.suggestedSkillsDisplay = _this2.suggestedSkills.slice(0, _this2.SKILLS_LIMIT);
          });
          return {
            v: void 0
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }

      this.skillSuggestion.getSkillSuggestions().then(function (response) {
        if (response.predicts) {
          _this2.suggestedSkills = [];
          _this2.projectData.skillsReadyPromise.then(function () {
            response.predicts.forEach(function (skillId, index) {
              var skill = _this2.projectData.skillOptions.find(function (skill) {
                return parseInt(skill.id, 10) === skillId;
              });
              if (skill) {
                _this2.suggestedSkills.push({
                  id: skill.id,
                  name: skill.name,
                  category: skill.category,
                  local: skill.local,
                  index: index
                });
              }
            });
            _this2.suggestedSkillsDisplay = _this2.suggestedSkills.slice(0, _this2.SKILLS_LIMIT);
          });
        }
      });
    }
  }, {
    key: 'addSkillSuggestion',
    value: function addSkillSuggestion(skill) {
      this.projectData.project.skillsDefinedByUser = true;
      this.projectData.addSelectedSkill(skill, 'skills-suggestion');
      this.refreshWidget();
    }
  }, {
    key: 'moreSkillSuggestion',
    value: function moreSkillSuggestion() {
      var head = this.suggestedSkills.splice(0, this.SKILLS_LIMIT);
      this.suggestedSkills = this.suggestedSkills.concat(head);
      this.suggestedSkillsDisplay = this.suggestedSkills.slice(0, this.SKILLS_LIMIT);
    }
  }, {
    key: 'refreshWidget',
    value: function refreshWidget() {
      this.getSkillSuggestions();
      this.skillsRemaining = this.SKILLS_LIMIT - this.projectData.project.selectedSkills.length;
    }
  }, {
    key: 'addSelectedSkill',
    value: function addSelectedSkill(skill) {
      var trackingLabel = !this.projectData.project.skillsDefinedByUser ? 'skills-change-detection' : 'skills-change-manual';

      this.projectData.addSelectedSkill(skill, trackingLabel);
      this.projectData.project.skillsDefinedByUser = true;
      this.refreshWidget();
    }
  }, {
    key: 'removeSelectedSkill',
    value: function removeSelectedSkill(skill) {
      var trackingLabel = !this.projectData.project.skillsDefinedByUser ? 'skills-change-detection' : 'skills-change-manual';

      this.projectData.removeSelectedSkill(skill, trackingLabel);

      if (this.projectData.project.selectedSkills.length === 0) {
        this.projectData.project.skillsDefinedByUser = false;
      } else {
        this.projectData.project.skillsDefinedByUser = true;
      }

      if (this.projectData.urgentSkills.length === 0) {
        this.ContestUpgradesService.toggleUrgentUpgrade(false);
      }

      this.refreshWidget();
    }
  }]);

  return flSkillsField;
}();

flSkillsField.$inject = ['ProjectData', 'SkillSuggestion', '$timeout', '$rootScope', 'WizardService', 'ContestUpgradesService'];

var flSkillsField$1 = flComponent$1(flSkillsField, {
  selector: 'fl-skills-field',
  template: fieldTemplate$3,
  bindings: {
    form: '='
  },
  providers: [ngMessages, AutocompleteComboboxProvider, ProjectDataProvider, SkillSuggestionProvider, SkillsCheckProvider, WizardServiceProvider, ContestUpgradesServiceProvider]
});

/**
 * @ngdoc directive
 * @name flContactDetailsInTitleCheck
 * @restrict A
 * @description
 * Validates if project title contains contact details
 */

var ContactDetailsInTitleCheck = function () {
  function ContactDetailsInTitleCheck() {
    _classCallCheck(this, ContactDetailsInTitleCheck);

    this.contactDetailsRegex = new RegExp([/([\w\-\+!#%\*\=\?\^\{\}\|~]+(?:\.[\w\-\+!#%\*\=\?\^\{\}\|~]+)*)/, /@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,10}(?:\.[a-z]{2})?)/i].map(function (r) {
      return r.source;
    }).join(''), 'i');
  }

  _createClass(ContactDetailsInTitleCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.containsContactDetails = function (projectTitle) {
        return !_this.contactDetailsRegex.test(projectTitle);
      };
    }
  }]);

  return ContactDetailsInTitleCheck;
}();

var ContactDetailsInTitleCheck$1 = flDirective$1(ContactDetailsInTitleCheck, {
  selector: '[fl-contact-details-in-title-check]',
  require: 'ngModel',
  providers: []
});

/**
 * @ngdoc directive
 * @name flUniqueProjectNameCheck
 * @restrict A
 * @description
 * Validate if project name is unique for logged in users
 */

var UniqueProjectNameCheck = function () {
  function UniqueProjectNameCheck($http, $q, $timeout, Auth, ProjectData) {
    _classCallCheck(this, UniqueProjectNameCheck);

    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
    this.userId = Auth.getUserId();
    this.projectData = ProjectData;
  }

  _createClass(UniqueProjectNameCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$asyncValidators.uniqueName = function (modelValue, projectName) {
        return _this.projectData.contestMode ? _this.checkContest(modelValue, projectName) : _this.checkProject(modelValue, projectName);
      };
    }
  }, {
    key: 'checkProject',
    value: function checkProject(modelValue, projectName) {
      var _this2 = this;

      var params = {
        project_name: projectName,
        active_only: true
      };
      var deferred = this.$q.defer();
      this.$http.get('/ajax/postproject/check-project-name.php', { params: params }).then(function (response) {
        var isNameUnique = response.data;
        _this2.$timeout(function () {
          if (isNameUnique) {
            deferred.resolve();
          } else {
            deferred.reject();
          }
        }, 500);
      }).catch(function (e) {
        qtsp.push({
          section: 'MigratedPPP',
          subsection: 'ProjectName',
          name: 'UniqueProjectNameCheck',
          action: 'error',
          value: JSON.stringify(e)
        });
        deferred.reject();
      });
      return deferred.promise;
    }
  }, {
    key: 'checkContest',
    value: function checkContest(modelValue, projectName) {
      var _this3 = this;

      var deferred = this.$q.defer();

      // For now, project id is set to 0 as we don't have draft mechanism for contest yet
      // Pass contest id as project id when we start saving contest drafts
      var data = 'contest_name=' + projectName + '&project_id=0';
      this.$http({
        method: 'POST',
        url: '/ajax/contest/checkContestName.php',
        data: data,
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        var isNameUnique = response.data;
        _this3.$timeout(function () {
          if (isNameUnique == 'true') {
            deferred.resolve();
          } else {
            deferred.reject();
          }
        }, 500);
      }).catch(function () {
        deferred.reject();
      });
      return deferred.promise;
    }
  }]);

  return UniqueProjectNameCheck;
}();

UniqueProjectNameCheck.$inject = ['$http', '$q', '$timeout', 'Auth', 'ProjectData'];

var UniqueProjectNameCheck$1 = flDirective$1(UniqueProjectNameCheck, {
  selector: '[fl-unique-project-name-check]',
  require: 'ngModel',
  providers: [AuthModule, ProjectDataProvider]
});

var fieldTemplate$4 = "<div class=\"NumberedForm-content\">\n  <fieldset class=\"PagePostProject-fieldset\">\n    <legend class=\"PagePostProject-legend\">{{TitleField.getTemplateLegend()}}</legend>\n    <ol>\n        <li class=\"form-step\" id=\"project_title\"\n            ng-class=\"{\n                'is-invalid': (TitleField.form.visible_name.$error.required &&\n                    TitleField.form.visible_name.$dirty),\n                'is-warning': (TitleField.form.visible_name.$invalid &&\n                    !TitleField.form.visible_name.$error.required &&\n                    TitleField.form.visible_name.$dirty)\n            }\">\n            <label for=\"project-name\" class=\"is-accessibly-hidden\">\n                {{TitleField.getTemplateLabel()}}\n            </label>\n            <input type=\"hidden\" name=\"project_name\" value=\"{{TitleField.projectData.project.project_name}}\"\n                    ng-if=\"!TitleField.projectData.contestMode\">\n            <input type=\"hidden\" name=\"contest_name\" value=\"{{TitleField.projectData.project.project_name}}\"\n                ng-if=\"TitleField.projectData.contestMode\">\n            <input type=\"text\"\n                class=\"PagePostProject-form-input large-input focusable-field\"\n                placeholder=\"{{TitleField.placeholder}}\"\n                name=\"visible_name\"\n                ng-model=\"TitleField.projectData.project.project_name\"\n                ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid:true }\"\n                autocomplete=\"off\"\n                autofocus\n                ng-required=\"true\"\n                ng-minlength=\"10\"\n                ng-maxlength=\"255\"\n                fl-focus-in-tracker=\"Project_Title_Input\"\n                fl-focus-out-tracker=\"Project_Title_Input\"\n                ng-change=\"TitleField.projectData.detectSkills()\"\n                fl-toggle-wizard-next=\"title\"\n                fl-autosave-draft\n                fl-unique-project-name-check\n                fl-contact-details-in-title-check>\n            <div ng-messages=\"TitleField.form.visible_name.$error\" tabindex=\"-1\">\n                <div class=\"form-error\" ng-message=\"required\">{{TitleField.getTemplateRequiredErrorMessage()}}</div>\n                <div class=\"form-error\" ng-message=\"minlength\">Please enter at least 10 characters.</div>\n                <div class=\"form-error\" ng-message=\"maxlength\">Please enter at most 255 characters.</div>\n                <div class=\"form-error\" ng-message=\"uniqueName\">{{TitleField.getTemplateUniqueNameErrorMessage()}}</div>\n                <div class=\"form-error\" ng-message=\"containsContactDetails\">You are not allowed to include contact details.</div>\n            </div>\n        </li>\n    </ol>\n  </fieldset>\n</div>\n";

var _templateObject$10 = _taggedTemplateLiteral(['e.g. I need ', ''], ['e.g. I need ', '']);

var flTitleField = function () {
  function flTitleField(ProjectData) {
    _classCallCheck(this, flTitleField);

    this.projectData = ProjectData;
    if (this.projectData && this.projectData.pppABTest && this.projectData.pppABTest.T91960 && this.projectData.pppABTest.T91960.inTestVariant) {
      this.placeholder = translate('e.g. Build a website for my retail business');
    } else {
      this.placeholder = skillPlaceholder ? translate(_templateObject$10, skillPlaceholder) : translate('e.g. Build me a website');
    }
  }

  _createClass(flTitleField, [{
    key: 'getTemplateLegend',
    value: function getTemplateLegend() {
      return this.projectData.contestMode ? translate('Choose a name for your contest') : translate('Choose a name for your project');
    }
  }, {
    key: 'getTemplateLabel',
    value: function getTemplateLabel() {
      return this.projectData.contestMode ? translate('Contest Title') : translate('Project Title');
    }
  }, {
    key: 'getTemplateRequiredErrorMessage',
    value: function getTemplateRequiredErrorMessage() {
      return this.projectData.contestMode ? translate('Please enter a contest name.') : translate('Please enter a project name.');
    }
  }, {
    key: 'getTemplateUniqueNameErrorMessage',
    value: function getTemplateUniqueNameErrorMessage() {
      return this.projectData.contestMode ? translate('You already have a contest with this name.') : translate('You already have a project with this name.');
    }
  }]);

  return flTitleField;
}();

flTitleField.$inject = ['ProjectData'];

var flTitleField$1 = flComponent$1(flTitleField, {
  selector: 'fl-title-field',
  transclude: true,
  template: fieldTemplate$4,
  bindings: {
    form: '='
  },
  providers: [ContactDetailsInTitleCheck$1, ngMessages, ProjectDataProvider, UniqueProjectNameCheck$1]
});

var template$7 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <legend class=\"PagePostProject-legend\">Are these details correct?</legend>\n        <div class=\"ProjectSnapshotCard\">\n            <div class=\"ProjectSnapshotCard-header\">\n                <div class=\"ProjectSnapshotCard-header-inner\">\n                    <figure class=\"ProjectSnapshotCard-figure\">\n                        <img src=\"/static/img/ppp/post-project-online.svg\" alt=\"\" class=\"ProjectSnapshotCard-img ProjectSnapshotCard-img--project\" ng-if=\"ProjectSummary.projectData.project.projectType === 'online' && !ProjectSummary.projectData.contestMode\">\n                        <img ng-src=\"{{ProjectSummary.Cdn.getCdnUrl('/static/img/ppp/contest-icon.svg')}}\" alt=\"\" class=\"ProjectSnapshotCard-img ProjectSnapshotCard-img--contest\" ng-if=\"ProjectSummary.projectData.contestMode\">\n                        <img src=\"/static/img/ppp/post-project-local.svg\" alt=\"\" class=\"ProjectSnapshotCard-img ProjectSnapshotCard-img--local\" ng-if=\"ProjectSummary.projectData.project.projectType === 'in-person' && !ProjectSummary.projectData.contestMode\">\n                    </figure>\n                    <div class=\"ProjectSnapshotCard-type\">\n                        <div class=\"ProjectSnapshotCard-type-inner\">\n                            <span class=\"ProjectSnapshotCard-type-title\" ng-if=\"ProjectSummary.projectData.project.projectType === 'online' && !ProjectSummary.projectData.contestMode\">Project</span>\n                            <span class=\"ProjectSnapshotCard-type-title\" ng-if=\"ProjectSummary.projectData.contestMode\">\n                                {{ ProjectSummary.projectData.project.contestUpgrades.urgent.checked ? '1' : ProjectSummary.projectData.project.contest_length }} Day Contest\n                            </span>\n                            <span class=\"ProjectSnapshotCard-type-title\" ng-if=\"ProjectSummary.projectData.project.projectType === 'in-person' && !ProjectSummary.projectData.contestMode\">Local</span>\n                            <div class=\"ProjectSnapshotCard-type-price\" ng-if=\"ProjectSummary.projectData.project.budgetType === 'fixed' && !ProjectSummary.projectData.contestMode\">\n                                <div class=\"ProjectSnapshotCard-type-price-value\" ng-if=\"ProjectSummary.projectData.project.selectedBudget.id !== 'custom'\">\n                                    <span class=\"ProjectSnapshotCard-type-price-value-item\">\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.selectedBudget.min_sum }}<span ng-if=\"ProjectSummary.projectData.project.selectedBudget.max_sum === null\">+ </span>\n                                        <span ng-if=\"ProjectSummary.projectData.project.selectedBudget.max_sum !== null\">\n                                            - {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.selectedBudget.max_sum }}\n                                        </span>\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.code }}\n                                    </span>\n                                </div>\n                                <div class=\"ProjectSnapshotCard-type-price-value\" ng-if=\"ProjectSummary.projectData.project.selectedBudget.id === 'custom'\">\n                                    <span class=\"ProjectSnapshotCard-type-price-value-item\">\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.customMinBudget }} -\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.customMaxBudget }}\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.code }}\n                                    </span>\n                                </div>\n                            </div>\n                            <div class=\"ProjectSnapshotCard-type-price\" ng-if=\"ProjectSummary.projectData.project.budgetType === 'hourly' && !ProjectSummary.projectData.contestMode\">\n                                <div class=\"ProjectSnapshotCard-type-price-value\" ng-if=\"ProjectSummary.projectData.project.selectedBudget.id !== 'custom'\">\n                                    <span class=\"ProjectSnapshotCard-type-price-value-item\">\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.selectedBudget.min_sum }}<span ng-if=\"ProjectSummary.projectData.project.selectedBudget.max_sum === null\">+</span>\n                                        <span ng-if=\"ProjectSummary.projectData.project.selectedBudget.max_sum !== null\">\n                                            - {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.selectedBudget.max_sum }}\n                                        </span>\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.code }} per hour\n                                    </span>\n                                </div>\n                                <div class=\"ProjectSnapshotCard-type-price-value\" ng-if=\"ProjectSummary.projectData.project.selectedBudget.id === 'custom'\">\n                                    <span class=\"ProjectSnapshotCard-type-price-value-item\">\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.customMinBudget }} -\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.customMaxBudget }}\n                                        {{ ProjectSummary.projectData.project.selectedCurrency.code }} per hour\n                                    </span>\n                                </div>\n                            </div>\n                            <div class=\"ProjectSnapshotCard-type-price\" ng-if=\"ProjectSummary.projectData.contestMode\">\n                                {{ ProjectSummary.projectData.project.selectedCurrency.sign }}{{ ProjectSummary.projectData.project.prize }} {{ ProjectSummary.projectData.project.selectedCurrency.code }}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"ProjectSnapshotCard-body\">\n                <h3 class=\"ProjectSnapshotCard-title\">{{ ProjectSummary.projectData.project.project_name }}</h3>\n                <p class=\"ProjectSnapshotCard-desc\">{{ ProjectSummary.projectData.project.description }}</p>\n                <ul class=\"ProjectSnapshotCard-tags\">\n                    <li class=\"ProjectSnapshotCard-tags-item\" ng-repeat=\"skillTag in ProjectSummary.projectData.project.selectedSkills\">\n                        <span class=\"SkillTag\">{{ skillTag.name }}</span>\n                    </li>\n                </ul>\n                <ul class=\"ProjectSnapshotCard-promotions\" ng-if=\"ProjectSummary.projectData.project.selectedUpgrade === 'advanced' && ProjectSummary.UpgradesService.selectedAdvancedUpgrades.length > 0 && !ProjectSummary.projectData.contestMode\">\n                    <li class=\"ProjectSnapshotCard-promotions-item\" ng-repeat=\"upgrade in ProjectSummary.UpgradesService.selectedAdvancedUpgrades\">\n                        <span class=\"promotion-tag has-no-icon\"\n                            ng-class=\"{'promotion-featured': upgrade === 'featured',\n                            'promotion-private': upgrade === 'private',\n                            'promotion-assisted': upgrade === 'recruiter',\n                            'promotion-nda': upgrade === 'nda',\n                            'promotion-urgent': upgrade === 'urgent'}\">{{ upgrade }}</span>\n                    </li>\n                </ul>\n                <ul class=\"ProjectSnapshotCard-promotions\" ng-if=\"ProjectSummary.projectData.project.selectedUpgrade === 'recruiter' && ProjectSummary.UpgradesService.selectedAdvancedUpgrades.length === 0 && !ProjectSummary.projectData.contestMode\">\n                    <li class=\"ProjectSnapshotCard-promotions-item\">\n                        <span class=\"promotion-tag has-no-icon promotion-assisted\">Recruiter</span>\n                    </li>\n                </ul>\n\n                <!-- T133576: Project management bundle AB test. -->\n                <ul class=\"ProjectSnapshotCard-promotions\" ng-if=\"ProjectSummary.projectData.project.selectedUpgrade === 'project_management_bundle' && ProjectSummary.UpgradesService.selectedAdvancedUpgrades.length === 0 && !ProjectSummary.projectData.contestMode\">\n                    <li class=\"ProjectSnapshotCard-promotions-item\">\n                        <span class=\"promotion-tag has-no-icon promotion-assisted\">Recruiter</span>\n                    </li>\n                    <li class=\"ProjectSnapshotCard-promotions-item\">\n                        <span class=\"promotion-tag has-no-icon promotion-project-management\">Technical Co-Pilot</span>\n                    </li>\n                </ul>\n\n                <ul class=\"ProjectSnapshotCard-promotions\" ng-if=\"ProjectSummary.projectData.project.selectedContestUpgrade === 'advanced' && ProjectSummary.ContestUpgradesService.selectedAdvancedUpgrades.length > 0 && ProjectSummary.projectData.contestMode\">\n                    <li class=\"ProjectSnapshotCard-promotions-item\" ng-if=\"ProjectSummary.projectData.project.selectedContestUpgrade === 'guaranteed'\">\n                        <span class=\"promotion-tag has-no-icon promotion-guaranteed\">Guaranteed</span>\n                    </li>\n                    <li class=\"ProjectSnapshotCard-promotions-item\" ng-repeat=\"upgrade in ProjectSummary.ContestUpgradesService.selectedAdvancedUpgrades\">\n                        <span class=\"promotion-tag has-no-icon\"\n                            ng-class=\"{'promotion-guaranteed': upgrade === 'contest_type',\n                            'promotion-featured': upgrade === 'featured',\n                            'promotion-topContest': upgrade === 'topContest',\n                            'promotion-highlight': upgrade === 'highlight',\n                            'promotion-sealed': upgrade === 'sealed',\n                            'promotion-nda': upgrade === 'nda',\n                            'promotion-private': upgrade === 'private',\n                            'promotion-urgent': upgrade === 'urgent'}\">{{ upgrade === 'contest_type' ? 'Guaranteed' : upgrade  }}</span>\n                    </li>\n                </ul>\n                <ul class=\"ProjectSnapshotCard-promotions\" ng-if=\"ProjectSummary.projectData.project.selectedContestUpgrade === 'guaranteed' && !ProjectSummary.projectData.project.contestUpgrades.urgent.checked && ProjectSummary.projectData.contestMode\">\n                    <li class=\"ProjectSnapshotCard-promotions-item\">\n                        <span class=\"promotion-tag has-no-icon promotion-guaranteed\">Guaranteed</span>\n                    </li>\n                </ul>\n                <ul class=\"ProjectSnapshotCard-promotions\" ng-if=\"ProjectSummary.projectData.project.selectedContestUpgrade !== 'advanced' && ProjectSummary.projectData.project.contestUpgrades.urgent.checked && ProjectSummary.projectData.contestMode\">\n                    <li class=\"ProjectSnapshotCard-promotions-item\">\n                        <span class=\"promotion-tag has-no-icon promotion-guaranteed\">Guaranteed</span>\n                    </li>\n                    <li class=\"ProjectSnapshotCard-promotions-item\">\n                        <span class=\"promotion-tag has-no-icon promotion-urgent\">Urgent</span>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </fieldset>\n</div>\n";

var flProjectSummary = function flProjectSummary(Cdn, ProjectData, UpgradesService, ContestUpgradesService) {
  _classCallCheck(this, flProjectSummary);

  this.Cdn = Cdn;
  this.projectData = ProjectData;
  this.UpgradesService = UpgradesService;
  this.ContestUpgradesService = ContestUpgradesService;
};

flProjectSummary.$inject = ['Cdn', 'ProjectData', 'UpgradesService', 'ContestUpgradesService'];

var flProjectSummary$1 = flComponent$1(flProjectSummary, {
  selector: 'fl-project-summary',
  transclude: true,
  template: template$7,
  bindings: {},
  providers: [CdnProvider, ProjectDataProvider, UpgradesServiceProvider, ContestUpgradesServiceProvider]
});

var ToggleWizardNext = function () {
  function ToggleWizardNext(ProjectData, WizardService) {
    _classCallCheck(this, ToggleWizardNext);

    this.projectData = ProjectData;
    this.WizardService = WizardService;
  }

  _createClass(ToggleWizardNext, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var step = attr.flToggleWizardNext;
      this.WizardService.steps[step].validate = function () {
        return _this.validate(step, ngModel);
      };
      this.WizardService.steps[step].validateSubmit = function () {
        return _this.validateSubmit(step, ngModel);
      };
      scope.$watchCollection(function () {
        return ngModel.$valid;
      }, function () {
        _this.toggleButton(step, ngModel);
      });
    }
  }, {
    key: 'toggleButton',
    value: function toggleButton(step, ngModel) {
      this.WizardService.steps[step].valid = this.validate(step, ngModel);
    }
  }, {
    key: 'validate',
    value: function validate(step, ngModel) {
      if (step === 'title') {
        return this.validateTitle(ngModel);
      }

      if (step === 'contestDurationType') {
        return this.validateContestDuration(ngModel);
      }

      return ngModel.$valid;
    }
  }, {
    key: 'validateSubmit',
    value: function validateSubmit(step, ngModel) {
      return ngModel.$valid;
    }
  }, {
    key: 'validateTitle',
    value: function validateTitle(ngModel) {
      return ngModel.$validators.minlength(ngModel.$modelValue, ngModel.$viewValue) && ngModel.$validators.maxlength(ngModel.$modelValue, ngModel.$viewValue) && ngModel.$validators.containsContactDetails(ngModel.$viewValue);
    }
  }, {
    key: 'validateContestDuration',
    value: function validateContestDuration(ngModel) {
      if (ngModel.$viewValue === 'nonurgent') {
        ngModel.$valid = this.projectData.project.contest_length >= 3 && this.projectData.project.contest_length <= 30;
      }
      return ngModel.$valid;
    }
  }]);

  return ToggleWizardNext;
}();

ToggleWizardNext.$inject = ['ProjectData', 'WizardService'];

var flToggleWizardNext = flDirective$1(ToggleWizardNext, {
  selector: '[fl-toggle-wizard-next]',
  require: 'ngModel',
  providers: [ProjectDataProvider, WizardServiceProvider]
});

var template$8 = "<div class=\"Modal\" ng-class=\"UiModal.modalProps.classes\">\n  <div class=\"Modal-inner\" outbounds=\"true\">\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <fl-compiled bind-html-compile=\"{[{UiModal.bodyTemplate}]}\"></fl-compiled>\n      </div>\n      <fl-compiled ng-if=\"UiModal.shadowFooterTemplate\" bind-html-compile=\"{[{UiModal.shadowFooterTemplate}]}\"></fl-compiled>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var Compiled = function () {
  function Compiled($scope, $element, $attrs, $compile) {
    _classCallCheck(this, Compiled);

    this.$compile = $compile;
    this.scope = $scope;
    this.element = $element;
    this.attrs = $attrs;
  }

  _createClass(Compiled, [{
    key: '$postLink',
    value: function $postLink() {
      var _this = this;

      this.scope.$watch(function () {
        return _this.attrs.bindHtmlCompile;
      }, function (value) {
        _this.element.html(value && value.toString());
        var compileScope = _this.scope.$parent;
        _this.$compile(_this.element.contents())(compileScope);
      });
    }
  }]);

  return Compiled;
}();

Compiled.$inject = ['$scope', '$element', '$attrs', '$compile'];

var flCompiled = flComponent$1(Compiled, {
  selector: 'fl-compiled'
});

var Modal = function () {
  function Modal($scope, $element, $document) {
    var _this = this;

    _classCallCheck(this, Modal);

    this.scope = $scope;
    if ($element.length) {
      this.element = $element[0];
    } else {
      this.element = $element;
    }
    if ($document.length) {
      this.body = $document[0].body;
    } else {
      this.body = $document.body;
    }
    this.bodyTemplate = '<' + this.modalSelector + ' ' + 'modal-props="UiModal.modalProps" ' + 'modal-visible="UiModal.modalVisible">' + ('</' + this.modalSelector + '>');

    this.shadowFooterTemplate = this.modalShadowFooterSelector ? '<' + this.modalShadowFooterSelector + ' ' + 'modal-props="UiModal.modalProps" ' + 'modal-visible="UiModal.modalVisible">' + ('</' + this.modalShadowFooterSelector + '>') : null;

    this.element.addEventListener('click', function (event) {
      if (event.target.hasAttribute('outbounds')) {
        _this.backdropClicked();
      }
    });

    document.addEventListener('keydown', function (event) {
      // keydown on Esc key
      if (event.which === 27) {
        event.preventDefault();
        _this.backdropClicked();
      }
    });
  }

  _createClass(Modal, [{
    key: '$postLink',
    value: function $postLink() {
      this.body.appendChild(this.element);
    }
  }, {
    key: 'backdropClicked',
    value: function backdropClicked() {
      if (typeof this.modalProps.onBackdropClick === 'function') {
        this.modalProps.onBackdropClick();
      }
      if (!this.modalProps.disableBackdropClose) {
        this.modalVisible = false;
        this.scope.$apply();
      }
    }
  }]);

  return Modal;
}();

Modal.$inject = ['$scope', '$element', '$document'];

var flUiModalProvider = flComponent$1(Modal, {
  selector: 'fl-ui-modal',
  template: template$8,
  bindings: {
    modalSelector: '=',
    modalShadowFooterSelector: '=',
    modalVisible: '=',
    modalProps: '='
  },
  providers: [flCompiled]
});

angular.module('ui.bootstrap.modal', ["template/modal/backdrop.html", "template/modal/window.html"])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
.factory('$$stackedMap', function () {
  return {
    createNew: function createNew() {
      var stack = [];

      return {
        add: function add(key, value) {
          stack.push({
            key: key,
            value: value
          });
        },
        get: function get(key) {
          for (var i = 0; i < stack.length; i++) {
            if (key == stack[i].key) {
              return stack[i];
            }
          }
        },
        keys: function keys() {
          var keys = [];
          for (var i = 0; i < stack.length; i++) {
            keys.push(stack[i].key);
          }
          return keys;
        },
        top: function top() {
          return stack[stack.length - 1];
        },
        remove: function remove(key) {
          var idx = -1;
          for (var i = 0; i < stack.length; i++) {
            if (key == stack[i].key) {
              idx = i;
              break;
            }
          }
          return stack.splice(idx, 1)[0];
        },
        removeTop: function removeTop() {
          return stack.splice(stack.length - 1, 1)[0];
        },
        length: function length() {
          return stack.length;
        }
      };
    }
  };
})

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
.directive('modalBackdrop', ['$modalStack', '$timeout', function ($modalStack, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/modal/backdrop.html',
    link: function link(scope) {

      scope.animate = false;

      //trigger CSS transitions
      $timeout(function () {
        scope.animate = true;
      });

      scope.close = function (evt) {
        var modal = $modalStack.getTop();
        if (modal && modal.value.backdrop && modal.value.backdrop != 'static') {
          evt.preventDefault();
          evt.stopPropagation();
          $modalStack.dismiss(modal.key, 'backdrop click');
        }
      };
    }
  };
}]).directive('modalWindow', ['$timeout', function ($timeout) {
  return {
    restrict: 'EA',
    scope: {
      index: '@'
    },
    replace: true,
    transclude: true,
    templateUrl: 'template/modal/window.html',
    link: function link(scope, element, attrs) {
      scope.windowClass = attrs.windowClass || '';

      // focus a freshly-opened modal
      element[0].focus();

      $timeout(function () {
        // trigger CSS transitions
        scope.animate = true;
      });
    }
  };
}]).factory('$modalStack', ['$window', '$document', '$compile', '$rootScope', '$$stackedMap', function ($window, $document, $compile, $rootScope, $$stackedMap) {

  var OPENED_MODAL_CLASS = 'modal-open';
  var backdropjqLiteEl, backdropDomEl, scrollbarWidth, originalBodyPad, bodyIsOverflowing;
  var backdropScope = $rootScope.$new(true);
  var openedWindows = $$stackedMap.createNew();
  var $modalStack = {};

  function backdropIndex() {
    var topBackdropIndex = -1;
    var opened = openedWindows.keys();
    for (var i = 0; i < opened.length; i++) {
      if (openedWindows.get(opened[i]).value.backdrop) {
        topBackdropIndex = i;
      }
    }
    return topBackdropIndex;
  }

  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
    backdropScope.index = newBackdropIndex;
  });

  function removeModalWindow(modalInstance) {
    var body = $document.find('body').eq(0);
    var modalWindow = openedWindows.get(modalInstance).value;

    //clean up the stack
    openedWindows.remove(modalInstance);

    //remove window DOM element
    modalWindow.modalDomEl.remove();
    body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);

    //remove backdrop if no longer needed
    if (backdropDomEl && backdropIndex() == -1) {
      backdropDomEl.remove();
      backdropDomEl = undefined;
    }

    //destroy scope
    modalWindow.modalScope.$destroy();
  }

  /**
   * Checks if scrollbar is visible.
   * Ported from the bootstrap v3.3.6.
   */
  function checkScrollbar() {
    var body = $document.find('body').eq(0);
    var fullWindowWidth = $window.innerWidth;

    bodyIsOverflowing = body[0].clientWidth < fullWindowWidth;
    scrollbarWidth = measureScrollbar();
  }

  /**
   * Sets the scrollbar padding offset on the body element.
   * Ported from the bootstrap v3.3.6.
   */
  function setScrollbar() {
    var body = $document.find('body').eq(0);
    var bodyPad = parseInt(body.css('padding-right') || 0, 10);

    originalBodyPad = body.css('padding-right') || '';

    if (bodyIsOverflowing) {
      body.css('padding-right', bodyPad + scrollbarWidth + 'px');
    }
  }

  /**
   * Resets the padding on the body to the way it was with the scrollbar.
   * Ported from the bootstrap v3.3.6.
   */
  function resetScrollbar() {
    var body = $document.find('body').eq(0);

    body.css('padding-right', originalBodyPad);
  }

  /**
   * Measures the width of the scrollbar.
   * Ported from the bootstrap v3.3.6.
   */
  function measureScrollbar() {
    var body = $document.find('body').eq(0);
    var scrollDiv = angular.element('<div></div>');
    scrollDiv.addClass('js-modal-scrollbar-measure');
    scrollDiv.css({
      'position': 'absolute',
      'overflow': 'scroll',
      'top': '-9999px',
      'width': '100px',
      'height': '100px'
    });

    body.append(scrollDiv);
    var scrollbarWidth = scrollDiv[0].offsetWidth - scrollDiv[0].clientWidth;
    body.find('.js-modal-scrollbar-measure').remove();
    return scrollbarWidth;
  }

  $document.bind('keydown', function (evt) {
    var modal;

    if (evt.which === 27) {
      modal = openedWindows.top();
      if (modal && modal.value.keyboard) {
        $rootScope.$apply(function () {
          $modalStack.dismiss(modal.key);
        });
      }
    }
  });

  $modalStack.open = function (modalInstance, modal) {

    checkScrollbar();
    setScrollbar();

    openedWindows.add(modalInstance, {
      deferred: modal.deferred,
      modalScope: modal.scope,
      backdrop: modal.backdrop,
      keyboard: modal.keyboard,
      container: modal.container
    });

    var body = $document.find('body').eq(0);
    var container = $document.find(modal.container).eq(0);

    if (backdropIndex() >= 0 && !backdropDomEl) {
      backdropjqLiteEl = angular.element('<div modal-backdrop></div>');
      backdropDomEl = $compile(backdropjqLiteEl)(backdropScope);
      container.append(backdropDomEl);
    }

    var angularDomEl = angular.element('<div modal-window></div>');
    angularDomEl.attr('window-class', modal.windowClass);
    angularDomEl.attr('index', openedWindows.length() - 1);
    angularDomEl.html(modal.content);
    var modalDomEl = $compile(angularDomEl)(modal.scope);
    openedWindows.top().value.modalDomEl = modalDomEl;
    container.append(modalDomEl);
    body.addClass(OPENED_MODAL_CLASS);
  };

  $modalStack.close = function (modalInstance, result) {
    var modal = openedWindows.get(modalInstance);
    if (modal) {
      modal.value.deferred.resolve(result);
      removeModalWindow(modalInstance);
    }
    resetScrollbar();
  };

  $modalStack.dismiss = function (modalInstance, reason) {
    var modalWindow = openedWindows.get(modalInstance).value;
    if (modalWindow) {
      modalWindow.deferred.reject(reason);
      removeModalWindow(modalInstance);
    }
    resetScrollbar();
  };

  $modalStack.getTop = function () {
    return openedWindows.top();
  };

  return $modalStack;
}]).provider('$modal', function () {

  var $modalProvider = {
    options: {
      backdrop: true, //can be also false or 'static'
      container: 'body',
      keyboard: true
    },
    $get: ['$injector', '$rootScope', '$q', '$http', '$templateRequest', '$controller', '$modalStack', function ($injector, $rootScope, $q, $http, $templateRequest, $controller, $modalStack) {

      var $modal = {};

      function getTemplatePromise(options) {
        return options.template ? $q.when(options.template) : $templateRequest(options.templateUrl);
      }

      function getResolvePromises(resolves) {
        var promisesArr = [];
        angular.forEach(resolves, function (value, key) {
          if (angular.isFunction(value) || angular.isArray(value)) {
            promisesArr.push($q.when($injector.invoke(value)));
          }
        });
        return promisesArr;
      }

      $modal.open = function (modalOptions) {

        var modalResultDeferred = $q.defer();
        var modalOpenedDeferred = $q.defer();

        //prepare an instance of a modal to be injected into controllers and returned to a caller
        var modalInstance = {
          result: modalResultDeferred.promise,
          opened: modalOpenedDeferred.promise,
          close: function close(result) {
            $modalStack.close(modalInstance, result);
          },
          dismiss: function dismiss(reason) {
            $modalStack.dismiss(modalInstance, reason);
          }
        };

        //merge and clean up options
        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
        modalOptions.resolve = modalOptions.resolve || {};

        //verify options
        if (!modalOptions.template && !modalOptions.templateUrl) {
          throw new Error('One of template or templateUrl options is required.');
        }

        var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));

        templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {

          var modalScope = (modalOptions.scope || $rootScope).$new();
          modalScope.$close = modalInstance.close;
          modalScope.$dismiss = modalInstance.dismiss;

          var ctrlInstance,
              ctrlLocals = {};
          var resolveIter = 1;

          //controllers
          if (modalOptions.controller) {
            ctrlLocals.$scope = modalScope;
            ctrlLocals.$modalInstance = modalInstance;
            angular.forEach(modalOptions.resolve, function (value, key) {
              ctrlLocals[key] = tplAndVars[resolveIter++];
            });

            ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
          }

          $modalStack.open(modalInstance, {
            scope: modalScope,
            deferred: modalResultDeferred,
            content: tplAndVars[0],
            backdrop: modalOptions.backdrop,
            keyboard: modalOptions.keyboard,
            windowClass: modalOptions.windowClass,
            container: modalOptions.container
          });
        }, function resolveError(reason) {
          modalResultDeferred.reject(reason);
        });

        templateAndResolvePromise.then(function () {
          modalOpenedDeferred.resolve(true);
        }, function () {
          modalOpenedDeferred.reject(false);
        });

        return modalInstance;
      };

      return $modal;
    }]
  };

  return $modalProvider;
});

angular.module("template/modal/backdrop.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/backdrop.html", "<div class=\"modal-backdrop fade\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1040 + index*10}\" ng-click=\"close($event)\"></div>");
}]);

angular.module("template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("template/modal/window.html", "<div tabindex=\"-1\" class=\"modal fade {{ windowClass }}\" ng-class=\"{in: animate}\" ng-style=\"{'z-index': 1050 + index*10}\" ng-transclude></div>");
}]);

var uiModal = angular$1.module('ui.bootstrap.modal.es6', ['ui.bootstrap.modal', 'template/modal/backdrop.html', 'template/modal/window.html']).name;

/**
* @ngdoc service
* @name flApi.GafInterceptor
* @description
*
* HTTP Interceptor for most GAF endpoints.

* DO NOT MODIFY THAT INTERCEPTOR.
* If you need to deal with an endpoint in GAF which behaves differently than
* the others, use a custom interceptor like the HourlyContract service:
*
*```
*    const customInterceptor = {
*      request: GafInterceptor.request,
*
*      response: function(response) {
*        return $q.when(GafInterceptor.response(response))
*        .then(function(data) {
*          return data.message;
*        });
*      },
*
*      responseError: function(response) {
*        switch(response.status) {
*          case 403:
*            response.code = 'CREDENTIAL_ERROR';
*            break;
*          case 400:
*            response.code = 'BAD_REQUEST';
*            break;
*          default:
*            response.code = 'UNKNOWN_ERROR';
*            break;
*        }
*        return $q.reject(response);
*      }
*    };
*```
*
* Note how the request method of the GafInterceptor is reused since only the
* response is different here. In doubt, ask for advices on the Angular HipChat
* channel.
*/

var GafInterceptor = function GafInterceptor($q, RequestTransformation) {
  _classCallCheck(this, GafInterceptor);

  return {
    /**
     * @ngdoc method
     * @name flApi.GafInterceptor#request
     * @methodOf flApi.GafInterceptor
     *
     * @description
     * Url Form encode the HTTP requests
     * ('application/x-www-form-urlencoded')
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.transformRequest = [];
      config.data = RequestTransformation.formUrlEncodedRecursive(config.data);
      return config;
    },
    /**
     * @ngdoc method
     * @name flApi.GafInterceptor#response
     * @methodOf flApi.GafInterceptor
     *
     * @description
     * Unpack the response from some of the GAF endpoint.
     * DO NOT EXTEND THAT BOOLEAN EXPRESSION. This is very ugly and will be
     * removed at some point. Write you own interceptor like the
     * HourlyContract service if needed
     *
     * @param {Object} response The content of the response.
     * @returns {Object} The object received as a parameter,
     * eventually modified.
     */
    response: function response(_response) {
      if (_response.data && (_response.data === 'success' || _response.data === 'true' || _response.data.success === true || _response.data.status === 'success' || _response.data.status === true)) {
        if (_response.data.data) {
          _response.data = _response.data.data;
        }
      } else {
        _response.defaultError = 'Internal error, please try again later.';
        return $q.reject(_response);
      }
      return _response.data;
    }
  };
};

GafInterceptor.$inject = ['$q', 'RequestTransformation'];


var GafInterceptorProvider = flService('GafInterceptor', [RequestTransformationProvider], GafInterceptor);

var User = function () {
  function User(user, Cdn, DEFAULT_AVATAR_URL, Currencies) {
    _classCallCheck(this, User);

    this.user = user;
    this.Cdn = Cdn;
    this.Currencies = Currencies;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
  }

  _createClass(User, [{
    key: 'canBeQuickHiredBy',
    value: function canBeQuickHiredBy(otherUser) {
      // A user can only be quick hired if that user is a freelancer (or
      // 'both'), and the other user is an employer (or 'both').
      var freelancerRoles = ['freelancer', 'both'];
      var employerRoles = ['employer', 'both'];

      return freelancerRoles.indexOf(this.getRole()) !== -1 && employerRoles.indexOf(otherUser.getRole()) !== -1;
    }
  }, {
    key: 'get',
    value: function get() {
      return this.user;
    }
  }, {
    key: 'getAvatarUrl',
    value: function getAvatarUrl() {
      if (this.user && this.user.avatar) {
        return this.Cdn.getCdnUrl(this.user.avatar);
      }

      // Fallback as sometimes user object is malformed at times
      return this.Cdn.getCdnUrl(this.DEFAULT_AVATAR_URL);
    }
  }, {
    key: 'getPrimaryCurrency',
    value: function getPrimaryCurrency() {
      return this.Currencies.currencyFactory(this.user.primary_currency);
    }
  }, {
    key: 'getBalanceForCurrency',
    value: function getBalanceForCurrency(currencyId) {
      var result = void 0;

      angular$1.forEach(this.user.account_balances.balances, function (balance) {
        if (balance.currency.id === parseInt(currencyId, 10)) {
          result = balance;
        }
      });

      return result;
    }
  }, {
    key: 'getRole',
    value: function getRole() {
      // Before a user bids or posts a project, their role type is
      // completely wrong. It doesn't just contain an inaccurate value, it
      // contains a value that doesn't make any sense what so ever. I'm
      // talking like apostrophe's in the db. APOSTROPHES. YES.
      //
      // That a side, even when the user has the role specified, it may be
      // inaccurate if it set to 'freelancer'. So if the role is
      // freelancer, AND their self chosen role is set AND is set to a
      // different value, we will assume their self chosen role is
      // correct, and use that.
      var role = this.user.role;
      var chosenRole = this.user.chosen_role;

      if (role === 'freelancer' && role !== chosenRole && chosenRole) {
        role = chosenRole;
      }
      return role;
    }
  }, {
    key: 'set',
    value: function set(updatedUser) {
      angular$1.extend(this.user, updatedUser);
    }
  }]);

  return User;
}();

var UserList = function () {
  function UserList(users, searchTotal, order, Cdn, DEFAULT_AVATAR_URL, Currencies) {
    _classCallCheck(this, UserList);

    this.users = users;
    this.searchTotal = searchTotal;
    this.order = order;
    this.Cdn = Cdn;
    this.Currencies = Currencies;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
  }

  _createClass(UserList, [{
    key: 'getMap',
    value: function getMap() {
      return this.users;
    }
  }, {
    key: 'getList',
    value: function getList() {
      var _this = this;

      if (angular$1.isUndefined(this.list)) {
        this.list = [];
        this.order.forEach(function (id) {
          _this.list.push(_this.users[id]);
        });
      }

      return this.list;
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      if (angular$1.isDefined(this.users[id])) {
        return new User(this.users[id], this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
      }
      return undefined;
    }
  }, {
    key: 'getCount',
    value: function getCount() {
      return this.getList().length;
    }
  }, {
    key: 'getSearchTotal',
    value: function getSearchTotal() {
      if (angular$1.isDefined(this.searchTotal) && this.searchTotal !== null) {
        return this.searchTotal;
      }
      return undefined;
    }
  }]);

  return UserList;
}();

/**
 * @ngdoc service
 * @name flApi.Users
 *
 * @description
 * A factory which creates a convenient service for interacting with
 * Users API.
 */


var Users = function () {
  function Users($q, Auth, Cdn, Currencies, flResource, ApiInterceptor, GafInterceptor, API_BASE_URL, GAF_BASE_URL, DEFAULT_AVATAR_URL) {
    _classCallCheck(this, Users);

    this.Cdn = Cdn;
    this.$q = $q;
    this.Auth = Auth;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
    this.Currencies = Currencies;

    this.Users = flResource(API_BASE_URL + '/users/0.1/users/:userId/', ApiInterceptor, null, {
      get: {
        cache: true
      },
      getList: {
        url: API_BASE_URL + '/users/0.1/users/'
      },
      getDirectory: {
        url: API_BASE_URL + '/users/0.1/users/directory/'
      },
      getSelf: {
        url: API_BASE_URL + '/users/0.1/users/self/'
      },
      updateUserInfo: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/users/self/'
      },
      setJobs: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/self/jobs/'
      },
      setLocation: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/self/location/'
      },
      check: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/users/check/'
      },
      sendPhoneVerification: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/phone_verifications/'
      },
      submitPhoneVerification: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/phone_verifications/'
      },
      alertBoxClose: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/alertbox_dont_show_next_time.php',
        interceptor: GafInterceptor
      },
      search: {
        url: API_BASE_URL + '/users/0.1/users/directory/'
      },
      deprecatedSearch: {
        url: GAF_BASE_URL + '/ajax/directory/getFreelancer.php',
        interceptor: GafInterceptor
      },
      deprecatedSearchWithPayload: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/directory/getFreelancer.php',
        interceptor: GafInterceptor
      },
      getProfile: {
        url: GAF_BASE_URL + '/ajax/getUserProfileData.php',
        interceptor: GafInterceptor
      },
      setProfile: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/users/self/account'
      },
      setPhoneNumber: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/signup/register.php',
        interceptor: GafInterceptor
      },
      getPortfolios: {
        url: API_BASE_URL + '/users/0.1/portfolios/',
        interceptor: GafInterceptor
      },
      isReferralInvitationsEligible: {
        method: 'GET',
        url: API_BASE_URL + '/users/0.1/referral_invitations/check/'
      },
      getReferralInvitationsList: {
        method: 'GET',
        url: API_BASE_URL + '/users/0.1/referral_invitations/'
      },
      createReferralInvitation: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/referral_invitations/'
      }
    });

    this.FBUsers = flResource(API_BASE_URL + '/users/0.1/users/facebook/', ApiInterceptor, null, {
      link: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/users/facebook/link/'
      }
    });
  }

  /**
   * @ngdoc method
   * @name flApi.Users#userFactory
   * @methodOf flApi.Users
   *
   * @description
   * A factory that generates User objects
   *
   * @returns {Object} The returned User object exposes 5 methods:
   *
   * - canBeQuickHiredBy(user) Checks if the given user can hire the current
   *   user. returns true iff the current user role is either 'freelancer'
   *   or 'both', AND the other users role is either 'employer' or 'both'.
   * - get() returns the raw user information
   * - getAvatarUrl() returns the users avatar url
   * - getPrimaryCurrency() returns the users primary currency
   * - getBalanceForCurrency() returns the user's balance for for specific
   *   currency id
   * - getRole() returns the users role (freelancer/employer/both). This
   *   function takes into account the users 'role' and their 'chosen role'.
   * - set(updatedUser) extends the user object with the specified
   *   parameters
   */


  _createClass(Users, [{
    key: 'userFactory',
    value: function userFactory(u) {
      return new User(u, this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#userListFactory
    * @methodOf flApi.Users
    *
    * @description
    * A factory that generated UserList objects
    *
    * @param {Object} users An object containing a map of users
    * @param {Number} [searchTotal] Total number of users matching the search
    * criteria, see Users.search()
    * @param {Array} [order] List of user ids in specific order; if specified,
    * affects the order returned by userListFactory.getList()
    * @returns {Object} The returned UserList object exposes 4 methods:
    *
    * - getMap() returns the raw object of users
    * - getList() returns a list of user objects NOTE: the ordering of users
    *   is undefined. If you need it to be ordered, you will need to order it
    *   yourself.
    * - getById(id) returns the user object, given a userId
    * - getCount() returns the number of users
    * - getSearchTotal() for search, Users.search(), this returns the total
    *   number of users matching the search criteria; otherwise this will
    *   be undefined
    */

  }, {
    key: 'userListFactory',
    value: function userListFactory(users, searchTotal) {
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.keys(users);

      return new UserList(users, searchTotal, order, this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#get
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a list of parameters
    *
    * @param {Object} params list of parameters for the requested user.
    * Possible values are:
    *
    * - users[] – Optional list of user IDs to search on.
    * - usernames[] – Optional list of usernames
    * - avatar – Return avatar for each user.
    * - reputation – Return freelancer reputation for each user.
    * - reputation_extra – Return full freelancer reputation info
    * - (jobhistory/projstats).
    * - employer_reputation – Return employer reputation for each user.
    * - employer_reputation_extra – Return full employer reputation info
    * - (jobhistory/projstats).
    * - country_details – Return country flag/code for each user.
    * - profile_description – Return user’s profile blurb
    * - display_info – Return user’s profile name/tagline
    * - jobs – Return jobs (i.e. skills) that the user currently has
    * - status – Return additional status info about user (see UserStatus).
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'get',
    value: function get(params) {
      var _this2 = this;

      return this.Users.get(params).$promise.then(function (user) {
        return _this2.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getDirectory
    * @methodOf flApi.Users
    *
    * @description
    * Get list of freelancers from directory. This method calls the
    * GET /api/users/0.1/users/directory/ endpoint, documented here:
    * https://rtfm.freelancer.com/rtfm/flapi-rest-docs/users_api_0_1.html
    * #get--api-users-0.1-users-directory-
    *
    * @param {Object} params list of parameters for the requested user.
    * Possible values are:
    *
    * - jobs[] – A list of job ids to search for
    * - countries[] – A list of country names to fetch freelancers from.
    * - username – The username of a freelancer to fetch
    * - hourly_rate_min – The minimum hourly rate of freelancers fetched.
    * - hourly_rate_max – The maximum hourly rate of freelancers fetched.
    * - online_only – Only fetch freelancers who are online.
    * - location_latitude – Fetch freelancers close to this latitude
    * - location_longitude – Fetch freelancers close to this longitude
    * - insignias[] – Fetch freelancers who have completed exams with these id
    * - rating – Search for freelancers with a minimum star rating
    * - offset – A pagination offset when fetching the list of users
    * - limit – The number of users to return in the list. Default is 10
    *
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getDirectory',
    value: function getDirectory(params) {
      var _this3 = this;

      return this.Users.getDirectory(params).$promise.then(function (users) {
        return _this3.userListFactory(users);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getByUserId
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a specific user id and a list of parameters
    *
    * @param {Number} userId the id of the user you want to get
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getByUserId',
    value: function getByUserId(userId, params) {
      var p = params || {};
      p.userId = userId;

      return this.get(p);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getByUsername
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a specific username and a list of parameters
    *
    * @param {String} username the username of the user you want to get
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getByUsername',
    value: function getByUsername(username, params) {
      var _this4 = this;

      var p = params || {};
      p['usernames[]'] = [username];

      return this.Users.get(params).$promise.then(function (response) {
        if (Object.keys(response.users).length) {
          return _this4.userFactory(response.users[Object.keys(response.users)[0]]);
        }

        return _this4.$q.reject({
          code: 'NOT_FOUND'
        });
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getLoggedInUser
    * @methodOf flApi.Users
    *
    * @description
    * Get user info for current user
    *
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getLoggedInUser',
    value: function getLoggedInUser(params) {
      var _this5 = this;

      return this.Users.getSelf(params).$promise.then(function (user) {
        return _this5.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getList
    * @methodOf flApi.Users
    *
    * @description
    * Returns list of users. As per the api, users[] or usernames[] must be
    * provided.
    *
    * @param {Object} params An object containing a set of query parameters
    * that will be used as search criteria. Possible values for params are:
    *
    * - users[]: the ids of specific users
    * - usernames[]: the usernames of specific users
    * @returns {Object} A userList object generated by userListFactory
    */

  }, {
    key: 'getList',
    value: function getList(params) {
      var _this6 = this;

      return this.Users.getList(params).$promise.then(function (result) {
        return _this6.userListFactory(result.users);
      });
    }
    /**
    * @ngdoc method
    * @name flApi.Users#getPortfolios
    * @methodOf flApi.Users
    *
    * @description
    * Returns list of users and portfolios. As per the api, users[] must be
    * provided.
    *
    * @param {Object} params An object containing a set of query parameters
    * that will be used as search criteria. Possible values for params are:
    *
    * - users[]: the ids of specific users
    * - limit
    * - offset
    * @returns {Object} portfolio and users object.
    */

  }, {
    key: 'getPortfolios',
    value: function getPortfolios() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.Users.getPortfolios(params).$promise.then(function (response) {
        return response.result;
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#create
    * @methodOf flApi.Users
    *
    * @description
    * Sign up a new user and logs in
    *
    * @param {Object} user an object containing info about the user to create
    * e.g. user.id, user.avatar etc...
    * @param {String} password the password for this user
    * @param {String} captcha captcha string
    * @param {Object} extra extra information for signup, either only used
    *                       temporarily and removed later or eventually move
    *                       to signupMeta.
    * @param {Object} signupMeta Information for Signup that we know is
    *                            used for signup
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or a String in case of error, with one
    * of the following values (quite self-explanatory):
    *
    * - CAPTCHA_REQUIRED
    * - INVALID_CAPTCHA
    * - USERNAME_TAKEN
    * - EMAIL_TAKEN
    */

  }, {
    key: 'create',
    value: function create(user, password, captcha) {
      var _this7 = this;

      var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var signupMeta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

      var newUser = {
        user: {
          email: user.email,
          username: user.username,
          role: user.role
        },
        password: password,
        captcha: captcha || {},
        extra: extra,
        signup_meta: signupMeta
      };

      return this.Users.save(newUser).$promise.then(function (data) {
        _this7.Auth.set(data.auth_hash, data.user.id, true);
        return _this7.userFactory(data.user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#createWithFacebook
    * @methodOf flApi.Users
    *
    * @description
    * Sign up a new user and logs in using facebook credentials
    *
    * @param {Object} user an object containing info about the user to create
    * e.g. user.id, user.avatar etc...
    * @param {String} facebookId the facebook id of the user
    * @param {String} accessToken the token used to authenticate the user
    * @param {Object} extra an object containing extra data to pass through API
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or a String in case of error
    */

  }, {
    key: 'createWithFacebook',
    value: function createWithFacebook(user, facebookAuthParams) {
      var _this8 = this;

      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var newUser = {
        user: {
          email: user.email,
          username: user.username,
          role: user.role
        },
        facebook_id: facebookAuthParams.userID,
        access_token: facebookAuthParams.accessToken,
        extra: extra
      };

      return this.FBUsers.save(newUser).$promise.then(function (data) {
        _this8.Auth.set(data.auth_hash, data.user.id, true);
        return _this8.userFactory(data.user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#linkFacebook
    * @methodOf flApi.Users
    *
    * @description
    * Link facebook account to existing user account. The user needs to be
    * logged in before calling this method.
    *
    * @param {String} email email address of user
    * @param {password} email password of user
    * @param {String} facebook_id the facebook id of the user
    * @param {String} access_token the token used to authenticate the user
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or an error object in case of error
    */

  }, {
    key: 'linkFacebook',
    value: function linkFacebook(facebookAuthParams) {
      var _this9 = this;

      var linkInfo = {
        facebook_id: facebookAuthParams.userID,
        access_token: facebookAuthParams.signedRequest
      };

      return this.FBUsers.link(linkInfo).$promise.then(function (user) {
        return _this9.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#check
    * @methodOf flApi.Users
    *
    * @description Check if the user's fields are valid for a user signup
    * request. Validated field are "username" and "email". Support a
    * "recommanded_name" param to get a suggested username based on a
    * submitted email/invalid username.
    *
    * @param {Object} user user object with "username" and/or "email" fields.
    * Checks each params individually.
    * @param {Object} params extra params. Only recommended_name is supported
    * for now, which gives back a recommended_name. The recommended username
    * is based off the email address when the email is valid, or based off
    * the username when the email is invalid
    */

  }, {
    key: 'check',
    value: function check(user, params) {
      var p = params || {};

      return this.Users.check(p, { user: user }).$promise.then(function (response) {
        return response;
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#updateUserInfo
     * @methodOf flApi.Users
     *
     * @description
     * Updates a user info given the action
     *
     * @param {String} Valid prams are [email_verify, local_jobs_enable,
     * local_email_subscribe, local_email_unsubscribe].
     */

  }, {
    key: 'updateUserInfo',
    value: function updateUserInfo(action) {
      return this.Users.updateUserInfo({ action: action }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setJobs
    * @methodOf flApi.Users
    *
    * @description
    * Updates ths skills for a logged in user
    *
    * @param {Object} jobs list(int) a list of job ids
    * ```
    *  {
    *    "jobs[]": [2, 3]
    *  }
    * ```
    */

  }, {
    key: 'setJobs',
    value: function setJobs(jobs) {
      return this.Users.setJobs({ 'jobs[]': jobs }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setLocation
    * @methodOf flApi.Users
    *
    * @description
    * Updates the location information for the logged in user.
    *
    * @param {Object} loc location object with the as followed:
    * ```
    *  {
    *    country: {
    *      name: 'Australia'
    *    },
    *    city: 'Sydney',
    *    latitude: -33.873651,
    *    longitude: 151.2068896,
    *    vicinity: 'Sydney',
    *    administrativeArea: 'Sydney',
    *    fullAddress: '42 Wallaby Way, Sydney, NSW, 2008, Australia'
    *  }
    * ```
    */

  }, {
    key: 'setLocation',
    value: function setLocation(loc) {
      return this.Users.setLocation({
        country: loc.country,
        city: loc.city,
        latitude: loc.latitude,
        longitude: loc.longitude,
        vicinity: loc.vicinity,
        administrative_area: loc.administrativeArea,
        full_address: loc.fullAddress
      }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#alertBoxClose
    * @methodOf flApi.Users
    *
    * @description
    * Adds an entry to alert_box_dont_show_next_time table which keeps track
    * of what alerts/messages the user encounters
    *
    * @param {String} event the name of the alert or event
    * @param {Number} eventId an id associated with the event such as a
    * project id
    * @param {Number} otherPartyId Optional an id associated with a secondary
    * party such as another user id
    *
    */

  }, {
    key: 'alertBoxClose',
    value: function alertBoxClose(event, eventId, otherPartyId) {
      return this.Users.alertBoxClose({
        event: event,
        event_id: eventId,
        otherparty_user_id: otherPartyId
      }).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users.
     *
     * @param {String} keyword Search filter to query by profile
     * description, username and jobs
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'search',
    value: function search(keywords) {
      var _this10 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.query = keywords;

      return this.Users.search(params).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.id] = user;
          order.push(user.id);
        });

        return _this10.userListFactory(users, result.total_count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users using the GAF endpoint.
     *
     * Taken from v1. This will be used by the search page when it is migrated
     * to ES6. At the moment, there are still some data missing from the Users
     * API, such as the top skills.
     *
     * This should be removed once the Users API and Search module have been
     * updated.
     *
     * @param {String} keywords A set of terms, space separated.
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'deprecatedSearch',
    value: function deprecatedSearch(keywords) {
      var _this11 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.freeSearch = keywords;

      return this.Users.deprecatedSearch(params).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.user_id] = user;
          order.push(user.user_id);
        });

        return _this11.userListFactory(users, result.count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users using the GAF endpoint.
     *
     * Taken from v1. This will be used by the search page when it is migrated
     * to ES6. At the moment, there are still some data missing from the Users
     * API, such as the top skills.
     *
     * This should be removed once the Users API and Search module have been
     * updated.
     *
     * This is different from `depracatedSearch` in a way that it uses the
     * POST method that allows us for more complex filtering.
     * This doesn't change the fact that the method is deprecated.
     *
     * @param {String} keywords A set of terms, space separated.
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @param {Object} payload A list of additional filters to be passed as
     * a POST payload for more complex search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'deprecatedSearchWithPayload',
    value: function deprecatedSearchWithPayload(keywords) {
      var _this12 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var body = payload || {};
      params.freeSearch = keywords;

      return this.Users.deprecatedSearchWithPayload(params, body).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.user_id] = user;
          order.push(user.user_id);
        });

        return _this12.userListFactory(users, result.count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#setPhoneNumber
     * @methodOf flApi.Users
     *
     * @description
     * Updates the phone number info for the logged in user.
     *
     * @param {Number} phone The phone number to be associated with the user.
     * @param {Number} timestamp The timestamp of expiry.
     * @param {String} token Sha1 generated token from phone, timestamp and
     * CSRF token.
     */

  }, {
    key: 'setPhoneNumber',
    value: function setPhoneNumber(phone, timestamp, token) {
      var _this13 = this;

      return this.Users.setPhoneNumber({
        tm: timestamp,
        ph: phone,
        t: token
      }).$promise
      // Assign error code when ajax endpoint returns error: invalid request
      .catch(function () {
        return _this13.$q.reject({
          code: 'LOCAL_BID_INVALID_REQUEST'
        });
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getProfile
    * @methodOf flApi.Users
    * @description
    * get the profile info for the logged in user.
    * @returns {Object} a Promise object that will be resolved with user
    * profile information.
    **/

  }, {
    key: 'getProfile',
    value: function getProfile() {
      return this.Users.getProfile().$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setProfile
    * @methodOf flApi.Users
    *
    * @description
    * Updates the profile info for the logged in user.
    *
    * @param {Object} name userData user profile information
    * fields to be updated
    * @returns {Object} a Promise object that will be resolved
    * with profile update success
    */

  }, {
    key: 'setProfile',
    value: function setProfile(userData) {
      return this.Users.setProfile({
        first_name: userData.firstname,
        last_name: userData.lastname,
        date_of_birth: userData.dateOfBirth,
        address1: userData.address1,
        city: userData.city,
        company: userData.company,
        zip: userData.zip,
        state_code: userData.state_code,
        timezone: userData.timezone,
        thm_session: userData.thm_session,
        token: userData.token
      }).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#sendPhoneVerification
     * @methodOf flApi.Users
     *
     * @description
     * Requests a verification code to be sent to a given phone number.
     *
     * @param {Object} params Query parameters.
     * @param {String} params.phone_number The phone number you wish to
     * verify.
     * @param {String} params.country_code The numeric code which is prefixed
     * to the phone number.
     * @param {String} params.operation The string enum of the type of
     * message you want to receive (either 'sms' or 'call').
     * @param {String} params.requested_country The string country code of
     * the phone's country.
     * @param {Boolean} params.request_phone_change Whether the user already
     * has a verified phone number.
     *
     * @returns {Object} a Promise object that will be resolved with a
     * boolean value 'reference_id', which is used by the phone verification
     * submit endpoint.
     */

  }, {
    key: 'sendPhoneVerification',
    value: function sendPhoneVerification(params) {
      return this.Users.sendPhoneVerification(params).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#submitPhoneVerification
     * @methodOf flApi.Users
     *
     * @description
     * Updates a phone verification process with a given action.
     *
     * @param {Object} params Query parameters.
     * @param {String} params.action 'verify'.
     * @param {Object} params.verification_details Verification details.
     * @param {String} params.verification_details.reference_id The
     * identifier returned by the verification request.
     * @param {String} params.verification_details.verification_code The code
     * sent to the phone.
     * @param {Boolean} params.verification_details.request_phone_change
     * Whether the user already has a verified phone number.
     * @param {Object} params.verification_details.phone_details Phone
     * details of the phone the code was sent to.
     * @param {String} params.verification_details.phone_details.phone_number
     * The phone number you wish to verify
     * @param {String} params.verification_details.phone_details.country_code
     * The numeric code which is prefixed to the phone number.
     * @param {String}
     * params.verification_details.phone_details.requested_country The string
     * country code of the phone's country.
     *
     * @returns {Object} a Promise object that will be resolved with a
     * boolean value 'id_verification_required', which is set to true if a
     * user must complete their ID verification before the phone verification
     * process is complete.
     *
     */

  }, {
    key: 'submitPhoneVerification',
    value: function submitPhoneVerification(params) {
      return this.Users.submitPhoneVerification(params).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#isGiveGetEligible
    * @methodOf flApi.Users
    *
    * @description
    * Is user eligible in Give Get referral program
    *
    * @returns {Object} a Promise object that will be resolved with a boolean
    * value which is set to true if user is eligible for give get and false
    * otherwise
    */

  }, {
    key: 'isGiveGetEligible',
    value: function isGiveGetEligible() {
      return this.Users.isReferralInvitationsEligible({ bonus_id: 16 }).$promise.catch(function () {
        return false;
      }).then(function (data) {
        if (typeof data === 'object') {
          return data.result;
        }
        return data;
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getGiveGetInvitationsList
    * @methodOf flApi.Users
    *
    * @description
    * Get list of invitations of Give Get referral program.
    * Each element of the array has status, email and send_date.
    *
    * @returns {Object} a Promise object that will be resolved with array of
    *   invitation list
    */

  }, {
    key: 'getGiveGetInvitationsList',
    value: function getGiveGetInvitationsList() {
      return this.Users.getReferralInvitationsList({ bonus_id: 16 }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#createGiveGetInvitation
    * @methodOf flApi.Users
    *
    * @description
    * Create GiveGet invitation. Give Get bonus Id = 16
    * @param {object}   emails    array of email addresses
    * @returns {array} List of user
    */

  }, {
    key: 'createGiveGetInvitation',
    value: function createGiveGetInvitation(emails) {
      return this.Users.createReferralInvitation({
        bonus_id: 16,
        emails: emails
      }).$promise;
    }
  }]);

  return Users;
}();

Users.$inject = ['$q', 'Auth', 'Cdn', 'Currencies', 'flResource', 'ApiInterceptor', 'GafInterceptor', 'API_BASE_URL', 'GAF_BASE_URL', 'DEFAULT_AVATAR_URL'];


var UsersProvider = flService('Users', [flResourceProvider, AuthModule, CdnProvider, CurrenciesProvider, ApiInterceptorProvider, GafInterceptorProvider, OPAQUE_MODULE_NAME], Users);

/**
 * @ngdoc service
 * @name flApi.Deposits
 *
 * @description
 * A factory that interacts with the deposit API
 * `/api/payments/<version>/deposits/`
 */

var Deposits = function () {
  function Deposits(flResource, ApiInterceptor, API_BASE_URL) {
    _classCallCheck(this, Deposits);

    this.DepositsSetUp = flResource(API_BASE_URL + '/payments/0.1/deposits/', ApiInterceptor);

    this.DepositsConfirm = flResource(API_BASE_URL + '/payments/0.1/deposits/', ApiInterceptor, {}, { update: { method: 'PUT' } });

    this.AuthorizationCharge = flResource(API_BASE_URL + '/payments/0.1/authorization/', ApiInterceptor, {}, { update: { method: 'PUT' } });

    this.GetVerifiedPaymentSources = flResource(API_BASE_URL + '/payments/0.1/authorizations/', ApiInterceptor);
  }

  /**
   * @ngdoc method
   * @name flApi.Deposits#depositFactory
   * @methodOf flApi.Deposits
   *
   * @description
   * A factory that generates Deposits objects
   *
   * @param {Object} d An object containing a raw deposit set-up information
   * @returns {Object} The returned deposit object exposes 1 methods:
   *
   * - get() returns the raw deposit information
   */


  _createClass(Deposits, [{
    key: 'depositFactory',
    value: function depositFactory(d) {
      var deposit = d;

      return {
        get: function get() {
          return deposit;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.Deposits#setupDeposit
     * @methodOf flApi.Deposits
     *
     * @description
     * A method that try to set up a deposit
     *
     * @param {Object}  An object containing the payment set-up request
     * @returns {Object} An object generated by depositFactory
     */

  }, {
    key: 'setupDeposit',
    value: function setupDeposit(request) {
      var _this = this;

      return this.DepositsSetUp.save(request).$promise.then(function (data) {
        return _this.depositFactory({
          deposit_method: data.deposit_method,
          url: data.url,
          data: data
        });
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Deposits#confirmDeposit
     * @methodOf flApi.Deposits
     *
     * @description
     * A method that try to finish a pending deposit
     *
     * @param {Object}  An object containing the payment confirmation request
     * @returns {Object} A Promise object, when resolved, returns the raw
     * result of the deposit confirmation process.
     */

  }, {
    key: 'confirmDeposit',
    value: function confirmDeposit(confirmation) {
      return this.DepositsConfirm.update(confirmation).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Deposits#authorizationCharge
     * @methodOf flApi.Deposits
     *
     * @description
     * A method that try to deposit through authorized payment reference
     *
     * @param {Object}  An object containing the payment reference
     * @returns {Object} A Promise object, when resolved, returns the raw
     * result of the deposit confirmation process.
     */

  }, {
    key: 'authorizationCharge',
    value: function authorizationCharge(reference) {
      return this.AuthorizationCharge.update(reference).$promise;
    }

    /**
      * @ngdoc method
      * @name flApi.Deposits#paymentAuthorizations
      * @methodOf flApi.Deposits
      *
      * @description
      * A method that try to deposit through authorized payment reference
      *
      * @param {Object}  An object containing the payment reference
      * @returns {Object} A Promise object, when resolved, returns the raw
      * result of the deposit confirmation process.
      */

  }, {
    key: 'getVerifiedPaymentSources',
    value: function getVerifiedPaymentSources(request) {
      return this.GetVerifiedPaymentSources.get(request).$promise;
    }
  }]);

  return Deposits;
}();

Deposits.$inject = ['flResource', 'ApiInterceptor', 'API_BASE_URL'];


var DepositsProvider = flService('Deposits', [flResourceProvider, ApiInterceptorProvider, OPAQUE_MODULE_NAME], Deposits);

/**
 * @ngdoc service
 * @name flApi.DepositFeeConfigs
 *
 * @description
 * A factory that returns an object that exposes methods to easily interact
 * with the `deposit/fees` API
 */

var DepositFeeConfigs = function () {
  function DepositFeeConfigs(flResource, ApiInterceptor, API_BASE_URL) {
    _classCallCheck(this, DepositFeeConfigs);

    this.API_BASE_URL = API_BASE_URL;
    this.resource = flResource(API_BASE_URL + '/payments/0.1/deposits/fees/', ApiInterceptor, null, { get: { cache: true } });
  }

  /**
   * @ngdoc method
   * @name flApi.DepositFeeConfigs#depositFeeConfigFactory
   * @methodOf flApi.DepositFeeConfigs
   *
   * @description
   * A factory that generates DepositFeeConfigs objects
   *
   * @param {Object} c An object containing a raw fee config information
   * @returns {Object} The returned Currency object exposes 1 methods:
   *
   * - get() returns the raw fee information
   */


  _createClass(DepositFeeConfigs, [{
    key: 'depositFeeConfigFactory',
    value: function depositFeeConfigFactory(f) {
      var fee = f;

      return {
        get: function get() {
          return fee;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.DepositFeeConfigs#depositFeeConfigListFactory
     * @methodOf flApi.DepositFeeConfigs
     *
     * @description
     * A factory that generates feeConfigList objects
     *
     * @param {Object} f An object containing a list of fee configs
     * @returns {Object} The returned feeConfigList object exposes 2 methods:
     *
     * - getMap() returns the raw list of fee configs
     * - get(currencyId, methodName) returns a fee object,
     *   given a certain currency ID and method name
     */

  }, {
    key: 'depositFeeConfigListFactory',
    value: function depositFeeConfigListFactory(f) {
      var _this = this;

      var fees = f;

      return {
        getMap: function getMap() {
          return fees;
        },

        get: function get(currencyId, methodName) {
          var resultFee = Object.keys(fees).map(function (key) {
            return fees[key];
          }).find(function (fee) {
            return fee.deposit_method === methodName && fee.currency_id === currencyId;
          });
          if (resultFee) {
            return _this.depositFeeConfigFactory(resultFee);
          }
          return undefined;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.DepositFeeConfigs#get
     * @methodOf flApi.DepositFeeConfigs
     *
     * @description
     * Return a list of all deposit fee configs
     * @param {String} depositMethod The name of the deposit method
     * @param {String} countryCode The code of country
     * @returns {Object} An object generated by depositFeeConfigListFactory
     */

  }, {
    key: 'get',
    value: function get(depositMethod, countryCode) {
      var _this2 = this;

      var data = { deposit_method: depositMethod };

      if (countryCode) {
        data.country_code = countryCode;
      }

      return this.resource.get(data).$promise.then(function (d) {
        return _this2.depositFeeConfigListFactory(d.deposit_fee_configs);
      });
    }
  }]);

  return DepositFeeConfigs;
}();

DepositFeeConfigs.$inject = ['flResource', 'ApiInterceptor', 'API_BASE_URL'];


var DepositFeeConfigsProvider = flService('DepositFeeConfigs', [flResourceProvider, ApiInterceptorProvider, OPAQUE_MODULE_NAME], DepositFeeConfigs);

var tagsSessionId = localStorage.getItem('tags_session_id');

/**
 * @ngdoc service
 * @name deposit.DepositUserInfo
 * @description
 * A service to handle "fake API calls". It essentially
 * gets the vars from php backend
 * while we wait for a real API to be implemented.
 */

var NewDepositUserInfo = function () {
  function NewDepositUserInfo(Currencies, $location) {
    _classCallCheck(this, NewDepositUserInfo);

    this.Currencies = Currencies;
    this.$location = $location;
    this.thm_session = tagsSessionId;
  }

  _createClass(NewDepositUserInfo, [{
    key: 'setConfig',
    value: function setConfig(configs) {
      for (var i = 0; i < configs.length; i++) {
        this[configs[i].name] = configs[i].value;
      }
    }
    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#depositMethodsFactory
     * @methodOf deposit.DepositUserInfo
     * @description
     * A factory that generates the billing agreement information
     * @returns {object} The returned object exposes 1 method:
     *
     * - get() returns the raw information
     */

  }, {
    key: 'depositOrderFactory',
    value: function depositOrderFactory(o) {
      var orders = o;
      return {
        get: function get() {
          return orders;
        }
      };
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#backUrlFactory
     * @methodOf deposit.DepositUserInfo
     * @description
     * A factory that generates the back urls for
     * redirection after successful deposits
     * @param {string} origin_back the original url
     * @param {string} back back-url
     * @param {string} origin_back_encode the encoded original url
     * @param {string} back_encode encoded back-url
     * @returns {object} The returned object exposes 1 method:
     *
     * - get() returns the raw information
     */

  }, {
    key: 'backUrlFactory',
    value: function backUrlFactory(origin_back, back, origin_back_encode, back_encode) {
      return {
        get: function get() {
          return {
            origin_back: {
              raw: origin_back,
              encode: origin_back_encode
            },
            back: {
              raw: back,
              encode: back_encode
            }
          };
        }
      };
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#BlackListedCurrencyFactory
     * @methodOf deposit.DepositUserInfo
     * @description
     * A factory that generates the blacklist currency information for
     * certain method
     * @returns {object} The returned object exposes 2 method:
     *
     * - get() returns the raw information
     * - getByName() returns the information for certain method
     */

  }, {
    key: 'BlackListedCurrencyFactory',
    value: function BlackListedCurrencyFactory(currency$$1) {
      var thisCurrency = currency$$1;
      return {
        get: function get() {
          return thisCurrency;
        },
        getByName: function getByName(name) {
          return thisCurrency[name];
        }
      };
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getAllOrders
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return all credit card billing agreements
     *
     * @returns {Object} An object generated by depositOrderFactory
     */

  }, {
    key: 'getAllOrders',
    value: function getAllOrders() {
      return this.depositOrderFactory(this.allOrders);
    }
  }, {
    key: 'getCurrency',
    value: function getCurrency() {
      return this.currency;
    }
    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getBackUrlInfo
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return a list of the backurls
     *
     * @returns {Object} An object generated by backUrlFactory
     */

  }, {
    key: 'getBackUrlInfo',
    value: function getBackUrlInfo() {
      return this.backUrlFactory(this.originBack, this.back, this.originBackEncode, this.backEncode);
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getMembershipTrialInfo
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return the eligibility of free trial membership
     *
     * @returns {Object} An object generated by MembershipTrialInfoFactory
     */

  }, {
    key: 'getMembershipTrialInfo',
    value: function getMembershipTrialInfo() {
      var isEligible = !!this.isFreeTrialAvailable;
      return {
        isEligible: isEligible,
        selected: isEligible && !!this.freeTrialSelected
      };
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getPPRefIds
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return all Paypal billing agreements
     *
     * @returns Array of paypal reference IDs
     */

  }, {
    key: 'getPaypalRefrenceIds',
    value: function getPaypalRefrenceIds() {
      var ids = this.ppReferenceIds;
      var refIds = [];
      return this.Currencies.get().then(function (response) {
        var currencies = response;
        if (ids) {
          Object.keys(ids).forEach(function (i) {
            if (ids[i].currency_id) {
              ids[i].currency = currencies.getById(parseInt(ids[i].currency_id, 10)).get();
            }
            refIds.push(ids[i]);
          });
        }
        return refIds;
      });
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getShowVisaSecuredLogo
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return whether to show the Visa secured/MC secured logo for CC dep.
      * @returns {Boolean} Whether or not to show this logo or not
     */

  }, {
    key: 'getShowVisaSecuredLogo',
    value: function getShowVisaSecuredLogo() {
      return this.showVisaSecuredLogo;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getBlackListedCurrency
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return all blacklisted currency list
      * @returns {Object} An object generated by BlackListedCurrencyFactory
     */

  }, {
    key: 'getBlackListedCurrency',
    value: function getBlackListedCurrency() {
      return this.BlackListedCurrencyFactory(this.blackListedCurrency);
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getThreatMetrixParams
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return threadmatrix session
      * @returns {String} An string for the threadmatrix session
     */

  }, {
    key: 'getThreatMetrixParams',
    value: function getThreatMetrixParams() {
      return this.thm_session;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getTrackingParams
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return tracking token information
      * @returns {String} An string for tracking token information
     */

  }, {
    key: 'getTrackingParams',
    value: function getTrackingParams() {
      return this.trackingToken;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getShowCloseBanner
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return showCloseBanner variable passed from php backend
     * @returns {Boolean} A flag on whether to show close banner or not
     */

  }, {
    key: 'getShowCloseBanner',
    value: function getShowCloseBanner() {
      return this.showCloseBanner === 1;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getUserInfo
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return user info containing phone, country, email, full name, city address.
     * @returns {String} An string for tracking token information
     */

  }, {
    key: 'getUserInfo',
    value: function getUserInfo() {
      return this.userInfo;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getDepositMethods
     * @methodOf deposit.getDepositMethods
     *
     * @description
     * @return bool
     */

  }, {
    key: 'getDepositMethods',
    value: function getDepositMethods() {
      return this.depositMethods;
    }
  }, {
    key: 'getShowProcessingFee',
    value: function getShowProcessingFee() {
      return this.showProcessingFee;
    }
  }, {
    key: 'getExpiryInputBox',
    value: function getExpiryInputBox() {
      return this.expiryInputBox;
    }
  }, {
    key: 'getFlnBillingBaseUrl',
    value: function getFlnBillingBaseUrl() {
      return this.flnBillingBaseUrl;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#prefillFxDepositAmount
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return whether to prefill deposit fx amount
      * @returns {Bool} Whether to prefill deposit fx amount
     */

  }, {
    key: 'getPrefillFxDepositAmount',
    value: function getPrefillFxDepositAmount() {
      return this.prefillFxDepositAmount;
    }
  }, {
    key: 'getCartCurrency',
    value: function getCartCurrency() {
      return this.cartCurrency;
    }
  }, {
    key: 'getCartAmount',
    value: function getCartAmount() {
      return this.cartAmount;
    }
  }, {
    key: 'getCartItems',
    value: function getCartItems() {
      return this.cartItems;
    }
  }, {
    key: 'getCartId',
    value: function getCartId() {
      return this.cartId;
    }
  }, {
    key: 'getNewDepositPage',
    value: function getNewDepositPage() {
      return this.newDepositPage;
    }
  }, {
    key: 'getCurrencies',
    value: function getCurrencies() {
      return this.currencies;
    }
  }, {
    key: 'getForceAVS',
    value: function getForceAVS() {
      return this.forceAVS;
    }
  }, {
    key: 'initSelectedOtherMethod',
    value: function initSelectedOtherMethod(methodarray) {
      var tab = this.$location.path().replace(/\//g, '');
      var index = void 0;
      var len = methodarray.length;
      for (index = 0; index < len; ++index) {
        if (methodarray[index].id === tab) {
          break;
        }
      }
      if (len === index) {
        tab = null;
      }
      return tab;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositUserInfo#getCCEligibility
     * @methodOf deposit.DepositUserInfo
     *
     * @description
     * Return the eligibility of credit card deposit
      * @returns {Bool} Eligibility of credit card deposit
     */

  }, {
    key: 'getCCEligibility',
    value: function getCCEligibility() {
      return this.isCCEligible;
    }
  }, {
    key: 'getExchangeRate',
    value: function getExchangeRate() {
      return this.exchangerate;
    }
  }, {
    key: 'getResetRedirect',
    value: function getResetRedirect() {
      return !!this.resetRedirect;
    }
  }, {
    key: 'getIframeUrl',
    value: function getIframeUrl() {
      return this.iframeUrl;
    }
  }, {
    key: 'getIdealBankList',
    value: function getIdealBankList() {
      return this.idealBankList;
    }
  }, {
    key: 'getCountries',
    value: function getCountries() {
      return this.countries;
    }
  }, {
    key: 'getRealBackUrl',
    value: function getRealBackUrl(backUrls, freeTrialSelected) {
      if (this.getResetRedirect()) {
        backUrls.realBack = backUrls.origin_back;
      } else if (freeTrialSelected) {
        backUrls.realBack = backUrls.back;
      } else {
        backUrls.realBack = backUrls.origin_back;
      }
    }
  }, {
    key: 'getEbanxEligibility',
    value: function getEbanxEligibility() {
      return this.ebanxEligible;
    }
  }]);

  return NewDepositUserInfo;
}();

NewDepositUserInfo.$inject = ['Currencies', '$location'];

var NewDepositUserInfoProvider = flService$1('NewDepositUserInfo', [CurrenciesProvider], NewDepositUserInfo);

/**
 * @ngdoc service
 * @name deposit.DepositAlert
 * @description
 * A service to handle all the alert message.
 */

var NewDepositAlert = function () {
  function NewDepositAlert(Analytics) {
    _classCallCheck(this, NewDepositAlert);

    /**
     * @ngdoc property
     * @name deposit.DepositAlert#show
     *
     * @description
     * Boolean value to show/hide alert message.
     */
    this.show = false;

    /**
     * @ngdoc property
     * @name deposit.DepositAlert#type
     *
     * @description
     * String for alert types. e.g. success, erorr, preDepositError etc.
     */
    this.type = '';

    /**
     * @ngdoc property
     * @name deposit.DepositAlert#category
     *
     * @description
     * String for alert class types. e.g. success, erorr, info or warning.
     * This declares which alert class-type to use on the alert dialog.
     */
    this.category = '';

    /**
     * @ngdoc property
     * @name deposit.DepositAlert#message
     *
     * @description
     * Customised text showing additional alert information.
     */
    this.message = '';

    /**
     * @ngdoc property
     * @name deposit.DepositAlert#depositObj
     *
     * @description
     * depositObj is the object of deposit information, which provide additional
     * information source.
     */
    this.depositObj = {};

    this.Analytics = Analytics;
  }

  /**
   * @ngdoc method
   * @name deposit.DepositAlert#setAlert
   *
   * @description
   * Showing error message and set deposit object. And every time when setting
   * alert, window will scroll for user to see the alerts.
   */

  _createClass(NewDepositAlert, [{
    key: 'setAlert',
    value: function setAlert(type, depositObj, action, message) {
      this.type = type;
      this.message = message;
      this.depositObj = typeof depositObj === 'object' ? depositObj : {};
      this.show = !(this.depositObj.successMask && this.type === 'success');
      if (this.type === 'success' || this.type === 'boletoSuccess' || this.type === 'cartError' || this.type === 'wireSuccess') {
        this.category = 'success';
      } else if (this.type === 'error' || this.type === 'error_detailed' || this.type === 'binError' || this.type === 'failure') {
        this.category = 'error';
      } else {
        this.category = 'warning';
      }
      window.document.body.scrollTop = 0;
      if (this.type !== 'success' && this.type !== 'boletoSuccess' && this.type !== 'wireSuccess') {
        this.Analytics.trackEvent('DepositErrors', '', '', action, message.error_code ? message.error_code : message, 'failed');
      }
    }

    /**
     * @ngdoc method
     * @name deposit.DepositAlert#close
     *
     * @description
     * Hide alert information.
     */

  }, {
    key: 'close',
    value: function close() {
      this.show = false;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositAlert#setApiError
     *
     * @description
     * Set API failure alerts.
     */

  }, {
    key: 'setApiError',
    value: function setApiError(message) {
      try {
        this.setAlert('apiError', undefined, 'setup', JSON.parse(message));
      } catch (e) {
        // if it's a non-json string, then just show the generic error message
        this.setAlert('genericError', undefined, 'setup', message);
      }
    }

    /**
     * @ngdoc method
     * @name deposit.DepositAlert#setPreDepositError
     *
     * @description
     * Set error alerts before deposit.
     */

  }, {
    key: 'setPreDepositError',
    value: function setPreDepositError(message) {
      try {
        this.setAlert('preDepositError', undefined, 'init', JSON.parse(message));
      } catch (e) {
        // if it's a non-json string, then just show the generic error message
        this.setAlert('genericError', undefined, 'init', message);
      }
    }
  }]);

  return NewDepositAlert;
}();

NewDepositAlert.$inject = ['Analytics'];

var NewDepositAlertProvider = flService$1('NewDepositAlert', [AnalyticsModule], NewDepositAlert);

/**
 * @ngdoc service
 * @name deposit.DepositManager
 * @description
 * A service for shared methods for controllers
 */

var NewDepositManager = function () {
  function NewDepositManager(DepositFeeConfigs, NewDepositUserInfo, NewDepositAlert) {
    _classCallCheck(this, NewDepositManager);

    this.DepositFeeConfigs = DepositFeeConfigs;
    this.DepositUserInfo = NewDepositUserInfo;
    this.alerts = NewDepositAlert;
  }
  /**
   * @ngdoc method
   * @name deposit.DepositManager#getDepositObject
   * @methodOf deposit.DepositManager
   *
   * @description
   * A method returns the object of deposit information
   *
   * @returns {object}
   */

  _createClass(NewDepositManager, [{
    key: 'getDepositObject',
    value: function getDepositObject() {
      return this.deposit;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#setDepositObject
     * @methodOf deposit.DepositManager
     *
     * @description
     * A method sets the deposit information
     *
     * @param {Object} Deposit Object
     *
     */

  }, {
    key: 'setDepositObject',
    value: function setDepositObject(deposit) {
      this.deposit = deposit;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#setVars
     * @methodOf deposit.DepositManager
     *
     * @description
     * A method sets the deposit shared information. e.g. DepositController and
     * ccDepositController will share configuration via this.vars.
     *
     * @param {Object} vars Object
     */

  }, {
    key: 'setVars',
    value: function setVars(vars) {
      this.vars = vars;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#getVars
     * @methodOf deposit.DepositManager
     *
     * @description
     * A method get the deposit shared information
     */

  }, {
    key: 'getVars',
    value: function getVars() {
      return this.vars;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#getAmountAndCurrency
     * @methodOf deposit.DepositManager
     *
     * @description
     * A method to initialize the fee
     * @param {string} type Deposit type
     *
     * @returns {object} feeConfigs Deposit fee config object
     */

  }, {
    key: 'initFeesConfigFactory',
    value: function initFeesConfigFactory(type, countryCode) {
      return this.DepositFeeConfigs.get(type, countryCode).then(function (r) {
        return r;
      });
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#updateFee
     * @methodOf deposit.DepositManager
     * @description
     * Updates the fees when the amount / currency changes
     * feeConfig = {
     *     fee_fixed_amount: number,
     *     fee_rate: number
     * }
     * @return float deposit fee amount
     */

  }, {
    key: 'getFee',
    value: function getFee(amount, feeConfig) {
      var fee = amount * (feeConfig.fee_rate || 0) + (feeConfig.fee_fixed_amount || 0);
      // In JS, the round up is different from PHP.
      // e.g. In JS, 5005 * 0.023 + 0.3 = 115.41499999999999, but in PHP,
      // it's 115.415. So if we don't round up here. Angular will show
      // 115.41. But the backend will charge 115.42 :(.
      return parseFloat(fee.toFixed(3));
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#isBillingInited
     * @methodOf deposit.DepositManager
     * @description
     * return billing inited flag
     */

  }, {
    key: 'isBillingInited',
    value: function isBillingInited() {
      return this.billingInited;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#initBilling
     * @methodOf deposit.DepositManager
     * @description
     * set billing inited flag to true
     */

  }, {
    key: 'initBilling',
    value: function initBilling() {
      this.billingInited = true;
    }

    /**
     * @ngdoc method
     * @name deposit.DepositManager#initializeDeposit
     * @methodOf deposit.DepositManager
     * @description
     * Initialize fee config and update the currency list
     */

  }, {
    key: 'initializeDeposit',
    value: function initializeDeposit(method, countryCode) {
      var _this = this;

      // real back url is set based on user free trial eligiblity and selection
      // free trial is only available for CC and paypal deposit
      this.DepositUserInfo.getRealBackUrl(this.vars.backUrls, this.vars.freeTrial.isEligible && this.vars.freeTrial.selected && ['fln_billing', 'paypal'].indexOf(this.vars.tab) !== -1);

      if (!this.feeConfigs) {
        this.feeConfigs = {};
      }
      if (!this.feeConfigs[method]) {
        this.initFeesConfigFactory(method, countryCode).then(function (r) {
          _this.feeConfigs[method] = r;
        }).catch(function (e) {
          _this.alerts.setPreDepositError(e.data ? e.data.message : e);
        });
      }
    }
  }]);

  return NewDepositManager;
}();

NewDepositManager.$inject = ['DepositFeeConfigs', 'NewDepositUserInfo', 'NewDepositAlert'];

var NewDepositManagerProvider = flService$1('NewDepositManager', [DepositFeeConfigsProvider, NewDepositUserInfoProvider, NewDepositAlertProvider], NewDepositManager);

/**
 * @ngdoc filter
 * @name deposit.creditCardFilter
 * @module deposit
 *
 * @description
 * Format card number to numbers with space in each 4 digits.
 * @param {string} A string of credit card number.
 * @return {string} Formatted credit card number.
 */
function creditCard() {
  return function (cardNumber) {
    var nums = cardNumber.replace(/ /g, '').match(/.{1,4}/g);
    return nums.join(' ');
  };
}

creditCard.$inject = [];
creditCard.$inject = [];
var creditCard$1 = flFilter$1('creditCard', [], creditCard);

var template$9 = "<section ng-class=\"{'PaymentMethod-content-inner' : !(CurrencySelector.DepositService.deposit.type === 'fln_billing' && !CurrencySelector.DepositService.deposit.agreementObject)}\">\n    <div class=\"fl-form PaymentMethod-form\">\n        <div class=\"PaymentMethod-form-group\">\n            <div class=\"PaymentMethod-form-column\"\n                ng-class=\"{'is-warning' : CurrencySelector.DepositService.deposit.data.name.valid === false,\n                'is-valid': CurrencySelector.DepositService.deposit.data.name.valid === true,\n                'PaymentMethod-form-column--medium': CurrencySelector.DepositService.deposit.cartSummary}\">\n                <label ng-if=\"CurrencySelector.DepositService.deposit.type === 'fln_billing'\" class=\"PaymentMethod-form-label\">Charge my card in:</label>\n                <label ng-if=\"CurrencySelector.DepositService.deposit.type === 'paypal_reference'\" class=\"PaymentMethod-form-label\">Charge my account in:</label>\n                <div class=\"PaymentMethod-form-inputContainer\">\n                    <div class=\"PagePayments-currency large-input\">\n                        <span class=\"PagePayments-currency-flag small-flag\"\n                        ng-class=\"CurrencySelector.DepositService.deposit.flagMap[CurrencySelector.DepositService.deposit.ccChargeCurrency.country].name.toLowerCase().replace(' ', '-')\"></span>\n                        <select fl-analytics=\"IssuingCurrency\" name=\"currency\" id=\"currency\" data-uitest-target=\"newdep-currency-dropdown\" class=\"PagePayments-currency-select\"\n                                name=\"currency\" ng-change=\"CurrencySelector.changeChargeCurrency()\" ng-model=\"CurrencySelector.DepositService.deposit.chargeCurrency\">\n                            <option ng-selected=\"{{c.code == CurrencySelector.DepositService.deposit.ccChargeCurrency.code}}\"\n                                ng-repeat=\"c in CurrencySelector.DepositService.deposit.agreementCurrencyList\"\n                                ng-disabled=\"c.disabled\"\n                                value=\"{{c.code}}\">{[{c.code}]} - {[{c.name}]}</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>";

/**
 * @ngdoc controller
 * @name deposit.CurrencySelector
 * @module deposit
 *
 * @description
 * Deposit page currency selector controller
 */

var CurrencySelector = function () {
  function CurrencySelector($scope) {
    var _this = this;

    _classCallCheck(this, CurrencySelector);

    this.$scope = $scope;
    if (!this.DepositService.deposit.agreementObject) {
      this.chargeCurrency = this.DepositService.deposit.ccChargeCurrency.code;
    } else {
      this.chargeCurrency = this.DepositService.deposit.availableCCFirstTimeCurrencyList.filter(function (x) {
        return x.id === _this.DepositService.deposit.agreementObject.currency_id;
      })[0].code;
    }
  }

  _createClass(CurrencySelector, [{
    key: 'changeChargeCurrency',
    value: function changeChargeCurrency() {
      var _this2 = this;

      this.DepositService.deposit.ccChargeCurrency = this.DepositService.deposit.availableCCFirstTimeCurrencyList.filter(function (x) {
        return x.code === _this2.DepositService.deposit.chargeCurrency;
      })[0];
      this.DepositService.deposit.changeChargeCurrency();
    }
  }]);

  return CurrencySelector;
}();

CurrencySelector.$inject = ['$scope'];

var flCurrencySelector = flComponent$1(CurrencySelector, {
  selector: 'fl-currency-selector',
  template: template$9,
  bindings: {
    DepositService: '=deposit'
  }
});

var template$10 = "<div ng-show=\"NewCcDeposit.allowCC\" class=\"tab-pane\" ng-class=\"{'fade in active': NewCcDeposit.config.tab === 'fln_billing' }\" fl-analytics-section=\"deposit\" fl-analytics-subsection=\"cc\">\n    <section class=\"PaymentMethod-content-inner\">\n        <div class=\"fl-form PaymentMethod-form\">\n            <div ng-show=\"!NewCcDeposit.Recurring\">\n                <div class=\"PaymentMethod-form-group\">\n                    <div class=\"PaymentMethod-form-column form-step\"\n                        ng-class=\"{'is-warning' : NewCcDeposit.DepositService.deposit.data.pan.valid === false,\n                        'is-valid': NewCcDeposit.DepositService.deposit.data.pan.valid === true,\n                        'PaymentMethod-form-column--medium': NewCcDeposit.DepositService.deposit.cartSummary}\">\n                        <label for=\"iframe-payment-method-pan\" class=\"PaymentMethod-form-label\">Card Number:</label>\n                        <div class=\"PaymentMethod-form-inputContainer\">\n                            <div class=\"PaymentMethod-form-input large-input\">\n                                <iframe fl-analytics=\"PanField\" id=\"iframe-payment-method-pan\"\n                                        class=\"PaymentMethod-form-iframe iframe-payment-method-cc\" ng-src=\"{[{NewCcDeposit.pan}]}\"\n                                        sandbox=\"allow-forms allow-scripts allow-same-origin\"\n                                        data-uitest-target=\"credit-card-number-iframe\"></iframe>\n                            </div>\n                            <span fl-analytics=\"PanInvalid\" ng-if=\"NewCcDeposit.DepositService.deposit.data.pan.valid === false\"\n                                  class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                                  data-tooltip=\"Invalid card number\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-warning\"></fl-icon>\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"PaymentMethod-form-column PaymentMethod-form-column--small form-step\"\n                        ng-class=\"{'is-warning' : NewCcDeposit.DepositService.deposit.data.expiry.valid === false,\n                        'is-valid': NewCcDeposit.DepositService.deposit.data.expiry.valid === true}\">\n                        <label for=\"iframe-payment-method-expiry\" class=\"PaymentMethod-form-label\">Expiry Date:</label>\n                        <div class=\"PaymentMethod-form-inputContainer\">\n                            <div class=\"PaymentMethod-form-input large-input\">\n                                <iframe fl-analytics=\"ExpiryField\" id=\"iframe-payment-method-expiry\"\n                                        class=\"PaymentMethod-form-iframe iframe-payment-method-cc\" ng-src=\"{[{NewCcDeposit.expiry}]}\"\n                                        sandbox=\"allow-forms allow-scripts allow-same-origin\"\n                                        data-uitest-target=\"credit-card-expiry-iframe\"></iframe>\n                            </div>\n                            <span fl-analytics=\"ExpiryInvalid\" ng-if=\"NewCcDeposit.DepositService.deposit.data.expiry.valid === false\"\n                                  class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                                  data-tooltip=\"Invalid expiry\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-warning\"></fl-icon>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"PaymentMethod-form-group\">\n                    <div class=\"PaymentMethod-form-column form-step\"\n                        ng-class=\"{'is-warning' : NewCcDeposit.DepositService.deposit.data.name.valid === false,\n                        'is-valid': NewCcDeposit.DepositService.deposit.data.name.valid === true,\n                        'PaymentMethod-form-column--medium': NewCcDeposit.DepositService.deposit.cartSummary}\">\n                        <label for=\"iframe-payment-method-name\" class=\"PaymentMethod-form-label\">Cardholder Name:</label>\n                        <div class=\"PaymentMethod-form-inputContainer\">\n                            <div class=\"PaymentMethod-form-input large-input\">\n                                <iframe fl-analytics=\"NameField\" id=\"iframe-payment-method-name\"\n                                        sandbox=\"allow-forms allow-scripts allow-same-origin\"\n                                        class=\"PaymentMethod-form-iframe iframe-payment-method-cc\" ng-src=\"{[{NewCcDeposit.name}]}\"\n                                        data-uitest-target=\"credit-card-name-iframe\"></iframe>\n                            </div>\n                            <span fl-analytics=\"NameInvalid\" ng-if=\"NewCcDeposit.DepositService.deposit.data.name.valid === false\"\n                                  class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                                  data-tooltip=\"Invalid cardholder name\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-warning\"></fl-icon>\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"PaymentMethod-form-column PaymentMethod-form-column--small form-step\"\n                        ng-class=\"{'is-warning' : NewCcDeposit.DepositService.deposit.data.cvv.valid === false,\n                        'is-valid' : NewCcDeposit.DepositService.deposit.data.cvv.valid === true}\">\n                        <label for=\"iframe-payment-method-cvv\" class=\"PaymentMethod-form-label\">\n                            CCV/CVV:\n                            <span fl-analytics=\"CVV\" ng-if=\"NewCcDeposit.DepositService.deposit.data.card !== 'amex'\" class=\"PaymentMethod-form-tip Icon Icon--mid Tooltip--right\" data-tooltip=\"The last 3 digits displayed on the back of your card\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-help\"></fl-icon>\n                            </span>\n                            <span fl-analytics=\"CVVAmex\" ng-if=\"NewCcDeposit.DepositService.deposit.data.card === 'amex'\" class=\"PaymentMethod-form-tip Icon Icon--mid Tooltip--left\" data-tooltip=\"The 4 digits displayed on the front of your card\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-help\"></fl-icon>\n                            </span>\n                        </label>\n                        <div class=\"PaymentMethod-form-inputContainer\">\n                            <div class=\"PaymentMethod-form-input large-input\">\n                                <iframe fl-analytics=\"CVVField\" id=\"iframe-payment-method-cvv\"\n                                        class=\"PaymentMethod-form-iframe iframe-payment-method-cc\"\n                                        sandbox=\"allow-forms allow-scripts allow-same-origin\"\n                                        ng-src=\"{[{NewCcDeposit.cvv}]}\" data-uitest-target=\"credit-card-cvv-iframe\"></iframe>\n                            </div>\n                            <span fl-analytics=\"CVVInvalid\" ng-if=\"NewCcDeposit.DepositService.deposit.data.cvv.valid === false\"\n                                  class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                                  data-tooltip=\"Invalid CVV\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-warning\"></fl-icon>\n                            </span>\n                        </div>\n                        <span class=\"form-error\" ng-if=\"NewCcDeposit.DepositService.deposit.data.cvv.valid === false\">Invalid CVV</span>\n                    </div>\n                </div>\n                <div class=\"PaymentMethod-form-group\">\n                    <fl-currency-selector ng-if=\"!NewCcDeposit.DepositService.deposit.agreementObject && NewCcDeposit.DepositService.deposit.type==='fln_billing' && NewCcDeposit.DepositService.deposit.showChargeCurrency\" deposit=\"NewCcDeposit.DepositService\"></fl-currency-selector>\n                    <div  ng-if=\"NewCcDeposit.forceAVS\" class=\"PaymentMethod-form-column PaymentMethod-form-column--small form-step\"\n                        ng-class=\"{'is-warning' : NewCcDeposit.DepositService.deposit.data.postcode.valid === false,\n                        'is-valid': NewCcDeposit.DepositService.deposit.data.postcode.valid === true}\">\n                        <label for=\"iframe-payment-method-name\" class=\"PaymentMethod-form-label\">Billing Zip Code:</label>\n                        <div class=\"PaymentMethod-form-inputContainer\">\n                            <input id=\"postcode\" ng-change=\"NewCcDeposit.validatePostcode()\" ng-model=\"NewCcDeposit.DepositService.deposit.data.postcode.code\"\n                            class=\"PaymentMethod-form-input large-input\"\n                            ng-style=\"NewCcDeposit.DepositService.deposit.data.postcode.valid == true ? {color : '#4fb55d'} : {}\"\n                            required>\n                            <span fl-analytics=\"PostcodeInvalid\" ng-if=\"NewCcDeposit.DepositService.deposit.data.postcode.valid === false &&\n                            NewCcDeposit.config.country.code == 'us'\"\n                                  class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                                  data-tooltip=\"Invalid Zip Code\" i18n-data-tooltip>\n                                <fl-icon name=\"ui-warning\"></fl-icon>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <form ng-if=\"NewCcDeposit.ebanxEligible\" class=\"fl-form PaymentMethod-form\" name=\"NewCcDeposit.DepositService.deposit.ebanxForm\" >\n                    <div id=\"ebanxForm\" ng-class=\"{'fade in active': NewCcDeposit.config.tab == 'fln_billing'}\" fl-analytics-subsection=\"ebanx\">\n                    <section class=\"payment-method\">\n                      <div class=\"Grid form-step\">\n                        <div class=\"Grid-col\">\n                          <fieldset class=\"PaymentMethod-form-fieldset\">\n                            <h4 class=\"PaymentMethod-form-title\">Additional details</h4>\n                            <div class=\"PaymentMethod-form-group\">\n                              <div class=\"PaymentMethod-form-column--medium form-step\" ng-class=\"{'is-invalid': (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxDocument.$invalid &&\n                                (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxDocument.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)) || (NewCcDeposit.DepositService.deposit.ebanxSubmit && !NewCcDeposit.DepositService.deposit.validDocument)\n                                || (!NewCcDeposit.DepositService.deposit.validDocument && NewCcDeposit.documentLength >= 11) || (!NewCcDeposit.DepositService.deposit.validDocument && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxDocument.$touched)}\"\n                                ng-if=\"NewCcDeposit.DepositService.deposit.user.location.country.code === 'br'\">\n                                <label ng-if=\"NewCcDeposit.DepositService.deposit.user.location.country.code === 'br'\" class=\"PaymentMethod-form-label\" for=\"ebanx-document\">CPF</label>\n                                <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.document\" ng-change=\"NewCcDeposit.validateDocument()\" name=\"ebanxDocument\" required type=\"text\" class=\"large-input\" ng-maxlength=\"16\">\n                                <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxDocument.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxDocument.$invalid\"\n                                      class=\"PaymentMethod-form-warningIcon PaymentMethod-form-half Icon Tooltip--left\"\n                                      data-tooltip=\"Please specify your document\">\n                                    <fl-icon name=\"ui-warning\"></fl-icon>\n                                </span>\n                                <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxSubmit && !NewCcDeposit.DepositService.deposit.validDocument) || (!NewCcDeposit.DepositService.deposit.validDocument && NewCcDeposit.documentLength >= 11)\n                                    || (!NewCcDeposit.DepositService.deposit.validDocument && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxDocument.$touched)\"\n                                      class=\"PaymentMethod-form-warningIcon PaymentMethod-form-half Icon Tooltip--left\"\n                                      data-tooltip=\"Incorrect CPF\">\n                                    <fl-icon name=\"ui-warning\"></fl-icon>\n                                </span>\n                              </div>\n                              <div class=\"PaymentMethod-form-column form-step phone-section\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxphone.$invalid &&\n                                (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxphone.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\">\n                                <label class=\"PaymentMethod-form-label-half\" for=\"ebanx-phone\">Phone Number</label>\n                                <div class=\"input-group\">\n                                  <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.phone\" name=\"ebanxphone\" required type=\"tel\"\n                                  ng-minlength=\"7\", ng-maxlength=\"15\" class=\"large-input\">\n                                  <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxphone.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxphone.$invalid\"\n                                      class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                      data-tooltip=\"Please specify your phone number\">\n                                    <fl-icon name=\"ui-warning\"></fl-icon>\n                                  </span>\n                                  <div ng-messages=\"NewCcDeposit.DepositService.deposit.ebanxForm.ebanxphone.$error\">\n                                    <span ng-message=\"maxlength\"\n                                        class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                        data-tooltip=\"Please input valid phone number\">\n                                      <fl-icon name=\"ui-warning\"></fl-icon>\n                                    </span>\n                                    <span ng-message=\"minlength\"\n                                        class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                        data-tooltip=\"Please input valid phone number\">\n                                      <fl-icon name=\"ui-warning\"></fl-icon>\n                                    </span>\n                                  </div>\n                                </div>\n                              </div>\n                            </div>\n                            <div class=\"form-step\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxEmail.$invalid &&\n                              (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxEmail.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\">\n                              <label class=\"PaymentMethod-form-label\" for=\"ebanx-email\">Email</label>\n                                <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.email\" class=\"large-input\" name=\"ebanxEmail\" required type=\"email\">\n                                <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxEmail.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxEmail.$invalid\"\n                                    class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                    data-tooltip=\"Please input valid email\">\n                                  <fl-icon name=\"ui-warning\"></fl-icon>\n                                </span>\n                            </div>\n                            <div class=\"form-step\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxAddress.$invalid &&\n                              (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxAddress.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\">\n                              <label class=\"PaymentMethod-form-label\" for=\"ebanx-address\">Address</label>\n                              <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.address\" name=\"ebanxAddress\" required type=\"text\" class=\"PaymentMethod-form-input large-input\">\n                              <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxAddress.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxAddress.$invalid\"\n                                  class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                  data-tooltip=\"Please specify your address\">\n                                <fl-icon name=\"ui-warning\"></fl-icon>\n                              </span>\n                            </div>\n                            <div class=\"PaymentMethod-form-group\">\n                                <div class=\"PaymentMethod-form-column form-step\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxStreetNumber.$invalid &&\n                                (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxStreetNumber.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\">\n                                    <label class=\"PaymentMethod-form-label\" for=\"ebanx-street-number\">Street Number</label>\n                                    <div class=\"PaymentMethod-form-inputContainer\">\n                                        <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.streetno\" name=\"ebanxStreetNumber\" required type=\"tel\" class=\"large-input\" >\n                                        <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxStreetNumber.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxStreetNumber.$invalid\"\n                                            class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                            data-tooltip=\"Please specify your street number\">\n                                          <fl-icon name=\"ui-warning\"></fl-icon>\n                                        </span>\n                                    </div>\n                                </div>\n                                <div class=\"PaymentMethod-form-column--medium form-step\">\n                                  <label class=\"PaymentMethod-form-label\" for=\"ebanx-street-complement\">Street Complement</label>\n                                  <div class=\"PaymentMethod-form-inputContainer\">\n                                      <input name=\"ebanxStreetComplement\" type=\"text\" class=\"large-input\">\n                                  </div>\n                                </div>\n                              <div class=\"PaymentMethod-form-column form-step\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxZip.$invalid &&\n                              (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxZip.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\">\n                                <label class=\"PaymentMethod-form-label\" for=\"ebanx-zip\">Zip\n                                <span fl-analytics=\"CVV\" ng-click=\"NewCcDeposit.zipLink()\" class=\"PaymentMethod-form-zipLink Icon Icon--mid Tooltip--right\" data-tooltip=\"Don't know your zip?\" i18n-data-tooltip>\n                                    <fl-icon name=\"ui-help\"></fl-icon>\n                                </span>\n                                </label>\n                                <div class=\"PaymentMethod-form-inputContainer\">\n                                    <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.zip\" name=\"ebanxZip\" required type=\"text\" class=\"large-input\" ng-maxlength=\"10\">\n                                    <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxZip.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxZip.$invalid\"\n                                        class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                        data-tooltip=\"Please specify your zip code\">\n                                      <fl-icon name=\"ui-warning\"></fl-icon>\n                                    </span>\n                                </div>\n                              </div>\n                            </div>\n                            <div class=\"PaymentMethod-form-group\">\n                              <div class=\"PaymentMethod-form-column form-step\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxCity.$invalid &&\n                                (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxCity.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\">\n                                <label class=\"PaymentMethod-form-label\" for=\"ebanx-city\">City</label>\n                                <div class=\"PaymentMethod-form-inputContainer\">\n                                    <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.city\" name=\"ebanxCity\" required type=\"text\" class=\"large-input\">\n                                    <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxCity.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxCity.$invalid\"\n                                        class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                        data-tooltip=\"Please specify your city\">\n                                      <fl-icon name=\"ui-warning\"></fl-icon>\n                                    </span>\n                                </div>\n                              </div>\n                              <div class=\"PaymentMethod-form-column form-step\" ng-if=\"NewCcDeposit.DepositService.deposit.user.location.country.code === 'br'\">\n                                <label class=\"PaymentMethod-form-label\" for=\"ebanx-state\">State</label>\n                                <select ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.state\" class=\"large-select\">\n                                  <option value=\"AC\" selected>AC</option>\n                                  <option value=\"AL\">AL</option>\n                                  <option value=\"AM\">AM</option>\n                                  <option value=\"AP\">AP</option>\n                                  <option value=\"BA\">BA</option>\n                                  <option value=\"CE\">CE</option>\n                                  <option value=\"DF\">DF</option>\n                                  <option value=\"ES\">ES</option>\n                                  <option value=\"GO\">GO</option>\n                                  <option value=\"MA\">MA</option>\n                                  <option value=\"MG\">MG</option>\n                                  <option value=\"MS\">MS</option>\n                                  <option value=\"MT\">MT</option>\n                                  <option value=\"PA\">PA</option>\n                                  <option value=\"PB\">PB</option>\n                                  <option value=\"PE\">PE</option>\n                                  <option value=\"PI\">PI</option>\n                                  <option value=\"PR\">PR</option>\n                                  <option value=\"RJ\">RJ</option>\n                                  <option value=\"RN\">RN</option>\n                                  <option value=\"RO\">RO</option>\n                                  <option value=\"RR\">RR</option>\n                                  <option value=\"RS\">RS</option>\n                                  <option value=\"SC\">SC</option>\n                                  <option value=\"SE\">SE</option>\n                                  <option value=\"SP\">SP</option>\n                                  <option value=\"TO\">TO</option>\n                                </select>\n                              </div>\n                              <div class=\"PaymentMethod-form-column form-step\" ng-class=\"{'is-invalid': NewCcDeposit.DepositService.deposit.ebanxForm.ebanxCity.$invalid &&\n                                (NewCcDeposit.DepositService.deposit.ebanxForm.ebanxState.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit)}\"\n                                ng-if=\"NewCcDeposit.DepositService.deposit.user.location.country.code === 'mx'\">\n                                <label class=\"PaymentMethod-form-label\" for=\"ebanx-city\">State</label>\n                                <div class=\"PaymentMethod-form-inputContainer\">\n                                    <input ng-model=\"NewCcDeposit.DepositService.deposit.ebanxDetail.state\" name=\"ebanxState\" required type=\"text\" class=\"large-input\">\n                                    <span ng-if=\"(NewCcDeposit.DepositService.deposit.ebanxForm.ebanxState.$dirty || NewCcDeposit.DepositService.deposit.ebanxSubmit) && NewCcDeposit.DepositService.deposit.ebanxForm.ebanxState.$invalid\"\n                                        class=\"PaymentMethod-form-warningIcon Icon Tooltip--left\"\n                                        data-tooltip=\"Please specify your state\">\n                                      <fl-icon name=\"ui-warning\"></fl-icon>\n                                    </span>\n                                </div>\n                              </div>\n                            </div>\n                          </fieldset>\n                        </div>\n                      </div>\n                    </section>\n                    </div>\n                </form>\n            </div>\n        </div>\n        <div class=\"Grid PaymentMethod-form-row\">\n            <div class=\"Grid-col Grid-col--12 PagePayments-creditCard\">\n                <ul class=\"PagePayments-acceptedCards\">\n                    <li fl-analytics=\"Visa\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"visa\"></fl-icon>\n                    </li>\n                    <li fl-analytics=\"Amex\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"amex\"></fl-icon>\n                    </li>\n                    <li fl-analytics=\"Mastercard\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"mastercard\"></fl-icon>\n                    </li>\n                    <li fl-analytics=\"JCB\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"jcb\"></fl-icon>\n                    </li>\n                    <li ng-if=\"NewCcDeposit.ebanxEligible && NewCcDeposit.DepositService.deposit.user.location.country.code === 'br'\" fl-analytics=\"hipercard\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"hipercard\"></fl-icon>\n                    </li>\n                    <li ng-if=\"NewCcDeposit.ebanxEligible && NewCcDeposit.DepositService.deposit.user.location.country.code === 'br'\" fl-analytics=\"elo\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"elo\"></fl-icon>\n                    </li>\n                    <li ng-if=\"NewCcDeposit.ebanxEligible && NewCcDeposit.DepositService.deposit.user.location.country.code === 'br'\" fl-analytics=\"aura\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"aura\"></fl-icon>\n                    </li>\n                    <li ng-if=\"NewCcDeposit.ebanxEligible && NewCcDeposit.DepositService.deposit.user.location.country.code === 'mx'\" fl-analytics=\"carnet\" class=\"PagePayments-acceptedCards-item\">\n                        <fl-icon name=\"carnet\"></fl-icon>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </section>\n</div>\n";

/**
 * @ngdoc controller
 * @name deposit.CCDepositController
 * @module deposit
 *
 * @description
 * Deposit page credit card tab controller
 */

var NewCcDeposit = function () {
  function NewCcDeposit($scope, $window, $sce, $http, $rootScope, NewDepositUserInfo, NewDepositManager, Analytics) {
    var _this = this;

    _classCallCheck(this, NewCcDeposit);

    this.$sce = $sce;
    this.$scope = $scope;
    this.$http = $http;
    this.$window = $window;
    this.DepositUserInfo = NewDepositUserInfo;
    this.DepositManager = NewDepositManager;
    this.Analytics = Analytics;
    this.Billing = Billing;
    this.flnBillingBaseUrl = this.DepositUserInfo.getFlnBillingBaseUrl();
    this.expiryInputBox = this.DepositUserInfo.getExpiryInputBox();
    this.allowCC = this.DepositUserInfo.getCCEligibility();
    this.userInfo = this.DepositUserInfo.getUserInfo();
    this.forceAVS = this.DepositUserInfo.getForceAVS();
    this.ebanxEligible = this.DepositUserInfo.getEbanxEligibility();
    this.pan = this.$sce.trustAsResourceUrl(this.DepositUserInfo.getIframeUrl());
    this.cvv = this.$sce.trustAsResourceUrl(this.DepositUserInfo.getIframeUrl());
    this.name = this.$sce.trustAsResourceUrl(this.DepositUserInfo.getIframeUrl());
    this.expiry = this.$sce.trustAsResourceUrl(this.DepositUserInfo.getIframeUrl());
    this.DepositService.deposit.data = {
      pan: { model: '', valid: null },
      cvv: { model: '', valid: null },
      expiry: { month: '', year: '' },
      name: { model: '', valid: null },
      postcode: { model: '', valid: null },
      creditCardForm: { valid: false }
    };
    this.DepositService.deposit.ccChargeCurrency = this.DepositService.deposit.currency;

    if (this.DepositService.deposit.type === 'fln_billing' || this.DepositService.deposit.type === 'paypal') {
      this.initial();
    }

    this.card = false;
    this.iin = false;
    this.last4 = false;
    var defaultPan = {
      lengths: [16],
      pattern: '(\\d{1,4}) ?(\\d{1,4})? ?(\\d{1,4})? ?(\\d{1,4})?'
    };
    var defaultCvv = { lengths: [3] };
    this.cards = {
      amex: {
        iinRegex: /^3[47]/,
        pan: { lengths: [15], pattern: '(\\d{1,4}) ?(\\d{1,6})? ?(\\d{1,5})?' },
        cvv: { lengths: [4] }
      },
      jcb: {
        iinRegex: /^35(2[89]|[3-8][0-9])/,
        pan: defaultPan,
        cvv: defaultCvv
      },
      visa_electron: {
        iinRegex: /^(4026|417500|4508|4844|491(3|7))/,
        pan: defaultPan,
        cvv: defaultCvv
      },
      visa: {
        iinRegex: /^4/,
        pan: defaultPan,
        cvv: defaultCvv
      },
      mastercard: {
        iinRegex: /^5[1-5]/,
        pan: defaultPan,
        cvv: defaultCvv
      }
    };

    if (this.allowCC) {
      this.setupBilling(this.DepositService.deposit.test);
    }
    // adding ebanx details
    if (this.ebanxEligible) {
      var state = 'AC';
      if (this.DepositService.deposit.user.location.country.code !== 'br') {
        state = '';
      }
      this.DepositService.deposit.ebanxDetail = {
        countrycode: this.DepositService.deposit.user.location.country.code,
        name: this.userInfo.fullname,
        email: this.userInfo.email,
        currencycode: this.DepositService.deposit.currency.code,
        phone: this.userInfo.phone,
        city: this.userInfo.city,
        address: this.userInfo.address1,
        streetcomplement: this.userInfo.address2,
        zip: this.userInfo.zip,
        state: state
      };
    }
    var switchPaymentType = $rootScope.$on('switchPaymentType', function () {
      if (_this.DepositService.deposit.type === 'fln_billing') {
        _this.initial();
      }
    });
    // clean up rootscope binding on destroy
    $scope.$on('$destroy', function () {
      switchPaymentType();
    });
  }

  _createClass(NewCcDeposit, [{
    key: 'validatePostcode',
    value: function validatePostcode() {
      if (this.DepositService.deposit.data.postcode.code && this.DepositService.deposit.data.postcode.code.length > 0) {
        var postcodeRegex = /^[0-9]{5}$/;
        if (postcodeRegex.test(this.DepositService.deposit.data.postcode.code)) {
          this.DepositService.deposit.data.postcode.valid = true;
        } else {
          this.DepositService.deposit.data.postcode.valid = false;
        }
      } else {
        this.DepositService.deposit.data.postcode.valid = false;
      }
    }
  }, {
    key: 'changeChargeCurrency',
    value: function changeChargeCurrency() {
      var _this2 = this;

      this.DepositService.deposit.chargeCurrency = this.DepositService.deposit.availableCCFirstTimeCurrencyList.filter(function (x) {
        return x.code === _this2.chargeCurrency;
      })[0];
      this.DepositService.deposit.changeChargeCurrency();
    }
  }, {
    key: 'zipLink',
    value: function zipLink() {
      this.$window.open('http://www.buscacep.correios.com.br/servicos/dnec/index.do', '_blank_');
    }

    // source http://nadikun.com/how-to-validate-cpf-number-using-custom-method-in-jquery-validate-plugin/

  }, {
    key: 'validateDocument',
    value: function validateDocument() {
      var value = this.DepositService.deposit.ebanxDetail.document;
      if (!value) {
        this.DepositService.deposit.validDocument = false;
        return false;
      }
      if (this.DepositService.deposit.user.location.country.code === 'br') {
        // Removing special characters from value
        value = value.replace(/([~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/? ])+/g, '');

        // Checking value to have 11 digits only
        this.documentLength = value.length;
        if (value.length !== 11) {
          this.DepositService.deposit.validDocument = false;
          return false;
        }

        var sum = 0;
        var i = void 0;

        var firstCN = parseInt(value.substring(9, 10), 10);
        var secondCN = parseInt(value.substring(10, 11), 10);

        // Checking for dump data
        if (value === '' || value === '00000000000' || value === '11111111111' || value === '22222222222' || value === '33333333333' || value === '44444444444' || value === '55555555555' || value === '66666666666' || value === '77777777777' || value === '88888888888' || value === '99999999999') {
          this.DepositService.deposit.validDocument = false;
          return false;
        }

        // Step 1 - using first Check Number:
        for (i = 1; i <= 9; i++) {
          sum += parseInt(value.substring(i - 1, i), 10) * (11 - i);
        }

        // If first Check Number (CN) is valid, move to Step 2 - using second Check Number:
        if (this.checkResult(sum, firstCN)) {
          sum = 0;
          for (i = 1; i <= 10; i++) {
            sum += parseInt(value.substring(i - 1, i), 10) * (12 - i);
          }
          this.DepositService.deposit.validDocument = this.checkResult(sum, secondCN);
          return this.DepositService.deposit.validDocument;
        }
        this.DepositService.deposit.validDocument = false;
        return false;
      }
    }
  }, {
    key: 'checkResult',
    value: function checkResult(sum, cn) {
      var result = sum * 10 % 11;
      if (result === 10 || result === 11) {
        result = 0;
      }
      return result === cn;
    }
  }, {
    key: 'setupBilling',
    value: function setupBilling(test) {
      var _this3 = this;

      if (!test) {
        this.DepositService.deposit.billing = new this.Billing(this.flnBillingBaseUrl, this.$window, this.DepositUserInfo.getIframeUrl, {
          pan: document.getElementById('iframe-payment-method-pan'),
          cvv: document.getElementById('iframe-payment-method-cvv'),
          expiry: document.getElementById('iframe-payment-method-expiry'),
          name: document.getElementById('iframe-payment-method-name')
        });
        this.DepositService.deposit.billing.setCallback(function (data) {
          _this3.receiveMessage(data);
        });
      }
    }

    // handler for messages from billing sdk

  }, {
    key: 'handleMessage',
    value: function handleMessage(data) {
      var _this4 = this;

      this.Analytics.trackEvent('DepositV3', 'CreditCard', 'CreditCard', 'change', JSON.stringify(data), 'CreditCardChanged');
      if ('pan' in data || 'cvv' in data) {
        if (data.pan.length === 6 && data.pan !== this.DepositService.deposit.data.pan) {
          this.DepositService.deposit.data.pan = data.pan;
          this.DepositService.deposit.data.card = data.card;
        }
        this.DepositService.deposit.data.pan.valid = data.pan.valid;
        this.DepositService.deposit.data.pan.length = data.pan.length;
        this.DepositService.deposit.data.last4 = data.last4;
        this.DepositService.deposit.billing.style({ pan: data.pan.valid });
        this.DepositService.deposit.data.cvv.valid = data.cvv.valid;
        this.DepositService.deposit.data.cvv.length = data.cvv.length;
        this.DepositService.deposit.billing.style({ cvv: data.cvv.valid });
        if (data.pan.length > 6) {
          this.$http.get('/ajax/payment/iin.php', { params: { iin: data.iin } }).then(function (response) {
            _this4.setBin(response);
          }).catch(function (e) {
            _this4.Analytics.trackEvent('DepositV3', 'CreditCard', 'BIN', 'error', JSON.stringify(e), data.iin);
            _this4.DepositService.deposit.showNativeCharge = false;
          });
        } else {
          this.DepositService.deposit.showNativeCharge = false;
        }
      } else if ('name' in data) {
        this.DepositService.deposit.data.name.model = data.name;
        this.DepositService.deposit.data.name.valid = data.valid;
        this.DepositService.deposit.billing.style({ name: data.valid });
      } else if ('year' in data || 'month' in data) {
        this.DepositService.deposit.data.expiry.month = data.month;
        this.DepositService.deposit.data.expiry.year = data.year;
        this.DepositService.deposit.data.expiry.valid = data.valid;
        this.DepositService.deposit.billing.style({ expiry: data.valid });
      }
      this.$scope.$apply();
    }
  }, {
    key: 'setBin',
    value: function setBin(response) {
      this.DepositService.deposit.ccIssuingCurrency = response.data.currency;
      this.chargeCurrency = response.data.currency.code;
      this.DepositService.deposit.ccChargeCurrency = response.data.currency;
      this.DepositService.deposit.ccChargeCurrency.id = parseInt(this.DepositService.deposit.ccChargeCurrency.id, 10);
      this.DepositService.deposit.changeChargeCurrency();
      if (this.DepositService.deposit.type === 'fln_billing' && this.DepositService.deposit.ccIssuingCurrency && this.DepositService.deposit.ccIssuingCurrency.code != this.DepositService.deposit.currency.code) {
        this.DepositService.deposit.showNativeCharge = true;
      } else {
        this.DepositService.deposit.showNativeCharge = false;
      }
    }
  }, {
    key: 'receiveMessage',
    value: function receiveMessage(data) {
      this.handleMessage(data);
    }
  }, {
    key: 'validate',
    value: function validate(field) {
      return field.valid && this.card && this.cards[this.card][field.name].lengths.includes(field.length);
    }

    /**
     * @ngdoc method
     * @name deposit.CCDepositController#initial
     *
     * @description
     * Operations needs to be done for time user switch to cc tab
     * These will be used to update the deposit statement and amount panel
     *
     */

  }, {
    key: 'initial',
    value: function initial() {
      var _this5 = this;

      var depositObj = this.DepositManager.getDepositObject();
      this.config = this.DepositManager.getVars();
      this.chargeCurrency = this.DepositService.deposit.ccChargeCurrency.code;
      if (this.allowCC === true) {
        depositObj.type = 'fln_billing';
        depositObj.action = 'getPostForm';
      } else {
        depositObj.type = 'paypal';
        depositObj.action = 'setExpressCheckout';
      }
      this.ccLoaded = false;
      if (typeof this.config.tab === 'undefined') {
        this.config.tab = 'fln_billing';
      }
      if (!this.Verification) ;
      this.exchangerate = this.DepositUserInfo.getExchangeRate();
      this.DepositService.deposit.handleSetupCallback = function (r) {
        if (_this5.allowCC) {
          _this5.pan = _this5.$sce.trustAsResourceUrl(r.url);
          _this5.DepositService.deposit.data.pan.valid = null;
          _this5.DepositService.deposit.data.name.valid = null;
          _this5.DepositService.deposit.data.expiry.valid = null;
          _this5.DepositService.deposit.data.cvv.valid = null;
        } else if (!document.documentMode) {
          _this5.DepositService.deposit.popup.location.href = r.url;
          _this5.DepositService.deposit.data.postcode.valid = null;
        } else {
          _this5.$window.location.href = r.url;
        }
        _this5.DepositService.deposit.processing = false;
        _this5.DepositService.deposit.showNativeCharge = false;
      };
    }
  }]);

  return NewCcDeposit;
}();

NewCcDeposit.$inject = ['$scope', '$window', '$sce', '$http', '$rootScope', 'NewDepositUserInfo', 'NewDepositManager', 'Analytics'];

var flCcDeposit = flComponent$1(NewCcDeposit, {
  selector: 'fl-new-cc-deposit',
  template: template$10,
  providers: [NewDepositManagerProvider, NewDepositUserInfoProvider, AnalyticsModule, creditCard$1, flCurrencySelector],
  bindings: {
    DepositService: '=deposit',
    Verification: '=verification',
    Recurring: '=recurring'
  }
});

/**
 * @ngdoc filter
 * @name deposit.depositCurrencyListFilter
 * @module deposit
 *
 * @description
 * filter out the currencies that are not supported by provided method
 * @param {array} currencyList List of currency object
 * @param {string} depositMethod Depoist method
 * @param {Object} Object of DepositFeeConfigListFactory
 */
function depositCurrencyListFilter() {
  return function (currencyList, depositMethod, feeConfig) {
    var results = [];
    angular$1.forEach(currencyList, function (currency$$1) {
      if (feeConfig.get(currency$$1.id, depositMethod) && !currency$$1.is_external) {
        results.push(currency$$1);
      }
    });
    return results;
  };
}

depositCurrencyListFilter.$inject = [];
depositCurrencyListFilter.$inject = [];
var depositCurrencyListFilter$1 = flFilter$1('depositCurrencyListFilter', [], depositCurrencyListFilter);

/**
 * @ngdoc directive
 * @name deposit.directive:flDisabledCurrencyCheck
 * @restrict A
 * @description
 * Validate if the ngModel match the disabled currency
 * <select ng-model="currencyCode"
 *   fl-disabled-currency-check="{[{disabledCurrency}]}">
 */

var DisabledCurrencyCheck = function () {
  function DisabledCurrencyCheck() {
    _classCallCheck(this, DisabledCurrencyCheck);
  }

  _createClass(DisabledCurrencyCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ctrl) {
      if (!ctrl) {
        return;
      }
      var disabledCurrency = this.flDisabledCurrencyCheck;
      ctrl.$validators.disabledCurrencyCheck = function (modelValue, viewValue) {
        return viewValue !== disabledCurrency;
      };
      ctrl.$validate();

      scope.$watch('flDisabledCurrencyCheck', function () {
        disabledCurrency = this.flDisabledCurrencyCheck;
        ctrl.$validate();
      });
    }
  }]);

  return DisabledCurrencyCheck;
}();

var disabledCurrencyCheck = flDirective$1(DisabledCurrencyCheck, {
  selector: '[fl-disabled-currency-check]',
  require: 'ngModel',
  scope: {
    flDisabledCurrencyCheck: '@'
  }
});

var IgnoreMouseWheel = function IgnoreMouseWheel() {
  _classCallCheck(this, IgnoreMouseWheel);
};

var ignoreMouseWheel = flDirective$1(IgnoreMouseWheel, {
  selector: '[fl-ignore-mouse-wheel]',
  link: function link(scope, element) {
    element.bind('mousewheel', function () {
      element.blur();
    });
  }
});

var template$11 = "<form class=\"fl-form\" name=\"NewDepositAmountPanel.feeForm\" novalidate\n    ng-submit=\"NewDepositAmountPanel.feeForm.$valid && NewDepositAmountPanel.routeToAction() && NewDepositAmountPanel.deposit.boletoForm.$valid\">\n    <div class=\"PagePayments-summary\" ng-class=\"{'PagePayments-summary-payByBalance': NewDepositAmountPanel.payByBalance === true}\">\n        <header class=\"PagePayments-summary-header\" ng-if=\"!(NewDepositAmountPanel.deposit.showChargeCurrency && NewDepositAmountPanel.deposit.type === 'fln_billing' && (NewDepositAmountPanel.modal || NewDepositAmountPanel.deposit.hiddenDepositAmount))\">\n            <label for=\"currency\" class=\"PaymentMethod-form-label PaymentMethod-form-depositCurrency\" ng-if=\"!NewDepositAmountPanel.payByBalance\">Deposit Currency</label>\n            <div class=\"PagePayments-currency\" ng-if=\"!NewDepositAmountPanel.payByBalance\">\n                <span class=\"PagePayments-currency-flag small-flag\"\n                ng-class=\"NewDepositAmountPanel.deposit.flagMap[NewDepositAmountPanel.deposit.currency.country].name.toLowerCase().replace(' ', '-')\"></span>\n                <select fl-analytics=\"Currency\" name=\"currency\" id=\"currency\" data-uitest-target=\"newdep-currency-dropdown\" class=\"PagePayments-currency-select\" ng-change=\"NewDepositAmountPanel.changeDepositCurrency()\"\n                        name=\"currency\" ng-if=\"!NewDepositAmountPanel.verification\" ng-model=\"NewDepositAmountPanel.deposit.currencyCode\" fl-disabled-currency-check=\"{[{NewDepositAmountPanel.disabledCurrency}]}\" >\n                    <option ng-selected=\"{[{c.code == NewDepositAmountPanel.deposit.currency.code}]}\"\n                        ng-repeat=\"c in NewDepositAmountPanel.availableCurrencyList\"\n                        ng-disabled=\"c.disabled\"\n                        value=\"{[{c.code}]}\">{[{c.code}]} - {[{c.name}]}</option>\n                </select>\n            </div>\n        </header>\n        <div>\n          <table class=\"PagePayments-summary-table\" ng-if=\"!NewDepositAmountPanel.payByBalance && !NewDepositAmountPanel.modal\">\n            <tr>\n              <th></th>\n              <th class=\"PagePayments-summary-amount\">Amount</th>\n              <th class=\"PagePayments-summary-currency\">Currency</th>\n            </tr>\n            <tr class=\"PagePayments-summary-group form-step\" ng-class=\"{'is-invalid': NewDepositAmountPanel.feeForm.amount.$invalid || NewDepositAmountPanel.feeForm.currency.$invalid}\">\n              <td class=\"PagePayments-summary-column PagePayments-summary-key\">\n                Deposit Amount\n                <span fl-analytics=\"AmountMin\" ng-if=\"NewDepositAmountPanel.feeForm.amount.$error.min\"\n                      class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                      data-tooltip=\"Please make sure deposit amount is greater than {[{NewDepositAmountPanel.minimum}]}\" i18n-data-tooltip>\n                    <fl-icon name=\"ui-warning\"></fl-icon>\n                </span>\n                <span fl-analytics=\"AmountMax\" ng-if=\"NewDepositAmountPanel.feeForm.amount.$error.max\"\n                      class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                      data-tooltip=\"Please make sure deposit amount is less than {[{NewDepositAmountPanel.feeConfig.max_amount}]}\" i18n-data-tooltip>\n                    <fl-icon name=\"ui-warning\"></fl-icon>\n                </span>\n                <span fl-analytics=\"AmountRequired\" ng-if=\"NewDepositAmountPanel.feeForm.amount.$error.required\"\n                      class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                      data-tooltip=\"Please specify your deposit amount\" i18n-data-tooltip>\n                    <fl-icon name=\"ui-warning\"></fl-icon>\n                </span>\n                <span fl-analytics=\"AmountInvalid\" ng-if=\"NewDepositAmountPanel.feeForm.amount.$error.number\"\n                      class=\"PaymentMethod-form-warningIcon Icon Tooltip--top\"\n                      data-tooltip=\"Please enter a valid number\" i18n-data-tooltip>\n                    <fl-icon name=\"ui-warning\"></fl-icon>\n                </span>\n              </td>\n              <td ng-if=\"!NewDepositAmountPanel.deposit.hiddenDepositAmount\" class=\"PagePayments-summary-column PagePayments-summary-amountBox\">\n                  <span class=\"input-group\">\n                    <span class=\"add-on\">{[{NewDepositAmountPanel.deposit.currency.sign}]}</span>\n                    <input fl-analytics=\"Amount\" ng-model=\"NewDepositAmountPanel.deposit.amount\" type=\"number\" name=\"amount\" step=\"0.01\"\n                      ng-change=\"NewDepositAmountPanel.updateFee()\"\n                      ng-model-options=\"{allowInvalid: true}\"\n                      ng-class=\"{'is-invalid': feeForm.amount.$invalid && NewDepositAmountPanel.feeForm.amount.$dirty}\"\n                      fl-ingore-mouse-wheel data-uitest-target=\"newdep-amount-field\"\n                      min=\"{[{NewDepositAmountPanel.minimum}]}\"\n                      max=\"{[{NewDepositAmountPanel.feeConfig.max_amount}]}\" id=\"deposit-amount\" class=\"default-input PagePayments-summary-input\" required>\n                  </span>\n              </td>\n              <td ng-if=\"NewDepositAmountPanel.deposit.hiddenDepositAmount\" class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{NewDepositAmountPanel.deposit.amount | number:2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.showChargeCurrency && NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject))\">\n              <td class=\"PagePayments-summary-column PagePayments-summary-key\">\n                <span class=\"PagePayments-summary-label PagePayments-summary-label--icon\">\n                  <strong>Exchanged Subtotal</strong>\n                  <span ng-if=\"NewDepositAmountPanel.deposit.hiddenDepositAmount\" fl-analytics=\"ExchangedSubtotalRate\" class=\"PagePayments-exchangeIcon Icon Icon--mid Tooltip--top Tooltip--med\" i18n-data-tooltip\n                  data-tooltip=\"(1 {[{NewDepositAmountPanel.deposit.itemCurrency.code}]} = {[{(NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id)).toPrecision(6)}]} {[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]})\">\n                      <fl-icon name=\"ui-help\"></fl-icon>\n                  </span>\n                  <span ng-if=\"!NewDepositAmountPanel.deposit.hiddenDepositAmount\" fl-analytics=\"ExchangedSubtotalRate\" class=\"PagePayments-exchangeIcon Icon Icon--mid Tooltip--top Tooltip--med\" i18n-data-tooltip\n                  data-tooltip=\"(1 {[{NewDepositAmountPanel.deposit.currency.code}]} = {[{(NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id)).toPrecision(6)}]} {[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]})\">\n                      <fl-icon name=\"ui-help\"></fl-icon>\n                  </span>\n                </span>\n              </td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{NewDepositAmountPanel.deposit.amount * NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id) | number:2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}</td>\n            </tr>\n            <tr ng-if=\"!NewDepositAmountPanel.payByBalance\">\n              <td class=\"PagePayments-summary-column PagePayments-summary-key\">Processing Fee\n                <span fl-analytics=\"Fee\" ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\" ng-show=\"NewDepositAmountPanel.deposit.fee > 0 && ['ideal', 'wire'].indexOf(NewDepositAmountPanel.deposit.type) === -1\"\n                  class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" i18n-data-tooltip\n                      data-tooltip=\"The fee is calculated as {[{NewDepositAmountPanel.deposit.currency.sign}]}{[{NewDepositAmountPanel.deposit.feeConfig.fee_fixed_amount.toFixed(2)}]} + {[{(NewDepositAmountPanel.deposit.feeConfig.fee_rate*100).toFixed(2)}]}% of the deposit amount.\">\n                      <fl-icon name=\"ui-help\"></fl-icon></span>\n                <span fl-analytics=\"Fee\" ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\"\n                  ng-show=\"NewDepositAmountPanel.deposit.fee > 0 && ['ideal', 'wire'].indexOf(NewDepositAmountPanel.deposit.type) === -1\"\n                  class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" i18n-data-tooltip\n                  data-tooltip=\"The fee is calculated as {[{NewDepositAmountPanel.deposit.ccChargeCurrency.sign}]}{[{NewDepositAmountPanel.feeCCChargeConfig.fee_fixed_amount.toFixed(2)}]} + {[{(NewDepositAmountPanel.feeCCChargeConfig.fee_rate*100).toFixed(2)}]}% of the deposit amount.\">\n                      <fl-icon name=\"ui-help\"></fl-icon></span>\n                <span fl-analytics=\"WireFee\" ng-show=\"NewDepositAmountPanel.deposit.type=='wire' && NewDepositAmountPanel.deposit.fee > 0\"\n                  class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" i18n-data-tooltip data-tooltip=\"Bank deposit processing fee. This is a fixed fee of {[{NewDepositAmountPanel.deposit.currency.sign}]}{[{NewDepositAmountPanel.deposit.fee}]}.\">\n                    <fl-icon name=\"ui-help\"></fl-icon>\n                </span>\n                <span fl-analytics=\"NoWireFee\" ng-show=\"NewDepositAmountPanel.deposit.type=='wire' && NewDepositAmountPanel.deposit.fee == 0\" i18n-data-tooltip\n                class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" data-tooltip=\"Bank deposit processing fee is Free!\">\n                    <fl-icon name=\"ui-help\"></fl-icon>\n                </span>\n                <span fl-analytics=\"IdealFee\" ng-show=\"NewDepositAmountPanel.deposit.type=='ideal' && NewDepositAmountPanel.deposit.fee > 0\" i18n-data-tooltip\n                class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" data-tooltip=\"iDEAL deposit processing fee. This is a fixed fee of {[{NewDepositAmountPanel.deposit.currency.sign}]}{[{NewDepositAmountPanel.deposit.fee}]}.\">\n                    <fl-icon name=\"ui-help\"></fl-icon>\n                </span>\n              </td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\" ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">{[{NewDepositAmountPanel.deposit.ccChargeFee | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\" ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">{[{NewDepositAmountPanel.deposit.fee | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\" ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id  && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">{[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\" ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\">\n              <td class=\"PagePayments-summary-column PagePayments-summary-key\"><strong>Total<strong></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\" ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\" data-uitest-target=\"newdep-total-deposit-amount\">{[{ NewDepositAmountPanel.deposit.amount * NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id) + NewDepositAmountPanel.deposit.ccChargeFee | currency:'':2 }]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\" ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\" data-uitest-target=\"newdep-total-deposit-amount\">{[{ (NewDepositAmountPanel.deposit.amount + NewDepositAmountPanel.deposit.fee) | currency:'':2 }]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\" ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\" ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">{[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}</td>\n            </tr>\n          </table>\n        </div>\n        <div ng-if=\"NewDepositAmountPanel.deposit.cartSummary && NewDepositAmountPanel.modal\">\n          <table class=\"PagePayments-summary-table\" ng-if=\"NewDepositAmountPanel.payByBalance\">\n            <tr>\n              <th></th>\n              <th class=\"PagePayments-summary-amount\">Amount</th>\n              <th class=\"PagePayments-summary-currency\">Currency</th>\n            </tr>\n            <tr ng-repeat=\"item in NewDepositAmountPanel.deposit.items.summary\" class=\"PagePayments-summary-group\">\n              <td class=\"PagePayments-summary-column\">{[{item.descr}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{item.amount | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.itemCurrency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\">\n              <td class=\"PagePayments-summary-column\"><strong>Total<strong></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.items.itemTotal | currency:'':2 }]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n            </tr>\n          </table>\n          <table class=\"PagePayments-summary-table\" ng-if=\"!NewDepositAmountPanel.payByBalance\">\n            <tr>\n              <th></th>\n              <th class=\"PagePayments-summary-amount\">Amount</th>\n              <th class=\"PagePayments-summary-currency\">Currency</th>\n            </tr>\n            <tr ng-repeat=\"item in NewDepositAmountPanel.deposit.items.summary\" class=\"PagePayments-summary-group\">\n              <td class=\"PagePayments-summary-column\">{[{item.descr}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{item.amount | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.itemCurrency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.items.balance > 0\">\n              <td class=\"PagePayments-summary-column\">Less Equivalent Balance</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.items.balance | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.itemCurrency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.items.balance < 0\">\n              <td class=\"PagePayments-summary-column\">Outstanding Balance</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.items.balance * -1 | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.itemCurrency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.items.balance != 0 || NewDeopsitAmountPanel.deposit.items.summary.length > 1\">\n              <td class=\"PagePayments-summary-column\"><strong>Subtotal<strong></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.itemAmount | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.itemCurrency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.itemCurrency.id!==NewDepositAmountPanel.deposit.currency.id\">\n              <td class=\"PagePayments-summary-column\"><strong>Exchanged Subtotal</strong>\n                <span fl-analytics=\"ExchangedSubtotalRate\" class=\"PagePayments-exchangeIcon Icon Icon--mid Tooltip--top Tooltip--med\" i18n-data-tooltip\n                data-tooltip=\"(1 {[{NewDepositAmountPanel.deposit.itemCurrency.code}]} = {[{(NewDepositAmountPanel.deposit.conversionRate / 100).toPrecision(6)}]} {[{NewDepositAmountPanel.deposit.currency.code}]})\">\n                    <fl-icon name=\"ui-help\"></fl-icon>\n                </span>\n              </td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.amount | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n            </tr>\n            <tr ng-if=\"!NewDepositAmountPanel.payByBalance && NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">\n              <td class=\"PagePayments-summary-column\">Processing Fee\n                <span fl-analytics=\"Fee\" ng-show=\"NewDepositAmountPanel.deposit.fee > 0 && ['ideal', 'wire'].indexOf(NewDepositAmountPanel.deposit.type) === -1\"\n                  class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" i18n-data-tooltip data-tooltip=\"The fee is calculated as {[{NewDepositAmountPanel.deposit.currency.sign}]}{[{NewDepositAmountPanel.deposit.feeConfig.fee_fixed_amount.toFixed(2)}]} + {[{(NewDepositAmountPanel.deposit.feeConfig.fee_rate*100).toFixed(2)}]}% of the deposit amount.\">\n                      <fl-icon name=\"ui-help\"></fl-icon></span></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{NewDepositAmountPanel.deposit.fee | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">\n              <td class=\"PagePayments-summary-column\"><strong>Total<strong></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.amount + NewDepositAmountPanel.deposit.fee | currency:'':2 }]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.currency.code}]}</td>\n            </tr>\n\n\n            <tr class=\"PagePayments-summary-group\" ng-if=\"NewDepositAmountPanel.deposit.showChargeCurrency && NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject))\">\n              <td class=\"PagePayments-summary-column\"><strong>Exchanged Subtotal</strong>\n                <span fl-analytics=\"ExchangedSubtotalRate\" class=\"PagePayments-exchangeIcon Icon Icon--mid Tooltip--top Tooltip--med\" i18n-data-tooltip\n                data-tooltip=\"(1 {[{NewDepositAmountPanel.deposit.itemCurrency.code}]} = {[{(NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id)).toPrecision(6)}]} {[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]})\">\n                    <fl-icon name=\"ui-help\"></fl-icon>\n                </span>\n              </td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{ NewDepositAmountPanel.deposit.amount * NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id) | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}</td>\n            </tr>\n            <tr ng-if=\"!NewDepositAmountPanel.payByBalance && (NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">\n              <td class=\"PagePayments-summary-column\">Processing Fee\n                <span fl-analytics=\"Fee\" ng-show=\"NewDepositAmountPanel.deposit.fee > 0 && ['ideal', 'wire'].indexOf(NewDepositAmountPanel.deposit.type) === -1\"\n                  class=\"PagePayments-helpIcon Icon Icon--mid Tooltip--top\" i18n-data-tooltip data-tooltip=\"The fee is calculated as {[{NewDepositAmountPanel.deposit.currency.sign}]}{[{NewDepositAmountPanel.deposit.feeConfig.fee_fixed_amount.toFixed(2)}]} + {[{(NewDepositAmountPanel.deposit.feeConfig.fee_rate*100).toFixed(2)}]}% of the deposit amount.\">\n                      <fl-icon name=\"ui-help\"></fl-icon></span></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\">{[{NewDepositAmountPanel.deposit.ccChargeFee | currency:'':2}]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}</td>\n            </tr>\n            <tr class=\"PagePayments-summary-group\" ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">\n              <td class=\"PagePayments-summary-column\"><strong>Total<strong></td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-amount\" data-uitest-target=\"newdep-total-deposit-amount\">{[{ NewDepositAmountPanel.deposit.amount * NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id) + NewDepositAmountPanel.deposit.ccChargeFee | currency:'':2 }]}</td>\n              <td class=\"PagePayments-summary-column PagePayments-summary-currency\">{[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}</td>\n            </tr>\n          </table>\n        </div>\n        <button ng-if=\"!NewDepositAmountPanel.payByBalance\" fl-analytics=\"Submit\" type=\"submit\" data-uitest-target=\"newdep-confirm-button\" class=\"PagePayments-summary-btn btn btn-xlarge btn-info btn-block\"\n        ng-class=\"{processing: NewDepositAmountPanel.deposit.processing}\"\n        ng-click=\"NewDepositAmountPanel.validateForms()\"\n        ng-disabled=\"!NewDepositAmountPanel.feeReady || NewDepositAmountPanel.feeForm.amount.$invalid || NewDepositAmountPanel.feeForm.currency.$invalid ||\n              (NewDepositAmountPanel.deposit.boletoForm.$invalid && NewDepositAmountPanel.deposit.type === 'boleto') ||\n              NewDepositAmountPanel.deposit.processing\">\n          <span ng-if=\"NewDepositAmountPanel.deposit.ccChargeCurrency.id==NewDepositAmountPanel.deposit.currency.id || !(NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">\n            Confirm {[{\n            NewDepositAmountPanel.deposit.amount + NewDepositAmountPanel.deposit.fee\n            | currency:NewDepositAmountPanel.deposit.currency.sign:2\n            }]}\n             {[{NewDepositAmountPanel.deposit.currency.code}]}\n          </span>\n          <span ng-if=\"(NewDepositAmountPanel.deposit.ccChargeCurrency.id!=NewDepositAmountPanel.deposit.currency.id && NewDepositAmountPanel.deposit.showChargeCurrency &&\n              (NewDepositAmountPanel.deposit.type === 'fln_billing' || (NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject)))\">\n            Confirm {[{\n            NewDepositAmountPanel.deposit.amount * NewDepositAmountPanel.rate(NewDepositAmountPanel.deposit.ccChargeCurrency.id) + NewDepositAmountPanel.deposit.ccChargeFee\n            | currency:NewDepositAmountPanel.deposit.ccChargeCurrency.sign:2\n            }]}\n             {[{NewDepositAmountPanel.deposit.ccChargeCurrency.code}]}\n          </span>\n        </button>\n        <button ng-if=\"NewDepositAmountPanel.payByBalance\" fl-analytics=\"Submit\" type=\"submit\" data-uitest-target=\"newdep-confirm-button\" class=\"PagePayments-summary-btn btn btn-xlarge btn-info btn-block\"\n        ng-class=\"{processing: NewDepositAmountPanel.deposit.processing}\"\n        ng-click=\"NewDepositAmountPanel.validateForms()\"\n        ng-disabled=\"!NewDepositAmountPanel.feeReady || NewDepositAmountPanel.feeForm.amount.$invalid || NewDepositAmountPanel.feeForm.currency.$invalid ||\n              (NewDepositAmountPanel.deposit.boletoForm.$invalid && NewDepositAmountPanel.deposit.type === 'boleto') ||\n              NewDepositAmountPanel.deposit.processing\">\n        Confirm {[{\n              NewDepositAmountPanel.deposit.items.itemTotal\n              | currency:NewDepositAmountPanel.deposit.currency.sign:2\n              }]}\n               {[{NewDepositAmountPanel.deposit.currency.code}]}</button>\n        <div ng-if=\"!NewDepositAmountPanel.payByBalance\">\n          <div ng-if=\"NewDepositAmountPanel.deposit.type === 'fln_billing' && !NewDepositAmountPanel.deposit.agreementObject\">\n            <div class=\"PagePayments-summary-footer\">\n                You agree to authorize the use of your card for this deposit and future payments.\n            </div>\n          </div>\n          <div ng-if=\"NewDepositAmountPanel.deposit.type === 'paypal_reference' && !NewDepositAmountPanel.deposit.agreementObject\">\n            <div class=\"PagePayments-summary-footer\">\n                You agree to authorize the use of your PayPal account for this deposit and future payments.\n            </div>\n          </div>\n          <div ng-if=\"NewDepositAmountPanel.deposit.type === 'paypal_reference' && !NewDepositAmountPanel.deposit.agreementObject\">\n            <div class=\"PagePayments-summary-footer\">\n                PayPal does not support Prepaid and gift cards as a funding source.\n            </div>\n          </div>\n          <div class=\"PagePayments-customCharge\" ng-show=\"['union_pay', 'alipay', 'wechatpay'].indexOf(NewDepositAmountPanel.deposit.type) !== -1 && NewDepositAmountPanel.deposit.currency.code !== 'CNY'\">\n              Your account will be charged in CNY. (1.00 {[{NewDepositAmountPanel.deposit.currency.code}]} = {[{NewDepositAmountPanel.nativeRate('CNY') | number:6}]} CNY)\n          </div>\n          <div class=\"PagePayments-customCharge\" ng-show=\"NewDepositAmountPanel.deposit.type === 'boleto' && NewDepositAmountPanel.deposit.currency.code !== 'BRL'\">\n              You will be charged in BRL. (1.00 {[{NewDepositAmountPanel.deposit.currency.code}]} = {[{NewDepositAmountPanel.nativeRate('BRL') | number:6}]} BRL)\n          </div>\n        </div>\n        </div>\n\n    </div>\n          <div ng-if=\"NewDepositAmountPanel.deposit.cartSummary && NewDepositAmountPanel.deposit.showNativeCharge && !NewDepositAmountPanel.deposit.agreementObject\">\n            <div class=\"PagePayments-charge\" ng-show=\"!NewDepositAmountPanel.deposit.showChargeCurrency && (!NewDepositAmountPanel.forceINR || NewDepositAmountPanel.deposit.ccIssuingCurrency.code !== 'INR')\">\n              <input class=\"PagePayments-charge-checkbox\" fl-analytics=\"NativeCharge\" type=\"checkbox\" ng-model=\"NewDepositAmountPanel.ccNativeCharge\" id=\"currency-charge-verify\">\n              <label class=\"PagePayments-charge-label\" for=\"currency-charge-verify\">\n                Charge my card in {[{NewDepositAmountPanel.deposit.ccIssuingCurrency.code}]}.\n                  (1.00 {[{NewDepositAmountPanel.deposit.currency.code}]} = {[{NewDepositAmountPanel.nativeRate(NewDepositAmountPanel.deposit.ccIssuingCurrency.code).toPrecision(5)}]} {[{NewDepositAmountPanel.deposit.ccIssuingCurrency.code}]})\n              </label>\n            </div>\n            <div class=\"PagePayments-customCharge\" ng-show=\"NewDepositAmountPanel.forceINR && NewDepositAmountPanel.deposit.ccIssuingCurrency.code === 'INR'\">\n              Your card will be charged in INR.\n              <div>\n                (1.00 {[{NewDepositAmountPanel.deposit.currency.code}]} = {[{NewDepositAmountPanel.nativeRate(NewDepositAmountPanel.deposit.ccIssuingCurrency.code) | number:6}]} {[{NewDepositAmountPanel.deposit.ccIssuingCurrency.code}]})\n              </div>\n            </div>\n          </div>\n          <div class=\"PagePayments-customCharge\" ng-if=\"!NewDepositAmountPanel.deposit.showChargeCurrency && NewDepositAmountPanel.deposit.cartSummary && NewDepositAmountPanel.deposit.type === 'paypal_reference' && NewDepositAmountPanel.deposit.agreementObject.currency.id && NewDepositAmountPanel.deposit.agreementObject.currency.id != NewDepositAmountPanel.deposit.currency.id\">\n            <div>\n                Your card will be charged in {[{NewDepositAmountPanel.deposit.agreementObject.currency.code}]}.\n                  (1.00 {[{NewDepositAmountPanel.deposit.currency.code}]} =\n                  {[{NewDepositAmountPanel.nativeRate(NewDepositAmountPanel.deposit.agreementObject.currency.code).toPrecision(5)}]} {[{NewDepositAmountPanel.deposit.agreementObject.currency.code}]})\n            </div>\n          </div>\n          <div class=\"PagePayments-customCharge\" ng-if=\"!NewDepositAmountPanel.deposit.showChargeCurrency && NewDepositAmountPanel.deposit.cartSummary && NewDepositAmountPanel.deposit.type === 'fln_billing' && NewDepositAmountPanel.deposit.agreementObject.currency && NewDepositAmountPanel.deposit.agreementObject.currency != NewDepositAmountPanel.deposit.currency.id\">\n            <div>\n                Your card will be charged in {[{NewDepositAmountPanel.deposit.agreementObject.code}]}.\n                  (1.00 {[{NewDepositAmountPanel.deposit.currency.code}]} =\n                  {[{NewDepositAmountPanel.nativeRate(NewDepositAmountPanel.deposit.agreementObject.code).toPrecision(5)}]} {[{NewDepositAmountPanel.deposit.agreementObject.code}]})\n            </div>\n          </div>\n        </div>\n    </div>\n</form>\n<ul ng-if=\"!NewDepositAmountPanel.payByBalance\" class=\"PagePayments-securityLogos\">\n    <li fl-analytics=\"VerifiedByVisa\" class=\"PagePayments-securityLogos-item\">\n        <span class=\"PaymentSecurityLogo PaymentSecurityLogo--visa\">\n          <span class=\"is-accessibly-hidden\">Verified by Visa</span>\n        </span>\n    </li>\n    <li fl-analytics=\"MastercardSecureCode\" class=\"PagePayments-securityLogos-item\">\n        <span class=\"PaymentSecurityLogo PaymentSecurityLogo--mastercard\">\n          <span class=\"is-accessibly-hidden\">Mastercard SecureCode</span>\n        </span>\n    </li>\n</ul>\n\n<div class=\"DepositConfirmation\" ng-show=\"NewDepositAmountPanel.deposit.showMask\">\n  <div class=\"DepositConfirmation-dialog is-active\">\n    <span ng-if=\"NewDepositAmountPanel.deposit.type==='paypal_reference'\" class=\"PaymentIcon PaymentIcon--paypal\"></span>\n    <p ng-if=\"NewDepositAmountPanel.deposit.type==='paypal_reference'\">Don't see the secure PayPal window?</p>\n    <span ng-if=\"NewDepositAmountPanel.deposit.type==='wechatpay'\" class=\"PaymentIcon PaymentIcon--wechatpay\"></span>\n    <p ng-if=\"NewDepositAmountPanel.deposit.type==='wechatpay'\">Don't see the secure WeChat Pay window?</p>\n    <button class=\"PagePayments-summary-btn btn btn-large btn-info btn-block\"\n      ng-click=\"NewDepositAmountPanel.refocusPopup()\">Show the window\n    </button>\n  </div>\n  <a class=\"DepositConfirmation-closeBtn Icon\" role=\"button\"\n  ng-click=\"NewDepositAmountPanel.closePopup()\">\n    <fl-icon name=\"ui-close\"></fl-icon>\n  </a>\n</div>\n<div class=\"DepositConfirmation\" ng-show=\"NewDepositAmountPanel.deposit.show3DSMask\">\n  <div class=\"DepositConfirmation-dialog is-active\">\n    <span class=\"PaymentIcon PaymentIcon--{[{NewDepositAmountPanel.deposit.data.card}]}\"></span>\n    <p>Your bank requires additional verification. You will be shown a new window to complete the transaction.</p>\n    <button class=\"PagePayments-summary-btn btn btn-large btn-info btn-block\"\n      ng-click=\"NewDepositAmountPanel.show3DS()\">Ok\n    </button>\n  </div>\n  <a class=\"DepositConfirmation-closeBtn Icon\" role=\"button\"\n  ng-click=\"NewDepositAmountPanel.close3DSPopup()\">\n    <fl-icon name=\"ui-close\"></fl-icon>\n  </a>\n</div>\n";

/**
* @ngdoc directive
* @name deposit.directive:flDepositAmountPanel
* @restrict E
* @description
* A directive to provide user a form to enter the deposit amount, currency
* and submit button
* @param {Object} deposit, object of deposit
*          {amount: 30, fee:0, type:'paypal', currency: {}}
* @param {Object} alert, object of the alert { {
            show: false,
            type:'',
            title:'',
            message: '',
            handle: function(type, title, message, show) {
                $scope.show = show;
                $scope.type = type;
                $scope.alerts.title = title;
                $scope.alerts.message = message;
            },
            setShow: function(show) {
                $scope.show = show;
            }}
* @param {array} countryList, List of the countries
* @param {Object} currencies
* @param {Object} back, object of the back urls
*  {back:'back', origin_back: 'origin'}
* @param {String} callback, callback function after setup() is executed
* @param {String} action, identify the action, setup() or authorize()
* @param {Bool} setupOnInit, flag for triggering setup call on init
* @param {Object} refRequests, object of the recurring requests
* @param {String} tab, parent's tab name
* @param {String} iframeId, dom id for credit card iframe
* @param {String} cardholderNameId, dom id for cardholder name field
* @param {String} expiryId, dom id for expiry field
* @param {Bool} autoReload, flag for auto reload
* @param {Bool} showCountry, flag for show the country markup in the template
* @example
* <fl-deposit-amount-panel auto-reload='true'
*   iframe-id='iframe-payment-method-cc'
*   cardholder-name-id='cc-name'
*   expiry-id='cc-expiry'
*   currencies='config.currencies'
*   back='config.backUrls' deposit='deposit'
*   alerts='alerts' currency-list='config.currencyList'
*   country='country' callback='handleSetupCallback'
*   setup-on-init='1' action='{[{cc.action}]}'
*   ref-requests='refRequests'>
* </fl-deposit-amount-panel>
*/
function NewDepositAmountPanel($scope, $filter, $rootScope, $timeout, $window, $http, Deposits, NewDepositManager, NewDepositUserInfo, Analytics) {
  var _this = this;

  /**
   * @ngdoc method
   * @name deposit.directive:flDepositAmountPanel#routeToAction
   * @methodOf deposit.directive:flDepositAmountPanel
   * @description
   * A method to route the correct operation
   * depends on the action
   * 'authorize' means calling authorize
   * 'confirm' only for fln-billing to submit iframe form
   * the rest will be the setup call
   */
  this.routeToAction = function () {
    if (_this.payByBalance) {
      _this.deposit.processing = true;
      setTimeout(function () {
        _this.deposit.closeWindow = true;
        $scope.$apply();
        setTimeout(function () {
          _this.deposit.success();
          _this.deposit.cancel();
          _this.deposit.processing = false;
        }, 500);
      }, 2000);
      return;
    }
    if (_this.action === 'authorize') {
      _this.authorize();
    } else if (_this.action === 'confirm') {
      _this.deposit.processing = true;
      if (!_this.verification) {
        localStorage.setItem('result_back_url', _this.back.realBack.encode);
      }
      _this.deposit.data.creditCardForm.valid = true;
      if (!_this.deposit.data.expiry.valid) {
        _this.deposit.data.creditCardForm.valid = false;
        _this.deposit.data.expiry.valid = false;
        _this.deposit.processing = false;
      }
      if (!_this.deposit.data.pan.valid) {
        _this.deposit.data.creditCardForm.valid = false;
        _this.deposit.data.pan.valid = false;
        _this.deposit.processing = false;
      }
      if (!_this.deposit.data.name.valid) {
        _this.deposit.data.creditCardForm.valid = false;
        _this.deposit.data.name.valid = false;
        _this.deposit.processing = false;
      }
      if (!_this.deposit.data.cvv.valid) {
        _this.deposit.data.creditCardForm.valid = false;
        _this.deposit.data.cvv.valid = false;
        _this.deposit.processing = false;
      }
      if (_this.forceAVS) {
        if (!_this.deposit.data.postcode.valid) {
          _this.deposit.data.creditCardForm.valid = false;
          _this.deposit.data.postcode.valid = false;
          _this.deposit.processing = false;
          return;
        }
      }
      _this.extraData = {};
      if (_this.ccNativeCharge && _this.deposit.showNativeCharge && _this.deposit.ccIssuingCurrency) {
        _this.extraData['fx-issuing-currency'] = _this.deposit.ccIssuingCurrency.code;
      }

      if (_this.deposit.ccChargeCurrency && _this.deposit.showChargeCurrency) {
        _this.extraData['fx-issuing-currency'] = _this.deposit.ccChargeCurrency.code;
      }

      if (_this.forceAVS) {
        _this.extraData.postcode = _this.deposit.data.postcode.code;
      }
      if (_this.ebanxEligible) {
        if (_this.deposit.ebanxForm.$invalid || _this.deposit.ebanxDetail.document && !_this.deposit.validDocument) {
          _this.deposit.ebanxSubmit = true;
          _this.deposit.processing = false;
          return;
        }
        _this.extraData.ebanxAddress = _this.deposit.ebanxDetail.address;
        _this.extraData.ebanxCity = _this.deposit.ebanxDetail.city;
        _this.extraData.ebanxCountryCode = _this.deposit.ebanxDetail.countrycode;
        _this.extraData.ebanxCurrencyCode = _this.deposit.currency.code;
        if (_this.deposit.ebanxDetail.document) {
          _this.extraData.ebanxDocument = _this.deposit.ebanxDetail.document;
        }
        _this.extraData.ebanxEmail = _this.deposit.ebanxDetail.email;
        _this.extraData.ebanxPhone = _this.deposit.ebanxDetail.phone;
        _this.extraData.ebanxState = _this.deposit.ebanxDetail.state;
        _this.extraData.ebanxStreetComplement = _this.deposit.ebanxDetail.streetcomplement;
        _this.extraData.ebanxStreetNo = _this.deposit.ebanxDetail.streetno;
        _this.extraData.ebanxZip = _this.deposit.ebanxDetail.zip;
      }
      _this.deposit.billing.submit(_this.deposit.amount, _this.deposit.currency.code, _this.extraData);
    } else {
      _this.setup();
    }
  };

  this.updateChargeFee = function () {
    _this.deposit.processing = true;
    if (_this.deposit.showChargeCurrency && (_this.deposit.type === 'fln_billing' || _this.deposit.type === 'paypal_reference' && _this.deposit.agreementObject)) {
      var countryCode = _this.deposit.country ? _this.deposit.country.code : undefined;

      if (_this.deposit.agreementObject) {
        if (!_this.deposit.agreementCurrencies[_this.deposit.agreementObject.token]) {
          _this.deposit.agreementCurrencies[_this.deposit.agreementObject.token] = _this.deposit.agreementObject.currency_id;
        } else if (_this.deposit.agreementCurrencies[_this.deposit.agreementObject.token]) {
          _this.deposit.agreementCurrencies[_this.deposit.agreementObject.token] = _this.deposit.ccChargeCurrency.id;
        }
        // make sure paypal charge currency is one available to paypal,
        // use whatevers in the dropdown first otherwise pick agreement currency
        _this.deposit.ccChargeCurrency = _this.deposit.availableCCFirstTimeCurrencyList.filter(function (x) {
          return x.id === _this.deposit.agreementCurrencies[_this.deposit.agreementObject.token];
        })[0];
      }
      // setting the model of currency-selector
      _this.deposit.chargeCurrency = _this.deposit.ccChargeCurrency.code;
      NewDepositManager.initFeesConfigFactory(_this.deposit.type, countryCode).then(function (feeConfigsFactory) {
        _this.feeConfigsFactory = feeConfigsFactory;
        _this.feeCCChargeConfig = _this.feeConfigsFactory.get(_this.deposit.ccChargeCurrency.id, _this.deposit.type).get();
        _this.deposit.ccChargeFee = NewDepositManager.getFee(_this.deposit.amount * _this.rate(_this.deposit.ccChargeCurrency.id), _this.feeCCChargeConfig);
      }).catch(function (e) {
        _this.alerts.setPreDepositError(e.data ? e.data.message : e);
        _this.deposit.processing = false;
      });
    }
    _this.deposit.processing = false;
  };

  /**
   * @ngdoc method
   * @name deposit.directive:flDepositAmountPanel#updateFee
   * @methodOf deposit.directive:flDepositAmountPanel
   * @description
   * A method to calculate the FLN charged deposit fee amount.
   */
  this.updateFee = function () {
    // Force the user to have 2 decimals.
    if (_this.deposit.amount) {
      _this.deposit.amount = parseFloat(_this.deposit.amount.toFixed(2));
    }
    if (!_this.feeConfig) {
      return;
    }
    // flag to disable the submit button in fee calculation
    _this.feeReady = false;
    _this.deposit.fee = NewDepositManager.getFee(_this.deposit.amount, _this.feeConfig);
    _this.updateChargeFee();

    _this.feeReady = true;
  };

  // This returns whether the amount-panel should hide the currency selector
  // condition is first time CC deposit and AB Test condition
  this.hideDepositCurrency = function () {
    return _this.deposit.type === 'fln_billing' && !_this.deposit.agreementObject && _this.deposit.hiddenDepositAmount && _this.deposit.showChargeCurrency;
  };

  /**
   * @ngdoc method
   * @name deposit.directive:flDepositAmountPanel#setDepositConfig
   * @description
   * Update deposit config based on deposit currency & deposit type.
   * this.depositConfig = {
   *   currency_id:
   *   deposit_method:
   *   fee_fixed_amount:
   *   fee_rate:
   *   max_amount:
   *   min_amount:
   * }
   */
  this.updateFeeConfig = function () {
    _this.fxrate = NewDepositUserInfo.getExchangeRate();
    _this.cartCurrency = NewDepositUserInfo.getCartCurrency();
    _this.cartAmount = NewDepositUserInfo.getCartAmount();
    if (_this.cartCurrency && _this.cartCurrency.id !== _this.deposit.currency.id) {
      Analytics.trackEvent('DepositPage', 'ChangeCurrency', _this.cartCurrency.id, 'change', _this.deposit.currency.id, undefined);
    }
    if (_this.hideDepositCurrency()) {
      _this.deposit.currency = _this.cartCurrency;
      _this.deposit.currencyCode = _this.cartCurrency.code;
    }
    if (_this.prefillFxDepositAmount) {
      _this.prefillFx();
    }
    if (_this.disabledCurrency === _this.deposit.currency.code) {
      _this.deposit.fee = undefined;
      return;
    }
    _this.feeConfig = _this.feeConfigsFactory.get(_this.deposit.currency.id, _this.deposit.type).get();

    if (typeof _this.config !== 'undefined' && _this.config.showCloseBanner) {
      _this.feeConfig.min_amount = 0.01;
    }
    _this.minimum = _this.feeConfig.min_amount;
    if (_this.deposit.amount < _this.minimum && !_this.payByBalance && !_this.modal) {
      _this.deposit.ABTestApi.testSubjectActivate('hidden-deposit-amount', 'control');
      Analytics.trackEvent('DepositPage', 'DepositRedirect', 'AmountBelowMinimumReshow', 'change', undefined, 'ReshowAmountPanel');
    }
    if (_this.deposit.amount < 0) {
      _this.deposit.amount = _this.minimum;
    }
    _this.deposit.feeConfig = _this.feeConfig;
    _this.updateFee();
    _this.disableButton = false;
  };

  // close paypal popup
  this.closePopup = function () {
    _this.deposit.showMask = false;
    _this.deposit.popup.close();
    Analytics.trackEvent('DepositPage', 'PaypalPopupClose');
  };

  // refocus the popup
  this.refocusPopup = function () {
    if (_this.deposit.popup && !_this.deposit.popup.closed) {
      _this.deposit.popup.focus();
    }
    if (_this.deposit.threeDSPopup && !_this.deposit.threeDSPopup.closed) {
      _this.deposit.threeDSPopup.focus();
    }
  };

  this.close3DSPopup = function () {
    _this.deposit.show3DSMask = false;
    if (_this.deposit.threeDSPopup) {
      _this.deposit.threeDSPopup.close();
    }
    Analytics.trackEvent('DepositPage', '3DSPopupClose');
    $rootScope.$broadcast('asyncDepositDone');
  };

  this.show3DS = function () {
    // exclude IE11
    var x = $window.top.outerWidth / 2 + $window.top.screenX - 437 / 2;
    var y = $window.top.outerHeight / 2 + $window.top.screenY - 602 / 2;
    _this.deposit.threeDSPopup = $window.open('', 'window name', 'width=437,height=602,left=' + x + ',top=' + y + 'menubar=0,toolbar=0,scrollbars=1');
    _this.deposit.threeDSPopup.document.write('Loading...');
    Analytics.trackEvent('DepositPage', '3DSPopupOpen');
    var i = 0;
    _this.deposit.threeDSinterval = $window.setInterval(function () {
      if (!(i % 3)) {
        Analytics.trackEvent('DepositPage', '3DSPopupHeartbeat', i);
      }
      i++;
      if (_this.deposit.threeDSPopup === null || _this.deposit.threeDSPopup.closed) {
        $window.clearInterval(_this.deposit.threeDSinterval);
        _this.deposit.show3DSMask = false;
        Analytics.trackEvent('DepositPage', '3DSPopupClose');
        $scope.$apply();
        $rootScope.$broadcast('asyncDepositDone');
      }
    }, 1000);
    // this.deposit.threeDSPopup.location.href = event.data.issuerUrl;
    $window.localStorage.setItem('cc_data' + _this.deposit.threeDSdata.invoiceId, _this.deposit.threeDSdata.data);
    $window.localStorage.setItem('cc_data_back' + _this.deposit.threeDSdata.invoiceId, _this.deposit.threeDSdata.backUrl);
    var returnForm = _this.deposit.threeDSPopup.document.createElement('form');
    returnForm.method = 'post';
    returnForm.action = _this.deposit.threeDSdata.issuerUrl;
    var dataInput = _this.deposit.threeDSPopup.document.createElement('input');
    dataInput.setAttribute('name', 'PaReq');
    dataInput.setAttribute('value', _this.deposit.threeDSdata.parequest);
    returnForm.appendChild(dataInput);
    var dataInput1 = _this.deposit.threeDSPopup.document.createElement('input');
    dataInput1.setAttribute('name', 'TermUrl');
    dataInput1.setAttribute('value', _this.deposit.threeDSdata.returnUrl);
    returnForm.appendChild(dataInput1);
    var isModalInput = _this.deposit.threeDSPopup.document.createElement('input');
    isModalInput.setAttribute('name', 'IsModal');
    isModalInput.setAttribute('value', true);
    returnForm.appendChild(isModalInput);
    if (_this.deposit.threeDSdata.md) {
      var dataInput2 = _this.deposit.threeDSPopup.document.createElement('input');
      dataInput2.setAttribute('name', 'MD');
      dataInput2.setAttribute('value', _this.deposit.threeDSdata.md);
      returnForm.appendChild(dataInput2);
    }
    _this.deposit.threeDSPopup.document.body.appendChild(returnForm);
    returnForm.submit();
    _this.deposit.threeDSPopup.focus();
  };

  /**
   * @ngdoc method
   * @name deposit.directive:flDepositAmountPanel#setup
   * @methodOf deposit.directive:flDepositAmountPanel
   * @description
   * Setup first time deposit
   * Bypass setupDeposit and run setup callback if iframe url pre-defined
   * Callbacks on success varies on deposit method
   * eg. paypal needs redirect to the paypal site
   * skrll and flnbilling needs render the iframe
   * webmoney needs to create a form and post to exteranl
   */
  this.setup = function () {
    var params = {};
    if (_this.iframe_url && _this.tab === 'fln_billing' && !_this.verification) {
      _this.callback({ params: { url: _this.iframe_url } });
      _this.iframe_url = undefined;
      return;
    }
    if (_this.deposit.type === 'wire') {
      _this.callback();
      return;
    }
    if (_this.deposit.type === 'boleto') {
      var boletoDetail = _this.deposit.boletoDetail;
      if (!boletoDetail.name || !boletoDetail.birthdate || !boletoDetail.document || !boletoDetail.email || !boletoDetail.phone || !boletoDetail.address || !boletoDetail.streetno || !boletoDetail.city || !boletoDetail.zip) {
        return;
      }
      params = {
        country_code: boletoDetail.countryCode,
        amount: _this.deposit.amount,
        currency_id: parseInt(_this.deposit.currency.id, 10),
        deposit_method: _this.deposit.type,
        tracking_token: _this.deposit.trackingToken,
        threatmetrix_session: _this.deposit.thm,
        cart_id: parseInt(NewDepositUserInfo.getCartId(), 10),
        boleto_info: {
          zip: boletoDetail.zip,
          state: boletoDetail.state,
          city: boletoDetail.city,
          street_complete: boletoDetail.streetcomplete,
          street_number: boletoDetail.streetno,
          address: boletoDetail.address,
          phone: boletoDetail.phone,
          email: boletoDetail.email,
          document: boletoDetail.document,
          birthdate: boletoDetail.birthdate,
          name: boletoDetail.name
        }
      };
      _this.deposit.processing = true;
      Deposits.setupDeposit(params).then(function (result) {
        var data = result.get().data;
        _this.alerts.setAlert('boletoSuccess', {
          dueDate: data.due_date,
          boletoUrl: data.url
        });
      }).catch(function (e) {
        _this.alerts.setApiError(e.data ? e.data.message : e);
      }).finally(function () {
        _this.deposit.processing = false;
      });
    } else {
      params = {
        // This amount is exclude the fee. The 0.01 here is to make sure non
        // empty amount sent to the API backend.
        amount: _this.deposit.amount || 0.01,
        currency_id: parseInt(_this.deposit.currency.id, 10),
        deposit_method: _this.deposit.type,
        action: _this.deposit.action,
        credit_card_gateway: 'gc',
        cancel_url: $window.location.href,
        country_code: _this.country ? _this.country.code : '',
        tracking_token: _this.deposit.trackingToken,
        threatmetrix_session: _this.deposit.thm
      };
      _this.popupEligible = (_this.deposit.type === 'paypal_reference' || _this.deposit.type === 'paypal' || _this.deposit.type === 'wechatpay') && !document.documentMode;
      if (_this.popupEligible) {
        // exclude IE11
        var x = $window.top.outerWidth / 2 + $window.top.screenX - 437 / 2;
        var y = $window.top.outerHeight / 2 + $window.top.screenY - 602 / 2;
        if (!_this.deposit.popup || _this.deposit.popup.closed) {
          (function () {
            _this.deposit.showMask = true;
            _this.deposit.popup = $window.open('', 'window name', 'width=437,height=602,left=' + x + ',top=' + y + 'menubar=0,toolbar=0,scrollbars=1');
            _this.deposit.popup.document.write('Loading...');
            Analytics.trackEvent('DepositPage', 'PaypalPopupOpen');
            var i = 0;
            _this.deposit.interval = $window.setInterval(function () {
              if (!(i % 3)) {
                Analytics.trackEvent('DepositPage', 'PaypalPopupHeartbeat', i);
              }
              i++;
              if (_this.deposit.popup === null || _this.deposit.popup.closed) {
                $window.clearInterval(_this.deposit.interval);
                _this.deposit.showMask = false;
                Analytics.trackEvent('DepositPage', 'PaypalPopupClose');
                $scope.$apply();
              }
            }, 1000);
            params.cancel_url = sslBaseUrl + '/payments/deposit/cancel.php?status=cancel';
          })();
        } else {
          _this.deposit.popup.focus();
          return;
        }
      }
      _this.deposit.processing = true;
      if (_this.deposit.type === 'ideal') {
        params.ideal_bank_id = _this.deposit.idealBank;
      }
      params.cart_id = parseInt(NewDepositUserInfo.getCartId(), 10);
      if (_this.verification) {
        params.action = 'verifyPayment';
        params.confirm_url = 'https://' + $window.location.hostname + '/ajax/payment/flnBilling.php?action=directPayment' + '&setupRecurring=true&style=interframe';
      } else {
        if (_this.deposit.type === 'fln_billing') {
          if (!_this.threeDSPopupTest) {
            params.action = 'getHosted';
          } else if (_this.threeDSPopupTest) {
            params.action = 'getHostedModal';
          }
        }
        var backUrl = _this.back.realBack.encode || '';
        params.confirm_url = 'https://' + $window.location.hostname + '/payments/deposit/confirm.php';
        if (backUrl) {
          params.confirm_url = params.confirm_url.concat('?back=' + backUrl);
        }
        if ((_this.deposit.type === 'paypal_reference' || _this.deposit.type === 'paypal') && !document.documentMode) {
          params.confirm_url = params.confirm_url.concat(backUrl ? '&' : '?');
          params.confirm_url = params.confirm_url.concat('paypalPopup=true');
        }
        params.amount = _this.deposit.amount || 0.01;
      }
      Deposits.setupDeposit(params).then(function (result) {
        if (_this.popupEligible) {
          _this.deposit.processing = false;
        }
        _this.callback({ params: result.get() });
      }).catch(function (e) {
        _this.alerts.setApiError(e.data ? e.data.message : e);
        if (_this.isPopupMethod(_this.deposit.type)) {
          _this.closePopup();
        }
        _this.deposit.processing = false;
      });
    }
  };

  // Check if the current currency is in availableCurrencyList, if not,
  // which means the the previous currency chose by user cannot be
  // selected in the currenct payment method.
  this.checkChosenCurrencyInAvailableCurrencyList = function () {
    _this.disabledCurrency = false;
    _this.use_global = false;
    _this.chosenCurrencyInList = false;
    if (_this.payByBalance) {
      _this.deposit.currencyCode = _this.deposit.currency.code;
      return;
    }

    if (['fln_billing', 'paypal_reference', 'skrill', 'wire', 'paypal'].indexOf(_this.deposit.type) !== -1) {
      for (var i = 0; i < _this.availableCurrencyList.length; i++) {
        if (_this.availableCurrencyList[i].id === _this.deposit.defaultcurrencies.globalcurrency.id) {
          _this.chosenCurrencyInList = true;
        }
      }
      if (_this.chosenCurrencyInList) {
        _this.deposit.currency = _this.deposit.defaultcurrencies.globalcurrency;
        _this.deposit.currencyCode = _this.deposit.defaultcurrencies.globalcurrency.code;
      } else {
        _this.deposit.currency = _this.deposit.defaultcurrencies[_this.deposit.type];
        _this.deposit.currencyCode = _this.deposit.defaultcurrencies[_this.deposit.type].code;
      }
    } else {
      _this.deposit.currency = _this.deposit.defaultcurrencies[_this.deposit.type];
      _this.deposit.currencyCode = _this.deposit.defaultcurrencies[_this.deposit.type].code;
    }
  };

  this.initialize = function () {
    var countryCode = _this.config.country ? _this.config.country.code : undefined;
    NewDepositManager.initFeesConfigFactory(_this.deposit.type, countryCode).then(function (feeConfigFactory) {
      _this.initializeConfig(feeConfigFactory);
      _this.disableButton = false;
      _this.deposit.processing = false;
    }).catch(function (e) {
      _this.alerts.setPreDepositError(e.data ? e.data.message : e);
    });

    if (_this.deposit.items && _this.deposit.items.summary) {
      var itemTotal = 0;
      _this.deposit.items.summary.forEach(function (item) {
        itemTotal += item.amount;
      });

      _this.deposit.items.itemTotal = itemTotal;
    }
  };

  /**
   * Set up fee configs, currency list and
   * @todo  checking disabled current currency.
   */
  this.initializeConfig = function (feeConfigs) {
    _this.feeConfigsFactory = feeConfigs;
    _this.currencies = NewDepositUserInfo.getCurrencies();
    // Set currency list.
    _this.availableCurrencyList = $filter('depositCurrencyListFilter')(_this.currencies.getList(), _this.deposit.type, _this.feeConfigsFactory);

    if (_this.deposit.showChargeCurrency && _this.deposit.type === 'fln_billing') {
      if (!_this.deposit.agreementObject && _this.deposit.type === 'fln_billing' || ['gc', 'worldpay', 'adyen'].indexOf(_this.deposit.agreementObject.credit_card.gateway) !== -1) {
        _this.deposit.agreementCurrencyList = _this.deposit.availableCCFirstTimeCurrencyList;
      } else if (_this.deposit.agreementObject.credit_card.gateway === 'nab') {
        _this.deposit.agreementCurrencyList = _this.availableCurrencyList.filter(function (x) {
          return x.code === 'AUD';
        });
      }
    } else {
      _this.deposit.agreementCurrencyList = _this.availableCurrencyList;
    }
    // preset charge currency when switching currencies.
    if (_this.deposit.type === 'paypal_reference' && _this.deposit.agreementObject && !_this.deposit.agreementCurrencyList.filter(function (x) {
      return x.id === _this.deposit.ccChargeCurrency.id;
    })[0]) {
      _this.deposit.ccChargeCurrency = _this.deposit.defaultcurrencies.paypal;
    }
    if (_this.deposit.type === 'fln_billing' || _this.deposit.type === 'paypal_reference' || _this.deposit.type === 'wire') {
      var otherCurrencies = _this.availableCurrencyList.filter(function (x) {
        return x.code !== 'USD' && x.code !== 'AUD' && x.code !== 'GBP' && x.code !== 'EUR' && x.code !== 'CAD';
      });
      otherCurrencies = [{
        code: '- - - - - - - - - - ',
        name: ' - - - - - - - - - - ',
        disabled: true
      }].concat(otherCurrencies);
      _this.availableCurrencyList = _this.deposit.topCurrencies.concat(otherCurrencies);
    }
    _this.checkChosenCurrencyInAvailableCurrencyList();
    if (_this.deposit.type === 'wire') {
      _this.deposit.changeCountry(false);
    }
    _this.updateFeeConfig(_this.availableCurrencyList);
  };

  this.changeDepositCurrency = function () {
    if (!_this.deposit.currencyCode) {
      _this.deposit.currencyCode = _this.deposit.currency.code;
    }
    // Get currency object.
    angular$1.forEach(_this.availableCurrencyList, function (currency$$1) {
      if (_this.deposit.currencyCode === currency$$1.code) {
        _this.deposit.currency = currency$$1;
      }
    });
    _this.updateFeeConfig();
    if (['fln_billing', 'paypal_reference', 'skrill', 'wire'].indexOf(_this.deposit.type) !== -1) {
      _this.deposit.defaultcurrencies.globalcurrency = _this.deposit.currency;
    }
    if (_this.deposit.type === 'wire') {
      _this.changeWireCurrency();
    }
    if (_this.deposit.type === 'fln_billing' && _this.deposit.ccIssuingCurrency && _this.deposit.ccIssuingCurrency.code != _this.deposit.currency.code) {
      _this.deposit.showNativeCharge = true;
    } else {
      _this.deposit.showNativeCharge = false;
    }

    if (_this.deposit.showChargeCurrency && (_this.deposit.type === 'fln_billing' || _this.deposit.type === 'paypal_reference') && _this.deposit.ccChargeCurrency.id != _this.deposit.currency.id) {
      _this.deposit.changeChargeCurrency();
    }
  };

  // function to execute when changing wire currency
  this.changeWireCurrency = function () {
    var params = {
      // This amount is exclude the fee. The 0.01 here is to make sure non
      // empty amount sent to the API backend.
      amount: 20000,
      currency_id: parseInt(_this.deposit.currency.id, 10),
      deposit_method: _this.deposit.type,
      action: _this.deposit.action,
      credit_card_gateway: 'gc',
      cancel_url: $window.location.href,
      country_code: _this.deposit.country ? _this.deposit.country.code : '',
      tracking_token: _this.deposit.trackingToken,
      threatmetrix_session: _this.deposit.thm
    };

    Deposits.setupDeposit(params).then(function (result) {
      _this.deposit.wire = result.get().data;
      _this.deposit.wire.confirm = {
        invoice_id: _this.deposit.wire.invoice.id
      };
      _this.handleUpdateFeeEvent();
    }).catch(function (e) {
      _this.alerts.setPreDepositError(e.data ? e.data.message : e);
      _this.deposit.processing = false;
    });
  };

  this.prefillFx = function () {
    var dropdownObj = _this.currencies.getList().find(function (obj) {
      if (obj.code === _this.deposit.currencyCode) {
        return obj;
      }
      return false;
    });
    var oldAmount = _this.deposit.amount;
    if (dropdownObj.id != _this.cartCurrency.id) {
      _this.deposit.conversionRate = 1 / (_this.fxrate[dropdownObj.id][_this.cartCurrency.code] / 0.97 * 0.95) * 100;
      _this.deposit.amount = Math.round(_this.cartAmount * _this.deposit.conversionRate) / 100;
    } else {
      _this.deposit.amount = _this.cartAmount;
    }
    if (oldAmount != _this.deposit.amount) {
      Analytics.trackEvent('DepositPage', 'PrefillFxDepositAmount', 'PrefillFxDepositAmount', 'change', undefined, 'PrefillFxDepositAmount');
    }
  };

  /**
   * @ngdoc method
   * @name deposit.directive:flDepositAmountPanel#authorize
   * @methodOf deposit.directive:flDepositAmountPanel
   * @description
   * Pay by reference
   */
  this.authorize = function () {
    _this.refRequests.amount = _this.deposit.amount;
    _this.refRequests.currency_id = parseInt(_this.deposit.currency.id, 10);
    _this.refRequests.tracking_token = _this.deposit.trackingToken;
    _this.refRequests.threatmetrix_session = _this.deposit.thm;
    if (_this.deposit.showChargeCurrency && _this.deposit.agreementObject.currency_id !== _this.deposit.ccChargeCurrency.id && (_this.deposit.type === 'fln_billing' && _this.deposit.agreementObject.credit_card.gateway !== 'ebanx' || _this.deposit.type === 'paypal_reference')) {
      _this.refRequests.issuing_currency_id = _this.deposit.ccChargeCurrency.id;
    }
    _this.deposit.processing = true;

    Deposits.authorizationCharge(_this.refRequests).then(function () {
      var shouldRedirect = !!_this.back.realBack.raw;
      // if user has a back URL or is on deposit modal
      if (_this.modal) {
        // this is for on success of deposit modal deposits
        _this.alerts.setAlert('success', _this.deposit);
        // run success callback if in modal.
        if (_this.deposit.success && _this.deposit.cancel) {
          _this.deposit.closeWindow = true;
          if (_this.deposit.billing) {
            _this.deposit.billing.dispose();
          }
          setTimeout(function () {
            _this.deposit.success();
            _this.alerts.close(); // close success alert
            _this.deposit.cancel();
          }, 2000);
        }
      } else if (!shouldRedirect) {
        // modal will never have back url so all direct deposit cases go here
        _this.alerts.setAlert('success', _this.deposit);
        _this.deposit.showDepositSurvey = false;
        if (!_this.deposit.showDepositSurvey) {
          setTimeout(function () {
            $window.location = sslBaseUrl;
          }, 5000);
        }
      } else {
        // this is for deposit page deposits with a redirect
        _this.alerts.setAlert('success', _this.deposit);
        if (_this.back.realBack.raw && !_this.deposit.successMask) {
          $window.location = _this.back.realBack.raw;
        } else if (_this.back.realBack.raw && _this.deposit.successMask) {
          setTimeout(function () {
            $window.location = _this.back.realBack.raw;
          }, 5000);
        }
      }
    }).catch(function (e) {
      var errorType = 'error';
      var variation = 'control';
      _this.deposit.ABTestApi.testSubjectEnrol('FIN-T44294-deposit-errors', _this.deposit.user.id, 2).then(function (response) {
        if (response.result.variation_name === 'test') {
          errorType = 'error_detailed';
          variation = 'test';
        }
      });
      try {
        _this.alerts.setAlert(errorType, undefined, 'authorize', e.data ? JSON.parse(e.data.message) : _this.alerts.setAlert('genericError', undefined, 'authorize', e));
        _this.deposit.ABTestApi.testSubjectActivate('FIN-T44294-deposit-errors', variation);
      } catch (e) {
        _this.alerts.setAlert('genericError', undefined, 'authorize', e);
      }
    }).finally(function () {
      _this.deposit.processing = false;
    });
  };

  this.iframe_url = undefined;
  this.prefillFxDepositAmount = NewDepositUserInfo.getPrefillFxDepositAmount();
  this.cartCurrency = NewDepositUserInfo.getCartCurrency();
  this.cartAmount = NewDepositUserInfo.getCartAmount();

  if (!this.cartCurrency && !this.cartAmount) {
    NewDepositUserInfo.setConfig([{ name: 'cartCurrency', value: this.deposit.currency }, { name: 'cartAmount', value: this.deposit.amount }]);
  }

  this.eventFired = false;
  this.disableButton = true;

  // Setup.
  this.initial = function () {
    _this.deposit.processing = true;
    if (!NewDepositManager.feeConfigs || !NewDepositManager.feeConfigs[_this.deposit.type]) {
      _this.initialize();
    } else {
      _this.initializeConfig(NewDepositManager.feeConfigs[_this.deposit.type]);
      _this.deposit.processing = false;
    }
    _this.feeReady = true;
    if (_this.deposit.type === 'fln_billing' && _this.deposit.ccIssuingCurrency && _this.deposit.ccIssuingCurrency.code != _this.deposit.currency.code) {
      _this.deposit.showNativeCharge = true;
    } else {
      _this.deposit.showNativeCharge = false;
    }
  };
  this.config = NewDepositManager.getVars();
  this.forceAVS = NewDepositUserInfo.getForceAVS();
  this.ebanxEligible = NewDepositUserInfo.getEbanxEligibility();
  this.initial();

  if (this.autoReload) {
    (function () {
      var asyncDepositDone = $rootScope.$on('asyncDepositDone', function () {
        _this.setup();
        _this.deposit.processing = false;
      });
      // clean up rootScope binding on destroy
      $scope.$on('$destroy', function () {
        asyncDepositDone();
      });
    })();
  }

  this.deposit.changeChargeCurrency = function () {
    if (_this.deposit.type === 'fln_billing') {
      _this.initial();
    }
    if (_this.deposit.showChargeCurrency) {
      _this.updateChargeFee();
    }
  };

  this.rate = function (issuingCurrency) {
    var buy = _this.deposit.currency.code;

    if (!_this.fxrate) {
      _this.fxrate = _this.exchangerate;
    }
    return 1 / _this.fxrate[issuingCurrency][buy];
  };

  this.nativeRate = function (issuingCurrencyCode) {
    var buy = _this.deposit.currency.id;
    if (!_this.fxrate) {
      _this.fxrate = _this.exchangerate;
    }
    return _this.fxrate[buy][issuingCurrencyCode];
  };

  this.isPopupMethod = function (depositMethod) {
    return ['paypal_reference', 'paypal', 'wechatpay'].indexOf(depositMethod) !== -1;
  };

  this.validateForms = function () {
    if (_this.deposit.type === 'boleto') {
      _this.deposit.boletoSubmit = true;
    } else if (_this.deposit.type === 'wire') {
      _this.deposit.wireSubmit = true;
    }
  };

  this.handleUpdateFeeEvent = function () {
    _this.initialize();
    var countryCode = _this.deposit.country ? _this.deposit.country.code : undefined;
    NewDepositManager.initFeesConfigFactory(_this.deposit.type, countryCode).then(function (feeConfigsFactory) {
      _this.feeConfigsFactory = feeConfigsFactory;
      _this.updateFeeConfig();
    }).catch(function (e) {
      _this.alerts.setPreDepositError(e.data ? e.data.message : e);
      _this.deposit.processing = false;
    });
  };

  this.ccIssuingCurrency = true;
  this.ccNativeCharge = true;
  this.deposit.idealBank = '0021';
  var switchPaymentType = $rootScope.$on('switchPaymentType', function () {
    _this.initial();
  });
  $scope.$on('$destroy', function () {
    switchPaymentType();
  });
  var updateFeeConfig = $rootScope.$on('updateFeeConfig', function () {
    _this.handleUpdateFeeEvent();
  });
  $scope.$on('$destroy', function () {
    updateFeeConfig();
  });
}

NewDepositAmountPanel.$inject = ['$scope', '$filter', '$rootScope', '$timeout', '$window', '$http', 'Deposits', 'NewDepositManager', 'NewDepositUserInfo', 'Analytics'];
NewDepositAmountPanel.$inject = ['$scope', '$filter', '$rootScope', '$timeout', '$window', '$http', 'Deposits', 'NewDepositManager', 'NewDepositUserInfo', 'Analytics'];
var flDepositAmountPanel = flComponent$1(NewDepositAmountPanel, {
  selector: 'fl-new-deposit-amount-panel',
  bindings: {
    deposit: '=',
    alerts: '=',
    currencies: '=',
    country: '=',
    countryList: '=',
    back: '=',
    callback: '&',
    action: '@',
    setupOnInit: '@',
    refRequests: '=',
    tab: '=',
    iframeId: '@',
    cardholderNameId: '@',
    expiryId: '@',
    autoReload: '@',
    showCountry: '@',
    exchangerate: '=',
    preferredcurrency: '=',
    verification: '=',
    modal: '=',
    payByBalance: '=?',
    threeDsPopupTest: '='
  },
  template: template$11,
  providers: [NewDepositManagerProvider, NewDepositUserInfoProvider, DepositsProvider, AnalyticsModule, depositCurrencyListFilter$1, disabledCurrencyCheck, ignoreMouseWheel, ngMessages]
});

var template$12 = "<div class='tab-pane'\n     ng-class=\"{'fade in active': PaypalDeposit.config.tab == 'paypal'}\"\n     fl-analytics-subsection=\"paypal\"\n     ng-class=\"{'is-loading':!NewPaypalDeposit.DepositService.config.currencyReady}\">\n    <section class='payment-method'>\n    </section>\n</div>\n";

/**
 * @ngdoc controller
 * @name deposit.PaypalDepositController
 * @module deposit
 *
 * @description
 * Deposit page paypal tab controller
 * The HTML template this page is linked to is
 * /static/angularjs/deposit/templates/paypal.htm
 */

var NewPaypalDeposit = function NewPaypalDeposit($window, $rootScope, NewDepositUserInfo, NewDepositManager) {
  var _this = this;

  _classCallCheck(this, NewPaypalDeposit);

  this.$window = $window;
  this.DepositManager = NewDepositManager;
  this.DepositUserInfo = NewDepositUserInfo;

  var depositObj = this.DepositManager.getDepositObject();
  this.config = this.DepositManager.getVars();
  this.config.tab = 'paypal';
  depositObj.type = 'paypal_reference';
  depositObj.action = 'setExpressCheckoutRef';
  this.paypal = { hasRefs: false };
  NewDepositManager.initializeDeposit(depositObj.type);
  this.exchangerate = this.DepositUserInfo.getExchangeRate();
  $rootScope.$broadcast('switchPaymentType');
  // no autoset payment
  // When the currency changed from currency list in flDepositAmountPanel, it
  // can select the same currency billing agreement if applicable. Otherwise,
  // choose the 'new paypal account'.
  this.DepositService.deposit.handleSetupCallback = function (r) {
    if (!document.documentMode) {
      _this.DepositService.deposit.popup.location.href = r.url;
    } else {
      $window.location.href = r.url;
    }
  };
};

NewPaypalDeposit.$inject = ['$window', '$rootScope', 'NewDepositUserInfo', 'NewDepositManager'];

var flPaypalDeposit = flComponent$1(NewPaypalDeposit, {
  selector: 'fl-new-paypal-deposit',
  template: template$12,
  providers: [NewDepositManagerProvider, NewDepositUserInfoProvider, flDepositAmountPanel],
  bindings: {
    DepositService: '=deposit'
  }
});

var depositModalCtrlProvider = angular$1.module('mD', [uiModal]).controller('mD', ['$modalInstance', '$location', '$window', '$scope', 'Currency', 'Amount', 'Items', 'Tracking', 'DepositMessage', function ($modalInstance, $location, $window, $scope, Currency, Amount, Items, Tracking, DepositMessage) {
  var _this = this;

  // hide anything but support chats.
  this.body = document.getElementsByTagName('body')[0];
  this.bodyClass = this.body.className;
  this.body.className += ' is-ModalPayment-active';

  this.confirm = function () {
    _this.body.className = _this.bodyClass;
    $modalInstance.close('close');
  };

  this.dismiss = function (action) {
    $modalInstance.dismiss(action);
  };

  this.successCallback = function () {
    $modalInstance.close('success');
  };

  this.depositPageCallback = function () {
    $modalInstance.close('depositPage');
  };

  // deposit object
  this.$window = $window;
  this.deposit = {};
  this.currency = Currency;
  this.success = this.successCallback;
  this.cancel = this.confirm;
  this.items = Items;
  this.amount = Amount;
  this.showDepositPage = this.depositPageCallback;
  this.tracking = Tracking;
  this.depositMessage = DepositMessage;
}]).name;

var componentTemplate = "<div fl-analytics-section=\"DepositModalSection\" class=\"responsive-modal FIN-1031\" id=\"expanded-payment-modal\">\n    <div class=\"modal ModalPayment FIN-1031\" ng-class=\"{'is-closing': DepositComponent.deposit.closeWindow === true}\" aria-label=\"<%- T_('Close') %>\">\n        <div class=\"ModalPayment-body\">\n            <div>\n                <div class=\"ModalPayment-header\">\n                    <div>\n                        <a class=\"ModalPayment-backLink\" ng-click=\"DepositComponent.close()\">Back</a>\n                    </div>\n                    <div class=\"Grid Grid--verticalCenter\">\n                        <div class=\"Grid-col Grid-col--10\">\n                            <h2 ng-if=\"!DepositComponent.deposit.items.payByBalance\" class=\"ModalPayment-heading\">Select a Payment Method</h2>\n                            <h2 ng-if=\"DepositComponent.deposit.items.payByBalance\" class=\"ModalPayment-heading\">Payment Method</h2>\n                        </div>\n                        <div class=\"Grid-col--flushRight\">\n                            <span class=\"fl-logo\">\n                                <fl-icon name=\"fl-logo\"></fl-icon>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div>\n                    <div class=\"alert alert-info\" ng-if=\"DepositComponent.config.message\">\n                        <p class=\"ModalPayment-alert\">\n                            {{DepositComponent.config.message}}\n                        </p>\n                    </div>\n                    <div fl-analytics-section=\"DepositV3\" class=\"alert deposit-alert\"\n                        ng-class=\"{'alert-error': DepositComponent.alerts.category === 'error',\n                        'alert-warning': DepositComponent.alerts.category === 'warning',\n                        'alert-success': DepositComponent.alerts.category === 'success'}\"\n                        ng-show=\"DepositComponent.alerts.show\">\n                        <button type=\"button\" class=\"close\" ng-click=\"DepositComponent.alerts.close();\">x</button>\n                        <div>\n                            <strong>\n                                <div ng-if=\"DepositComponent.alerts.type === 'success'\" data-uitest-target=\"deposit-success-notification\">Deposit Success</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'error'\" data-uitest-target=\"deposit-error\">Deposit Failed</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'failure'\" data-uitest-target=\"deposit-error\">Deposit Failed</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'pending'\" data-uitest-target=\"deposit-error\">Deposit Pending</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'cartError'\" data-uitest-target=\"deposit-error\">Item paid for already</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'apiError'\" data-uitest-target=\"deposit-error\">Deposit Failed</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'preDepositError'\" data-uitest-target=\"deposit-error\">Error</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'genericError'\" data-uitest-target=\"deposit-error\">Something has gone wrong</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'authError'\" data-uitest-target=\"deposit-error\">Authentication Error</div>\n                                <div ng-if=\"DepositComponent.alerts.type === 'binError'\" data-uitest-target=\"deposit-error\">Error</div>\n                            </strong>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'boletoSuccess'\">\n                            <span>You have successfully created your Boleto Banc&#225;rio, please double check that all details are correct. Your Boleto Banc&#225;rio needs to be paid before\n                              {[{DepositComponent.alerts.depositObj.dueDate}]} (Sao Paulo BR Local Time) at ATMs, branch facilities and internet banking of any Bank,\n                              Post Office, Lottery Agent and some supermarkets. Here's the boleto\n                              <a href=\"{[{DepositComponent.alerts.depositObj.boletoUrl}]}\" target=\"_blank\">link</a></span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'wireSuccess'\">\n                            <span>Your account will be credited\n                                    {[{\n                                        DepositComponent.deposit.amount | currency:DepositComponent.deposit.currency.sign:2\n                                    }]} {[{DepositComponent.deposit.currency.code}]} when we are notified of payment from our bank.\n                                    Please expect up to 5 business days for your funds to clear.\n                            </span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'success'\" data-uitest-target=\"deposit-success-message\">\n                            <span>Thank you! Your account has been credited </span>\n                            <span>{[{DepositComponent.alerts.depositObj.currency.sign}]}{[{DepositComponent.alerts.depositObj.amount}]} </span>\n                            <span>{[{DepositComponent.alerts.depositObj.currency.code}]}.</span>\n                            <span ng-if=\"DepositComponent.alerts.depositObj.showNativeChargeError\">\n                              Native charge failed. Please contact support (ID: {[{DepositComponent.alerts.depositObj.fxTransId}]})\n                            </span>\n                            <br>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'error'\">\n                            <span>Your payment has been rejected by your bank. Please ensure your payment details are entered correctly and that\n                             your card is authorized for online purchasing. Alternatively, you can try a different card or one of our other payment\n                            methods.<br>\n                            Error code: {[{DepositComponent.alerts.message.error_code}]}<br>\n                            Event ID: {[{DepositComponent.alerts.message.uuid}]}<br>\n                            Please do not hesitate to contact our <a href=\"/support?show_ticket_modal=true\" target=\"_blank\">\n                            Freelancer.com support</a> if you need help.</span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'pending' || DepositComponent.alerts.type === 'failure'\">\n                            {[{DepositComponent.alerts.message}]}\n                        </div>\n\n                        <div ng-if=\"DepositComponent.alerts.type === 'wireError'\">\n                            <span>{[{DepositComponent.alerts.message}]}</span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'cartError'\">\n                            <span>Looks like you've already paid for this item</span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'apiError'\">\n                            There was an error processing your payment.<br>\n                            Error message: {[{DepositComponent.alerts.message.human_msg}]}<br>\n                            Error code: {[{DepositComponent.alerts.message.error_code}]}<br>\n                            Event ID: {[{DepositComponent.alerts.message.uuid}]}<br>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'preDepositError'\">\n                            <span>\n                                There is an error loading the deposit form. Please refresh the page to try again.\n                                If the problem persists, please contact\n                                <a href=\"/support/?show_chat_modal=1\" fl-analytics=\"DepositFailedSupportChat\" target=\"_blank\">\n                                  Freelancer.com support\n                                </a>.\n                            </span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'binError'\">\n                            <span>\n                                {[{DepositComponent.alerts.message.human_msg}]}<br>\n                                Error code: {[{DepositComponent.alerts.message.error_code}]}<br>\n                                Event ID: {[{DepositComponent.alerts.message.uuid}]}<br></span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'genericError'\">\n                            <span>\n                                We cannot process any deposit requests at this stage. Please try again later.<br>\n                                If the problem persists, please contact\n                                <a href=\"/support/?show_chat_modal=1\" fl-analytics=\"DepositFailedSupportChat\" target=\"_blank\">\n                                  Freelancer.com support\n                                </a>.\n                            </span>\n                        </div>\n                        <div ng-if=\"DepositComponent.alerts.type === 'authError'\">\n                          <span>\n                            There was an issue processing your deposit request.<br><br>\n                            This may be due to your browser blocking third party cookies, which can be fixed by enabling them for your browser, or adding www.{[{DepositComponent.alerts.message.domain}]} as an exception.<br>\n                            Please refer to the following support articles for more detailed instructions:<br><br>\n                            Google Chrome: <a href=\"https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en\" target=\"_blank\">Google support article</a><br>\n                            Mozilla Firefox: <a href=\"https://support.mozilla.org/t5/Cookies-and-cache/Enable-and-disable-cookies-that-websites-use-to-track-your/ta-p/2784\" target=\"_blank\">Mozilla support article</a><br>\n                            Internet Explorer: <a href=\"https://support.microsoft.com/en-au/help/17442/windows-internet-explorer-delete-manage-cookies\" target=\"_blank\">Microsoft support article</a><br><br>\n\n                            Once you have completed this step, please refresh this page and try again.\n                            Alternatively, you can try a different payment method.<br>\n                            If the problem persists, please contact support@freelancer.com for further help.\n                          </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"PagePayments-body section-inner\">\n                <div class=\"Grid\">\n                    <div class=\"Grid-col Grid-col--6\">\n                        <div class=\"PaymentMethod\" ng-if=\"DepositComponent.deposit.items.payByBalance\" ng-class=\"DepositComponent.deposit.depositMethodClass\">\n                            <form class=\"methodsForm\">\n                                <div class=\"PaymentMethod-item\" id=\"ccLabel\">\n                                    <input type=\"radio\" class=\"PaymentMethod-radio\" id=\"ccRadio\" name=\"deposit-method\"\n                                    ng-checked=\"true\">\n                                    <label class=\"PaymentMethod-label PaymentMethod-label--balance\" for=\"ccRadio\">\n                                        Balance\n                                        <span class=\"PaymentMethod-balanceNote\">{[{DepositComponent.deposit.currency.sign}]}{[{DepositComponent.deposit.items.balance | currency:'':2}]} {[{DepositComponent.deposit.currency.code}]} equivalent</span>\n                                    </label>\n                                    <div class=\"tab-pane\" fl-analytics-section=\"deposit\" fl-analytics-subsection=\"balance\">\n                                        <section class=\"PaymentMethod-content-inner\">\n                                            <div class=\"fl-form PaymentMethod-form\">\n                                                Funds available:\n                                                <table class=\"PagePayments-summary-table\">\n                                                    <tr class=\"PagePayments-summary-group\" ng-repeat=\"balance in DepositComponent.deposit.items.balances\" ng-if=\"balance.balance != 0\">\n                                                        <td class=\"PagePayments-summary-column\"><span class=\"small-flag\" ng-class=\"DepositComponent.deposit.flagMap[balance.currency.country].name.toLowerCase().replace(' ', '-')\"></span></td>\n                                                        <td class=\"PagePayments-summary-column\">{[{balance.currency.code}]} - {[{balance.currency.name}]} </td>\n                                                        <td class=\"PagePayments-summary-column-amount\">{[{balance.balance}]}</td>\n                                                    </tr>\n                                                </table>\n                                            </div>\n                                        </section>\n                                    </div>\n                                </div>\n                            </form>\n                        </div>\n                        <div class=\"PaymentMethod\" ng-if=\"!DepositComponent.deposit.items.payByBalance\" ng-class=\"DepositComponent.deposit.billingAgreementClass\">\n                            <div class=\"PaymentMethod-item\" ng-repeat=\"order in DepositComponent.cc.refIds\"\n                                    ng-class=\"order.class\"\n                                     ng-if=\"DepositComponent.allowCC\">\n                                <input ng-click=\"DepositComponent.switchPaymentType('/cc', 'fln_billing');DepositComponent.setBillingAgreement(order)\"\n                                    fl-analytics=\"CCRecurring\"\n                                    type=\"radio\" class=\"PaymentMethod-radio\" name=\"deposit-method\" id=\"{[{order.token}]}\"\n                                    ng-disabled=\"DepositComponent.deposit.processing\"\n                                    ng-checked=\"order.token===DepositComponent.selectedAgreement && DepositComponent.config.tab==='fln_billing'\">\n                                <label ng-if=\"!DepositComponent.deposit.showChargeCurrency\" class=\"PaymentMethod-label PaymentMethod-label--{[{order.card_type | lowercase}]}\" for=\"{[{order.token}]}\">\n                                    {[{order.credit_card.credit_card_number}]} ({[{order.code}]})\n                                    <span class=\"PaymentMethod-logo\">\n                                        <span class=\"PaymentIcon PaymentIcon--{[{order.credit_card.card_type | lowercase}]}\"></span>\n                                    </span>\n                                </label>\n                                <label ng-if=\"DepositComponent.deposit.showChargeCurrency\" class=\"PaymentMethod-label PaymentMethod-label--{[{order.card_type | lowercase}]}\" for=\"{[{order.token}]}\">\n                                    {[{order.credit_card.credit_card_number}]}\n                                    <span class=\"PaymentMethod-logo\">\n                                        <span class=\"PaymentIcon PaymentIcon--{[{order.credit_card.card_type | lowercase}]}\"></span>\n                                    </span>\n                                </label>\n                                <div ng-if=\"order.token===DepositComponent.selectedAgreement && DepositComponent.config.tab==='fln_billing'\"></div>\n                                <fl-currency-selector ng-if=\"DepositComponent.config.currencyReady && order.token===DepositComponent.selectedAgreement && DepositComponent.config.tab==='fln_billing' && DepositComponent.deposit.showChargeCurrency && order.credit_card.gateway!=='ebanx'\" deposit=\"DepositComponent\"></fl-currency-selector>\n                            </div>\n                            <div class=\"PaymentMethod-item\" ng-repeat=\"agreement in DepositComponent.paypal.refIds\"\n                                    ng-class=\"agreement.class\">\n                                <input ng-click=\"DepositComponent.switchPaymentType('/paypal', 'paypal');DepositComponent.setBillingAgreement(agreement)\"\n                                    fl-analytics=\"PayPalRecurring\"\n                                    type=\"radio\" class=\"PaymentMethod-radio\" name=\"deposit-method\" id=\"{[{agreement.token}]}\"\n                                    ng-disabled=\"DepositComponent.deposit.processing\"\n                                    ng-checked=\"agreement.token===DepositComponent.selectedAgreement && DepositComponent.config.tab==='paypal'\">\n                                <label ng-if=\"!DepositComponent.deposit.showChargeCurrency\" class=\"PaymentMethod-label PaymentMethod-label--paypal\" for=\"{[{agreement.token}]}\">\n                                    {[{agreement.paypal.paypal_email}]} ({[{agreement.code}]})\n                                    <span class=\"PaymentMethod-logo\">\n                                        <span class=\"PaymentIcon PaymentIcon--paypal\"></span>\n                                    </span>\n                                </label>\n                                <label ng-if=\"DepositComponent.deposit.showChargeCurrency\" class=\"PaymentMethod-label PaymentMethod-label--paypal\" for=\"{[{agreement.token}]}\">\n                                    {[{agreement.paypal.paypal_email}]}\n                                    <span class=\"PaymentMethod-logo\">\n                                        <span class=\"PaymentIcon PaymentIcon--paypal\"></span>\n                                    </span>\n                                </label>\n                                <div ng-if=\"agreement.token===DepositComponent.selectedAgreement && DepositComponent.config.tab==='paypal'\"></div>\n                                <fl-currency-selector ng-if=\"DepositComponent.config.currencyReady && agreement.token===DepositComponent.selectedAgreement && DepositComponent.config.tab==='paypal' && DepositComponent.deposit.showChargeCurrency\" deposit=\"DepositComponent\"></fl-currency-selector>\n                            </div>\n                        </div>\n                        <h3 ng-if=\"DepositComponent.hasBillingAgreements && !DepositComponent.deposit.items.payByBalance\" class=\"PagePayments-body-title\">More Payment Methods</h3>\n                        <div class=\"PaymentMethod\" ng-if=\"!DepositComponent.deposit.items.payByBalance\" ng-class=\"DepositComponent.deposit.depositMethodClass\">\n                            <form class=\"methodsForm\">\n                                <div class=\"PaymentMethod-item\" ng-class=\"DepositComponent.depositMethods[0].class\" id=\"ccLabel\">\n                                    <input type=\"radio\" class=\"PaymentMethod-radio\" id=\"ccRadio\" name=\"deposit-method\"\n                                    ng-click=\"DepositComponent.switchPaymentType('/cc', 'fln_billing');DepositComponent.setBillingAgreement(order);\"\n                                    ng-checked=\"DepositComponent.config.tab==='fln_billing' && !DepositComponent.selectedAgreement\">\n                                    <label class=\"PaymentMethod-label PaymentMethod-label--fln_billing\" for=\"ccRadio\">\n                                        Credit or Debit Card\n                                        <span class=\"PaymentMethod-note\">All major cards accepted</span>\n                                    </label>\n                                    <fl-new-cc-deposit deposit=\"DepositComponent\" ng-if=\"DepositComponent.config.currencyReady\"\n                                    ng-show=\"DepositComponent.config.tab==='fln_billing' && !DepositComponent.selectedAgreement\"></fl-new-cc-deposit>\n                                </div>\n                                <div class=\"PaymentMethod-item\" ng-class=\"DepositComponent.depositMethods[1].class\" id=\"paypalLabel\">\n                                    <input type=\"radio\" class=\"PaymentMethod-radio\" id=\"paypalRadio\" name=\"deposit-method\"\n                                    ng-click=\"DepositComponent.switchPaymentType('/paypal', 'paypal');DepositComponent.setBillingAgreement(order);\"\n                                    ng-checked=\"DepositComponent.config.tab==='paypal' && !DepositComponent.selectedAgreement\">\n                                    <label class=\"PaymentMethod-label PaymentMethod-label--paypal\" for=\"paypalRadio\">\n                                        PayPal\n                                        <span class=\"PaymentMethod-logo\">\n                                            <span class=\"PaymentIcon PaymentIcon--paypal\"></span>\n                                        </span>\n                                    </label>\n                                    <fl-new-paypal-deposit deposit=\"DepositComponent\" ng-if=\"DepositComponent.config.currencyReady &&\n                                    DepositComponent.config.tab==='paypal'\"></fl-new-paypal-deposit>\n                                </div>\n                                <div ng-hide=\"DepositComponent.config.tracking \n                                        && (DepositComponent.config.tracking.source === 'postproject' || DepositComponent.config.tracking.source === 'postcontest')\n                                        && (DepositComponent.paypal.refIds.length != 0 || DepositComponent.cc.refIds.length != 0)\"\n                                    class=\"PaymentMethod-item\" ng-class=\"DepositComponent.allMethodsClass\" id=\"showMoreLabel\">\n                                    <a id=\"redirectDepositPageButton\" role=\"button\" class=\"PaymentMethod-showMore\"\n                                        ng-click=\"DepositComponent.showMoreMethods()\">\n                                        <span class=\"PaymentMethod-showMore-icon\">+</span>\n                                        <span>{[{DepositComponent.moreMethods[0].name}]}, {[{DepositComponent.moreMethods[1].name}]}, {[{DepositComponent.moreMethods[2].name}]}\n                                            <div>(You will be redirected to another page)</div>\n                                        </span>\n                                    </a>\n                                </div>\n                            </form>\n                        </div>\n                    </div>\n                    <div class=\"Grid-col Grid-col--6\">\n                        <fl-new-deposit-amount-panel\n                            tab=\"DepositComponent.config.tab\"\n                            back=\"DepositComponent.config.backUrls\"\n                            deposit=\"DepositComponent.deposit\"\n                            alerts=\"DepositComponent.alerts\"\n                            currency-list=\"DepositComponent.config.currencyList\"\n                            currencies='DepositComponent.config.currencies'\n                            callback=\"DepositComponent.deposit.handleSetupCallback(params)\"\n                            ref-requests=\"DepositComponent.refRequests\"\n                            action=\"{[{DepositComponent.action}]}\"\n                            iframe-id=\"iframe-payment-method-cc\"\n                            cardholder-name-id=\"cc-name\"\n                            expiry-id=\"cc-expiry\"\n                            auto-reload=\"true\"\n                            setup-on-init=\"1\"\n                            exchangerate=\"DepositComponent.exchangerate\"\n                            modal=\"true\"\n                            three-ds-popup-test=\"true\"\n                            pay-by-balance=\"DepositComponent.deposit.items.payByBalance\"\n                            ng-if=\"DepositComponent.config.currencyReady\">\n                        </fl-new-deposit-amount-panel>\n                    </div>\n                </div>\n            </div>\n            <footer class=\"PagePayments-footer section-inner\">\n                <div class=\"Grid\">\n                    <div class=\"Grid-col Grid-col--12\">\n                        <p class=\"PagePayments-footer-copyright\">Copyright © {[{DepositComponent.currentYear}]} Freelancer Technology Pty Limited (ACN 142 189 759)</p>\n                        <nav class=\"PagePayments-footer-nav\">\n                            <a href=\"/about/privacy\" class=\"PagePayments-footer-nav-link\">Privacy Policy</a>\n                            <a href=\"/about/terms\" class=\"PagePayments-footer-nav-link\">Terms and Conditions</a>\n                            <a href=\"/dmca\" class=\"PagePayments-footer-nav-link\">Copyright Infringement Policy</a>\n                            <a href=\"/info/codeofconduct.php\" class=\"PagePayments-footer-nav-link\">Code of Conduct</a>\n                        </nav>\n                    </div>\n                </div>\n            </footer>\n        </div>\n    </div>\n</div>\n";

var template$13 = "<fl-deposit-component\n    currency=\"mD.currency\"\n    amount=\"mD.amount\"\n    success=\"mD.success(params)\"\n    cancel=\"mD.cancel(params)\"\n    items=\"mD.items()\"\n    showdepositpage=\"mD.showDepositPage(params)\"\n    tracking=\"mD.tracking\"\n    depositmessage=\"mD.depositMessage\">\n</fl-deposit-component>\n";

function DepositComponent($q, $window, $scope, $rootScope, $location, $http, Currencies, Users, NewDepositUserInfo, NewDepositAlert, NewDepositManager, Analytics, Deposits) {
  var _this = this;

  this.alerts = NewDepositAlert;
  this.$window = $window;
  Analytics.trackEvent('ModalDeposit', undefined, 'ModalOpen', 'open', undefined, 'ModalOpen');
  this.deposit = {
    amount: this.Amount(),
    fee: 0,
    type: '',
    currency: this.Currency(),
    itemCurrency: this.Currency(),
    itemAmount: this.Amount(),
    eventFired: false,
    processing: true,
    agreementCurrencies: {}
  };
  this.config = {
    currencyReady: 0,
    freeTrial: false,
    backUrls: {},
    showCloseBanner: false,
    message: this.DepositMessage(),
    tracking: this.Tracking()
  };
  var dt = new Date();
  this.currentYear = dt.getUTCFullYear();
  var tracking = this.Tracking() ? this.Tracking() : '';
  this.deposit.trackingToken = 'API|' + tracking.source + '|deposit_modal|Desktop';
  if (tracking.reference_type) {
    this.deposit.trackingToken = this.deposit.trackingToken.concat('|' + tracking.reference_type);
    if (tracking.reference_id) {
      this.deposit.trackingToken = this.deposit.trackingToken.concat('|' + tracking.reference_id);
    }
  }
  var configObj = [{ name: 'trackingToken', value: this.deposit.trackingToken }, { name: 'resetRedirect', value: false }, { name: 'currency', value: this.Currency() }, { name: 'flnBillingBaseUrl', value: flnBillingBaseUrl }, { name: 'prefillFxDepositAmount', value: true }, { name: 'cartCurrency', value: this.Currency() }, { name: 'cartAmount', value: this.Amount() }];
  NewDepositUserInfo.setConfig(configObj);
  this.depositMethods = [{ id: 'fln_billing', tab: '/cc', class: 'is-active' }, { id: 'paypal', tab: '/paypal', class: 'is-nextSibling' }];
  this.allMethodsClass = 'is-nextSibling';
  this.deposit.trackingToken = NewDepositUserInfo.getTrackingParams();
  this.deposit.defaultcurrencies = {};
  this.deposit.defaultcurrencies.fln_billing = {
    code: 'USD',
    id: 1,
    sign: '$',
    country: 'US'
  };
  this.deposit.type = 'fln_billing';
  this.config.tab = 'fln_billing';
  this.action = 'confirm';
  // Show payment item summary
  this.deposit.cartSummary = true;
  this.deposit.items = this.Items;
  this.deposit.defaultcurrencies.globalcurrency = this.deposit.currency;
  this.deposit.ABTestApi = ABTestApi;
  this.deposit.success = this.Success;
  this.deposit.cancel = this.Cancel;
  this.deposit.thm = NewDepositUserInfo.getThreatMetrixParams();

  // Make the history of the browser go forward by one when the modal opens
  // this is so we can close the modal by clicking back button
  if (this.$window.history && this.$window.history.pushState) {
    this.$window.history.pushState('forward', null, $location.absUrl());
  }
  this.$window.onpopstate = function () {
    if (_this.deposit.billing) {
      _this.deposit.billing.dispose();
    }
    _this.alerts.close();
    _this.deposit.closeWindow = true;
    setTimeout(function () {
      // wait for animation
      _this.Cancel('close');
    }, 500);
    $scope.$apply();
  };

  var self = this;
  $q.all([Currencies.get({ include_external_currencies: true }), Users.getLoggedInUser({ country_details: true }), $http.get('/ajax/payment/depositModal.php'), Deposits.getVerifiedPaymentSources()]).then(function (response) {
    _this.config.currencies = response[0];
    _this.deposit.availableCCFirstTimeCurrencyList = _this.config.currencies.getList();
    _this.deposit.topCurrencies = _this.config.currencies.getList().filter(function (x) {
      return x.code === 'USD' || x.code === 'AUD' || x.code === 'GBP' || x.code === 'EUR' || x.code === 'CAD';
    });
    // set default currencies for deposit methods
    _this.deposit.defaultcurrencies.fln_billing = response[0].getList().filter(function (x) {
      return x.code === 'USD';
    })[0];
    _this.deposit.defaultcurrencies.paypal_reference = response[0].getList().filter(function (x) {
      return x.code === 'USD';
    })[0];
    _this.deposit.defaultcurrencies.paypal = response[0].getList().filter(function (x) {
      return x.code === 'USD';
    })[0];
    var user = response[1];
    _this.user = user.get();
    _this.deposit.user = _this.user;
    _this.config.country = _this.user.location.country;
    _this.forceAVSEligible = ['us', 'gb', 'ca'].indexOf(_this.user.location.country.code) !== -1;

    _this.billingAgreements = response[3].payment_source;
    if (_this.billingAgreements.length > 0) {
      _this.hasBillingAgreements = true;
    }
    _this.cc = { selectedPayment: 'new', action: 'confirm' };
    _this.cc.refIds = [];
    _this.paypal = { hasRefs: false };
    _this.paypal.refIds = [];
    _this.billingAgreements.forEach(function (billingAgreement) {
      billingAgreement.currencyObj = response[0].getList().filter(function (x) {
        return x.id === billingAgreement.currency_id;
      })[0];
      billingAgreement.code = billingAgreement.currencyObj.code;
      if (billingAgreement.paypal) {
        if (billingAgreement.paypal.paypal_email.length > 24) {
          billingAgreement.paypal.paypal_email = billingAgreement.paypal.paypal_email.substr(0, 23);
          billingAgreement.paypal.paypal_email = billingAgreement.paypal.paypal_email.concat('...');
        }
        _this.paypal.refIds.push(billingAgreement);
        billingAgreement.currency = {
          id: billingAgreement.currencyObj.id,
          code: billingAgreement.currencyObj.code
        };
      } else if (billingAgreement.credit_card) {
        _this.cc.refIds.push(billingAgreement);
        billingAgreement.currency = billingAgreement.currencyObj.id;
      }
    });

    NewDepositManager.setDepositObject(_this.deposit);
    _this.ajax = response[2];
    NewDepositUserInfo.setConfig([{ name: 'currencies', value: response[0] }, { name: 'exchangerate', value: response[2].data.exchangeRate }, { name: 'isCCEligible', value: response[2].data.isCCEligible }, { name: 'countries', value: response[2].data.countries }, { name: 'back', value: response[2].data.back }, { name: 'back_encode', value: response[2].data.backEncode }, { name: 'origin_back', value: response[2].data.originBack }, {
      name: 'origin_back_encode',
      value: response[2].data.originBackEncode
    }]);
    _this.moreMethods = response[2].data.moreMethods;
    _this.isWhitelist = response[2].data.isWhitelist;
    _this.config.backUrls = NewDepositUserInfo.getBackUrlInfo().get();
    _this.config.blacklist = NewDepositUserInfo.getBlackListedCurrency();

    _this.deposit.ccChargeCurrency = _this.deposit.currency;
    _this.allowCC = NewDepositUserInfo.getCCEligibility();
    _this.exchangerate = NewDepositUserInfo.getExchangeRate();
    NewDepositUserInfo.getRealBackUrl(_this.config.backUrls, false);
    _this.deposit.flagMap = {};
    _this.countries = NewDepositUserInfo.getCountries();
    _this.countries.forEach(function (country) {
      _this.deposit.flagMap[country.code] = country;
    });
    _this.deposit.flagMap.EU = { name: 'eu' };
    _this.deposit.flagMap.UK = _this.deposit.flagMap.GB;

    if (!_this.allowCC) {
      _this.config.tab = 'fln_billing';
      _this.deposit.type = 'paypal';
      _this.action = 'setup';
    }
    if (!_this.deposit.items.payByBalance) {
      _this.autosetBillingAgreement(_this.deposit.currency);
    }
    if (_this.isWhitelist) {
      _this.deposit.showChargeCurrency = true;
    } else {
      _this.deposit.ABTestApi.testSubjectEnrol('T40461-select-card-currency-deposit-2', _this.user.id, 2).then(function (response) {
        _this.deposit.showChargeCurrency = response.result.variation_name === 'test';
      });
    }

    NewDepositManager.setVars(_this.config);
    var params = {
      // This amount is exclude the fee. The 0.01 here is to make sure non
      // empty amount sent to the API backend.
      amount: 30,
      currency_id: parseInt(_this.deposit.currency.id, 10),
      deposit_method: 'fln_billing',
      action: 'getHostedModal',
      credit_card_gateway: 'gc',
      cancel_url: $window.location.href,
      country_code: _this.country ? _this.country.code : '',
      tracking_token: _this.deposit.trackingToken,
      threatmetrix_session: _this.deposit.thm
    };
    Deposits.setupDeposit(params).then(function (result) {
      NewDepositUserInfo.setConfig([{
        name: 'iframeUrl',
        value: result.get().url
      }]);
      _this.config.currencyReady = 1;
    }).catch(function (e) {
      _this.alerts.setPreDepositError(e.data.message);
      _this.deposit.processing = false;
    });
  }).catch(function (e) {
    self.alerts.setPreDepositError(e.data ? e.data.message : e);
  });

  this.close = function () {
    var _this2 = this;

    if (this.deposit.billing) {
      this.deposit.billing.dispose();
    }
    this.alerts.close();
    this.deposit.closeWindow = true;
    setTimeout(function () {
      // wait for animation
      _this2.Cancel('close');
      _this2.$window.history.back();
    }, 500);
  };

  this.switchPaymentType = function (paymentPath, tab) {
    if (this.config.tab === tab && tab !== 'paypal' && tab !== 'cc') {
      return;
    }
    this.config.tab = tab;
    this.deposit.type = tab;
    if (this.allowCC) {
      if (this.deposit.type === 'paypal') {
        this.deposit.type = 'paypal_reference';
      } else if (this.deposit.type === 'cc') {
        this.deposit.type = 'fln_billing';
        this.config.tab = 'fln_billing';
      }
    } else if (this.deposit.type === 'paypal') {
      this.deposit.type = 'paypal_reference';
    } else if (this.deposit.type === 'fln_billing') {
      this.deposit.type = 'paypal';
      this.config.tab = 'fln_billing';
    }
    $rootScope.$broadcast('switchPaymentType');
  };

  this.receiveMessage = function (event) {
    var _this3 = this;

    if (event.origin !== $window.location.origin || !event.data.type) {
      return;
    }
    if (event.data.type === 'breakTo3ds') {
      this.deposit.show3DSMask = true;
      this.deposit.threeDSdata = event.data;
      return;
    } else if (event.data.type === 'returnFrom3DS') {
      this.returnFrom3DS(event);
      return;
    }
    this.deposit.showNativeChargeError = false;
    if (event.data.fx_result === 'false') {
      this.deposit.showNativeChargeError = true;
      this.deposit.fxTransId = event.data.fx_trans_ID;
    }
    if (event.data.type !== 'cancel' && event.data.type !== 'failure' && event.data.type !== 'pending') {
      this.alerts.setAlert(event.data.type, this.deposit, 'deposit', '');
      if (event.data.threeDSFailure) {
        this.deposit.show3DSMask = false;
        this.deposit.threeDSPopup.close();
      }
    }
    if (event.data.type === 'failure' || event.data.type === 'pending') {
      this.deposit.threeDSPending = event.data.threeDSPending;
      this.alerts.setAlert(event.data.type, this.deposit, 'deposit', event.data.message);
    }
    if ((this.deposit.type === 'paypal' || this.deposit.type === 'paypal_reference') && !document.documentMode) {
      this.deposit.showMask = false;
      this.deposit.popup.close();
      Analytics.trackEvent('DepositPage', 'PaypalPopupClose');
      $scope.$apply();
    }
    if (event.data.type === 'success' || event.data.type === 'cartError') {
      if (event.data.threeDSSuccess) {
        this.deposit.show3DSMask = false;
        this.deposit.threeDSPopup.close();
        Analytics.trackEvent('DepositPage', '3DSPopupCloseOnSuccess');
        $scope.$apply();
      }
      setTimeout(function () {
        _this3.deposit.closeWindow = true;
        $scope.$apply();
        setTimeout(function () {
          // close alert box
          _this3.alerts.close();
          if (_this3.deposit.billing) {
            _this3.deposit.billing.dispose();
          }
          _this3.Success('success');
        }, 500);
      }, 2000);
    }
    $scope.$apply();
    if (this.deposit.type === 'fln_billing') {
      $rootScope.$broadcast('asyncDepositDone');
    }
  };

  this.returnFrom3DS = function (event) {
    var data = $window.localStorage.getItem('cc_data' + event.data.invoiceId);
    localStorage.removeItem('cc_data' + event.data.invoiceId);
    var back = $window.localStorage.getItem('cc_data_back' + event.data.invoiceId);
    $window.localStorage.removeItem('cc_data_back' + event.data.invoiceId);
    var returnForm = this.deposit.threeDSPopup.document.createElement('form');
    returnForm.method = 'post';
    returnForm.action = back;
    var dataInputDummy = this.deposit.threeDSPopup.document.createElement('input');
    dataInputDummy.setAttribute('name', 'fielddummy');
    dataInputDummy.setAttribute('value', '');
    returnForm.appendChild(dataInputDummy);
    var dataInput1 = this.deposit.threeDSPopup.document.createElement('input');
    dataInput1.setAttribute('name', 'invoice_id');
    dataInput1.setAttribute('value', event.data.invoiceId);
    returnForm.appendChild(dataInput1);
    var dataInput2 = this.deposit.threeDSPopup.document.createElement('input');
    dataInput2.setAttribute('name', 'data');
    dataInput2.setAttribute('value', decodeURIComponent(data));
    returnForm.appendChild(dataInput2);
    var dataInput = document.createElement('input');
    dataInput.setAttribute('name', 'PaRes');
    dataInput.setAttribute('value', event.data.paresult);
    returnForm.appendChild(dataInput);
    this.deposit.threeDSPopup.document.body.appendChild(returnForm);
    returnForm.submit();
  };

  this.setBillingAgreement = function (billingAgreement) {
    var _this4 = this;

    if (billingAgreement) {
      this.action = 'authorize';
      if (billingAgreement.credit_card) {
        this.refRequests = {
          deposit_method: this.deposit.type,
          credit_card_gateway: billingAgreement.credit_card.gateway,
          recurring_order_id: billingAgreement.token
        };
      } else {
        this.refRequests = {
          deposit_method: this.deposit.type,
          recurring_order_id: billingAgreement.token
        };
      }
      this.selectedAgreement = billingAgreement.token;
      this.deposit.agreementObject = billingAgreement;
    } else {
      // reset authorize
      if (this.deposit.type === 'fln_billing') {
        this.action = 'confirm';
        if (this.forceAVSEligible) {
          this.deposit.ABTestApi.testSubjectActivate('FIN-1113-force-avs', this.forceAVS ? 'test' : 'control');
        }
      } else {
        this.action = '';
      }
      this.selectedAgreement = false;
      this.deposit.agreementObject = false;
    }
    if (this.deposit.agreementObject) {
      this.deposit.ccChargeCurrency = this.deposit.availableCCFirstTimeCurrencyList.filter(function (x) {
        return x.id === _this4.deposit.agreementObject.currency_id;
      })[0];
    } else {
      this.deposit.ccChargeCurrency = this.deposit.currency;
    }
    // if nab or ebanx don't show other currencies except what they support.
    if (this.deposit.showChargeCurrency && this.deposit.type === 'fln_billing' && this.deposit.agreementObject) {
      if (this.deposit.agreementObject.credit_card && this.deposit.agreementObject.credit_card.gateway === 'nab') {
        this.deposit.agreementCurrencyList = this.deposit.agreementCurrencyList.filter(function (x) {
          return x.code === 'AUD';
        });
        this.deposit.ccChargeCurrency = this.deposit.agreementCurrencyList.filter(function (x) {
          return x.code === 'AUD';
        })[0];
      } else {
        this.deposit.agreementCurrencyList = this.deposit.availableCCFirstTimeCurrencyList;
      }
    }
    this.setBillingAgreementClass(billingAgreement);
    this.setDepositMethodClass();
    if (this.deposit.changeChargeCurrency) {
      this.deposit.changeChargeCurrency();
    }
  };

  this.setDepositMethodClass = function () {
    this.depositMethodIndex = false;
    this.allMethodsClass = '';
    for (var i = 0; i < this.depositMethods.length; i++) {
      if (this.depositMethods[i].id === this.config.tab && !this.selectedAgreement) {
        this.depositMethodIndex = i;
        if (i > 0) {
          this.depositMethods[i - 1].class = 'is-prevSibling';
        }
        this.depositMethods[i].class = 'is-active';
        this.allMethodsClass = 'is-nextSibling';
      } else if (this.depositMethodIndex !== false) {
        this.depositMethods[i].class = 'is-nextSibling';
      } else {
        this.depositMethods[i].class = false;
      }
    }
  };

  this.autosetBillingAgreement = function (currencyObj) {
    var _this5 = this;

    // if type is not paypal, don't autoset agreement
    if (this.deposit.type !== 'paypal') {
      this.action = 'confirm';
      if (this.paypal.refIds.length > 0) {
        Object.keys(this.paypal.refIds).forEach(function (i) {
          if (_this5.paypal.refIds[i].currency.id === currencyObj.id) {
            _this5.deposit.type = 'paypal_reference';
            _this5.config.tab = 'paypal';
            _this5.setBillingAgreement(_this5.paypal.refIds[i]);
          }
        });
      }
      if (this.deposit.type === 'fln_billing' && this.cc.refIds.length === 0 || this.cc.refIds.length > 0) {
        Object.keys(this.cc.refIds).forEach(function (i) {
          if (parseInt(_this5.cc.refIds[i].currency, 10) === currencyObj.id) {
            _this5.deposit.type = 'fln_billing';
            _this5.config.tab = 'fln_billing';
            _this5.setBillingAgreement(_this5.cc.refIds[i]);
          }
        });
        if (!this.selectedAgreement) {
          if (this.hasBillingAgreements) {
            if (this.cc.refIds.length > 0) {
              this.deposit.type = 'fln_billing';
              this.config.tab = 'fln_billing';
              this.setBillingAgreement(this.cc.refIds[0]);
            } else if (this.paypal.refIds.length > 0) {
              this.deposit.type = 'paypal_reference';
              this.config.tab = 'paypal';
              this.setBillingAgreement(this.paypal.refIds[0]);
            }
          }
          if (this.forceAVSEligible) {
            this.deposit.ABTestApi.testSubjectActivate('FIN-1113-force-avs', this.forceAVS ? 'test' : 'control');
          }
        }
      }
    }
  };

  this.showMoreMethods = function () {
    // run clients call back for redirection to deposit page
    this.ShowDepositPage();
  };

  this.setBillingAgreementClass = function (billingAgreement) {
    this.billingAgreementIndex = false;
    if (billingAgreement) {
      this.deposit.billingAgreementClass = 'is-groupActive';
      this.deposit.depositMethodClass = '';
      if (billingAgreement.credit_card) {
        for (var i = 0; i < this.cc.refIds.length; i++) {
          if (this.cc.refIds[i].token === billingAgreement.token) {
            this.billingAgreementIndex = i;
            if (i > 0) {
              this.cc.refIds[i - 1].class = 'is-prevSibling';
            }
            this.cc.refIds[i].class = 'is-active';
          } else if (this.billingAgreementIndex !== false) {
            this.cc.refIds[i].class = 'is-nextSibling';
          } else {
            this.cc.refIds[i].class = false;
          }
        }
        for (var _i = 0; _i < this.paypal.refIds.length; _i++) {
          this.paypal.refIds[_i].class = 'is-nextSibling';
        }
      } else if (billingAgreement.paypal) {
        for (var _i2 = 0; _i2 < this.paypal.refIds.length; _i2++) {
          if (this.paypal.refIds[_i2].token === billingAgreement.token) {
            this.billingAgreementIndex = _i2;
            if (_i2 > 0) {
              this.paypal.refIds[_i2 - 1].class = 'is-prevSibling';
            }
            this.paypal.refIds[_i2].class = 'is-active';
          } else if (this.billingAgreementIndex !== false) {
            this.paypal.refIds[_i2].class = 'is-nextSibling';
          } else {
            this.paypal.refIds[_i2].class = false;
          }
        }
        for (var _i3 = 0; _i3 < this.cc.refIds.length; _i3++) {
          if (this.billingAgreementIndex === 0 && _i3 === this.cc.refIds.length - 1) {
            this.cc.refIds[_i3].class = 'is-prevSibling';
          } else {
            this.cc.refIds[_i3].class = '';
          }
        }
      }
    } else {
      this.deposit.billingAgreementClass = '';
      this.deposit.depositMethodClass = 'is-groupActive';
      for (var _i4 = 0; _i4 < this.cc.refIds.length; _i4++) {
        this.cc.refIds[_i4].class = '';
      }
      for (var _i5 = 0; _i5 < this.paypal.refIds.length; _i5++) {
        this.paypal.refIds[_i5].class = '';
      }
    }
  };

  $window.addEventListener('message', function (e) {
    _this.receiveMessage(e);
  });
}

DepositComponent.$inject = ['$q', '$window', '$scope', '$rootScope', '$location', '$http', 'Currencies', 'Users', 'NewDepositUserInfo', 'NewDepositAlert', 'NewDepositManager', 'Analytics', 'Deposits'];
DepositComponent.$inject = ['$q', '$window', '$scope', '$rootScope', '$location', '$http', 'Currencies', 'Users', 'NewDepositUserInfo', 'NewDepositAlert', 'NewDepositManager', 'Analytics', 'Deposits'];
var component = flComponent$1(DepositComponent, {
  selector: 'fl-deposit-component',
  template: componentTemplate,
  providers: [UsersProvider, CurrenciesProvider, NewDepositAlertProvider, NewDepositManagerProvider, NewDepositUserInfoProvider, flCcDeposit, flPaypalDeposit, flDepositAmountPanel, flCurrencySelector, AnalyticsModule, flIconProvider, DepositsProvider],
  bindings: {
    Currency: '=currency',
    Amount: '=amount',
    Success: '&?success',
    Cancel: '&?cancel',
    Items: '=items',
    ShowDepositPage: '&?showdepositpage',
    Tracking: '=tracking',
    DepositMessage: '=depositmessage'
  }
});

var DepositModal = function () {
  function DepositModal($modal) {
    _classCallCheck(this, DepositModal);

    this.$modal = $modal;
  }

  _createClass(DepositModal, [{
    key: 'open',
    value: function open(config) {
      config = config || {};
      var modalInstance = this.$modal.open({
        template: template$13,
        backdrop: true,
        controller: depositModalCtrlProvider + ' as mD',
        container: 'fl-deposit-modal',
        resolve: {
          Currency: function Currency() {
            return config.config.currency;
          },
          Amount: function Amount() {
            return config.config.amount;
          },
          Items: function Items() {
            return config.config.items;
          },
          Tracking: function Tracking() {
            return config.config.tracking;
          },
          DepositMessage: function DepositMessage() {
            return config.config.depositMessage;
          }
        }
      });
      return modalInstance;
    }
  }]);

  return DepositModal;
}();

DepositModal.$inject = ['$modal'];

var depositModalProvider = flService$1('DepositModal', [uiModal, depositModalCtrlProvider, component], DepositModal);

var UsersService = function () {
  function UsersService($http, $log, $window, Auth, FACEBOOK_APP_ID, Localization, Users) {
    _classCallCheck(this, UsersService);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.Users = Users;
    this.$log = $log;
    this.newAuthUrl = '/auth'; // TODO replace this to use config
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.LOCALSTORAGE_DEVICE_KEY = 'deviceToken';
    this.Localization = Localization;
  }

  /**
   * get device token from Auth Server and saves it to local storage for token reuse
   * The priority to retrieve is:
   * 1. From UserData that parsed in
   * 2. From localStorage
   * 3. From auth server
   * @param UserData user UserData object in UsersService
   */

  _createClass(UsersService, [{
    key: 'getDeviceToken',
    value: function getDeviceToken(user) {
      var _this = this;

      var deviceToken = void 0;
      if (user.deviceToken) {
        return user.deviceToken;
      }

      if (window.localStorage) {
        deviceToken = window.localStorage.getItem(this.LOCALSTORAGE_DEVICE_KEY);
      }

      if (deviceToken) {
        user.deviceToken = deviceToken;
        return Promise.resolve(deviceToken);
      }

      return this.$http.get(this.newAuthUrl + '/device/').then(function (response) {
        if (response.status === 200 && response.data) {
          if (window.localStorage) {
            try {
              window.localStorage.setItem(_this.LOCALSTORAGE_DEVICE_KEY, response.data.token);
            } catch (e) {
              // throws QuotaExceededError in Safari <11.
              _this.trackError('QuotaExceededError', e);
            }
          }
          user.deviceToken = response.data.token;
          return response.data.token;
        }
        throw new Error('auth: invalid server response: ' + response.data);
      }).catch(function (e) {
        return _this.trackError('GetDeviceToken', e);
      });
    }
  }, {
    key: 'verifyNewEmail',
    value: function verifyNewEmail(email) {
      var _this2 = this;

      var params = {
        existing: true,
        json: true,
        email: email
      };
      return this.$http.get('/ajax/users/email/check_email_valid.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this2.trackError('EmailExistsCheck', e);
      });
    }
  }, {
    key: 'checkBlockedEmail',
    value: function checkBlockedEmail(email) {
      var _this3 = this;

      var params = { email: email };
      return this.$http.get('/ajax/check-email-blocked.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this3.trackError('BlockedEmailCheck', e);
      });
    }
  }, {
    key: 'autofillUsername',
    value: function autofillUsername(email) {
      var _this4 = this;

      var user = { email: email };
      return this.Users.check(user, { recommend_name: true }).catch(function (e) {
        return _this4.trackError('AutofillUsername', e);
      });
    }
  }, {
    key: 'getSuggestedUsernames',
    value: function getSuggestedUsernames(email) {
      var _this5 = this;

      var user = { email: email };
      return this.Users.check(user, { recommend_name: true }).catch(function (e) {
        return _this5.trackError('GetSuggestedUsernames', e);
      });
    }
  }, {
    key: 'checkUsernameExists',
    value: function checkUsernameExists(username) {
      var _this6 = this;

      var params = {
        validator: true,
        username: username
      };
      return this.$http.get('/ajax/check-username-exist.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this6.trackError('UniqueUsernameCheck', e);
      });
    }
  }, {
    key: 'checkEmailExists',
    value: function checkEmailExists(email) {
      var _this7 = this;

      var params = {
        email: email,
        validator: true
      };
      return this.$http.get('/ajax/check-email-exist.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this7.trackError('UniqueEmailCheck', e);
      });
    }
  }, {
    key: 'setExtraCookies',
    value: function setExtraCookies() {
      var _this8 = this;

      // sets a cookie to identify users who have logged in
      // at least once, separating them "from new_users"
      setCookieToBrowser(cookieBase + '_NOTNEW', true, 365, '/', cookieDomain);

      this.Users.getLoggedInUser().then(function (user) {
        _this8.Localization.language(user.get().primary_language);
      });

      var quickLoginFencePromise = this.getQuickLoginFenceCookie();

      Promise.all([quickLoginFencePromise]).then(function (responses) {
        var cookies = {};
        responses.forEach(function (cookie) {
          cookies = Object.assign(cookies, cookie);
        });

        _this8.Auth.setExtraCookies(cookies);
      });
    }

    /**
     * New 2FA Login Endpoint.
     *
     * Example request without device token:
     * {
     *   "status": "success",
     *   "result": {
     *     "token": "xx6IBy22+ve4rjkMAA1p5Q+fu/NvAeMz0vzeqQ6CcVY=",
     *     "user": 23521511
     *   },
     *   "request_id": "unknown"
     * }
     *
     * Example request with device token:
     * {
     *   "status": "success",
     *   "result": {
     *     "pre_login_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVC..",
     *     "message": "We've temporarily blocked this login attempt. Get a verification code from your Email."
     *   },
     *   "request_id": "unknown"
     * }
     */

  }, {
    key: 'login',
    value: function login(user, rememberLogin, old2FAToken) {
      var _this9 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        user: user.username,
        password: user.password
      };
      if (user.deviceToken) {
        data.device_token = user.deviceToken;
      }
      if (old2FAToken) {
        data.old_2FA_token = old2FAToken;
      }
      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this9.Auth.set(response.data.token, response.data.user, rememberLogin);
          _this9.setExtraCookies();
          return response;
        } else if (response.data && response.data.pre_login_token) {
          user.preLoginToken = response.data.pre_login_token;
          return response;
        }
      }).then(function (response) {
        return _this9.crossDomainSSO(response, rememberLogin);
      }).catch(function (response) {
        _this9.trackError('NewLoginUser', response.data.error_code);
        if (response.status === 401 || response.status === 429 || response.status === 500) {
          return Promise.reject(response);
        }
      });
    }

    /**
     * 2FA, Time-based One Time Password Login
     *
     * Example request:
     * {
     *   "status": "success",
     *   "result": {
     *     "token": "xx6IBy22+ve4rjkMAA1p5Q+fu/NvAeMz0vzeqQ6CcVY=",
     *     "user": 23521511
     *   },
     *   "request_id": "unknown"
     * }
     *
     * Example error request:
     * {
     *   "status": "error",
     *   "message": "There was a problem logging in with your account.Please contact support.",
     *   "error_code": "ExceptionCodes.EXPIRED_PRELOGIN_TOKEN",
     *   "request_id": "unknown"
     * }
     */

  }, {
    key: 'totpLogin',
    value: function totpLogin(user, rememberLogin) {
      var _this10 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        device_token: user.deviceToken,
        pre_login_token: user.preLoginToken,
        totp: user.TOTP
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login_verify.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this10.Auth.set(response.data.token, response.data.user, rememberLogin);
          _this10.setExtraCookies();
          return response;
        }
      }).then(function (response) {
        return _this10.crossDomainSSO(response, rememberLogin);
      }).catch(function (response) {
        _this10.trackError('totpLogin', response.data.error_code);
        if (response.status === 401) {
          return Promise.reject(response);
        } else if (response.status === 429) {
          return Promise.reject(response);
        } else if (response.status === 500) {
          return Promise.reject(response);
        }
      });
    }
  }, {
    key: 'getAvailableTotpMethods',
    value: function getAvailableTotpMethods(userId) {
      var _this11 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = { user_id: userId };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/get_totp_methods.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }
      }).catch(function (response) {
        _this11.trackError('getAvailableTotpMethods', response.data.message);
        return Promise.reject(response);
      });
    }
  }, {
    key: 'deliverToken',
    value: function deliverToken(user, method) {
      var _this12 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        device_token: user.deviceToken,
        pre_login_token: user.preLoginToken,
        '2fa_method': method
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/delivery_token.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data && response.data.pre_login_token) {
            user.preLoginToken = response.data.pre_login_token;
          }

          return Promise.resolve(response.data);
        }
      }).catch(function (response) {
        _this12.trackError('deliverToken', response.data.message);
        return Promise.reject(response);
      });
    }

    /**
     * Login through Facebook.
     */

  }, {
    key: 'loginWithFacebook',
    value: function loginWithFacebook(user) {
      var _this13 = this;

      var data = {
        app_id: this.FACEBOOK_APP_ID,
        oauth_type: 'facebook',
        credentials: user.facebookSignedRequest,
        access_token: user.facebookAccessToken
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/fb_login.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this13.Auth.set(response.data.token, response.data.user);
          _this13.setExtraCookies();
          return response;
        } else if (response.data && response.data.pre_login_token) {
          user.preLoginToken = response.data.pre_login_token;
          return response;
        }
      }).then(function (response) {
        return _this13.crossDomainSSO(response);
      }).catch(function (response) {
        _this13.trackError('FacebookLogin', response.data.error_code);
        return Promise.reject(response);
      });
    }

    /**
     * Link Facebook Account.
     * - Given User Details and Facebook Tokens
     * - Able to bypass the TOTP Login.
     * - Default remembers login. (Same as loginWithFacebook->oAuthLogin)
     */

  }, {
    key: 'linkFacebookAccount',
    value: function linkFacebookAccount(user) {
      var _this14 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        email: user.email,
        password: user.password,
        credentials: user.facebookSignedRequest,
        access_token: user.facebookAccessToken
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/fb_link_login.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login.
          _this14.Auth.set(response.data.token, response.data.user, true);
          _this14.setExtraCookies();
          return response;
        }
      }).then(function (response) {
        return _this14.crossDomainSSO(response);
      }).catch(function (response) {
        _this14.trackError('LinkFacebookAccount', response.data.error_code);
        if (response.status === 401 || response.status === 429 || response.status === 500) {
          return Promise.reject(response);
        }
      });
    }
  }, {
    key: 'crossDomainSSO',
    value: function crossDomainSSO(originalResponse, rememberLogin) {
      var _this15 = this;

      if (!originalResponse || !originalResponse.data || !originalResponse.data.token || !originalResponse.data.user) {
        return originalResponse;
      }
      var ssoPromise = function ssoPromise(domain) {
        return _this15.$http({
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          url: domain + '/ajax/auth/cross_domain_sso.php',
          withCredentials: true,
          data: _this15.serializeData({
            authToken: originalResponse.data.token,
            userId: originalResponse.data.user,
            rememberLogin: !!rememberLogin
          })
        }).catch(function (e) {
          return _this15.trackError('CrossDomainSSOProcess', e);
        });
      };

      return this.$http({
        headers: { 'Content-Type': 'application/json' },
        url: '/ajax/auth/cross_domain_sso_domains.php'
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.domains) {
          var _ret = function () {
            var ssoPromises = [];
            var current = _this15.$window.location.protocol.concat('//').concat(_this15.$window.location.hostname);
            response.data.domains.forEach(function (domain) {
              if (domain !== current) {
                ssoPromises.push(ssoPromise(domain));
              }
            });
            return {
              v: Promise.all(ssoPromises).then(function () {
                return originalResponse;
              })
            };
          }();

          if (typeof _ret === "object") return _ret.v;
        }
        return originalResponse;
      }).catch(function (e) {
        return _this15.trackError('CrossDomainSSOGetDomains', e);
      });
    }
  }, {
    key: 'getQuickLoginFenceCookie',
    value: function getQuickLoginFenceCookie() {
      return this.$http({
        method: 'GET',
        url: '/ajax/signup/get-quick-login-fence.php'
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data) {
          return response.data;
        }
      }).catch(function () {});
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(email) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-XSRF-TOKEN': getCSRFToken(),
        Accept: 'application/json'
      };
      var data = { email: email };
      return this.$http({
        method: 'POST',
        url: '/users/ajaxonforgotpassword.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }, {
    key: 'serializeData',
    value: function serializeData(obj) {
      var result = [];

      Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        if (value === null) {
          value = '';
        }
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return result.join('&');
    }
  }, {
    key: 'trackError',
    value: function trackError(label, e) {
      qtsp.push({
        section: 'newAuth2FA',
        subsection: 'usersService',
        label: label,
        action: 'error',
        value: JSON.stringify(e)
      });
    }
  }, {
    key: 'getLoginRedirectUrl',
    value: function getLoginRedirectUrl(redirectDisabled, isModal, goto) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };

      var data = {
        redirect_disabled: redirectDisabled,
        is_modal: isModal,
        goto: goto
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login_redirect.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }, {
    key: 'getSignupRedirectUrl',
    value: function getSignupRedirectUrl(redirectDisabled, isModal, goto, projectCollaborationInvitation, contestCollaborationInvitation) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };

      var data = {
        redirect_disabled: redirectDisabled,
        is_modal: isModal,
        goto: goto,
        project_collaboration_invitation: projectCollaborationInvitation,
        contest_collaboration_invitation: contestCollaborationInvitation
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/signup_redirect.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }]);

  return UsersService;
}();

UsersService.$inject = ['$http', '$log', '$window', 'Auth', 'FACEBOOK_APP_ID', 'Localization', 'Users'];

var UsersProvider$1 = flService$1('UsersService', [AuthModule, UsersProvider, OPAQUE_MODULE_NAME], UsersService);

var UserData = function () {
  function UserData(UsersService) {
    _classCallCheck(this, UserData);

    this.user = {
      fullName: '',
      username: '',
      email: '',
      password: '',
      country: '',
      deviceToken: '',
      preLoginToken: '',
      TOTP: '',
      role: '',
      isNewUser: false,
      captcha: {
        challenge: '',
        response: ''
      },
      // Facebook
      facebookConnected: false,
      facebookName: '',
      facebookEmail: '',
      facebookPictureUrl: '',
      facebookAccessToken: '',
      facebookSignedRequest: '',
      // Privacy Consent
      isFromEU: false,
      privacyConsent: false,
      privateUser: null
    };
    this.UsersService = UsersService;
  }

  _createClass(UserData, [{
    key: 'setFacebookName',
    value: function setFacebookName(name) {
      this.user.facebookName = name;
    }
  }, {
    key: 'getFacebookName',
    value: function getFacebookName() {
      return this.user.facebookName;
    }
  }, {
    key: 'setFacebookEmail',
    value: function setFacebookEmail(email) {
      this.user.facebookEmail = email;
    }
  }, {
    key: 'getFacebookEmail',
    value: function getFacebookEmail() {
      return this.user.facebookEmail;
    }
  }, {
    key: 'setFacebookPictureUrl',
    value: function setFacebookPictureUrl(url) {
      this.user.facebookPictureUrl = url;
    }
  }, {
    key: 'getFacebookPictureUrl',
    value: function getFacebookPictureUrl() {
      return this.user.facebookPictureUrl;
    }
  }, {
    key: 'setFacebookUserId',
    value: function setFacebookUserId(id) {
      this.user.facebookUserId = id;
    }
  }, {
    key: 'getFacebookUserId',
    value: function getFacebookUserId() {
      return this.user.facebookUserId;
    }
  }, {
    key: 'setFacebookAccessToken',
    value: function setFacebookAccessToken(token) {
      this.user.facebookAccessToken = token;
    }
  }, {
    key: 'getFacebookAccessToken',
    value: function getFacebookAccessToken() {
      return this.user.facebookAccessToken;
    }
  }, {
    key: 'setFacebookConnected',
    value: function setFacebookConnected(isFacebook) {
      this.user.facebookConnected = isFacebook;
    }
  }, {
    key: 'isFacebookConnected',
    value: function isFacebookConnected() {
      return this.user.facebookConnected;
    }
  }]);

  return UserData;
}();

UserData.$inject = ['UsersService'];

var UserData$1 = flService$1('UserData', [UsersProvider$1], UserData);

/**
 * @ngdoc directive
 * @name flBlockedEmailCheck
 * @restrict A
 * @description
 * Validate if user email address is blocked
 */

var BlockedEmailCheck = function () {
  function BlockedEmailCheck($q, $timeout, UsersService) {
    _classCallCheck(this, BlockedEmailCheck);

    this.$q = $q;
    this.$timeout = $timeout;
    this.UsersService = UsersService;
  }

  _createClass(BlockedEmailCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$asyncValidators.unblockedEmail = function (modelValue, email) {
        var deferred = _this.$q.defer();
        _this.UsersService.checkBlockedEmail(email).then(function (isValidEmail) {
          _this.$timeout(function () {
            if (isValidEmail) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          }, 500);
        });
        return deferred.promise;
      };
    }
  }]);

  return BlockedEmailCheck;
}();

BlockedEmailCheck.$inject = ['$q', '$timeout', 'UsersService'];

var flBlockedEmailCheck = flDirective$1(BlockedEmailCheck, {
  selector: '[fl-blocked-email-check]',
  require: 'ngModel',
  providers: [UsersProvider$1]
});

var _templateObject$11 = _taggedTemplateLiteral(['^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\n    \\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]\n    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'], ['^(([^<>()\\\\[\\\\]\\\\\\.,;:\\\\s@"]+(\\\\.[^<>()\\\\[\\\\]\n    \\\\\\.,;:\\\\s@"]+)*)|(".+"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]\n    {1,3}])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$']);

function isValidEmail(email) {
  // TODO: Check unit test as the regex has failed to catch no TLD domains.
  var re = new RegExp(oneLineTrim(_templateObject$11));
  return re.test(email);
}

function isValidUsernameFormat(username) {
  var re = /^[a-z][a-z0-9]{2,15}$/i;
  return re.test(username);
}

/**
 * @ngdoc directive
 * @name flEmailUsernameValidCheck
 * @restrict A
 * @description
 * Validates email pattern and is not equal to username
 */

var flEmailUsernameValidCheck = function () {
  function flEmailUsernameValidCheck(UserData) {
    _classCallCheck(this, flEmailUsernameValidCheck);

    this.user = UserData.user;
  }

  _createClass(flEmailUsernameValidCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var field = attr.flEmailUsernameValidCheck;
      if (field === 'email') {
        ngModel.$validators.validEmail = isValidEmail;
      } else if (field === 'username') {
        ngModel.$validators.validUsername = isValidUsernameFormat;
        ngModel.$validators.uniqueFromPassword = function (username) {
          if (!username) {
            return true;
          }

          return username !== _this.user.password;
        };
      } else {
        ngModel.$validators.validEmailUsername = function (email) {
          if (!email) {
            return true;
          }
          return isValidEmail(email) || isValidUsernameFormat(email);
        };
      }
    }
  }]);

  return flEmailUsernameValidCheck;
}();

flEmailUsernameValidCheck.$inject = ['UserData'];

var flEmailUsernameValidCheck$1 = flDirective$1(flEmailUsernameValidCheck, {
  selector: '[fl-email-username-valid-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flPasswordCheck
 * @restrict A
 * @description
 * Validates password pattern and is not equal to username
 */

var PasswordCheck = function () {
  function PasswordCheck(UserData) {
    _classCallCheck(this, PasswordCheck);

    this.user = UserData.user;
  }

  _createClass(PasswordCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.uniqueFromUsername = function (password) {
        if (!password) {
          return true;
        }
        return password !== _this.user.username;
      };

      ngModel.$validators.strongPassword = function (password) {
        if (!password) {
          return true;
        }
        var nums = password.match(/\d/g);
        var lowers = password.match(/[a-z]/g);
        var uppers = password.match(/[A-Z]/g);

        var pattern = /^.{6,}$/i;
        var pattern_result = pattern.test(password);

        if (pattern_result) {
          var strengthLevel = 0;
          if (nums) {
            strengthLevel += 2;
          }
          if (lowers) {
            strengthLevel += uppers ? 4 : 3;
          }
          if (uppers) {
            strengthLevel += lowers ? 4 : 3;
          }
          return strengthLevel > 4;
        }
        return false;
      };
    }
  }]);

  return PasswordCheck;
}();

PasswordCheck.$inject = ['UserData'];

var flPasswordCheck = flDirective$1(PasswordCheck, {
  selector: '[fl-password-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flArrowPasswordCheck
 * @restrict A
 * @description
 * Validates password meets Arrow password requirements
 */

var ArrowPasswordCheck = function () {
  function ArrowPasswordCheck(UserData) {
    _classCallCheck(this, ArrowPasswordCheck);

    this.user = UserData.user;
  }

  _createClass(ArrowPasswordCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      ngModel.$validators.strongArrowPassword = function (password) {
        // Arrow passwords require there to be at least one lowercase,
        // one uppercase, and a number in passwords.
        if (!password) {
          return true;
        }
        var nums = password.match(/\d/g);
        var lowers = password.match(/[a-z]/g);
        var uppers = password.match(/[A-Z]/g);

        var pattern = /^.{8,}$/i;
        var pattern_result = pattern.test(password);

        if (pattern_result) {
          return Boolean(nums) && Boolean(lowers) && Boolean(uppers);
        }
        return false;
      };

      // Arrow allows a certain set of special characters: ~!@#$%^*()-_=+[]|;:,.<>/?
      // We must check that special characters in the password are allowed.
      ngModel.$validators.arrowPasswordAllowedCharacters = function (password) {
        return (/^[\w~!@#$%^*()\-_=+[\]\|;:,.<>\/?]*$/.test(password)
        );
      };
    }
  }]);

  return ArrowPasswordCheck;
}();

ArrowPasswordCheck.$inject = ['UserData'];

var flArrowPasswordCheck = flDirective$1(ArrowPasswordCheck, {
  selector: '[fl-arrow-password-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flUniqueEmailUsernameCheck
 * @restrict A
 * @description
 * Async Validator to check if email or username given already exists
 */

var UniqueEmailUsernameCheck = function () {
  function UniqueEmailUsernameCheck($q, $timeout, UsersService) {
    _classCallCheck(this, UniqueEmailUsernameCheck);

    this.$q = $q;
    this.$timeout = $timeout;
    this.UsersService = UsersService;
  }

  _createClass(UniqueEmailUsernameCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var field = attr.flUniqueEmailUsernameCheck;
      if (field === 'username') {
        ngModel.$asyncValidators.uniqueUsername = function (modelValue, username) {
          var deferred = _this.$q.defer();
          if (!username) {
            deferred.resolve();
          }
          _this.UsersService.checkUsernameExists(username).then(function (response) {
            _this.$timeout(function () {
              if (response === 'true') {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, 500);
          });
          return deferred.promise;
        };
      } else {
        ngModel.$asyncValidators.uniqueEmail = function (modelValue, email) {
          var deferred = _this.$q.defer();
          if (!email) {
            deferred.resolve();
          }
          _this.UsersService.checkEmailExists(email).then(function (response) {
            _this.$timeout(function () {
              if (response === 'true') {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, 500);
          });
          return deferred.promise;
        };
      }
    }
  }]);

  return UniqueEmailUsernameCheck;
}();

UniqueEmailUsernameCheck.$inject = ['$q', '$timeout', 'UsersService'];

var flUniqueEmailUsernameCheck = flDirective$1(UniqueEmailUsernameCheck, {
  selector: '[fl-unique-email-username-check]',
  require: 'ngModel',
  providers: [UsersProvider$1]
});

/**
 * @ngdoc directive
 * @name flUniqueArrowEmailCheck
 * @restrict A
 * @description
 * Async Validator to check if email exists on Arrow already.
 */

var UniqueArrowEmailCheck = function () {
  function UniqueArrowEmailCheck($http, $q, $timeout) {
    _classCallCheck(this, UniqueArrowEmailCheck);

    this.$http = $http;
    this.$q = $q;
    this.$timeout = $timeout;
  }

  _createClass(UniqueArrowEmailCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$asyncValidators.uniqueArrowEmail = function (modelValue, email) {
        var deferred = _this.$q.defer();
        _this.$http({
          method: 'GET',
          url: '/ajax/auth/arrow/check-email-exists.php',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          params: { email: email }
        }).then(function (response) {
          _this.$timeout(function () {
            if (response.status !== 200) {
              return Promise.reject();
            }
            deferred.resolve();
          }, 500);
        }).catch(function () {
          deferred.reject();
        });
        return deferred.promise;
      };
    }
  }]);

  return UniqueArrowEmailCheck;
}();

UniqueArrowEmailCheck.$inject = ['$http', '$q', '$timeout'];

var flUniqueArrowEmailCheck = flDirective$1(UniqueArrowEmailCheck, {
  selector: '[fl-unique-arrow-email-check]',
  require: 'ngModel'
});

var CorporateService = function () {
  function CorporateService($http, $log, Auth) {
    _classCallCheck(this, CorporateService);

    this.$http = $http;
    this.$log = $log;
    this.Auth = Auth;
    this.newAuthUrl = '/auth'; // TODO: Replace this to use config
    this.CORPORATE_COOKIE_KEY = 'CORPORATE_ID';
  }

  _createClass(CorporateService, [{
    key: 'checkCorporate',
    value: function checkCorporate() {
      if (getCookie(this.CORPORATE_COOKIE_KEY) !== '') {
        return true;
      }
      return false;
    }
  }, {
    key: 'serializeData',
    value: function serializeData(obj) {
      var result = [];

      Object.keys(obj).forEach(function (key) {
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      });
      return result.join('&');
    }
  }, {
    key: 'swapAccount',
    value: function swapAccount(rememberLogin) {
      var _this = this;

      var user = this.Auth.getUserId();
      var token = this.Auth.getAccessToken();
      var otherUser = getCookie(this.CORPORATE_COOKIE_KEY);
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        user: user,
        token: token,
        other_user: otherUser
      };
      if (user != otherUser) {
        return this.$http({
          method: 'POST',
          url: this.newAuthUrl + '/switch_account/',
          headers: headers,
          data: this.serializeData(data)
        }).then(function (response) {
          if (response.status !== 200) {
            return;
          }
          if (response.data && response.data.token) {
            // Successfully login
            _this.Auth.reset();
            _this.Auth.set(response.data.token, response.data.user, rememberLogin);
            return response;
          }
        }).catch(function (response) {
          _this.trackError('SwitchCorporateUserLogin', response.data.error_code);
          // Auth HTTP Interceptor will log the user out if a response status is 401.
          // Add the Auth Cookie for the current user if this happens.
          _this.Auth.reset();
          _this.Auth.set(token, user, rememberLogin);
          return response;
        });
      }
      return Promise.resolve();
    }
  }, {
    key: 'trackError',
    value: function trackError(label, e) {
      qtsp.push({
        section: 'newAuth2FA',
        subsection: 'corporateService',
        label: label,
        action: 'error',
        value: JSON.stringify(e)
      });
    }
  }]);

  return CorporateService;
}();

CorporateService.$inject = ['$http', '$log', 'Auth'];

var CorporateProvider = flService$1('CorporateService', [AuthModule], CorporateService);

// This allows Webapp Modals to be used from the SystemJS (static/modules) code.
var webappCompatModalsReady = new Promise(function (resolve) {
  if (window.webappCompatModals) {
    resolve();
  } else {
    window.webappCompatModalsReadyCallback = function () {
      return resolve();
    };
  }
});

var WebappModals = function () {
  function WebappModals() {
    _classCallCheck(this, WebappModals);
  }

  _createClass(WebappModals, [{
    key: "open",
    value: function open(componentName, config, afterCloseCallback) {
      return webappCompatModalsReady.then(function () {
        return window.webappCompatModals.open(componentName, config, afterCloseCallback);
      });
    }
  }]);

  return WebappModals;
}();

// e.g.,
// webappModals.open('AwardModalComponent',
//   inputs: {
//     userId: 233223243,
//   }
// );
var webappModals = new WebappModals();

// Compute the CRC32 of a string
var table = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

/* Number */
function crc32$1( /* String */str, /* Number */crc) {
  if (crc == undefined) crc = 0;
  var n = 0; // a number between 0 and 255
  var x = 0; // an hex number

  crc ^= -1;
  for (var i = 0, iTop = str.length; i < iTop; i++) {
    n = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(n * 9, 8);
    crc = crc >>> 8 ^ x;
  }
  return crc ^ -1;
}

function cdn_url(url, protocol) {
  // forcing https this way for backwards compat
  protocol = 'https://';

  var host = cdnUrls[Math.abs(crc32$1(url)) % cdnUrls.length];
  return protocol + host + url;
}

/**
 * - disableRedirect option will disable redirects & reloads, but not force
 *   redirects in on login. Note it will also cancel default redirects into
 *   the usual signup funnel.
 * - Best not to directly edit varaibles showSignup and visible, but to use the
 *   appropriate function calls.
 */
var DEFAULT_OPTIONS = {
  showAsModal: true,
  hideFb: false,
  showSignupOption: true,
  showLoginOption: true,
  showAppLinks: true,
  pageName: '',
  signupTitle: '',
  loginTitle: '',
  signupSuccessMessage: '',
  loginSuccessMessage: '',
  forcedAccountType: '',
  redirectUrl: '',
  redirectUrlEncoded: '',
  disableRedirect: false,
  disableBackdropClose: false,
  visible: false,
  showSignup: false,
  projectCollaborationInvitation: '',
  contestCollaborationInvitation: '',
  old2FAToken: ''
};

/**
 * @ngdoc service
 * @name loginSignupApp.LoginSignupConfig
 *
 * @description
 * Customisable Login Signup Config.
 * Acts as an angularjs service which can be accessed by legacy code
 *
 * Usage:
 */

var LoginSignupConfig = function () {
  function LoginSignupConfig($rootScope, UserData) {
    var _this = this;

    _classCallCheck(this, LoginSignupConfig);

    this.$rootScope = $rootScope;
    this.UserData = UserData;

    // Auth Messages returned in onAuthPromise, on signup and login
    this.authMessages = {
      SIGNUP_EMPLOYER: 'signup_success_employer',
      SIGNUP_FREELANCER: 'signup_success_freelancer',
      LOGIN_SUCCESS: 'login_success',
      CLOSE_MODAL: 'close_modal'
    };

    // Customisable options: Can be changed on the fly. For example each time
    // you show the Login/Signup Modal.
    this.options = Object.assign({}, DEFAULT_OPTIONS);

    this.$rootScope.$watch(function () {
      return _this.options.visible;
    }, function (newValue) {
      // If Login/Signup has been hidden, reject the auth promise
      if (newValue === false && typeof _this.rejectAuth === 'function') {
        _this.rejectAuth(_this.authMessages.CLOSE_MODAL);
      }
    });
  }

  /**
   * @ngdoc method
   * @name loginSignupApp.LoginSignupConfig#showSignup
   * @param {object} customOptions Custom modal options. (optional)
   * @description
   * Show the signup angular modal.
   * This can be called from within angular code and legacy code.
   */

  _createClass(LoginSignupConfig, [{
    key: 'showSignup',
    value: function showSignup(customOptions) {
      var _this2 = this;

      this.$rootScope.$evalAsync(function () {
        _this2.options = Object.assign({}, _this2.options, customOptions);
        _this2.options.visible = true;
        _this2.options.showSignup = true;
      });

      return new Promise(function (resolve, reject) {
        _this2.resolveAuth = resolve;
        _this2.rejectAuth = reject;
      });
    }

    /**
     * @ngdoc method
     * @name loginSignupApp.LoginSignupConfig#showLogin
     * @param {object} customOptions Custom modal options. (optional)
     * @description
     * Show the login angular modal.
     * This can be called from within angular code and legacy code.
     */

  }, {
    key: 'showLogin',
    value: function showLogin(customOptions) {
      var _this3 = this;

      this.$rootScope.$evalAsync(function () {
        _this3.options = Object.assign({}, _this3.options, customOptions);

        _this3.options.visible = true;
        _this3.options.showSignup = false;
      });

      return new Promise(function (resolve, reject) {
        _this3.resolveAuth = resolve;
        _this3.rejectAuth = reject;
      });
    }
  }, {
    key: 'switchToSignup',
    value: function switchToSignup() {
      this.options.showSignup = true;
      // reset the username value
      this.UserData.user.username = '';
      // if username is valid email, move to email input on Signup Form.
      if (this.UserData.user.username && isValidEmail(this.UserData.user.username)) {
        this.UserData.user.email = this.UserData.user.username;
      }
    }
  }, {
    key: 'switchToLogin',
    value: function switchToLogin() {
      this.options.showSignup = false;
      if (this.UserData.user.email) {
        this.UserData.user.username = this.UserData.user.email;
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      var _this4 = this;

      this.$rootScope.$evalAsync(function () {
        _this4.options.visible = false;
      });
    }
  }, {
    key: 'isModal',
    value: function isModal() {
      return this.options.showAsModal;
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.options.visible;
    }
  }, {
    key: 'isDisableBackdropClose',
    value: function isDisableBackdropClose() {
      return this.options.disableBackdropClose;
    }
  }, {
    key: 'showSignupOption',
    value: function showSignupOption() {
      return this.options.showSignupOption;
    }
  }, {
    key: 'showLoginOption',
    value: function showLoginOption() {
      return this.options.showLoginOption;
    }
  }, {
    key: 'showAppLinks',
    value: function showAppLinks() {
      return this.options.showAppLinks;
    }
  }, {
    key: 'getPageName',
    value: function getPageName() {
      return this.options.pageName;
    }
  }, {
    key: 'getSignupTitle',
    value: function getSignupTitle() {
      return this.options.signupTitle;
    }
  }, {
    key: 'getLoginTitle',
    value: function getLoginTitle() {
      return this.options.loginTitle;
    }
  }, {
    key: 'getSignupSuccessMessage',
    value: function getSignupSuccessMessage() {
      return this.options.signupSuccessMessage;
    }
  }, {
    key: 'getLoginSuccessMessage',
    value: function getLoginSuccessMessage() {
      return this.options.loginSuccessMessage;
    }
  }, {
    key: 'getRedirectUrl',
    value: function getRedirectUrl() {
      return this.options.redirectUrl;
    }
  }, {
    key: 'getRedirectUrlEncoded',
    value: function getRedirectUrlEncoded() {
      return this.options.redirectUrlEncoded;
    }
  }, {
    key: 'getForcedAccountType',
    value: function getForcedAccountType() {
      return this.options.forcedAccountType;
    }
  }, {
    key: 'isHideFb',
    value: function isHideFb() {
      return this.options.hideFb;
    }
  }, {
    key: 'getSkipCaptchaHash',
    value: function getSkipCaptchaHash() {
      return this.options.skipCaptchaHash;
    }
  }, {
    key: 'isRedirectDisabled',
    value: function isRedirectDisabled() {
      return this.options.disableRedirect;
    }
  }, {
    key: 'getEmailPrefill',
    value: function getEmailPrefill() {
      return this.options.emailPrefill;
    }
  }, {
    key: 'getProjectCollaborationInvitation',
    value: function getProjectCollaborationInvitation() {
      return this.options.projectCollaborationInvitation;
    }
  }, {
    key: 'getContestCollaborationInvitation',
    value: function getContestCollaborationInvitation() {
      return this.options.contestCollaborationInvitation;
    }
  }, {
    key: 'getOld2FAToken',
    value: function getOld2FAToken() {
      return this.options.old2FAToken;
    }
  }]);

  return LoginSignupConfig;
}();

LoginSignupConfig.$inject = ['$rootScope', 'UserData'];

var LoginSignupConfigProvider = flService$1('LoginSignupConfig', [UserData$1], LoginSignupConfig);

var APP_LINKS = flConstant$1('APP_LINKS', {
  appStoreLink: 'https://bnc.lt/Ed5l/nPQu9RdcWr',
  playStoreLink: 'https://bnc.lt/Ed5l/nPQu9RdcWr'
});

var linkTemplate = "<div class=\"ModalLoginSignup-appLinks\">\n  <a id='appStore' href=\"{{AppLinks.appStoreUrl}}\" class=\"app-store-link\" target=\"_blank\"\n    title=\"Download from the iTunes store\"\n    ng-click=\"AppLinks.trackAppStoreClick()\">\n    <img ng-src=\"{{AppLinks.cdn_url('/static/img/appstoreicons/apple-app-store-badge.png')}}\" height=\"100%\" />\n  </a>\n  <a id='playStore' href=\"{{AppLinks.playStoreUrl}}\" class=\"app-store-link\" target=\"_blank\"\n    title=\"Download from Google play\"\n    ng-click=\"AppLinks.trackPlayStoreClick()\">\n    <img ng-src=\"{{AppLinks.cdn_url('/static/img/appstoreicons/google-play-store-badge.png')}}\" height=\"100%\" />\n  </a>\n</div>\n";

var flAppLinks = function () {
  function flAppLinks(APP_LINKS$$1, LoginSignupConfig) {
    _classCallCheck(this, flAppLinks);

    this.appStoreUrl = APP_LINKS$$1.appStoreLink;
    this.playStoreUrl = APP_LINKS$$1.playStoreLink;
    this.cdn_url = cdn_url;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flAppLinks, [{
    key: 'trackPlayStoreClick',
    value: function trackPlayStoreClick() {
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'DownloadPlayStore',
        action: 'click'
      });
    }
  }, {
    key: 'trackAppStoreClick',
    value: function trackAppStoreClick() {
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'DownloadAppStore',
        action: 'click'
      });
    }
  }]);

  return flAppLinks;
}();

flAppLinks.$inject = ['APP_LINKS', 'LoginSignupConfig'];

var flAppLinks$1 = flComponent$1(flAppLinks, {
  selector: 'fl-app-links',
  template: linkTemplate,
  providers: [APP_LINKS, LoginSignupConfigProvider]
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
* @ngdoc directive
* @name flUi.directive:flFocusOn
* @element input
* @function
*
* @description
* Focus an element when the attached expression is true
*
* @usage
* <!-- This input will gain focus when focus evaluates to true -->
* <input type="text" fl-focus-on="focus">
* </input>
*
* @example
*  <example module="flUi">
*    <file name="index.html">
*      <div ng-controller="myController">
*        <input type="text" fl-focus-on="result.willBeTrue"
*          ng-model="confirmation">
*        </input>
*        <a ng-click="startInterval()" class="btn btn-primary" href="">
*          Run example again
*        </a>
*      </div>
*    </file>
*    <file name="index.js">
*        angular.module('flUi', []).controller('myController',
*        ($scope, $interval) => {
*          // Here we store our $interval so we can cancel it (stop it) later
*          let interval;
*          // Initialize this to false. As soon as it turns to true,
*          // our input element will gain focus.
*          $scope.result = {
*            willBeTrue: false
*          };
*          // The value of this var will appear in the text input
*          //after 5 secs
*          $scope.confirmation = null;
*
*          // Make expression evaluate to true after 3 seconds
*          $scope.startInterval = () => {
*            $scope.result.willBeTrue = false;
*            $scope.confirmation = 5;
*
*            interval = $interval(() => {
*              $scope.confirmation--;
*
*              if($scope.confirmation === 0) {
*                $scope.confirmation = "I should have focus now...";
*                $scope.result.willBeTrue = true;
*                $interval.cancel(interval);
*              };
*            }, 1000);
*          };
*
*          $scope.startInterval();
*        })
*    </file>
*  </example>
*/

var flFocusOn = function () {
  function flFocusOn() {
    _classCallCheck(this, flFocusOn);
  }

  _createClass(flFocusOn, [{
    key: 'link',
    value: function link(scope, element, attrs) {
      scope.$watch(attrs.flFocusOn, function (doFocus) {
        if (doFocus) {
          element[0].focus();
        }
      });
    }
  }]);

  return flFocusOn;
}();

var flFocusOnProvider = flDirective(flFocusOn, {
  selector: '[fl-focus-on]'
});

var arrowLoginFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\"\n    ng-if=\"ArrowLoginForm.showAsModal\"\n    ng-click=\"ArrowLoginForm.closeModal()\"\n    type=\"button\"\n    data-modal-hide aria-label=\"Close this modal window\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-body--arrow\"\n  fl-analytics-section=\"Login\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span>\n      Welcome Back\n    </span>\n  </div>\n\n  <form name=\"ArrowLoginForm.form\"\n    class=\"user-login-form fl-form large-form responsive-form\">\n    <aside ng-class=\"{'is-hidden': !ArrowLoginForm.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span ng-if=\"ArrowLoginForm.errorStatus === 200 && ArrowLoginForm.errorCode === 'EXTERNAL_AW_LINK_EXISTING_BOTH'\">\n        Sorry we were unable to login to your account, there was a Freelancer account under the same email address. Please contact <a href=\"/support\">support</a>.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 401 && (ArrowLoginForm.errorCode === 'EXTERNAL_AW_NOT_FOUND' || ArrowLoginForm.errorCode === 'EXTERNAL_AW_UNAUTHORIZED')\">\n        Incorrect email address or password provided.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 401 && ArrowLoginForm.errorCode === 'GAF_ACCOUNT_CLOSED'\">\n        This account has been closed. Please contact <a href=\"/support/profile/can-i-reopen-my-closed-account\">support</a> for more assistance.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 400 && ArrowLoginForm.errorCode === 'EXTERNAL_AW_USER_LOCKED'\">\n        You have attempted to log in too many times, and your account has been locked. Please reset your password to unlock your account.\n      </span>\n      <span ng-if=\"(\n            ArrowLoginForm.errorStatus === 401\n            && ArrowLoginForm.errorCode !== 'EXTERNAL_AW_NOT_FOUND'\n            && ArrowLoginForm.errorCode !== 'EXTERNAL_AW_UNAUTHORIZED'\n            && ArrowLoginForm.errorCode !== 'GAF_ACCOUNT_CLOSED'\n        )\n        || ArrowLoginForm.errorStatus === 500\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n      <span ng-if=\"ArrowLoginForm.errorStatus === 429\">\n        You are performing too many requests. Please try again later.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowLoginForm.loginSuccess\">\n      Login Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n    <ol>\n      <li class=\"form-step username-step\"\n        ng-class=\"{'is-invalid': ArrowLoginForm.form.username.$invalid && ArrowLoginForm.form.username.$dirty}\">\n        <p class=\"ModalLoginSignup-body-credential\">\n          Sign in with your Arrow credentials\n        </p>\n        <label for=\"username\" class=\"is-accessibly-hidden\">\n          Email Address\n        </label>\n        <input id=\"username\"\n          class=\"large-input\"\n          name=\"username\"\n          type=\"text\"\n          placeholder=\"Email\"\n          maxlength=\"150\"\n          ng-model=\"ArrowLoginForm.UserData.user.email\"\n          ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n          ng-required=\"true\"\n          ng-change=\"ArrowLoginForm.hideErrorMessage()\"\n          fl-email-username-valid-check=\"email\"\n          fl-focus-on=\"ArrowLoginForm.focusEmailInput\"\n        />\n        <div ng-messages=\"ArrowLoginForm.form.username.$error\"\n          tabindex=\"-1\">\n          <div class=\"form-error\"\n            ng-message=\"required\">\n              Please enter your email address.\n          </div>\n          <div class=\"form-error\"\n            ng-message=\"validEmail\">\n              Please enter a valid email address.\n          </div>\n        </div>\n      </li>\n      <li class=\"form-step password-step\"\n        ng-class=\"{'is-invalid': ArrowLoginForm.form.password.$invalid && ArrowLoginForm.form.password.$dirty}\">\n          <label class=\"is-accessibly-hidden\"\n            for=\"password\">\n            Password\n          </label>\n          <input id=\"password\"\n            class=\"large-input\"\n            name=\"password\"\n            type=\"password\"\n            placeholder=\"Password\"\n            maxlength=\"150\"\n            ng-model=\"ArrowLoginForm.UserData.user.password\"\n            ng-required=\"true\"\n          />\n          <div ng-messages=\"ArrowLoginForm.form.password.$error\"\n            tabindex=\"-1\">\n            <div class=\"form-error\"\n              ng-message=\"required\">\n                Please enter your password.\n            </div>\n          </div>\n      </li>\n      <li class=\"form-step has-label login-form-options\">\n          <a class=\"login-form-forgot forgot-password\"\n            ng-click=\"ArrowLoginForm.showStep({step: ArrowLoginForm.steps.RESET_PASSWORD})\"\n            fl-analytics=\"ArrowForgotPassword\">\n            Forgot Password?\n          </a>\n          <div class=\"Checkbox\">\n            <input id=\"loginpermanent\"\n              ng-model=\"ArrowLoginForm.rememberLogin\"\n              class=\"Checkbox-input\"\n              type=\"checkbox\"\n              name=\"remember\"\n            />\n            <label class=\"ModalLoginSignup-body-label Checkbox-label checkbox\"\n              for=\"loginpermanent\">\n                Remember me\n            </label>\n          </div>\n      </li>\n      <li class=\"form-step\">\n        <button id=\"login_btn\"\n          class=\"btn btn-black btn-large btn-submit ModalLoginSignup-loginForm-submitBtn\"\n          ng-click=\"ArrowLoginForm.login($event)\"\n          ng-disabled=\"ArrowLoginForm.isSubmitting\"\n          type=\"submit\"\n          fl-analytics=\"NormalLogin\">\n          Log In\n        </button>\n      </li>\n      <li class=\"form-step\">\n        <div class=\"ModalLoginSignup-body-loginFl\">\n          <a href=\"{{ArrowLoginForm.loginWithFreelancerUrl}}\">\n            or log in with Freelancer.com\n          </a>\n        </div>\n      </li>\n    </ol>\n  </form>\n  <span class=\"ModalLoginSignup-switchLoginSignupType\">\n    Don't have an account?\n    <a ng-click=\"ArrowLoginForm.showSignupForm({event: $event})\"\n      fl-analytics=\"ArrowSignupLink\">\n      Sign Up\n    </a>\n  </span>\n</div>\n";

var flArrowLoginForm = function () {
  function flArrowLoginForm($http, $timeout, UserData, UsersService, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flArrowLoginForm);

    this.$http = $http;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.loginSignupConfig = LoginSignupConfig;
    this.form = {};
    this.isSubmitting = false;
    this.showErrorMessage = false;
    this.loginSuccess = false;

    // Focus on the email input after timeout
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);

    // Set the redirect url if a user decides to login with their freelancer
    // account on Freelancer.com
    var redirectUrlEncoded = this.loginSignupConfig.getRedirectUrlEncoded();
    // If there is no goto provided, the login component is in a modal, so we
    // must use the `next` url param to provide the actual path in the param.
    var nextPath = encodeURIComponent(window.location.pathname + window.location.search);
    this.loginWithFreelancerUrl = 'https://www.freelancer.com/partner-login?' + (redirectUrlEncoded ? 'goto=' + redirectUrlEncoded : 'nextSite=arrow&next=' + nextPath);
  }

  _createClass(flArrowLoginForm, [{
    key: 'login',
    value: function login($event) {
      var _this2 = this;

      $event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty if it has any errors
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });

      // Do not make any submitting actions if submission has begun already,
      // or if the form is invalid.
      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;

      // Make login request
      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/login.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password
        })
      }).then(function (response) {
        // An error occurred
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successful login
          _this2.loginSuccess = true;
          _this2.onLoginSuccess({ response: response });
        }
      }).catch(function (response) {
        if (response.data && response.data.error === 'EXTERNAL_AW_LINK_EXISTING_AW') {
          // Arrow account exists without a linked FLN account
          _this2.showStep({ step: _this2.steps.USERNAME_INPUT });
          return;
        }
        if (response.data && response.data.error === 'GAF_ACCOUNT_SUSPENDED') {
          _this2.onLoginSuccess({
            response: response,
            forceRedirectUrl: '/users/usersuspended.php'
          });
          return;
        }
        _this2.showErrorMessage = true;
        _this2.isSubmitting = false;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error;
      });
    }
  }, {
    key: 'hideErrorMessage',
    value: function hideErrorMessage() {
      this.showErrorMessage = false;
    }
  }]);

  return flArrowLoginForm;
}();

flArrowLoginForm.$inject = ['$http', '$timeout', 'UserData', 'UsersService', 'LoginSignupConfig'];

var flArrowLoginForm$1 = flComponent$1(flArrowLoginForm, {
  selector: 'fl-arrow-login-form',
  template: arrowLoginFormTemplate,
  providers: [flEmailUsernameValidCheck$1, flFocusOnProvider, UserData$1, UsersProvider$1, LoginSignupConfigProvider],
  bindings: {
    rememberLogin: '=',
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    showSignupForm: '&',
    showStep: '&'
  }
});

var arrowLoginSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\"\n      ng-click=\"ArrowLoginSuccess.closeModal($event)\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"ArrowLoginSuccess.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body\"\n  fl-analytics-section=\"ArrowLogin\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Login Success!</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flArrowLoginSuccess = function flArrowLoginSuccess() {
  _classCallCheck(this, flArrowLoginSuccess);
};

var flArrowLoginSuccess$1 = flComponent$1(flArrowLoginSuccess, {
  selector: 'fl-arrow-login-success',
  template: arrowLoginSuccessTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

var arrowLoginUsernameInputTemplate = "<div class=\"Modal-header\">\n    <div class=\"ModalLoginSignup-header\">\n      <div class=\"ModalLoginSignup-header-previousStep\"\n        ng-click=\"ArrowLoginUsernameInput.showStep({step: ArrowLoginUsernameInput.steps.LOGIN_FORM})\">\n        <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n          name=\"ui-chevron-left\">\n        </fl-icon>\n      </div>\n      <button class=\"Modal-close\"\n        ng-if=\"ArrowLoginUsernameInput.showAsModal\"\n        ng-click=\"ArrowLoginUsernameInput.closeModal()\"\n        type=\"button\"\n        data-modal-hide aria-label=\"Close this modal window\">\n        <span class=\"Icon Icon--small\">\n          <fl-icon name=\"ui-close\"></fl-icon>\n        </span>\n      </button>\n      <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n        <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"Modal-body\"\n    fl-analytics-section=\"Signup\">\n    <h2 class=\"ModalLoginSignup-body-title ModalLoginSignup-body-title--center\">\n      Choose a username\n    </h2>\n    <aside ng-class=\"{'is-hidden': !ArrowLoginUsernameInput.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 400 && ArrowLoginUsernameInput.errorCode === 'GAF_EMAIL_EXISTS'\">\n        This email address is already in use. Please log in to your account.\n      </span>\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 400 && ArrowLoginUsernameInput.errorCode === 'GAF_EMAIL_BLOCKED'\">\n        This email domain you are using is blocked. Please use another email address.\n      </span>\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 401\n        || ArrowLoginUsernameInput.errorStatus === 500\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n      <span ng-if=\"ArrowLoginUsernameInput.errorStatus === 429\">\n        You are performing too many requests. Please try again later.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowLoginUsernameInput.loginSuccess\">\n      Login Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n    <p class=\"ModalLoginSignup-body-subtitle\">\n      Please note that a username cannot be changed, once chosen.\n    </p>\n    <form class=\"user-signup-form fl-form responsive-form\"\n      name=\"ArrowLoginUsernameInput.form\">\n      <div class=\"form-step email-step\"\n        ng-class=\"{'is-invalid': ArrowLoginUsernameInput.form.username.$invalid && ArrowLoginUsernameInput.form.username.$dirty,\n                    'is-valid': ArrowLoginUsernameInput.form.username.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"new-username\">\n          Username\n        </label>\n        <input id=\"new-username\"\n          class=\"large-input\"\n          type=\"text\"\n          name=\"username\"\n          rel=\"popover\"\n          placeholder=\"Username\"\n          ng-model=\"ArrowLoginUsernameInput.UserData.user.username\"\n          ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n          ng-required=\"true\"\n          ng-minlength=\"3\"\n          ng-maxlength=\"16\"\n          fl-email-username-valid-check=\"username\"\n          fl-unique-email-username-check=\"username\"\n          fl-focus-on=\"ArrowLoginUsernameInput.focusUsernameInput\">\n        <div class=\"Loader Loader--small ModalLoginSignup-inputLoader\"\n          ng-if=\"ArrowLoginUsernameInput.form.username.$pending\">\n        </div>\n        <div ng-messages=\"ArrowLoginUsernameInput.form.username.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please enter a username.\n          </div>\n          <div class=\"form-error\" ng-message=\"minlength\">\n            Please enter at least 3 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"maxlength\">\n            Please enter at most 16 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"validUsername\">\n            Username must be alphanumeric starting with a letter.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueUsername\">\n            This username already exists, please choose another.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n            Username must be different to password.\n          </div>\n        </div>\n        <div id=\"new-username-suggestion\"\n          class=\"ModalLoginSignup-signupUsernameInput-suggestions\"\n          ng-if=\"ArrowLoginUsernameInput.usernameSuggestions\">\n          <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">\n            Suggestions:\n          </span>\n          <span ng-repeat=\"name in ArrowLoginUsernameInput.usernameSuggestions\">\n            <a ng-click=\"ArrowLoginUsernameInput.updateUsername(name)\">\n              {{name}}\n            </a>\n            <span class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\"\n              ng-show=\"!$last\">\n              /\n            </span>\n          </span>\n        </div>\n      </div>\n      <button class=\"btn btn-black btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n        ng-disabled=\"ArrowLoginUsernameInput.isSubmitting\"\n        ng-click=\"ArrowLoginUsernameInput.login($event)\"\n        fl-analytics=\"NormalSignupUsername\">\n        Next\n        <span class=\"Loader Loader--small\"\n          ng-if=\"ArrowLoginUsernameInput.isSubmitting\">\n        </span>\n      </button>\n    </form>\n  </div>\n";

var flArrowLoginUsernameInput = function () {
  function flArrowLoginUsernameInput($http, $timeout, Users, UserData, UsersService) {
    var _this = this;

    _classCallCheck(this, flArrowLoginUsernameInput);

    this.$http = $http;
    this.$timeout = $timeout;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.isSubmitting = false;
    this.loginSuccess = false;
    this.showErrorMessage = false;

    this.generateSuggestedUsernames();

    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flArrowLoginUsernameInput, [{
    key: 'login',
    value: function login($event) {
      var _this2 = this;

      $event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/login-create.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username
        })
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.onLoginSuccess({ response: response });
        }
      }).catch(function (response) {
        _this2.showErrorMessage = true;
        _this2.isSubmitting = false;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error;
      });
    }
  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this3 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this3.usernameSuggestions = [];
        _this3.usernameSuggestions.push(result.recommended_name);
        _this3.usernameSuggestions = _this3.usernameSuggestions.concat(result.alternate_names);
      });
    }
  }, {
    key: 'updateUsername',
    value: function updateUsername(name) {
      this.form.username.$setDirty();
      this.UserData.user.username = name;
    }
  }]);

  return flArrowLoginUsernameInput;
}();

flArrowLoginUsernameInput.$inject = ['$http', '$timeout', 'Users', 'UserData', 'UsersService'];

var flArrowLoginUsernameInput$1 = flComponent$1(flArrowLoginUsernameInput, {
  selector: 'fl-arrow-login-username-input',
  template: arrowLoginUsernameInputTemplate,
  providers: [flFocusOnProvider, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck, UserData$1, UsersProvider, UsersProvider$1],
  bindings: {
    rememberLogin: '=',
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    showStep: '&'
  }
});

var arrowResetPasswordFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowResetPasswordForm.showStep({step: ArrowResetPasswordForm.steps.LOGIN_FORM})\">\n      <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n        name=\"ui-chevron-left\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-if=\"ArrowResetPasswordForm.showAsModal\"\n      ng-click=\"ArrowResetPasswordForm.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body\">\n  <h4 class=\"ModalLoginSignup-body-heading ModalLoginSignup-body-title--center\">\n    Reset your password\n  </h4>\n  <p class=\"alert alert-info\"\n    ng-class=\"{'is-hidden': !ArrowResetPasswordForm.showSuccessMessage}\">\n    Email sent. If the email address you entered is registered at Arrow.com, you'll receive an email with instructions on how to set a new password.\n  </p>\n  <form name=\"ArrowResetPasswordForm.form\" class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <fieldset>\n      <ol>\n        <li class=\"form-step recover-email-step\"\n          ng-class=\"{'is-invalid': ArrowResetPasswordForm.form.email.$invalid && ArrowResetPasswordForm.form.email.$dirty,\n          'is-valid': ArrowResetPasswordForm.form.email.$valid}\">\n          <label class=\"is-accessibly-hidden\"\n            for=\"forgotten-email\">\n            Email Address\n          </label>\n          <p class=\"ModalLoginSignup-body-subtitle\">\n            Enter your email address\n          </p>\n          <input id=\"forgotten-email\"\n            class=\"large-input\"\n            name=\"email\"\n            maxlength=\"100\"\n            type=\"text\"\n            placeholder=\"Email address\"\n            ng-model=\"ArrowResetPasswordForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-focus-on=\"ArrowResetPasswordForm.focusEmailInput\"\n          />\n          <div ng-messages=\"ArrowResetPasswordForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n                Please enter your email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n                Please enter a valid email address.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step\">\n          <button class=\"btn btn-black btn-large btn-primary btn-submit ModalLoginSignup-resetPassword-submitBtn\"\n            ng-disabled=\"ArrowResetPasswordForm.isSubmitting\"\n            ng-click=\"ArrowResetPasswordForm.resetPassword($event)\"\n            type=\"submit\">\n            Reset Password\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n  <span class=\"login-form-signup-link\">\n    Don't have an account?\n    <a ng-click=\"ArrowResetPasswordForm.showSignupForm({event: $event})\">\n      Sign Up\n    </a>\n  </span>\n</div>\n";

var flArrowResetPasswordForm = function () {
  function flArrowResetPasswordForm($http, $timeout, UserData, UsersService) {
    var _this = this;

    _classCallCheck(this, flArrowResetPasswordForm);

    this.$http = $http;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.form = {};
    this.isSubmitting = false;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.errorMessage = '';

    // Focus on the email input after timeout
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flArrowResetPasswordForm, [{
    key: 'resetPassword',
    value: function resetPassword($event) {
      var _this2 = this;

      $event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty for each form input type with any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/reset-password.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email
        })
      }).then(function () {
        _this2.showSuccessMessage = true;
      });
    }
  }]);

  return flArrowResetPasswordForm;
}();

flArrowResetPasswordForm.$inject = ['$http', '$timeout', 'UserData', 'UsersService'];

var flArrowResetPasswordForm$1 = flComponent$1(flArrowResetPasswordForm, {
  selector: 'fl-arrow-reset-password-form',
  template: arrowResetPasswordFormTemplate,
  providers: [flEmailUsernameValidCheck$1, flFocusOnProvider, UserData$1, UsersProvider$1],
  bindings: {
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    showStep: '&',
    showSignupForm: '&'
  }
});

var arrowLoginTemplate = "<fl-arrow-login-form\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.LOGIN_FORM\"\n  remember-login=\"ArrowLogin.rememberLogin\"\n  steps=\"ArrowLogin.steps\"\n  show-step=\"ArrowLogin.showStep(step)\"\n  show-signup-form=\"ArrowLogin.showSignupForm(event)\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n  on-login-success=\"ArrowLogin.onLoginSuccess(response, forceRedirectUrl)\"\n></fl-arrow-login-form>\n<fl-arrow-reset-password-form\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.RESET_PASSWORD\"\n  steps=\"ArrowLogin.steps\"\n  show-step=\"ArrowLogin.showStep(step)\"\n  show-signup-form=\"ArrowLogin.showSignupForm(event)\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n></fl-arrow-reset-password-form>\n<fl-arrow-login-username-input\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.USERNAME_INPUT\"\n  remember-login=\"ArrowLogin.rememberLogin\"\n  steps=\"ArrowLogin.steps\"\n  show-step=\"ArrowLogin.showStep(step)\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n  on-login-success=\"ArrowLogin.onLoginSuccess(response, forceRedirectUrl)\"\n  ></fl-arrow-login-username-input>\n<fl-arrow-login-success\n  ng-if=\"ArrowLogin.currentStep === ArrowLogin.steps.LOGIN_SUCCESS\"\n  show-as-modal=\"ArrowLogin.showAsModal\"\n  close-modal=\"ArrowLogin.closeModal()\"\n></fl-arrow-login-success>\n";

var flArrowLogin = function () {
  function flArrowLogin($http, $window, Auth, LoginSignupConfig, UsersService) {
    _classCallCheck(this, flArrowLogin);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.loginSignupConfig = LoginSignupConfig;
    this.UsersService = UsersService;
    this.steps = {
      LOGIN_FORM: 1,
      RESET_PASSWORD: 2,
      USERNAME_INPUT: 3,
      LOGIN_SUCCESS: 4
    };
    this.showStep(this.steps.LOGIN_FORM);
    this.rememberLogin = false;

    this.urlParams = new Map(window.location.search.slice(1).split('&').map(function (kv) {
      return kv.split('=');
    }));
  }

  _createClass(flArrowLogin, [{
    key: 'onLoginSuccessRedirect',
    value: function onLoginSuccessRedirect(forceRedirectUrl) {
      var _this = this;

      if (forceRedirectUrl) {
        this.$window.location.href = forceRedirectUrl;
        return;
      }

      this.UsersService.getLoginRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;
          if (redirectUrl === 'reload') {
            _this.$window.location.reload();
          } else if (redirectUrl !== '') {
            _this.$window.location.href = redirectUrl;
          } else {
            _this.$window.location.href = '/dashboard/';
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard/';
      });
    }
  }, {
    key: 'onLoginSuccess',
    value: function onLoginSuccess(response, forceRedirectUrl) {
      var _this2 = this;

      this.showStep(this.steps.LOGIN_SUCCESS);

      return new Promise(function (resolve) {
        _this2.setCookiesOnLogin(response);
        resolve();
      }).then(function () {
        return _this2.UsersService.crossDomainSSO({
          data: {
            token: _this2.Auth.getAccessToken(),
            user: _this2.Auth.getUserId()
          }
        }, _this2.rememberLogin);
      }).then(function () {
        return new Promise(function (resolve) {
          _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
          resolve();
        });
      }).then(function () {
        return new Promise(function (resolve) {
          var postProjectObject = JSON.parse(window.localStorage.getItem('postProjectObject'));
          var draftProject = JSON.parse(window.localStorage.getItem('arrowPostProjectDraft'));

          var postProjectOnLogin = _this2.urlParams.get('postProjectOnLogin') === 'true';

          if (postProjectOnLogin && postProjectObject && postProjectObject['logged-out']) {
            // Post a project
            _this2.postProject(postProjectObject['logged-out'].item).then(function (response) {
              var project = response.data.result;

              // Clear draft of the just posted project if it is in localStorage
              if (draftProject) {
                delete draftProject['logged-out'];
                window.localStorage.setItem('arrowPostProjectDraft', JSON.stringify(draftProject));
              }

              // Clear localStorage entry of object that was just posted
              delete postProjectObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(postProjectObject));
              // Redirect to PVP
              _this2.$window.location.href = '/projects/' + project.id;
              resolve();
            }).catch(function (response) {
              // TODO: Redirect to PJP, populate with draft data, and then show
              // error message. If funds are required for upgrades, do something else

              // Clear localStorage entry of project so it doesn't randomly get posted later
              delete postProjectObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(postProjectObject));

              // If posting the project failed and the user requires payment verification
              // send them to be payment verified, and also move the draft project in
              // localstorage from logged-out to their user id.
              if (response.data && response.data.status === 'error' && response.data.error_code === 'ProjectExceptionCodes.UNVERIFIED_PAYMENT') {
                if (draftProject && draftProject['logged-out']) {
                  draftProject['id-' + _this2.Auth.getUserId()] = draftProject['logged-out'];
                  delete draftProject['logged-out'];
                  window.localStorage.setItem('arrowPostProjectDraft', JSON.stringify(draftProject));
                }
                _this2.$window.location.href = '/post-project';
                return;
              }

              _this2.$window.location.href = '/dashboard';
            });
          } else {
            resolve();
          }
        });
      }).then(function () {
        _this2.onLoginSuccessRedirect(forceRedirectUrl);
      });
    }
  }, {
    key: 'postProject',
    value: function postProject(project) {
      var _this3 = this;

      var projectData = {
        title: project.title,
        description: project.description,
        currency: { id: project.currency.id },
        budget: {
          minimum: project.budget.minimum,
          maximum: project.budget.maximum,
          currency_id: project.currency.id,
          project_type: project.type
        },
        jobs: project.jobs,
        type: project.type,
        hourly_project_info: project.type === 'hourly' ? project.hourlyProjectInfo : undefined,
        hireme: project.hireme,
        location: project.local ? project.location : undefined,
        upgrades: _extends({}, project.upgrades, {
          recruiter: project.upgrades.assisted,
          project_management: project.upgrades.projectManagement,
          ip_contract: project.upgrades.ipContract
        }),
        nda_details: {
          hidden_description: project.ndaDetails.hiddenDescription
        },
        files: project.files
      };

      return new Promise(function (resolve, reject) {
        _this3.$http({
          method: 'POST',
          url: '/api/projects/0.1/projects/',
          data: projectData,
          headers: {
            'Content-type': 'application/json'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'setCookiesOnLogin',
    value: function setCookiesOnLogin(response) {
      this.Auth.set(response.data.token, response.data.user, this.rememberLogin);
      this.UsersService.setExtraCookies();
      // TODO: Set any other AFLN specific cookies (ARROW_FED_AUTH_TOKEN)
      this.setExternalCookies(response);
    }
  }, {
    key: 'setExternalCookies',
    value: function setExternalCookies(response) {
      Object.values(response.data.external_cookies).forEach(function (cookie) {
        var expireDate = new Date(cookie.expiry * 1000);
        var expireMinutes = (expireDate - new Date()) / 1000 / 60;
        setCookieToBrowser(cookie.name, cookie.value, 0, '/', cookieDomain, expireMinutes);
      });
    }
  }, {
    key: 'showStep',
    value: function showStep(step) {
      this.currentStep = step;
    }
  }, {
    key: 'showSignupForm',
    value: function showSignupForm($event) {
      $event.preventDefault();
      this.loginSignupConfig.switchToSignup();
    }
  }]);

  return flArrowLogin;
}();

flArrowLogin.$inject = ['$http', '$window', 'Auth', 'LoginSignupConfig', 'UsersService'];

var flArrowLogin$1 = flComponent$1(flArrowLogin, {
  selector: 'fl-arrow-login',
  template: arrowLoginTemplate,
  providers: [flArrowLoginForm$1, flArrowLoginSuccess$1, flArrowLoginUsernameInput$1, flArrowResetPasswordForm$1, AuthModule, LoginSignupConfigProvider, UsersProvider$1],
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

var USER_TYPE_EMPLOYER = 'employer';
var USER_TYPE_FREELANCER = 'freelancer';
var SIGNUP_STEPS = {
  BASE_STEP: 1,
  USERNAME_STEP: 2,
  ACCOUNT_TYPE_STEP: 3,
  PRIVACY_CONSENT_STEP: 4,
  CAPTCHA_STEP: 5,
  SUCCESS_STEP: 10 };
var REFERRAL_SIGNUP_COOKIE_KEY = 'referral_signup';
var IS_FROM_EU_COOKIE_KEY = 'is_from_eu';
var PRIVACY_CONSENT_KEY = 'privacy_consent';
var BUSINESS_USER_KEY = 'business_user';
var PROJECT_COLLABORATION_INVITATION_KEY = 'project_collaboration_invitation';
var CONTEST_COLLABORATION_INVITATION_KEY = 'contest_collaboration_invitation';

var arrowAccountTypeTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowAccountType.showStep({step: ArrowAccountType.steps.USERNAME_INPUT})\">\n      <fl-icon name=\"ui-chevron-left\"\n        class=\"ModalLoginSignup-header-previousStep-icon\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-click=\"ArrowAccountType.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"ArrowAccountType.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\"\n      class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <h2 class=\"ModalLoginSignup-body-title\">\n    Select account type\n  </h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">\n    Don’t worry, this can be changed later.\n  </p>\n  <aside ng-class=\"{'is-hidden': !ArrowAccountType.showErrorMessage}\"\n    class=\"alert alert-error\">\n    <span ng-if=\"ArrowAccountType.errorCode === 'EXTERNAL_AW_LINK_EXISTING_FLN'\">\n      Sorry we were unable to create your account, there was a Freelancer account under the same email address. Please contact <a href=\"/support\">support</a>.\n    </span>\n    <span ng-if=\"ArrowAccountType.errorCode === 'EXTERNAL_AW_USER_EXISTS'\">\n      An account with this email already exists on Arrow.com. Please login with your account details.\n    </span>\n    <span ng-if=\"ArrowAccountType.errorStatus === 429\">\n      You are performing too many requests. Please try again later.\n    </span>\n    <span ng-if=\"ArrowAccountType.errorStatus !== 429 &&\n      ArrowAccountType.errorCode !== 'EXTERNAL_AW_LINK_EXISTING_FLN' &&\n      ArrowAccountType.errorCode !== 'EXTERNAL_AW_USER_EXISTS'\">\n      There was a problem signing up. Please contact <a href=\"/support\">support</a> for assistance.\n    </span>\n  </aside>\n  <div class=\"form-feedback-success login-success alert alert-success\"\n    ng-if=\"ArrowAccountType.signupSuccess\">\n    Signup Success!\n    <div class=\"Loader Loader--small\"></div>\n  </div>\n  <div ng-click=\"ArrowAccountType.selectFreelancer()\"\n    class=\"Card ModalLoginSignup-signupAccountType-card\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{ArrowAccountType.workImageUrl}]}\" alt=\"Work Image\"/>\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to work\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!ArrowAccountType.isSubmitting || ArrowAccountType.selectedEmployer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"ArrowAccountType.isSubmitting && ArrowAccountType.selectedFreelancer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n  <div ng-click=\"ArrowAccountType.selectEmployer()\"\n    class=\"Card ModalLoginSignup-signupAccountType-card\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{ArrowAccountType.hireImageUrl}]}\" alt=\"Hire Image\"/>\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to hire\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!ArrowAccountType.isSubmitting || ArrowAccountType.selectedFreelancer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"ArrowAccountType.isSubmitting && ArrowAccountType.selectedEmployer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n</div>\n";

var flArrowAccountType = function () {
  function flArrowAccountType($http, Cdn, UserData, UsersService) {
    _classCallCheck(this, flArrowAccountType);

    this.$http = $http;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.hireImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-hire-black.svg');
    this.workImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-work-black.svg');

    this.signupSuccess = false;
    this.showErrorMessage = false;
    this.isSubmitting = false;

    // States
    this.selectedEmployer = false;
    this.selectedFreelancer = false;
  }

  _createClass(flArrowAccountType, [{
    key: 'selectEmployer',
    value: function selectEmployer() {
      this.UserData.user.role = 'Employer';
      this.selectedEmployer = true;
      this.selectedFreelancer = false;
      this.signup();
    }
  }, {
    key: 'selectFreelancer',
    value: function selectFreelancer() {
      this.UserData.user.role = 'Worker';
      this.selectedFreelancer = true;
      this.selectedEmployer = false;
      this.signup();
    }
  }, {
    key: 'signup',
    value: function signup() {
      var _this = this;

      // Check if user is from the EU. If they are, we show the consent form,
      // otherwise we attempt to sign up.
      if (this.UserData.user.isFromEU) {
        this.showStep({ step: this.steps.CONSENT_FORM });
        return;
      }

      // Attempt to signup
      if (this.signupSuccess || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/signup.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username,
          fullname: this.UserData.user.fullName,
          country: this.UserData.user.country,
          privacyConsent: this.UserData.user.privacyConsent,
          businessUser: !this.UserData.user.privateUser,
          userType: this.UserData.user.role
        })
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.token) {
          _this.signupSuccess = true;
          _this.onSignupSuccess({ response: response });
          return;
        }
        return Promise.reject(response);
      }).catch(function (response) {
        _this.showErrorMessage = true;
        _this.isSubmitting = false;
        _this.errorStatus = response.status;
        _this.errorCode = response.data.error;
      });
    }
  }]);

  return flArrowAccountType;
}();

flArrowAccountType.$inject = ['$http', 'Cdn', 'UserData', 'UsersService'];

var flArrowAccountType$1 = flComponent$1(flArrowAccountType, {
  selector: 'fl-arrow-account-type',
  template: arrowAccountTypeTemplate,
  bindings: {
    steps: '=',
    signupAgreements: '=',
    showAsModal: '=',
    closeModal: '&',
    showStep: '&',
    onSignupSuccess: '&'
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1]
});

var arrowConsentFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowConsentForm.goBack()\">\n      <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n        name=\"ui-chevron-left\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-if=\"ArrowConsentForm.showAsModal\"\n      ng-click=\"ArrowConsentForm.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-body--arrow\">\n  <form name=\"ArrowConsentForm.form\"\n    class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <aside ng-class=\"{'is-hidden': !ArrowConsentForm.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span >\n        There was a problem signing up. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowConsentForm.signupSuccess\">\n      Signup Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n    <ol>\n      <li class=\"form-step has-label login-form-options\">\n        <h4 class=\"ModalLoginSignup-body-subheading\">\n          Email Opt-In\n        </h4>\n        <p class=\"ModalLoginSignup-body-tag\">\n          Would you like to receive marketing promotions, special offers,\n          inspirations, and updates to Freelancer’s product and policies? You can unsubscribe at any time.\n        </p>\n        <div class=\"Checkbox\">\n          <input id=\"email\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"\"\n            ng-model=\"ArrowConsentForm.UserData.user.privacyConsent\"\n          />\n          <label class=\"ModalLoginSignup-body-label Checkbox-label checkbox\"\n            for=\"email\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              Yes, I want to receive emails.\n            </small>\n          </label>\n        </div>\n      </li>\n      <li class=\"form-step has-label login-form-options\">\n        <h4 class=\"ModalLoginSignup-body-subheading\">\n          Account Type\n        </h4>\n        <p class=\"ModalLoginSignup-body-tag\">\n          Do you intend to use Freelancer for personal use? Using\n          Freelancer for cases other than business may be subject to additional VAT.\n        </p>\n        <div class=\"Checkbox\">\n          <input id=\"account\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"\"\n            ng-model=\"ArrowConsentForm.UserData.user.privateUser\"\n          />\n          <label class=\"Checkbox-label checkbox\"\n            for=\"account\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              Yes, I am using Freelancer for personal use.\n            </small>\n          </label>\n        </div>\n      </li>\n      <li class=\"form-step\">\n        <button id=\"signup_btn\"\n          class=\"btn btn-black btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n          type=\"submit\"\n          ng-click=\"ArrowConsentForm.signup($event)\">\n          Sign up\n        </button>\n      </li>\n    </ol>\n  </form>\n</div>\n";

var flArrowConsentForm = function () {
  function flArrowConsentForm($http, UserData, UsersService) {
    _classCallCheck(this, flArrowConsentForm);

    this.$http = $http;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.isSubmitting = false;
    this.signupSuccess = false;
    this.showErrorMessage = false;
  }

  _createClass(flArrowConsentForm, [{
    key: 'signup',
    value: function signup($event) {
      var _this = this;

      $event.preventDefault();

      // Attempt to signup
      if (this.signupSuccess || this.isSubmitting) {
        return;
      }

      this.showErrorMessage = false;
      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/signup.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username,
          fullname: this.UserData.user.fullName,
          country: this.UserData.user.country,
          privacyConsent: this.UserData.user.privacyConsent,
          businessUser: !this.UserData.user.privateUser,
          userType: this.UserData.user.role
        })
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.token) {
          _this.signupSuccess = true;
          _this.onSignupSuccess({ response: response });
          return;
        }
        return Promise.reject(response);
      }).catch(function () {
        _this.showErrorMessage = true;
        _this.isSubmitting = false;
      });
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      if (this.postProjectOnLogin) {
        // Account type select was skipped, so go to username input
        this.showStep(this.steps.USERNAME_INPUT);
      } else {
        this.showStep(this.steps.ACCOUNT_TYPE);
      }
    }
  }]);

  return flArrowConsentForm;
}();

flArrowConsentForm.$inject = ['$http', 'UserData', 'UsersService'];

var flArrowConsentForm$1 = flComponent$1(flArrowConsentForm, {
  selector: 'fl-arrow-consent-form',
  template: arrowConsentFormTemplate,
  providers: [UserData$1, UsersProvider$1],
  bindings: {
    steps: '=',
    signupAgreements: '=',
    showAsModal: '=',
    postProjectOnLogin: '=',
    closeModal: '&',
    showStep: '&',
    onSignupSuccess: '&'
  }
});

var arrowSignupFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\"\n    ng-if=\"ArrowSignupForm.showAsModal\"\n    ng-click=\"ArrowSignupForm.closeModal()\"\n    type=\"button\"\n    data-modal-hide aria-label=\"Close this modal window\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n  </div>\n</div>\n\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-body--arrow\"\n  fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span>\n      Sign Up\n    </span>\n  </div>\n\n  <form id=\"signup_form\"\n    class=\"user-signup-form fl-form responsive-form\"\n    name=\"ArrowSignupForm.form\">\n    <ol>\n      <li class=\"form-step name-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.fullName.$invalid && ArrowSignupForm.form.fullName.$dirty,\n                    'is-valid': ArrowSignupForm.form.fullName.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"fullName\">\n          Full Name\n        </label>\n        <input id=\"name\"\n          type=\"text\"\n          name=\"fullName\"\n          rel=\"popover\"\n          placeholder=\"Full Name\"\n          class=\"large-input\"\n          fl-focus-on=\"ArrowSignupForm.focusFullNameInput\"\n          ng-model=\"ArrowSignupForm.UserData.user.fullName\"\n          ng-required=\"true\"\n        />\n        <div ng-messages=\"ArrowSignupForm.form.fullName.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please provide your full name.\n          </div>\n        </div>\n      </li>\n\n      <li class=\"form-step email-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.email.$invalid && ArrowSignupForm.form.email.$dirty,\n                    'is-valid': ArrowSignupForm.form.email.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"new-email\">\n          Email Address\n        </label>\n        <input id=\"new-email\"\n          class=\"large-input\"\n          type=\"text\"\n          name=\"email\"\n          rel=\"popover\"\n          placeholder=\"Email\"\n          ng-model=\"ArrowSignupForm.UserData.user.email\"\n          ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n          ng-required=\"true\"\n          fl-email-username-valid-check=\"email\"\n          fl-blocked-email-check\n          fl-unique-email-username-check\n          fl-unique-arrow-email-check\n        />\n        <div class=\"Loader Loader--small ModalLoginSignup-inputLoader\"\n          ng-if=\"ArrowSignupForm.form.email.$pending\">\n        </div>\n        <div ng-messages=\"ArrowSignupForm.form.email.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please enter an email address.\n          </div>\n          <div class=\"form-error\" ng-message=\"validEmail\">\n            Please enter a valid email address.\n          </div>\n          <div class=\"form-error\" ng-message=\"unblockedEmail\">\n            This email domain is blocked. Please use a different email address.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueEmail\">\n            This email address is already in use on the Freelancer platform.\n          </div>\n          <div class=\"form-error\" ng-message=\"uniqueArrowEmail\">\n            This email address is already in use on Arrow.com.\n          </div>\n        </div>\n      </li>\n\n      <li class=\"form-step password-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.password.$invalid && ArrowSignupForm.form.password.$dirty,\n                    'is-valid': ArrowSignupForm.form.password.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"new-password\">\n          Password\n        </label>\n        <input id=\"new-password\"\n          class=\"large-input\"\n          type=\"password\"\n          name=\"password\"\n          placeholder=\"Password\"\n          ng-model=\"ArrowSignupForm.UserData.user.password\"\n          ng-required=\"true\"\n          ng-minlength=\"8\"\n          ng-maxlength=\"25\"\n          fl-arrow-password-check\n        />\n        <div ng-if=\"ArrowSignupForm.form.password.$pending\"\n          class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n        </div>\n        <div ng-messages=\"ArrowSignupForm.form.password.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please enter a password.\n          </div>\n          <div class=\"form-error\" ng-message=\"minlength\">\n            Password must be at least 8 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"maxlength\">\n            Password must be at most 25 characters.\n          </div>\n          <div class=\"form-error\" ng-message=\"strongArrowPassword\">\n            Password must contain a lowercase letter, an uppercase letter, and a number.\n          </div>\n          <div class=\"form-error\" ng-message=\"arrowPasswordAllowedCharacters\">\n            Password can only contain capital and lowercase letters, numbers, and the following special characters !@#$%^*()-_=+[]|;:,.&lt;&gt;/?.\n          </div>\n        </div>\n      </li>\n\n      <li class=\"form-step country-step\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.country.$invalid && ArrowSignupForm.form.country.$dirty,\n                    'is-valid': ArrowSignupForm.form.country.$valid}\">\n        <label class=\"is-accessibly-hidden\"\n          for=\"country\">\n          Country\n        </label>\n        <select id=\"country\"\n          class=\"large-input\"\n          name=\"country\"\n          ng-options=\"country.code as country.name for country in ArrowSignupForm.countryOptions\"\n          ng-model=\"ArrowSignupForm.UserData.user.country\"\n          ng-required=\"true\"\n        >\n          <option value=\"\" selected disabled>Select a country</option>\n        </select>\n        <div ng-messages=\"ArrowSignupForm.form.country.$error\" tabindex=\"-1\">\n          <div class=\"form-error\" ng-message=\"required\">\n            Please select a country.\n          </div>\n        </div>\n      </li>\n\n      <input id=\"signup_skip_captcha\"\n        type=\"hidden\"\n        name=\"signup_skip_captcha\"\n        value=\"{{ArrowSignupForm.loginSignupConfig.getSkipCaptchaHash()}}\"\n      />\n\n      <li class=\"form-step has-label login-form-options\"\n        ng-class=\"{'is-invalid': ArrowSignupForm.form.termsAgreement.$invalid && ArrowSignupForm.form.termsAgreement.$dirty}\">\n        <div class=\"Checkbox\">\n          <input id=\"termsAgreement\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"termsAgreement\"\n            ng-required=\"true\"\n            ng-model=\"ArrowSignupForm.signupAgreements.terms\"\n          />\n          <label class=\"ModalLoginSignup-body-label Checkbox-label checkbox\"\n            for=\"termsAgreement\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              By creating an account you agree to the use of your personal information in accordance with Arrow Electronics and Freelancer.com,\n              through the platform's\n              <a href='javascript: void()'\n                onclick='window.open(\n                \"/about/privacy?popup=true\",\"\",\"width=700, height=550, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n                );return false;'>\n                Privacy Policy\n              </a>\n              and\n              <a href='#' onclick='window.open(\n                \"/info/plainterms.html\",\"\",\"width=500, height=450, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n                );return false;'>\n                Terms of Use.\n              </a>\n            </small>\n          </label>\n        </div>\n      </li>\n\n      <li class=\"form-step has-label login-form-options\">\n        <div class=\"Checkbox\">\n          <input id=\"promotionalAgreement\"\n            class=\"Checkbox-input\"\n            type=\"checkbox\"\n            name=\"promotionalAgreement\"\n            ng-model=\"ArrowSignupForm.signupAgreements.arrowMarketing\"\n          />\n          <label class=\"Checkbox-label checkbox\"\n            for=\"promotionalAgreement\">\n            <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n              I would like to receive promotional email communication from Arrow.\n            </small>\n          </label>\n        </div>\n      </li>\n\n      <li class=\"form-step\">\n        <button id=\"signup_btn\"\n          type=\"submit\"\n          class=\"btn btn-black btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n          ng-click=\"ArrowSignupForm.signup($event)\"\n          fl-analytics=\"NormalSignupEmailPassword\">\n            Sign up with Arrow\n        </button>\n      </li>\n    </ol>\n  </form>\n</div>\n";

var flArrowSignupForm = function () {
  function flArrowSignupForm($timeout, UserData) {
    var _this = this;

    _classCallCheck(this, flArrowSignupForm);

    this.$timeout = $timeout;
    this.UserData = UserData;
    this.form = {};

    // Focus on the full name input after timeout
    this.$timeout(function () {
      _this.focusFullNameInput = true;
    }, 50);
  }

  _createClass(flArrowSignupForm, [{
    key: 'signup',
    value: function signup($event) {
      $event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.showStep({ step: this.steps.USERNAME_INPUT });
    }
  }]);

  return flArrowSignupForm;
}();

flArrowSignupForm.$inject = ['$timeout', 'UserData'];

var flArrowSignupForm$1 = flComponent$1(flArrowSignupForm, {
  selector: 'fl-arrow-signup-form',
  template: arrowSignupFormTemplate,
  providers: [flFocusOnProvider, flArrowPasswordCheck, flBlockedEmailCheck, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck, flUniqueArrowEmailCheck, UserData$1],
  bindings: {
    countryOptions: '=',
    signupAgreements: '=',
    steps: '=',
    showAsModal: '=',
    closeModal: '&',
    showStep: '&'
  }
});

var arrowSignupUsernameInputTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div class=\"ModalLoginSignup-header-previousStep\"\n      ng-click=\"ArrowSignupUsernameInput.showStep({step: ArrowSignupUsernameInput.steps.SIGNUP_FORM})\">\n      <fl-icon class=\"ModalLoginSignup-header-previousStep-icon\"\n        name=\"ui-chevron-left\">\n      </fl-icon>\n    </div>\n    <button class=\"Modal-close\"\n      ng-if=\"ArrowSignupUsernameInput.showAsModal\"\n      ng-click=\"ArrowSignupUsernameInput.closeModal()\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body\"\n  fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title ModalLoginSignup-body-title--center\">\n    Choose a username\n  </h2>\n    <aside ng-class=\"{'is-hidden': !ArrowSignupUsernameInput.showErrorMessage}\"\n      class=\"alert alert-error\">\n      <span ng-if=\"ArrowSignupUsernameInput.errorCode === 'EXTERNAL_AW_LINK_EXISTING_FLN'\">\n        Sorry we were unable to create your account, there was a Freelancer account under the same email address. Please contact <a href=\"/support\">support</a>.\n      </span>\n      <span ng-if=\"ArrowSignupUsernameInput.errorCode === 'EXTERNAL_AW_USER_EXISTS'\">\n        An account with this email already exists on Arrow.com. Please login with your account details.\n      </span>\n      <span ng-if=\"ArrowSignupUsernameInput.errorStatus === 429\">\n        You are performing too many requests. Please try again later.\n      </span>\n      <span ng-if=\"ArrowSignupUsernameInput.errorStatus !== 429 &&\n        ArrowSignupUsernameInput.errorCode !== 'EXTERNAL_AW_LINK_EXISTING_FLN' &&\n        ArrowSignupUsernameInput.errorCode !== 'EXTERNAL_AW_USER_EXISTS'\">\n        There was a problem signing up. Please contact <a href=\"/support\">support</a> for assistance.\n      </span>\n    </aside>\n    <div class=\"form-feedback-success login-success alert alert-success\"\n      ng-if=\"ArrowSignupUsernameInput.signupSuccess\">\n      Signup Success!\n      <div class=\"Loader Loader--small\"></div>\n    </div>\n  <p class=\"ModalLoginSignup-body-subtitle\">\n    Please note that a username cannot be changed, once chosen.\n  </p>\n  <form class=\"user-signup-form fl-form responsive-form\"\n    name=\"ArrowSignupUsernameInput.form\">\n    <div class=\"form-step email-step\"\n      ng-class=\"{'is-invalid': ArrowSignupUsernameInput.form.username.$invalid && ArrowSignupUsernameInput.form.username.$dirty,\n                  'is-valid': ArrowSignupUsernameInput.form.username.$valid}\">\n      <label class=\"is-accessibly-hidden\"\n        for=\"new-username\">\n        Username\n      </label>\n      <input id=\"new-username\"\n        class=\"large-input\"\n        type=\"text\"\n        name=\"username\"\n        rel=\"popover\"\n        placeholder=\"Username\"\n        ng-model=\"ArrowSignupUsernameInput.UserData.user.username\"\n        ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n        ng-required=\"true\"\n        ng-minlength=\"3\"\n        ng-maxlength=\"16\"\n        fl-email-username-valid-check=\"username\"\n        fl-unique-email-username-check=\"username\"\n        fl-focus-on=\"ArrowSignupUsernameInput.focusUsernameInput\">\n      <div class=\"Loader Loader--small ModalLoginSignup-inputLoader\"\n        ng-if=\"ArrowSignupUsernameInput.form.username.$pending\">\n      </div>\n      <div ng-messages=\"ArrowSignupUsernameInput.form.username.$error\" tabindex=\"-1\">\n        <div class=\"form-error\" ng-message=\"required\">\n          Please enter a username.\n        </div>\n        <div class=\"form-error\" ng-message=\"minlength\">\n          Please enter at least 3 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"maxlength\">\n          Please enter at most 16 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"validUsername\">\n          Username must be alphanumeric starting with a letter.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueUsername\">\n          This username already exists, please choose another.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n          Username must be different to password.\n        </div>\n      </div>\n      <div id=\"new-username-suggestion\"\n        class=\"ModalLoginSignup-signupUsernameInput-suggestions\"\n        ng-if=\"ArrowSignupUsernameInput.usernameSuggestions\">\n        <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">\n          Suggestions:\n        </span>\n        <span ng-repeat=\"name in ArrowSignupUsernameInput.usernameSuggestions\">\n          <a ng-click=\"ArrowSignupUsernameInput.updateUsername(name)\">\n            {{name}}\n          </a>\n          <span class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\"\n            ng-show=\"!$last\">\n            /\n          </span>\n        </span>\n      </div>\n    </div>\n    <button class=\"btn btn-black btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n      ng-disabled=\"ArrowSignupUsernameInput.isSubmitting\"\n      ng-click=\"ArrowSignupUsernameInput.signup($event)\"\n      fl-analytics=\"NormalSignupUsername\">\n      Next\n      <span class=\"Loader Loader--small\"\n        ng-if=\"ArrowSignupUsernameInput.isSubmitting\">\n      </span>\n    </button>\n  </form>\n</div>\n";

var flArrowSignupUsernameInput = function () {
  function flArrowSignupUsernameInput($http, $timeout, Users, UserData, UsersService) {
    var _this = this;

    _classCallCheck(this, flArrowSignupUsernameInput);

    this.$http = $http;
    this.$timeout = $timeout;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;

    this.isSubmitting = false;
    this.signupSuccess = false;
    this.showErrorMessage = false;

    this.generateSuggestedUsernames();

    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flArrowSignupUsernameInput, [{
    key: 'signup',
    value: function signup($event) {
      var _this2 = this;

      $event.preventDefault();

      if (!this.form.$valid || this.signupSuccess || this.isSubmitting) {
        return;
      }

      // If posting a project, skip account type step and set to 'Employer'
      if (this.postProjectOnLogin) {
        this.UserData.user.role = 'Employer';
      } else {
        this.showStep({ step: this.steps.ACCOUNT_TYPE });
        return;
      }

      // Check if user is from the EU. If they are, we show the consent form,
      // otherwise we attempt to sign up.
      if (this.UserData.user.isFromEU) {
        this.showStep({ step: this.steps.CONSENT_FORM });
        return;
      }

      this.isSubmitting = true;

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/arrow/signup.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.UsersService.serializeData({
          email: this.UserData.user.email,
          password: this.UserData.user.password,
          username: this.UserData.user.username,
          fullname: this.UserData.user.fullName,
          country: this.UserData.user.country,
          privacyConsent: this.UserData.user.privacyConsent,
          businessUser: !this.UserData.user.privateUser,
          userType: this.UserData.user.role
        })
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.token) {
          _this2.signupSuccess = true;
          _this2.onSignupSuccess({ response: response });
          return;
        }
        return Promise.reject(response);
      }).catch(function (response) {
        _this2.showErrorMessage = true;
        _this2.isSubmitting = false;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error;
      });
    }
  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this3 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this3.usernameSuggestions = [];
        _this3.usernameSuggestions.push(result.recommended_name);
        _this3.usernameSuggestions = _this3.usernameSuggestions.concat(result.alternate_names);
      });
    }
  }, {
    key: 'updateUsername',
    value: function updateUsername(name) {
      this.form.username.$setDirty();
      this.UserData.user.username = name;
    }
  }]);

  return flArrowSignupUsernameInput;
}();

flArrowSignupUsernameInput.$inject = ['$http', '$timeout', 'Users', 'UserData', 'UsersService'];

var flArrowSignupUsernameInput$1 = flComponent$1(flArrowSignupUsernameInput, {
  selector: 'fl-arrow-signup-username-input',
  template: arrowSignupUsernameInputTemplate,
  provider: [flFocusOnProvider, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck, UserData$1, UsersProvider, UsersProvider$1],
  bindings: {
    steps: '=',
    signupAgreements: '=',
    showAsModal: '=',
    postProjectOnLogin: '=',
    closeModal: '&',
    showStep: '&',
    onSignupSuccess: '&'
  }
});

var arrowSignupSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\"\n      ng-click=\"ArrowSignupSuccess.closeModal($event)\"\n      type=\"button\"\n      data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"ArrowSignupSuccess.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-arrow-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n\n<div class=\"Modal-body\"\n  fl-analytics-section=\"ArrowLogin\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Signup Success!</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flArrowSignupSuccess = function flArrowSignupSuccess() {
  _classCallCheck(this, flArrowSignupSuccess);
};

var flArrowSignupSuccess$1 = flComponent$1(flArrowSignupSuccess, {
  selector: 'fl-arrow-signup-success',
  template: arrowSignupSuccessTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

var arrowSignupTemplate = "<fl-arrow-signup-form\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.SIGNUP_FORM\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  country-options=\"ArrowSignup.countryOptions\"\n></fl-arrow-signup-form>\n<fl-arrow-signup-username-input\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.USERNAME_INPUT\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  on-signup-success=\"ArrowSignup.onSignupSuccess(response)\"\n  post-project-on-login=\"ArrowSignup.postProjectOnLogin\"\n></fl-arrow-signup-username-input>\n<fl-arrow-account-type\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.ACCOUNT_TYPE\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  on-signup-success=\"ArrowSignup.onSignupSuccess(response)\"\n></fl-arrow-account-type>\n<fl-arrow-consent-form\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.CONSENT_FORM\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n  steps=\"ArrowSignup.steps\"\n  show-step=\"ArrowSignup.showStep(step)\"\n  signup-agreements=\"ArrowSignup.signupAgreements\"\n  on-signup-success=\"ArrowSignup.onSignupSuccess(response)\"\n  post-project-on-login=\"ArrowSignup.postProjectOnLogin\"\n></fl-arrow-consent-form>\n<fl-arrow-signup-success\n  ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.SIGNUP_SUCCESS\"\n  show-as-modal=\"ArrowSignup.showAsModal\"\n  close-modal=\"ArrowSignup.closeModal()\"\n></fl-arrow-signup-success>\n\n<div class=\"Modal-footer\">\n  <div ng-messages=\"ArrowSignup.error\">\n    <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n      There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n    </div>\n    <div ng-message=\"internalError\" class=\"alert alert-error\">\n      Something went wrong. Please try again.\n    </div>\n  </div>\n  <div class=\"ModalLoginSignup-switchLoginSignupType\"\n    ng-if=\"ArrowSignup.currentStep === ArrowSignup.steps.SIGNUP_FORM\">\n    Already have an account on Arrow.com?\n    <a class=\"ModalLoginSignup--switchToLogin-link\"\n      ng-click=\"ArrowSignup.showLoginForm()\">\n      Log In\n    </a>\n  </div>\n</div>\n";

var flArrowSignup = function () {
  function flArrowSignup($http, $window, Auth, CookieStore, LoginSignupConfig, UserData, UsersService) {
    _classCallCheck(this, flArrowSignup);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.CookieStore = CookieStore;
    this.loginSignupConfig = LoginSignupConfig;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.steps = {
      SIGNUP_FORM: 1,
      USERNAME_INPUT: 2,
      ACCOUNT_TYPE: 3,
      CONSENT_FORM: 4,
      SIGNUP_SUCCESS: 5
    };
    this.currentStep = this.steps.SIGNUP_FORM;

    this.signupAgreements = {
      terms: false,
      arrowMarketing: false
    };

    // Check if user is from the EU
    if (this.CookieStore.get(IS_FROM_EU_COOKIE_KEY) === 'true') {
      this.UserData.user.isFromEU = true;
      this.UserData.user.privacyConsent = false;
    } else {
      this.UserData.user.isFromEU = false;
      this.UserData.user.privacyConsent = true;
    }

    this.urlParams = new Map(window.location.search.slice(1).split('&').map(function (kv) {
      return kv.split('=');
    }));

    // Check if the user is posting a project on signup
    this.postProjectOnLoginObject = JSON.parse(window.localStorage.getItem('postProjectObject'));
    this.postProjectOnLogin = this.urlParams.get('postProjectOnLogin') === 'true' && this.postProjectOnLoginObject && this.postProjectOnLoginObject['logged-out'];

    this.getCountryOptions();
  }

  _createClass(flArrowSignup, [{
    key: 'onSignupSuccessRedirect',
    value: function onSignupSuccessRedirect() {
      var _this = this;

      this.UsersService.getSignupRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl(), this.loginSignupConfig.getProjectCollaborationInvitation(), this.loginSignupConfig.getContestCollaborationInvitation()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;

          if (redirectUrl === 'reload') {
            _this.$window.location.reload();
          } else if (redirectUrl !== '') {
            if (!redirectUrl.includes('?')) {
              redirectUrl = redirectUrl + '?';
            }

            _this.$window.location.href = redirectUrl + '&new_signup=true';
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard';
      });

      // Close the modal only if there is no redirects
      if (this.loginSignupConfig.isRedirectDisabled()) {
        this.closeModal();
      }
    }
  }, {
    key: 'onSignupSuccess',
    value: function onSignupSuccess(response) {
      var _this2 = this;

      this.showStep(this.steps.SIGNUP_SUCCESS);

      return new Promise(function (resolve) {
        _this2.setCookiesOnSignup(response);
        resolve();
      }).then(function () {
        return _this2.UsersService.crossDomainSSO({
          data: {
            token: _this2.Auth.getAccessToken(),
            user: _this2.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
          resolve();
        });
      }).then(function () {
        return new Promise(function (resolve) {
          if (_this2.postProjectOnLogin) {
            // Post a project
            _this2.postProject(_this2.postProjectOnLoginObject['logged-out'].item).then(function (response) {
              var project = response.data.result;

              // Clear draft of the just posted project if it is in localStorage
              var draftProject = JSON.parse(window.localStorage.getItem('arrowPostProjectDraft'));
              if (draftProject) {
                delete draftProject['logged-out'];
                window.localStorage.setItem('arrowPostProjectDraft', JSON.stringify(draftProject));
              }

              // Clear localStorage entry of object that was just posted
              delete _this2.postProjectOnLoginObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(_this2.postProjectOnLoginObject));
              // Redirect to PVP
              _this2.$window.location.href = '/projects/' + project.id;
              resolve();
            }).catch(function () {
              // TODO: Redirect to PJP, populate with draft data, and then show
              // error message. If funds are required for upgrades, do something else

              // Clear localStorage entry of project so it doesn't randomly get posted later
              delete _this2.postProjectOnLoginObject['logged-out'];
              window.localStorage.setItem('postProjectObject', JSON.stringify(_this2.postProjectOnLoginObject));
              _this2.$window.location.href = '/dashboard';
            });
          } else {
            resolve();
          }
        });
      }).then(function () {
        _this2.onSignupSuccessRedirect();
      });
    }
  }, {
    key: 'postProject',
    value: function postProject(project) {
      var _this3 = this;

      var projectData = {
        title: project.title,
        description: project.description,
        currency: { id: project.currency.id },
        budget: {
          minimum: project.budget.minimum,
          maximum: project.budget.maximum,
          currency_id: project.currency.id,
          project_type: project.type
        },
        jobs: project.jobs,
        type: project.type,
        hourly_project_info: project.type === 'hourly' ? project.hourlyProjectInfo : undefined,
        hireme: project.hireme,
        location: project.local ? project.location : undefined,
        upgrades: _extends({}, project.upgrades, {
          recruiter: project.upgrades.assisted,
          project_management: project.upgrades.projectManagement,
          ip_contract: project.upgrades.ipContract
        }),
        nda_details: {
          hidden_description: project.ndaDetails.hiddenDescription
        },
        files: project.files
      };

      return new Promise(function (resolve, reject) {
        _this3.$http({
          method: 'POST',
          url: '/api/projects/0.1/projects/',
          data: projectData,
          headers: {
            'Content-type': 'application/json'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    }
  }, {
    key: 'setCookiesOnSignup',
    value: function setCookiesOnSignup(response) {
      this.Auth.set(response.data.token, response.data.user, true);
      this.UsersService.setExtraCookies();
      // TODO: Set any other AFLN specific cookies (ARROW_FED_AUTH_TOKEN)
      this.setExternalCookies(response);
    }
  }, {
    key: 'setExternalCookies',
    value: function setExternalCookies(response) {
      Object.values(response.data.external_cookies).forEach(function (cookie) {
        var expireDate = new Date(cookie.expiry * 1000);
        var expireMinutes = (expireDate - new Date()) / 1000 / 60;
        setCookieToBrowser(cookie.name, cookie.value, 0, '/', cookieDomain, expireMinutes);
      });
    }

    // Get a list of countries to show on the dropdown in the signup form

  }, {
    key: 'getCountryOptions',
    value: function getCountryOptions() {
      var _this4 = this;

      this.$http.get('/ajax/user/getCountries.php').then(function (response) {
        var countryMap = response.data.data;
        _this4.countryOptions = Object.keys(countryMap).map(function (key) {
          return {
            name: key,
            code: countryMap[key]
          };
        });
      });
    }
  }, {
    key: 'showStep',
    value: function showStep(step) {
      this.currentStep = step;
    }
  }, {
    key: 'showLoginForm',
    value: function showLoginForm() {
      this.loginSignupConfig.switchToLogin();
    }
  }]);

  return flArrowSignup;
}();

flArrowSignup.$inject = ['$http', '$window', 'Auth', 'CookieStore', 'LoginSignupConfig', 'UserData', 'UsersService'];

var flArrowSignup$1 = flComponent$1(flArrowSignup, {
  selector: 'fl-arrow-signup',
  template: arrowSignupTemplate,
  providers: [flArrowAccountType$1, flArrowConsentForm$1, flArrowSignupForm$1, flArrowSignupUsernameInput$1, flArrowSignupSuccess$1, AuthModule, CookieStoreProvider$1, LoginSignupConfigProvider, UserData$1, UsersProvider$1],
  bindings: {
    showAsModal: '=',
    closeModal: '&'
  }
});

/**
* @ngdoc service
* @name flFacebook.FacebookSDK
*
* @description
* Angular wrapper around the Facebook API, providing access to all the
* Facebook JS SDK APIs within the Angular context & returning Promises instead
* of callbacks. This service is currently implemented using "ezfb". Please
* prefer the use of the higher level Facebook service over that one.
*/

var FacebookSDK = function FacebookSDK(ezfb) {
  _classCallCheck(this, FacebookSDK);

  return ezfb;
};

FacebookSDK.$inject = ['ezfb'];

var FacebookSDKModule = flService('FacebookSDK', ['ezfb', OPAQUE_MODULE_NAME], FacebookSDK);

angular$1.module(FacebookSDKModule).config(['ezfbProvider', 'FACEBOOK_APP_ID', function (ezfbProvider, FACEBOOK_APP_ID) {
  ezfbProvider.setInitParams({
    appId: FACEBOOK_APP_ID,
    xfbml: false,
    version: 'v3.2'
  });
}]);

var _templateObject$12 = _taggedTemplateLiteral(['\n        ', '://\n        ', '\n        ', '\n        ', '', ''], ['\n        ', '://\n        ', '\n        ', '\n        ', '', '']),
    _templateObject2$4 = _taggedTemplateLiteral(['\n        https://www.facebook.com/dialog/oauth?client_id=\n        ', '\n        &redirect_uri=', '\n        &scope=', ''], ['\n        https://www.facebook.com/dialog/oauth?client_id=\n        ', '\n        &redirect_uri=', '\n        &scope=', '']);

/**
  * @ngdoc service
  * @name flFacebook.Facebook
  *
  * @description
  * Provides high level Facebook functionality. Your controllers should prefer
  * using this service instead of Facebook SDK as it abstracts Facebook SDK's
  * internal complexity.
  */

var FacebookProvider = function () {
  function FacebookProvider($q, $window, $location, FacebookSDK, FACEBOOK_APP_ID) {
    _classCallCheck(this, FacebookProvider);

    this.$q = $q;
    this.$window = $window;
    this.$location = $location;
    this.FacebookSDK = FacebookSDK;
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
  }
  /**
  * @ngdoc method
  * @name flFacebook.Facebook#getLoginStatus
  * @methodOf flFacebook.Facebook
  *
  * @description
  * Check if the user is currently connected with Facebook.
  *
  * @returns {Object} a Promise object that will be resolved with an
  * AuthResponse object from the Facebook API. This object can then be
  * passed to the Auth Service's loginWithFacebook API to login the
  * user into Freelancer or the Users Service's createWithFacebook to
  * create a new user account. On failure, an error object with a "code"
  * key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' will be returned.
  */


  _createClass(FacebookProvider, [{
    key: 'checkConnected',
    value: function checkConnected() {
      var _this = this;

      return this.FacebookSDK.getLoginStatus().then(function (response) {
        // Ask user to login if they are not signed into facebook
        if (response.status === 'connected') {
          return _this.$q.when(response.authResponse);
        } else if (response.status === 'not_authorized') {
          return _this.$q.reject({ code: 'NOT_AUTHORISED' });
        }

        return _this.$q.reject({ code: 'NOT_CONNECTED' });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#login
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Prompt the user, if required, to login to his Facebook account &
    * authorize Freelancer to access his profile.
    *
    * @param {Array} scope Array of permission strings. Calling this
    * function with new permissions will prompt the user to accept them.
    * These permissions will be added to the default ones (user_location,
    * user_website, email, user_birthday).
    *
    * @returns {Object} a Promise object that will be resolved with an
    * AuthResponse object from the Facebook API. This object can then be
    * passed to the Auth Service's loginWithFacebook API to login the
    * user into Freelancer or the Users Service's createWithFacebook to
    * create a new user account. On failure, an error object with a "code"
    * key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' will be returned.
    * WARNING: For Chrome on iOS (userAgent detected), the user would be
    * redirect to Facebook & redirected back to the current page with the
    * "facebook_redirect" appended to it. This is needed to fix
    * http://stackoverflow.com/questions/16843116/
    * facebook-oauth-unsupported-in-chrome-on-ios
    */

  }, {
    key: 'login',
    value: function login(permissions) {
      var _this2 = this;

      var s = ['email', 'public_profile'];
      var scope = s.concat(permissions);
      // The redirect method is needed to fix
      // http://stackoverflow.com/questions/16843116/
      // facebook-oauth-unsupported-in-chrome-on-ios
      // Also for the installable web app when launched specifically on iOS
      if (this.$window.navigator.userAgent.match('CriOS') || this.$window.navigator.standalone) {
        // Exclusive to iOS
        // Add the "facebook_redirect" search param to the current query
        // string to allow the app to identify the redirect
        var queryString = this.$window.location.search;
        // TODO: a proper URL lib would probably be nicer
        var redirectQueryString = queryString ? queryString + '&facebook_redirect' : '?facebook_redirect';
        var redirectUrl = oneLineTrim(_templateObject$12, this.$location.protocol(), this.$location.host(), this.$location.path(), redirectQueryString, this.$location.hash());
        // Do redirect the user.
        this.$window.location.href = oneLineTrim(_templateObject2$4, this.FACEBOOK_APP_ID, encodeURIComponent(redirectUrl), scope.join(','));
        // Do not return a state as user is going to be redirected
        return this.$q.defer().promise;
      }
      return this.FacebookSDK.login(null, {
        scope: scope.join(', ')
      }).then(function (response) {
        // Make sure the user has authorised Facebook
        if (response.status === 'connected') {
          return _this2.$q.when(response.authResponse);
        } else if (response.status === 'not_authorized') {
          return _this2.$q.reject({ code: 'NOT_AUTHORISED' });
        }
        return _this2.$q.reject({ code: 'NOT_CONNECTED' });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#getUser
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Get the Facebook Graph API user object of the currently connected
    * user, or an error object with a "code" key of 'NOT_AUTHORISED' or
    * 'NOT_CONNECTED' on error.
    *
    * @returns {Object} a Promise object that will be resolved with an
    * Faceook Graph API User Object. The exact fields of the user object
    * are determined by the requested permissions on login.
    */

  }, {
    key: 'getUser',
    value: function getUser() {
      var _this3 = this;

      var fields = ['first_name', 'email'];
      return this.checkConnected().then(function () {
        return _this3.FacebookSDK.api('/me', { fields: fields.join(', ') });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#getUserPictureUrl
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Get the profile picture URL on the currently connected user, or an error
    * object with a "code" key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' on error
    *
    * @param {int} height Request a profile picture with a specific height
    * @param {int} width Request a profile picture with a specific width
     * @returns {String} a Promise object that will be resolved with the URL
    * of the user's profile picture. The dimession of the picture are
    * determined by the height & width paramaters and default to Facebook
    * default size if unspecified.
    */

  }, {
    key: 'getUserPictureUrl',
    value: function getUserPictureUrl(height, width) {
      var _this4 = this;

      var params = height ? '&height=' + height : '';
      params += width ? '&width=' + width : '';
      return this.checkConnected().then(function () {
        return _this4.FacebookSDK.api('/me/picture?redirect=false' + params);
      }).then(function (response) {
        return response.data.url;
      });
    }
  }]);

  return FacebookProvider;
}();

FacebookProvider.$inject = ['$q', '$window', '$location', 'FacebookSDK', 'FACEBOOK_APP_ID'];


var FacebookProvider$1 = flService('Facebook', [FacebookSDKModule, OPAQUE_MODULE_NAME], FacebookProvider);

var template$14 = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\" ng-click=\"LoginForm.closeModal()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"LoginForm.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Login\">\n    <div class=\"ModalLoginSignup-body-heading\">\n      <span ng-if=\"!LoginForm.loginSignupConfig.getLoginTitle()\">\n        Welcome Back\n      </span>\n      <span ng-if=\"LoginForm.loginSignupConfig.getLoginTitle()\">\n        {{LoginForm.loginSignupConfig.getLoginTitle()}}\n      </span>\n    </div>\n    <form class=\"user-login-form fl-form large-form responsive-form\">\n        <div ng-messages=\"LoginForm.fbError\">\n            <div ng-message=\"facebookNotAuthorized\" class=\"alert alert-error\">\n                Please authorize Freelancer to access your Facebook account in order to login with Facebook\n            </div>\n            <div ng-message=\"facebookNotConnected\" class=\"alert alert-error\">\n                Please connect with your Facebook account or login below\n            </div>\n            <div ng-message=\"facebookRateLimit\" class=\"alert alert-error\">\n              You are performing too many requests. Please try again later.\n            </div>\n            <div ng-message=\"facebookClosed\" class=\"alert alert-error\">\n              This account has been closed. Please contact <a href=\"/support/profile/can-i-reopen-my-closed-account\">support</a> for more assistance.\n            </div>\n            <div ng-message=\"facebookAccessDenied\" class=\"alert alert-error\">\n                There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n            </div>\n            <div ng-message=\"facebookUnknownError\" class=\"alert alert-error\">\n                Failed to connect with Facebook. Please try again.\n            </div>\n        </div>\n        <button ng-if=\"!LoginForm.loginSignupConfig.isHideFb()\"\n            ng-click=\"LoginForm.fbLogin()\"\n            class=\"btn-facebook btn btn-large ModalLoginSignup-facebook-connect\"\n            data-uitest-target=\"facebook-login-button\"\n            fl-analytics=\"FBLogin\">\n            <div class=\"ModalLoginSignup-facebook-container\">\n                <span class=\"ModalLoginSignup-facebook-icon btn-facebook-icon Icon Icon--large Icon--light\">\n                    <fl-icon name=\"ui-facebook\"></fl-icon>\n                </span>\n                <div>Login with Facebook</div>\n            </div>\n        </button>\n    </form>\n    <div class=\"hr-divider\" ng-if=\"!LoginForm.loginSignupConfig.isHideFb()\"><span class=\"hr-divider-text\">OR</span></div>\n    <form name=\"LoginForm.form\" class=\"user-login-form fl-form large-form responsive-form\">\n        <aside ng-class=\"{'is-hidden': !LoginForm.showErrorMessage}\"\n            class=\"alert alert-error\">\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'ExceptionCodes.MISSING_USER'\">Incorrect username or password provided.</span>\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'Closed'\">This account has been closed. Please contact <a href=\"/support/profile/can-i-reopen-my-closed-account\">support</a> for more assistance.</span>\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'ExceptionCodes.BLOCKED_TWO_FACTOR'\">\n                We have detected your log in from a new device. Please check your email to continue.\n            </span>\n            <span ng-if=\"(\n                    LoginForm.errorStatus === 401\n                    && LoginForm.errorCode !== 'ExceptionCodes.MISSING_USER'\n                    && LoginForm.errorCode !== 'Closed'\n                    && LoginForm.errorCode !== 'ExceptionCodes.BLOCKED_TWO_FACTOR'\n                )\n                || LoginForm.errorStatus === 500\">\n                There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Request ID: {{LoginForm.requestId}}\n            </span>\n            <span ng-if=\"LoginForm.errorStatus === 429\">You are performing too many requests. Please try again later.</span>\n        </aside>\n        <div ng-if=\"LoginForm.loginSuccess\"\n          class=\"form-feedback-success login-success alert alert-success\">\n          Login Success!\n          <div class=\"Loader Loader--small\"></div>\n        </div>\n        <fieldset>\n            <ol>\n                <li ng-class=\"{'is-invalid': LoginForm.form.username.$invalid && LoginForm.form.username.$dirty}\"\n                    class=\"form-step username-step\">\n                    <label for=\"username\" class=\"is-accessibly-hidden\">Username</label>\n                    <input id=\"username\" name=\"username\" type=\"text\"\n                      placeholder=\"Email or Username\" maxlength=\"150\" class=\"large-input\"\n                      ng-model=\"LoginForm.UserData.user.username\"\n                      ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n                      ng-required=\"true\"\n                      ng-change=\"LoginForm.hideErrorMessage()\"\n                      fl-email-username-valid-check\n                      fl-focus-on=\"LoginForm.focusEmailInput\" />\n                    <div ng-messages=\"LoginForm.form.username.$error\" tabindex=\"-1\">\n                        <div class=\"form-error\" ng-message=\"required\">\n                            Please enter your username or email address.\n                        </div>\n                        <div class=\"form-error\" ng-message=\"validEmailUsername\">\n                            Please enter a valid username or email address.\n                        </div>\n                    </div>\n                </li>\n                <li ng-class=\"{'is-invalid': LoginForm.form.password.$invalid && LoginForm.form.password.$dirty}\"\n                  class=\"form-step password-step\">\n                    <label for=\"password\" class=\"is-accessibly-hidden\">Password</label>\n                    <input id=\"password\" name=\"password\" type=\"password\"\n                      placeholder=\"Password\" maxlength=\"150\" class=\"large-input\"\n                      ng-model=\"LoginForm.UserData.user.password\"\n                      ng-required=\"true\"/>\n                    <div ng-messages=\"LoginForm.form.password.$error\" tabindex=\"-1\">\n                        <div class=\"form-error\" ng-message=\"required\">\n                            Please enter your password.\n                        </div>\n                    </div>\n                </li>\n                <li class=\"form-step has-label login-form-options\">\n                    <a ng-click=\"LoginForm.showResetPasswordForm()\" class=\"login-form-forgot forgot-password\" fl-analytics=\"ForgotPassword\">\n                        Forgot Password?\n                    </a>\n                    <div class=\"Checkbox\">\n                        <input ng-model=\"LoginForm.rememberLogin\" id=\"loginpermanent\" class=\"Checkbox-input\" type=\"checkbox\" name=\"remember\" />\n                        <label class=\"Checkbox-label checkbox\" for=\"loginpermanent\">\n                            Remember me\n                        </label>\n                    </div>\n                </li>\n                <li class=\"form-step\">\n                    <button ng-click=\"LoginForm.login($event)\"\n                        id=\"login_btn\"\n                        ng-disabled=\"LoginForm.isSubmitting\"\n                        type=\"submit\"\n                        class=\"btn btn-info btn-large btn-submit ModalLoginSignup-loginForm-submitBtn\"\n                        fl-analytics=\"NormalLogin\">\n                        Log In\n                    </button>\n                </li>\n            </ol>\n        </fieldset>\n    </form>\n    <span class=\"ModalLoginSignup-switchLoginSignupType\" ng-if=\"LoginForm.loginSignupConfig.showSignupOption()\">\n        Don't have an account?\n        <a ng-click=\"LoginForm.goToSignup($event)\" fl-analytics=\"SignupLink\">Sign Up</a>\n    </span>\n</div>\n";

var twoFAOptionsWhitelist = [9603891, // nyl10
24461021, // rchoapeck
26277993];

var flLoginForm = function () {
  function flLoginForm($window, $timeout, $rootScope, UsersService, Users, UserData, Facebook, Analytics, Auth, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flLoginForm);

    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.UsersService = UsersService;
    this.Users = Users;
    this.UserData = UserData;
    this.Analytics = Analytics;
    this.Facebook = Facebook;
    this.Auth = Auth;
    this.UsersService.getDeviceToken(this.UserData.user);
    this.isSubmitting = false;
    this.showErrorMessage = false;
    this.rememberLogin = false;
    this.loginSuccess = false;
    this.form = {};
    this.fbError = {};

    this.loginSignupConfig = LoginSignupConfig;

    this.watchShowSignup = $rootScope.$watch(function () {
      return _this.loginSignupConfig.options.showSignup;
    }, function (newValue) {
      // If Show Signup was set to false (on login), try auto connect facebook
      if (newValue === false && _this.UserData.isFacebookConnected()) {
        _this.fbLogin(true);
      }
    });

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flLoginForm, [{
    key: 'login',
    value: function login(event) {
      var _this2 = this;

      event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });

      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;
      this.fbError = {};
      return this.UsersService.login(this.UserData.user, this.rememberLogin, this.loginSignupConfig.getOld2FAToken()).then(function (response) {
        if (response.data && response.data.pre_login_token) {
          var _ret = function () {
            var token = response.data.pre_login_token.split('.');
            var twoFATokenDecoded = atob(token[1]);
            var userId = JSON.parse(twoFATokenDecoded).user_id;

            return {
              v: ABTest.getUserExperimentVariation('TS-T69187-show-more-2fa-options', userId).then(function (variant) {
                _this2.onNeedTotp({
                  twoFAMethod: _this2.retrieveTwoFAMethod(response.data.pre_login_token),
                  userId: userId,
                  showTwoFAOptions: variant === 'test' || twoFAOptionsWhitelist.includes(userId)
                });
              })
            };
          }();

          if (typeof _ret === "object") return _ret.v;
        } else if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.$window.requestAnimationFrame(function () {
            _this2.onLoginSuccess({
              rememberLogin: _this2.rememberLogin
            });
          });
        } else {
          _this2.isSubmitting = false;
        }
      }).catch(function (response) {
        if (response.data && response.data.error_code === 'Suspended') {
          _this2.$window.requestAnimationFrame(function () {
            _this2.onLoginSuccess({
              rememberLogin: _this2.rememberLogin,
              forceRedirectUrl: '/users/usersuspended.php'
            });
          });
        }
        _this2.showErrorMessage = true;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error_code;
        _this2.requestId = response.data.request_id;
        _this2.errorMessage = response.data.message;
        _this2.isSubmitting = false;
      });
    }
  }, {
    key: 'retrieveTwoFAMethod',
    value: function retrieveTwoFAMethod(preLoginToken) {
      var token = preLoginToken.split('.');
      var twoFATokenDecoded = atob(token[1]);
      return JSON.parse(twoFATokenDecoded)['2fa_methods'][0];
    }

    /**
     * Login through Facebook.
     * Automatically Triggers FB Link or Switch to Signup on new account.
     */

  }, {
    key: 'fbLogin',
    value: function fbLogin(skipLogin) {
      var _this3 = this;

      if (this.loginSuccess || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.showErrorMessage = false;
      this.fbError = {};
      var facebookAuthParams = void 0;
      var authParamsPromise = void 0;
      // 1. Get Facebook auth params
      // If we come from Facebook signup, we need to skip the login
      // step overwise the popup will be blocked!
      if (!skipLogin) {
        authParamsPromise = this.Facebook.login();
      } else {
        authParamsPromise = this.Facebook.checkConnected();
      }

      // 2. Log into the Freelancer account
      return authParamsPromise.then(function (authParams) {
        facebookAuthParams = authParams;
        _this3.UserData.user.facebookAccessToken = authParams.accessToken;
        _this3.UserData.user.facebookSignedRequest = authParams.signedRequest;

        return _this3.UsersService.loginWithFacebook(_this3.UserData.user)
        // 3. Redirect the user
        .then(function (response) {
          if (response.data) {
            _this3.loginSuccess = true;
            _this3.Analytics.trackAction('facebook', 'login', 'SUCCESS');
            _this3.$window.requestAnimationFrame(function () {
              _this3.onLoginSuccess({
                rememberLogin: false
              });
            });
            return;
          }
          _this3.isSubmitting = false;
        }).catch(function (error) {
          // Get Error Contents
          var errorStatus = error.status;
          error = error.data || null;

          // No Error Data
          if (!error) {
            _this3.Analytics.trackError('facebook', 'login', errorStatus, 'EmptyError');
            _this3.fbError.facebookUnknownError = true;
            _this3.isSubmitting = false;
            return;
          }

          if (error.error_code === 'FacebookEmailMatch') {
            // Facebook email matches an existing Freelancer's email.
            _this3.Analytics.trackAction('facebook', 'login', error.error_code);
            _this3.fbLink(facebookAuthParams);
            return;
          } else if (error.error_code === 'ExceptionCodes.MISSING_USER') {
            // New User, Redirect to Signup
            _this3.Analytics.trackAction('facebook', 'login', error.error_code);
            _this3.fbRedirectToSignup();
            return;
          }

          _this3.isSubmitting = false;
          if (errorStatus === 429) {
            _this3.fbError.facebookRateLimit = true;
          } else if (error.error_code === 'Closed') {
            _this3.fbError.facebookClosed = true;
          } else if (error.error_code === 'Suspended') {
            _this3.$window.requestAnimationFrame(function () {
              _this3.onLoginSuccess({
                rememberLogin: _this3.rememberLogin,
                forceRedirectUrl: '/users/usersuspended.php'
              });
            });
          } else if (errorStatus === 401) {
            _this3.fbError.facebookAccessDenied = true;
          } else {
            _this3.Analytics.trackError('facebook', 'login', error.error_code, error.message);
            _this3.fbError.facebookUnknownError = true;
          }
        });
      }).catch(function () {
        _this3.isSubmitting = false;
      });
    }

    /**
     * Get Facebook Details for current user then Redirect to /signup
     * Used from fbLogin()
     */

  }, {
    key: 'fbRedirectToSignup',
    value: function fbRedirectToSignup() {
      var _this4 = this;

      return this.Facebook.getUser().then(function (facebookUser) {
        _this4.UserData.setFacebookConnected(true);
        // Clear username and set Email
        _this4.UserData.username = '';
        _this4.UserData.user.email = facebookUser.email;
        // Set Facebook Data
        _this4.UserData.setFacebookEmail(facebookUser.email);
        _this4.UserData.setFacebookName(facebookUser.first_name);
        // Switch to Signup Form
        _this4.isSubmitting = false;
        _this4.showSignupForm();
      }).catch(function (error) {
        _this4.isSubmitting = false;
        if (error.code === 'NOT_AUTHORISED') {
          _this4.fbError.facebookNotAuthorized = true;
        } else if (error.code === 'NOT_CONNECTED') {
          _this4.fbError.facebookNotConnected = true;
        } else {
          _this4.Analytics.trackError('facebook', 'loginRedirectToSignup', error.code);
          _this4.fbError.facebookUnknownError = true;
        }
      });
    }

    /**
     * Links User to their Freelancer Account.
     * Used from fbLogin()
     */

  }, {
    key: 'fbLink',
    value: function fbLink(facebookAuthParams) {
      var _this5 = this;

      this.fbError = {};
      this.Facebook.getUser().then(function (facebookUser) {
        _this5.UserData.setFacebookConnected(true);
        _this5.UserData.setFacebookEmail(facebookUser.email);
        _this5.UserData.setFacebookName(facebookUser.first_name);
        _this5.UserData.user.facebookAccessToken = facebookAuthParams.accessToken;
        _this5.UserData.user.facebookSignedRequest = facebookAuthParams.signedRequest;

        // Try Get Profile Picture then Show Facebook Link Form
        _this5.Facebook.getUserPictureUrl(60, 60).then(function (pictureUrl) {
          _this5.UserData.setFacebookPictureUrl(pictureUrl);
        }).finally(function () {
          _this5.isSubmitting = false;
          _this5.showFacebookLinkForm();
        });
      }).catch(function (error) {
        _this5.isSubmitting = false;
        if (error.code === 'NOT_AUTHORISED') {
          _this5.Analytics.trackAction('facebook', 'link accounts', error.code);
          _this5.fbError.facebookNotAuthorized = true;
        } else if (error.code === 'NOT_CONNECTED') {
          _this5.Analytics.trackAction('facebook', 'link accounts', error.code);
          _this5.fbError.facebookNotConnected = true;
        } else {
          _this5.fbError.facebookUnknownError = error.code;
        }
      });
    }
  }, {
    key: 'goToSignup',
    value: function goToSignup($event) {
      $event.preventDefault();
      this.showSignupForm();
    }
  }, {
    key: 'hideErrorMessage',
    value: function hideErrorMessage() {
      this.showErrorMessage = false;
    }
  }]);

  return flLoginForm;
}();

flLoginForm.$inject = ['$window', '$timeout', '$rootScope', 'UsersService', 'Users', 'UserData', 'Facebook', 'Analytics', 'Auth', 'LoginSignupConfig'];

var flLoginForm$1 = flComponent$1(flLoginForm, {
  selector: 'fl-login-form',
  template: template$14,
  providers: [flIconProvider, flFocusOnProvider, flEmailUsernameValidCheck$1, UsersProvider$1, FacebookProvider$1, AnalyticsModule, AuthModule, UserData$1, UsersProvider, LoginSignupConfigProvider],
  bindings: {
    showSignupForm: '&',
    showResetPasswordForm: '&',
    showFacebookLinkForm: '&',
    onNeedTotp: '&',
    rememberLogin: '=',
    onLoginSuccess: '&',
    showAsModal: '=',
    closeModal: '&'
  }
});

var template$15 = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-totp\">\n    <h4 class=\"ModalLoginSignup-body-heading\">2-Step Verification</h4>\n    <div ng-if=\"!TotpForm.showOptions\">\n        <div class=\"ModalLoginSignup-totp-message\">\n            A verification code has been sent to you via\n            <span ng-switch=\"TotpForm.twoFaMethod\">\n                <span ng-switch-when=\"1\">Email.</span>\n                <span ng-switch-when=\"2\">SMS.</span>\n                <span ng-switch-when=\"3\">Generator App.</span>\n                <span ng-switch-when=\"4\">Freelancer App.</span>\n                <span ng-switch-default>Email, SMS or App.</span>\n            </span>\n            Please verify that 6 digit code below to continue.\n        </div>\n        <form class=\"user-login-form fl-form large-form responsive-form\">\n            <div ng-if=\"TotpForm.loginSuccess\"\n              class=\"form-feedback-success login-success alert alert-success\">\n              Login Success\n            </div>\n            <fieldset>\n                <ol>\n                    <li class=\"form-step has-label login-form-options\">\n                        <a ng-if=\"TotpForm.showTwoFAOptions\"\n                          ng-click=\"TotpForm.showOtherOptions()\"\n                          class=\"login-form-forgot recover-login-switch-bt\">\n                          Having problems?\n                        </a>\n                        <a ng-if=\"!TotpForm.showTwoFAOptions\"\n                          ng-click=\"TotpForm.login()\"\n                          class=\"login-form-forgot recover-login-switch-bt\">\n                          Resend code\n                        </a>\n                    </li>\n                    <aside ng-class=\"{'is-hidden': !TotpForm.showResendSuccessMessage}\"\n                        class=\"alert alert-info\">\n                        Code has been resent. Please check your\n                        <span ng-switch=\"TotpForm.twoFaMethod\">\n                            <span ng-switch-when=\"1\">Email.</span>\n                            <span ng-switch-when=\"2\">SMS.</span>\n                            <span ng-switch-when=\"3\">Generator App.</span>\n                            <span ng-switch-when=\"4\">Freelancer App.</span>\n                            <span ng-switch-default>Email, SMS or App.</span>\n                        </span>\n                    </aside>\n                    <aside ng-class=\"{'is-hidden': !TotpForm.showErrorMessage}\"\n                        class=\"alert alert-error\">\n                        <span ng-if=\"TotpForm.errorStatus === 401 && TotpForm.errorCode === 'ExceptionCodes.INVALID_TOTP'\">Wrong code. Please try again.</span>\n                        <span ng-if=\"TotpForm.errorStatus === 401 && TotpForm.errorCode !== 'ExceptionCodes.INVALID_TOTP'\">There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Error: {{TotpForm.errorCode}}</span>\n                        <span ng-if=\"TotpForm.errorStatus === 429\">You are performing too many requests. Please try again later.</span>\n                        <span ng-if=\"TotpForm.errorStatus === 500\">{{TotpForm.errorMessage}}<br/>Error: {{TotpForm.errorCode}}</span>\n                        <span ng-if=\"TotpForm.errorStatus === 'error'\" ng-bind-html=\"TotpForm.errorMessage\"></span>\n                    </aside>\n                    <li class=\"form-step totp-step\">\n                        <label for=\"totp\" class=\"is-accessibly-hidden\">One Time Password</label>\n                        <input type=\"text\" placeholder=\"6 digit code\" name=\"totp\"\n                            class=\"large-input\"\n                            ng-model=\"TotpForm.UserData.user.TOTP\"\n                            ng-keypress=\"TotpForm.totpOnKeyPress($event)\"\n                            ng-change=\"TotpForm.totpOnChange()\"\n                            fl-focus-on=\"TotpForm.focusTotpInput\" />\n                    </li>\n                </ol>\n            </fieldset>\n        </form>\n    </div>\n    <div ng-if=\"TotpForm.showOptions\">\n      <h6 class=\"ModalLoginSignup-totp-message\">\n          Choose another method to sign-in\n      </h6>\n      <aside ng-class=\"{'is-hidden': !TotpForm.showErrorMessage}\"\n          ng-switch=\"TotpForm.errorStatus\"\n          class=\"alert alert-error\">\n          <span ng-switch-when=\"401\">There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Error: {{TotpForm.errorCode}}</span>\n          <span ng-switch-when=\"429\">You are performing too many requests. Please try again later.</span>\n          <span ng-switch-when=\"500\">{{TotpForm.errorMessage}}<br/>Error: {{TotpForm.errorCode}}</span>\n          <span ng-switch-default>An unexpected error has occured. Please try again later.</span>\n      </aside>\n      <ul class=\"ModalLoginSignup-totp-options\">\n          <li class=\"ModalLoginSignup-totp-item\">\n            <a ng-if=\"TotpForm.totpMethods.indexOf(1) >= 0\" ng-click=\"TotpForm.resendCode(1)\" role=\"button\" class=\"ModalLoginSignup-totp-btn\">\n              <span class=\"Icon ModalLoginSignup-totp-icon\">\n                <fl-icon name=\"ui-mail\"></fl-icon>\n              </span>\n              <span class=\"ModalLoginSignup-totp-details\">Receive the verification code from your email</span>\n            </a>\n          </li>\n          <li class=\"ModalLoginSignup-totp-item\">\n            <a ng-if=\"TotpForm.totpMethods.indexOf(2) >= 0\" ng-click=\"TotpForm.resendCode(2)\" role=\"button\" class=\"ModalLoginSignup-totp-btn\">\n              <span class=\"Icon ModalLoginSignup-totp-icon\">\n                <fl-icon name=\"ui-mobile-phone\"></fl-icon>\n              </span>\n              <span class=\"ModalLoginSignup-totp-details\">Get the verification code at {{TotpForm.smsNumber}}</span>\n            </a>\n          </li>\n          <li class=\"ModalLoginSignup-totp-item\">\n            <a ng-click=\"TotpForm.contactSupport()\" role=\"button\" class=\"ModalLoginSignup-totp-btn\">\n              <span class=\"Icon ModalLoginSignup-totp-icon\">\n                <fl-icon name=\"ui-help\"></fl-icon>\n              </span>\n              <span class=\"ModalLoginSignup-totp-details\">Contact Customer Support. We'll get back to you as soon as we can.</span>\n            </a>\n          </li>\n      </ul>\n    </div>\n</div>\n";

/**
 * @ngdoc component
 * @name LoginSignupApp.flTotpForm
 * @description
 * Handles the code input, and resends for the 2FA form.
 */

var flTotpForm = function () {
  function flTotpForm($window, $timeout, Analytics, UsersService, UserData) {
    var _this = this;

    _classCallCheck(this, flTotpForm);

    this.$window = $window;
    this.$timeout = $timeout;
    this.Analytics = Analytics;
    this.Users = UsersService;
    this.UserData = UserData;

    this.Users.getDeviceToken(this.UserData.user);
    this.showResendSuccessMessage = false;
    this.isResendingCode = false;
    this.isSubmitting = false;
    this.loginSuccess = false;
    this.showOptions = false;
    this.totpMethods = [];
    this.smsNumber = null;
    this.defaultMethod = null;

    // Focus on TOTP Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusTotpInput = true;
    }, 50);
  }

  _createClass(flTotpForm, [{
    key: 'tryTotpLogin',
    value: function tryTotpLogin() {
      var _this2 = this;

      if (!this.isSubmitting && !this.loginSuccess && this.UserData.user.TOTP.length > 5) {
        this.isSubmitting = true;
        this.showErrorMessage = false;
        this.Users.totpLogin(this.UserData.user, this.rememberLogin).then(function (response) {
          if (response.data && response.data.token) {
            _this2.loginSuccess = true;
            _this2.$window.requestAnimationFrame(function () {
              _this2.onLoginSuccess({
                rememberLogin: _this2.rememberLogin
              });
            });
          }
          _this2.isSubmitting = false;
        }).catch(function (response) {
          _this2.showErrorMessage = true;
          _this2.errorStatus = response.status;
          _this2.errorCode = response.data.error_code;
          _this2.errorMessage = response.data.message;
          _this2.isSubmitting = false;
        });
      }
    }

    /**
     * Try to login again. This is useful for totp form component to mimic resending code
     */

  }, {
    key: 'login',
    value: function login() {
      var _this3 = this;

      this.Analytics.trackEvent('Login', '2fa', null, 'click', null, 'ResendCode');

      if (!this.isResendingCode) {
        this.isResendingCode = true;

        return this.Users.login(this.UserData.user, this.rememberLogin).then(function (response) {
          if (response.data && response.data.pre_login_token) {
            _this3.showResendSuccessMessage = true;
            _this3.$timeout(function () {
              _this3.showResendSuccessMessage = false;
            }, 10000);
          }

          _this3.isResendingCode = false;
        });
      }
    }

    /**
     * Limit TOTP length to 6 numbers.
     * Disallows input if length is greater or equal to 6 characters.
     */

  }, {
    key: 'totpOnKeyPress',
    value: function totpOnKeyPress(event) {
      var specialKeys = ['Backspace', 'Tab', 'End', 'Home'];
      var specialKeyCodes = [8, 9, 2, 3];
      // Allow Special Keys
      if (event.key && specialKeys.indexOf(event.key) !== -1 || specialKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
      }

      if (this.UserData.user.TOTP.length < 6) {
        return;
      }
      event.preventDefault();
    }

    /**
     * Allow only numeric values and Limit Length
     */

  }, {
    key: 'totpOnChange',
    value: function totpOnChange() {
      var numberOnlyValue = this.UserData.user.TOTP.replace(/[^0-9]/g, '');
      this.UserData.user.TOTP = numberOnlyValue;
      var limitString = this.UserData.user.TOTP.substring(0, 6);
      this.UserData.user.TOTP = limitString;

      this.tryTotpLogin();
    }
  }, {
    key: 'showOtherOptions',
    value: function showOtherOptions() {
      var _this4 = this;

      this.track2FAMethodEvent('HavingProblems');
      this.showErrorMessage = false;

      this.Users.getAvailableTotpMethods(this.userId).then(function (response) {
        _this4.totpMethods = response.methods;
        _this4.smsNumber = response.sms;
        _this4.showOptions = true;
      }).catch(function (response) {
        _this4.showErrorMessage = true;
        _this4.errorStatus = response.data.status;
        _this4.errorMessage = response.data.message;
      });
    }
  }, {
    key: 'resendCode',
    value: function resendCode(method) {
      var _this5 = this;

      var methodName = this.get2FAMethodLabel(method).split(' ').map(function (word) {
        return word[0].toUpperCase() + word.substr(1);
      }).join('');
      this.track2FAMethodEvent('ChangeMethod' + methodName);

      if (!this.isResendingCode) {
        this.isResendingCode = true;
        this.showResendSuccessMessage = false;
        this.showErrorMessage = false;

        if (!this.defaultMethod) {
          this.defaultMethod = this.twoFaMethod;
        }

        return this.Users.deliverToken(this.UserData.user, method).then(function () {
          if (_this5.defaultMethod === method) {
            _this5.showResendSuccessMessage = true;
            _this5.$timeout(function () {
              _this5.showResendSuccessMessage = false;
            }, 10000);
          }

          _this5.twoFaMethod = method;
          _this5.showOptions = false;
          _this5.isResendingCode = false;
        }).catch(function (response) {
          _this5.showErrorMessage = true;
          _this5.errorStatus = response.status;
          _this5.errorCode = response.data.error_code;
          _this5.errorMessage = response.data.message;
          _this5.isResendingCode = false;
        });
      }
    }
  }, {
    key: 'contactSupport',
    value: function contactSupport() {
      this.track2FAMethodEvent('ContactSupport');
      this.$window.location.href = '/contact';
    }
  }, {
    key: 'get2FAMethodLabel',
    value: function get2FAMethodLabel(methodId) {
      switch (methodId) {
        case 2:
          return 'sms';

        case 3:
          return 'authenticator app';

        case 4:
          return 'freelancer app';

        default:
          return 'email';
      }
    }
  }, {
    key: 'track2FAMethodEvent',
    value: function track2FAMethodEvent(label) {
      this.Analytics.trackEvent('Login', '2fa', 'current method', null, this.get2FAMethodLabel(this.twoFaMethod), label);
    }
  }]);

  return flTotpForm;
}();

flTotpForm.$inject = ['$window', '$timeout', 'Analytics', 'UsersService', 'UserData'];

var flTotpForm$1 = flComponent$1(flTotpForm, {
  selector: 'fl-totp-form',
  template: template$15,
  providers: [flIconProvider, flFocusOnProvider, AnalyticsModule, UsersProvider$1, UserData$1],
  bindings: {
    twoFaMethod: '=',
    userId: '=',
    showTwoFAOptions: '=',
    rememberLogin: '=',
    onLoginSuccess: '&'
  }
});

var facebookLinkFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"FacebookLinkForm.cancelLink()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"FacebookLinkForm.closeModal()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n        ng-if=\"FacebookLinkForm.showAsModal\">\n        <span class=\"Icon Icon--small\">\n          <fl-icon name=\"ui-close\"></fl-icon>\n        </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{FacebookLinkForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    Link to existing Freelancer account\n  </div>\n  <figure class=\"ImageThumbnail ModalLoginSignup-facebook-profileImage\">\n    <img ng-src=\"{{FacebookLinkForm.UserData.getFacebookPictureUrl()}}\" alt=\"Profile Picture\"\n      class=\"ImageThumbnail-image\">\n  </figure>\n  <h2 class=\"ModalLoginSignup-body-heading\">\n    Welcome {{FacebookLinkForm.UserData.getFacebookName()}}!\n  </h2>\n  <div class=\"ModalLoginSignup-facebookLinkForm-info\">\n    Your email address is already associated with a Freelancer account. Enter your password below to link accounts:\n  </div>\n  <form name=\"FacebookLinkForm.form\" class=\"user-login-form fl-form large-form responsive-form\">\n    <div ng-messages=\"FacebookLinkForm.errors\">\n      <div ng-message=\"incorrectPassword\" class=\"alert alert-error\">\n        Incorrect username or password provided.\n      </div>\n      <div ng-message=\"facebookRateLimit\" class=\"alert alert-error\">\n        You are performing too many requests. Please try again later.\n      </div>\n      <div ng-message=\"facebookClosed\" class=\"alert alert-error\">\n        This account has been closed. Please contact <a href=\"/support/profile/can-i-reopen-my-closed-account\">support</a> for more assistance.\n      </div>\n      <div ng-message=\"facebookAccessDenied\" class=\"alert alert-error\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n      </div>\n      <div ng-message=\"facebookUnknownError\" class=\"alert alert-error\">\n        Failed to connect with Facebook. Please try again.\n      </div>\n    </div>\n    <div ng-if=\"FacebookLinkForm.loginSuccess\"\n      class=\"form-feedback-success login-success alert alert-success\">\n      Successfully Linked!\n    </div>\n    <fieldset>\n      <ol>\n        <li ng-class=\"{'is-invalid': FacebookLinkForm.form.email.$invalid && FacebookLinkForm.form.email.$dirty}\"\n          class=\"form-step email-step\">\n          <label for=\"email\" class=\"is-accessibly-hidden\">Username</label>\n          <input id=\"email\" name=\"email\" type=\"email\"\n            maxlength=\"150\" class=\"large-input\"\n            ng-model=\"FacebookLinkForm.UserData.user.email\"\n            ng-required=\"true\"\n            ng-disabled=\"true\"/>\n        </li>\n        <li ng-class=\"{'is-invalid': FacebookLinkForm.form.password.$invalid && FacebookLinkForm.form.password.$dirty}\"\n          class=\"form-step password-step\">\n          <label for=\"password\" class=\"is-accessibly-hidden\">Password</label>\n          <input id=\"password\" name=\"password\" type=\"password\"\n            placeholder=\"Password\" class=\"large-input\"\n            maxlength=\"150\"\n            ng-model=\"FacebookLinkForm.UserData.user.password\"\n            ng-required=\"true\"/>\n          <div ng-if=\"FacebookLinkForm.form.password.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div ng-messages=\"FacebookLinkForm.form.password.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter your password.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step has-label login-form-options\">\n          <a ng-click=\"FacebookLinkForm.showResetPasswordForm()\" class=\"login-form-forgot forgot-password\">Forgot Password?</a>\n        </li>\n        <li class=\"form-step\">\n          <button ng-click=\"FacebookLinkForm.onFormSubmit($event)\" ng-disabled=\"FacebookLinkForm.isSubmitting\" type=\"submit\" class=\"btn btn-info btn-large btn-submit ModalLoginSignup-facebookLinkForm-submitBtn\">\n            Log In\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var flFacebookLinkForm = function () {
  function flFacebookLinkForm($http, Cdn, UsersService, UserData, Analytics) {
    _classCallCheck(this, flFacebookLinkForm);

    this.$http = $http;
    this.UserData = UserData;
    this.Analytics = Analytics;
    this.UsersService = UsersService;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.isSubmitting = false;
    this.errors = {};
  }

  _createClass(flFacebookLinkForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      var _this = this;

      event.preventDefault();
      this.errors = {};
      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      // All Errors should be dealt with in linkFacebookAccount.
      this.linkFacebookAccount().then(function () {
        _this.onComplete();
      }).catch(function () {});
    }

    /**
     * Try to link a user to their facebook account, given their facebook auth
     * params and email and password.
     */

  }, {
    key: 'linkFacebookAccount',
    value: function linkFacebookAccount() {
      var _this2 = this;

      this.errors = {};
      return this.UsersService.linkFacebookAccount(this.UserData.user).then(function (response) {
        if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.onLoginSuccess();
          return;
        }
        _this2.isSubmitting = false;
      }).catch(function (error) {
        // Get Error Contents
        var errorStatus = error.status;
        error = error.data || null;

        // No Error Data
        if (!error) {
          _this2.Analytics.trackError('facebook', 'login', errorStatus, 'EmptyError');
          _this2.errors.facebookUnknownError = true;
          return;
        }

        // Redirect on Suspended
        if (error.error_code === 'Suspended') {
          _this2.onLoginSuccess({
            rememberLogin: _this2.rememberLogin,
            forceRedirectUrl: '/users/usersuspended.php'
          });
          return;
        }

        _this2.isSubmitting = false;
        if (errorStatus === 429) {
          _this2.errors.facebookRateLimit = true;
        } else if (errorStatus === 401 && error.error_code === 'None') {
          _this2.errors.incorrectPassword = true;
        } else if (errorStatus === 401 && error.error_code === 'Closed') {
          _this2.errors.facebookClosed = true;
        } else if (errorStatus === 401) {
          _this2.errors.facebookAccessDenied = true;
        } else {
          _this2.Analytics.trackError('facebook', 'login', error.error_code, error.message);
          _this2.errors.facebookUnknownError = true;
        }
      });
    }

    /**
     * Cancel Facebook Link
     */

  }, {
    key: 'cancelLink',
    value: function cancelLink() {
      // Clear User Data
      this.UserData.user.facebookConnected = false;
      this.UserData.user.facebookName = '';
      this.UserData.user.facebookEmail = '';
      this.UserData.user.facebookPictureUrl = '';
      this.UserData.user.facebookAccessToken = '';
      this.UserData.user.facebookSignedRequest = '';
      this.UserData.user.password = '';
      // Use Callback.
      this.onCancel();
    }
  }]);

  return flFacebookLinkForm;
}();

flFacebookLinkForm.$inject = ['$http', 'Cdn', 'UsersService', 'UserData', 'Analytics'];

var flFacebookLinkForm$1 = flComponent$1(flFacebookLinkForm, {
  selector: 'fl-facebook-link-form',
  template: facebookLinkFormTemplate,
  bindings: {
    onComplete: '&',
    onCancel: '&',
    onLoginSuccess: '&',
    showResetPasswordForm: '&',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [ngMessages, UserData$1, UsersProvider$1, AnalyticsModule, CdnProvider, flIconProvider]
});

var template$16 = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"ResetPasswordForm.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body ModalLoginSignup-body\">\n  <h4 class=\"ModalLoginSignup-body-heading\">Reset your password</h4>\n  <p ng-class=\"{'is-hidden': !ResetPasswordForm.showSuccessMessage}\"\n      class=\"alert alert-info\">\n      Email sent. If the email address you entered is registered at Freelancer.com, you'll receive an email with instructions on how to set a new password.\n  </p>\n  <p ng-class=\"{'is-hidden': !ResetPasswordForm.showErrorMessage}\" class=\"alert alert-danger\">\n    {{ ResetPasswordForm.errorMessage }}\n  </p>\n  <form name=\"ResetPasswordForm.form\" class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <fieldset>\n      <ol>\n        <li class=\"form-step recover-email-step\"\n          ng-class=\"{'is-invalid': ResetPasswordForm.form.email.$invalid && ResetPasswordForm.form.email.$dirty,\n          'is-valid': ResetPasswordForm.form.email.$valid}\">\n          <label for=\"forgotten-email\" class=\"is-accessibly-hidden\">Email Address</label>\n          <input id=\"forgotten-email\" name=\"email\" maxlength=\"100\" type=\"text\"\n            class=\"large-input\"\n            placeholder=\"Enter your email address\"\n            ng-model=\"ResetPasswordForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-focus-on=\"ResetPasswordForm.focusEmailInput\" />\n          <div ng-messages=\"ResetPasswordForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n                Please enter your email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n                Please enter a valid email address.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step\">\n          <button class=\"btn btn-info btn-large btn-primary btn-submit ModalLoginSignup-resetPassword-submitBtn\"\n            ng-disabled=\"ResetPasswordForm.isSubmitting\"\n            ng-click=\"ResetPasswordForm.resetPassword($event)\"\n            type=\"submit\">\n            Reset Password\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n  <span class=\"login-form-signup-link\" ng-if=\"ResetPasswordForm.loginSignupConfig.showSignupOption()\">\n      Don't have an account?\n      <a ng-click=\"ResetPasswordForm.goToSignup($event)\">Sign Up</a>\n  </span>\n</div>\n";

var flResetPasswordForm = function () {
  function flResetPasswordForm($timeout, UsersService, UserData, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flResetPasswordForm);

    this.$timeout = $timeout;
    this.UserData = UserData;
    this.Users = UsersService;
    this.isSubmitting = false;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.errorMessage = '';
    this.loginSignupConfig = LoginSignupConfig;

    // Set User Email to Username if it's a valid email
    // Reset Password is accessed from Login, which uses ng mdoel on username,
    // so we check to see if we can prefill this value first instead.
    if (this.UserData.user.username && isValidEmail(this.UserData.user.username)) {
      this.UserData.user.email = this.UserData.user.username;
    }

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flResetPasswordForm, [{
    key: 'resetPassword',
    value: function resetPassword(event) {
      var _this2 = this;

      event.preventDefault();
      this.showErrorMessage = false;
      // Set form fields as dirty for each form input type with any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.Users.forgotPassword(this.UserData.user.email).then(function (response) {
        if (response.data && response.data.status === 'success') {
          _this2.showSuccessMessage = true;
          _this2.$timeout(function () {
            _this2.showSuccessMessage = false;
          }, 10000);
        } else if (response.data && response.data.msg) {
          _this2.errorMessage = response.data.msg;
          _this2.showErrorMessage = true;

          if (response.data.redirectUrl) {
            window.location.href = response.data.redirectUrl;
          }
        }
        _this2.isSubmitting = false;
      });
    }
  }, {
    key: 'goToSignup',
    value: function goToSignup($event) {
      $event.preventDefault();
      this.showSignupForm();
    }
  }]);

  return flResetPasswordForm;
}();

flResetPasswordForm.$inject = ['$timeout', 'UsersService', 'UserData', 'LoginSignupConfig'];

var flResetPasswordForm$1 = flComponent$1(flResetPasswordForm, {
  selector: 'fl-reset-password-form',
  template: template$16,
  providers: [flIconProvider, flFocusOnProvider, flEmailUsernameValidCheck$1, UserData$1, UsersProvider$1, LoginSignupConfigProvider],
  bindings: {
    showSignupForm: '&',
    onCancel: '&',
    showLoginForm: '&'
  }
});

var loginSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\" ng-click=\"LoginSuccess.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"LoginSuccess.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{LoginSuccess.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Login\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Login Success!</h2>\n    <div ng-if=\"LoginSuccess.loginSignupConfig.getLoginSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">{{LoginSuccess.loginSignupConfig.getLoginSuccessMessage()}}</p>\n    </div>\n    <div ng-if=\"!LoginSuccess.loginSignupConfig.getLoginSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    </div>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flLoginSuccess = function () {
  function flLoginSuccess(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flLoginSuccess);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flLoginSuccess, [{
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flLoginSuccess;
}();

flLoginSuccess.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flLoginSuccess$1 = flComponent$1(flLoginSuccess, {
  selector: 'fl-login-success',
  template: loginSuccessTemplate,
  bindings: { closeModal: '&' },
  providers: [CdnProvider, UserData$1, LoginSignupConfigProvider]
});

var LOGIN_STEPS = {
  LOGIN_FORM: 1,
  TOTP_FORM: 2,
  FB_LINK_FORM: 3,
  RESET_PASSWORD_FORM: 4,
  LOGIN_SUCCESS: 10
};

var loginTemplate = "<fl-login-form\n  ng-if=\"Login.currentStep === Login.steps.LOGIN_FORM\"\n  show-signup-form=\"Login.goToSignup()\"\n  show-reset-password-form=\"Login.showResetPasswordForm()\"\n  show-facebook-link-form=\"Login.showFacebookLinkForm()\"\n  on-need-totp=\"Login.showTOTPForm(twoFAMethod, userId, showTwoFAOptions)\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  remember-login=\"Login.rememberLogin\"\n  show-as-modal=\"Login.showAsModal\"\n  close-modal=\"Login.closeModal()\">\n</fl-login-form>\n<fl-totp-form\n  ng-if=\"Login.currentStep === Login.steps.TOTP_FORM\"\n  two-fa-method=\"Login.twoFAMethod\"\n  user-id=\"Login.userId\"\n  show-two-f-a-options=\"Login.showTwoFAOptions\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  remember-login=\"Login.rememberLogin\"\n  show-as-modal=\"Login.showAsModal\">\n</fl-totp-form>\n<fl-reset-password-form\n  ng-if=\"Login.currentStep === Login.steps.RESET_PASSWORD_FORM\"\n  show-signup-form=\"Login.goToSignup()\"\n  on-cancel=\"Login.currentStep = Login.steps.LOGIN_FORM\"\n  show-login-form=\"Login.showLoginForm()\"\n  show-as-modal=\"Login.showAsModal\">\n</fl-reset-password-form>\n<fl-facebook-link-form\n  ng-if=\"Login.currentStep === Login.steps.FB_LINK_FORM\"\n  on-cancel=\"Login.currentStep = Login.steps.LOGIN_FORM\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  show-reset-password-form=\"Login.showResetPasswordForm()\"\n  show-as-modal=\"Login.showAsModal\"\n  close-modal=\"Login.closeModal()\">\n</fl-facebook-link-form>\n<fl-login-success\n  ng-if=\"Login.currentStep === Login.steps.LOGIN_SUCCESS\"\n  close-modal=\"Login.closeModal($event)\">\n</fl-login-success>\n";

var flLogin = function () {
  function flLogin($window, $rootScope, UserData, LoginSignupConfig) {
    _classCallCheck(this, flLogin);

    this.$window = $window;
    this.$rootScope = $rootScope;
    this.UserData = UserData;
    this.steps = LOGIN_STEPS;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flLogin, [{
    key: 'goToSignup',
    value: function goToSignup() {
      this.loginSignupConfig.switchToSignup();
    }
  }, {
    key: 'showLoginForm',
    value: function showLoginForm() {
      this.currentStep = this.steps.LOGIN_FORM;
    }
  }, {
    key: 'showTOTPForm',
    value: function showTOTPForm(twoFAMethod, userId, showTwoFAOptions) {
      this.twoFAMethod = twoFAMethod;
      this.userId = userId;
      this.showTwoFAOptions = showTwoFAOptions;
      this.currentStep = this.steps.TOTP_FORM;
    }
  }, {
    key: 'showResetPasswordForm',
    value: function showResetPasswordForm() {
      this.currentStep = this.steps.RESET_PASSWORD_FORM;
    }
  }, {
    key: 'showFacebookLinkForm',
    value: function showFacebookLinkForm() {
      if (this.UserData.isFacebookConnected()) {
        this.UserData.user.password = '';
        this.UserData.user.email = this.UserData.getFacebookEmail();
        this.currentStep = this.steps.FB_LINK_FORM;
        return;
      }
      this.currentStep = this.steps.LOGIN_FORM;
    }
  }]);

  return flLogin;
}();

flLogin.$inject = ['$window', '$rootScope', 'UserData', 'LoginSignupConfig'];

var flLogin$1 = flComponent$1(flLogin, {
  selector: 'fl-login',
  template: loginTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    currentStep: '='
  },
  providers: [UserData$1, flLoginForm$1, flTotpForm$1, flLoginSuccess$1, flFacebookLinkForm$1, flResetPasswordForm$1, LoginSignupConfigProvider]
});

var _defineProperty = (function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
});

var webappTrackingServiceReady = new Promise(function (resolve) {
  if (window.webappCompatTracking) {
    resolve();
  } else {
    window.webappCompatTrackingReadyCallback = function () {
      return resolve();
    };
  }
});

var Tracking = {
  trackCustomEvent: function trackCustomEvent(name, section, extraParams) {
    return webappTrackingServiceReady.then(function () {
      return window.webappCompatTracking.trackCustomEvent(name, section, extraParams);
    });
  }
};

var usernameInputTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"UsernameInput.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n\n    <button class=\"Modal-close\" ng-click=\"UsernameInput.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"UsernameInput.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{UsernameInput.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title\">Choose a username</h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">Please note that a username cannot be changed, once chosen.</p>\n  <form class=\"user-signup-form fl-form responsive-form\" name=\"UsernameInput.form\">\n    <div class=\"form-step email-step\"\n      ng-class=\"{'is-invalid': UsernameInput.form.username.$invalid && UsernameInput.form.username.$dirty,\n                 'is-valid': UsernameInput.form.username.$valid}\">\n      <label for=\"new-username\" class=\"is-accessibly-hidden\">Username</label>\n      <input type=\"text\" name=\"username\" id=\"new-username\"\n        rel=\"popover\" placeholder=\"Username\" class=\"large-input\"\n        ng-model=\"UsernameInput.UserData.user.username\"\n        ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n        ng-required=\"true\"\n        ng-minlength=\"3\"\n        ng-maxlength=\"16\"\n        fl-email-username-valid-check=\"username\"\n        fl-unique-email-username-check=\"username\"\n        fl-focus-on=\"UsernameInput.focusUsernameInput\">\n      <div ng-if=\"UsernameInput.form.username.$pending\"\n        class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n      </div>\n      <div ng-messages=\"UsernameInput.form.username.$error\" tabindex=\"-1\">\n        <div class=\"form-error\" ng-message=\"required\">\n          Please enter a username.\n        </div>\n        <div class=\"form-error\" ng-message=\"minlength\">\n          Please enter at least 3 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"maxlength\">\n          Please enter at most 16 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"validUsername\">\n          Username must be alphanumeric starting with a letter.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueUsername\">\n          This username already exists, please choose another.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n          Username must be different to password.\n        </div>\n      </div>\n      <div id=\"new-username-suggestion\" class=\"ModalLoginSignup-signupUsernameInput-suggestions\">\n        <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">Suggestions:</span>\n        <span ng-repeat=\"name in UsernameInput.usernameSuggestions\">\n          <a ng-click=\"UsernameInput.updateUsername(name)\">\n          {{name}}\n          </a>\n          <span ng-show=\"!$last\" class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\">/</span>\n        </span>\n      </div>\n    </div>\n    <button class=\"btn btn-info btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n      ng-disabled=\"UsernameInput.isSubmitting\"\n      ng-click=\"UsernameInput.onFormSubmit($event)\"\n      fl-analytics=\"NormalSignupUsername\">\n      Next\n      <span ng-if=\"UsernameInput.isSubmitting\" class=\"Loader Loader--small\">\n      </span>\n    </button>\n  </form>\n</div>\n";

var flUsernameInput = function () {
  function flUsernameInput($scope, $timeout, Cdn, UsersService, UserData, Facebook) {
    var _this = this;

    _classCallCheck(this, flUsernameInput);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.Users = UsersService;
    this.Facebook = Facebook;

    // Focus on Username Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flUsernameInput, [{
    key: 'updateUsername',
    value: function updateUsername(name) {
      var _this2 = this;

      this.form.username.$setDirty();
      this.UserData.user.username = name;
      var usernameValidWatch = this.$scope.$watch(function () {
        return _this2.form.$valid;
      }, function (newValue) {
        if (newValue === true) {
          _this2.onComplete();
          usernameValidWatch();
        }
      });
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }]);

  return flUsernameInput;
}();

flUsernameInput.$inject = ['$scope', '$timeout', 'Cdn', 'UsersService', 'UserData', 'Facebook'];

var flUsernameInput$1 = flComponent$1(flUsernameInput, {
  selector: 'fl-username-input',
  template: usernameInputTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    usernameSuggestions: '=',
    showAsModal: '=',
    closeModal: '&',
    isSubmitting: '='
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1, flFocusOnProvider, flIconProvider, FacebookProvider$1, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck]
});

var signupBaseFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\" ng-click=\"SignupBaseForm.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n    ng-if=\"SignupBaseForm.showAsModal\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span ng-if=\"!SignupBaseForm.loginSignupConfig.getSignupTitle()\">\n      Sign Up\n    </span>\n    <span ng-if=\"SignupBaseForm.loginSignupConfig.getSignupTitle()\">\n      {{SignupBaseForm.loginSignupConfig.getSignupTitle()}}\n    </span>\n  </div>\n  <div ng-if=\"!SignupBaseForm.UserData.isFacebookConnected()\">\n    <button ng-if=\"!SignupBaseForm.loginSignupConfig.isHideFb()\"\n      ng-click=\"SignupBaseForm.facebookConnect()\"\n      class=\"btn-facebook btn btn-large ModalLoginSignup-facebook-connect\"\n      data-uitest-target=\"facebook-signup-button\"\n      fl-analytics=\"FBSignup\">\n      <div class=\"ModalLoginSignup-facebook-container\">\n        <span class=\"ModalLoginSignup-facebook-icon btn-facebook-icon Icon Icon--large Icon--light\">\n            <fl-icon name=\"ui-facebook\"></fl-icon>\n        </span>\n        <div>Continue with Facebook</div>\n      </div>\n    </button>\n    <div ng-messages=\"SignupBaseForm.facebookErrors\" class=\"ModalLoginSignup-signupBaseForm-facebookErrors\">\n      <div ng-message=\"facebookLinked\" class=\"alert alert-success ModalLoginSignup-signupBaseForm-loginSuccess\">\n        <div class=\"ModalLoginSignup-signupBaseForm-loginSuccess-text\">Welcome {{SignupBaseForm.UserData.getFacebookName()}}! Logging you in.</div>\n        <div class=\"Loader Loader--small\"></div>\n      </div>\n      <div ng-message=\"emailTaken\" class=\"alert alert-info\">\n        Your Facebook email is already associated with a Freelancer account.\n        Click <a ng-click=\"SignupBaseForm.showLoginForm()\">here</a> to login.\n      </div>\n      <div ng-message=\"emailBlocked\" class=\"alert alert-error\">\n        The email domain associated with your Facebook Account is blocked. Please use a different email address.\n      </div>\n      <div ng-message=\"notAuthorized\" class=\"alert alert-error\">\n        Please authorise Freelancer to access your Facebook account in order to sign up with Facebook.\n      </div>\n      <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n        There was a problem logging in with your account. Please contact <a href=\"https://www.freelancer.com/support\">support</a>.\n      </div>\n      <div ng-message=\"unknownError\" class=\"alert alert-error\">\n        Failed to connect with Facebook. Please try again.\n      </div>\n    </div>\n    <div ng-if=\"!SignupBaseForm.loginSignupConfig.isHideFb()\" class=\"hr-divider\">\n      <span class=\"hr-divider-text\">OR</span>\n    </div>\n  </div>\n  <div ng-if=\"SignupBaseForm.UserData.isFacebookConnected()\">\n    <figure class=\"ImageThumbnail ModalLoginSignup-facebook-profileImage\">\n      <img ng-src=\"{{SignupBaseForm.UserData.user.facebookPictureUrl}}\" class=\"ImageThumbnail-image\">\n    </figure>\n    <h2 class=\"ModalLoginSignup-body-heading\">\n      Welcome {{SignupBaseForm.UserData.getFacebookName()}}!\n    </h2>\n  </div>\n  <form id=\"signup_form\" class=\"user-signup-form fl-form responsive-form ModalLoginSignup-form\"\n    name=\"SignupBaseForm.form\">\n    <fieldset class=\"ModalLoginSignup-form-fieldset\">\n      <ol>\n        <li class=\"form-step email-step\"\n          ng-class=\"{'is-invalid': SignupBaseForm.form.email.$invalid && SignupBaseForm.form.email.$dirty,\n                     'is-valid': SignupBaseForm.form.email.$valid}\">\n          <label for=\"new-email\" class=\"is-accessibly-hidden\">Email Address</label>\n          <input type=\"text\" name=\"email\" id=\"new-email\"\n            rel=\"popover\" placeholder=\"Email Address\" class=\"large-input\"\n            ng-model=\"SignupBaseForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n            ng-disabled=\"SignupBaseForm.UserData.isFacebookConnected()\n              && (SignupBaseForm.form.email.$valid || SignupBaseForm.form.email.$pending)\n              && SignupBaseForm.UserData.user.email === SignupBaseForm.UserData.getFacebookEmail()\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-blocked-email-check\n            fl-unique-email-username-check\n            fl-focus-on=\"SignupBaseForm.focusEmailInput\">\n          <div ng-if=\"SignupBaseForm.form.email.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div class=\"form-help\" id=\"new-email-suggestion\" style=\"display: none;\">\n            Did you mean <a id=\"new-email-suggestion-content\"></a>?\n          </div>\n          <div ng-messages=\"SignupBaseForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter an email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n              Please enter a valid email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"unblockedEmail\">\n              This email domain is blocked. Please use a different email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"uniqueEmail\">\n              This email address is already in use.\n            </div>\n          </div>\n        </li>\n\n        <li class=\"form-step password-step\"\n          ng-if=\"!SignupBaseForm.UserData.isFacebookConnected()\"\n          ng-class=\"{'is-invalid': SignupBaseForm.form.password.$invalid && SignupBaseForm.form.password.$dirty,\n                     'is-valid': SignupBaseForm.form.password.$valid}\">\n          <label for=\"new-password\" class=\"is-accessibly-hidden\">Password</label>\n          <input type=\"password\" id=\"new-password\" name=\"password\"\n            placeholder=\"Password\" class=\"large-input\"\n            ng-model=\"SignupBaseForm.UserData.user.password\"\n            ng-required=\"true\"\n            ng-minlength=\"6\"\n            ng-maxlength=\"150\"\n            fl-password-check>\n          <div ng-if=\"SignupBaseForm.form.password.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div ng-messages=\"SignupBaseForm.form.password.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter a password.\n            </div>\n            <div class=\"form-error\" ng-message=\"minlength\">\n              Password must be at least 6 characters.\n            </div>\n            <div class=\"form-error\" ng-message=\"maxlength\">\n              Password must be at most 150 characters.\n            </div>\n            <div class=\"form-error\" ng-message=\"uniqueFromUsername\">\n              Password must be different to username.\n            </div>\n            <div class=\"form-error\" ng-message=\"strongPassword\">\n              Password must contain lowercase and uppercase letters or a number.\n            </div>\n          </div>\n        </li>\n\n        <li id=\"coupon-step\" class=\"form-step coupon-step\" ng-if=\"SignupBaseForm.showCouponInput\">\n            <button type=\"button\" id=\"redeem_coupon\" class=\"coupon-step-toggle btn btn-plain\">\n              I have a coupon code I would like to use\n            </button>\n            <div class=\"coupon-step-inner\">\n              <label for=\"coupon\">\n                Coupon Code (Optional)\n              </label>\n              <input type=\"text\" name=\"coupon\" id=\"coupon\" value=\"{{SignupBaseForm.coupon}}\" class=\"default-input\">\n              <span class=\"help-inline\"></span>\n              <div class=\"form-error\"></div>\n            </div>\n        </li>\n\n        <input type=\"hidden\" name=\"signup_skip_captcha\" id=\"signup_skip_captcha\" value=\"{{SignupBaseForm.loginSignupConfig.getSkipCaptchaHash()}}\">\n\n        <li class=\"form-step\">\n            <button type=\"submit\" id=\"signup_btn\"\n              class=\"btn btn-info btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n              ng-click=\"SignupBaseForm.onFormSubmit($event)\"\n              fl-analytics=\"NormalSignupEmailPassword\">\n              Join Freelancer\n            </button>\n        </li>\n        <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n          By registering you confirm that you accept the\n          <a href='/about/terms' onclick='window.open(\n            \"/info/plainterms.html\",\"\",\"width=500, height=450, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n            );return false;'>\n            Terms and Conditions\n          </a>\n          and\n          <a href='/about/privacy' onclick='window.open(\n            \"/about/privacy?popup=true\",\"\",\"width=700, height=550, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n           );return false;'>\n            Privacy Policy\n          </a>\n        </small>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var flSignupBaseForm = function () {
  function flSignupBaseForm($log, $timeout, UsersService, UserData, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flSignupBaseForm);

    this.$log = $log;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.Users = UsersService;
    this.loginSignupConfig = LoginSignupConfig;

    if (this.loginSignupConfig.getEmailPrefill()) {
      this.UserData.user.email = this.loginSignupConfig.getEmailPrefill();
    }

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flSignupBaseForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }, {
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flSignupBaseForm;
}();

flSignupBaseForm.$inject = ['$log', '$timeout', 'UsersService', 'UserData', 'LoginSignupConfig'];

var flSignupBaseForm$1 = flComponent$1(flSignupBaseForm, {
  selector: 'fl-signup-base-form',
  template: signupBaseFormTemplate,
  bindings: {
    onComplete: '&',
    showLoginForm: '&',
    facebookConnect: '&',
    facebookErrors: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [ngMessages, UserData$1, UsersProvider$1, flIconProvider, flFocusOnProvider, flPasswordCheck, flBlockedEmailCheck, flEmailUsernameValidCheck$1, LoginSignupConfigProvider, flUniqueEmailUsernameCheck]
});

var accountTypeSelectorTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"AccountTypeSelector.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"AccountTypeSelector.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"AccountTypeSelector.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{AccountTypeSelector.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title\">Select account type</h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">Don’t worry, this can be changed later.</p>\n  <div ng-click=\"AccountTypeSelector.selectFreelancer()\" class=\"Card ModalLoginSignup-signupAccountType-card\" fl-analytics=\"NormalSignupFreelancer\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{AccountTypeSelector.workImageUrl}]}\" alt=\"Work Image\" />\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to work\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!AccountTypeSelector.submittingSignup || AccountTypeSelector.selectedEmployer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"AccountTypeSelector.submittingSignup && AccountTypeSelector.selectedFreelancer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n  <div ng-click=\"AccountTypeSelector.selectEmployer()\" class=\"Card ModalLoginSignup-signupAccountType-card\" fl-analytics=\"NormalSignupEmployer\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{AccountTypeSelector.hireImageUrl}]}\" alt=\"Hire Image\" />\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to hire\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!AccountTypeSelector.submittingSignup || AccountTypeSelector.selectedFreelancer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"AccountTypeSelector.submittingSignup && AccountTypeSelector.selectedEmployer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n</div>\n";

var flAccountTypeSelector = function () {
  function flAccountTypeSelector(Cdn, UserData, UsersService) {
    _classCallCheck(this, flAccountTypeSelector);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.hireImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-hire.svg');
    this.workImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-work.svg');
    this.UserData = UserData;
    this.Users = UsersService;

    // States
    this.selectedEmployer = false;
    this.selectedFreelancer = false;
  }

  _createClass(flAccountTypeSelector, [{
    key: 'selectEmployer',
    value: function selectEmployer() {
      this.UserData.user.role = USER_TYPE_EMPLOYER;
      this.selectedEmployer = true;
      this.selectedFreelancer = false;
      this.onComplete();
    }
  }, {
    key: 'selectFreelancer',
    value: function selectFreelancer() {
      this.UserData.user.role = USER_TYPE_FREELANCER;
      this.selectedFreelancer = true;
      this.selectedEmployer = false;
      this.onComplete();
    }
  }]);

  return flAccountTypeSelector;
}();

flAccountTypeSelector.$inject = ['Cdn', 'UserData', 'UsersService'];

var flAccountTypeSelector$1 = flComponent$1(flAccountTypeSelector, {
  selector: 'fl-account-type-selector',
  template: accountTypeSelectorTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1, flIconProvider]
});

var privacyConsentFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"PrivacyConsentForm.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"PrivacyConsentForm.loginSignupConfig.hide()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"PrivacyConsentForm.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{PrivacyConsentForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n <form name=\"PrivacyConsentForm.form\">\n    <h2 class=\"ModalLoginSignup-body-title\">Email Opt-In</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Would you like to receive marketing promotions, special offers, inspirations, and updates to Freelancer's product and policies? You can unsubscribe at any time.</p>\n    <div class=\"fl-form Checkbox ModalLoginSignup-privacyConsentForm-input\">\n      <input id=\"privacy-consent\" name=\"privacy-consent\"\n        class=\"Checkbox-input\" type=\"checkbox\"\n        ng-model=\"PrivacyConsentForm.UserData.user.privacyConsent\">\n      <label class=\"Checkbox-label\" for=\"privacy-consent\">\n        Yes, I want to receive emails.\n      </label>\n    </div>\n\n    <h2 class=\"ModalLoginSignup-body-title\">Account Type</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Do you intend to use Freelancer for personal use? Using Freelancer for cases other than business may be subject to additional VAT.</p>\n    <div class=\"fl-form Checkbox ModalLoginSignup-privacyConsentForm-input\">\n      <input id=\"business-user\" name=\"business-user\"\n        class=\"Checkbox-input\" type=\"checkbox\"\n        ng-model=\"PrivacyConsentForm.UserData.user.privateUser\">\n      <label class=\"Checkbox-label\" for=\"business-user\">\n        Yes, I am using Freelancer for personal use.\n      </label>\n    </div>\n\n    <button type=\"submit\"\n      class=\"btn btn-info btn-large btn-submit ModalLoginSignup-privacyConsentForm-submitBtn\"\n      ng-click=\"PrivacyConsentForm.onFormSubmit($event)\"\n      fl-analytics=\"NormalSignupPrivacyConsent\"\n      ng-disabled=\"PrivacyConsentForm.submittingSignup\">\n      <span ng-if=\"!PrivacyConsentForm.submittingSignup\">\n        Sign Up\n      </span>\n      <span ng-if=\"PrivacyConsentForm.submittingSignup\">\n        <div class=\"Loader Loader--small\"></div>\n      </span>\n    </button>\n  </form>\n</div>\n";

var flPrivacyConsentForm = function () {
  function flPrivacyConsentForm(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flPrivacyConsentForm);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
    this.UserData.user.privateUser = false;
  }

  _createClass(flPrivacyConsentForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular$1.forEach(this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }]);

  return flPrivacyConsentForm;
}();

flPrivacyConsentForm.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flPrivacyConsentForm$1 = flComponent$1(flPrivacyConsentForm, {
  selector: 'fl-privacy-consent-form',
  template: privacyConsentFormTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '='
  },
  providers: [CdnProvider, UserData$1, flIconProvider, LoginSignupConfigProvider]
});

/**
 * @ngdoc service
 * @name Captcha
 * @description
 * Captcha Service
 * TODO: Move to replace captcha.js in flAngular
 * (also need to move flRecaptcha.js which contains the directive)
 */

var Captcha = function () {
  function Captcha($q, $window, $interval, RECAPTCHA_PUBLIC_KEY) {
    _classCallCheck(this, Captcha);

    this.$q = $q;
    this.$window = $window;
    this.$interval = $interval;
    this.RECAPTCHA_PUBLIC_KEY = RECAPTCHA_PUBLIC_KEY;
    this.recaptchaLibraryLoaded = false;
  }

  _createClass(Captcha, [{
    key: 'create',
    value: function create(element, params) {
      var _this = this;

      // Assign Site Key
      params.sitekey = this.RECAPTCHA_PUBLIC_KEY;
      // Create Promise
      var deferred = this.$q.defer();
      if (this.recaptchaLibraryLoaded) {
        (function () {
          var waitForLoad = _this.$interval(function () {
            if (angular$1.isDefined(_this.$window.grecaptcha)) {
              _this.$interval.cancel(waitForLoad);
              var widgetId = _this._render(element, params);
              deferred.resolve(widgetId);
            }
          }, 100);
        })();
      } else if (!this._existsRecaptchaScript()) {
        // If recaptcha script does not exist, create it and call back to render
        this.recaptchaLibraryLoaded = true;
        // Create callback function to onRecaptchaLoad
        this.$window.onRecaptchaLoad = function () {
          var widgetId = _this._render(element, params);
          deferred.resolve(widgetId);
        };
        this._injectRecaptchaScript(element);
      } else {
        // Otherwise, call render
        var widgetId = this._render(element, params);
        deferred.resolve(widgetId);
      }
      return deferred.promise;
    }
  }, {
    key: '_render',
    value: function _render(element, params) {
      return this.$window.grecaptcha.render(element, params);
    }
  }, {
    key: '_existsRecaptchaScript',
    value: function _existsRecaptchaScript() {
      return angular$1.isDefined(this.$window.grecaptcha);
    }
  }, {
    key: '_injectRecaptchaScript',
    value: function _injectRecaptchaScript() {
      var script = angular$1.element(document.createElement('script'));
      script.attr('src', 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit');
      script.attr('async', true);
      angular$1.element(document.body).append(script);
    }
  }]);

  return Captcha;
}();

Captcha.$inject = ['$q', '$window', '$interval', 'RECAPTCHA_PUBLIC_KEY'];

var CaptchaProvider = flService$1('Captcha', [OPAQUE_MODULE_NAME], Captcha);

/**
 * @ngdoc directive
 * @name Captcha.directive:flRecaptcha
 * @restrict E
 * @description
 * Injects Google No Captcha Recaptcha
 * TODO: Move to replace this with flRecaptcha in flAngular
 * (also need to move captcha.js which contains the service)
 */

var flRecaptcha = function () {
  function flRecaptcha($window, Captcha) {
    _classCallCheck(this, flRecaptcha);

    this.$window = $window;
    this.Captcha = Captcha;
  }

  _createClass(flRecaptcha, [{
    key: 'link',
    value: function link() {
      var _this = this;

      this.widgetId = null;
      this.captchaRendered = false;
      this.Captcha.create(this.elementId, this.getParams()).then(function (widgetId) {
        _this.widgetId = widgetId;
        _this.captchaRendered = true;
      }).catch(function () {});
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      return {
        callback: this._successCallback.bind(this),
        'expired-callback': this._expiredCallback.bind(this),
        'error-callback': this._errorCallback.bind(this),
        theme: this.theme,
        type: this.type,
        size: this.size
      };
    }
  }, {
    key: '_successCallback',
    value: function _successCallback(response) {
      this.onSuccess({ response: response });
    }
  }, {
    key: '_expiredCallback',
    value: function _expiredCallback() {
      this.onExpired();
    }
  }, {
    key: '_errorCallback',
    value: function _errorCallback() {
      this.onError();
    }
  }]);

  return flRecaptcha;
}();

flRecaptcha.$inject = ['$window', 'Captcha'];

var flRecaptcha$1 = flDirective$1(flRecaptcha, {
  selector: 'fl-recaptcha',
  template: '<div id="{{Recaptcha.elementId}}"></div><div class="Loader" ng-if="!Recaptcha.captchaRendered"></div>',
  restrict: 'E',
  scope: {
    elementId: '@',
    theme: '@',
    type: '@',
    size: '@',
    onSuccess: '&',
    onExpired: '&',
    onError: '&'
  },
  providers: [CaptchaProvider]
});

var captchaFormTemplate = "<div class=\"Modal-header\">\n  <button type=\"button\" class=\"Modal-close\" type=\"button\"\n    aria-label=\"Close this modal window\" ng-click=\"CaptchaForm.closeModal($event)\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n    <img ng-src=\"{[{CaptchaForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <h2 class=\"ModalLoginSignup-body-heading\">You're almost there!</h2>\n  <div class=\"ModalLoginSignup-captchaForm-recaptcha\">\n    <fl-recaptcha element-id=\"SignupCaptcha\"\n      on-success=\"CaptchaForm.onVerifyCaptcha(response)\"\n      on-expired=\"CaptchaForm.onExpiredCaptcha()\">\n    </fl-recaptcha>\n  </div>\n  <div ng-if=\"CaptchaForm.showError\" class=\"alert alert-error ModalLoginSignup-captchaForm-error\">\n    You must click the I'm not a robot checkbox.\n  </div>\n  <button class=\"btn btn-large btn-info ModalLoginSignup-captchaForm-submit\"\n    ng-click=\"CaptchaForm.onSubmit()\"\n    ng-disabled=\"CaptchaForm.submittingSignup\">\n    <span ng-if=\"!CaptchaForm.submittingSignup\">\n      Join Freelancer\n    </span>\n    <span ng-if=\"CaptchaForm.submittingSignup\">\n      <div class=\"Loader Loader--small\"></div>\n    </span>\n  </button>\n</div>\n";

var flCaptchaForm = function () {
  function flCaptchaForm(Cdn, UserData) {
    _classCallCheck(this, flCaptchaForm);

    this.UserData = UserData;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.showError = false;
    this.isSubmitting = false;
    this.verifiedCaptcha = false;
  }

  _createClass(flCaptchaForm, [{
    key: 'onExpiredCaptcha',
    value: function onExpiredCaptcha() {
      this.verifiedCaptcha = false;
      this.UserData.user.captcha.response = '';
    }
  }, {
    key: 'onVerifyCaptcha',
    value: function onVerifyCaptcha(response) {
      if (!response) {
        return;
      }
      this.verifiedCaptcha = true;
      this.showError = false;
      this.UserData.user.captcha.response = response;
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      this.isSubmitting = true;
      if (this.verifiedCaptcha !== true) {
        this.showError = true;
        this.isSubmitting = false;
        return;
      }
      this.showError = false;
      this.onComplete();
    }
  }, {
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flCaptchaForm;
}();

flCaptchaForm.$inject = ['Cdn', 'UserData'];

var flCaptchaForm$1 = flComponent$1(flCaptchaForm, {
  selector: 'fl-captcha-form',
  template: captchaFormTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [UserData$1, CdnProvider, flIconProvider, flRecaptcha$1]
});

var signupSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\" ng-click=\"SignupSuccess.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"SignupSuccess.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{SignupSuccess.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-signupSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Signup Success!</h2>\n    <div ng-if=\"SignupSuccess.loginSignupConfig.getSignupSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">{{SignupSuccess.loginSignupConfig.getSignupSuccessMessage()}}</p>\n    </div>\n    <div ng-if=\"!SignupSuccess.loginSignupConfig.getSignupSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    </div>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flSignupSuccess = function () {
  function flSignupSuccess(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flSignupSuccess);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flSignupSuccess, [{
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flSignupSuccess;
}();

flSignupSuccess.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flSignupSuccess$1 = flComponent$1(flSignupSuccess, {
  selector: 'fl-signup-success',
  template: signupSuccessTemplate,
  bindings: { closeModal: '&' },
  providers: [CdnProvider, UserData$1, LoginSignupConfigProvider]
});

var signupTemplate = "<fl-signup-base-form\n  ng-if=\"Signup.currentStep === Signup.steps.BASE_STEP\"\n  on-complete=\"Signup.onCompleteBaseForm()\"\n  facebook-connect=\"Signup.facebookConnect()\"\n  facebook-errors=\"Signup.error.facebook\"\n  show-login-form=\"Signup.gotoLogin()\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-signup-base-form>\n<fl-username-input\n  ng-if=\"Signup.currentStep === Signup.steps.USERNAME_STEP\"\n  username-suggestions=\"Signup.usernameSuggestions\"\n  on-cancel=\"Signup.currentStep = Signup.steps.BASE_STEP\"\n  on-complete=\"Signup.onCompleteUsernameStep()\"\n  show-as-modal=\"Signup.showAsModal\"\n  is-submitting=Signup.isSubmitting\n  close-modal=\"Signup.closeModal($event)\">\n</fl-username-input>\n<fl-account-type-selector\n  ng-if=\"Signup.currentStep === Signup.steps.ACCOUNT_TYPE_STEP\"\n  on-cancel=\"Signup.currentStep = Signup.steps.USERNAME_STEP\"\n  on-complete=\"Signup.onCompleteAccountTypeStep()\"\n  submitting-signup=\"Signup.isSubmitting\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-account-type-selector>\n<fl-privacy-consent-form\n  ng-if=\"Signup.currentStep === Signup.steps.PRIVACY_CONSENT_STEP\"\n  on-cancel=\"Signup.currentStep = Signup.steps.ACCOUNT_TYPE_STEP\"\n  on-complete=\"Signup.onCompletePrivacyStep()\"\n  submitting-signup=\"Signup.isSubmitting\">\n</fl-privacy-consent-form>\n<fl-captcha-form\n  ng-if=\"Signup.currentStep === Signup.steps.CAPTCHA_STEP\"\n  on-complete=\"Signup.onCompleteCaptchaStep(response)\"\n  submitting-signup=\"Signup.isSubmitting\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-captcha-form>\n<fl-signup-success\n  ng-if=\"Signup.currentStep === Signup.steps.SUCCESS_STEP\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-signup-success>\n<div class=\"Modal-footer\">\n  <div ng-messages=\"Signup.error\">\n    <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n      There was a problem logging in with your account. Please contact <a href=\"https://www.freelancer.com/support\">support</a>.\n    </div>\n    <div ng-message=\"internalError\" class=\"alert alert-error\">\n      Something went wrong. Please try again.\n    </div>\n  </div>\n  <div ng-if=\"Signup.loginSignupConfig.showLoginOption() && Signup.currentStep === Signup.steps.BASE_STEP\"\n    class=\"ModalLoginSignup-switchLoginSignupType\">\n    Already have an account?\n    <a ng-click=\"Signup.gotoLogin()\" class=\"ModalLoginSignup--switchToLogin-link\">\n      Log In\n    </a>\n  </div>\n</div>\n";

/**
 * @ngdoc controller
 * @name LoginSignupApp.flSignup
 * @description
 * Handles the Signup Flow which consists of several steps:
 * 1. Email and Password Step (signup-base-form)
 * 2. Username Step (username-input)
 * 3. Account Type Step (account-type-selector)
 */

var flSignup = function () {
  function flSignup($window, $rootScope, Auth, Analytics, Cdn, CookieStore, Facebook, LoginSignupConfig, UserData, Users, UsersService) {
    var _this = this;

    _classCallCheck(this, flSignup);

    this.$window = $window;
    this.$rootScope = $rootScope;
    this.isSubmitting = false;
    this.Auth = Auth;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.Facebook = Facebook;
    this.Analytics = Analytics;
    this.Cdn = Cdn;
    this.CookieStore = CookieStore;
    this.loginSignupConfig = LoginSignupConfig;
    // Form
    this.error = {};
    this.steps = SIGNUP_STEPS;
    this.currentStep = this.steps.BASE_STEP;
    this.usernameSuggestions = [];
    this.referralSignupCookieKey = REFERRAL_SIGNUP_COOKIE_KEY;

    // Initialise User Object
    this.UserData.user.isNewUser = true;

    // Watch for Signup/Login switches, and auto connect facebook
    this.watchShowSignup = $rootScope.$watch(function () {
      return _this.loginSignupConfig.options.showSignup;
    }, function (newValue) {
      // If Show Signup was set to true, try auto connect facebook
      if (newValue === true && _this.UserData.isFacebookConnected()) {
        _this.facebookConnect(true, false);
      }
    });
  }

  /**
   * @ngdoc method
   * @name LoginSignupApp.flSignup#gotoLogin
   * @methodOf LoginSignupApp.flSignup
   * @description
   * Switches to Login funnel by:
   * Setting the rootscope variable to false in order for flLogin to be displayed.
   */

  _createClass(flSignup, [{
    key: 'gotoLogin',
    value: function gotoLogin() {
      // Clear Errors
      this.clearErrors();
      // Disconnect Facebook if Connected (stops Login from auto logging same
      // facebook account, and redirecting back to signup if it is a new account)
      this.UserData.setFacebookConnected(false);
      this.loginSignupConfig.switchToLogin();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteBaseForm
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the base form.
     * Generates suggested usernames and activates to step 2, which is username input.
     */

  }, {
    key: 'onCompleteBaseForm',
    value: function onCompleteBaseForm() {
      this.clearErrors();
      this.generateSuggestedUsernames();
      this.currentStep = this.steps.USERNAME_STEP;
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteUsernameStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the username input step.
     * Activates step 3 which is account type selector.
     */

  }, {
    key: 'onCompleteUsernameStep',
    value: function onCompleteUsernameStep() {
      this.clearErrors();
      // Check whether we can skip the Select Account Type Step.
      if (this.loginSignupConfig.getForcedAccountType() === USER_TYPE_FREELANCER) {
        this.UserData.user.role = USER_TYPE_FREELANCER;
        this.onCompleteAccountTypeStep();
      } else if (this.loginSignupConfig.getForcedAccountType() === USER_TYPE_EMPLOYER) {
        this.UserData.user.role = USER_TYPE_EMPLOYER;
        this.onCompleteAccountTypeStep();
      } else {
        this.currentStep = this.steps.ACCOUNT_TYPE_STEP;
      }
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteAccountTypeStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the account type selector step.
     *
     * Show Privacy Consent Form as next step for EU Users.
     * Default Privacy Consent to true for Non EU Users.
     */

  }, {
    key: 'onCompleteAccountTypeStep',
    value: function onCompleteAccountTypeStep() {
      this.clearErrors();

      var fromEU = this.CookieStore.get(IS_FROM_EU_COOKIE_KEY);
      if (fromEU === 'true') {
        this.UserData.user.isFromEU = true;
        this.UserData.user.privacyConsent = false;
      } else {
        this.UserData.user.isFromEU = false;
        this.UserData.user.privacyConsent = true;
      }
      // If User is from EU, show Privacy Step.
      if (this.UserData.user.isFromEU) {
        this.currentStep = this.steps.PRIVACY_CONSENT_STEP;
        return;
      }

      // Otherwise: Normal Signup Flow (default Privacy Consent to true)
      this.UserData.user.privacyConsent = true;
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompletePrivacyStep
     * @description
     * Call back for when user successfully completes the privacy step.
     */

  }, {
    key: 'onCompletePrivacyStep',
    value: function onCompletePrivacyStep() {
      this.clearErrors();
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteCaptchaStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the captcha step.
     */

  }, {
    key: 'onCompleteCaptchaStep',
    value: function onCompleteCaptchaStep() {
      this.clearErrors();
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onSignupSuccessStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Show Message whilst satisfying any redirects and callbacks.
     */

  }, {
    key: 'onSignupSuccessStep',
    value: function onSignupSuccessStep() {
      var source = this.UserData.isFacebookConnected() ? 'facebook' : 'normal';
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'OnSignup',
        name: 'success',
        value: source
      });

      this.clearErrors();
      // If Redirect is not disabled, show success step while user is being
      // redirected. Otherwise, keep window open until signup is successful.
      if (!this.loginSignupConfig.isRedirectDisabled()) {
        this.currentStep = this.steps.SUCCESS_STEP;
      }
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#facebookConnect
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Connects to the User's Facebook Account, and stores the user's facebook profile
     * information in UserData.
     */

  }, {
    key: 'facebookConnect',
    value: function facebookConnect(skipLogin, retry) {
      var _this2 = this;

      // Clear Errors and define facebook error
      this.clearErrors();
      this.error.facebook = {};
      var authParamsPromise = void 0;
      // 1. Get Facebook auth params
      // If we come from Facebook login, we need to skip the login
      // step otherwise the popup will be blocked!
      if (!skipLogin) {
        authParamsPromise = this.Facebook.login();
      } else {
        authParamsPromise = this.Facebook.checkConnected().catch(function () {});
      }
      authParamsPromise.then(function (facebookAuthParams) {
        // 2. Get Facebook user infos
        _this2.UserData.setFacebookUserId(facebookAuthParams.userID);
        _this2.UserData.setFacebookAccessToken(facebookAuthParams.accessToken);
        _this2.UserData.user.facebookSignedRequest = facebookAuthParams.signedRequest;
        return _this2.Facebook.getUser();
      }).then(function (facebookUser) {
        _this2.UserData.setFacebookEmail(facebookUser.email);
        _this2.UserData.setFacebookName(facebookUser.first_name);

        // 3. Try to login to see if the facebook account is linked
        _this2.UsersService.loginWithFacebook(_this2.UserData.user).then(function (response) {
          if (response.data) {
            _this2.error.facebook.facebookLinked = true;
            _this2.Analytics.trackAction('facebook', 'login', 'SUCCESS');
            _this2.loginSuccess = true;
            _this2.$window.requestAnimationFrame(function () {
              _this2.onLoginSuccess({
                rememberLogin: false
              });
            });
          }
        }).catch(function () {
          if (_this2.loginSuccess) {
            return;
          }
          // 3. Check if user is registered
          _this2.Users.check({ email: _this2.UserData.user.facebookEmail }).then(function () {
            // User's Email is not taken. Must be new user.
            _this2.UserData.user.isNewUser = false;
            var url = _this2.Facebook.getUserPictureUrl(60, 60);
            if (url) {
              return url;
            }
            return _this2.Cdn.getCdnUrl('/img/unknown.png');
          }).then(function (facebookPictureUrl) {
            // 5. Display relevant form to continue facebook signup
            _this2.UserData.user.email = _this2.UserData.getFacebookEmail();
            _this2.UserData.setFacebookPictureUrl(facebookPictureUrl);
            _this2.UserData.setFacebookConnected(true);
            // Show Base Step
            _this2.currentStep = _this2.steps.BASE_STEP;
          }).catch(function (error) {
            if (error.code === 'EMAIL_TAKEN') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.emailTaken = true;
            } else if (error.code === 'EMAIL_BLOCKED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.emailBlocked = true;
            } else if (error.code === 'NOT_AUTHORISED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.notAuthorized = true;
            } else if (error.code === 'ACCESS_DENIED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.accessDenied = true;
            } else if (error.code === 'NOT_CONNECTED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              if (retry) {
                _this2.facebookConnect();
              } else {
                _this2.error.facebook.notConnected = true;
              }
            } else {
              _this2.Analytics.trackError('facebook', 'signup', error.code, error.data);
              _this2.error.facebook.unknownError = true;
            }
          });
        });
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#tryFacebookSignup
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Attempts to Signup User through Facebook, using info stored in UserData.user
     */

  }, {
    key: 'tryFacebookSignup',
    value: function tryFacebookSignup() {
      var _this3 = this;

      if (this.isSubmitting === true) {
        return;
      }
      this.error = {};
      this.isSubmitting = true;
      this.Users.createWithFacebook(this.UserData.user, {
        userID: this.UserData.getFacebookUserId(),
        accessToken: this.UserData.getFacebookAccessToken()
      }, this.getAllExtraData()).then(function () {
        _this3.Analytics.trackAction('facebook', 'signup', 'SUCCESS');
        Tracking.trackCustomEvent('User Sign Up', 'Sign Up Form', {
          account_type: _this3.UserData.user.role
        });
        _this3.onSignupSuccessStep();
        _this3.removeExtraDataFromCookie();
        _this3.UsersService.setExtraCookies();
      }).then(function () {
        return _this3.UsersService.crossDomainSSO({
          data: {
            token: _this3.Auth.getAccessToken(),
            user: _this3.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          // Resolve LoginSignupConfig Callback first, before resolving then
          // going through any redirects.
          if (_this3.UserData.user.role === USER_TYPE_FREELANCER) {
            _this3.loginSignupConfig.resolveAuth(_this3.loginSignupConfig.authMessages.SIGNUP_FREELANCER);
          } else {
            _this3.loginSignupConfig.resolveAuth(_this3.loginSignupConfig.authMessages.SIGNUP_EMPLOYER);
          }
          resolve();
        }).then(function () {
          _this3.onSignupSuccessRedirect();
        });
      }).catch(function (error) {
        if (error.code === 'ACCESS_DENIED') {
          _this3.error.accessDenied = true;
        } else {
          _this3.error.internalError = true;
        }
        qtsp.push({
          section: _this3.loginSignupConfig.getPageName(),
          sub_section: 'LoginSignup',
          label: 'OnSignup',
          name: 'facebook_failure',
          value: error.code
        });

        _this3.isSubmitting = false;
      });
    }
  }, {
    key: 'removeExtraDataFromCookie',
    value: function removeExtraDataFromCookie() {
      this.CookieStore.remove(this.referralSignupCookieKey);
    }
  }, {
    key: 'getAllExtraData',
    value: function getAllExtraData() {
      var extraData = {};

      // Referral Signup
      var cookieData = this.CookieStore.get(REFERRAL_SIGNUP_COOKIE_KEY);
      if (cookieData) {
        extraData[REFERRAL_SIGNUP_COOKIE_KEY] = cookieData;
      }

      // VAT Business/Individual User, only set the business_user if the option
      // is shown to the user.
      if (this.UserData.user.privateUser !== null) {
        extraData[BUSINESS_USER_KEY] = !this.UserData.user.privateUser ? 'true' : 'false';
      }

      if (this.loginSignupConfig.getProjectCollaborationInvitation() !== '') {
        extraData[PROJECT_COLLABORATION_INVITATION_KEY] = this.loginSignupConfig.getProjectCollaborationInvitation();
      }

      if (this.loginSignupConfig.getContestCollaborationInvitation() !== '') {
        extraData[CONTEST_COLLABORATION_INVITATION_KEY] = this.loginSignupConfig.getContestCollaborationInvitation();
      }

      return extraData;
    }
  }, {
    key: 'getSignupMetaData',
    value: function getSignupMetaData() {
      return _defineProperty({}, PRIVACY_CONSENT_KEY, !!this.UserData.user.privacyConsent);
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#tryUserSignup
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Attempts to Signup the user, using info stored in UserData.user
     */

  }, {
    key: 'tryUserSignup',
    value: function tryUserSignup() {
      var _this4 = this;

      if (this.isSubmitting === true) {
        return;
      }
      this.isSubmitting = true;
      this.error = {};
      this.Users.create(this.UserData.user, this.UserData.user.password, this.UserData.user.captcha, this.getAllExtraData(), this.getSignupMetaData()).then(function () {
        _this4.Analytics.trackAction('user', 'signup', 'SUCCESS');
        Tracking.trackCustomEvent('User Sign Up', 'Sign Up Form', {
          account_type: _this4.UserData.user.role
        });
        _this4.onSignupSuccessStep();
        _this4.removeExtraDataFromCookie();
        _this4.UsersService.setExtraCookies();
      }).then(function () {
        return _this4.UsersService.crossDomainSSO({
          data: {
            token: _this4.Auth.getAccessToken(),
            user: _this4.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          // Resolve LoginSignupConfig Callback first, before resolving then
          // going through any redirects.
          if (_this4.UserData.user.role === USER_TYPE_FREELANCER) {
            _this4.loginSignupConfig.resolveAuth(_this4.loginSignupConfig.authMessages.SIGNUP_FREELANCER);
          } else {
            _this4.loginSignupConfig.resolveAuth(_this4.loginSignupConfig.authMessages.SIGNUP_EMPLOYER);
          }
          resolve();
        }).then(function () {
          _this4.onSignupSuccessRedirect();

          // Close the modal only if there is no redirects
          if (_this4.loginSignupConfig.isRedirectDisabled()) {
            _this4.closeModal();
          }
        });
      }).catch(function (error) {
        if (error.code === 'CAPTCHA_REQUIRED') {
          _this4.UserData.user.captcha.challenge = error.data.request_id;
          _this4.currentStep = _this4.steps.CAPTCHA_STEP;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        } else if (error.code === 'ACCESS_DENIED') {
          _this4.error.accessDenied = true;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        } else {
          _this4.error.internalError = true;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        }
        qtsp.push({
          section: _this4.loginSignupConfig.getPageName(),
          sub_section: 'LoginSignup',
          label: 'OnSignup',
          name: 'failure',
          value: error.code
        });

        _this4.isSubmitting = false;
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onSignupSuccessRedirect
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Handles redirects on signup success (for both normal and facebook)
     * Currently happens after the Auth Promise has been resolved, and any call
     * backs related to Auth Promise (LoginSignupConfig) has been called.
     */

  }, {
    key: 'onSignupSuccessRedirect',
    value: function onSignupSuccessRedirect() {
      var _this5 = this;

      this.UsersService.getSignupRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl(), this.loginSignupConfig.getProjectCollaborationInvitation(), this.loginSignupConfig.getContestCollaborationInvitation()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;

          if (redirectUrl === 'reload') {
            _this5.$window.location.reload();
          } else if (redirectUrl !== '') {
            if (!redirectUrl.includes('?')) {
              redirectUrl = redirectUrl + '?';
            }

            _this5.$window.location.href = redirectUrl + '&new_signup=true';
          }
        }
      }).catch(function () {
        if (_this5.UserData.user.role === USER_TYPE_FREELANCER) {
          _this5.$window.location.href = '/new-freelancer';
        } else {
          _this5.$window.location.href = '/post-project?onboard=true';
        }
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#generateSuggestedUsernames
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Gets suggested usernames for the current email stored in UserData.
     * Is linked to the username-input component where it is then displayed.
     */

  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this6 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this6.usernameSuggestions = [];
        _this6.usernameSuggestions.push(result.recommended_name);
        _this6.usernameSuggestions = _this6.usernameSuggestions.concat(result.alternate_names);
      }).catch(function (error) {
        _this6.Analytics.trackError('suggestUsernames', 'signup', error.error_code);
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#clearErrors
     * @methodOf LoginSignupApp
     * @description
     * Clears all errors.
     */

  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.error = {};
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#clearErrors
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Gets any errors currently set.
     */

  }, {
    key: 'getErrors',
    value: function getErrors() {
      return this.error;
    }
  }]);

  return flSignup;
}();

flSignup.$inject = ['$window', '$rootScope', 'Auth', 'Analytics', 'Cdn', 'CookieStore', 'Facebook', 'LoginSignupConfig', 'UserData', 'Users', 'UsersService'];

var flSignup$1 = flComponent$1(flSignup, {
  selector: 'fl-signup',
  template: signupTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&'
  },
  providers: [AuthModule, UserData$1, UsersProvider$1, UsersProvider, CookieStoreProvider$1, FacebookProvider$1, AnalyticsModule, flCaptchaForm$1, flSignupSuccess$1, flUsernameInput$1, flSignupBaseForm$1, flPrivacyConsentForm$1, flAccountTypeSelector$1, flIconProvider, flPasswordCheck, flBlockedEmailCheck, CdnProvider, LoginSignupConfigProvider]
});

var template$17 = "<div ng-if=\"!LoginSignupModal.loginSignupConfig.isModal()\" class=\"Modal Modal--small\">\n  <div class=\"Modal-inner ModalLoginSignup-inner ModalLoginSignup--asPage\"\n    aria-hidden=\"false\" data-keyboard=\"false\" data-backdrop=\"static\">\n    <div class=\"Modal-dialog\"\n      ng-if=\"!(LoginSignupModal.enterprise === 'arrow')\"\n      role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n          <fl-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n            on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\">\n          </fl-signup>\n          <fl-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n            on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\"\n            current-step=\"LoginSignupModal.currentLoginStep\">\n          </fl-login>\n      </div>\n      <fl-app-links\n        ng-if=\"LoginSignupModal.loginSignupConfig.showAppLinks() && !LoginSignupModal.loginSignupConfig.options.showSignup\">\n      </fl-app-links>\n    </div>\n    <div class=\"Modal-dialog\"\n      ng-if=\"LoginSignupModal.enterprise === 'arrow'\"\n      role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <fl-arrow-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\"\n        ></fl-arrow-signup>\n        <fl-arrow-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\"\n        ></fl-arrow-login>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"LoginSignupModal.loginSignupConfig.isModal()\">\n  <div ng-if=\"!(LoginSignupModal.enterprise === 'arrow')\">\n    <fl-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\" on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\">\n    </fl-signup>\n    <fl-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\" on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\"\n      current-step=\"LoginSignupModal.currentLoginStep\">\n    </fl-login>\n  </div>\n  <div ng-if=\"LoginSignupModal.enterprise === 'arrow'\">\n    <fl-arrow-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\"\n    ></fl-arrow-signup>\n    <fl-arrow-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\"\n      show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n      close-modal=\"LoginSignupModal.closeModal()\"\n    ></fl-arrow-login>\n  </div>\n</div>\n";

var LoginSignupModal = function () {
  function LoginSignupModal($rootScope, $window, CorporateService, LoginSignupConfig, UsersService) {
    _classCallCheck(this, LoginSignupModal);

    this.$rootScope = $rootScope;
    this.$window = $window;
    this.Corporate = CorporateService;
    this.UsersService = UsersService;
    this.loginSignupConfig = LoginSignupConfig;
    this.loginSteps = LOGIN_STEPS;
    this.currentLoginStep = LOGIN_STEPS.LOGIN_FORM;
    this.enterprise = enterprise;
  }

  _createClass(LoginSignupModal, [{
    key: 'loginUrlRedirect',
    value: function loginUrlRedirect(forceRedirectUrl) {
      var _this = this;

      if (forceRedirectUrl) {
        this.$window.location.href = forceRedirectUrl;
        return;
      }

      this.UsersService.getLoginRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;
          if (redirectUrl === 'reload') {
            _this.$window.location.replace(_this.removeWebappRelatedUrlParameters(_this.$window.location.href));
          } else if (redirectUrl !== '') {
            _this.$window.location.href = redirectUrl;
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard/';
      });
    }
  }, {
    key: 'removeWebappRelatedUrlParameters',
    value: function removeWebappRelatedUrlParameters(url) {
      var urlProcessed = new URL(url);
      urlProcessed.searchParams.delete('w');
      urlProcessed.searchParams.delete('ngsw-bypass');
      return urlProcessed.toString();
    }

    /**
     * @ngdoc method
     * @description
     * Resolves the Auth Promise in LoginSignupConfig, waits for any code linked
     * to that to complete, then resolves and deals with redirects.
     *
     * Not placed in flLogin.js because flSignup.js also needs access to this,
     * as it is possible to login via facebook on the Signup module.
     */

  }, {
    key: 'onLoginSuccess',
    value: function onLoginSuccess(rememberLogin, forceRedirectUrl) {
      var _this2 = this;

      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'OnLogin',
        name: 'success'
      });

      // Set Login Step as Success Step
      // This is done here instead of flLogin because flSignup can call this too.
      if (this.loginSignupConfig.isRedirectDisabled()) {
        this.loginSignupConfig.hide();
      } else {
        this.currentLoginStep = this.loginSteps.LOGIN_SUCCESS;
      }

      return new Promise(function (resolve) {
        // Login Signup Config Callbacks
        _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
        resolve();
      }).then(function () {
        if (!_this2.Corporate.checkCorporate()) {
          _this2.loginUrlRedirect(forceRedirectUrl);
          return;
        }
        _this2.Corporate.swapAccount(rememberLogin).then(_this2.loginUrlRedirect(forceRedirectUrl));
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.loginSignupConfig.hide();
    }
  }]);

  return LoginSignupModal;
}();

LoginSignupModal.$inject = ['$rootScope', '$window', 'CorporateService', 'LoginSignupConfig', 'UsersService'];

var flLoginSignupModal = flComponent$1(LoginSignupModal, {
  selector: 'fl-login-signup-modal',
  template: template$17,
  providers: [ngRoute, flArrowLogin$1, flArrowSignup$1, flLogin$1, flSignup$1, flAppLinks$1, flIconProvider, UsersProvider$1, UsersProvider$1, CorporateProvider, UserData$1, LoginSignupConfigProvider]
});

var template$18 = "<fl-login-signup-modal ng-if=\"!LoginSignupAngular.loginSignupConfig.isModal()\"\n></fl-login-signup-modal>\n\n<fl-ui-modal ng-if=\"LoginSignupAngular.loginSignupConfig.options.showAppLinks && LoginSignupAngular.loginSignupConfig.isModal() && LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-selector=\"'fl-login-signup-modal'\"\n    modal-visible=\"LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-props=\"{ classes: 'Modal--small', disableBackdropClose: LoginSignupAngular.loginSignupConfig.isDisableBackdropClose() }\"\n    modal-shadow-footer-selector=\"LoginSignupAngular.enterprise ? undefined : 'fl-app-links'\"\n    class=\"pinky-template\"\n></fl-ui-modal>\n\n<fl-ui-modal ng-if=\"!LoginSignupAngular.loginSignupConfig.options.showAppLinks && LoginSignupAngular.loginSignupConfig.isModal() && LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-selector=\"'fl-login-signup-modal'\"\n    modal-visible=\"LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-props=\"{ classes: 'Modal--small', disableBackdropClose: LoginSignupAngular.loginSignupConfig.isDisableBackdropClose() }\"\n    class=\"pinky-template\"\n></fl-ui-modal>\n\n\n<a ng-if=\"LoginSignupAngular.showLoginButton\"\n    ng-click=\"LoginSignupAngular.showLoginModal($event)\"\n    class=\"LoginSection-btn\" href=\"/login\" rel=\"nofollow\"\n    ng-class=\"{'LoginSection-btn--arrow' : LoginSignupAngular.enterprise === 'arrow'}\"\n    data-uitest-target=\"login-button\"\n    data-qtsb-section=\"NavBar\"\n    data-qtsb-label=\"ShowLoginSplash\">Log In</a>\n\n<a ng-if=\"LoginSignupAngular.showSignupButton\"\n    ng-click=\"LoginSignupAngular.showSignupModal($event)\"\n    class=\"LoginSection-btn\" href=\"/signup\" rel=\"nofollow\"\n    ng-class=\"{'LoginSection-btn--arrow' : LoginSignupAngular.enterprise === 'arrow'}\"\n    data-uitest-target=\"signup-button\"\n    data-qtsb-section=\"NavBar\"\n    data-qtsb-label=\"ShowHireSignupSplash\">Sign Up</a>\n";

var LoginSignupApp = function () {
  function LoginSignupApp(LoginSignupConfig) {
    _classCallCheck(this, LoginSignupApp);

    this.loginSignupConfig = LoginSignupConfig;
    this.enterprise = enterprise;
    this.modalProps = {
      classes: 'Modal--small',
      disableBackdropClose: this.loginSignupConfig.isDisableBackdropClose()
    };
  }

  _createClass(LoginSignupApp, [{
    key: 'showArrowLoginSignUpModal',
    value: function showArrowLoginSignUpModal(formName) {
      var afterCloseCallback = function afterCloseCallback(authUid) {
        // Login signup modal will return the user id of the authenticated user
        // as the result if successful
        if (authUid) {
          window.location.reload();
        }
      };
      webappModals.open('ArrowLoginSignupModalComponent', {
        inputs: {
          form: formName
        },
        size: 'xsmall',
        edgeToEdge: true,
        closeable: true
      }, afterCloseCallback);
    }
  }, {
    key: 'showSignupModal',
    value: function showSignupModal($event) {
      $event.preventDefault();
      if (this.enterprise === 'arrow') {
        this.showArrowLoginSignUpModal('signup');
      } else {
        this.loginSignupConfig.showSignup().catch(function () {});
      }
    }
  }, {
    key: 'showLoginModal',
    value: function showLoginModal($event) {
      $event.preventDefault();
      if (this.enterprise === 'arrow') {
        this.showArrowLoginSignUpModal('login');
      } else {
        this.loginSignupConfig.showLogin().catch(function () {});
      }
    }
  }]);

  return LoginSignupApp;
}();

LoginSignupApp.$inject = ['LoginSignupConfig'];
LoginSignupApp.$inject = ['LoginSignupConfig'];

function getUrlParameter(param) {
  var pageURL = decodeURIComponent(window.location.search.substring(1));
  var urlVariables = pageURL.split('&');
  var parameterName = void 0;
  var i = void 0;
  for (i = 0; i < urlVariables.length; i++) {
    parameterName = urlVariables[i].split('=');

    if (parameterName[0] === param) {
      return parameterName[1];
    }
  }
}

var skipCaptchaHash = typeof getUrlParameter('secured_connection') !== 'undefined' ? getUrlParameter('secured_connection') : '';

/**
 * Component for Angular Apps
 * Import with LoginSignupConfigProvider, for example usage see flWizardForm
 */
var LoginSignupComponent = flComponent$1(LoginSignupApp, {
  selector: 'fl-login-signup-angular',
  template: template$18,
  bindings: {
    showLoginButton: '=',
    showSignupButton: '='
  },
  providers: [
  // Component
  flLoginSignupModal, flIconProvider, flUiModalProvider, flAppLinks$1,

  // Service
  UsersProvider$1, UserData$1, AuthModule, LoginSignupConfigProvider]
});

var paymentsSourceTemplate = "<div class=\"payment-from\">\n    <div class=\"need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('You will be directed to the deposit page to make this payment.') %>\n    </div>\n    <div class=\"may-need-deposit payment-from-option\" style=\"display:none\">\n        <%- T_('This will be debited from your available account balances, then if required, you will be directed to the deposit page to make this payment:') %>\n    </div>\n    <div class='form-only-balance only-balance payment-from-option' style=\"display:none\">\n        <%- T_('This will be debited from your available account balances:') %>\n    </div>\n    <% if (templateData.firstAvailablePaymentMethod) { %>\n        <div class=\"only-vpm payment-from-option\" style=\"display:none\">\n            <% if (templateData.verifiedPaymentSourceCount == 1) { %>\n                <%- T_('This will be debited from your verified payment method.') %>\n            <% } else { %>\n                <%- T_('This will be debited from your verified payment methods.') %>\n            <% } %>\n            <% if (templateData.showWireTransferLink) { %>\n                <%= T_(' If you prefer to pay by wire deposit, please click <a class=\"handover-wire-transfer-link\">here</a>') %>\n            <% } %>\n        </div>\n        <div class=\"mixed-balance-vpm payment-from-option\" style=\"display:none\">\n            <% if (templateData.verifiedPaymentSourceCount == 1) { %>\n                <%- T_('This will be debited from your available balances, then if required we will attempt to process this payment from your verified payment method:') %>\n            <% } else { %>\n                <%- T_('This will be debited from your available balances, then if required we will attempt to process this payment from your verified payment methods:') %>\n            <% } %>\n        </div>\n    <% } %>\n    <p class=\"form-account-balance account-balances\" style=\"display:none\">\n        <strong><%- T_('Account Balance:') %></strong>\n        <% if (templateData.balances) { %>\n            <% for (var i = 0; i < templateData.balances.length; i++) { %>\n                <%- templateData.balances[i].currency.sign %><%- templateData.balances[i].balance.toFixed(2) %> <%- templateData.balances[i].currency.code %><%- (i == templateData.balances.length - 1) ? '' : ',' %>\n            <% } %>\n        <% } %>\n    </p>\n</div>\n<% if (templateData.firstAvailablePaymentMethod) { %>\n    <div class=\"payment-logos-container\" style=\"display:none\">\n        <h6>\n            <%- T_('Verified payment method:') %>\n        </h6>\n\n        <img src=\"<%= cdn_url('/img/ajax-loader.gif') %>\" class=\"loading-img-change-preferred-method margin-r20\" style=\"display:none\" />\n        <div class=\"payment-logo-container paypal gatewayPP\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayPP') { %> style=\"display:none\" <% } %>>\n            <span class=\"payment-icon-paypal\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container cc gatewayGC gatewayWP gatewayNAB gatewayAdyen\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayGC' && templateData.firstAvailablePaymentMethod != 'gatewayWP' && templateData.firstAvailablePaymentMethod != 'gatewayNAB' && templateData.firstAvailablePaymentMethod != 'gatewayAdyen') { %> style=\"display:none\" <% } %>>\n            <span class=\"payment-icon-mastercard\"></span>\n            <span class=\"payment-icon-amex\"></span>\n            <span class=\"payment-icon-visa\"></span>\n            <div class=\"clear\"></div>\n        </div>\n        <div class=\"payment-logo-container skrill gatewayMB\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayMB') { %> style=\"display:none\" <% } %>>\n            <span class=\"payment-icon-skrill\"></span>\n        </div>\n        <div class=\"PaymentMethodSettings\">\n            <span class=\"showing-method-account-details gatewayPP\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayPP') { %> style=\"display:none\" <% } %>>\n                <% if (templateData.paymentMethods.ppEmail) { %>\n                    <%- templateData.paymentMethods.ppEmail %>\n                <% }%>\n            </span>\n            <span class=\"showing-method-account-details gatewayWP\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayWP') { %> style=\"display:none\" <% } %>>\n                <% if (templateData.paymentMethods.wpRecurring.length == 1) { %>\n                    <span class=\"margin-l20\"><%- templateData.paymentMethods.wpRecurring[0]['cc_number'] %></span>\n                <% } else { %>\n                    <span class=\"payment-source-tooltip gatewayWP margin-l20\"><%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.wpRecurring.length}) %></span>\n                <% } %>\n            </span>\n            <span class=\"showing-method-account-details gatewayNAB\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayNAB') { %> style=\"display:none\" <% } %>>\n                <% if (templateData.paymentMethods.nabRecurring.length == 1) { %>\n                    <span class=\"margin-l20\"><%- templateData.paymentMethods.nabRecurring[0]['cc_number'] %></span>\n                <% } else { %>\n                    <span class=\"payment-source-tooltip gatewayNAB margin-l20\"><%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.nabRecurring.length}) %></span>\n                <% } %>\n            </span>\n            <span class=\"showing-method-account-details gatewayAdyen\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayAdyen') { %> style=\"display:none\" <% } %>>\n                <% if (templateData.paymentMethods.adyenRecurring.length == 1) { %>\n                    <span class=\"margin-l20\"><%- templateData.paymentMethods.adyenRecurring[0]['cc_number'] %></span>\n                <% } else { %>\n                    <span class=\"payment-source-tooltip gatewayAdyen margin-l20\"><%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.adyenRecurring.length}) %></span>\n                <% } %>\n            </span>\n            <div class=\"payment-method-selector\">\n                <% if (templateData.verifiedPaymentSourceCount > 1) { %>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control open-change-preferred-method\">\n                        <%- T_('Edit preference') %>\n                    </a>\n                    <a href=\"#\" onclick=\"return false\" class=\"PaymentMethodSettings-control close-change-preferred-method\" style=\"display:none\">\n                        <%- T_('Cancel') %>\n                    </a>\n                    <span class=\"PaymentMethodSettings-control PaymentMethodSettings-control-separator\" <% if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) { %> style=\"display:none\" <% } %>> | </span>\n                <% } %>\n                <span class=\"PaymentMethodSettings-control is-PaymentMethodSettings-control-active\" <% if (templateData.preferredPaymentMethod != templateData.firstAvailablePaymentMethod) { %> style=\"display:none\" <% } %>><%- T_('Preferred') %></span>\n            </div>\n            <span class=\"showing-method-account-details gatewayGC\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayGC') { %> style=\"display:none\" <% } %>>\n                <% if (templateData.paymentMethods.gcRecurring.length == 1) { %>\n                    <span class=\"margin-l20\"><%- templateData.paymentMethods.gcRecurring[0]['cc_number'] %></span>\n                <% } else { %>\n                    <span class=\"payment-source-tooltip gatewayGC margin-l20\"><%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.gcRecurring.length}) %></span>\n                <% } %>\n            </span>\n            <span class=\"showing-method-account-details gatewayMB\" <% if (templateData.firstAvailablePaymentMethod != 'gatewayMB') { %> style=\"display:none\" <% } %>>\n                <% if (templateData.paymentMethods.skrillPaymentVerified.length == 1) { %>\n                    <%- T_('Order ID ') %> <%- templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id %>\n                <% } else { %>\n                    <span class=\"payment-source-tooltip gatewayMB\"><%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length}) %></span>\n                <% } %>\n            </span>\n            <div class=\"clear\"></div>\n            <select class=\"default-select change-preferred-method\" style=\"display:none\">\n                <option value=\"\" selected=\"selected\"><%- T_('Select your preferred payment method') %></option>\n                <% if (templateData.paymentMethods.ppEmail) { %>\n                    <option value=\"gatewayPP\"><%- T_('Paypal:') %> (<%- templateData.paymentMethods.ppEmail %>)</option>\n                <% } %>\n                <% if (templateData.paymentMethods.gcRecurring) { %>\n                    <option value=\"gatewayGC\"><%- T_('Credit Card:') %>\n                        <% if (templateData.paymentMethods.gcRecurring.length == 1) { %>\n                            (<%- templateData.paymentMethods.gcRecurring[0]['cc_number'] %>)\n                        <% } else { %>\n                            (<%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.gcRecurring.length}) %>)\n                        <% } %>\n                    </option>\n                <% } %>\n                <% if (templateData.paymentMethods.wpRecurring) { %>\n                    <option value=\"gatewayWP\"><%- T_('Credit Card:') %>\n                    <% if (templateData.paymentMethods.wpRecurring.length == 1) { %>\n                        (<%- templateData.paymentMethods.wpRecurring[0]['cc_number'] %>)\n                    <% } else { %>\n                        (<%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.wpRecurring.length}) %>)\n                    <% } %>\n                    </option>\n                <% } %>\n                <% if (templateData.paymentMethods.skrillPaymentVerified) { %>\n                    <option value=\"gatewayMB\"><%- T_('Skrill:') %>\n                    <% if (templateData.paymentMethods.skrillPaymentVerified.length == 1) { %>\n                        (<%- T_('Order ID:') %> <%- templateData.paymentMethods.skrillPaymentVerified[0].onetap_invoice_id %>)\n                    <% } else { %>\n                        (<%= T_('<[-numberOfAccounts]> accounts available', {'numberOfAccounts': templateData.paymentMethods.skrillPaymentVerified.length}) %>)\n                    <% } %>\n                    </option>\n                <% } %>\n            </select>\n        </div>\n        <div class=\"payments-source-generic-error margin-t10 alert alert-error\" style=\"display:none\"></div>\n    </div>\n<% } %>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-payments-source.js
 * Please replicate all changes to the other file.
 */

var moduleData = false;
var $el = false;
var moduleSettings = {
  disableCC: false,
  disableBalance: false,
  showWireTransferLink: false
};

function init$1(paymentsSourceDetails, paymentsSourceContainer, preferredSettings) {
  jq.extend(moduleSettings, preferredSettings);

  if (typeof paymentsSourceDetails === 'object') {
    moduleData = paymentsSourceDetails;
  } else {
    return;
  }
  if (typeof paymentsSourceContainer !== 'undefined') {
    $el = paymentsSourceContainer;
  } else {
    return;
  }
  if (!validateAndPrepareData()) {
    return;
  }
  $el.html('<img src="' + cdn_url('/img/ajax-loader.gif') + '" ' + 'class="loading-payment-source-module margin-center block" />');
  jq.ajax({
    type: 'post',
    data: {
      currency: moduleData.currencyDetails.id
    },
    url: '/ajax/payment/getUserPaymentMethodInfo.php',
    dataType: 'json',
    success: function success(response) {
      if (response.status == 'success') {
        moduleData.balances = response.balances;
        moduleData.paymentMethods = response.paymentMethods;
        moduleData.firstAvailablePaymentMethod = response.firstAvailablePaymentMethod;
        moduleData.preferredPaymentMethod = response.preferredPaymentMethod;
        for (var i = 0; i < moduleData.balances.length; i++) {
          if (parseFloat(moduleData.balances[i].balance) > 0) {
            moduleData.totalBalanceIsEmpty = false;
            break;
          }
        }

        if (moduleSettings.disableCC) {
          removeCC();
        }

        if (moduleSettings.disableBalance) {
          removeBalance();
        }

        if (moduleSettings.showWireTransferLink) {
          includeWireTransferLink();
        }

        reconstructBalances();
        countVerifiedPaymentSource();
        render();
        buildBinds();
        checkPaymentSource(moduleData.amount);
      }
    },
    complete: function complete() {
      $el.find('.loading-payment-source-module').remove();
    }
  });
}

function removeCC() {
  moduleData.hasVerifiedCreditCard = moduleData.paymentMethods.gcRecurring || moduleData.paymentMethods.wpRecurring;
  moduleData.removedCC = true;
  moduleData.paymentMethods.gcRecurring = false;
  moduleData.paymentMethods.wpRecurring = false;

  moduleData.preferredPaymentMethod = 'gatewayPP';
  moduleData.firstAvailablePaymentMethod = 'gatewayPP';
}

function removeBalance() {
  moduleData.balances = [];
  moduleData.totalBalanceIsEmpty = true;
}

function includeWireTransferLink() {
  moduleData.showWireTransferLink = true;
}

function validateAndPrepareData() {
  if (typeof moduleData.amount === 'undefined' || Number.isNaN(moduleData.amount) || !moduleData.amount || typeof moduleData.currencyDetails === 'undefined') {
    return false;
  }
  moduleData.amount = parseFloat(moduleData.amount);
  moduleData.primaryBalanceForPayment = false;
  moduleData.totalBalanceIsEmpty = true;
  moduleData.verifiedPaymentSourceCount = 0;
  return true;
}

function render() {
  var tpl = paymentsSourceTemplate;

  if (typeof tpl === 'undefined') {
    tpl = jq('#payment-source-template').html();
  }

  $el.html(_.template(tpl)({
    templateData: moduleData,
    T_: translate,
    cdn_url: cdn_url
  }));
}

function checkPaymentSource(amountToCheck) {
  $el.find('.payment-from-option, .account-balances, .payment-logos-container').hide();
  if (Number.isNaN(amountToCheck) || !amountToCheck) {
    return;
  }

  amountToCheck = parseFloat(amountToCheck);

  if (moduleData.totalBalanceIsEmpty) {
    // If all balances are zero
    if (moduleData.firstAvailablePaymentMethod) {
      $el.find('.only-vpm, .payment-logos-container').show();
    } else {
      customizePaymentSourceNeedDepositContent();
      $el.find('.need-deposit').show();
    }
  } else if (moduleData.primaryBalanceForPayment && amountToCheck <= moduleData.primaryBalanceForPayment.balance) {
    // If primary balance is sufficient
    $el.find('.only-balance, .account-balances').show();
    // Primary balance is insufficient but not zero balances among all balances
  } else if (moduleData.firstAvailablePaymentMethod) {
    $el.find('.mixed-balance-vpm, .account-balances, .payment-logos-container').show();
  } else if (moduleData.balances.length === 1 && moduleData.balances[0].currency.id == moduleData.currencyDetails.id) {
    customizePaymentSourceNeedDepositContent();
    $el.find('.need-deposit').show();
  } else {
    $el.find('.may-need-deposit, .account-balances').show();
  }
}

function buildBinds() {
  jq(document).ready(function () {
    $el.off('change', '.change-preferred-method').on('change', '.change-preferred-method', function () {
      var that = jq(this);
      var method = that.val();
      if (!method) {
        return;
      }
      var existingMethod = $el.find('.payment-logo-container:visible, ' + '.showing-method-account-details:visible');
      jq.ajax({
        url: '/ajax/user/setUserPreferedPayment.php',
        dataType: 'json',
        type: 'post',
        data: {
          method: method
        },
        beforeSend: function beforeSend() {
          that.hide();
          $el.find('.payment-logo-container, .close-change-preferred-method, ' + '.showing-method-account-details').hide();
          $el.find('.loading-img-change-preferred-method, ' + '.open-change-preferred-method').show();
          $el.find('.payments-source-generic-error').html('').hide();
          $el.closest('.modal').find('.btn').attr('disabled', true);
        },
        success: function success(response) {
          if (response.result == 'success') {
            $el.find('.is-preferred, .is-preferred-separator, ' + ('.payment-logo-container.' + method + ', ') + ('.showing-method-account-details.' + method)).show();
            moduleData.preferredPaymentMethod = method;
          } else {
            $el.find('.payments-source-generic-error').html(translate('Failed to save your preferred payment method. ' + 'Please try again.')).show();
            existingMethod.show();
          }
        },
        error: function error() {
          $el.find('.payments-source-generic-error').html(translate('Server Error')).show();
          existingMethod.show();
        },
        complete: function complete() {
          $el.find('.loading-img-change-preferred-method').hide();
          // front end delay for potential slave drift
          setTimeout(function () {
            $el.closest('.modal').find('.btn').removeAttr('disabled');
          }, 1200);
        }
      });
    });

    $el.off('click', '.open-change-preferred-method').on('click', '.open-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.is-preferred').hide();
      $el.find('.change-preferred-method, .close-change-preferred-method').show();
    });

    $el.off('click', '.close-change-preferred-method').on('click', '.close-change-preferred-method', function () {
      jq(this).hide();
      $el.find('.change-preferred-method').hide();
      if (moduleData.preferredPaymentMethod) {
        $el.find('.is-preferred').show();
      }
      $el.find('.open-change-preferred-method').show();
    });

    $el.find('.payment-source-tooltip.gatewayGC').popover({
      content: function content() {
        var gatewayGCAccounts = [];
        if (moduleData.paymentMethods.gcRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.gcRecurring.length; i++) {
            gatewayGCAccounts.push(moduleData.paymentMethods.gcRecurring[i].cc_number);
          }
        }
        return gatewayGCAccounts.join('<br>');
      },

      title: 'Credit cards',
      placement: 'top',
      html: true,
      trigger: 'hover'
    });

    $el.find('.payment-source-tooltip.gatewayWP').popover({
      content: function content() {
        var gatewayWPAccounts = [];
        if (moduleData.paymentMethods.wpRecurring) {
          for (var i = 0; i < moduleData.paymentMethods.wpRecurring.length; i++) {
            gatewayWPAccounts.push(moduleData.paymentMethods.wpRecurring[i].cc_number);
          }
        }
        return gatewayWPAccounts.join('<br>');
      },

      title: translate('Credit cards'),
      placement: 'top',
      html: true,
      trigger: 'hover'
    });

    $el.find('.payment-source-tooltip.gatewayMB').popover({
      content: function content() {
        var gatewayMBAccounts = [];
        if (moduleData.paymentMethods.skrillPaymentVerified) {
          for (var i = 0; i < moduleData.paymentMethods.skrillPaymentVerified.length; i++) {
            gatewayMBAccounts.push(moduleData.paymentMethods.skrillPaymentVerified[i].onetap_invoice_id);
          }
        }
        return gatewayMBAccounts.join('<br>');
      },

      placement: 'top',
      html: true,
      trigger: 'hover'
    });
  });
}

function reconstructBalances() {
  // Remove balances with zero amount and set the primary balance to balance
  // with payment's currency
  for (var i = 0; i < moduleData.balances.length;) {
    moduleData.balances[i].balance = parseFloat(moduleData.balances[i].balance);
    if (moduleData.balances[i].balance == 0) {
      moduleData.balances.splice(i, 1);
    } else if (moduleData.balances[i].currency.id == moduleData.currencyDetails.id) {
      moduleData.primaryBalanceForPayment = moduleData.balances[i];
      moduleData.balances.splice(i, 1);
    } else {
      i++;
    }
  }
  if (moduleData.primaryBalanceForPayment) {
    moduleData.balances.unshift(moduleData.primaryBalanceForPayment);
  }
}

function countVerifiedPaymentSource() {
  if (moduleData.firstAvailablePaymentMethod) {
    if (moduleData.paymentMethods.ppEmail) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.gcRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.wpRecurring) {
      moduleData.verifiedPaymentSourceCount++;
    }
    if (moduleData.paymentMethods.skrillPaymentVerified) {
      moduleData.verifiedPaymentSourceCount++;
    }
  }
}

function customizePaymentSourceNeedDepositContent() {
  if (typeof moduleData.needDepositCustomTitle !== 'undefined') {
    $el.closest('.modal').find('.modal-header h3').html(moduleData.needDepositCustomTitle);
  }

  if (typeof moduleData.needDepositCustomBody !== 'undefined') {
    $el.find('.need-deposit').html(moduleData.needDepositCustomBody);
  }
  if (typeof moduleData.needDepositAmountDiv !== 'undefined' && !moduleData.needDepositAmountDiv) {
    $el.find('.payment-from').hide();
    $el.closest('.modal-body').find('p:first').hide();
  }

  if (typeof moduleData.needDepositConfirmText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-confirm-payment').html(moduleData.needDepositConfirmText);
  }
  if (typeof moduleData.needDepositCancelText !== 'undefined') {
    $el.closest('.modal').find('.modal-footer .modal-btn-cancel-payment').html(moduleData.needDepositCancelText);
  }
}

var modulePaymentsSource = {
  init: init$1,
  checkPaymentSource: checkPaymentSource
};

/**
 * Loads the contents of an SVG file and injects it to where it's being called.
 * In its originality this function is only used with the Underscore templating
 * engine, so it only works if the template is being rendered right after
 * compilation.
 * @param  {String} icon The icon name. Consult with FEDs or the
 * [Pattern Library](https://patternlibrary.freelancer.com)
 *                       for the naming convention of the icon you're using.
 * @return {String}      A temporary placeholder element to be replaced later
 * after the XHR fetches the SVG.
 */

function generateUniqueIdentifier() {
  var identifier = 'uiIcon-' + Math.floor(Math.random() * 1024);
  // Does the passwordless form with that identifier exist? Reroll the
  // dice again to get a new unique one.
  if (document.getElementById(identifier)) {
    return generateUniqueIdentifier();
  }

  return identifier;
}

function uiIcon(icon) {
  // Make a placeholder element to be replaced with the SVG later.
  var identifier = generateUniqueIdentifier();
  var placeholderHTML = '<span id="' + identifier + '"></span>';

  // Fetch the contents of the SVG file we're going to replace it with.
  var placeholderNode = void 0;
  // DO NOT use the SystemJS API without talking to @laurent first! Things
  // might go really bad if you do.
  fetch(SystemJS.normalizeSync('icons/' + icon + '.svg')).then(function (response) {
    if (response.ok) {
      return response.text();
    }

    // Remove the placeholder element if the icon is not found or some server
    // problems happened.
    placeholderNode = document.getElementById('' + identifier);
    if (placeholderNode.parentNode) {
      placeholderNode.parentNode.removeChild(placeholderNode);
    }
    throw new Error();
  }).then(function (html) {
    var replace = function replace() {
      placeholderNode = document.getElementById('' + identifier);
      // Sometimes the templates are rendered but never inserted in the DOM
      // ¯\_(ツ)_/¯
      if (placeholderNode) {
        placeholderNode.outerHTML = html;
      }
    };

    // Replace the placeholder element at the next animation frame if possible
    if ('requestAnimationFrame' in window) {
      requestAnimationFrame(replace);
    } else {
      replace();
    }
    // 404 or something else happened. Don't worry about it.
  }).catch(function () {
    return undefined;
  });

  // While that call's happening return the placeholder element to be injected
  // to the template first.
  return placeholderHTML;
}

var fixedAmountPaymentModalTemplate = "<div class=\"modal-header\">\n    <a class=\"close\" data-dismiss=\"modal\">&times;</a>\n    <h3><%- customizedModal.title %></h3>\n</div>\n<div class=\"modal-body\">\n\n    <% if (customizedModal.description != '') { %>\n        <p class=\"margin-b20\">\n            <%= customizedModal.description %>\n        </p>\n    <% } %>\n\n    <% if (!customizedModal.showDescriptionOnly) { %>\n        <p class=\"margin-b20\">\n            <strong><%- T_('Amount to be paid:') %></strong> <%- templateData.currencyDetails.sign %><%- templateData.amount.toFixed(2) %> <%- templateData.currencyDetails.code %>\n            <span class='muted'> <%- customizedModal.chargeDetail %> </span>\n        </p>\n        <div class=\"payment-sources-container\">\n        </div>\n    <% } %>\n    <% if (typeof customizedModal.additionalDetails != 'undefined') { %>\n        <p class=\"margin-b20 margin-t10\">\n            <%= customizedModal.additionalDetails %>\n        </p>\n    <% } %>\n\n    <div class=\"alert alert-error modal-milestone-generic-error regular\" style=\"display:none\"></div>\n\n</div>\n<div class=\"modal-footer\">\n    <% if (customizedConfirm.show) { %>\n        <button type=\"button\" class=\"btn btn-info btn-small modal-btn-confirm-payment\"><%- customizedConfirm.buttonText %></button>\n    <% } %>\n    <img src=\"<%= cdn_url('/img/ajax-loader.gif') %>\" class=\"loading-img margin-r20\" style=\"display:none\"/>\n    <% if (customizedCancel.show) { %>\n        <button type=\"button\" class=\"btn btn-small modal-btn-cancel-payment\"><%- customizedCancel.buttonText %></button>\n    <% } %>\n</div>\n";

var newFixedAmountPaymentModalTemplate = "<div class=\"responsive-modal\" id=\"expanded-payment-modal\">\n    <div class=\"modal ModalPayment\" aria-label=\"<%- T_('Close') %>\" data-backdrop=\"true\">\n        <div class=\"modal-header ModalPayment-header\">\n            <button id=\"paymentModalCloseButton\" type=\"button\" class=\"payment-modal-close close\" data-dismiss=\"modal\" aria-label=\"<%- T_('Close') %>\">\n                <span class=\"Icon Icon--small\">\n                    <%= uiIcon('ui-close-alt') %>\n                </span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <div class=\"ModalPayment-body\">\n                <figure class=\"ModalPayment-figure\">\n                    <img class=\"ModalPayment-image\" src=\"<%= cdn_url('/static/img/secure-payment.png') %>\" alt=\"<%- T_('Secure Payment') %>\" />\n                </figure>\n                <div class=\"ModalPayment-heading\"><%- heading %></div>\n                <% if (headingSubtext) { %>\n                    <div class=\"ModalPayment-headingSubtext\"><%- headingSubtext %></div>\n                <% } %>\n                <% if (subHeading) { %>\n                    <div class=\"ModalPayment-subHeading\"><%- subHeading %></div>\n                <% } %>\n                <% if (showCharges) { %>\n                    <% for (i = 0; i < chargeDetails.length; i++) { %>\n                        <% if (parseFloat(chargeDetails[i].amount) > 0) { %>\n                            <div class=\"ModalPayment-paymentDetails\">\n                                <div class=\"ModalPayment-label\">\n                                    <%= chargeDetails[i].label %>\n                                </div>\n                                <div class=\"ModalPayment-price\">\n                                    <span class=\"ModalPayment-totalCost-price\">\n                                        <% if (chargeDetails[i].paid) { %>\n                                            <span class=\"ModalPayment-totalCost-price-paid\">\n                                                <%- T_('PAID') %>\n                                            </span>\n                                        <% } else { %>\n                                            <%- currency.sign %><%- chargeDetails[i].amount.toFixed(2) %>\n                                        <% } %>\n                                    </span>\n                                </div>\n                            </div>\n                        <% } %>\n                    <% } %>\n                    <div class=\"ModalPayment-totalCost\">\n                        <span class=\"ModalPayment-totalCost-label\"><%- T_('Total: ') %></span>\n                        <span class=\"ModalPayment-totalCost-price\">\n                            <%- currency.sign %><%- chargeTotal.toFixed(2) %> <%- currency.code %>\n                        </span>\n                        <% if (includesGST) { %>\n                            <div class=\"ModalPayment-totalCost-detail\"><%- T_('including GST') %></div>\n                        <% } else if (taxName) { %>\n                            <div class=\"ModalPayment-totalCost-detail\"><%- T_('including')%> <%- taxName %></div>\n                        <% } %>\n                    </div>\n                <% } %>\n                <% if (text) { %>\n                    <p class=\"ModalPayment-descriptionText\"><%= text %></p>\n                <% } %>\n            </div>\n            <div class=\"ModalPayment-footer\n                <% if (!footerText) { %>\n                    ModalPayment-footer-noText\n                <% } %>\n            \">\n                <% if (footerText) { %>\n                    <p><%- footerText %></p>\n                <% } %>\n                <button id=\"paymentModalConfirmButton\" class=\"btn btn-large btn-success ModalPayment-footer-btn\"><%- buttonLabel %></button>\n            </div>\n        </div>\n    </div>\n</div>\n";

/**
 * NOTE: This file needs to be kept in sync with the non-SystemJS variant:
 * /public/static/js/payments/module-fixed-amount-payment-modal.js
 * Please replicate all changes to the other file.
 */

/*
Usage:
For bootstrap page:
  1. Require the module in your javascript file
  2. Call module.initModal(paymentDetails)
For non-bootstrap page:
  1. Call initFixedAmountPaymentModalOnNonBSPage(paymentDetails) --
     lack of template, not supported yet

@compulsory params
paymentDetails is an object contains
  Compulsory:
    amount -- amount for checking payment source
    currencyDetails(id, sign, code) -- object with id, sign, code

@optional params
callbackFn is a callback function for 'Confirm' button
callbackFnParams is an object contains params for callbackFn
cancelCallbackFn is a callback function for 'cancel' button
cancelCallbackFn is an object contains params for cancelCallbackFn
customizedConfirmDetails is an object contains customized copies, etc for
'Confirm' button
customizedCancelDetails is an object contains customized copies, etc for
'Cancel' button
These are optional params, please precheck these params
(eg. null/undefined/false) in the module/template to avoid unexpected errors
*/

var modalVars = {};

function initModalVars(scope) {
  scope.moduleData = {};
  scope.$el = false;
  scope.callback = false;
  scope.callbackParams = false;
  scope.cancelCallback = false;
  scope.cancelCallbackParams = false;
  scope.closeCallback = false;
  scope.closeCallbackParams = false;
  scope.confirmConfig = {
    buttonText: translate('Confirm Payment'),
    show: true
  };
  scope.cancelConfig = {
    buttonText: translate('Cancel'),
    show: true
  };
  scope.customizedConfirm = scope.confirmConfig;
  scope.customizedCancel = scope.cancelConfig;

  scope.customizedModal = {
    title: translate('Authorise Payment'),
    description: '',
    chargeDetail: '',
    showDescriptionOnly: false
  };
}

function buildBinds$1() {
  jq(document).ready(function () {
    modalVars.$el.off('click', '.modal-btn-confirm-payment').on('click', '.modal-btn-confirm-payment', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.callback === 'function') {
        modalVars.callback(modalVars.callbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'ConfirmPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id
      }]);
      return false;
    });

    modalVars.$el.off('click', '.modal-btn-cancel-payment').on('click', '.modal-btn-cancel-payment', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.cancelCallback === 'function') {
        modalVars.cancelCallback(modalVars.cancelCallbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'CancelPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id
      }]);
      return false;
    });

    modalVars.$el.on('click', '.modal-header .close', function () {
      if (typeof modalVars.closeCallback === 'function') {
        modalVars.closeCallback(modalVars.closeCallbackParams);
      }
      _t.push(['user_action', {
        section: 'PaymentConfirmationModal',
        label: 'CloseModal',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id
      }]);
      return false;
    });
  });
}

function buildBindsForExpandedModal() {
  jq(document).ready(function () {
    modalVars.$el.off('click', '#paymentModalConfirmButton').on('click', '#paymentModalConfirmButton', function () {
      modalVars.$el.modal('hide');
      if (typeof modalVars.callback === 'function') {
        modalVars.callback(modalVars.callbackParams);
      }
      _t.push(['user_action', {
        section: 'ExpandedPaymentConfirmationModal',
        label: 'ConfirmPayment',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id
      }]);
      return false;
    });

    modalVars.$el.on('click', '#paymentModalCloseButton', function () {
      if (typeof modalVars.closeCallback === 'function') {
        modalVars.closeCallback(modalVars.closeCallbackParams);
      }
      _t.push(['user_action', {
        section: 'ExpandedPaymentConfirmationModal',
        label: 'CloseModal',
        action: 'click',
        amount: modalVars.moduleData.amount,
        currency: modalVars.moduleData.currencyDetails.id
      }]);
      return false;
    });
  });
}

function initModal(paymentDetails, callbackFn, callbackFnParams, cancelCallbackFn, cancelCallbackFnParams, customizedConfirmDetails, customizedCancelDetails, customizedModalDialog, closeCallbackFn, closeCallbackFnParams, useExpandedModal) {
  initModalVars(modalVars);

  if (typeof callbackFn === 'function') {
    modalVars.callback = callbackFn;
  }
  if (typeof callbackFnParams === 'object') {
    modalVars.callbackParams = callbackFnParams;
  }
  if (typeof cancelCallbackFn === 'function') {
    modalVars.cancelCallback = cancelCallbackFn;
  }
  if (typeof cancelCallbackFnParams === 'object') {
    modalVars.cancelCallbackParams = cancelCallbackFnParams;
  }
  if (typeof closeCallbackFn === 'function') {
    modalVars.closeCallback = closeCallbackFn;
  }
  if (typeof closeCallbackFnParams === 'object') {
    modalVars.closeCallbackParams = closeCallbackFnParams;
  }
  if (typeof customizedConfirmDetails === 'object') {
    modalVars.customizedConfirm = customizedConfirmDetails;
    if (typeof modalVars.customizedConfirm.buttonText === 'undefined') {
      modalVars.customizedConfirm.buttonText = modalVars.confirmConfig.buttonText;
    }
    if (typeof modalVars.customizedConfirm.show === 'undefined') {
      modalVars.customizedConfirm.show = modalVars.confirmConfig.show;
    }
  }
  if (typeof customizedCancelDetails === 'object') {
    modalVars.customizedCancel = customizedCancelDetails;
    if (typeof modalVars.customizedCancel.buttonText === 'undefined') {
      modalVars.customizedCancel.buttonText = modalVars.cancelConfig.buttonText;
    }
    if (typeof modalVars.customizedCancel.show === 'undefined') {
      modalVars.customizedCancel.show = modalVars.cancelConfig.show;
    }
  }
  if (typeof customizedModalDialog === 'object') {
    modalVars.customizedModal = jq.extend(modalVars.customizedModal, customizedModalDialog);
  }
  if (typeof paymentDetails === 'object') {
    modalVars.moduleData = paymentDetails;
  } else {
    return;
  }
  if (validateAndPrepareData$1()) {
    if (modalVars.moduleData.amount > 0) {
      if (typeof useExpandedModal !== 'undefined' && useExpandedModal) {
        renderExpandedModal();
      } else {
        renderModal();
      }
    } else if (typeof modalVars.callback === 'function') {
      modalVars.callback(modalVars.callbackParams);
    }
  }
}

function validateAndPrepareData$1() {
  if (typeof modalVars.moduleData.amount === 'undefined' || typeof modalVars.moduleData.currencyDetails === 'undefined' || modalVars.customizedModal.showDescriptionOnly && modalVars.customizedModal.description === '') {
    return false;
  }
  modalVars.moduleData.amount = parseFloat(modalVars.moduleData.amount);
  if (Number.isNaN(modalVars.moduleData.amount) || modalVars.moduleData.amount < 0) {
    return false;
  }
  return true;
}

function renderModal() {
  var mainContainer = void 0;
  if (jq('.gaf-container').length > 0) {
    mainContainer = '.gaf-container:first';
  } else {
    mainContainer = '.pinky-template:first';
  }

  /**
   * When you have a page that has both `.gaf-container` and `.pinky-template`,
   * but want to force this payment modal to be appended
   * inside a `.pinky-template` container,
   * just set `usePinkyTemplateContainer` to `true`
   * in the first object argument of `initModal`.
   */
  if (typeof modalVars.moduleData.usePinkyTemplateContainer !== 'undefined' && modalVars.moduleData.usePinkyTemplateContainer === true) {
    mainContainer = '.pinky-template:first';
  }
  modalVars.$el = jq('.fixed-amount-payment-modal');
  modalVars.$el.modal('hide').remove();
  modalVars.$el = jq('<div class="fixed-amount-payment-modal modal hide"></div>').appendTo(mainContainer);
  modalVars.$el.html(_.template(fixedAmountPaymentModalTemplate)({
    templateData: modalVars.moduleData,
    customizedConfirm: modalVars.customizedConfirm,
    customizedCancel: modalVars.customizedCancel,
    customizedModal: modalVars.customizedModal,
    T_: translate,
    cdn_url: cdn_url
  }));
  modulePaymentsSource.init(modalVars.moduleData, modalVars.$el.find('.payment-sources-container'));
  buildBinds$1();
  modalVars.$el.modal({
    backdrop: 'static',
    keyboard: true
  });
}

function renderExpandedModal() {
  var mainContainer = void 0;
  if (jq('.gaf-container').length > 0) {
    mainContainer = '.gaf-container:first';
  } else {
    mainContainer = '.pinky-template:first';
  }

  if (typeof modalVars.moduleData.usePinkyTemplateContainer !== 'undefined' && modalVars.moduleData.usePinkyTemplateContainer === true) {
    mainContainer = '.pinky-template:first';
  }
  modalVars.$el = jq('.fixed-amount-payment-modal');
  modalVars.$el.modal('hide').remove();
  modalVars.$el = jq('<div class="fixed-amount-payment-modal hide"></div>').appendTo(mainContainer);
  modalVars.$el.html(_.template(newFixedAmountPaymentModalTemplate)({
    heading: translate('Confirm Payment'),
    headingSubtext: modalVars.moduleData.headingSubtext,
    subHeading: translate('Upgrades'),
    buttonLabel: translate('Confirm Payment'),
    showCharges: true,
    chargeDetails: modalVars.moduleData.chargeDetails,
    chargeTotal: modalVars.moduleData.amount,
    currency: modalVars.moduleData.currencyDetails,
    includesGST: modalVars.moduleData.includesGST,
    taxName: modalVars.moduleData.taxName,
    text: null,
    footerText: translate('This will be debited from your available balances, ' + 'then if required we will attempt to process this payment from ' + 'your verified payment methods.'),
    templateData: modalVars.moduleData,
    customizedConfirm: modalVars.customizedConfirm,
    customizedCancel: modalVars.customizedCancel,
    customizedModal: modalVars.customizedModal,
    T_: translate,
    uiIcon: uiIcon,
    cdn_url: cdn_url
  }));
  buildBindsForExpandedModal();
  modalVars.$el.modal({
    backdrop: 'static',
    keyboard: true
  });
}

function getModal() {
  return modalVars.$el;
}

var fixedAmountPaymentModalModule = {
  initModal: initModal,
  getModal: getModal
};

var UpgradesPayment = function () {
  function UpgradesPayment(UpgradesService, $q, ProjectData, taxName$$1) {
    _classCallCheck(this, UpgradesPayment);

    this.ProjectData = ProjectData;
    this.UpgradesService = UpgradesService;
    this.$q = $q;
    this.taxName = taxName$$1;
  }

  _createClass(UpgradesPayment, [{
    key: 'show',
    value: function show(closeModalCallback, parentForm) {
      var deferred = this.$q.defer();
      fixedAmountPaymentModalModule.initModal({
        amount: this.UpgradesService.totalCost,
        currencyDetails: this.ProjectData.project.selectedCurrency,
        chargeDetails: this.getChargeDetails(),
        taxName: this.taxName
      }, function () {
        return deferred.resolve();
      }, false, false, false, false, false, false, function () {
        closeModalCallback(parentForm);
      }, false, true);
      return deferred.promise;
    }
  }, {
    key: 'getChargeDetails',
    value: function getChargeDetails() {
      return this.UpgradesService.getSelectedUpgrades().map(function (upgrade) {
        return {
          label: upgrade.name.charAt(0).toUpperCase() + upgrade.name.substr(1),
          amount: upgrade.price
        };
      });
    }
  }]);

  return UpgradesPayment;
}();

UpgradesPayment.$inject = ['UpgradesService', '$q', 'ProjectData', 'taxName'];

var UpgradesPaymentProvider = flService$1('UpgradesPayment', [ProjectDataProvider, taxName], UpgradesPayment);

var budgetWizardTemplate = "<div class=\"NumberedForm-content\">\n  <fieldset class=\"PagePostProject-fieldset\">\n    <legend class=\"PagePostProject-legend\">What is your budget?</legend>\n    <ol>\n      <li class=\"form-step\">\n        <div class=\"BudgetSlider\">\n          <div ng-class=\"[ContestBudgetSelector.sliderHeadingClass]\" class=\"BudgetSlider-result\">\n            <h3 class=\"BudgetSlider-heading BudgetSlider-heading--changeBudgetSlider\">{{ContestBudgetSelector.resultsDescription}}</h3>\n            <span id=\"expect_entry_container\" class=\"BudgetSlider-subHeading\">{{ContestBudgetSelector.entriesDescription}}</span>\n          </div>\n          <div class=\"BudgetSlider-controllers--changeBudgetSlider\">\n            <slider\n              class=\"fl-slider BudgetSlider-sliderBar BudgetSlider-sliderBar--alt\"\n              floor=\"{[{ ContestBudgetSelector.floor }]}\"\n              ceiling=\"{[{ ContestBudgetSelector.ceiling }]}\"\n              step=\"{[{ ContestBudgetSelector.sliderStep }]}\"\n              highlight=\"left\"\n              ng-model=\"ContestBudgetSelector.projectData.project.prize\" fl-toggle-wizard-next=\"contestBudgetSelector\">\n            </slider>\n\n            <div class=\"BudgetSlider-priceRange BudgetSlider-priceRange--changeBudgetSlider\">\n              <div class=\"BudgetSlider-priceMin\">\n                <span class=\"csign\">{{ContestBudgetSelector.projectData.project.selectedCurrency.sign}}</span>\n                <span class=\"min-prize\">{{ContestBudgetSelector.floor}}</span>\n              </div>\n              <div class=\"BudgetSlider-priceMax\">\n                <span class=\"csign\">{{ContestBudgetSelector.projectData.project.selectedCurrency.sign}}</span>\n                <span class=\"max-prize\">{{ContestBudgetSelector.ceiling}}+</span>\n              </div>\n            </div>\n\n            <div class=\"BudgetSlider-form\">\n              <span class=\"form-step BudgetSlider-inputWrapper BudgetSlider-inputWrapper--changeBudgetSlider BudgetSlider-inputWrapper--large--changeBudgetSlider\"\n                ng-class=\"{\n                  'is-invalid': (ContestBudgetSelector.form.prize.$error.required &&\n                      ContestBudgetSelector.form.prize.$dirty),\n                  'is-warning': (ContestBudgetSelector.form.prize.$invalid &&\n                      !ContestBudgetSelector.form.prize.$error.required &&\n                      ContestBudgetSelector.form.prize.$dirty)\n                }\">\n                <div class=\"input-group\">\n                  <span class=\"add-on csign\">{{ContestBudgetSelector.projectData.project.selectedCurrency.sign}}</span>\n                  <input\n                    name=\"prize\"\n                    type=\"number\"\n                    size=\"12\"\n                    class=\"input-integers-only default-input large-input BudgetSlider-inputWrapper-inputLarge\"\n                    ng-model=\"ContestBudgetSelector.projectData.project.prize\"\n                    ng-required=\"true\"\n                    ng-min=\"{[{ ContestBudgetSelector.floor }]}\" fl-toggle-wizard-next=\"contestBudgetSelector\">\n                </div>\n                <div ng-messages=\"ContestBudgetSelector.form.prize.$error\" tabindex=\"-1\">\n                  <div class=\"form-error\" ng-message=\"required\">Please enter a prize.</div>\n                  <div class=\"form-error\" ng-message=\"min\">Minimum prize is {{ContestBudgetSelector.floor}}</div>\n                </div>\n              </span>\n              <span class=\"BudgetSlider-inputWrapper BudgetSlider-inputWrapper--changeBudgetSlider BudgetSlider-inputWrapper--large--changeBudgetSlider\">\n                <select\n                  name=\"currency\"\n                  ng-model=\"ContestBudgetSelector.projectData.project.selectedCurrency\"\n                  ng-change=\"ContestBudgetSelector.onCurrencyChange()\"\n                  ng-options=\"currency as currency.code for currency in ContestBudgetSelector.currencyData track by currency.id\"\n                  fl-toggle-wizard-next=\"contestBudgetSelector\"\n                  id=\"contest_currency\"\n                  class=\"BudgetSlider-selectCurrency default-input large-input\"\n                  fl-autosave-draft>\n                </select>\n              </span>\n            </div>\n          </div>\n        </div>\n      </li>\n    </ol>\n  </fieldset>\n</div>\n";

var flContestBudgetSelector = function () {
  function flContestBudgetSelector(ProjectData, WizardService, Currencies, escrowCurrencies$$1, UpgradesService, ContestUpgradesService, $scope) {
    var _this = this;

    _classCallCheck(this, flContestBudgetSelector);

    this.projectData = ProjectData;
    this.WizardService = WizardService;
    this.UpgradesService = UpgradesService;
    this.ContestUpgradesService = ContestUpgradesService;
    this.Currencies = Currencies;
    this.escrowCurrencies = escrowCurrencies$$1;
    this.fetchCurrencyData();
    // Default currency
    this.previousCurrency = this.previousCurrency ? this.previousCurrency : this.projectData.project.currency;

    this.resetCurrency();

    // Initial setup with default currencyId
    var currencyId = this.projectData.project.selectedCurrency ? this.projectData.project.selectedCurrency.id : this.projectData.project.currency.id;
    this.refreshMinMax(currencyId);
    this.refreshBudgetCategories(currencyId);
    this.projectData.project.prize = this.projectData.project.prize ? this.projectData.project.prize : contestBudgetRanges[currencyId].default;
    this.sliderStep = 50;

    $scope.$watch('ContestBudgetSelector.projectData.project.prize', function () {
      _this.setBudgetFeedback(parseFloat(_this.projectData.project.prize));
      _this.recomputeTotal();
    });

    $scope.$watch('ContestBudgetSelector.projectData.project.isEscrowCurrencyRestricted', function () {
      if (_this.projectData.project.isEscrowCurrencyRestricted && _this.currencyData) {
        _this.currencyData = _this.currencyData.filter(function (currency$$1) {
          return _this.escrowCurrencies.includes(currency$$1.code);
        });

        // Default currency is USD
        var defaultCurrency = _this.currencyData.find(function (currency$$1) {
          return currency$$1.id === 1;
        });

        _this.projectData.project.selectedCurrency = defaultCurrency;

        delete _this.projectData.budgetId;

        _this.onCurrencyChange();
      }
    });
  }

  _createClass(flContestBudgetSelector, [{
    key: 'fetchCurrencyData',
    value: function fetchCurrencyData() {
      var _this2 = this;

      this.currencyDataPromise = this.Currencies.get().then(function (currencies) {
        _this2.currencyData = currencies.getList();

        if (_this2.projectData.project.isEscrowCurrencyRestricted) {
          _this2.currencyData = _this2.currencyData.filter(function (currency$$1) {
            return _this2.escrowCurrencies.includes(currency$$1.code);
          });
        }

        _this2.currencyData.sort(function (a, b) {
          return a.code.localeCompare(b.code);
        });
      }).catch(function () {
        _this2.currencyData = {};
      });
    }
  }, {
    key: 'resetCurrency',
    value: function resetCurrency() {
      var _this3 = this;

      this.currencyDataPromise.then(function () {
        // Default currency is USD
        var defaultCurrency = _this3.currencyData.find(function (currency$$1) {
          return currency$$1.id === 1;
        });

        if (!_this3.projectData.project.selectedCurrency) {
          // Check if Prefilled Currency is a valid currency
          var prefilledCurrency = _this3.currencyData.find(function (currency$$1) {
            return parseInt(_this3.projectData.project.prefillCurrencyId, 10) === currency$$1.id;
          });
          if (prefilledCurrency) {
            _this3.projectData.project.selectedCurrency = prefilledCurrency;
            _this3.onCurrencyChange();
            return;
          }

          // Otherwise use initial currency, and reset any prefilled budgetId
          var initialCurrency = _this3.currencyData.find(function (currency$$1) {
            return parseInt(_this3.projectData.project.currency.id, 10) === currency$$1.id;
          });

          _this3.projectData.project.selectedCurrency = initialCurrency || defaultCurrency;

          _this3.onCurrencyChange();
          delete _this3.projectData.project.budgetId;
        }

        var selectedCurrency = _this3.currencyData.find(function (currency$$1) {
          return parseInt(_this3.projectData.project.selectedCurrency.id, 10) === currency$$1.id;
        });

        if (!selectedCurrency) {
          _this3.projectData.project.selectedCurrency = defaultCurrency;
          _this3.onCurrencyChange();
        }

        _this3.previousCurrency = _this3.projectData.project.selectedCurrency;
      });
    }
  }, {
    key: 'onCurrencyChange',
    value: function onCurrencyChange() {
      var currencyId = this.projectData.project.selectedCurrency ? this.projectData.project.selectedCurrency.id : 1;
      this.refreshMinMax(currencyId);
      this.refreshBudgetCategories(currencyId);
      this.setConvertedBudgetValue();
      this.previousCurrency = this.projectData.project.selectedCurrency;
      if (this.projectData.contestMode) {
        this.ContestUpgradesService.getUpgradeFees();
      } else {
        this.UpgradesService.getUpgradeFees();
      }
    }
  }, {
    key: 'recomputeTotal',
    value: function recomputeTotal() {
      if (this.projectData.contestMode) {
        this.ContestUpgradesService.onBudgetReset();
      }
    }
  }, {
    key: 'refreshMinMax',
    value: function refreshMinMax(currencyId) {
      this.floor = parseInt(contestBudgetRanges[currencyId].min, 10);
      this.ceiling = parseInt(contestBudgetRanges[currencyId].max, 10);
    }
  }, {
    key: 'refreshBudgetCategories',
    value: function refreshBudgetCategories(currencyId) {
      this.budgetCategories = contestBudgetRanges[currencyId].budget;
    }
  }, {
    key: 'setConvertedBudgetValue',
    value: function setConvertedBudgetValue() {
      var convertedBudgetValue = this.convertBudgetValue(this.previousCurrency, this.projectData.project.selectedCurrency);
      this.projectData.project.prize = Math.round(Math.max(this.floor, Math.min(convertedBudgetValue, this.ceiling)));
    }
  }, {
    key: 'convertBudgetValue',
    value: function convertBudgetValue(previousCurrency, selectedCurrency) {
      var budgetInUsd = this.projectData.project.prize * parseFloat(previousCurrency.exchange_rate || previousCurrency.exchangerate);
      return budgetInUsd / parseFloat(selectedCurrency.exchange_rate);
    }
  }, {
    key: 'setBudgetFeedback',
    value: function setBudgetFeedback(budget) {
      if (budget < this.budgetCategories.ok.max) {
        this.resultsDescription = 'Ok Results';
        this.entriesDescription = 'Expect around 30 entries';
        this.sliderHeadingClass = 'feedback-ok BudgetSlider-result--ok';
      } else if (budget < this.budgetCategories.good.max) {
        this.resultsDescription = 'Good Results';
        this.entriesDescription = 'Expect around 80 entries';
        this.sliderHeadingClass = 'feedback-good BudgetSlider-result--good';
      } else if (budget < this.budgetCategories.great.max) {
        this.resultsDescription = 'Great Results';
        this.entriesDescription = 'Expect around 100 entries';
        this.sliderHeadingClass = 'feedback-great BudgetSlider-result--great';
      } else if (budget < this.budgetCategories.excellent.max) {
        this.resultsDescription = 'Excellent Results';
        this.entriesDescription = 'Expect around 150 entries';
        this.sliderHeadingClass = 'feedback-excellent BudgetSlider-result--excellent';
      } else if (budget < this.budgetCategories.best.max && budget < this.ceiling) {
        this.resultsDescription = 'Best Results';
        this.entriesDescription = 'Expect around 250 entries';
        this.sliderHeadingClass = 'feedback-best BudgetSlider-result--best';
      } else if (budget >= this.ceiling) {
        this.resultsDescription = 'Amazing Results';
        this.entriesDescription = 'Expect the unexpected!';
        this.sliderHeadingClass = 'feedback-best BudgetSlider-result--amazing--changeBudgetSlider';
      }
    }
  }]);

  return flContestBudgetSelector;
}();

flContestBudgetSelector.$inject = ['ProjectData', 'WizardService', 'Currencies', 'escrowCurrencies', 'UpgradesService', 'ContestUpgradesService', '$scope'];

var flContestBudgetSelector$1 = flComponent$1(flContestBudgetSelector, {
  selector: 'fl-contest-budget-selector',
  transclude: true,
  template: budgetWizardTemplate,
  bindings: {
    form: '='
  },
  providers: [CurrenciesProvider, escrowCurrencies, ngMessages, WizardServiceProvider, ProjectDataProvider, UpgradesServiceProvider, ContestUpgradesServiceProvider, 'ui.slider']
});

var ServerDraftStorage$1 = function () {
  function ServerDraftStorage($http, ProjectData, Auth) {
    _classCallCheck(this, ServerDraftStorage);

    this.ProjectData = ProjectData;
    this.Auth = Auth;
    this.$http = $http;
    this.autosavedOnce = false;
  }

  _createClass(ServerDraftStorage, [{
    key: 'save',
    value: function save() {
      var _this = this;

      if (this.autosavedOnce) {
        return Promise.reject();
      }
      var keyValuePairs = this.encodeForm();
      return this.$http({
        method: 'POST',
        url: '/ajax/contest/saveDraft.php',
        data: keyValuePairs.join('&'),
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        if (response.data.success) {
          _this.autosavedOnce = true;
          return Promise.resolve(response.data.data);
        }
        return Promise.reject(response.data.data);
      });
    }
  }, {
    key: 'encodeForm',
    value: function encodeForm() {
      var keyValuePairs = [];
      var elements = document.getElementById('post-project-form').elements;
      for (var i = 0; i < elements.length; i++) {
        var elem = elements[i];
        if (elem.name && elem.value) {
          if (elem.type === 'checkbox' || elem.type === 'radio') {
            if (elem.checked) {
              keyValuePairs.push(encodeURIComponent(elem.name) + '=' + encodeURIComponent(elem.value));
            }
          } else {
            keyValuePairs.push(encodeURIComponent(elem.name) + '=' + encodeURIComponent(elem.value));
          }
        }
      }
      return keyValuePairs;
    }
  }, {
    key: 'hasSkills',
    value: function hasSkills(project) {
      return project.skills.length > 0;
    }
  }]);

  return ServerDraftStorage;
}();

ServerDraftStorage$1.$inject = ['$http', 'ProjectData', 'Auth'];

var contestDraftStorageProvider = flService$1('ContestDraftStorage', [ProjectDataProvider, AuthModule], ServerDraftStorage$1);

var ContestPayment = function () {
  function ContestPayment($q, ProjectData, taxName$$1) {
    _classCallCheck(this, ContestPayment);

    this.ProjectData = ProjectData;
    this.$q = $q;
    this.taxName = taxName$$1;
  }

  _createClass(ContestPayment, [{
    key: 'show',
    value: function show(closeModalCallback, parentForm) {
      var deferred = this.$q.defer();
      fixedAmountPaymentModalModule.initModal({
        amount: this.ProjectData.project.prize + this.getUpgradesCost(),
        currencyDetails: this.ProjectData.project.selectedCurrency,
        chargeDetails: this.getChargeDetails(),
        taxName: this.taxName
      }, function () {
        return deferred.resolve();
      }, false, false, false, false, false, false, function () {
        closeModalCallback(parentForm);
      }, false, true);
      return deferred.promise;
    }
  }, {
    key: 'getChargeDetails',
    value: function getChargeDetails() {
      var details = [{
        label: 'Contest Prize',
        amount: this.ProjectData.project.prize
      }];

      if (this.getUpgradesCost() > 0) {
        details.push({
          label: 'Contest Upgrades',
          amount: this.getUpgradesCost()
        });
      }

      return details;
    }
  }, {
    key: 'getUpgradesCost',
    value: function getUpgradesCost() {
      var _this = this;

      return Object.keys(this.ProjectData.project.contestUpgrades).filter(function (upgradeName) {
        return _this.ProjectData.project.contestUpgrades[upgradeName].checked;
      }).reduce(function (total, upgradeName) {
        return total + _this.ProjectData.project.contestUpgrades[upgradeName].price;
      }, 0);
    }
  }]);

  return ContestPayment;
}();

ContestPayment.$inject = ['$q', 'ProjectData', 'taxName'];

var contestPaymentProvider = flService$1('ContestPayment', [ProjectDataProvider, taxName], ContestPayment);

var WizardScrollService = function () {
  function WizardScrollService() {
    _classCallCheck(this, WizardScrollService);

    this.elems = [];
  }

  _createClass(WizardScrollService, [{
    key: 'register',
    value: function register(elem) {
      this.elems.push(elem);
    }
  }, {
    key: 'getNearestToCenter',
    value: function getNearestToCenter(center) {
      var distance = 1000;
      var nearest = void 0;
      this.elems.forEach(function (curr) {
        var rect = curr.getBoundingClientRect();
        var top = rect.top;
        var height = rect.height;
        var mid = height / 2 + top;
        var currDistance = Math.abs(center - mid);
        if (currDistance < distance) {
          distance = currDistance;
          nearest = curr;
        }
      });
      return nearest;
    }
  }]);

  return WizardScrollService;
}();

var WizardScrollServiceProvider = flService$1('WizardScrollService', [], WizardScrollService);

var ScrollStepper = function () {
  function ScrollStepper($scope, $window, $timeout, ProjectData, WizardService, WizardScrollService) {
    _classCallCheck(this, ScrollStepper);

    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.projectData = ProjectData;
    this.WizardService = WizardService;
    this.WizardScrollService = WizardScrollService;
  }

  _createClass(ScrollStepper, [{
    key: 'link',
    value: function link(scope, elem, attr) {
      var _this = this;

      this.step = attr.flScrollStepper;
      this.elem = elem;
      this.WizardScrollService.register(elem[0]);

      var stepObject = this.WizardService.steps[this.step];

      if (stepObject.isButton) {
        return;
      }

      this.elem[0].addEventListener('mousedown', function (event) {
        if (_this.WizardService.currentStep !== _this.step) {
          event.preventDefault();
          _this.WizardService.goToStep(_this.step);
          _this.$scope.$apply();
          if (!_this.WizardService.steps[_this.step].visited) {
            _this.WizardService.scheduleScrollToCurrent();
          }
        }
      });
    }
  }, {
    key: 'getAbsoluteTop',
    value: function getAbsoluteTop() {
      var element = this.elem;
      var top = 0;
      do {
        top += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);

      return {
        top: top
      };
    }
  }]);

  return ScrollStepper;
}();

ScrollStepper.$inject = ['$scope', '$window', '$timeout', 'ProjectData', 'WizardService', 'WizardScrollService'];

var flScrollStepper = flDirective$1(ScrollStepper, {
  selector: '[fl-scroll-stepper]',
  providers: [ProjectDataProvider, WizardServiceProvider, WizardScrollServiceProvider]
});

var template$19 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <legend class=\"PagePostProject-legend\">Does this project need to be done in a specific location?</legend>\n        <nav class=\"PagePostProject-budgetTabs\">\n        <ul class=\"PagePostProject-budgetTabs-cards\">\n            <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                    type=\"radio\"\n                    id=\"no\"\n                    name=\"selectedLocal\"\n                    class=\"focusable-field\"\n                    value=\"no\"\n                    ng-model=\"LocalQuestion.WizardService.selectedLocal\"\n                    ng-click=\"LocalQuestion.WizardService.onChoiceSelect('localQuestion'); LocalQuestion.projectData.toggleLocalJob(false)\">\n                <label for=\"no\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                    <figure class=\"PagePostProject-budgetTabs-figure\">\n                        <img class=\"PagePostProject-budgetTabs-img\" ng-src=\"{[{LocalQuestion.localJobsNoImage}]}\" alt=\"No\">\n                    </figure>\n                    <div class=\"PagePostProject-budgetTabs-details\">\n                        <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                            No, online job\n                        </h4>\n                        <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                            Your project can be completed from anywhere around the world. Expect more competitive bids.\n                        </div>\n                    </div>\n                </label>\n            </li>\n            <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                    type=\"radio\"\n                    id=\"yes\"\n                    name=\"selectedLocal\"\n                    class=\"focusable-field\"\n                    value=\"yes\"\n                    ng-model=\"LocalQuestion.WizardService.selectedLocal\"\n                    ng-click=\"LocalQuestion.WizardService.onChoiceSelect('localQuestion'); LocalQuestion.projectData.toggleLocalJob(true)\"\n                    checked=\"\">\n                <label for=\"yes\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                    <figure class=\"PagePostProject-budgetTabs-figure\">\n                        <img class=\"PagePostProject-budgetTabs-img\" ng-src=\"{[{LocalQuestion.localJobsYesImage}]}\" alt=\"Yes\">\n                    </figure>\n                    <div class=\"PagePostProject-budgetTabs-details\">\n                        <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                            Yes, local job\n                        </h4>\n                        <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                            Freelancers must be in a specific location to bid on your project. Expect fewer, more specific bids.\n                        </div>\n                    </div>\n                </label>\n            </li>\n        </ul>\n        </nav>\n    </fieldset>\n    </div>\n";

var LocalQuestion = function LocalQuestion(ProjectData, WizardService, Cdn, $window, $scope, $timeout) {
  _classCallCheck(this, LocalQuestion);

  this.projectData = ProjectData;
  this.WizardService = WizardService;
  this.$window = $window;
  this.$scope = $scope;
  this.$timeout = $timeout;

  this.localJobsYesImage = Cdn.getCdnUrl('/static/img/ppp/post-project-local.svg');
  this.localJobsNoImage = Cdn.getCdnUrl('/static/img/ppp/post-project-online.svg');
};

LocalQuestion.$inject = ['ProjectData', 'WizardService', 'Cdn', '$window', '$scope', '$timeout'];

var flLocalQuestion = flComponent$1(LocalQuestion, {
  selector: 'fl-local-question',
  transclude: true,
  template: template$19,
  providers: [WizardServiceProvider, ProjectDataProvider, CdnProvider]
});

var template$20 = "<div\n  class=\"alert alert-error\"\n  ng-repeat=\"errorMessage in WizardForm.errorMessages track by $index\"\n  ng-bind-html=\"errorMessage\"\n></div>\n\n<div class=\"T54144\">\n  <form\n    class=\"fl-form PagePostProject-form\"\n    name=\"WizardForm.form\"\n    id=\"post-project-form\"\n    enctype=\"multipart/form-data\"\n  >\n    <input\n      ng-if=\"WizardForm.projectData.project.id\"\n      type=\"hidden\"\n      name=\"projectId\"\n      value=\"{{ WizardForm.projectData.project.id }}\"\n    />\n    <input\n      ng-if=\"WizardForm.projectData.project.id\"\n      type=\"hidden\"\n      name=\"id\"\n      value=\"{{ WizardForm.projectData.project.id }}\"\n    />\n    <input\n      ng-if=\"WizardForm.projectData.project.id\"\n      type=\"hidden\"\n      name=\"submitAction\"\n      value=\"publish project\"\n    />\n    <input\n      ng-if=\"WizardForm.projectData.project.id\"\n      type=\"hidden\"\n      name=\"action\"\n      value=\"updatePublish\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"page_name\"\n      value=\"{{ WizardForm.projectData.project.pageName }}\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"csrf_token\"\n      value=\"{{ WizardForm.projectData.project.csrfToken }}\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"duration\"\n      value=\"{{ WizardForm.projectData.project.duration }}\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"commitment\"\n      value=\"{{ WizardForm.projectData.project.commitment }}\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"commitmentInterval\"\n      value=\"{{ WizardForm.projectData.project.commitmentInterval }}\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"budgetPeriod\"\n      value=\"{{ WizardForm.projectData.project.budgetType }}\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"project_type\"\n      value=\"{{ WizardForm.projectData.project.projectType }}\"\n      ng-if=\"!WizardForm.projectData.contestMode\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"email\"\n      value=\"{{ WizardForm.projectData.project.email }}\"\n      ng-if=\"!WizardForm.userId && !WizardForm.projectData.isNewUser\"\n    />\n    <input\n      id=\"auth-user-type\"\n      type=\"hidden\"\n      name=\"userType\"\n      value=\"userTypeNew\"\n      ng-if=\"!WizardForm.userId && WizardForm.projectData.isNewUser\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"email\"\n      value=\"{{ WizardForm.projectData.project.newEmail }}\"\n      ng-if=\"!WizardForm.userId && WizardForm.projectData.isNewUser\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"newusername\"\n      value=\"{{ WizardForm.projectData.project.newUsername }}\"\n      ng-if=\"!WizardForm.userId && WizardForm.projectData.isNewUser\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"newuserpasswd\"\n      value=\"{{ WizardForm.projectData.project.newPassword }}\"\n      ng-if=\"!WizardForm.userId && WizardForm.projectData.isNewUser\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"newuserpasswd1\"\n      value=\"{{ WizardForm.projectData.project.newPassword }}\"\n      ng-if=\"!WizardForm.userId && WizardForm.projectData.isNewUser\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"invitedUser\"\n      value=\"{{ WizardForm.projectData.project.invitedUser.id }}\"\n      ng-if=\"WizardForm.projectData.project.invitedUser\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"repost_project_id\"\n      value=\"{{ WizardForm.projectData.project.repostProjectId }}\"\n      ng-if=\"WizardForm.projectData.project.repostProjectId\"\n    />\n    <input\n      type=\"hidden\"\n      name=\"saveAsDraft\"\n      value=\"1\"\n      ng-if=\"WizardForm.projectData.contestMode\"\n    />\n\n    <ol>\n      <li\n        id=\"project-title-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"title\"\n      >\n        <fl-title-field form=\"WizardForm.form\"></fl-title-field>\n      </li>\n      <li\n        id=\"description-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"description\"\n        ng-if=\"WizardForm.WizardService.steps['description'].visited || WizardForm.WizardService.steps['title'].visited\"\n      >\n        <fl-description-field form=\"WizardForm.form\"></fl-description-field>\n      </li>\n      <li\n        id=\"skills-selector-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"skills\"\n        ng-if=\"WizardForm.WizardService.steps['skills'].visited\"\n      >\n        <fl-skills-field form=\"WizardForm.form\"></fl-skills-field>\n      </li>\n      <li\n        id=\"contest-upsell\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"contest\"\n        ng-if=\"WizardForm.WizardService.steps['contest'].visited\"\n      >\n        <fl-contest-upsell></fl-contest-upsell>\n      </li>\n      <li\n        id=\"local-question\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"localQuestion\"\n        ng-if=\"WizardForm.WizardService.steps['localQuestion'].visited &&\n                (WizardForm.projectData.localSkills.length > 0 && !WizardForm.projectData.project.areSkillsAllLocal) &&\n                !WizardForm.projectData.contestMode\"\n      >\n        <fl-local-question form=\"WizardForm.form\"></fl-local-question>\n      </li>\n\n      <li\n        id=\"location-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"locationField\"\n        ng-if=\"WizardForm.WizardService.steps['locationField'].visited &&\n                ((WizardForm.WizardService.selectedLocal === 'yes' && WizardForm.projectData.localSkills.length > 0) || WizardForm.projectData.project.areSkillsAllLocal) &&\n                !WizardForm.projectData.contestMode\"\n      >\n        <fl-local-jobs-upsell form=\"WizardForm.form\"></fl-local-jobs-upsell>\n      </li>\n\n      <li\n        id=\"contest-budget-selector\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"contestBudgetSelector\"\n        ng-if=\"WizardForm.WizardService.steps['contestBudgetSelector'].visited && WizardForm.projectData.contestMode\"\n      >\n        <fl-contest-budget-selector\n          form=\"WizardForm.form\"\n        ></fl-contest-budget-selector>\n      </li>\n\n      <li\n        id=\"contest-duration-type\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"contestDurationType\"\n        ng-if=\"WizardForm.WizardService.steps['contestDurationType'].visited && WizardForm.projectData.contestMode && WizardForm.projectData.urgentSkills.length > 0\"\n      >\n        <fl-contest-duration-type\n          form=\"WizardForm.form\"\n        ></fl-contest-duration-type>\n      </li>\n\n      <li\n        id=\"contest-duration-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"contestDuration\"\n        ng-if=\"WizardForm.WizardService.steps['contestDuration'].visited && WizardForm.projectData.contestMode && (WizardForm.projectData.project.durationType !== 'urgent' || WizardForm.projectData.urgentSkills.length === 0)\"\n      >\n        <fl-contest-duration-input\n          form=\"WizardForm.form\"\n        ></fl-contest-duration-input>\n      </li>\n\n      <li\n        id=\"budget-type-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"budgetType\"\n        ng-if=\"WizardForm.WizardService.steps['budgetType'].visited && !WizardForm.projectData.contestMode\"\n      >\n        <fl-budget-selector\n          budget-field=\"budgetType\"\n          form=\"WizardForm.form\"\n        ></fl-budget-selector>\n      </li>\n      <li\n        id=\"estimated-budget-field\"\n        class=\"PagePostProject-listItem\"\n        fl-scroll-stepper=\"estimatedBudget\"\n        ng-if=\"WizardForm.WizardService.steps['estimatedBudget'].visited && !WizardForm.projectData.contestMode\"\n        ng-hide=\"WizardForm.projectData.contestMode\"\n      >\n        <fl-budget-selector\n          budget-field=\"estimatedBudget\"\n          form=\"WizardForm.form\"\n        ></fl-budget-selector>\n      </li>\n\n      <li\n        id=\"upgrades-field\"\n        class=\"PagePostProject-listItem PagePostProject-listItem\"\n        ng-class=\"{'PagePostProject-listItem--last': False}\"\n        data-uitest-target=\"upgradesSection\"\n        fl-scroll-stepper=\"upgrades\"\n        ng-if=\"WizardForm.WizardService.steps['upgrades'].visited && !WizardForm.projectData.contestMode\"\n      >\n        <fl-post-project-upgrades\n          ng-if=\"WizardForm.t133576TestVariation.variant !== 'test'\"\n        ></fl-post-project-upgrades>\n        <fl-post-project-upgrades-abtest\n          ng-if=\"WizardForm.t133576TestVariation.variant === 'test'\"\n          t133576-test-variation=\"WizardForm.t133576TestVariation\"\n        ></fl-post-project-upgrades-abtest>\n      </li>\n\n      <li\n        id=\"contest-upgrades-field\"\n        class=\"PagePostProject-listItem PagePostProject-listItem\"\n        data-uitest-target=\"upgradesSection\"\n        fl-scroll-stepper=\"contestUpgrades\"\n        ng-class=\"{'PagePostProject-listItem--last': False}\"\n        ng-if=\"WizardForm.WizardService.steps['contestUpgrades'].visited && WizardForm.projectData.contestMode\"\n        ng-hide=\"!WizardForm.projectData.contestMode\"\n      >\n        <fl-contest-upgrades></fl-contest-upgrades>\n      </li>\n\n      <li\n        class=\"PagePostProject-listItem PagePostProject-listItem--action\"\n        ng-if=\"WizardForm.WizardService.showNextButton\"\n      >\n        <div ng-if=\"!WizardForm.WizardService.ProjectData.contestMode\">\n          <div class=\"PagePostProject-listItem-action\">\n            <button\n              type=\"button\"\n              class=\"PagePostProject-submit-btn btn btn-info\"\n              ng-click=\"WizardForm.goToNextStep(true)\"\n              ng-disabled=\"!WizardForm.WizardService.validateStep(WizardForm.WizardService.projectLastStep)\"\n            >\n              Next\n            </button>\n            <span\n              class=\"PagePostProject-enter\"\n              ng-class=\"{'is-PagePostProject-enter-inactive': !WizardForm.WizardService.validateStep(WizardForm.WizardService.projectLastStep)}\"\n              ng-if=\"WizardForm.WizardService.projectLastStep !== 'title' && WizardForm.WizardService.projectLastStep !== 'description'\"\n            >\n              Press <strong>ENTER</strong></span\n            >\n            <span\n              class=\"PagePostProject-enter\"\n              ng-class=\"{'is-PagePostProject-enter-inactive': !WizardForm.WizardService.validateStep(WizardForm.WizardService.projectLastStep)}\"\n              ng-if=\"WizardForm.WizardService.projectLastStep === 'title' || WizardForm.WizardService.projectLastStep === 'description'\"\n            >\n              Press <strong>CTRL + ENTER</strong></span\n            >\n          </div>\n        </div>\n        <div ng-if=\"WizardForm.WizardService.ProjectData.contestMode\">\n          <div class=\"PagePostProject-listItem-action\">\n            <button\n              type=\"button\"\n              class=\"PagePostProject-submit-btn btn btn-info\"\n              ng-click=\"WizardForm.goToNextStep(true)\"\n              ng-disabled=\"!WizardForm.WizardService.validateStep(WizardForm.WizardService.contestLastStep)\"\n            >\n              Next\n            </button>\n            <span\n              class=\"PagePostProject-enter\"\n              ng-class=\"{'is-PagePostProject-enter-inactive': !WizardForm.WizardService.validateStep(WizardForm.WizardService.contestLastStep)}\"\n              ng-if=\"WizardForm.WizardService.contestLastStep !== 'title' && WizardForm.WizardService.contestLastStep !== 'description'\"\n            >\n              Press <strong>ENTER</strong></span\n            >\n            <span\n              class=\"PagePostProject-enter\"\n              ng-class=\"{'is-PagePostProject-enter-inactive': !WizardForm.WizardService.validateStep(WizardForm.WizardService.contestLastStep)}\"\n              ng-if=\"WizardForm.WizardService.contestLastStep === 'title' || WizardForm.WizardService.contestLastStep === 'description'\"\n            >\n              Press <strong>CTRL + ENTER</strong></span\n            >\n          </div>\n        </div>\n      </li>\n\n      <li\n        id=\"project-submit-field\"\n        class=\"PagePostProject-listItem PagePostProject-listItem--last\"\n        data-uitest-target=\"submitSection\"\n        fl-scroll-stepper=\"projectSubmit\"\n        ng-if=\"WizardForm.WizardService.steps['projectSubmit'].visited && !WizardForm.projectData.contestMode\"\n      >\n        <div ng-show=\"WizardForm.WizardService.steps['projectSubmit'].visited\">\n          <fl-project-summary></fl-project-summary>\n          <div class=\"PagePostProject-submit\">\n            <div\n              id=\"project-total-cost-container\"\n              class=\"PagePostProject-totalCost\"\n              ng-if=\"WizardForm.UpgradesService.totalCost\"\n            >\n              <strong>\n                Total:\n                <span class=\"currency-sign\">{{\n                  WizardForm.UpgradesService.sign\n                }}</span\n                ><span id=\"project-total-cost\" data-robots=\"ProjectTotalCost\">{{\n                  WizardForm.UpgradesService.totalCost | number: 2\n                }}</span>\n                <span class=\"currency-code\">{{\n                  WizardForm.projectData.project.selectedCurrency.code\n                }}</span>\n              </strong>\n              <span\n                class=\"PagePostProject-totalCost-note\"\n                ng-if=\"WizardForm.UpgradesService.isTaxIncluded && WizardForm.UpgradesService.taxType === 'gst'\"\n              >\n                Including GST\n              </span>\n              <span\n                class=\"PagePostProject-totalCost-note\"\n                ng-if=\"WizardForm.UpgradesService.isTaxIncluded && WizardForm.UpgradesService.taxType === 'vat'\"\n              >\n                Including VAT\n              </span>\n            </div>\n            <button\n              class=\"btn btn-large PagePostProject-submit-btn btn-primary\"\n              ng-class=\"{'processing': WizardForm.projectData.submitInProgress}\"\n              ng-disabled=\"WizardForm.projectData.submitInProgress\"\n              data-qtsb-section=\"PPP\"\n              data-qtsb-label=\"Submit\"\n              data-qtsb-value=\"Project\"\n              data-uitest-target=\"post-project-submit\"\n              ng-click=\"WizardForm.submit()\"\n            >\n              <span>\n                Yes, Post My Project\n              </span>\n            </button>\n          </div>\n          <p class=\"PagePostProject-submit-terms\">\n            By clicking 'Yes, Post My Project', you agree to the\n            <a\n              class=\"PagePostProject-submit-link\"\n              ng-click=\"WizardForm.openTermsAndConditions()\"\n              >Terms & Conditions</a\n            >\n            and\n            <a\n              class=\"PagePostProject-submit-link\"\n              ng-click=\"WizardForm.openPrivacyPolicy()\"\n              >Privacy Policy</a\n            ><br />\n            Copyright © {[{WizardForm.currentYear}]} Freelancer Technology Pty\n            Limited (ACN 142 189 759)\n          </p>\n        </div>\n      </li>\n\n      <li\n        id=\"contest-submit-field\"\n        class=\"PagePostProject-listItem PagePostProject-listItem--last\"\n        data-uitest-target=\"submitSection\"\n        fl-scroll-stepper=\"contestSubmit\"\n        ng-if=\"WizardForm.WizardService.steps['contestSubmit'].visited && WizardForm.projectData.contestMode\"\n        ng-hide=\"!WizardForm.projectData.contestMode\"\n      >\n        <div>\n          <fl-project-summary></fl-project-summary>\n          <div class=\"PagePostProject-submit\">\n            <div\n              id=\"project-total-cost-container\"\n              class=\"PagePostProject-totalCost\"\n              ng-if=\"WizardForm.ContestUpgradesService.totalCost\"\n            >\n              <strong>\n                Total:\n                <span class=\"currency-sign\">{{\n                  WizardForm.ContestUpgradesService.sign\n                }}</span\n                ><span id=\"project-total-cost\" data-robots=\"ProjectTotalCost\">{{\n                  WizardForm.ContestUpgradesService.totalCost | number: 2\n                }}</span>\n                <span class=\"currency-code\">{{\n                  WizardForm.projectData.project.selectedCurrency.code\n                }}</span>\n              </strong>\n              <span\n                class=\"PagePostProject-totalCost-note\"\n                ng-if=\"WizardForm.UpgradesService.isTaxIncluded && WizardForm.UpgradesService.taxType === 'gst'\"\n              >\n                Including GST\n              </span>\n              <span\n                class=\"PagePostProject-totalCost-note\"\n                ng-if=\"WizardForm.UpgradesService.isTaxIncluded && WizardForm.UpgradesService.taxType === 'vat'\"\n              >\n                Including VAT\n              </span>\n            </div>\n            <button\n              class=\"btn btn-large PagePostProject-submit-btn btn-primary\"\n              ng-class=\"{'processing': WizardForm.projectData.submitInProgress}\"\n              ng-disabled=\"WizardForm.projectData.submitInProgress\"\n              data-qtsb-section=\"PPP\"\n              data-qtsb-label=\"Submit\"\n              data-qtsb-value=\"Contest\"\n              data-uitest-target=\"post-project-submit\"\n              ng-click=\"WizardForm.submit()\"\n            >\n              Get Entries Now\n            </button>\n          </div>\n          <p class=\"PagePostProject-submit-terms\">\n            By clicking\n            <span ng-if=\"!WizardForm.inviteToBidTest\">\n              'Get Entries Now',\n            </span>\n            <span ng-if=\"WizardForm.inviteToBidTest\">\n              'Post Project and Invite\n              {{ WizardForm.projectData.project.invitedUser.username }}',\n            </span>\n            you agree to the\n            <a\n              class=\"PagePostProject-submit-link\"\n              ng-click=\"WizardForm.openTermsAndConditions()\"\n              >Terms & Conditions</a\n            >\n            and\n            <a\n              class=\"PagePostProject-submit-link\"\n              ng-click=\"WizardForm.openPrivacyPolicy()\"\n              >Privacy Policy</a\n            ><br />\n            Copyright © {[{WizardForm.currentYear}]} Freelancer Technology Pty\n            Limited (ACN 142 189 759)\n          </p>\n        </div>\n      </li>\n    </ol>\n  </form>\n</div>\n\n<fl-login-signup-angular> </fl-login-signup-angular>\n\n<fl-deposit-modal\n  class=\"ModalPaymentContainer\"\n  fl-analytics-section=\"DepositModal\"\n></fl-deposit-modal>\n";

var DelayedPVService = function () {
  function DelayedPVService($http) {
    _classCallCheck(this, DelayedPVService);

    this.$http = $http;
  }

  _createClass(DelayedPVService, [{
    key: 'shouldRedirectToPV',
    value: function shouldRedirectToPV() {
      return this.$http.get('/ajax/give-and-get/getDelayedPaymentVerifyVars.php').then(function (res) {
        return Promise.resolve(res.data.inExperiment && res.data.isTest && !res.data.isChildPaymentVerified);
      }).catch(function () {
        return false;
      });
    }
  }]);

  return DelayedPVService;
}();

DelayedPVService.$inject = ['$http'];

var DelayedPVServiceProvider = flService$1('DelayedPVService', [], DelayedPVService);

var _templateObject$13 = _taggedTemplateLiteral(['Please deposit funds to publish your project with\n                          selected upgrades and begin receiving bids right away!'], ['Please deposit funds to publish your project with\n                          selected upgrades and begin receiving bids right away!']),
    _templateObject2$5 = _taggedTemplateLiteral(['Please deposit funds to start your contest and\n                            begin receiving entries right away!'], ['Please deposit funds to start your contest and\n                            begin receiving entries right away!']),
    _templateObject3$2 = _taggedTemplateLiteral(['Please deposit funds to start your contest with\n                          selected upgrades and begin receiving entries right away!'], ['Please deposit funds to start your contest with\n                          selected upgrades and begin receiving entries right away!']),
    _templateObject4 = _taggedTemplateLiteral(['You have been restricted from posting a contest.\n          Please do not hesitate to <a href="/support/">contact support</a>\n          for further questions.'], ['You have been restricted from posting a contest.\n          Please do not hesitate to <a href="/support/">contact support</a>\n          for further questions.']),
    _templateObject5 = _taggedTemplateLiteral(['Please deposit funds to publish your project\n          with the selected upgrades and begin receiving bids right away!'], ['Please deposit funds to publish your project\n          with the selected upgrades and begin receiving bids right away!']),
    _templateObject6 = _taggedTemplateLiteral(['Log in to post your contest'], ['Log in to post your contest']),
    _templateObject7 = _taggedTemplateLiteral(['Log in to post your project'], ['Log in to post your project']),
    _templateObject8 = _taggedTemplateLiteral(['Sign up to post your contest'], ['Sign up to post your contest']),
    _templateObject9 = _taggedTemplateLiteral(['Sign up to post your project'], ['Sign up to post your project']),
    _templateObject10 = _taggedTemplateLiteral(['Recruiter Upgrade'], ['Recruiter Upgrade']),
    _templateObject11 = _taggedTemplateLiteral(['Featured Upgrade'], ['Featured Upgrade']),
    _templateObject12 = _taggedTemplateLiteral(['Urgent Upgrade'], ['Urgent Upgrade']),
    _templateObject13 = _taggedTemplateLiteral(['Private Upgrade'], ['Private Upgrade']),
    _templateObject14 = _taggedTemplateLiteral(['NDA Upgrade'], ['NDA Upgrade']),
    _templateObject15 = _taggedTemplateLiteral(['Project Management Package'], ['Project Management Package']);

/**
 * @ngdoc controller
 * @name flWizardForm
 * @description
 * Controls the Post Project Form
 */

var flWizardForm = function () {
  function flWizardForm($q, $log, $http, $rootScope, $scope, $window, $timeout, $location, $element, prefill$$1, Auth, ProjectData, UpgradesService, UpgradesPayment, ContestUpgradesService, AutoSaveDraftService, WizardService, ContestDraftStorage, ContestPayment, LoginSignupConfig, DepositModal, DelayedPVService, escrowCurrencies$$1, isRestrictedUser$$1, Users) {
    var _this = this;

    _classCallCheck(this, flWizardForm);

    this.$q = $q;
    this.$log = $log;
    this.$http = $http;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$location = $location;
    this.$timeout = $timeout;
    this.elem = $element;
    this.currentYear = new Date().getFullYear();
    this.Auth = Auth;
    this.projectData = ProjectData;
    this.UpgradesService = UpgradesService;
    this.UpgradePayments = UpgradesPayment;
    this.ContestUpgradesService = ContestUpgradesService;
    this.AutoSaveDraftService = AutoSaveDraftService;
    this.WizardService = WizardService;
    this.Users = Users;

    this.escrowCurrencies = escrowCurrencies$$1;

    this.userId = this.Auth.getUserId();
    this.authToken = this.Auth.getAccessToken();
    this.errorMessages = [];
    this.disableSubmit = false;
    this.shiftPressed = false;

    this.prefillForm(prefill$$1);
    // Default to Empty (Case: No ABTests on Find Page PJP)
    this.pppABTest = pppABTest || {};
    this.iframeMode = iframeMode;

    this.$window.addEventListener('keydown', function (event) {
      return _this.onKeyDown(event);
    });
    this.ContestDraftStorage = ContestDraftStorage;
    this.ContestPayment = ContestPayment;
    this.loginSignupConfig = LoginSignupConfig;
    this.DepositModal = DepositModal;
    this.DelayedPVService = DelayedPVService;
    this.isRestrictedUser = isRestrictedUser$$1;

    $scope.$on('draftLoaded', function () {
      // On Draft Loads, Validate Project name and description
      angular$1.forEach(_this.form.$error, function (type) {
        angular$1.forEach(type, function (field) {
          field.$setDirty();
        });
      });
    });
  }

  /**
   * @ngdoc method
   * @name WizardForm.prefillForm
   * @description
   * Prefills the Wizard Form if data exists.
   * Checks currency and budget values are valid before prefilling.
   * Waits for skills to be initialised before prefiling it.
   */

  _createClass(flWizardForm, [{
    key: 'prefillForm',
    value: function prefillForm(prefillData) {
      var _this2 = this;

      if (prefillData.repostProjectId) {
        this.projectData.project.repostProjectId = prefillData.repostProjectId;
      }
      if (prefillData.title) {
        this.projectData.project.project_name = prefillData.title;
      }
      if (prefillData.description) {
        this.projectData.project.description = prefillData.description;
      }
      if (prefillData.budgetPeriod) {
        this.projectData.project.budgetType = prefillData.budgetPeriod;
      }
      if (prefillData.budgetId) {
        this.projectData.project.budgetId = prefillData.budgetId;
        if (prefillData.budgetId === 'custom') {
          this.projectData.project.customMinBudget = prefillData.minBudget;
          this.projectData.project.customMaxBudget = prefillData.maxBudget;
          this.projectData.project.customFromPrefill = true;
        }
      }
      this.projectData.project.prefillCurrencyId = prefillData.currencyId;
      if (prefillData.upgrades) {
        if (prefillData.upgrades.length === 1 && prefillData.upgrades[0] === 'recruiter') {
          this.UpgradesService.addRecruiter();
        } else {
          (function () {
            var prom = [];
            prefillData.upgrades.forEach(function (upgradeName) {
              prom.push(_this2.UpgradesService.addUpgrade(upgradeName));
            });

            _this2.$q.all(prom).then(function () {
              return _this2.UpgradesService.getUpgradeFees();
            });
          })();
        }
      }

      // Prefill Skills when they are loaded.
      this.projectData.skillsReadyPromise.then(function () {
        if (prefillData.skills) {
          prefillData.skills.forEach(function (skillId) {
            return _this2.projectData.addSelectedSkillById(parseInt(skillId, 10), 'skills-prefill');
          });
          _this2.projectData.project.skillsDefinedByUser = true;
        }
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      this.form.$setSubmitted();
      if (!this.WizardService.validate()) {
        return;
      }

      if (this.projectData.submitInProgress) {
        return;
      }

      this.projectData.submitInProgress = true;
      if (this.userId || this.projectData.project.email) {
        this.onSubmitCallback();
      } else {
        this.showSignupModal();
      }
      if (this.projectData.submitInProgress) {
        this.AutoSaveDraftService.clear(true);
      }
    }
  }, {
    key: 'focusError',
    value: function focusError() {
      var errorFields = this.elem[0].getElementsByClassName('ng-invalid');
      // form is included as first match
      if (errorFields.length > 1) {
        if (errorFields[1].classList.contains('focusable-field')) {
          errorFields[1].focus();
        } else {
          var focusable = errorFields[1].getElementsByClassName('focusable-field');
          if (focusable.length > 0) {
            focusable[0].focus();
          }
        }
      }
    }
  }, {
    key: 'openNewDepositModal',
    value: function openNewDepositModal() {
      var _this3 = this;

      var webappCompatModalsReady = new Promise(function (resolve) {
        if (window.webappCompatModals) {
          resolve();
        } else {
          window.webappCompatModalsReadyCallback = function () {
            return resolve();
          };
        }
      });
      var depositItems = this.getDepositItemsSummary();
      var totalAmount = this.getTotalDepositAmount();
      var depositMessage = translate(_templateObject$13);

      if (this.projectData.contestMode) {
        if (depositItems.length === 1) {
          depositMessage = translate(_templateObject2$5);
        } else {
          depositMessage = translate(_templateObject3$2);
        }
      }

      var depositItemSummary = this.getNewDepositModalItems(this.getFeesSummary(depositItems));
      // "calculated" based on the `@shared/modal-deposit/index.js`
      var trackingToken = 'API|' + (this.projectData.contestMode === true ? 'postcontest' : 'postproject') + '|deposit_modal|Desktop|deposit|1';
      return webappCompatModalsReady.then(function () {
        window.webappCompatModals.setSession(_this3.userId, _this3.authToken);
        return window.webappCompatModals.open('PaymentsModalComponent', {
          inputs: {
            chargeCurrencyId: _this3.projectData.project.selectedCurrency.id,
            chargeAmount: totalAmount,
            banner: { body: depositMessage },
            items: depositItemSummary,
            trackingToken: trackingToken
          },
          size: 'large',
          closeOnBackdropClick: false
        }, function (result) {
          _this3.onNewDepositModalCallback(result);
        });
      });
    }
  }, {
    key: 'onNewDepositModalCallback',
    value: function onNewDepositModalCallback(result) {
      switch (result) {
        case 'success':
          this.submitDomForm();
          break;
        case 'redirect':
          this.redirectToDepositPage(this.getTotalDepositAmount(), this.projectData.project.selectedCurrency.id);
          break;
        case 'interrupted':
        case 'pending': // this won't happen, modal doesnt't display non instant methods
        default:
          this.onCloseDepositModal();
          break;
      }
    }
  }, {
    key: 'onSubmitCallback',
    value: function onSubmitCallback() {
      var _this4 = this;

      if (this.projectData.contestMode) {
        if (this.isRestrictedUser) {
          this.errorMessages = [oneLine(_templateObject4)];
          this.WizardService.focusStep('title');
          return;
        }

        this.DelayedPVService.shouldRedirectToPV().then(function (shouldRedirectToPV) {
          if (!shouldRedirectToPV) {
            _this4.showContestPayment();
          } else {
            _this4.saveContestAndForcePV();
          }
        }).catch(function () {
          return _this4.showContestPayment();
        });
        return;
      }

      if (this.UpgradesService.totalCost > 0) {
        this.$timeout(function () {
          return _this4.UpgradesService.getUpgradeFees().then(function () {
            return _this4.openNewDepositModal().catch(function () {
              _this4.projectData.submitInProgress = false;
            });
          }).catch(function () {
            _this4.projectData.submitInProgress = false;
          });
        }, 300);
        return;
      }

      this.submitDomForm();
    }
  }, {
    key: 'redirectToDepositPage',
    value: function redirectToDepositPage(amount, currencyId) {
      var _this5 = this;

      this.AutoSaveDraftService.cancelPendingAutosave();
      this.AutoSaveDraftService.save().then(function () {
        return _this5.redirect('/deposit/?amount=' + amount + '&currency=' + currencyId + '&checkBalance=true&refAction=post_project');
      });
    }
  }, {
    key: 'showContestPayment',
    value: function showContestPayment() {
      var _this6 = this;

      this.ContestUpgradesService.getUpgradeFees().then(function () {
        _this6.openNewDepositModal().catch(function () {
          _this6.projectData.submitInProgress = false;
        });
      }).catch(function () {
        _this6.projectData.submitInProgress = false;
      });
    }
  }, {
    key: 'redirect',
    value: function redirect(url) {
      if (this.iframeMode) {
        window.top.location.href = url;
      } else {
        window.location = url;
      }
    }
  }, {
    key: 'getTotalDepositAmount',
    value: function getTotalDepositAmount() {
      return this.projectData.contestMode ? this.ContestUpgradesService.totalCost : this.UpgradesService.totalCost;
    }
  }, {
    key: 'getDepositItemsSummary',
    value: function getDepositItemsSummary() {
      return this.projectData.contestMode ? this.ContestPayment.getChargeDetails() : this.UpgradePayments.getChargeDetails();
    }

    /**
     * @description
     * Before Submitting the job, check whether the User needs to deposit funds.
     */

  }, {
    key: 'checkUserBalance',
    value: function checkUserBalance() {
      var _this7 = this;

      var depositItemSummary = this.getFeesSummary(this.getDepositItemsSummary());
      var totalAmount = this.getTotalDepositAmount();
      // Check User Balance
      var payload = new FormData();
      payload.append('currency', this.projectData.project.selectedCurrency.id);
      payload.append('amount', totalAmount);
      payload.append('isPPP', true);
      this.$http.post('/ajax/payment/getUserPaymentMethodInfo.php', payload, {
        headers: { 'Content-Type': undefined },
        transformRequest: true
      }).then(function (paymentMethodInfo) {
        var paymentSource = paymentMethodInfo.data;
        var _items = {
          summary: depositItemSummary,
          balance: paymentSource.totalBalance.amount,
          balances: paymentSource.balances,
          payByBalance: paymentSource.totalBalance.amount >= totalAmount
        };
        var _tracking = {
          source: _this7.projectData.contestMode === true ? 'postcontest' : 'postproject',
          reference_type: 'deposit',
          reference_id: 1
        };
        var _currency = _this7.projectData.project.selectedCurrency;
        _currency.id = parseInt(_currency.id, 10);
        // Show deposit message if not paying by balance
        var _depositMessage = translate(_templateObject5);

        var result = _this7.DepositModal.open({
          config: {
            currency: function currency$$1() {
              return _currency;
            },
            amount: function amount() {
              return totalAmount - paymentSource.totalBalance.amount;
            },
            items: function items() {
              return _items;
            },
            tracking: function tracking() {
              return _tracking;
            },
            depositMessage: function depositMessage() {
              return _items.payByBalance ? '' : _depositMessage;
            }
          }
        });
        result.result.then(function (response) {
          switch (response) {
            case 'close':
              _this7.onCloseDepositModal();
              break;
            case 'success':
              _this7.submitDomForm();
              break;
            case 'depositPage':
              _this7.submitDomForm();
              break;
            default:
              _this7.submitDomForm();
          }
        }).catch(function () {
          _this7.projectData.submitInProgress = false;
        });
      }).catch(function () {
        _this7.projectData.submitInProgress = false;
      });
    }
  }, {
    key: 'submitDomForm',
    value: function submitDomForm() {
      var _this8 = this;

      this.trackSubmit();
      if (this.projectData.contestMode) {
        this.submitContest();
        return;
      }
      this.AutoSaveDraftService.cancelPendingAutosave();
      this.AutoSaveDraftService.save().then(function () {
        return _this8.postForm();
      });
    }
  }, {
    key: 'getProjectIdFromRedirectUrl',
    value: function getProjectIdFromRedirectUrl(redirectUrl) {
      var url = new URL(this.$location.protocol() + '://' + this.$location.host() + redirectUrl);
      var urlPath = url.pathname;
      var urlParams = url.searchParams;
      var action = urlParams.get('action');
      var projectId = urlParams.get('id');
      // projectId will be return as a string.
      if (urlPath === '/buyers/draft.php' && action === 'publish' && /^[0-9]+$/.test(projectId)) {
        return projectId;
      }
      return null;
    }
  }, {
    key: 'getJobIdsFromForm',
    value: function getJobIdsFromForm(formKeyValuePairs) {
      // Structure of `formKeyValuePairs` is an array of
      // strings `<key>=<value>`
      // The jobs are `job_<id>=on`

      var jobEntries = formKeyValuePairs.filter(function (entry) {
        return entry.startsWith('job_');
      });

      // Need to return `job_ids[]=<job_id>` array since we have
      // to be url encoded value to post in the form.
      return jobEntries.map(function (entry) {
        var key = entry.split('=')[0];
        var jobId = key.split('_')[1];
        return 'job_ids[]=' + jobId;
      });
    }
  }, {
    key: 'postForm',
    value: function postForm() {
      var _this9 = this;

      // This function will do an AJAX call to either create a draft or
      // use an existing draft project (shouldn't happen anymore).
      // After the draft is created and a Project ID is returned, it will
      // publish the draft which therefore changes the project from a draft
      // to an active project.
      this.$timeout(function () {
        var keyValuePairs = _this9.encodeForm();
        keyValuePairs.push('ajax=' + true);

        return _this9.$http({
          method: 'POST',
          url: _this9.getAction(),
          data: keyValuePairs.join('&'),
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          if (response.data) {
            if (response.data.error_messages !== undefined) {
              _this9.projectData.submitInProgress = false;
              _this9.errorMessages = response.data.error_messages;
              _this9.WizardService.focusStep('title'); // scroll to the top
              return;
            }

            if (window.localStorage) {
              // delete posted draft from logged out local storage
              window.localStorage.removeItem(LOCAL_DRAFT_STORAGE);
            }

            if (response.data.url !== undefined) {
              return response.data.url;
            }
          }
        }).then(function (redirectUrl) {
          if (redirectUrl) {
            var projectId = _this9.getProjectIdFromRedirectUrl(redirectUrl);
            if (!projectId) {
              return redirectUrl;
            }
            // I need to convert these to url encoded because for
            // the backend, it can only type check if it is url
            // encoded.
            var projectJobOrderPayload = ['project_id=' + projectId].concat(_this9.getJobIdsFromForm(keyValuePairs));

            return _this9.$http({
              method: 'POST',
              url: '/ajax/project/recordProjectJobOrder.php',
              data: projectJobOrderPayload.join('&'),
              headers: {
                'Content-type': 'application/x-www-form-urlencoded'
              }
            }).then(function () {
              return redirectUrl;
            });
          }

          return redirectUrl;
        }).then(function (redirectUrl) {
          if (redirectUrl) {
            _this9.Users.getByUserId(_this9.userId).then(function (response) {
              var user = response.user;
              if (user && user.location && user.location.country && ['United States', 'United Kingdom', 'Australia', 'New Zealand', 'Canada'].includes(user.location.country.name)) {
                Tracking.trackCustomEvent('Post Non Hire Me Project', 'PJPPostCTA', {
                  skills: _this9.projectData.project.selectedSkills.map(function (s) {
                    return s.name;
                  })
                });
              }
            }).then(function () {
              _this9.redirect(redirectUrl);
            });
          }
        }).catch(function (e) {
          _this9.projectData.submitInProgress = false;
          _this9.$log.error('There is something wrong with the request. Please contact support if problem persists.', e);
        });
      }, 300);
    }
  }, {
    key: 'encodeForm',
    value: function encodeForm() {
      // Structure of `formKeyValuePairs` is an array of
      // strings `<key>=<value>`
      // Key = name attribute of element
      // Value = value of element
      var keyValuePairs = [];
      var elements = document.getElementById('post-project-form').elements;
      for (var i = 0; i < elements.length; i++) {
        var elem = elements[i];
        if (elem.name && elem.value) {
          if (elem.type === 'checkbox' || elem.type === 'radio') {
            if (elem.checked) {
              keyValuePairs.push(encodeURIComponent(elem.name) + '=' + encodeURIComponent(elem.value));
            }
          } else {
            keyValuePairs.push(encodeURIComponent(elem.name) + '=' + encodeURIComponent(elem.value));
          }
        }
      }
      return keyValuePairs;
    }
  }, {
    key: 'submitContest',
    value: function submitContest() {
      var _this10 = this;

      this.$timeout(function () {
        _this10.ContestDraftStorage.save().then(function (data) {
          _this10.Users.getByUserId(_this10.userId).then(function (response) {
            var user = response.user;
            if (user && user.location && user.location.country && ['United States', 'United Kingdom', 'Australia', 'New Zealand', 'Canada'].includes(user.location.country.name)) {
              Tracking.trackCustomEvent('Post Contest', 'PJPPostCTA', {
                skills: _this10.projectData.project.selectedSkills.map(function (s) {
                  return s.name;
                })
              });
            }
          }).then(function () {
            _this10.AutoSaveDraftService.storage.clear();
            _this10.redirect(data.publishUrl);
          });
        }).catch(function (data) {
          _this10.onContestSaveError(data);
        });
      }, 100);
    }
  }, {
    key: 'saveContestAndForcePV',
    value: function saveContestAndForcePV() {
      var _this11 = this;

      this.$timeout(function () {
        _this11.ContestDraftStorage.save().then(function (data) {
          _this11.AutoSaveDraftService.storage.clear();
          _this11.redirect('/payments/verify.php?referral-program=true\n              &new_signup=true&contest_redirect_url=' + encodeURIComponent(data.publishUrl));
        }).catch(function (data) {
          _this11.onContestSaveError(data);
        });
      }, 100);
    }
  }, {
    key: 'onContestSaveError',
    value: function onContestSaveError(data) {
      this.projectData.submitInProgress = false;

      if (data.errors.contest_name) {
        this.form.visible_name.$setValidity('uniqueName', false);
        this.WizardService.focusStep('title');
      }

      if (data.errors.user_id) {
        this.errorMessages = data.errors.user_id;
        this.WizardService.focusStep('title');
      }
    }
  }, {
    key: 'trackSubmit',
    value: function trackSubmit() {
      var value = this.projectData.contestMode ? 'Contest' : 'Project';
      qtsp.push({
        section: 'WizardPPP',
        name: 'PostClientValidation',
        label: 'PostJobNow',
        value: value
      });
    }
  }, {
    key: 'showSignupModal',
    value: function showSignupModal() {
      var _this12 = this;

      this.loginSignupConfig.showSignup({
        loginTitle: this.projectData.contestMode ? translate(_templateObject6) : translate(_templateObject7),
        signupTitle: this.projectData.contestMode ? translate(_templateObject8) : translate(_templateObject9),
        forcedAccountType: 'employer',
        pageName: this.projectData.project.pageName,
        showAppLinks: false,
        disableRedirect: true
      }).then(function () {
        // Resolves only on Successful Login or Signup
        _this12.userId = _this12.Auth.getUserId();
        _this12.authToken = _this12.Auth.getAccessToken();

        if (!_this12.escrowCurrencies.includes(_this12.projectData.project.selectedCurrency.code)) {
          fetch('/ajax-api/user/isUserPotentiallyCalifornian.php', {
            headers: new Headers(getAuthHeader()),
            method: 'GET',
            credentials: 'same-origin'
          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            if (response && response.status === 'success' && response.result) {
              if (response.result.isUserCali) {
                _this12.errorMessages = ['Please select a supported currency for Californian users and try again.'];
                _this12.projectData.project.isEscrowCurrencyRestricted = true;
                _this12.WizardService.focusStep('title');
                _this12.projectData.submitInProgress = false;

                return;
              }

              _this12.onSubmitCallback();
            }
          }).catch(function () {});
          return;
        }
        _this12.onSubmitCallback();
      }).catch(function () {
        _this12.$scope.$evalAsync(function () {
          _this12.projectData.submitInProgress = false;
        });
      });
    }
  }, {
    key: 'getAction',
    value: function getAction() {
      // I don't think project_id should appear anymore since that is
      // for the older drafts.
      // We remove the project_id whenever we get a draft now
      // (if it ever existed).
      // TODO: If we want to remove it, let's add tracking to it.
      return this.projectData.project.id ? '/buyers/draft.php' : '/buyers/onverifycreate.php';
    }
  }, {
    key: 'openTermsAndConditions',
    value: function openTermsAndConditions() {
      this.openSmallWindow('../info/plainterms.html');
    }
  }, {
    key: 'openPrivacyPolicy',
    value: function openPrivacyPolicy() {
      this.openSmallWindow('../page.php?p=info/privacy&popup=true');
    }
  }, {
    key: 'openSmallWindow',
    value: function openSmallWindow(url) {
      var options = 'width=700, height=550, left=0,top=0,menu=no, toolbar=no,scrollbars=yes,resizable=yes';
      this.$window.open(url, '', options);
    }

    /**
     * @ngdoc method
     * @name WizardForm.onClosePaymentModalCallback
     *
     * @description
     * Callback passed to deposit modal to enable the submit button
     * when the modal is closed.
     *
     * @param parentForm this is needed to reference this service from the
     * UiModal SystemJS module when it calls the callback because `this`
     * will become undefined.
     */

  }, {
    key: 'onClosePaymentModalCallback',
    value: function onClosePaymentModalCallback(parentForm) {
      parentForm.projectData.submitInProgress = false;
      parentForm.$timeout(function () {
        return parentForm.$scope.$apply();
      }, 0);
      qtsp.push({
        section: 'ExpandedPaymentConfirmationModalPPP',
        label: 'CloseModal'
      });
    }
  }, {
    key: 'onCloseDepositModal',
    value: function onCloseDepositModal() {
      var _this13 = this;

      this.$scope.$evalAsync(function () {
        _this13.projectData.submitInProgress = false;
      });
    }
  }, {
    key: 'goToNextStep',
    value: function goToNextStep(fromButton) {
      var currentStep = this.WizardService.steps[this.WizardService.currentStep];

      // T66662: Find Page PJP
      // hide the how it works step (for find page)
      // NOTE: Move to find page module if test wins.
      var findPageExtraInfoEl = document.getElementById('find-page-extra-info');
      if (findPageExtraInfoEl) {
        findPageExtraInfoEl.classList.add('is-PageFind-extraInfo-closing');
        setTimeout(function () {
          findPageExtraInfoEl.remove();
          var findPageEl = document.getElementsByClassName('PageFind');
          if (findPageEl.length > 0) {
            findPageEl[0].classList.remove('PageFind--showExtraInfo');
          }
        }, 1000);
      }

      if (this.WizardService.currentStep === 'description' && !this.WizardService.validateStep(this.WizardService.currentStep) || currentStep.validate && !currentStep.validate()) {
        return;
      }
      if (!this.WizardService.hasNext()) {
        this.submit();
        return;
      }
      this.WizardService.enableNext = false;
      this.WizardService.goToNextStep(fromButton);
      if (this.WizardService.currentStep === 'skills') {
        this.projectData.detectSkills();
        this.projectData.getJobClassification();
      }
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      switch (event.keyCode) {
        // Tab
        case 9:
          {
            if (this.loginSignupConfig.isVisible()) {
              return;
            }

            event.preventDefault();

            if (event.shiftKey) {
              this.WizardService.goToPreviousStep();
            } else {
              if (this.WizardService.currentStep === 'contest') {
                return;
              }
              this.goToNextStep();
            }
            break;
          }
        // Enter
        case 13:
          {
            if (event.target.id === 'project-description' && !event.ctrlKey || this.loginSignupConfig.isVisible()) {
              return;
            }

            event.preventDefault();
            if (this.WizardService.currentStep !== 'contest') {
              this.goToNextStep();
            }
            break;
          }
        // arrow keys: left, up, right, down
        case 37:
        case 38:
        case 39:
        case 40:
          if (this.loginSignupConfig.isVisible()) {
            return;
          }

          if (this.WizardService.steps[this.WizardService.currentStep].isButton) {
            event.preventDefault();
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: 'getNewDepositModalItems',
    value: function getNewDepositModalItems(items) {
      return items.map(function (i) {
        return {
          description: i.descr,
          amount: i.amount
        };
      });
    }

    /**
     * @description
     * Summarize Upgrade information for to show info for the deposit modal
     */

  }, {
    key: 'getFeesSummary',
    value: function getFeesSummary(items) {
      var _this14 = this;

      items.forEach(function (upgrade) {
        upgrade.descr = _this14.getReadableUpgradeName(upgrade.label);
        delete upgrade.label;
      });

      return items;
    }
  }, {
    key: 'getReadableUpgradeName',
    value: function getReadableUpgradeName(upgradeName) {
      switch (upgradeName) {
        case 'Recruiter':
          return translate(_templateObject10);
        case 'Featured':
          return translate(_templateObject11);
        case 'Urgent':
          return translate(_templateObject12);
        case 'Private':
          return translate(_templateObject13);
        case 'Nda':
          return translate(_templateObject14);
        case 'Project_management_bundle':
          return translate(_templateObject15);
        default:
          return upgradeName;
      }
    }
  }]);

  return flWizardForm;
}();

flWizardForm.$inject = ['$q', '$log', '$http', '$rootScope', '$scope', '$window', '$timeout', '$location', '$element', 'prefill', 'Auth', 'ProjectData', 'UpgradesService', 'UpgradesPayment', 'ContestUpgradesService', 'AutoSaveDraftService', 'WizardService', 'ContestDraftStorage', 'ContestPayment', 'LoginSignupConfig', 'DepositModal', 'DelayedPVService', 'escrowCurrencies', 'isRestrictedUser', 'Users'];

function getTemplate() {
  return template$20;
}

var flWizardForm$1 = flComponent$1(flWizardForm, {
  selector: 'fl-wizard-form',
  transclude: true,
  template: getTemplate(),
  bindings: {
    t133576TestVariation: '=' },
  providers: [ngSanitize, AuthModule, AutoSaveDraftServiceProvider, flScrollStepper, flUiModalProvider, prefill, ProjectDataProvider, UpgradesPaymentProvider, UpgradesServiceProvider, ContestUpgradesServiceProvider, WizardServiceProvider, flLocalQuestion, flContestBudgetSelector$1, contestDraftStorageProvider, contestPaymentProvider, LoginSignupComponent, LoginSignupConfigProvider, depositModalProvider, DelayedPVServiceProvider, escrowCurrencies, isRestrictedUser, UsersProvider]
});

var template$21 = "<ul class=\"PagePostProject-advancedUpgrades\">\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_assisted\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedUpgrades.ProjectData.project.upgrades.recruiter.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"chkbx_assisted\"\n                        data-name=\"assisted\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_assisted\"\n                        ng-model=\"AdvancedUpgrades.ProjectData.project.upgrades.recruiter.checked\"\n                        ng-change=\"AdvancedUpgrades.UpgradesService.computeAdvanced('recruiter')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-assisted\">Recruiter</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">One of our experts will find and recommend the perfect freelancer for your job, saving you time. The best experience for new users.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div ng-if=\"!AdvancedUpgrades.UpgradesService.freeRecruiter\">\n                        <div class=\"PagePostProject-halfPrice\">\n                            <div class=\"PagePostProject-advancedUpgrades-price-value PagePostProject-halfPrice-newPrice\">\n                              Only\n                              <span class=\"currency-sign\">{{AdvancedUpgrades.UpgradesService.sign}}</span><span>{{AdvancedUpgrades.UpgradesService.projectData.upgrades.recruiter.price | number : 2}}</span>\n                            </div>\n                        </div>\n                        <div id=\"priced_assisted_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value PagePostProject-halfPrice-oldPrice\">\n                            <span id=\"recruiter-card-price\" data-uitest-target=\"RecruiterUpgradePrice\">\n                                <span class=\"currency-sign\">{{AdvancedUpgrades.UpgradesService.sign}}</span><span>{{AdvancedUpgrades.UpgradesService.fullRecruiterPrice | number : 2}}</span>\n                            </span>\n                        </div>\n                    </div>\n                    <div ng-if=\"AdvancedUpgrades.UpgradesService.freeRecruiter\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span id=\"assisted-upgrade-price\" data-uitest-target=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_nda\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedUpgrades.ProjectData.project.upgrades.nda.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"chkbx_NDA\"\n                        data-name=\"nda\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_nda\"\n                        ng-model=\"AdvancedUpgrades.ProjectData.project.upgrades.nda.checked\"\n                        ng-change=\"AdvancedUpgrades.UpgradesService.computeAdvanced('nda')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-nda\">NDA</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Freelancers must sign a Non-disclosure Agreement to work on your project. Freelancers agree to keep details discussed through private messages and files confidential.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div ng-if=\"!AdvancedUpgrades.UpgradesService.freeNDA\">\n                        <div id=\"priced_nda_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                            <span ng-if=\"!AdvancedUpgrades.UpgradesService.freeNda\" class=\"currency-sign\">{{AdvancedUpgrades.UpgradesService.sign}}</span><span ng-if=\"!AdvancedUpgrades.UpgradesService.freeNda\"\n                            id=\"nda-upgrade-price\" data-uitest-target=\"NdaUpgradePrice\">{{AdvancedUpgrades.ProjectData.project.upgrades.nda.price | number : 2}}</span>\n                        </div>\n                    </div>\n                    <div ng-if=\"AdvancedUpgrades.UpgradesService.freeNDA\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span id=\"nda-upgrade-price\" data-uitest-target=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n\n\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_featured\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedUpgrades.ProjectData.project.upgrades.featured.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"chkbx_featured\"\n                        data-name=\"featured\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_featured\"\n                        ng-model=\"AdvancedUpgrades.ProjectData.project.upgrades.featured.checked\"\n                        ng-change=\"AdvancedUpgrades.UpgradesService.computeAdvanced('featured')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-featured\">Featured</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Featured projects attract higher-quality bids and are displayed prominently in the 'Featured Jobs and Contests' page.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_featured_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedUpgrades.UpgradesService.freeFeatured\" class=\"currency-sign\">{{AdvancedUpgrades.UpgradesService.sign}}</span><span ng-if=\"!AdvancedUpgrades.UpgradesService.freeFeatured\"\n                        id=\"featured-upgrade-price\" data-uitest-target=\"FeaturedUpgradePrice\">{{AdvancedUpgrades.ProjectData.project.upgrades.featured.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedUpgrades.UpgradesService.freeFeatured\" id=\"assisted-upgrade-price\" data-uitest-target=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_urgent\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedUpgrades.ProjectData.project.upgrades.urgent.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"chkbx_urgent\"\n                        data-name=\"urgent\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_urgent\"\n                        ng-model=\"AdvancedUpgrades.ProjectData.project.upgrades.urgent.checked\"\n                        ng-change=\"AdvancedUpgrades.UpgradesService.computeAdvanced('urgent')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-urgent\">Urgent</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Make your project stand out and let freelancers know that your job is time sensitive.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_urgent_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedUpgrades.UpgradesService.freeUrgent\" class=\"currency-sign\">{{AdvancedUpgrades.UpgradesService.sign}}</span><span ng-if=\"!AdvancedUpgrades.UpgradesService.freeUrgent\"\n                        id=\"urgent-upgrade-price\" data-uitest-target=\"UrgentUpgradePrice\">{{AdvancedUpgrades.ProjectData.project.upgrades.urgent.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedUpgrades.UpgradesService.freeUrgent\" id=\"assisted-upgrade-price\" data-uitest-target=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_private\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedUpgrades.ProjectData.project.upgrades.private.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"chkbx_nonpublic\"\n                        data-name=\"private\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_private\"\n                        ng-model=\"AdvancedUpgrades.ProjectData.project.upgrades.private.checked\"\n                        ng-change=\"AdvancedUpgrades.UpgradesService.computeAdvanced('private')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-private\">Private</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Hide project details from search engines and users that are not logged in, for projects that you need to keep confidential.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_private_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedUpgrades.UpgradesService.freePrivate\" class=\"currency-sign\">{{AdvancedUpgrades.UpgradesService.sign}}</span><span ng-if=\"!AdvancedUpgrades.UpgradesService.freePrivate\"\n                        id=\"private-upgrade-price\" data-uitest-target=\"PrivateUpgradePrice\">{{AdvancedUpgrades.ProjectData.project.upgrades.private.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedUpgrades.UpgradesService.freePrivate\" id=\"assisted-upgrade-price\" data-uitest-target=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n</ul>\n";

var AdvancedUpgrades = function AdvancedUpgrades(UpgradesService, ProjectData) {
  _classCallCheck(this, AdvancedUpgrades);

  this.UpgradesService = UpgradesService;
  this.ProjectData = ProjectData;
};

AdvancedUpgrades.$inject = ['UpgradesService', 'ProjectData'];

function getTemplate$1() {
  return template$21;
}

var AdvancedUpgrades$1 = flComponent$1(AdvancedUpgrades, {
  selector: 'fl-advanced-upgrades',
  template: getTemplate$1(),
  providers: [ProjectDataProvider, UpgradesServiceProvider]
});

var template$22 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <legend class=\"PagePostProject-legend\">Do you need a helping hand?</legend>\n        <nav class=\"PagePostProject-budgetTabs\">\n            <ul class=\"PagePostProject-budgetTabs-cards\">\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\" >\n                    <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        id=\"standard\"\n                        name=\"optional-upgrades\"\n                        value=\"standard\"\n                        ng-model=\"PostProjectUpgrades.UpgradesService.projectData.selectedUpgrade\"\n                        ng-click=\"PostProjectUpgrades.WizardService.onChoiceSelect('upgrades')\"\n                        ng-change=\"PostProjectUpgrades.UpgradesService.changeUpgradeSelection()\"\n                        fl-toggle-wizard-next=\"upgrades\">\n                    <label for=\"standard\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/ppp/project-001.svg\" alt=\"Fixed price project\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Standard project\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Free to post, your project will go live instantly and start receiving bids within seconds.\n                            </div>\n                            <div class=\"PagePostProject-budgetTabs-price\">\n                                <strong>Free</strong>\n                            </div>\n                        </div>\n                    </label>\n                </li>\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                    <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        id=\"recruiter\"\n                        name=\"optional-upgrades\"\n                        value=\"recruiter\"\n                        ng-model=\"PostProjectUpgrades.UpgradesService.projectData.selectedUpgrade\"\n                        ng-click=\"PostProjectUpgrades.WizardService.onChoiceSelect('upgrades')\"\n                        ng-change=\"PostProjectUpgrades.UpgradesService.changeUpgradeSelection()\"\n                        fl-toggle-wizard-next=\"upgrades\">\n                    <label for=\"recruiter\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/ppp/recruiter-001.svg\" alt=\"Hourly price project\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                <span class=\"PagePostProject-budgetTabs-headingWithPromotion\">\n                                    <span class=\"PagePostProject-budgetTabs-promotion\">\n                                        Recommended</span>\n                                    <span class=\"PagePostProject-budgetTabs-title\">Recruiter project</span>\n                                </span>\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                We'll assign one of our expert staff to help you find the perfect freelancer for the job.\n                            </div>\n                            <div class=\"PagePostProject-budgetTabs-price\"\n                                ng-if=\"!PostProjectUpgrades.UpgradesService.freeRecruiter\">\n                                <span class=\"PagePostProject-halfPrice-priceWrapper\">\n                                    <span class=\"PagePostProject-halfPrice-newPrice\">\n                                    Only <span class=\"currency-sign\">{{PostProjectUpgrades.UpgradesService.sign}}</span><span>{{PostProjectUpgrades.UpgradesService.projectData.upgrades.recruiter.price | number : 2}}</span>\n                                </span>\n                                <strong class=\"PagePostProject-halfPrice-oldPrice\">\n                                    <span id=\"recruiter-card-price\" data-robots=\"RecruiterUpgradePrice\">\n                                        <span class=\"currency-sign\">{{PostProjectUpgrades.UpgradesService.sign}}</span><span>{{PostProjectUpgrades.UpgradesService.fullRecruiterPrice | number : 2}}</span>\n                                    </span>\n                                </strong>\n                            </div>\n                            <div class=\"PagePostProject-budgetTabs-price\"\n                                ng-if=\"PostProjectUpgrades.UpgradesService.freeRecruiter\">\n                                <strong>\n                                <span id=\"recruiter-card-price\" data-robots=\"RecruiterUpgradePrice\">Free</span>\n                                </strong>\n                            </div>\n                            </div>\n                        </div>\n                    </label>\n                </li>\n            </ul>\n        </nav>\n        <div class=\"PagePostProject-advanceOptions PagePostProject-budgetTabs-footer\">\n            <div class=\"PagePostProject-advanceOptions-heading\">\n                <label class=\"PagePostProject-advanceOptions-label\"\n                    for=\"advanced\"\n                    ng-show=\"PostProjectUpgrades.UpgradesService.projectData.selectedUpgrade!=='advanced'\"\n                    ng-click=\"PostProjectUpgrades.WizardService.toggleNextButton(!PostProjectUpgrades.WizardService.steps.projectSubmit.visited);\">Show Advanced Options</label>\n                <label class=\"PagePostProject-advanceOptions-label\"\n                    ng-show=\"PostProjectUpgrades.UpgradesService.projectData.selectedUpgrade==='advanced'\"\n                    ng-click=\"PostProjectUpgrades.WizardService.toggleNextButton(false); PostProjectUpgrades.resetSelected()\">Hide Advanced Options</label>\n            </div>\n            <input class=\"PagePostProject-advanceOptions-input\" type=\"radio\"\n                id=\"advanced\"\n                name=\"optional-upgrades\"\n                value=\"advanced\"\n                ng-model=\"PostProjectUpgrades.UpgradesService.projectData.selectedUpgrade\"\n                ng-change=\"PostProjectUpgrades.UpgradesService.changeUpgradeSelection()\">\n            <div class=\"PagePostProject-advanceOptions-content\">\n                <fl-advanced-upgrades></fl-advanced-upgrades>\n            </div>\n        </div>\n        <input ng-if=\"PostProjectUpgrades.UpgradesService.projectData.selectedUpgrade==='recruiter'\" type=\"checkbox\" name=\"chkbx_assisted\" data-name=\"assisted\" value=\"on\" checked=\"true\" class=\"is-hidden\">\n    </fieldset>\n</div>\n";

var PostProjectUpgrades = function () {
  function PostProjectUpgrades(UpgradesService, WizardService) {
    _classCallCheck(this, PostProjectUpgrades);

    this.UpgradesService = UpgradesService;
    this.WizardService = WizardService;

    this.UpgradesService.projectData.selectedUpgrade = null;
  }

  _createClass(PostProjectUpgrades, [{
    key: 'resetSelected',
    value: function resetSelected() {
      this.UpgradesService.projectData.selectedUpgrade = 'standard';
      this.UpgradesService.changeUpgradeSelection();
    }
  }]);

  return PostProjectUpgrades;
}();

PostProjectUpgrades.$inject = ['UpgradesService', 'WizardService'];

function getTemplate$2() {
  return template$22;
}

var UpgradesProvider = flComponent$1(PostProjectUpgrades, {
  selector: 'fl-post-project-upgrades',
  template: getTemplate$2(),
  providers: [AdvancedUpgrades$1, UpgradesServiceProvider, WizardServiceProvider]
});

var template$23 = "<fieldset class=\"PagePostProject-fieldset\">\n    <legend class=\"PagePostProject-legend\">Do you need a helping hand?</legend>\n\n    <!-- Standard Project -->\n    <input\n        id=\"no-upgrade\"\n        type=\"radio\"\n        name=\"optional-upgrades\"\n        value=\"standard\"\n        class=\"MajorUpgradeCard-input\"\n        ng-model=\"PostProjectUpgradesAbtest.UpgradesService.projectData.selectedUpgrade\"\n        ng-click=\"PostProjectUpgradesAbtest.WizardService.onChoiceSelect('upgrades')\"\n        ng-change=\"PostProjectUpgradesAbtest.UpgradesService.changeUpgradeSelection()\"\n        fl-toggle-wizard-next=\"upgrades\"\n    />\n    <label class=\"MajorUpgradeCard\" for=\"no-upgrade\">\n        <div class=\"MajorUpgradeCard-container\">\n            <div class=\"MajorUpgradeCard-imageContainer\">\n                <img\n                    class=\"MajorUpgradeCard-image ImageThumbnail--fluid\"\n                    ng-src=\"{[{PostProjectUpgradesAbtest.normalProjectImageUrl}]}\"\n                    alt=\"Fixed price project\"\n                />\n            </div>\n            <div class=\"MajorUpgradeCard-mainSection\">\n                <div class=\"MajorUpgradeCard-text\">\n                    <div class=\"MajorUpgradeCard-name\">\n                        Standard Project\n                    </div>\n                    <div class=\"MajorUpgradeCard-description\">\n                        Free to post. Your project will go live instantly and start receiving bids within seconds.\n                    </div>\n                </div>\n                <div class=\"MajorUpgradeCard-priceSection\">\n                    <div class=\"MajorUpgradeCard-price\">\n                        FREE\n                    </div>\n                </div>\n            </div>\n        </div>\n    </label>\n\n    <!-- Recruiter Upgrade -->\n    <input\n        id=\"recruiter-upgrade\"\n        type=\"radio\"\n        name=\"optional-upgrades\"\n        value=\"recruiter\"\n        class=\"MajorUpgradeCard-input\"\n        ng-model=\"PostProjectUpgradesAbtest.UpgradesService.projectData.selectedUpgrade\"\n        ng-click=\"PostProjectUpgradesAbtest.WizardService.onChoiceSelect('upgrades')\"\n        ng-change=\"PostProjectUpgradesAbtest.UpgradesService.changeUpgradeSelection()\"\n        fl-toggle-wizard-next=\"upgrades\"\n    />\n    <label class=\"MajorUpgradeCard\" for=\"recruiter-upgrade\">\n        <div class=\"MajorUpgradeCard-container\">\n            <div class=\"MajorUpgradeCard-imageContainer\">\n                <img\n                    class=\"MajorUpgradeCard-image ImageThumbnail--fluid\"\n                    ng-src=\"{[{PostProjectUpgradesAbtest.recruiterProjectImageUrl}]}\"\n                    alt=\"Fixed price project\"\n                >\n            </div>\n            <div class=\"MajorUpgradeCard-mainSection\">\n                <div class=\"MajorUpgradeCard-text\">\n                    <div class=\"MajorUpgradeCard-name\">\n                        Recruiter Project\n                    </div>\n                    <div class=\"MajorUpgradeCard-description\">\n                        We'll assign one of our expert staff to help you find the perfect freelancer for the job.\n                    </div>\n                </div>\n                <div class=\"MajorUpgradeCard-priceSection\">\n                    <div class=\"MajorUpgradeCard-price\">\n                        {{ PostProjectUpgradesAbtest.UpgradesService.sign }}{{ PostProjectUpgradesAbtest.UpgradesService.projectData.upgrades[\"recruiter\"].price | number : 2 }}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </label>\n\n    <!-- Project Management Bundle Upgrade -->\n    <input\n        id=\"project-management-bundle\"\n        type=\"radio\"\n        name=\"optional-upgrades\"\n        value=\"project_management_bundle\"\n        class=\"MajorUpgradeCard-input\"\n        ng-model=\"PostProjectUpgradesAbtest.UpgradesService.projectData.selectedUpgrade\"\n        ng-click=\"PostProjectUpgradesAbtest.WizardService.onChoiceSelect('upgrades')\"\n        ng-change=\"PostProjectUpgradesAbtest.UpgradesService.changeUpgradeSelection()\"\n        fl-toggle-wizard-next=\"upgrades\"\n    />\n    <label class=\"MajorUpgradeCard\" for=\"project-management-bundle\">\n        <div class=\"MajorUpgradeCard-container\">\n            <div class=\"MajorUpgradeCard-imageContainer\">\n                <img\n                    class=\"MajorUpgradeCard-image ImageThumbnail--fluid\"\n                    ng-src=\"{[{PostProjectUpgradesAbtest.managedProjectImageUrl}]}\"\n                    alt=\"Fixed price project\"\n                >\n            </div>\n            <div class=\"MajorUpgradeCard-mainSection\">\n                <div class=\"MajorUpgradeCard-text\">\n                    <div class=\"MajorUpgradeCard-name\">\n                        Recruiter + Managed Project\n                    </div>\n                    <div class=\"MajorUpgradeCard-description\">\n                        Get a hand-picked freelancer and a free trial of our project management service. If you love it, you can continue using the service at only {{ PostProjectUpgradesAbtest.UpgradesService.sign }}{{ PostProjectUpgradesAbtest.UpgradesService.projectData.upgrades['project_management_bundle'].hourlyPrice }} / hour.\n                    </div>\n                </div>\n                <div class=\"MajorUpgradeCard-priceSection\">\n                    <div class=\"MajorUpgradeCard-discountedPrice\">\n                        {{ PostProjectUpgradesAbtest.UpgradesService.sign }}{{ PostProjectUpgradesAbtest.UpgradesService.projectData.upgrades[\"project_management_bundle\"].price | number : 2 }}\n                    </div>\n                    <div class=\"MajorUpgradeCard-fullPrice\">\n                        {{ PostProjectUpgradesAbtest.UpgradesService.sign }}{{ PostProjectUpgradesAbtest.UpgradesService.fullProjectManagementBundlePrice | number : 2 }}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </label>\n</fieldset>\n\n<!-- These hidden input checkboxes are used to pass the selectedUpgrade to the backend. -->\n<input\n    ng-if=\"PostProjectUpgradesAbtest.UpgradesService.projectData.selectedUpgrade === 'recruiter'\"\n    type=\"checkbox\"\n    name=\"chkbx_assisted\"\n    data-name=\"assisted\"\n    value=\"on\"\n    checked=\"true\"\n    class=\"is-hidden\"\n/>\n<input\n    ng-if=\"PostProjectUpgradesAbtest.UpgradesService.projectData.selectedUpgrade === 'project_management_bundle'\"\n    type=\"checkbox\"\n    name=\"chkbx_project_management_bundle\"\n    data-name=\"project_management_bundle\"\n    value=\"on\"\n    checked=\"true\"\n    class=\"is-hidden\"\n/>\n";

var PostProjectUpgrades$1 = function PostProjectUpgrades(Cdn, UpgradesService, WizardService) {
  _classCallCheck(this, PostProjectUpgrades);

  this.UpgradesService = UpgradesService;
  this.WizardService = WizardService;

  this.normalProjectImageUrl = Cdn.getCdnUrl('/static/img/ppp-T133576/standard-project.svg');
  this.recruiterProjectImageUrl = Cdn.getCdnUrl('/static/img/ppp-T133576/recruiter-project.svg');
  this.managedProjectImageUrl = Cdn.getCdnUrl('/static/img/ppp-T133576/managed-project.svg');

  // For T133576 AB test:
  // Record in project data that we have shown the project management bundle
  // to the user. The project data is stored in the draft.
  this.UpgradesService.projectData.upgrades.project_management_bundle.allowUpgrade = true;

  // Reset the selected upgrade so that we don't show the value from the draft project.
  this.UpgradesService.projectData.selectedUpgrade = null;
};

PostProjectUpgrades$1.$inject = ['Cdn', 'UpgradesService', 'WizardService'];

var UpgradesT133576Provider = flComponent$1(PostProjectUpgrades$1, {
  selector: 'fl-post-project-upgrades-abtest',
  template: template$23,
  bindings: {
    t133576TestVariation: '=' },
  providers: [UpgradesServiceProvider, WizardServiceProvider]
});

/**
 * @ngdoc directive
 * @name flContestDurationLimitCheck
 * @restrict A
 * @description
 * Prevents user from entering duration outside of 3-30 days
 */

var ContestDurationLimitCheck = function () {
  function ContestDurationLimitCheck() {
    _classCallCheck(this, ContestDurationLimitCheck);

    this.min = 3;
    this.max = 30;
  }

  _createClass(ContestDurationLimitCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.outsideDurationLimit = function (duration) {
        return duration >= _this.min && duration <= _this.max;
      };
    }
  }]);

  return ContestDurationLimitCheck;
}();

var ContestDurationLimitCheck$1 = flDirective$1(ContestDurationLimitCheck, {
  selector: '[fl-contest-duration-limit-check]',
  require: 'ngModel',
  providers: []
});

var template$24 = "<div class=\"NumberedForm-content\" ng-if=\"ContestDurationField.showUrgent === 'false'\">\n  <fieldset class=\"PagePostProject-fieldset\">\n    <legend class=\"PagePostProject-legend\">Run your contest for</legend>\n    <ol>\n        <li class=\"form-step\" id=\"contest_length\"\n            ng-class=\"{\n                'is-invalid': (ContestDurationField.form.length.$error.required &&\n                    ContestDurationField.form.length.$dirty ||\n                    ContestDurationField.form.length.$invalid),\n            }\">\n            <label for=\"project-name\" class=\"is-accessibly-hidden\">\n                Contest Name\n            </label>\n            <span class=\"input-group\">\n                <span class=\"PagePostProject-addOn add-on\">Days</span>\n                <input type=\"text\"\n                    class=\"input-integers-only default-input PagePostProject-form-input large-input focusable-field\"\n                    ng-required=\"true\"\n                    ng-keydown=\"ContestDurationField.forceNumeric($event)\"\n                    name=\"length\"\n                    ng-model=\"ContestDurationField.projectData.project.contest_length\"\n                    autocomplete=\"off\"\n                    autofocus\n                    fl-focus-in-tracker=\"Contest_Duration_Input\"\n                    fl-focus-out-tracker=\"Contest_Duration_Input\"\n                    fl-toggle-wizard-next=\"contestDuration\"\n                    fl-autosave-draft\n                    fl-contest-duration-limit-check>\n            </span>\n            <div ng-messages=\"ContestDurationField.form.length.$error\" tabindex=\"-1\">\n                <div class=\"form-error\" ng-message=\"required\">Please enter a contest duration.</div>\n                <div class=\"form-error\" ng-message=\"outsideDurationLimit\">Enter from 3 to 30 days.</div>\n            </div>\n        </li>\n    </ol>\n  </fieldset>\n</div>\n\n<div class=\"NumberedForm-content\" ng-if=\"ContestDurationField.showUrgent === 'true'\">\n  <fieldset class=\"PagePostProject-fieldset\">\n    <legend class=\"PagePostProject-legend\">Run your contest for</legend>\n    <div class=\"PagePostProject-optionalTabs\">\n      <ul class=\"PagePostProject-optionalTabs-list\">\n        <li class=\"PagePostProject-optionalTabs-item\">\n          <input\n            type=\"radio\"\n            id=\"nonurgent\"\n            name=\"duration-type\"\n            value=\"nonurgent\"\n            ng-model=\"ContestDurationField.projectData.project.durationType\"\n            ng-click=\"ContestDurationField.switchDurationType()\"\n            class=\"PagePostProject-selectableCard-input PagePostProject-optionalTabs-input\"\n            fl-toggle-wizard-next=\"contestDurationType\">\n          <label for=\"nonurgent\" class=\"PagePostProject-selectableCard-label PagePostProject-optionalTabs-label\">\n            <img class=\"PagePostProject-optionalTabs-icon\" ng-src=\"{[{ContestDurationField.Cdn.getCdnUrl('/static/img/ppp/nonurgent-contest-icon.svg')}]}\" alt=\"Non urgent contest icon\">\n            <div class=\"PagePostProject-optionalTabs-copy\">\n              <div class=\"PagePostProject-optionalTabs-header\">\n                <h4 class=\"PagePostProject-optionalTabs-heading\">3 to 30 days</h4>\n                <div class=\"PagePostProject-optionalTabs-price PagePostProject-optionalTabs-price--large\"><strong>Free</strong></div>\n              </div>\n              <p class=\"PagePostProject-optionalTabs-intro\">\n                  <ul class=\"PagePostProject-optionalTabs-body\">\n                    <li class=\"form-step\" id=\"contest_length\"\n                        ng-class=\"{\n                            'is-invalid': (ContestDurationField.form.length.$error.required &&\n                                ContestDurationField.form.length.$dirty ||\n                                ContestDurationField.form.length.$invalid),\n                        }\">\n                        <span class=\"input-group\">\n                            <span class=\"PagePostProject-addOn add-on\">Days</span>\n                            <input type=\"text\"\n                                class=\"input-integers-only default-input PagePostProject-form-input large-input\"\n                                ng-required=\"true\"\n                                ng-keydown=\"ContestDurationField.forceNumeric($event)\"\n                                ng-keyup=\"ContestDurationField.onDurationChange()\"\n                                name=\"length\"\n                                placeholder=\"Enter from 3 to 30 days\"\n                                ng-model=\"ContestDurationField.projectData.project.contest_length\"\n                                autocomplete=\"off\"\n                                autofocus\n                                fl-focus-in-tracker=\"Contest_Duration_Input\"\n                                fl-focus-out-tracker=\"Contest_Duration_Input\"\n                                fl-autosave-draft\n                                fl-contest-duration-limit-check>\n                        </span>\n                        <div ng-messages=\"ContestDurationField.form.length.$error\" tabindex=\"-1\">\n                            <div class=\"form-error\" ng-message=\"required\">Please enter a contest duration.</div>\n                            <div class=\"form-error\" ng-message=\"outsideDurationLimit\">Enter from 3 to 30 days.</div>\n                        </div>\n                    </li>\n                  </ul>\n                </p>\n            </div>\n          </label>\n        </li>\n        <li class=\"PagePostProject-optionalTabs-item\" >\n          <input\n          type=\"radio\"\n          id=\"urgent\"\n          name=\"duration-type\"\n          value=\"urgent\"\n          ng-model=\"ContestDurationField.projectData.project.durationType\"\n          ng-click=\"ContestDurationField.switchDurationType()\"\n          class=\"PagePostProject-selectableCard-input PagePostProject-optionalTabs-input\"\n          fl-toggle-wizard-next=\"contestDurationType\"\n          >\n          <label for=\"urgent\" class=\"PagePostProject-selectableCard-label PagePostProject-optionalTabs-label\">\n            <img class=\"PagePostProject-optionalTabs-icon\" ng-src=\"{[{ContestDurationField.Cdn.getCdnUrl('/static/img/ppp/urgent-contest-icon.svg')}]}\" alt=\"Urgent contest icon\">\n            <div class=\"PagePostProject-optionalTabs-copy\">\n              <div class=\"PagePostProject-optionalTabs-header\">\n                <h4 class=\"PagePostProject-optionalTabs-heading\">1 day</h4>\n                <div class=\"PagePostProject-optionalTabs-price PagePostProject-optionalTabs-price--large\">\n                    <span class=\"currency-sign\">{{ContestDurationField.ContestUpgradesService.sign}}</span><span data-robots=\"UrgentUpgradePrice\">{{ContestDurationField.ContestUpgradesService.projectData.contestUpgrades.urgent.price | number : 2}}</span>\n                </div>\n              </div>\n              <div class=\"PagePostProject-optionalTabs-intro\">\n                  <input type=\"checkbox\" ng-if=\"ContestDurationField.projectData.project.durationType === 'urgent'\"\n                    name=\"urgent\"\n                    ng-model=\"ContestDurationField.ContestUpgradesService.projectData.contestUpgrades.urgent.checked\"\n                    class=\"is-hidden\">\n                  <input name=\"length_urgent\" value=\"1\" type=\"hidden\"\n                    ng-if=\"ContestDurationField.projectData.project.durationType === 'urgent'\">\n                  <table class=\"PagePostProject-upgradeListing\">\n                    <tbody>\n                      <tr id=\"project-upgrade-item-urgent\"\n                        class=\"PagePostProject-upgradeListing-option UpgradeListing-option\" data-robots=\"ProjectUpgradeFeatured\">\n                        <td class=\"UpgradeListing-info\">\n                          <div class=\"Checkbox\">\n                            <div class=\"PagePostProject-upgradeListing-tags UpgradeListing-tags\">\n                              <span class=\"UpgradeListing-promoTag promotion-tag has-no-icon promotion-urgent PagePostProject-upgradeListing-promoTag\">\n                                Urgent\n                              </span>\n                            </div>\n                          </div>\n                        </td>\n                        <td class=\"UpgradeListing-intro\">\n                          <p class=\"PagePostProject-upgradeListing-desc UpgradeListing-desc\">Receive a faster response from freelancers and get your favorite entries in 1 day! To ensure you get a fast result, this contest will be upgraded to guaranteed automatically.</p>\n                        </td>\n                      </tr>\n                    </tbody>\n                  </table>\n              </div>\n            </div>\n          </label>\n        </li>\n      </ul>\n    </div>\n  </fieldset>\n</div>\n";

var flContestDurationField = function () {
  function flContestDurationField(ProjectData, Cdn, WizardService, ContestUpgradesService) {
    _classCallCheck(this, flContestDurationField);

    this.projectData = ProjectData;
    this.projectData.project.contest_length = 7;
    this.projectData.project.durationType = this.projectData.project.durationType ? this.projectData.project.durationType : 'nonurgent';
    this.Cdn = Cdn;
    this.WizardService = WizardService;
    this.ContestUpgradesService = ContestUpgradesService;
    this.min = 3;
    this.max = 30;
  }

  _createClass(flContestDurationField, [{
    key: 'forceNumeric',
    value: function forceNumeric(e) {
      var key = e.charCode || e.keyCode || 0;
      // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
      if (key == 8 || key == 9 || key == 46 || key >= 37 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105) {
        return;
      }

      e.preventDefault();
    }
  }, {
    key: 'switchDurationType',
    value: function switchDurationType() {
      if (this.projectData.project.durationType === 'urgent') {
        this.ContestUpgradesService.toggleUrgentUpgrade(true);
        return;
      }
      this.ContestUpgradesService.toggleUrgentUpgrade(false);
      this.WizardService.steps.contestDurationType.validate();
    }
  }, {
    key: 'onDurationChange',
    value: function onDurationChange() {
      this.projectData.project.durationType = 'nonurgent';
      this.switchDurationType();
    }
  }]);

  return flContestDurationField;
}();

flContestDurationField.$inject = ['ProjectData', 'Cdn', 'WizardService', 'ContestUpgradesService'];

var flContestDurationField$1 = flComponent$1(flContestDurationField, {
  selector: 'fl-contest-duration-field',
  transclude: true,
  template: template$24,
  bindings: {
    form: '=',
    showUrgent: '@'
  },
  providers: [ngMessages, CdnProvider, ProjectDataProvider, ContestDurationLimitCheck$1, ContestUpgradesServiceProvider, WizardServiceProvider]
});

var template$25 = "<div class=\"NumberedForm-content\">\n        <fieldset class=\"PagePostProject-fieldset PagePostProject-contestDuration\">\n          <legend class=\"PagePostProject-legend\">How long would you like to run your contest?</legend>\n          <ol>\n              <li class=\"form-step\" id=\"contest_length\"\n                  ng-class=\"{\n                      'is-invalid': (ContestDurationInput.form.length.$error.required &&\n                          ContestDurationInput.form.length.$dirty ||\n                          ContestDurationInput.form.length.$invalid),\n                  }\">\n                  <label for=\"project-name\" class=\"is-accessibly-hidden\">\n                      Contest Name\n                  </label>\n                  <span class=\"input-group PagePostProject-contestDuration-input\">\n                      <span class=\"PagePostProject-addOn add-on\">Days</span>\n                      <input type=\"text\"\n                            id=\"project-name\"\n                            class=\"input-integers-only default-input PagePostProject-form-input large-input focusable-field\"\n                            ng-required=\"true\"\n                            ng-keydown=\"ContestDurationInput.forceNumeric($event)\"\n                            name=\"length\"\n                            ng-model=\"ContestDurationInput.projectData.project.contest_length\"\n                            autocomplete=\"off\"\n                            autofocus\n                            fl-focus-in-tracker=\"Contest_Duration_Input\"\n                            fl-focus-out-tracker=\"Contest_Duration_Input\"\n                            fl-toggle-wizard-next=\"contestDuration\"\n                            fl-autosave-draft\n                            fl-contest-duration-limit-check>\n                  </span>\n                  <div ng-messages=\"ContestDurationInput.form.length.$error\" tabindex=\"-1\">\n                      <div class=\"form-error\" ng-message=\"required\">Please enter a contest duration.</div>\n                      <div class=\"form-error\" ng-message=\"outsideDurationLimit\">Enter from 3 to 30 days.</div>\n                  </div>\n              </li>\n          </ol>\n        </fieldset>\n</div>\n";

var flContestDurationInput = function () {
  function flContestDurationInput(ProjectData, Cdn, WizardService, ContestUpgradesService) {
    _classCallCheck(this, flContestDurationInput);

    this.projectData = ProjectData;
    this.projectData.project.contest_length = 7;
    this.Cdn = Cdn;
    this.WizardService = WizardService;
    this.ContestUpgradesService = ContestUpgradesService;
    this.min = 3;
    this.max = 30;
  }

  _createClass(flContestDurationInput, [{
    key: 'forceNumeric',
    value: function forceNumeric(e) {
      var key = e.charCode || e.keyCode || 0;
      // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
      if (key == 8 || key == 9 || key == 46 || key >= 37 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105) {
        return;
      }

      e.preventDefault();
    }
  }]);

  return flContestDurationInput;
}();

flContestDurationInput.$inject = ['ProjectData', 'Cdn', 'WizardService', 'ContestUpgradesService'];

var flContestDurationInput$1 = flComponent$1(flContestDurationInput, {
  selector: 'fl-contest-duration-input',
  transclude: true,
  template: template$25,
  bindings: {
    form: '='
  },
  providers: [ngMessages, CdnProvider, ProjectDataProvider, ContestDurationLimitCheck$1, ContestUpgradesServiceProvider, WizardServiceProvider]
});

var template$26 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <legend class=\"PagePostProject-legend\">Is your contest urgent?</legend>\n        <nav class=\"PagePostProject-budgetTabs\">\n            <ul class=\"PagePostProject-budgetTabs-cards\">\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                    <input type=\"radio\" name=\"duration-type\" id=\"nonurgent\" value=\"nonurgent\"\n                        class=\"PagePostProject-selectableCard-input focusable-field\"\n                        ng-model=\"ContestDurationType.projectData.project.durationType\"\n                        ng-click=\"ContestDurationType.switchDurationType()\"\n                        fl-toggle-wizard-next=\"contestDurationType\">\n                    <label for=\"nonurgent\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" ng-src=\"{[{ContestDurationType.Cdn.getCdnUrl('/static/img/ppp/nonurgent-contest-icon.svg')}]}\" alt=\"Non urgent contest icon\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                3 to 30 days\n                            </h4>\n                            <h5 class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Give freelancers plenty of time to submit quality entries. Best for getting the most creativity.\n                            </h5>\n                            <div class=\"PagePostProject-budgetTabs-price\">\n                                <strong>Free</strong>\n                            </div>\n                        </div>\n                    </label>\n                </li>\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                    <input type=\"radio\" name=\"duration-type\" id=\"urgent\" value=\"urgent\"\n                        class=\"PagePostProject-selectableCard-input focusable-field\"\n                        ng-model=\"ContestDurationType.projectData.project.durationType\"\n                        ng-click=\"ContestDurationType.switchDurationType()\"\n                        fl-toggle-wizard-next=\"contestDurationType\">\n                    <label class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\" for=\"urgent\">\n                        <input type=\"checkbox\" ng-if=\"ContestDurationType.projectData.project.durationType === 'urgent'\"\n                            name=\"urgent\"\n                            ng-model=\"ContestDurationType.ContestUpgradesService.projectData.contestUpgrades.urgent.checked\"\n                            class=\"is-hidden\">\n                        <input name=\"length_urgent\" value=\"1\" type=\"hidden\"\n                            ng-if=\"ContestDurationType.projectData.project.durationType === 'urgent'\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" ng-src=\"{[{ContestDurationType.Cdn.getCdnUrl('/static/img/ppp/urgent-contest-icon.svg')}]}\" alt=\"Urgent contest icon\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                1 day\n                            </h4>\n                            <h5 class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Receive faster response from freelancers and get great entries returned to you in just 1 day!\n                            </h5>\n                            <input type=\"checkbox\" ng-if=\"ContestDurationType.projectData.project.durationType === 'urgent'\"\n                                name=\"urgent\"\n                                ng-model=\"ContestDurationType.ContestUpgradesService.projectData.contestUpgrades.urgent.checked\"\n                                class=\"is-hidden\">\n                            <input name=\"length_urgent\" value=\"1\" type=\"hidden\"\n                                ng-if=\"ContestDurationType.projectData.project.durationType === 'urgent'\">\n                            <div class=\"PagePostProject-budgetTabs-price\">\n                                <strong>\n                                    <span class=\"currency-sign\">{{ContestDurationType.ContestUpgradesService.sign}}</span><span data-robots=\"UrgentUpgradePrice\">{{ContestDurationType.ContestUpgradesService.projectData.contestUpgrades.urgent.price | number : 2}}</span>\n                                </strong>\n                                <span class=\"PagePostProject-budgetTabs-status promotion-tag has-no-icon promotion-urgent\">\n                                    Urgent\n                                </span>\n                            </div>\n                        </div>\n                    </label>\n                </li>\n            </ul>\n        </nav>\n    </fieldset>\n</div>\n";

var flContestDurationType = function () {
  function flContestDurationType(ProjectData, Cdn, WizardService, ContestUpgradesService) {
    _classCallCheck(this, flContestDurationType);

    this.projectData = ProjectData;
    this.projectData.project.contest_length = 7;
    this.projectData.project.durationType = this.projectData.project.durationType ? this.projectData.project.durationType : '';
    this.Cdn = Cdn;
    this.WizardService = WizardService;
    this.ContestUpgradesService = ContestUpgradesService;
    this.min = 3;
    this.max = 30;
  }

  _createClass(flContestDurationType, [{
    key: 'switchDurationType',
    value: function switchDurationType() {
      if (this.projectData.project.durationType === 'urgent') {
        this.projectData.project.selectedContestUpgrade = 'guaranteed';
        this.ContestUpgradesService.toggleUrgentUpgrade(true);
        this.WizardService.contestLastStep = 'contestDurationType';
        this.WizardService.onChoiceSelect('contestDurationType');
        return;
      }
      this.ContestUpgradesService.toggleUrgentUpgrade(false);
      this.WizardService.steps.contestDurationType.validate();
      this.WizardService.currentStep = 'contestDurationType';
      this.WizardService.contestLastStep = 'contestDuration';
      this.WizardService.onChoiceSelect('contestDurationType');
    }
  }]);

  return flContestDurationType;
}();

flContestDurationType.$inject = ['ProjectData', 'Cdn', 'WizardService', 'ContestUpgradesService'];

var flContestDurationType$1 = flComponent$1(flContestDurationType, {
  selector: 'fl-contest-duration-type',
  transclude: true,
  template: template$26,
  bindings: {
    form: '='
  },
  providers: [ngMessages, CdnProvider, ProjectDataProvider, ContestDurationLimitCheck$1, ContestUpgradesServiceProvider, WizardServiceProvider]
});

var template$27 = "<ul class=\"PagePostProject-advancedUpgrades\">\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_guaranteed\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.contest_type.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                           name=\"contest_type\"\n                           value=\"3\"\n                           data-name=\"guaranteed\"\n                           class=\"Checkbox-input\"\n                           id=\"checkbox_guaranteed\"\n                           ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.contest_type.checked\"\n                           ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('contest_type')\"\n                           ng-disabled=\"AdvancedContestUpgrades.ContestUpgradesService.projectData.contestUpgrades.urgent.checked\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-guaranteed\">Guaranteed</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Guarantee freelancers that a winner will be chosen and awarded the prize. This will attract better entries from more freelancers. Moneyback guarantee is not applicable if a contest has a guaranteed upgrade.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_guaranteed_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span id=\"guaranteed-upgrade-price\" data-robots=\"GuaranteedUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_featured\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.featured.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"featured\"\n                        data-name=\"featured\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_featured\"\n                        ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.featured.checked\"\n                        ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('featured')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-featured\">Featured</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Attract more freelancers with a prominent placement in our 'Featured Jobs and Contests' page.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_featured_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freeFeatured\" class=\"currency-sign\">{{AdvancedContestUpgrades.ContestUpgradesService.sign}}</span><span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freeFeatured\"\n                        id=\"featured-upgrade-price\" data-robots=\"FeaturedUpgradePrice\">{{AdvancedContestUpgrades.ProjectData.project.contestUpgrades.featured.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedContestUpgrades.ContestUpgradesService.freeFeatured\" id=\"assisted-upgrade-price\" data-robots=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_topContest\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.topContest.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"top_contest\"\n                        data-name=\"topContest\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_topContest\"\n                        ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.topContest.checked\"\n                        ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('topContest')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-topContest\">Top Contest</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">We will contact our top freelancers to join your contest.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_topContest_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.topContest\" class=\"currency-sign\">{{AdvancedContestUpgrades.ContestUpgradesService.sign}}</span><span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.topContest\"\n                        id=\"topContest-upgrade-price\" data-robots=\"UrgentUpgradePrice\">{{AdvancedContestUpgrades.ProjectData.project.contestUpgrades.topContest.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedContestUpgrades.ContestUpgradesService.topContest\" id=\"assisted-upgrade-price\" data-robots=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_highlight\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.highlight.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"highlight\"\n                        data-name=\"highlight\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_highlight\"\n                        ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.highlight.checked\"\n                        ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('highlight')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-highlight\">Highlight</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Make your contest more visible in our main job search pages.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_highlight_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" class=\"currency-sign\">{{AdvancedContestUpgrades.ContestUpgradesService.sign}}</span><span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\"\n                        id=\"highlight-upgrade-price\" data-robots=\"PrivateUpgradePrice\">{{AdvancedContestUpgrades.ProjectData.project.contestUpgrades.highlight.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" id=\"assisted-upgrade-price\" data-robots=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_sealed\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.sealed.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"sealed\"\n                        data-name=\"sealed\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_sealed\"\n                        ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.sealed.checked\"\n                        ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('sealed')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-sealed\">Sealed</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Only you can see individual entries, ensuring you get unique ideas.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_sealed_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" class=\"currency-sign\">{{AdvancedContestUpgrades.ContestUpgradesService.sign}}</span><span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\"\n                        id=\"sealed-upgrade-price\" data-robots=\"PrivateUpgradePrice\">{{AdvancedContestUpgrades.ProjectData.project.contestUpgrades.sealed.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" id=\"assisted-upgrade-price\" data-robots=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_nda\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.nda.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"nda\"\n                        data-name=\"nda\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_nda\"\n                        ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.nda.checked\"\n                        ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('nda')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-nda\">NDA</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Freelancers must sign a Non-Disclosure Agreement to see your contest details.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_nda_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" class=\"currency-sign\">{{AdvancedContestUpgrades.ContestUpgradesService.sign}}</span><span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\"\n                        id=\"nda-upgrade-price\" data-robots=\"PrivateUpgradePrice\">{{AdvancedContestUpgrades.ProjectData.project.contestUpgrades.nda.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" id=\"assisted-upgrade-price\" data-robots=\"Re cruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n    <li class=\"PagePostProject-advancedUpgrades-item\">\n        <label for=\"checkbox_private\" class=\"PagePostProject-advancedUpgrades-listItem ListItem ListItem--hoverable\" ng-class=\"{'is-active': AdvancedContestUpgrades.ProjectData.project.contestUpgrades.private.checked}\">\n            <div class=\"ListItem-icon\">\n                <div class=\"Checkbox\">\n                    <input type=\"checkbox\"\n                        name=\"private\"\n                        data-name=\"private\"\n                        class=\"Checkbox-input\"\n                        id=\"checkbox_private\"\n                        ng-model=\"AdvancedContestUpgrades.ProjectData.project.contestUpgrades.private.checked\"\n                        ng-change=\"AdvancedContestUpgrades.ContestUpgradesService.computeAdvanced('private')\">\n                    <div class=\"PagePostProject-advancedUpgrades-checkbox Checkbox-label Checkbox-label--large\"></div>\n                </div>\n            </div>\n            <div class=\"PagePostProject-advancedUpgrades-content ListItem-content\">\n                <div class=\"PagePostProject-advancedUpgrades-header\">\n                    <span class=\"PagePostProject-advancedUpgrades-promoTag promotion-tag has-no-icon promotion-private\">Private</span>\n                </div>\n                <p class=\"PagePostProject-advancedUpgrades-desc\">Hide project details from search engines and users that are not logged in, for projects that you need to keep confidential.</p>\n                <div class=\"PagePostProject-advancedUpgrades-price js-upgrade-price\">\n                    <div id=\"priced_private_upgrade_block\" class=\"PagePostProject-advancedUpgrades-price-value\">\n                        <span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" class=\"currency-sign\">{{AdvancedContestUpgrades.ContestUpgradesService.sign}}</span><span ng-if=\"!AdvancedContestUpgrades.ContestUpgradesService.freePrivate\"\n                        id=\"private-upgrade-price\" data-robots=\"PrivateUpgradePrice\">{{AdvancedContestUpgrades.ProjectData.project.contestUpgrades.private.price | number : 2}}</span>\n                        <span ng-if=\"AdvancedContestUpgrades.ContestUpgradesService.freePrivate\" id=\"assisted-upgrade-price\" data-robots=\"RecruiterUpgradePrice\">Free</span>\n                    </div>\n                </div>\n            </div>\n        </label>\n    </li>\n</ul>\n";

var AdvancedContestUpgrades = function AdvancedContestUpgrades(ProjectData, ContestUpgradesService) {
  _classCallCheck(this, AdvancedContestUpgrades);

  this.ProjectData = ProjectData;
  this.ContestUpgradesService = ContestUpgradesService;
};

AdvancedContestUpgrades.$inject = ['ProjectData', 'ContestUpgradesService'];

function getTemplate$3() {
  return template$27;
}

var AdvancedContestUpgrades$1 = flComponent$1(AdvancedContestUpgrades, {
  selector: 'fl-advanced-contest-upgrades',
  template: getTemplate$3(),
  providers: [ProjectDataProvider, ContestUpgradesServiceProvider]
});

var template$28 = "<div class=\"NumberedForm-content\">\n    <fieldset class=\"PagePostProject-fieldset\">\n        <legend class=\"PagePostProject-legend\" ng-if=\"ContestUpgrades.ContestUpgradesService.isOnT70947Test\">\n            What type of contest do you want to run?\n        </legend>\n        <legend class=\"PagePostProject-legend\" ng-if=\"!ContestUpgrades.ContestUpgradesService.isOnT70947Test\">\n            Optional Upgrades\n        </legend>\n        <nav class=\"PagePostProject-budgetTabs\">\n            <ul class=\"PagePostProject-budgetTabs-cards\">\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\"\n                    ng-if=\"ContestUpgrades.ContestUpgradesService.isOnT70947Test\">\n                    <input\n                        ng-if=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade === 'guaranteed'\"\n                        name=\"contest_type\"\n                        value=\"3\"\n                        type=\"hidden\">\n                    <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        id=\"guaranteed\"\n                        name=\"optional-upgrades\"\n                        value=\"guaranteed\"\n                        ng-model=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade\"\n                        ng-click=\"ContestUpgrades.WizardService.onChoiceSelect('contestUpgrades');\n                            ContestUpgrades.ContestUpgradesService.trackMainUpgradeTypeCardClick('guaranteed')\"\n                        ng-change=\"ContestUpgrades.ContestUpgradesService.recompute()\"\n                        fl-toggle-wizard-next=\"contestUpgrades\">\n                    <label\n                        for=\"guaranteed\"\n                        class=\"\n                            PagePostProject-selectableCard-label\n                            PagePostProject-budgetTabs-cardsLabel\n                            PagePostProject-budgetTabs-cardsLabel--large\n                            PagePostProject-budgetTabs-cardsLabel--upsell\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/fixed-price-project.svg\" alt=\"Guaranteed\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Guaranteed contest\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Attract higher quality entries by guaranteeing freelancers a winner will be chosen.\n                            </div>\n                            <span class=\"PagePostProject-budgetTabs-promotion\">\n                                <span class=\"Tooltip--top Tooltip--large\" data-tooltip=\"Based on data of contests posted from Jan to Nov 2018\">\n                                    Get 2x more entries*\n                                </span>\n                            </span>\n                        </div>\n                    </label>\n                </li>\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\">\n                    <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        id=\"standard\"\n                        name=\"optional-upgrades\"\n                        value=\"standard\"\n                        ng-model=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade\"\n                        ng-click=\"ContestUpgrades.WizardService.onChoiceSelect('contestUpgrades');\n                            ContestUpgrades.ContestUpgradesService.trackMainUpgradeTypeCardClick('standard')\"\n                        ng-change=\"ContestUpgrades.ContestUpgradesService.recompute()\"\n                        fl-toggle-wizard-next=\"contestUpgrades\">\n                    <label for=\"standard\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel\n                    PagePostProject-budgetTabs-cardsLabel--large\"\n                        ng-class=\"{'is-disabled': ContestUpgrades.ContestUpgradesService.projectData.contestUpgrades.urgent.checked}\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/ppp/project-001.svg\" alt=\"Basic contest\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Basic contest\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                <span class=\"PagePostProject-budgetTabs-cardsIntro-heading-item\">Start getting entries.</span>\n                                <span class=\"PagePostProject-budgetTabs-cardsIntro-heading-item\">Award your favorites.</span>\n                                <span class=\"PagePostProject-budgetTabs-cardsIntro-heading-item\">Money back guarantee.</span>\n                                <span class=\"PagePostProject-budgetTabs-cardsIntro-heading-item\" ng-if=\"ContestUpgrades.ContestUpgradesService.projectData.contestUpgrades.urgent.checked\">Unavailable for urgent contests.</span>\n                            </div>\n                            <div class=\"PagePostProject-budgetTabs-price\">\n                                <strong ng-if=\"!ContestUpgrades.ContestUpgradesService.projectData.contestUpgrades.urgent.checked &&\n                                    !ContestUpgrades.ContestUpgradesService.isOnT70947Test\">Free</strong>\n                                <strong ng-if=\"ContestUpgrades.ContestUpgradesService.projectData.contestUpgrades.urgent.checked\">Unavailable</strong>\n                            </div>\n                        </div>\n                    </label>\n                </li>\n                <li class=\"PagePostProject-budgetTabs-cardsItem PagePostProject-budgetTabs-cardsItem--even\"\n                    ng-if=\"!ContestUpgrades.ContestUpgradesService.isOnT70947Test\">\n                    <input\n                        ng-if=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade === 'guaranteed'\"\n                        name=\"contest_type\"\n                        value=\"3\"\n                        type=\"hidden\">\n                    <input class=\"PagePostProject-selectableCard-input focusable-field\"\n                        type=\"radio\"\n                        id=\"guaranteed\"\n                        name=\"optional-upgrades\"\n                        value=\"guaranteed\"\n                        ng-model=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade\"\n                        ng-click=\"ContestUpgrades.WizardService.onChoiceSelect('contestUpgrades')\"\n                        ng-change=\"ContestUpgrades.ContestUpgradesService.recompute()\"\n                        fl-toggle-wizard-next=\"contestUpgrades\">\n                    <label for=\"guaranteed\" class=\"PagePostProject-selectableCard-label PagePostProject-budgetTabs-cardsLabel PagePostProject-budgetTabs-cardsLabel--large\">\n                        <figure class=\"PagePostProject-budgetTabs-figure\">\n                            <img class=\"PagePostProject-budgetTabs-img\" src=\"/build/img/fixed-price-project.svg\" alt=\"Guaranteed\">\n                        </figure>\n                        <div class=\"PagePostProject-budgetTabs-details\">\n                            <h4 class=\"PagePostProject-budgetTabs-cardsHeading\">\n                                Guaranteed contest\n                            </h4>\n                            <div class=\"PagePostProject-budgetTabs-cardsIntro-heading\">\n                                Attract higher quality entries from freelancers. Moneyback guarantee is not applicable if a contest is guaranteed.\n                            </div>\n                            <div class=\"PagePostProject-budgetTabs-price\">\n                                <strong>Free</strong>\n                            </div>\n                        </div>\n                    </label>\n                </li>\n            </ul>\n        </nav>\n        <div class=\"PagePostProject-advanceOptions PagePostProject-budgetTabs-footer\">\n            <div class=\"PagePostProject-advanceOptions-heading\">\n                <label class=\"PagePostProject-advanceOptions-label\"\n                    for=\"advanced\"\n                    ng-show=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade!=='advanced'\"\n                    ng-click=\"ContestUpgrades.WizardService.toggleNextButton(!ContestUpgrades.WizardService.steps.contestSubmit.visited);\n                        ContestUpgrades.ContestUpgradesService.trackClickAdvancedOptionsToggle(true)\">Show Advanced Options</label>\n                <label class=\"PagePostProject-advanceOptions-label\"\n                    ng-show=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade==='advanced'\"\n                    ng-click=\"ContestUpgrades.WizardService.toggleNextButton(false); ContestUpgrades.resetSelected();\n                        ContestUpgrades.ContestUpgradesService.trackClickAdvancedOptionsToggle(false)\">Hide Advanced Options</label>\n            </div>\n            <input class=\"PagePostProject-advanceOptions-input\" type=\"radio\"\n                type=\"radio\"\n                id=\"advanced\"\n                name=\"optional-upgrades\"\n                value=\"advanced\"\n                ng-model=\"ContestUpgrades.ContestUpgradesService.projectData.selectedContestUpgrade\"\n                ng-change=\"ContestUpgrades.ContestUpgradesService.recompute()\">\n            <div class=\"PagePostProject-advanceOptions-content\">\n                <fl-advanced-contest-upgrades></fl-advanced-contest-upgrades>\n            </div>\n        </div>\n    </fieldset>\n</div>\n";

var ContestUpgrades = function () {
  function ContestUpgrades(Cdn, Auth, ProjectData, ContestUpgradesService, WizardService) {
    _classCallCheck(this, ContestUpgrades);

    this.Cdn = Cdn;
    this.Auth = Auth;
    this.WizardService = WizardService;
    this.ProjectData = ProjectData;
    this.ContestUpgradesService = ContestUpgradesService;

    if (pppABTest && pppABTest.T70947) {
      this.isOnT70947Test = pppABTest.T70947.onTest;
    } else {
      this.isOnT70947Test = false;
    }

    this.ContestUpgradesService.projectData.selectedContestUpgrade = this.ProjectData.project.durationType === 'urgent' || this.isOnT70947Test ? 'guaranteed' : undefined;
  }

  _createClass(ContestUpgrades, [{
    key: 'resetSelected',
    value: function resetSelected() {
      this.ContestUpgradesService.projectData.selectedContestUpgrade = this.ProjectData.project.contestUpgrades.urgent.checked || this.isOnT70947Test ? 'guaranteed' : 'standard';
      this.ContestUpgradesService.changeUpgradeSelection();
    }
  }]);

  return ContestUpgrades;
}();

ContestUpgrades.$inject = ['Cdn', 'Auth', 'ProjectData', 'ContestUpgradesService', 'WizardService'];

function getTemplate$4() {
  return template$28;
}

var flContestUpgrades = flComponent$1(ContestUpgrades, {
  selector: 'fl-contest-upgrades',
  template: getTemplate$4(),
  providers: [CdnProvider, AuthModule, ProjectDataProvider, AdvancedContestUpgrades$1, ContestUpgradesServiceProvider, WizardServiceProvider]
});

var template$29 = "<div class=\"SectionProjectStep-help\">\n  <button class=\"SectionHelp-help\"\n    ng-click=\"HelpFab.toggleHelp()\"\n    ng-class=\"{'is-active': HelpFab.active}\">\n    <span class=\"SectionHelp-help-button SectionHelp-help-button--question \">?</span>\n    <span class=\"SectionHelp-help-button SectionHelp-help-button--close\">+</span>\n  </button>\n</div>\n\n<ul class=\"SectionHelp-help-menu\"\n  ng-class=\"{'SectionHelp-help-menu-active': HelpFab.active}\">\n  <li class=\"SectionHelp-helpCard\">\n    <div class=\"PageEmployerOnboarding-stepContainer-helpCard-inner\">\n      <p class=\"SectionProjectStep-paragraph\">Don't know what to do?</p>\n    </div>\n  </li>\n  <li class=\"SectionHelp-helpCard SectionHelp-helpCard--large\">\n    <div class=\"SectionHelp-helpCard-inner\">\n      <p>Don't be shy! Our <b>expert recruiters</b> are here to help you.</p>\n      <a href=\"/recruiter/\" class=\"SectionProjectStep-link\">I need help\n        <span class=\"Icon Icon--small\">\n            <fl-icon name=\"ui-arrow-right\"></fl-icon>\n        </span>\n      </a>\n    </div>\n  </li>\n  <li class=\"SectionHelp-helpCard SectionHelp-helpCard--mid\">\n    <div class=\"SectionHelp-helpCard-inner\">\n      <p>Want to find work instead?</p>\n      <a href=\"/jobs\" class=\"SectionProjectStep-link\">Browse Jobs\n        <span class=\"Icon Icon--small\">\n            <fl-icon name=\"ui-arrow-right\"></fl-icon>\n        </span>\n      </a>\n    </div>\n  </li>\n</ul>\n";

var flHelpFab = function () {
  function flHelpFab() {
    _classCallCheck(this, flHelpFab);

    this.active = false;
  }

  _createClass(flHelpFab, [{
    key: 'toggleHelp',
    value: function toggleHelp() {
      this.active = !this.active;
    }
  }]);

  return flHelpFab;
}();

var flHelpFab$1 = flComponent$1(flHelpFab, {
  selector: 'fl-help-fab',
  transclude: true,
  template: template$29
});

var _templateObject$14 = _taggedTemplateLiteral(['Welcome to Freelancer!'], ['Welcome to Freelancer!']),
    _templateObject2$6 = _taggedTemplateLiteral(['We\'re excited you\'ve joined the world\'s largest marketplace\n      for online services. Let\'s help you get started with just a few steps.'], ['We\'re excited you\'ve joined the world\'s largest marketplace\n      for online services. Let\'s help you get started with just a few steps.']),
    _templateObject3$3 = _taggedTemplateLiteral(['Get it done with freelancers'], ['Get it done with freelancers']),
    _templateObject4$1 = _taggedTemplateLiteral(['Tell us what you\'re looking to get done, and we\'ll\n      match you with top freelancers from around the world.'], ['Tell us what you\'re looking to get done, and we\'ll\n      match you with top freelancers from around the world.']),
    _templateObject5$1 = _taggedTemplateLiteral(['Have peace of mind'], ['Have peace of mind']),
    _templateObject6$1 = _taggedTemplateLiteral(['Pay securely with Freelancer. Create Milestone Payments and\n      only release the funds once you are 100% satisfied with the work\n      completed.'], ['Pay securely with Freelancer. Create Milestone Payments and\n      only release the funds once you are 100% satisfied with the work\n      completed.']);

var STEP_TYPE = {
  TUTORIAL_STEP: 'tutorial-step',
  DECISION_STEP: 'decision-step'
};
var STEP_SEQUENCE = {
  welcome: {
    stepType: STEP_TYPE.TUTORIAL_STEP,
    skippable: true,
    mediaPlayback: {
      played: false,
      start: 0,
      end: 2
    },
    title: translate(_templateObject$14),
    description: translate(_templateObject2$6)
  },
  'find-your-favorite': {
    stepType: STEP_TYPE.TUTORIAL_STEP,
    skippable: true,
    mediaPlayback: {
      played: false,
      start: 2,
      end: 4
    },
    title: translate(_templateObject3$3),
    description: translate(_templateObject4$1)
  },
  'pay-with-confidence': {
    stepType: STEP_TYPE.TUTORIAL_STEP,
    skippable: true,
    mediaPlayback: {
      played: false,
      start: 4,
      end: 7
    },
    title: translate(_templateObject5$1),
    description: translate(_templateObject6$1)
  }
};

var StepProgress = function () {
  function StepProgress() {
    _classCallCheck(this, StepProgress);

    this.stepSequence = STEP_SEQUENCE;

    this.currentStepIndex = 0;
    this.totalSteps = Object.keys(this.stepSequence).length;
  }

  _createClass(StepProgress, [{
    key: 'getCurrentStep',
    value: function getCurrentStep() {
      return this.currentStepIndex;
    }
  }, {
    key: 'getCurrentStepData',
    value: function getCurrentStepData() {
      if (this.currentStepIndex < 0 || this.currentStepIndex >= this.totalSteps) {
        return {};
      }
      var stepName = Object.keys(this.stepSequence)[this.currentStepIndex];
      return this.stepSequence[stepName];
    }
  }, {
    key: 'isFirstStep',
    value: function isFirstStep() {
      return this.currentStepIndex === 0;
    }
  }, {
    key: 'isLastStep',
    value: function isLastStep() {
      return this.currentStepIndex === this.totalSteps - 1;
    }
  }, {
    key: 'isCompleted',
    value: function isCompleted() {
      return this.currentStepIndex >= this.totalSteps;
    }

    /**
     * @description
     * Goes to the first Unskippable from Current Step Index
     */

  }, {
    key: 'gotoNextUnskippableStep',
    value: function gotoNextUnskippableStep() {
      var _this = this;

      var nextUnskippableIndex = Array.from(this.stepSequence).find(function (elem, index) {
        return index > _this.currentStepIndex && elem.skippable === false;
      });
      // If No unskippable steps: return an invalid step (which will mark all
      // steps as completed in the function isCompleted())
      if (!nextUnskippableIndex) {
        return this.gotoStepIndex(this.totalSteps);
      }
      return this.gotoStepIndex(nextUnskippableIndex);
    }
  }, {
    key: 'gotoNextStep',
    value: function gotoNextStep() {
      this.currentStepIndex += 1;
      this.gotoStepIndex(this.currentStepIndex);
    }
  }, {
    key: 'gotoStepIndex',
    value: function gotoStepIndex(index) {
      this.currentStepIndex = index;
    }
  }]);

  return StepProgress;
}();

var StepProgressProvider = flService$1('StepProgress', [], StepProgress);

var template$30 = "<div class=\"SectionTutorialStep\">\n\t<div class=\"SectionTutorialStep-text\">\n\t\t<h1 class=\"SectionTutorialStep-heading\">\n      {{TutorialStep.title}}\n    </h1>\n    <p class=\"SectionTutorialStep-content\">\n      {{TutorialStep.description}}\n    </p>\n\t</div>\n</div>\n";

var flTutorialStep = function flTutorialStep(StepProgress) {
  _classCallCheck(this, flTutorialStep);

  this.stepProgress = StepProgress;
};

flTutorialStep.$inject = ['StepProgress'];

var flTutorialStep$1 = flComponent$1(flTutorialStep, {
  selector: 'fl-tutorial-step',
  template: template$30,
  providers: [StepProgressProvider],
  bindings: {
    title: '=',
    description: '='
  }
});

var template$31 = "<div class=\"SectionDecisionStep\">\n    <h1 class=\"SectionDecisionStep-heading\">{[{DecisionStep.title}]}</h1>\n    <div class=\"SectionDecisionStep-items Grid\">\n        <div class=\"Grid-col Grid-col--tablet-4\" ng-repeat=\"option in DecisionStep.options\">\n            <div class=\"SectionDecisionStep-card Card\">\n                <div class=\"Card--simpleHeader\">\n                    <div class=\"Card-header\">\n                        <img class=\"SectionDecisionStep-graphic\" ng-src=\"{[{option.graphicUrl}]}\" alt=\"Ticket\" />\n                        <div class=\"Card-heading\">{[{option.title}]}</div>\n                    </div>\n                </div>\n                <div class=\"Card-body SectionDecisionStep-item-content\">{[{option.description}]}</div>\n                <div class=\"Card--simpleFooter\">\n                    <div class=\"Card-footer\">\n                        <a ng-href=\"{[{option.url}]}\">{[{option.linkCopy}]} &rarr;</a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

var flDecisionStep = function flDecisionStep(StepProgress) {
  _classCallCheck(this, flDecisionStep);

  this.stepProgress = StepProgress;
};

flDecisionStep.$inject = ['StepProgress'];

var flDecisionStep$1 = flComponent$1(flDecisionStep, {
  selector: 'fl-step-decision',
  template: template$31,
  providers: [StepProgressProvider],
  bindings: {
    title: '=',
    options: '='
  }
});

var template$32 = "<header class=\"PageEmployerOnboarding-header-inner\">\n  <div class=\"PageEmployerOnboarding-header-link\">\n    <a ng-click=\"OnboardHeader.onSkip()\"\n      class=\"PageEmployerOnboarding-stepContainer-skip\">\n      Skip Tutorial\n    </a>\n  </div>\n</header>\n";

var flOnboardHeader = function flOnboardHeader(StepProgress) {
  _classCallCheck(this, flOnboardHeader);

  this.stepProgress = StepProgress;
};

flOnboardHeader.$inject = ['StepProgress'];

var flOnboardHeader$1 = flComponent$1(flOnboardHeader, {
  selector: 'fl-onboard-header',
  transclude: true,
  template: template$32,
  providers: [StepProgressProvider],
  bindings: {
    allowSkipOnboard: '=',
    onSkip: '&'
  }
});

var template$33 = "<div class=\"Modal-inner PageEmployerOnboarding\"\n   ng-class=\"{ 'is-closing': Onboard.onCloseOnboard }\">\n  <div class=\"Modal-dialog Modal-content\">\n    <div class=\"Container\">\n      <div ng-show=\"!Onboard.closedGiveGetBlock && Onboard.giveGetBlockedStatus.amount\"\n        class=\"PageEmployerOnboarding-alert alert alert-error\">\n        <h6>Sorry we couldn't award your {{ Onboard.giveGetBlockedStatus.amount }} bonus.</h6>\n        <p>\n          Your payment details are registered to another existing user.\n          The {{ Onboard.giveGetBlockedStatus.amount }} referral bonus is reserved only to new Freelancer.com users.\n        </p>\n        <button class=\"close\" ng-click=\"Onboard.closedGiveGetBlock = true\">\n          <fl-icon name=\"flicon-close\"></fl-icon>\n        </button>\n      </div>\n    </div>\n    <div class=\"Container\">\n      <div class=\"PageEmployerOnboarding-inner\">\n        <fl-onboard-header\n          class=\"PageEmployerOnboarding-header\"\n          on-skip=\"Onboard.onSkip()\"\n          allow-skip-onboard=\"Onboard.currentStepData.skippable\">\n        </fl-onboard-header>\n        <div class=\"PageEmployerOnboarding-content\">\n          <div class=\"PageEmployerOnboarding-stepContainer-video\" ng-show=\"Onboard.currentStepData.mediaPlayback\">\n            <video id=\"tutorialVideo\" class=\"PageEmployerOnboarding-video\" muted autoplay>\n              <source ng-src=\"{{Onboard.tutorialVideoUrl}}\">\n            </video>\n          </div>\n          <div class=\"PageEmployerOnboarding-stepContainer\">\n            <fl-tutorial-step ng-if=\"Onboard.currentStepData.stepType === Onboard.stepTypes.TUTORIAL_STEP\"\n              data-title=\"Onboard.currentStepData.title\"\n              description=\"Onboard.currentStepData.description\">\n            </fl-tutorial-step>\n            <fl-decision-step ng-if=\"Onboard.currentStepData.stepType === Onboard.stepTypes.DECISION_STEP\"\n              data-title=\"Onboard.currentStepData.title\"\n              options=\"Onboard.currentStepData.options\">\n            </fl-decision-step>\n          </div>\n          <div class=\"SectionNavigation PageEmployerOnboarding-navigation\">\n            <a ng-show=\"Onboard.currentStepData.skippable\"\n              ng-click=\"Onboard.onClickNext()\"\n              class=\"SectionNavigation-button\">\n                <span ng-if=\"!Onboard.stepProgress.isLastStep()\">\n                  Next\n                </span>\n                <span ng-if=\"Onboard.stepProgress.isLastStep()\">\n                  Get Started\n                </span>\n                <span class=\"Icon Icon--small SectionNavigation-icon\">\n                    <fl-icon name=\"ui-arrow-right\"></fl-icon>\n                </span>\n            </a>\n            <ul class=\"SectionNavigation-stepIndicator\">\n              <li class=\"SectionNavigation-stepIndicator-step\"\n                ng-repeat=\"stepUrl in Onboard.getSteps() track by $index\"\n                ng-class=\"{ 'isActive': ($index) == Onboard.stepProgress.getCurrentStep() }\" ng-click=\"Onboard.onClickIndex($index)\">\n              </li>\n            </ul>\n            <fl-help-fab ng-if=\"!Onboard.currentStepData.skippable\"></fl-help-fab>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n\n";

var flOnboard = function () {
  function flOnboard($sce, $timeout, Cdn, StepProgress) {
    var _this = this;

    _classCallCheck(this, flOnboard);

    this.$timeout = $timeout;
    this.Cdn = Cdn;
    this.stepProgress = StepProgress;
    this.stepTypes = STEP_TYPE;
    this.tutorialVideoUrl = $sce.trustAsResourceUrl(tutorialVideoUrl);
    this.tutorialVideo = document.getElementById('tutorialVideo');
    this.giveGetBlockedStatus = giveGetBlockedStatus;
    this.bodyElement = document.querySelector('body');

    this.currentStepData = this.stepProgress.getCurrentStepData();
    this.tutorialVideo.addEventListener('loadedmetadata', function () {
      _this.updateStep();
    });

    if (this.bodyElement) {
      this.bodyElement.setAttribute('data-modal-open', true);
    }

    this.tutorialVideo.addEventListener('timeupdate', function () {
      if (_this.currentStepData.mediaPlayback && _this.tutorialVideo.currentTime >= _this.currentStepData.mediaPlayback.end) {
        _this.tutorialVideo.pause();
      }
    });
  }

  _createClass(flOnboard, [{
    key: 'getSteps',
    value: function getSteps() {
      return Object.keys(this.stepProgress.stepSequence);
    }
  }, {
    key: 'onClickNext',
    value: function onClickNext() {
      this.stepProgress.gotoNextStep();
      this.updateStep();
    }
  }, {
    key: 'onClickIndex',
    value: function onClickIndex(index) {
      this.stepProgress.gotoStepIndex(index);
      this.updateStep();
    }
  }, {
    key: 'onSkip',
    value: function onSkip() {
      this.stepProgress.gotoNextUnskippableStep();
      this.updateStep();
    }

    /**
     * @description
     * Should be called after each step, checks completion of Onboarding.
     */

  }, {
    key: 'updateStep',
    value: function updateStep() {
      var _this2 = this;

      // Hide Onboarding after Finishing all Steps
      if (this.stepProgress.isCompleted()) {
        if (this.bodyElement) {
          this.bodyElement.removeAttribute('data-modal-open');
        }

        this.onCloseOnboard = true;
        this.$timeout(function () {
          _this2.onComplete();
        }, 500);
        return;
      }

      this.currentStepData = this.stepProgress.getCurrentStepData();
      // Playback of Onboarding Video defined via tutorialVideoUrl
      if (this.currentStepData.mediaPlayback) {
        this.playVideo();
      }
    }
  }, {
    key: 'playVideo',
    value: function playVideo() {
      if (this.currentStepData.mediaPlayback.played) {
        if (this.prevStep !== this.stepProgress.getCurrentStep()) {
          this.tutorialVideo.pause();
          this.tutorialVideo.currentTime = this.currentStepData.mediaPlayback.end;
        }
      } else {
        this.currentStepData.mediaPlayback.played = true;
        this.tutorialVideo.currentTime = this.currentStepData.mediaPlayback.start;
        this.tutorialVideo.play();
      }
      this.prevStep = this.stepProgress.getCurrentStep();
    }
  }]);

  return flOnboard;
}();

flOnboard.$inject = ['$sce', '$timeout', 'Cdn', 'StepProgress'];

var flOnboard$1 = flComponent$1(flOnboard, {
  selector: 'fl-onboard',
  template: template$33,
  bindings: {
    onComplete: '&'
  },
  providers: [flHelpFab$1, flOnboardHeader$1, flTutorialStep$1, flDecisionStep$1, CdnProvider, flIconProvider, StepProgressProvider]
});

var ProjectCreateApp = function () {
  function ProjectCreateApp($scope, $timeout, Auth, AutoSaveDraftService, ProjectData) {
    var _this = this;

    _classCallCheck(this, ProjectCreateApp);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.AutoSaveDraftService = AutoSaveDraftService;
    this.currentYear = new Date().getFullYear();
    this.Auth = Auth;
    this.iframeMode = iframeMode;
    this.pppABTest = pppABTest || {};

    // ABTest T52910 Give Get Banner
    this.activateT52910();

    // T91960: Logged-Out PJP Changes Experiment
    this.activateT91960ABTest();

    // PPP Onboarding (Default completion to true)
    if (Auth.getUserId() && getQueryStringValueByName('onboard') === 'true') {
      // Delay showing Onboard slightly.
      this.$timeout(function () {
        _this.showOnboard = true;
      }, 300);
      // This variable is required to show the PPP whilst the Onboarding is
      // animating the fadeOutDown
    }

    this.setT133576TestVariation(ProjectData);
  }

  _createClass(ProjectCreateApp, [{
    key: 'activateT52910',
    value: function activateT52910() {
      // Activate if ABTest exists and User is in experiment
      if (this.Auth.getUserId() && this.pppABTest.T52910 && this.pppABTest.T52910.inExperiment) {
        ABTestApi.testSubjectActivate(this.pppABTest.T52910.name, this.pppABTest.T52910.variation);
      }
    }

    // T91960: Logged-Out PJP Changes Experiment

  }, {
    key: 'activateT91960ABTest',
    value: function activateT91960ABTest() {
      if (this.pppABTest.T91960 && this.pppABTest.T91960.inTestVariant) {
        // Activate the test subject if the test exists
        // and user is in experiment.
        ABTestApi.activateSessionBasedTestSubject(this.pppABTest.T91960.name, this.pppABTest.T91960.variant);
      }
    }
  }, {
    key: 'onOnboardComplete',
    value: function onOnboardComplete() {
      this.showOnboard = false;
    }
  }, {
    key: 'setT133576TestVariation',
    value: function setT133576TestVariation(ProjectData) {
      var _this2 = this;

      // By default, we set the test variant to control.
      this.t133576TestVariation = {
        name: 'T133576-Logged-Out-PJP-Project-Management-Bundle-V1',
        variant: 'control'
      };

      // Allow QA to overwrite the test variant.
      var abTestUrlParamValue = getQueryStringValueByName('isT133576Test');
      if (abTestUrlParamValue) {
        if (abTestUrlParamValue === 't') {
          this.t133576TestVariation.variant = 'test';
        }
        return;
      }

      // Only allow English user.
      var languageCondPromise = Promise.resolve(languageCode === 'en');
      // User is logged out.
      var userLoggedOutCondPromise = Promise.resolve(!this.Auth.getUserId());
      // User does not have draft project.
      var userHasNoDraftCondPromise = new Promise(function (resolve) {
        // The "draftLoaded" event is emitted when there
        // is a draft project loaded locally or remotely.
        _this2.$scope.$on('draftLoaded', function () {
          // The allowUpgrade field in the project management bundle indicates that we have shown
          // the project management bundle upgrade to the user when they created a draft project.
          // When the user return back to the PJP with a draft loaded, we will always
          // show them the project management bundle upgrade for consistency reason.
          if (ProjectData.project.upgrades.hasOwnProperty('project_management_bundle') && ProjectData.project.upgrades.project_management_bundle.allowUpgrade) {
            _this2.t133576TestVariation.variant = 'test';
          }
          resolve(false);
        });

        // The "noDraftLoaded" event is emitted when there
        // is no draft project loaded locally or remotely.
        _this2.$scope.$on('noDraftLoaded', function () {
          resolve(true);
        });
      });

      // Only call the AJAX endpoint to get the test or control variant
      // when the user has fulfilled the test conditions.
      Promise.all([languageCondPromise, userLoggedOutCondPromise, userHasNoDraftCondPromise]).then(function (conditions) {
        // All promises are true indicating that all AB test conditions have been satisfied.
        if (conditions.every(function (i) {
          return i === true;
        })) {
          // Only enrol 50% of the user into the AB test.
          ABTest.shouldEnrol(_this2.t133576TestVariation.name, getCookie('_tracking_session'), 0.5).then(function (shouldEnrol) {
            if (shouldEnrol) {
              // Enroll the user into the AB test and get the variant from the AB test server.
              // https://www.freelancer.com/admin/abtest/index.php?action=show_experiment&experiment_id=1056
              // https://www.freelancer-staging.com/admin/abtest/index.php?action=show_experiment&experiment_id=1038
              ABTest.getSessionExperimentVariation(_this2.t133576TestVariation.name).then(function (result) {
                // The result from AB test service can be undefined.
                if (result !== undefined) {
                  _this2.t133576TestVariation.variant = result;
                }
              })
              // Don't perform any action when there is an error calling the endpoint.
              .catch(function () {});
            }
          })
          // Remain in control when there is an error from the shouldEnrol function.
          .catch(function () {});
        }
      })
      // Remain in control when there is an error in the any of the three AB test conditions.
      .catch(function () {});
    }
  }]);

  return ProjectCreateApp;
}();

ProjectCreateApp.$inject = ['$scope', '$timeout', 'Auth', 'AutoSaveDraftService', 'ProjectData'];
ProjectCreateApp.$inject = ['$scope', '$timeout', 'Auth', 'AutoSaveDraftService', 'ProjectData'];

var pppComponent = flComponent$1(ProjectCreateApp, {
  selector: 'fl-project-create',
  transclude: 'true',
  template: template,
  bindings: {}
});

var app = flApp('fl-project-create', [ngRoute, pppComponent,
// Components
flOnboard$1, flAutoSaveDraft, flDraftBanner$1, flBudgetSelector$1, flContestUpsell, flDescriptionField$1, flFileUpload$1, flFocusInTracker, flFocusOutTracker, flLanguageSelector$1, flLocalJobsUpsell$1, flSkillsField$1, flTitleField$1, flProjectSummary$1, flToggleWizardNext, flWizardForm$1, flContestBudgetSelector$1, flContestDurationField$1, flContestDurationInput$1, flContestDurationType$1, flContestUpgrades,
// Providers
AuthModule, AutoSaveDraftServiceProvider, flIconProvider, UpgradesProvider, ProjectDataProvider, UpgradesT133576Provider], ProjectCreateApp);

export default app;
